/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  DateTimeString: any;
  JSON: { [key: string]: any };
  StringOrFloat: any;
  Time: string;
  Upload: never;
};

/** 접속 인가 */
export type AccessAuthorization = {
  __typename: 'AccessAuthorization';
  /** 접속 가능 여부 */
  hasAccess: Scalars['Boolean'];
};

export type ActionList = {
  __typename: 'ActionList';
  clickTime: Scalars['Date'];
};

export enum ActionType {
  CLICK = 'CLICK',
  OPEN = 'OPEN'
}

export type AddBannerLogInput = {
  bannerId: Scalars['ID'];
  timezone: Scalars['String'];
};

/** 라이센스 옵저버 추가 input */
export type AddLicenseObserverList = {
  /** 라이센스ID */
  licenseId: Scalars['ID'];
  /** 유저ID 목록 */
  userIdList: Array<Scalars['ID']>;
};

/** 라이센스 팀 추가 input */
export type AddLicenseTeamListInput = {
  /** 라이센스ID */
  licenseId: Scalars['ID'];
  /** 팀ID 목록 */
  teamIdList: Array<Scalars['ID']>;
};

export type Alarm = {
  /** 알람 생성 유저 정보 */
  createUser: SportsUser;
  /** 생성일 */
  createdAt: Scalars['DateTime'];
  /** 알림 ID */
  id: Scalars['ID'];
  /** 알림 읽음 여부 */
  isChecked: Scalars['Boolean'];
  /** 학부모 정보 */
  parent?: Maybe<SportsUser>;
  /** 플랜 정보 */
  plan?: Maybe<PlanV2Alarm>;
  /** 선수 정보 */
  player?: Maybe<SportsUser>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 알림 종류 */
  type: AlarmType;
};


export type AlarmPlanArgs = {
  input: MultilingualTextInput;
};

export type AlarmConnection = {
  __typename: 'AlarmConnection';
  edges: Array<AlarmEdge>;
  pageInfo: PageInfo;
};

export type AlarmEdge = {
  __typename: 'AlarmEdge';
  cursor: Scalars['String'];
  node: Alarm;
};

export enum AlarmType {
  COMMENT_CREATED = 'COMMENT_CREATED',
  FEEDBACK_CREATED = 'FEEDBACK_CREATED',
  FEEDBACK_REQUESTED = 'FEEDBACK_REQUESTED',
  FEEDBACK_UPDATED = 'FEEDBACK_UPDATED',
  PARENT_CONNECTION_REQUEST = 'PARENT_CONNECTION_REQUEST',
  SCHEDULE_ABSENT = 'SCHEDULE_ABSENT',
  SCHEDULE_BULK_CREATED = 'SCHEDULE_BULK_CREATED',
  SCHEDULE_CREATED = 'SCHEDULE_CREATED',
  SCHEDULE_DELETE = 'SCHEDULE_DELETE',
  SCHEDULE_UPDATE = 'SCHEDULE_UPDATE',
  SCHEDULE_WORKLOAD_UPDATED = 'SCHEDULE_WORKLOAD_UPDATED',
  SUBSCRIPTION_PAYMENT_SUCCESS = 'SUBSCRIPTION_PAYMENT_SUCCESS',
  TEAM_INVITATION_REQUEST = 'TEAM_INVITATION_REQUEST'
}

/** 앱알림 flag input */
export type AppPushAlarmFlagInput = {
  /** 마케팅 알림 동의 */
  marketingAllowed?: Maybe<Scalars['Boolean']>;
  /** 일정 알림 동의 */
  scheduleAllowed?: Maybe<Scalars['Boolean']>;
};

/** 앱 푸시 알림 세팅 */
export type AppPushAlarmSetting = {
  __typename: 'AppPushAlarmSetting';
  /** 마케팅 푸시 동의 */
  marketingPushAllowed: Scalars['Boolean'];
  /** 일정 푸시 동의 */
  schedulePushAllowed: Scalars['Boolean'];
};

/** 통증 추가 input */
export type AppendSorenessListInput = {
  /** 통증 목록 input */
  sorenessList: Array<SorenessInput>;
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
};

/** 팀 매치 이벤트 - 공격 지표 */
export type Attack = {
  __typename: 'Attack';
  /** 도움 */
  assists?: Maybe<Scalars['Float']>;
  /** 블락된 슈팅 */
  blockedShots?: Maybe<Scalars['Float']>;
  /** 득점 */
  goals?: Maybe<Scalars['Float']>;
  /** 유효슈팅률 */
  shotAccuracy?: Maybe<Scalars['Float']>;
  /** 박스 안 슈팅 */
  shotsInsideBox?: Maybe<Scalars['Float']>;
  /** 벗어난 슈팅 */
  shotsOffTarget?: Maybe<Scalars['Float']>;
  /** 유효슈팅 */
  shotsOnTarget?: Maybe<Scalars['Float']>;
  /** 박스 밖 슈팅 */
  shotsOutsideBox?: Maybe<Scalars['Float']>;
  /** 전체 슈팅 */
  totalShots?: Maybe<Scalars['Float']>;
};

export type AttendeeChartAvg = ChartCondition | ChartWorkload;

export type AttendeeChartAvgSchedule = {
  __typename: 'AttendeeChartAvgSchedule';
  /** 운동시간 */
  duration: Scalars['Float'];
  /** 운동강도 */
  intensity: Scalars['Float'];
  /** 운동만족 */
  satisfaction: Scalars['Float'];
  /** 운동부하 */
  workload: Scalars['Float'];
};

/** 참여자 운동부하 차트 데이터 */
export type AttendeeChartData = {
  __typename: 'AttendeeChartData';
  /** 운동부하 평균데이터 */
  avg: AttendeeChartAvg;
  /** 참여자 유저 운동부하 데이터 목록 */
  userList: Array<AttendeeChartUser>;
};

export type AttendeeChartDataSchedule = {
  __typename: 'AttendeeChartDataSchedule';
  /** 참가 선수 차트 데이터 평균 */
  avg: AttendeeChartAvgSchedule;
  /** 참가 선수 데이터 목록 */
  userList: Array<AttendeeChartUserSchedule>;
};

export enum AttendeeChartDataType {
  CONDITION = 'CONDITION',
  WORKLOAD = 'WORKLOAD'
}

/** 참여자 유저 운동부하 데이터 */
export type AttendeeChartUser = {
  __typename: 'AttendeeChartUser';
  /** 유저 정보 */
  user: SportsUser;
  /** 운동부하 데이터 */
  value: AttendeeChartValue;
};

export type AttendeeChartUserSchedule = {
  __typename: 'AttendeeChartUserSchedule';
  /** 유저 정보 */
  user: SportsUser;
  /** 운동 부하 데이터 */
  value: ChartUserWorkload;
};

export type AttendeeChartValue = ChartUserCondition | ChartUserWorkload;

/** 재활 골키퍼 제외 운동부하 평균 */
export type AvgExcludeRehabAndGk = {
  __typename: 'AvgExcludeRehabAndGK';
  /** 운동강도 */
  intensity: Scalars['Float'];
  /** 운동부하 */
  load: Scalars['Float'];
};

/** 수상 이력 */
export type AwardHistory = {
  __typename: 'AwardHistory';
  /** 수상 날짜 */
  date: Scalars['String'];
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
};

/** 수상 이력 input */
export type AwardHistoryInput = {
  /** 수상 날짜 */
  date: Scalars['String'];
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
};

/** 팀 매치 이벤트 - 볼 배급 지표 */
export type BallDistribution = {
  __typename: 'BallDistribution';
  /** 백패스 성공률 */
  backPassAccuracy?: Maybe<Scalars['Float']>;
  /** 백패스 */
  backPasses?: Maybe<Scalars['Float']>;
  /** 크로스 성공률 */
  crossAccuracy?: Maybe<Scalars['Float']>;
  /** 크로스 */
  crosses?: Maybe<Scalars['Float']>;
  /** 돌파 시도 */
  dribbleAttempts?: Maybe<Scalars['Float']>;
  /** 돌파 성공률 */
  dribbleSuccessRate?: Maybe<Scalars['Float']>;
  /** 전진 패스 성공률 */
  forwardPassAccuracy?: Maybe<Scalars['Float']>;
  /** 전진패스 */
  forwardPasses?: Maybe<Scalars['Float']>;
  /** 키패스 */
  keyPasses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공률 */
  lateralPassAccuracy?: Maybe<Scalars['Float']>;
  /** 횡패스 */
  lateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리 패스 성공률 */
  longPassAccuracy?: Maybe<Scalars['Float']>;
  /** 장거리 패스 */
  longPasses?: Maybe<Scalars['Float']>;
  /** 중거리 패스 성공률 */
  mediumPassAccuracy?: Maybe<Scalars['Float']>;
  /** 중거리 패스 */
  mediumPasses?: Maybe<Scalars['Float']>;
  /** 패스성공률 */
  passAccuracy?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 성공률 */
  passAccuracyInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비지역 패스 성공률 */
  passAccuracyInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공률 */
  passAccuracyInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 */
  passes?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 */
  passesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 */
  passesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 */
  passesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 받음 */
  passesReceived?: Maybe<Scalars['Float']>;
  /** 팀 점유율 */
  possession?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공률 */
  shortPassAccuracy?: Maybe<Scalars['Float']>;
  /** 단거리 패스 */
  shortPasses?: Maybe<Scalars['Float']>;
  /** 스텝인 */
  stepIns?: Maybe<Scalars['Float']>;
  /** 백패스 성공 */
  successfulBackPasses?: Maybe<Scalars['Float']>;
  /** 크로스 성공 */
  successfulCrosses?: Maybe<Scalars['Float']>;
  /** 돌파 성공 */
  successfulDribbles?: Maybe<Scalars['Float']>;
  /** 전진패스 성공 */
  successfulForwardPasses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공 */
  successfulLateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리패스 성공 */
  successfulLongPasses?: Maybe<Scalars['Float']>;
  /** 중거리패스 성공 */
  successfulMediumPasses?: Maybe<Scalars['Float']>;
  /** 패스 성공 */
  successfulPasses?: Maybe<Scalars['Float']>;
  /** 공격 지역 패스 성공 */
  successfulPassesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 성공 */
  successfulPassesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공 */
  successfulPassesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공 */
  successfulShortPasses?: Maybe<Scalars['Float']>;
  /** 턴오버 허용 */
  turnoversConceded?: Maybe<Scalars['Float']>;
};

/** 배너 정보 */
export type Banner = {
  __typename: 'Banner';
  /** 배너 클릭 유저 목록 */
  clickUserList: BannerLogResponse;
  /** 생성일 */
  createdAt: Scalars['Date'];
  /** 게시종료일 */
  endAt?: Maybe<Scalars['Date']>;
  /** 배너 ID */
  id: Scalars['ID'];
  /** 이미지 url */
  imageUrl: Scalars['String'];
  /** 클릭 시 연결 웹페이지 링크 */
  landingUrl?: Maybe<Scalars['String']>;
  /** 게시시작일 */
  startAt: Scalars['Date'];
  /** 타겟 옵션 목록 */
  targetOptionList?: Maybe<Array<Maybe<TargetOption>>>;
  /** 제목 */
  title: Scalars['String'];
};


/** 배너 정보 */
export type BannerClickUserListArgs = {
  date: Scalars['Date'];
  limit: Scalars['Float'];
  offset: Scalars['Float'];
};

export type BannerLogResponse = {
  __typename: 'BannerLogResponse';
  clickUserList: Array<Maybe<ClickUser>>;
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  totalCount: Scalars['Float'];
};

export type BasicEvent = Event & {
  __typename: 'BasicEvent';
  /** 종료일 */
  endAt: Scalars['Date'];
  eventInvitees: Array<EventInvitee>;
  expectedIntensity?: Maybe<Scalars['Int']>;
  hideExpectedIntensityFromPlayers?: Maybe<Scalars['Boolean']>;
  /** 일정 ID */
  id: Scalars['ID'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 시작일 */
  startAt: Scalars['Date'];
  team?: Maybe<SportsTeam>;
  /** 타임존 */
  timezone: Scalars['String'];
  /** 제목 */
  title: Scalars['String'];
  /** 종류 */
  type: ScheduleType;
};

export type BasicEventInvitee = EventInvitee & {
  __typename: 'BasicEventInvitee';
  event: Event;
  hasChecked: Scalars['Boolean'];
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  status?: Maybe<EventInviteeStatus>;
  /** the player who is invited to this event */
  user?: Maybe<SportsUser>;
  workoutType?: Maybe<WorkoutType>;
};

/** 플랜 기본 정보 v2 */
export type BasicPlanV2 = {
  /** 소분류 */
  detailCategory: Scalars['String'];
  /** 플랜 ID */
  id: Scalars['ID'];
  /** 대분류 */
  mainCategory: PlanMainCategory;
  /** 가격 */
  price: Scalars['Float'];
  /** 중분류 */
  subCategory: PlanSubCategory;
};

/** 일정 정보 */
export type BasicSchedule = Schedule & {
  __typename: 'BasicSchedule';
  /** 상세 종류 */
  detailType: ScheduleDetailType;
  /** 종료시간 */
  endTime?: Maybe<Scalars['Time']>;
  /** 목표 강도 */
  expectedIntensity?: Maybe<Scalars['Int']>;
  /** 목표 운동 부하 */
  expectedWorkload?: Maybe<Scalars['Int']>;
  /** 첨부 파일 목록 */
  fileList?: Maybe<Array<ScheduleFile>>;
  /** 일정ID */
  id: Scalars['ID'];
  /** 삭제 여부 */
  isDeleted: Scalars['Boolean'];
  /** 선수 공지 유무 */
  isPlayerNotice: Scalars['Boolean'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 공지 */
  notice?: Maybe<Scalars['String']>;
  /** 일정 일자 */
  scheduleDate: Scalars['String'];
  /** 일정 초대자 */
  scheduleInviteeList: Array<ScheduleInvitee>;
  /** 시작시간 */
  startTime?: Maybe<Scalars['Time']>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 제목 */
  title?: Maybe<Scalars['String']>;
  /** 훈련 포인트 */
  trainingPoint?: Maybe<Scalars['String']>;
  /** 종류 */
  type: ScheduleType;
};

/** 일정 참여자 정보 */
export type BasicScheduleInvitee = ScheduleInvitee & {
  __typename: 'BasicScheduleInvitee';
  /** 불참사유 */
  absenceReason?: Maybe<Scalars['String']>;
  /** 참여 체크 여부 */
  hasChecked: Scalars['Boolean'];
  /** 일정 초대자 ID */
  id: Scalars['ID'];
  /** 일정 정보 */
  schedule?: Maybe<Schedule>;
  /** 일정 초대자 상태 */
  status?: Maybe<ScheduleInviteeStatus>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** the player who is invited to this schedule */
  user?: Maybe<SportsUser>;
  /** 운동부하 종류 */
  workoutType: WorkoutType;
};


/** 일정 참여자 정보 */
export type BasicScheduleInviteeScheduleArgs = {
  teamId?: Maybe<Scalars['ID']>;
};

/** 빌링 */
export type Billing = {
  __typename: 'Billing';
  /** 결제 유저 이메일 */
  buyerEmail?: Maybe<Scalars['String']>;
  /** 결제 유저 이름 */
  buyerName?: Maybe<Scalars['String']>;
  /** 결제 유저 전화번호 */
  buyerTel?: Maybe<Scalars['String']>;
  /** 결제 카드 이름 */
  cardName?: Maybe<Scalars['String']>;
  /** 결제 카드 번호 */
  cardNumber?: Maybe<Scalars['String']>;
  /** 카드 ID */
  customerUid: Scalars['String'];
  /** 빌링ID */
  id: Scalars['ID'];
  /** 빌링 팀 ID */
  identityToken: Scalars['String'];
};

/** 빌링 토큰 */
export type BillingToken = {
  __typename: 'BillingToken';
  /** 카드ID */
  customerUid: Scalars['String'];
  /** 주문ID */
  paymentToken: Scalars['String'];
};

/** 빌링 v2 정보 */
export type BillingV2 = {
  __typename: 'BillingV2';
  /** 카드사 코드 */
  cardCompanyCode?: Maybe<CardCompanyCode>;
  /** 결제 카드 번호 */
  cardNumber?: Maybe<Scalars['String']>;
  /** 고객 키 */
  customerKey: Scalars['String'];
  /** 빌링ID */
  id: Scalars['ID'];
  /** 대표 여부 */
  isDefault?: Maybe<Scalars['Boolean']>;
};

/** 신체 데이터 */
export type BodyData = {
  __typename: 'BodyData';
  /** BMI */
  BMI?: Maybe<Scalars['Float']>;
  /** 신장 */
  height?: Maybe<Scalars['Float']>;
  /** 신장 단위 */
  heightUnit?: Maybe<HeightUnit>;
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** 권장 수분섭취량 */
  recommendedHydration?: Maybe<Scalars['Float']>;
  /** 체중 */
  weight?: Maybe<Scalars['Float']>;
  /** 체중 단위 */
  weightUnit?: Maybe<WeightUnit>;
};

/** 맨몸 운동 */
export type BodyWeightWorkout = {
  __typename: 'BodyWeightWorkout';
  /** 세션 목록 */
  sessionList?: Maybe<Array<Session>>;
};

/** 맨몸 운동 input */
export type BodyWeightWorkoutInput = {
  /** 세션 목록 */
  sessionList: Array<TrainingSolutionSessionInput>;
};

/** 브리핑 컨디션 리포트 유저 데이터 */
export type BriefingData = {
  __typename: 'BriefingData';
  /** 브리핑 컨디션 리포트 - 근육 상태 나쁨 데이터 */
  severeConditionMuscle: ConditionUserData;
  /** 브리핑 컨디션 리포트 - 수면 시간 짧음 데이터 */
  severeConditionSleepDuration: ConditionUserData;
  /** 브리핑 컨디션 리포트 - 수면 품질 나쁨 데이터 */
  severeConditionSleepQuality: ConditionUserData;
  /** 브리핑 컨디션 리포트 - 스트레스 나쁨 데이터 */
  severeConditionStress: ConditionUserData;
};

/** 브리핑 컨디션 & 통증 리포트 데이터 */
export type BriefingReportData = {
  __typename: 'BriefingReportData';
  /** 브리핑 - 컨디션 리포트 데이터 */
  condition: BriefingData;
  id: Scalars['String'];
  /** 브리핑 - 솔루션 리포트 데이터 */
  solution: SolutionData;
  /** 브리핑 - 통증 리포트 데이터 */
  soreness: SorenessUserData;
  /** 브리핑 컨디션 & 통증 리포트 - 조회 통계 데이터 */
  viewSummary: ViewSummaryData;
};

/** 코디네이팅 경기 리포트 데이터 */
export type BriefingReportMatchScheduleData = {
  __typename: 'BriefingReportMatchScheduleData';
  /** 유저 컨디션 목록 */
  conditionScoreUserList: Array<ConditionScoreUser>;
  /** 브리핑 - 경기 솔루션 */
  solution?: Maybe<MatchReportSolution>;
};

/** 브리핑 리포트 - 솔루션 */
export type BriefingReportSolutionData = {
  __typename: 'BriefingReportSolutionData';
  /** 컨디션 솔루션 목록 */
  conditionSolutionList: Array<ConditionSolution>;
  /** 조회 여부 */
  isViewed: Scalars['Boolean'];
  /** 통증 솔루션 목록 */
  sorenessSolutionList: Array<SorenessSolution>;
  /** 유저 정보 */
  user: SportsUser;
};

/** 브리핑 리포트 - 운동부하 데이터 */
export type BriefingReportTrainingScheduleData = {
  __typename: 'BriefingReportTrainingScheduleData';
  /** 브리핑 - 훈련 솔루션 */
  solution?: Maybe<TrainingReportSolution>;
};

export enum BriefingReportType {
  NEW_SORENESS = 'NEW_SORENESS',
  RECOVER_SORENESS = 'RECOVER_SORENESS',
  SEVERER_CONDITION_SLEEP_QUALITY = 'SEVERER_CONDITION_SLEEP_QUALITY',
  SEVERE_CONDITION_MUSCLE = 'SEVERE_CONDITION_MUSCLE',
  SEVERE_CONDITION_SLEEP_DURATION = 'SEVERE_CONDITION_SLEEP_DURATION',
  SEVERE_CONDITION_STRESS = 'SEVERE_CONDITION_STRESS',
  SEVERE_SORENESS = 'SEVERE_SORENESS',
  SOLUTION_TEAM = 'SOLUTION_TEAM',
  SOLUTION_USER = 'SOLUTION_USER'
}

export enum BriefingSummaryType {
  FIRST_VISIT = 'FIRST_VISIT',
  RESUME = 'RESUME',
  REVISIT = 'REVISIT',
  UPDATED = 'UPDATED'
}

export type BriefingViewedLog = {
  __typename: 'BriefingViewedLog';
  /** 브리핑 리포트 조회 로그 아이디 */
  id: Scalars['ID'];
  /** 브리핑 리포트 조회 통계 데이터 */
  viewSummary: ViewSummary;
};

export type Build = {
  __typename: 'Build';
  buildDuration: Scalars['String'];
  description: Array<Scalars['String']>;
  equipmentList?: Maybe<Array<Equipment>>;
  id: Scalars['ID'];
  physicalElementList: Array<PhysicalElementType>;
  repetition: Scalars['String'];
  set: Scalars['String'];
  setCount: Scalars['Int'];
  status: TrainingSolutionBuildStatus;
  thumbnailImageLink: Scalars['String'];
  title: Scalars['String'];
  videoLink: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
};

/** 빌드 메타 정보 */
export type BuildMeta = {
  __typename: 'BuildMeta';
  /** 설명 */
  description: Array<Scalars['String']>;
  /** 장비 목록 */
  equipmentList?: Maybe<Array<Equipment>>;
  /** 빌드ID */
  id: Scalars['ID'];
  /** 반복 횟수 */
  repetition: Scalars['String'];
  /** 세트수  */
  set: Scalars['String'];
  /** 썸네일 이미지 링크 */
  thumbnailImageLink: Scalars['String'];
  /** 제목 */
  title: Scalars['String'];
  /** 훈련 솔루션 종류 */
  type: TrainingSolutionType;
  /** 비디오 링크 */
  videoLink: Scalars['String'];
  /** 무게 */
  weight?: Maybe<Scalars['Int']>;
};

/** 빌드 메타 정보 input */
export type BuildMetaInput = {
  /** 빌드 영상 시간 */
  buildDuration: Scalars['String'];
  /** 설명 */
  description: Array<Scalars['String']>;
  /** 장비 목록 */
  equipmentList?: Maybe<Array<EquipmentInput>>;
  /** 빌드ID */
  id: Scalars['ID'];
  /** 피지컬 요소 리스트 */
  physicalElementList: Array<PhysicalElementType>;
  /** 반복 횟수 */
  repetition: Scalars['String'];
  /** 세트수 */
  set: Scalars['String'];
  /** 썸네일 링크 */
  thumbnailImageLink: Scalars['String'];
  /** 제목 */
  title: Scalars['String'];
  /** 트레이닝 솔루션 종류 */
  type: TrainingSolutionType;
  /** 비디오 링크 */
  videoLink: Scalars['String'];
  /** 무게 */
  weight?: Maybe<Scalars['Int']>;
};

/** 일정표 */
export type Calendar = {
  __typename: 'Calendar';
  /** 종료일 */
  endAt?: Maybe<Scalars['Date']>;
  /** 일정표 ID */
  id: Scalars['ID'];
  /** 이름 */
  name?: Maybe<Scalars['String']>;
  /** 시작일 */
  startAt?: Maybe<Scalars['Date']>;
  /** 팀ID */
  teamId: Scalars['ID'];
  /** 일정표 종류 */
  type?: Maybe<CalendarType>;
};

export enum CalendarType {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

/** 구독 취소 input */
export type CancelSubscriptionInput = {
  /** 구독ID */
  subscriptionId: Scalars['ID'];
  /** 팀ID */
  teamId: Scalars['ID'];
};

export enum CardCompanyCode {
  BC = 'BC',
  CITI = 'CITI',
  GWANGJUBANK = 'GWANGJUBANK',
  HANA = 'HANA',
  HYUNDAI = 'HYUNDAI',
  IBK_BC = 'IBK_BC',
  JEJUBANK = 'JEJUBANK',
  JEONBUKBANK = 'JEONBUKBANK',
  KAKAOBANK = 'KAKAOBANK',
  KBANK = 'KBANK',
  KDBBANK = 'KDBBANK',
  KOOKMIN = 'KOOKMIN',
  LOTTE = 'LOTTE',
  NONGHYEOP = 'NONGHYEOP',
  POST = 'POST',
  SAEMAUL = 'SAEMAUL',
  SAMSUNG = 'SAMSUNG',
  SAVINGBANK = 'SAVINGBANK',
  SHINHAN = 'SHINHAN',
  SHINHYEOP = 'SHINHYEOP',
  SUHYEOP = 'SUHYEOP',
  TOSSBANK = 'TOSSBANK',
  WOORI = 'WOORI'
}

/** 구독일 변경 input */
export type ChangeSubscriptionDateInput = {
  /** 종료일 */
  endAt: Scalars['DateTime'];
  /** 시작일 */
  startAt?: Maybe<Scalars['DateTime']>;
  /** 구독ID */
  subscriptionId: Scalars['ID'];
};

/** 구독 상품 정보 수정 input */
export type ChangeSubscriptionProductInput = {
  /** 구독 ID */
  id: Scalars['ID'];
  /** 상품 코드 */
  productCode: ProductCode;
};

export type ChartAvgData = ChartBody | ChartCondition | ChartSoreness | ChartWorkload | ChartWorkloadAcxrAxd;

/** 차트 신체 데이터 */
export type ChartBody = {
  __typename: 'ChartBody';
  /** 키 */
  height: Scalars['Float'];
  /** 체중 */
  weight: Scalars['Float'];
};

/** 컨디션 차트 */
export type ChartCondition = {
  __typename: 'ChartCondition';
  /** 컨디션 */
  condition: Scalars['Float'];
  /** 수면기간 */
  duration: Scalars['Float'];
  /** 피로도 */
  fatigue: Scalars['Float'];
  /** 기분 */
  mood: Scalars['Float'];
  /** 근육 */
  muscle: Scalars['Float'];
  /** 수면 품질 */
  quality: Scalars['Float'];
  /** 스트레스 */
  stress: Scalars['Float'];
};

/** 차트 데이터 */
export type ChartData = {
  __typename: 'ChartData';
  /** 차트 평균 데이터 */
  avg: ChartAvgData;
  /** 유저 목록 */
  userList: Array<ChartUser>;
};

/** 차트 통증 */
export type ChartSoreness = {
  __typename: 'ChartSoreness';
  /** 1단계 */
  level1: SorenessLevelData;
  /** 2단계 */
  level2: SorenessLevelData;
  /** 3단계 */
  level3: SorenessLevelData;
  /** 4단계 */
  level4: SorenessLevelData;
  /** 5단계 */
  level5: SorenessLevelData;
};

/** 차트 유저 */
export type ChartUser = {
  __typename: 'ChartUser';
  /** 유저 정보 */
  user: SportsUser;
  /** 값 */
  value: ChartUserData;
};

/** 선수 컨디션 차트 */
export type ChartUserCondition = {
  __typename: 'ChartUserCondition';
  /** 컨디션 점수 */
  condition?: Maybe<Scalars['Float']>;
  /** 수면 기간 */
  duration?: Maybe<Scalars['Float']>;
  /** 피로도 */
  fatigue?: Maybe<Scalars['Float']>;
  /** 기분 */
  mood?: Maybe<Scalars['Float']>;
  /** 근육 */
  muscle?: Maybe<Scalars['Float']>;
  /** 수면 품질 */
  quality?: Maybe<Scalars['Float']>;
  /** 스트레스 */
  stress?: Maybe<Scalars['Float']>;
};

export type ChartUserData = ChartBody | ChartSoreness | ChartUserCondition | ChartUserWorkload | ChartWorkloadAcxrAxd;

/** 차트 선수 운동부하 데이터 */
export type ChartUserWorkload = {
  __typename: 'ChartUserWorkload';
  /** 당일 운동시간의 합 */
  duration?: Maybe<Scalars['Float']>;
  /** 첫번째 운동부하의 아이디 */
  id?: Maybe<Scalars['ID']>;
  /** 당일 운동강도의 평균 */
  intensity?: Maybe<Scalars['Float']>;
  /** 운동 안 함 이유 */
  reasonForNoWorkout?: Maybe<NoWorkoutType>;
  /** 당일 운동만족도의 평균 */
  satisfaction?: Maybe<Scalars['Float']>;
  /** 당일 운동부하의 합 */
  workload?: Maybe<Scalars['Float']>;
  /** 운동부하 목록 */
  workloadList: Array<Maybe<Workload>>;
};

/** 운동부하 차트 */
export type ChartWorkload = {
  __typename: 'ChartWorkload';
  /** 운동시간 */
  duration: Scalars['Float'];
  /** 운동강도 */
  intensity: Scalars['Float'];
  /** 운동만족 */
  satisfaction: Scalars['Float'];
  /** 운동부하 */
  workload: Scalars['Float'];
};

/** 운동부하 부상위험도 */
export type ChartWorkloadAcxrAxd = {
  __typename: 'ChartWorkloadAcxrAxd';
  /** 부상위험도 */
  acxr: Scalars['Float'];
  /** 급성부하 */
  ax: Scalars['Float'];
  /** 값이 Infinity 일 때 null 로 응답 */
  axd?: Maybe<Scalars['Float']>;
  /** 만성부하 */
  cx: Scalars['Float'];
};

/** 쿠폰 팀 지급확인 input */
export type CheckIsGivenTeamsInput = {
  /** 팀ID 목록 */
  teamIdList: Array<Scalars['ID']>;
};

/** 쿠폰 유저 지급 확인 input */
export type CheckIsGivenUserListInput = {
  /** 유저ID 목록 */
  userIdList: Array<Scalars['ID']>;
};

/** 체크 리마인더 푸시 input */
export type CheckReminderPushInput = {
  /** 코치 이름 */
  coachName: Scalars['String'];
  /** 팀 ID */
  teamId: Scalars['String'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 유저 ID 목록 */
  userIdList?: Maybe<Array<Scalars['ID']>>;
};

/** 체크 일정 초대 리마인더 푸시 input */
export type CheckScheduleInviteReminderPushInput = {
  /** 코치 이름 */
  coachName: Scalars['String'];
  /** 일정ID */
  scheduleId: Scalars['ID'];
  /** 유저 ID 목록 */
  userIdList?: Maybe<Array<Scalars['ID']>>;
};

/** 체크 데이터 */
export type CheckedData = {
  __typename: 'CheckedData';
  /** 컨디션 체크 여부 */
  condition: CheckedOrNotData;
  /** 날짜 */
  date: Scalars['String'];
  /** 운동 체크 여부 */
  workload: CheckedOrNotData;
};

/** 운동 체크 선수 상세 */
export type CheckedDetailData = {
  __typename: 'CheckedDetailData';
  /** 운동 체크 선수 목록 */
  playerList: Array<SportsUser>;
  /** 전체 수 */
  total: Scalars['Float'];
};

/** 운동 체크 여부 */
export type CheckedOrNotData = {
  __typename: 'CheckedOrNotData';
  /** 체크 데이터 */
  checked: CheckedDetailData;
  /** 미체크 데이터  */
  unChecked: CheckedDetailData;
};

export type ClickUser = {
  __typename: 'ClickUser';
  actionList: Array<ActionList>;
  user: SportsUser;
};

/** 코멘트 */
export type Comment = {
  __typename: 'Comment';
  /** 코멘트 내용 */
  comment: Scalars['String'];
  /** 코멘트 작성 유저 정보 */
  createUser: SportsUser;
  /** 코멘트 생성 날짜 시간 */
  createdAt: Scalars['Date'];
  /** 코멘트 ID */
  id: Scalars['String'];
};

/** 완료 횟수 정보 */
export type CompleteCount = {
  __typename: 'CompleteCount';
  /** 완료 횟수 */
  completedCount: Scalars['Float'];
  /** 전체 횟수 */
  totalCount: Scalars['Float'];
};

export type CompletedCount = {
  __typename: 'CompletedCount';
  completedCount: Scalars['Float'];
  totalCount: Scalars['Float'];
};

/** 날짜별 종합 분석 */
export type ComprehensiveAnalysisByDate = {
  __typename: 'ComprehensiveAnalysisByDate';
  /** 종합 분석 상세 */
  dataList: Array<ComprehensiveAnalysisDetail>;
  /** 날짜 */
  date: Scalars['String'];
};

/** 종합 분석 상세 */
export type ComprehensiveAnalysisDetail = {
  __typename: 'ComprehensiveAnalysisDetail';
  /** 종합 분석 데이터 범례 */
  name: ComprehensiveAnalysisType;
  /** 종합 분석 상세 값 */
  value?: Maybe<Scalars['Float']>;
};

export enum ComprehensiveAnalysisType {
  AERIAL_ACTIONS = 'AERIAL_ACTIONS',
  AERIAL_ACTIONS_WON = 'AERIAL_ACTIONS_WON',
  AERIAL_ACTION_SUCCESS_RATE = 'AERIAL_ACTION_SUCCESS_RATE',
  AERIAL_DUELS = 'AERIAL_DUELS',
  AERIAL_DUELS_WON = 'AERIAL_DUELS_WON',
  AERIAL_DUEL_SUCCESS_RATE = 'AERIAL_DUEL_SUCCESS_RATE',
  ASSISTS = 'ASSISTS',
  AVAILABILITY = 'AVAILABILITY',
  AVERAGE_SPEED = 'AVERAGE_SPEED',
  BACK_PASSES = 'BACK_PASSES',
  BACK_PASS_ACCURACY = 'BACK_PASS_ACCURACY',
  BLOCKED_SHOTS = 'BLOCKED_SHOTS',
  CATCHES = 'CATCHES',
  CLEARANCES = 'CLEARANCES',
  CMJ_CONCENTRIC_FORCE = 'CMJ_CONCENTRIC_FORCE',
  CMJ_ECCENTRIC_FORCE = 'CMJ_ECCENTRIC_FORCE',
  CMJ_HEIGHT = 'CMJ_HEIGHT',
  CMJ_PEAK_POWER = 'CMJ_PEAK_POWER',
  CONDITION_FATIGUE = 'CONDITION_FATIGUE',
  CONDITION_MOOD = 'CONDITION_MOOD',
  CONDITION_MUSCLE = 'CONDITION_MUSCLE',
  CONDITION_SCORE = 'CONDITION_SCORE',
  CONDITION_SLEEP_DURATION = 'CONDITION_SLEEP_DURATION',
  CONDITION_SLEEP_QUALITY = 'CONDITION_SLEEP_QUALITY',
  CONDITION_STRESS = 'CONDITION_STRESS',
  CORNER_KICKS = 'CORNER_KICKS',
  CROSSES = 'CROSSES',
  CROSSES_BLOCKED = 'CROSSES_BLOCKED',
  CROSS_ACCURACY = 'CROSS_ACCURACY',
  DRIBBLE_ATTEMPTS = 'DRIBBLE_ATTEMPTS',
  DRIBBLE_SUCCESS_RATE = 'DRIBBLE_SUCCESS_RATE',
  EXTERNAL_WORKLOAD_DAILY_COUNT_OF_SPRINT = 'EXTERNAL_WORKLOAD_DAILY_COUNT_OF_SPRINT',
  EXTERNAL_WORKLOAD_DAILY_TOTAL_DISTANCE = 'EXTERNAL_WORKLOAD_DAILY_TOTAL_DISTANCE',
  EXTERNAL_WORKLOAD_DAILY_TOTAL_DURATION = 'EXTERNAL_WORKLOAD_DAILY_TOTAL_DURATION',
  EXTERNAL_WORKLOAD_DAILY_TOTAL_HSR_DISTANCE = 'EXTERNAL_WORKLOAD_DAILY_TOTAL_HSR_DISTANCE',
  EXTERNAL_WORKLOAD_DAILY_TOTAL_PLAYER_LOAD = 'EXTERNAL_WORKLOAD_DAILY_TOTAL_PLAYER_LOAD',
  EXTERNAL_WORKLOAD_TOTAL_DISTANCE_ACWR = 'EXTERNAL_WORKLOAD_TOTAL_DISTANCE_ACWR',
  EXTERNAL_WORKLOAD_TOTAL_HSR_DISTANCE_ACWR = 'EXTERNAL_WORKLOAD_TOTAL_HSR_DISTANCE_ACWR',
  FAT_PERCENTAGE = 'FAT_PERCENTAGE',
  FORWARD_PASSES = 'FORWARD_PASSES',
  FORWARD_PASS_ACCURACY = 'FORWARD_PASS_ACCURACY',
  FOULS = 'FOULS',
  FOULS_SUFFERED = 'FOULS_SUFFERED',
  FREE_KICKS = 'FREE_KICKS',
  FREE_KICK_CROSSES = 'FREE_KICK_CROSSES',
  FREE_KICK_SHOTS = 'FREE_KICK_SHOTS',
  FREE_KICK_SHOTS_ON_TARGET = 'FREE_KICK_SHOTS_ON_TARGET',
  GOALS = 'GOALS',
  GOALS_CONCEDED = 'GOALS_CONCEDED',
  GOAL_KICKS = 'GOAL_KICKS',
  GROUND_ACTIONS = 'GROUND_ACTIONS',
  GROUND_ACTIONS_WON = 'GROUND_ACTIONS_WON',
  GROUND_ACTION_SUCCESS_RATE = 'GROUND_ACTION_SUCCESS_RATE',
  GROUND_DUELS = 'GROUND_DUELS',
  GROUND_DUELS_WON = 'GROUND_DUELS_WON',
  GROUND_DUEL_SUCCESS_RATE = 'GROUND_DUEL_SUCCESS_RATE',
  HANDBALL_FOULS = 'HANDBALL_FOULS',
  HIGH_INTENSITY_RUNNING_RATIO = 'HIGH_INTENSITY_RUNNING_RATIO',
  INJURY_COUNT = 'INJURY_COUNT',
  INTERCEPTIONS = 'INTERCEPTIONS',
  KEY_PASSES = 'KEY_PASSES',
  LATERAL_PASSES = 'LATERAL_PASSES',
  LATERAL_PASS_ACCURACY = 'LATERAL_PASS_ACCURACY',
  LONG_PASSES = 'LONG_PASSES',
  LONG_PASS_ACCURACY = 'LONG_PASS_ACCURACY',
  LOOSE_BALL_DUELS = 'LOOSE_BALL_DUELS',
  LOOSE_BALL_DUELS_WON = 'LOOSE_BALL_DUELS_WON',
  LOOSE_BALL_DUEL_SUCCESS_RATE = 'LOOSE_BALL_DUEL_SUCCESS_RATE',
  MEDIUM_PASSES = 'MEDIUM_PASSES',
  MEDIUM_PASS_ACCURACY = 'MEDIUM_PASS_ACCURACY',
  MISCONTROLS = 'MISCONTROLS',
  NORDIC_HAMSTRING_ASYMMETRY = 'NORDIC_HAMSTRING_ASYMMETRY',
  NORDIC_HAMSTRING_AVERAGE_FORCE_LEFT = 'NORDIC_HAMSTRING_AVERAGE_FORCE_LEFT',
  NORDIC_HAMSTRING_AVERAGE_FORCE_RIGHT = 'NORDIC_HAMSTRING_AVERAGE_FORCE_RIGHT',
  NORDIC_HAMSTRING_MAX_FORCE_LEFT = 'NORDIC_HAMSTRING_MAX_FORCE_LEFT',
  NORDIC_HAMSTRING_MAX_FORCE_RIGHT = 'NORDIC_HAMSTRING_MAX_FORCE_RIGHT',
  OFFSIDES = 'OFFSIDES',
  OWN_GOALS = 'OWN_GOALS',
  PASSES = 'PASSES',
  PASSES_IN_ATTACKING_THIRD = 'PASSES_IN_ATTACKING_THIRD',
  PASSES_IN_DEFENSIVE_THIRD = 'PASSES_IN_DEFENSIVE_THIRD',
  PASSES_IN_MIDDLE_THIRD = 'PASSES_IN_MIDDLE_THIRD',
  PASSES_RECEIVED = 'PASSES_RECEIVED',
  PASS_ACCURACY = 'PASS_ACCURACY',
  PASS_ACCURACY_IN_ATTACKING_THIRD = 'PASS_ACCURACY_IN_ATTACKING_THIRD',
  PASS_ACCURACY_IN_DEFENSIVE_THIRD = 'PASS_ACCURACY_IN_DEFENSIVE_THIRD',
  PASS_ACCURACY_IN_MIDDLE_THIRD = 'PASS_ACCURACY_IN_MIDDLE_THIRD',
  PENALTIES_CONCEDED = 'PENALTIES_CONCEDED',
  PENALTIES_WON = 'PENALTIES_WON',
  PENALTY_KICKS = 'PENALTY_KICKS',
  PENALTY_SAVES = 'PENALTY_SAVES',
  POSSESSION = 'POSSESSION',
  PUNCHES = 'PUNCHES',
  REACTIVE_STRENGTH_INDEX = 'REACTIVE_STRENGTH_INDEX',
  RECOVERIES = 'RECOVERIES',
  RED_CARDS = 'RED_CARDS',
  SAVES = 'SAVES',
  SET_PIECE_GOALS = 'SET_PIECE_GOALS',
  SET_PIECE_GOALS_CONCEDED = 'SET_PIECE_GOALS_CONCEDED',
  SET_PIECE_SHOTS = 'SET_PIECE_SHOTS',
  SET_PIECE_SHOTS_CONCEDED = 'SET_PIECE_SHOTS_CONCEDED',
  SHORT_PASSES = 'SHORT_PASSES',
  SHORT_PASS_ACCURACY = 'SHORT_PASS_ACCURACY',
  SHOTS_BLOCKED = 'SHOTS_BLOCKED',
  SHOTS_INSIDE_BOX = 'SHOTS_INSIDE_BOX',
  SHOTS_OFF_TARGET = 'SHOTS_OFF_TARGET',
  SHOTS_ON_TARGET = 'SHOTS_ON_TARGET',
  SHOTS_OUTSIDE_BOX = 'SHOTS_OUTSIDE_BOX',
  SHOT_ACCURACY = 'SHOT_ACCURACY',
  SORENESS_COUNT = 'SORENESS_COUNT',
  SPRINT_COUNT = 'SPRINT_COUNT',
  SPRINT_DISTANCE = 'SPRINT_DISTANCE',
  STEP_INS = 'STEP_INS',
  SUCCESSFUL_BACK_PASSES = 'SUCCESSFUL_BACK_PASSES',
  SUCCESSFUL_CROSSES = 'SUCCESSFUL_CROSSES',
  SUCCESSFUL_DRIBBLES = 'SUCCESSFUL_DRIBBLES',
  SUCCESSFUL_FORWARD_PASSES = 'SUCCESSFUL_FORWARD_PASSES',
  SUCCESSFUL_FREE_KICK_CROSSES = 'SUCCESSFUL_FREE_KICK_CROSSES',
  SUCCESSFUL_LATERAL_PASSES = 'SUCCESSFUL_LATERAL_PASSES',
  SUCCESSFUL_LONG_PASSES = 'SUCCESSFUL_LONG_PASSES',
  SUCCESSFUL_MEDIUM_PASSES = 'SUCCESSFUL_MEDIUM_PASSES',
  SUCCESSFUL_PASSES = 'SUCCESSFUL_PASSES',
  SUCCESSFUL_PASSES_IN_ATTACKING_THIRD = 'SUCCESSFUL_PASSES_IN_ATTACKING_THIRD',
  SUCCESSFUL_PASSES_IN_DEFENSIVE_THIRD = 'SUCCESSFUL_PASSES_IN_DEFENSIVE_THIRD',
  SUCCESSFUL_PASSES_IN_MIDDLE_THIRD = 'SUCCESSFUL_PASSES_IN_MIDDLE_THIRD',
  SUCCESSFUL_SHORT_PASSES = 'SUCCESSFUL_SHORT_PASSES',
  SUM_9P = 'SUM_9P',
  TACKLES_LOST = 'TACKLES_LOST',
  TACKLES_SUCCESS_RATE = 'TACKLES_SUCCESS_RATE',
  TACKLES_WON_NO_POSSESSION = 'TACKLES_WON_NO_POSSESSION',
  TACKLES_WON_POSSESSION = 'TACKLES_WON_POSSESSION',
  TACKLE_ATTEMPTS = 'TACKLE_ATTEMPTS',
  THROW_INS = 'THROW_INS',
  THROW_IN_FOULS = 'THROW_IN_FOULS',
  TOP_SPEED = 'TOP_SPEED',
  TOTAL_BLOCKS = 'TOTAL_BLOCKS',
  TOTAL_DISTANCE = 'TOTAL_DISTANCE',
  TOTAL_FOULS = 'TOTAL_FOULS',
  TOTAL_SHOTS = 'TOTAL_SHOTS',
  TURNOVERS_CONCEDED = 'TURNOVERS_CONCEDED',
  TURNOVERS_WON = 'TURNOVERS_WON',
  VHIR_COUNT = 'VHIR_COUNT',
  VHIR_DISTANCE = 'VHIR_DISTANCE',
  WEIGHT = 'WEIGHT',
  WORKLOAD_ACWR = 'WORKLOAD_ACWR',
  WORKLOAD_AW = 'WORKLOAD_AW',
  WORKLOAD_AWD = 'WORKLOAD_AWD',
  WORKLOAD_CW = 'WORKLOAD_CW',
  WORKLOAD_DURATION_SUM = 'WORKLOAD_DURATION_SUM',
  WORKLOAD_STRAIN = 'WORKLOAD_STRAIN',
  WORKLOAD_SUM = 'WORKLOAD_SUM',
  YELLOW_CARDS = 'YELLOW_CARDS'
}

/** 컨디션 데이터 */
export type Condition = {
  __typename: 'Condition';
  ac: Scalars['Float'];
  cc: Scalars['Float'];
  /** 피로도 */
  fatigue: Scalars['Float'];
  /** 컨디션 ID */
  id: Scalars['ID'];
  /** 체크 여부 */
  isChecked: Scalars['Boolean'];
  /** 기분 */
  mood: Scalars['Float'];
  /** 근육 */
  muscle: Scalars['Float'];
  /** 준비도 */
  readiness: Scalars['Float'];
  /** 점수 */
  score: Scalars['Float'];
  /** 수면기간 */
  sleepDuration: Scalars['Float'];
  /** 수면품질 */
  sleepQuality: Scalars['Float'];
  /** 수면 시간 */
  sleepTime: Scalars['DateTimeString'];
  /** 스트레스 */
  stress: Scalars['Float'];
};

/** 컨디셔 관리 유저 */
export type ConditionCareUser = {
  __typename: 'ConditionCareUser';
  /** 유저 컨디션 데이터 목록 */
  dataList: Array<UserConditionDataType>;
  /** 유형 */
  type: UserConditionLabelType;
  /** 유저 정보 */
  user: SportsUser;
};

/** 컨디션 */
export type ConditionInfo = {
  /** 피로도 */
  fatigue?: Maybe<Scalars['Float']>;
  /** 기분 */
  mood?: Maybe<Scalars['Float']>;
  /** 근육 */
  muscle?: Maybe<Scalars['Float']>;
  /** 컨디션 점수 */
  score?: Maybe<Scalars['Float']>;
  /** 수면 시간 */
  sleepDuration?: Maybe<Scalars['Float']>;
  /** 수면 품질 */
  sleepQuality?: Maybe<Scalars['Float']>;
  /** 스트레스 */
  stress?: Maybe<Scalars['Float']>;
};

/** 브리핑 컨디션 리포트 - 피로도 데이터 */
export type ConditionReportFatigueData = {
  __typename: 'ConditionReportFatigueData';
  /** 피로도 */
  fatigue: Scalars['Float'];
  /** 지속일 */
  streak?: Maybe<Scalars['Float']>;
};

/** 브리핑 컨디션 리포트 - 기분 데이터 */
export type ConditionReportMoodData = {
  __typename: 'ConditionReportMoodData';
  /** 기분 */
  mood: Scalars['Float'];
  /** 지속일 */
  streak?: Maybe<Scalars['Float']>;
};

/** 브리핑 컨디션 리포트 - 근육 데이터 */
export type ConditionReportMuscleData = {
  __typename: 'ConditionReportMuscleData';
  /** 근육 */
  muscle: Scalars['Float'];
  /** 지속일 */
  streak?: Maybe<Scalars['Float']>;
};

/** 브리핑 컨디션 리포트 - 수면기간 데이터 */
export type ConditionReportSleepDurationData = {
  __typename: 'ConditionReportSleepDurationData';
  /** 수면 기간 */
  sleepDuration: Scalars['Float'];
  /** 지속일 */
  streak?: Maybe<Scalars['Float']>;
};

/** 브리핑 컨디션 리포트 - 수면품질 데이터 */
export type ConditionReportSleepQualityData = {
  __typename: 'ConditionReportSleepQualityData';
  /** 수면 품질 */
  sleepQuality: Scalars['Float'];
  /** 지속일 */
  streak?: Maybe<Scalars['Float']>;
};

/** 브리핑 컨디션 리포트 - 스트레스 데이터 */
export type ConditionReportStressData = {
  __typename: 'ConditionReportStressData';
  /** 지속일 */
  streak?: Maybe<Scalars['Float']>;
  /** 스트레스 */
  stress: Scalars['Float'];
};

/** 유저 컨디션 */
export type ConditionScoreUser = {
  __typename: 'ConditionScoreUser';
  /** 컨디션 점수 */
  score: Scalars['Float'];
  /** 유저 정보 */
  user: SportsUser;
};

/** 컨디션 솔루션 */
export type ConditionSolution = {
  __typename: 'ConditionSolution';
  /** 카테고리 */
  category: Scalars['String'];
  /** 시작일 */
  declineStartDate?: Maybe<Scalars['String']>;
  /** 가이드 */
  guide: Scalars['String'];
  /** 컨디션 솔루션 종류 */
  type: ConditionSolutionType;
};

export enum ConditionSolutionType {
  CB = 'CB',
  CC1 = 'CC1',
  CC2 = 'CC2',
  CE1 = 'CE1',
  CE2 = 'CE2',
  CE3 = 'CE3'
}

export type ConditionStreakData = ConditionReportFatigueData | ConditionReportMoodData | ConditionReportMuscleData | ConditionReportSleepDurationData | ConditionReportSleepQualityData | ConditionReportStressData;

/** 컨디션 팀 솔루션 */
export type ConditionTeamSolution = {
  __typename: 'ConditionTeamSolution';
  /** 가이드 */
  guide: Scalars['String'];
  /** 컨디션 팀 솔루션 조회 여부 */
  isViewed: Scalars['Boolean'];
  /** 컨디션 팀 솔루션 종류 */
  type: ConditionTeamSolutionType;
};

export enum ConditionTeamSolutionType {
  CA1 = 'CA1',
  CA2 = 'CA2'
}

/** 컨디션 유저 정보 */
export type ConditionUser = {
  __typename: 'ConditionUser';
  /** 컨디션 목록 */
  conditionList: Array<ConditionStreakData>;
  /** 유저 정보 */
  user: SportsUser;
};

/** 브리핑 컨디션 리포트 - 유저 별 통증 데이터 */
export type ConditionUserData = {
  __typename: 'ConditionUserData';
  /** 컨디션 데이터 조회 여부 */
  isViewed: Scalars['Boolean'];
  /** 컨디션 유저 데이터 리스트 */
  userList: Array<ConditionUserDetailData>;
};

/** 브리핑 컨디션 리포트 - 유저 상세 데이터 */
export type ConditionUserDetailData = {
  __typename: 'ConditionUserDetailData';
  /** 유저 조회 여부 */
  isViewed: Scalars['Boolean'];
  /** 유저 정보 */
  user: SportsUser;
  /** 컨디션 데이터 */
  value?: Maybe<Scalars['Float']>;
};

/** 학부모/선수 연결 및 상태 요청 input */
export type ConnectParentPlayerInput = {
  /** 연결 및 상태 변경 요청 */
  action: ConnectedAction;
  /** 사용자의 롤 */
  role: SportsRole;
  /** 유저 ID */
  userId: Scalars['String'];
};

export enum ConnectedAction {
  ACCEPT = 'ACCEPT',
  DISCONNECT = 'DISCONNECT',
  REJECT = 'REJECT',
  REQUEST = 'REQUEST'
}

export enum ConnectedStatus {
  CONNECTED = 'CONNECTED',
  PENDING = 'PENDING'
}

export enum Contact {
  CONTACT = 'CONTACT',
  NON_CONTACT = 'NON_CONTACT',
  NO_SORENESS = 'NO_SORENESS',
  UNKNOWN = 'UNKNOWN'
}

/** 코디네이팅 컨디션 리포트 데이터 */
export type CoordinatingConditionReportData = {
  __typename: 'CoordinatingConditionReportData';
  /** 새 통증 유저 목록 */
  newSorenessUserList: Array<SorenessUserDetailData>;
  /** 회복 통증 유저 목록 */
  recoverSorenessUserList: Array<SorenessUserDetailData>;
  /** 심각한 컨디션 유저 목록 */
  severeConditionUserList: Array<ConditionUser>;
  /** 심각한 통증 유저 목록 */
  severeSorenessUserList: Array<SorenessUserDetailData>;
  /** 코디네이팅 컨디션 리포트 솔루션 */
  solution: SolutionDetailData;
};

/** 코디네이팅 경기 리포트 데이터 */
export type CoordinatingMatchReportData = {
  __typename: 'CoordinatingMatchReportData';
  /** 만족 유저 ID 목록 */
  satisfactionUserIdList: Array<SatisfactionUserId>;
  /** 일정 경기 정보 */
  schedule: MatchScheduleForCoordinatingReport;
  /** 경기 리포트 솔루션 */
  solution?: Maybe<MatchReportSolution>;
};

/** 코디네이팅 훈련 리포트 데이터 */
export type CoordinatingTrainingReportData = {
  __typename: 'CoordinatingTrainingReportData';
  /** 재활, 골키퍼 재외 평균 */
  avgExcludeRehabAndGK: AvgExcludeRehabAndGk;
  highDiffWithTeamIntensityAvgUserList: Array<IntensityUser>;
  /** 골키퍼 팀 포함 유무 */
  isTeamIncludeGKPlayer: Scalars['Boolean'];
  /** 낮은 만족도 유저 목록 */
  lowSatisfactionUserList: Array<SatisfactionUser>;
  /** 일정 정보 */
  schedule: TrainingScheduleForCoordinatingReport;
  /** 브리핑 - 운동 부하 솔루션 */
  solution?: Maybe<TrainingReportSolution>;
};

export type Country = {
  __typename: 'Country';
  defaultLanguage?: Maybe<Scalars['String']>;
  defaultUTCOffset?: Maybe<Scalars['Int']>;
  id?: Maybe<CountryCode>;
};

export enum CountryCode {
  all_country_code__ad = 'all_country_code__ad',
  all_country_code__ae = 'all_country_code__ae',
  all_country_code__af = 'all_country_code__af',
  all_country_code__ag = 'all_country_code__ag',
  all_country_code__ai = 'all_country_code__ai',
  all_country_code__al = 'all_country_code__al',
  all_country_code__am = 'all_country_code__am',
  all_country_code__ao = 'all_country_code__ao',
  all_country_code__aq = 'all_country_code__aq',
  all_country_code__ar = 'all_country_code__ar',
  all_country_code__as = 'all_country_code__as',
  all_country_code__at = 'all_country_code__at',
  all_country_code__au = 'all_country_code__au',
  all_country_code__aw = 'all_country_code__aw',
  all_country_code__ax = 'all_country_code__ax',
  all_country_code__az = 'all_country_code__az',
  all_country_code__ba = 'all_country_code__ba',
  all_country_code__bb = 'all_country_code__bb',
  all_country_code__bd = 'all_country_code__bd',
  all_country_code__be = 'all_country_code__be',
  all_country_code__bf = 'all_country_code__bf',
  all_country_code__bg = 'all_country_code__bg',
  all_country_code__bh = 'all_country_code__bh',
  all_country_code__bi = 'all_country_code__bi',
  all_country_code__bj = 'all_country_code__bj',
  all_country_code__bl = 'all_country_code__bl',
  all_country_code__bm = 'all_country_code__bm',
  all_country_code__bn = 'all_country_code__bn',
  all_country_code__bo = 'all_country_code__bo',
  all_country_code__bq = 'all_country_code__bq',
  all_country_code__br = 'all_country_code__br',
  all_country_code__bs = 'all_country_code__bs',
  all_country_code__bt = 'all_country_code__bt',
  all_country_code__bv = 'all_country_code__bv',
  all_country_code__bw = 'all_country_code__bw',
  all_country_code__by = 'all_country_code__by',
  all_country_code__bz = 'all_country_code__bz',
  all_country_code__ca = 'all_country_code__ca',
  all_country_code__cc = 'all_country_code__cc',
  all_country_code__cd = 'all_country_code__cd',
  all_country_code__cf = 'all_country_code__cf',
  all_country_code__cg = 'all_country_code__cg',
  all_country_code__ch = 'all_country_code__ch',
  all_country_code__ci = 'all_country_code__ci',
  all_country_code__ck = 'all_country_code__ck',
  all_country_code__cl = 'all_country_code__cl',
  all_country_code__cm = 'all_country_code__cm',
  all_country_code__cn = 'all_country_code__cn',
  all_country_code__co = 'all_country_code__co',
  all_country_code__cr = 'all_country_code__cr',
  all_country_code__cu = 'all_country_code__cu',
  all_country_code__cv = 'all_country_code__cv',
  all_country_code__cw = 'all_country_code__cw',
  all_country_code__cx = 'all_country_code__cx',
  all_country_code__cy = 'all_country_code__cy',
  all_country_code__cz = 'all_country_code__cz',
  all_country_code__de = 'all_country_code__de',
  all_country_code__dj = 'all_country_code__dj',
  all_country_code__dk = 'all_country_code__dk',
  all_country_code__dm = 'all_country_code__dm',
  all_country_code__do = 'all_country_code__do',
  all_country_code__dz = 'all_country_code__dz',
  all_country_code__ec = 'all_country_code__ec',
  all_country_code__ee = 'all_country_code__ee',
  all_country_code__eg = 'all_country_code__eg',
  all_country_code__eh = 'all_country_code__eh',
  all_country_code__er = 'all_country_code__er',
  all_country_code__es = 'all_country_code__es',
  all_country_code__et = 'all_country_code__et',
  all_country_code__fi = 'all_country_code__fi',
  all_country_code__fj = 'all_country_code__fj',
  all_country_code__fk = 'all_country_code__fk',
  all_country_code__fm = 'all_country_code__fm',
  all_country_code__fo = 'all_country_code__fo',
  all_country_code__fr = 'all_country_code__fr',
  all_country_code__ga = 'all_country_code__ga',
  all_country_code__gb = 'all_country_code__gb',
  all_country_code__gd = 'all_country_code__gd',
  all_country_code__ge = 'all_country_code__ge',
  all_country_code__gf = 'all_country_code__gf',
  all_country_code__gg = 'all_country_code__gg',
  all_country_code__gh = 'all_country_code__gh',
  all_country_code__gi = 'all_country_code__gi',
  all_country_code__gl = 'all_country_code__gl',
  all_country_code__gm = 'all_country_code__gm',
  all_country_code__gn = 'all_country_code__gn',
  all_country_code__gp = 'all_country_code__gp',
  all_country_code__gq = 'all_country_code__gq',
  all_country_code__gr = 'all_country_code__gr',
  all_country_code__gs = 'all_country_code__gs',
  all_country_code__gt = 'all_country_code__gt',
  all_country_code__gu = 'all_country_code__gu',
  all_country_code__gw = 'all_country_code__gw',
  all_country_code__gy = 'all_country_code__gy',
  all_country_code__hk = 'all_country_code__hk',
  all_country_code__hm = 'all_country_code__hm',
  all_country_code__hn = 'all_country_code__hn',
  all_country_code__hr = 'all_country_code__hr',
  all_country_code__ht = 'all_country_code__ht',
  all_country_code__hu = 'all_country_code__hu',
  all_country_code__id = 'all_country_code__id',
  all_country_code__ie = 'all_country_code__ie',
  all_country_code__il = 'all_country_code__il',
  all_country_code__im = 'all_country_code__im',
  all_country_code__in = 'all_country_code__in',
  all_country_code__io = 'all_country_code__io',
  all_country_code__iq = 'all_country_code__iq',
  all_country_code__ir = 'all_country_code__ir',
  all_country_code__is = 'all_country_code__is',
  all_country_code__it = 'all_country_code__it',
  all_country_code__je = 'all_country_code__je',
  all_country_code__jm = 'all_country_code__jm',
  all_country_code__jo = 'all_country_code__jo',
  all_country_code__jp = 'all_country_code__jp',
  all_country_code__ke = 'all_country_code__ke',
  all_country_code__kg = 'all_country_code__kg',
  all_country_code__kh = 'all_country_code__kh',
  all_country_code__ki = 'all_country_code__ki',
  all_country_code__km = 'all_country_code__km',
  all_country_code__kn = 'all_country_code__kn',
  all_country_code__kp = 'all_country_code__kp',
  all_country_code__kr = 'all_country_code__kr',
  all_country_code__kw = 'all_country_code__kw',
  all_country_code__ky = 'all_country_code__ky',
  all_country_code__kz = 'all_country_code__kz',
  all_country_code__la = 'all_country_code__la',
  all_country_code__lb = 'all_country_code__lb',
  all_country_code__lc = 'all_country_code__lc',
  all_country_code__li = 'all_country_code__li',
  all_country_code__lk = 'all_country_code__lk',
  all_country_code__lr = 'all_country_code__lr',
  all_country_code__ls = 'all_country_code__ls',
  all_country_code__lt = 'all_country_code__lt',
  all_country_code__lu = 'all_country_code__lu',
  all_country_code__lv = 'all_country_code__lv',
  all_country_code__ly = 'all_country_code__ly',
  all_country_code__ma = 'all_country_code__ma',
  all_country_code__mc = 'all_country_code__mc',
  all_country_code__md = 'all_country_code__md',
  all_country_code__me = 'all_country_code__me',
  all_country_code__mf = 'all_country_code__mf',
  all_country_code__mg = 'all_country_code__mg',
  all_country_code__mh = 'all_country_code__mh',
  all_country_code__mk = 'all_country_code__mk',
  all_country_code__ml = 'all_country_code__ml',
  all_country_code__mm = 'all_country_code__mm',
  all_country_code__mn = 'all_country_code__mn',
  all_country_code__mo = 'all_country_code__mo',
  all_country_code__mp = 'all_country_code__mp',
  all_country_code__mq = 'all_country_code__mq',
  all_country_code__mr = 'all_country_code__mr',
  all_country_code__ms = 'all_country_code__ms',
  all_country_code__mt = 'all_country_code__mt',
  all_country_code__mu = 'all_country_code__mu',
  all_country_code__mv = 'all_country_code__mv',
  all_country_code__mw = 'all_country_code__mw',
  all_country_code__mx = 'all_country_code__mx',
  all_country_code__my = 'all_country_code__my',
  all_country_code__mz = 'all_country_code__mz',
  all_country_code__na = 'all_country_code__na',
  all_country_code__nc = 'all_country_code__nc',
  all_country_code__ne = 'all_country_code__ne',
  all_country_code__nf = 'all_country_code__nf',
  all_country_code__ng = 'all_country_code__ng',
  all_country_code__ni = 'all_country_code__ni',
  all_country_code__nl = 'all_country_code__nl',
  all_country_code__no = 'all_country_code__no',
  all_country_code__np = 'all_country_code__np',
  all_country_code__nr = 'all_country_code__nr',
  all_country_code__nu = 'all_country_code__nu',
  all_country_code__nz = 'all_country_code__nz',
  all_country_code__om = 'all_country_code__om',
  all_country_code__pa = 'all_country_code__pa',
  all_country_code__pe = 'all_country_code__pe',
  all_country_code__pf = 'all_country_code__pf',
  all_country_code__pg = 'all_country_code__pg',
  all_country_code__ph = 'all_country_code__ph',
  all_country_code__pk = 'all_country_code__pk',
  all_country_code__pl = 'all_country_code__pl',
  all_country_code__pm = 'all_country_code__pm',
  all_country_code__pn = 'all_country_code__pn',
  all_country_code__pr = 'all_country_code__pr',
  all_country_code__ps = 'all_country_code__ps',
  all_country_code__pt = 'all_country_code__pt',
  all_country_code__pw = 'all_country_code__pw',
  all_country_code__py = 'all_country_code__py',
  all_country_code__qa = 'all_country_code__qa',
  all_country_code__re = 'all_country_code__re',
  all_country_code__ro = 'all_country_code__ro',
  all_country_code__rs = 'all_country_code__rs',
  all_country_code__ru = 'all_country_code__ru',
  all_country_code__rw = 'all_country_code__rw',
  all_country_code__sa = 'all_country_code__sa',
  all_country_code__sb = 'all_country_code__sb',
  all_country_code__sc = 'all_country_code__sc',
  all_country_code__sd = 'all_country_code__sd',
  all_country_code__se = 'all_country_code__se',
  all_country_code__sg = 'all_country_code__sg',
  all_country_code__sh = 'all_country_code__sh',
  all_country_code__si = 'all_country_code__si',
  all_country_code__sj = 'all_country_code__sj',
  all_country_code__sk = 'all_country_code__sk',
  all_country_code__sl = 'all_country_code__sl',
  all_country_code__sm = 'all_country_code__sm',
  all_country_code__sn = 'all_country_code__sn',
  all_country_code__so = 'all_country_code__so',
  all_country_code__sr = 'all_country_code__sr',
  all_country_code__ss = 'all_country_code__ss',
  all_country_code__st = 'all_country_code__st',
  all_country_code__sv = 'all_country_code__sv',
  all_country_code__sx = 'all_country_code__sx',
  all_country_code__sy = 'all_country_code__sy',
  all_country_code__sz = 'all_country_code__sz',
  all_country_code__tc = 'all_country_code__tc',
  all_country_code__td = 'all_country_code__td',
  all_country_code__tf = 'all_country_code__tf',
  all_country_code__tg = 'all_country_code__tg',
  all_country_code__th = 'all_country_code__th',
  all_country_code__tj = 'all_country_code__tj',
  all_country_code__tk = 'all_country_code__tk',
  all_country_code__tl = 'all_country_code__tl',
  all_country_code__tm = 'all_country_code__tm',
  all_country_code__tn = 'all_country_code__tn',
  all_country_code__to = 'all_country_code__to',
  all_country_code__tr = 'all_country_code__tr',
  all_country_code__tt = 'all_country_code__tt',
  all_country_code__tv = 'all_country_code__tv',
  all_country_code__tw = 'all_country_code__tw',
  all_country_code__tz = 'all_country_code__tz',
  all_country_code__ua = 'all_country_code__ua',
  all_country_code__ug = 'all_country_code__ug',
  all_country_code__um = 'all_country_code__um',
  all_country_code__us = 'all_country_code__us',
  all_country_code__uy = 'all_country_code__uy',
  all_country_code__uz = 'all_country_code__uz',
  all_country_code__va = 'all_country_code__va',
  all_country_code__vc = 'all_country_code__vc',
  all_country_code__ve = 'all_country_code__ve',
  all_country_code__vg = 'all_country_code__vg',
  all_country_code__vi = 'all_country_code__vi',
  all_country_code__vn = 'all_country_code__vn',
  all_country_code__vu = 'all_country_code__vu',
  all_country_code__wf = 'all_country_code__wf',
  all_country_code__ws = 'all_country_code__ws',
  all_country_code__ye = 'all_country_code__ye',
  all_country_code__yt = 'all_country_code__yt',
  all_country_code__za = 'all_country_code__za',
  all_country_code__zm = 'all_country_code__zm',
  all_country_code__zw = 'all_country_code__zw'
}

/** 쿠폰 할인 정보 */
export type CouponApplied = {
  __typename: 'CouponApplied';
  /** 할인 적용 금액 */
  deductedPrice?: Maybe<Scalars['Int']>;
  /** 할인 정보 */
  discountInfo: DiscountInfo;
  /** 할인금액 */
  discountedPrice?: Maybe<Scalars['Int']>;
  /** 할인전 금액 */
  originalPrice: Scalars['Int'];
};

/** 쿠폰 상세 정보 */
export type CouponDetail = {
  __typename: 'CouponDetail';
  /** 쿠폰ID */
  couponId: Scalars['ID'];
  /** 쿠폰 아이템 페이징 목록 */
  couponItemListByPage: CouponItemListByPage;
  /** 할인 정보 */
  discountInfo: DiscountInfo;
  /** 종료일 */
  endAt: Scalars['Date'];
  /** 적용 가능 횟수 */
  limitCount: Scalars['Int'];
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 이름 */
  name: Scalars['String'];
  /** 남은 일수 */
  remainDays: Scalars['Int'];
  /** 시작일 */
  startAt: Scalars['Date'];
  /** 전체 발급 팀 개수 */
  totalTeamCnt: Scalars['Int'];
  /** 전체 유저 발급 개수 */
  totalUserCnt: Scalars['Int'];
  /** 사용 팀 개수 */
  useTeamCnt: Scalars['Int'];
  /** 사용 유저 개수 */
  useUserCnt: Scalars['Int'];
};


/** 쿠폰 상세 정보 */
export type CouponDetailCouponItemListByPageArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export enum CouponDiscountType {
  FIXED_RATE_DISCOUNT = 'FIXED_RATE_DISCOUNT',
  FLAT_DISCOUNT = 'FLAT_DISCOUNT'
}

/** 팀 쿠폰 지급 여부 정보 */
export type CouponIsGivenTeam = {
  __typename: 'CouponIsGivenTeam';
  /** 팀 쿠폰 지급 여부 */
  isGiven: Scalars['Boolean'];
  /** 팀ID */
  ownerToken: Scalars['String'];
};

/** 팀 쿠폰 지급 목록 */
export type CouponIsGivenTeamList = {
  __typename: 'CouponIsGivenTeamList';
  /** 팀 쿠폰 지급 여부 정보 */
  content?: Maybe<Array<CouponIsGivenTeam>>;
};

/** 유저 쿠폰 지급 여부 정보 */
export type CouponIsGivenUser = {
  __typename: 'CouponIsGivenUser';
  /** 유저 쿠폰 지급 여부 */
  isGiven: Scalars['Boolean'];
  /** 유저ID */
  userId: Scalars['String'];
};

/** 유저 쿠폰 지급 목록 */
export type CouponIsGivenUserList = {
  __typename: 'CouponIsGivenUserList';
  /** 유저 쿠폰 지급 여부 정보 */
  content?: Maybe<Array<CouponIsGivenUser>>;
};

/** 쿠폰 아이템 페이징 목록 */
export type CouponItemListByPage = {
  __typename: 'CouponItemListByPage';
  /** 팀 쿠폰 아이템 페이징 목록 */
  teamCouponItemListByPage?: Maybe<TeamCouponItemByPage>;
  /** 유저 쿠폰 아이템 페이징 목록 */
  userCouponItemListByPage?: Maybe<UserCouponItemByPage>;
};

export enum CouponItemStateType {
  TERMINATED = 'TERMINATED',
  UNUSED = 'UNUSED',
  USE_COMPLETE = 'USE_COMPLETE',
  USING = 'USING'
}

/** 쿠폰 페이징 정보 목록 */
export type CouponListByPage = Page & {
  __typename: 'CouponListByPage';
  /** 쿠폰 정보 */
  content?: Maybe<Array<CouponSimple>>;
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

/** 팀 쿠폰 지급 목록 */
export type CouponListByTeam = {
  __typename: 'CouponListByTeam';
  /** 쿠폰 정보 */
  content?: Maybe<Array<CouponSimple>>;
};

/** 쿠폰 정보 */
export type CouponSimple = {
  __typename: 'CouponSimple';
  /** 쿠폰ID */
  couponId: Scalars['ID'];
  /** 종료일 */
  endAt: Scalars['Date'];
  /** 이름 */
  name: Scalars['String'];
  /** 남은 일수 */
  remainDays: Scalars['Int'];
  /** 시작일 */
  startAt: Scalars['Date'];
};

export type CreateBodyInput = {
  /** 신장 */
  height: Scalars['Float'];
  /** 신장 단위 */
  heightUnit?: Maybe<HeightUnit>;
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 체중 */
  weight: Scalars['Float'];
  /** 체중 단위 */
  weightUnit?: Maybe<WeightUnit>;
};

/** 팀 미체크 알림 발송 스케줄 생성 input */
export type CreateCheckReminderPushSchedule = {
  /** 푸시 메시지 종류 */
  pushMessageType: ReminderPushMessageType;
  /** 전송 시간 */
  scheduleTime: Scalars['String'];
  /** 팀ID 목록 */
  teamIdList: Array<Scalars['String']>;
  /** 타임존 */
  timezone: Scalars['String'];
};

export type CreateConditionAndSorenessInput = {
  /** 피로도 */
  fatigue: Scalars['Int'];
  /** 기분 */
  mood: Scalars['Int'];
  /** 근육 */
  muscle: Scalars['Int'];
  /** 수면 기간 */
  sleepDuration: Scalars['Int'];
  /** 수면 품질 */
  sleepQuality: Scalars['Int'];
  /** 수면시간 */
  sleepTime: Scalars['DateTime'];
  /** 통증 목록 */
  sorenessList: Array<SorenessInput>;
  /** 스트레스 */
  stress: Scalars['Int'];
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
};

/** 컨디션 생성 inputs */
export type CreateConditionInput = {
  /** 피로도 */
  fatigue: Scalars['Int'];
  /** 기분 */
  mood: Scalars['Int'];
  /** 근육 */
  muscle: Scalars['Int'];
  /** 수면 기간 */
  sleepDuration: Scalars['Int'];
  /** 수면 품질 */
  sleepQuality: Scalars['Int'];
  /** 수면시간 */
  sleepTime: Scalars['DateTime'];
  /** 스트레스 */
  stress: Scalars['Int'];
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
};

/** 쿠폰 생성 input */
export type CreateCouponInput = {
  /** 쿠폰 할인 종류 */
  discountType: CouponDiscountType;
  /** 할인 가격 */
  discountValue: Scalars['Int'];
  /** 종료일 */
  endAt: Scalars['DateTime'];
  /** 적용 가능 횟수 */
  limitCount: Scalars['Int'];
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 이름 */
  name: Scalars['String'];
  /** 시작일 */
  startAt: Scalars['DateTime'];
};

/** 피드백 댓글 생성 input */
export type CreateFeedbackCommentInput = {
  /** 댓글 */
  comment: Scalars['String'];
  /** 피드백ID */
  feedbackId: Scalars['ID'];
};

/** 피드백 생성 input */
export type CreateFeedbackInput = {
  /** 컨디션 난조 */
  conditionNotGood?: Maybe<FeedbackConditionNotGoodInput>;
  /** 컨디션 급락 */
  conditionPlummet?: Maybe<FeedbackConditionPlummetInput>;
  /** 날짜, YYYY-MM-DD 형식 */
  date: Scalars['String'];
  /** 메시지 */
  message: Scalars['String'];
  /** 선수 유저 ID */
  playerId: Scalars['String'];
  /** 심각한 통증 */
  sorenessSevere?: Maybe<FeedbackSorenessSevereInput>;
  /** 팀ID */
  teamId: Scalars['String'];
  /** 피드백 목록 */
  type: FeedbackType;
  /** 운동부하 메모 */
  workloadMemo?: Maybe<FeedbackWorkloadMemoInput>;
  /** 운동부하 부상 위험 */
  workloadRiskAtInjury?: Maybe<FeedbackWorkloadRiskAtInjuryInput>;
};

/** 하이퍼 유저 생성 input */
export type CreateHyperClientInput = {
  /** 생년월일 */
  birthdate?: Maybe<Scalars['String']>;
  /** 이메일 */
  email: Scalars['String'];
  /** 유저 존재 유무 */
  isExistsUser: Scalars['Boolean'];
  /** 이름 */
  name?: Maybe<Scalars['String']>;
  /** 패스워드 */
  password?: Maybe<Scalars['String']>;
  /** 전화번호 */
  phoneNumber?: Maybe<Scalars['String']>;
};

/** 부상 생성 input */
export type CreateInjuryInput = {
  /** 부위 */
  bodyPart?: Maybe<SportsBodyPartName>;
  /** 진단, 최대 100자 */
  diagnosis?: Maybe<Scalars['String']>;
  /** 부상 히스토리 상태 */
  historyStatus: InjuryHistoryStatus;
  /** 접촉 여부 */
  isContact?: Maybe<InjuryContact>;
  /** 의료 기록, 최대 100자 */
  medicalRecord?: Maybe<Scalars['String']>;
  /** 발생일 */
  occurDate: Scalars['DateTime'];
  /** 이유, 최대 100자 */
  reason?: Maybe<Scalars['String']>;
  /** 부상 복귀 */
  return: ReturnInput;
  /** 일정ID */
  scheduleId?: Maybe<Scalars['String']>;
  /** 부상 상태 */
  status: InjuryStatus;
  /** 직접 입력 내용 */
  symptomEnterDirectly?: Maybe<Scalars['String']>;
  /** 증상 타입 목록 */
  symptomList?: Maybe<Array<SymptomType>>;
  /** 팀ID */
  teamId: Scalars['ID'];
  /** 유저ID */
  userId: Scalars['ID'];
};

/** 나의 할일 생성 input */
export type CreateInput = {
  /** 스케줄 */
  schedule?: Maybe<ScheduleInput>;
  /** 제목 */
  title: Scalars['String'];
};

/** 라이센스 생성 input */
export type CreateLicenseInput = {
  /** 종료일 */
  endAt: Scalars['DateTime'];
  /** 라이센스명 */
  licenseName: Scalars['String'];
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 시작일 */
  startAt: Scalars['DateTime'];
  /** 소속팀 최대 갯수 */
  teamVolume: Scalars['Int'];
};

/** 운동 안함 input */
export type CreateNoWorkoutInput = {
  /** 운동 안함 사유 */
  reasonForNoWorkout: NoWorkoutType;
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
};

/** 관찰 리포트 생성 input */
export type CreateObservationReportInput = {
  /** 종합 코멘트 */
  comprehensiveComment?: Maybe<Scalars['String']>;
  /** 심리 평가 */
  mental: MentalObservationReportInput;
  /** 신체 평가 */
  physical: PhysicalObservationReportInput;
  /** 스카우팅 선수 ID */
  prospectPlayerId: Scalars['String'];
  /** 일정 정보 */
  schedule: ObservationReportScheduleInput;
  /** 전술 평가 */
  tactic: TacticObservationReportInput;
  /** 기술 평가 */
  technic: TechnicObservationReportInput;
};

/** 팝업 생성 input */
export type CreatePopupInput = {
  /** 생성일 */
  createdAt: Scalars['Date'];
  /** 성별 */
  genderList: Array<GenderType>;
  /** 오늘 보지 않음 버튼 여부 */
  isTodayHidden: Scalars['Boolean'];
  /** url */
  landingUrl?: Maybe<Scalars['String']>;
  /** 언어 */
  languageList: Array<Language>;
  /** 최대 연령 */
  maxAge?: Maybe<Scalars['Float']>;
  /** 최소 연령 */
  minAge?: Maybe<Scalars['Float']>;
  /** os 종류 */
  osTypeList: Array<OsType>;
  /** 게시 종료일 */
  publishEndAt?: Maybe<Scalars['Date']>;
  /** 게시 시작일 */
  publishStartAt: Scalars['Date'];
  /** 제목 */
  title: Scalars['String'];
};

/** 스카우팅 선수 코멘트 생성 input */
export type CreateProspectPlayerCommentInput = {
  /** 코멘트 */
  comment: Scalars['String'];
  /** 스카우팅 선수 ID */
  prospectPlayerId: Scalars['String'];
};

/** 스카우팅 선수 생성 input */
export type CreateProspectPlayerInput = {
  /** 에이전트/소속사 */
  agent?: Maybe<Scalars['String']>;
  /** 수상 이력 목록 */
  awardHistoryList: Array<AwardHistoryInput>;
  /** 생년월일 */
  birthDate: Scalars['String'];
  /** 기타 사항 */
  etc?: Maybe<Scalars['String']>;
  /** 키 */
  height?: Maybe<Scalars['Float']>;
  /** 부상 이력 목록 */
  injuryHistoryList: Array<InjuryHistoryInput>;
  /** 이름 */
  name: Scalars['String'];
  /** 국적 */
  nationality?: Maybe<CountryCode>;
  /** 포지션 목록 */
  positionList: Array<ProspectPlayerPositionType>;
  /** 주발 */
  preferredFoot?: Maybe<PreferredFootType>;
  /** 소셜 미디어 목록 */
  socialMediaList: Array<SocialMediaInput>;
  /** 팀 소속 이력 목록 */
  teamHistoryList: Array<TeamHistoryInput>;
  /** 팀 ID */
  teamId: Scalars['String'];
  /** 몸무게 */
  weight?: Maybe<Scalars['Float']>;
};

export type CreateScheduleAttendanceStatusInput = {
  absenceReason?: Maybe<Scalars['String']>;
  scheduleId: Scalars['ID'];
  status: ScheduleInviteeStatus;
};

/** 스카우팅 모델 수정 input */
export type CreateScoutingModelInput = {
  /** 심리 기준 */
  mental: MentalScoutingModelInput;
  /** 신체 가중치 */
  mentalWeight: Scalars['Int'];
  /** 신체 기준 */
  physical: PhysicalScoutingModelInput;
  /** 신체 가중치 */
  physicalWeight: Scalars['Int'];
  /** 포지션 */
  position: ProspectPlayerPositionType;
  /** 전술 기준 */
  tactic: TacticScoutingModelInput;
  /** 신체 가중치 */
  tacticWeight: Scalars['Int'];
  /** 팀 ID */
  teamId: Scalars['String'];
  /** 기술 기준 */
  technic: TechnicScoutingModelInput;
  /** 신체 가중치 */
  technicWeight: Scalars['Int'];
};

/** 배송지 생성 input */
export type CreateShipmentInput = {
  /** 주소 */
  address: Scalars['String'];
  /** 상세 주소 */
  detailAddress: Scalars['String'];
  /** 기본 배송지 여부 */
  isDefault: Scalars['Boolean'];
  /** 이름 */
  name: Scalars['String'];
  /** 휴대폰 번호 */
  phoneNumber: Scalars['String'];
  /** 우편 번호 */
  postCode: Scalars['String'];
  /** 배송 요청 메세지 */
  requestMessage?: Maybe<Scalars['String']>;
};

/** 팀 컨디션 기준 데이터 생성 input */
export type CreateTeamConditionThreshold = {
  /** 피로도 */
  fatigue: Scalars['Int'];
  /** 기분 */
  mood: Scalars['Int'];
  /** 근육 */
  muscle: Scalars['Int'];
  /** 수면 시간 */
  sleepDuration: Scalars['Int'];
  /** 수면 품질 */
  sleepQuality: Scalars['Int'];
  /** 스트레스 */
  stress: Scalars['Int'];
  teamId: Scalars['ID'];
};

/** 팀 gps 기준 데이터 생성 input */
export type CreateTeamGpsDataThreshold = {
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount: Scalars['Float'];
  /** 스프린트 횟수 */
  countOfSprint: Scalars['Float'];
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount: Scalars['Float'];
  teamId: Scalars['ID'];
  /** 이동거리 */
  totalDistance: Scalars['Float'];
  /** 고강도 이동 거리 */
  totalHsrDistance: Scalars['Float'];
  /** 고강도 액션 횟수 */
  totalRhieBout: Scalars['Float'];
};

/** 팀 그룹 생성 input */
export type CreateTeamGroupInput = {
  /** 순서 */
  index?: Maybe<Scalars['Int']>;
  /** 이름 */
  name: Scalars['String'];
  /** 팀ID */
  teamId: Scalars['ID'];
  /** 유저 ID 목록 */
  userIds: Array<Scalars['ID']>;
};

/** 팀 생성 input */
export type CreateTeamInput = {
  /** 이름 */
  name: Scalars['String'];
};

/** 팀 매치 이벤트 기준 데이터 생성 input */
export type CreateTeamMatchEventThreshold = {
  /** 공중볼 처리 성공률 */
  aerialActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 */
  aerialActions?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 성공 */
  aerialActionsWon?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공률 */
  aerialDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 */
  aerialDuels?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공 */
  aerialDuelsWon?: Maybe<Scalars['Float']>;
  /** 도움 */
  assists?: Maybe<Scalars['Float']>;
  /** 평균 속도 */
  averageSpeed?: Maybe<Scalars['Float']>;
  /** 백패스 성공률 */
  backPassAccuracy?: Maybe<Scalars['Float']>;
  /** 백패스 */
  backPasses?: Maybe<Scalars['Float']>;
  /** 블락된 슈팅 */
  blockedShots?: Maybe<Scalars['Float']>;
  /** 캐칭 */
  catches?: Maybe<Scalars['Float']>;
  /** 클리어 */
  clearances?: Maybe<Scalars['Float']>;
  /** 코너킥 */
  cornerKicks?: Maybe<Scalars['Float']>;
  /** 크로스 성공률 */
  crossAccuracy?: Maybe<Scalars['Float']>;
  /** 크로스 */
  crosses?: Maybe<Scalars['Float']>;
  /** 크로스 차단 */
  crossesBlocked?: Maybe<Scalars['Float']>;
  /** 돌파 시도 */
  dribbleAttempts?: Maybe<Scalars['Float']>;
  /** 돌파 성공률 */
  dribbleSuccessRate?: Maybe<Scalars['Float']>;
  /** 전진 패스 성공률 */
  forwardPassAccuracy?: Maybe<Scalars['Float']>;
  /** 전진패스 */
  forwardPasses?: Maybe<Scalars['Float']>;
  /** 파울 */
  fouls?: Maybe<Scalars['Float']>;
  /** 피파울 */
  foulsSuffered?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 */
  freeKickCrosses?: Maybe<Scalars['Float']>;
  /** 프리킥 슈팅 */
  freeKickShots?: Maybe<Scalars['Float']>;
  /** 프리킥 유효 슈팅 */
  freeKickShotsOnTarget?: Maybe<Scalars['Float']>;
  /** 프리킥 */
  freeKicks?: Maybe<Scalars['Float']>;
  /** 골킥 */
  goalKicks?: Maybe<Scalars['Float']>;
  /** 득점 */
  goals?: Maybe<Scalars['Float']>;
  /** 실점 */
  goalsConceded?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공률 */
  groundActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 */
  groundActions?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공 */
  groundActionsWon?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공률 */
  groundDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 */
  groundDuels?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공 */
  groundDuelsWon?: Maybe<Scalars['Float']>;
  /** 핸드볼 파울 */
  handballFouls?: Maybe<Scalars['Float']>;
  /** 고강도 러닝 거리 비율 */
  highIntensityRunningRatio?: Maybe<Scalars['Float']>;
  /** 인터셉트 */
  interceptions?: Maybe<Scalars['Float']>;
  /** 키패스 */
  keyPasses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공률 */
  lateralPassAccuracy?: Maybe<Scalars['Float']>;
  /** 횡패스 */
  lateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리 패스 성공률 */
  longPassAccuracy?: Maybe<Scalars['Float']>;
  /** 장거리 패스 */
  longPasses?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공률 */
  looseBallDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 */
  looseBallDuels?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공 */
  looseBallDuelsWon?: Maybe<Scalars['Float']>;
  /** 중거리 패스 성공률 */
  mediumPassAccuracy?: Maybe<Scalars['Float']>;
  /** 중거리 패스 */
  mediumPasses?: Maybe<Scalars['Float']>;
  /** 볼미스 */
  miscontrols?: Maybe<Scalars['Float']>;
  /** 오프사이드 */
  offsides?: Maybe<Scalars['Float']>;
  /** 자책골 */
  ownGoals?: Maybe<Scalars['Float']>;
  /** 패스성공률 */
  passAccuracy?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 성공률 */
  passAccuracyInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비지역 패스 성공률 */
  passAccuracyInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공률 */
  passAccuracyInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 */
  passes?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 */
  passesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 */
  passesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 */
  passesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 받음 */
  passesReceived?: Maybe<Scalars['Float']>;
  /** 페널티킥 허용 */
  penaltiesConceded?: Maybe<Scalars['Float']>;
  /** 페널티킥 획득 */
  penaltiesWon?: Maybe<Scalars['Float']>;
  /** 페널티킥 */
  penaltyKicks?: Maybe<Scalars['Float']>;
  /** 페널티킥 세이브 */
  penaltySaves?: Maybe<Scalars['Float']>;
  /** 공 점유율 */
  possession?: Maybe<Scalars['Float']>;
  /** 펀칭 */
  punches?: Maybe<Scalars['Float']>;
  /** 획득 */
  recoveries?: Maybe<Scalars['Float']>;
  /** 퇴장 */
  redCards?: Maybe<Scalars['Float']>;
  /** 세이브 */
  saves?: Maybe<Scalars['Float']>;
  /** 세트피스 득점 */
  setPieceGoals?: Maybe<Scalars['Float']>;
  /** 세트피스 득점 허용 */
  setPieceGoalsConceded?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 */
  setPieceShots?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 허용 */
  setPieceShotsConceded?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공률 */
  shortPassAccuracy?: Maybe<Scalars['Float']>;
  /** 단거리 패스 */
  shortPasses?: Maybe<Scalars['Float']>;
  /** 유효슈팅률 */
  shotAccuracy?: Maybe<Scalars['Float']>;
  /** 슈팅 차단 */
  shotsBlocked?: Maybe<Scalars['Float']>;
  /** 박스 안 슈팅 */
  shotsInsideBox?: Maybe<Scalars['Float']>;
  /** 벗어난 슈팅 */
  shotsOffTarget?: Maybe<Scalars['Float']>;
  /** 유효슈팅 */
  shotsOnTarget?: Maybe<Scalars['Float']>;
  /** 박스 밖 슈팅 */
  shotsOutsideBox?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  sprintCount?: Maybe<Scalars['Float']>;
  /** 스프린트 총 거리 */
  sprintDistance?: Maybe<Scalars['Float']>;
  /** 스텝인 */
  stepIns?: Maybe<Scalars['Float']>;
  /** 백패스 성공 */
  successfulBackPasses?: Maybe<Scalars['Float']>;
  /** 크로스 성공 */
  successfulCrosses?: Maybe<Scalars['Float']>;
  /** 돌파 성공 */
  successfulDribbles?: Maybe<Scalars['Float']>;
  /** 전진패스 성공 */
  successfulForwardPasses?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 성공 */
  successfulFreeKickCrosses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공 */
  successfulLateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리패스 성공 */
  successfulLongPasses?: Maybe<Scalars['Float']>;
  /** 중거리패스 성공 */
  successfulMediumPasses?: Maybe<Scalars['Float']>;
  /** 패스 성공 */
  successfulPasses?: Maybe<Scalars['Float']>;
  /** 공격 지역 패스 성공 */
  successfulPassesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 성공 */
  successfulPassesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공 */
  successfulPassesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공 */
  successfulShortPasses?: Maybe<Scalars['Float']>;
  /** 태클 시도 */
  tackleAttempts?: Maybe<Scalars['Float']>;
  /** 태클 실패 */
  tacklesLost?: Maybe<Scalars['Float']>;
  /** 태클 성공률 */
  tacklesSuccessRate?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 미획득 */
  tacklesWonNoPossession?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 획득 */
  tacklesWonPossession?: Maybe<Scalars['Float']>;
  teamId: Scalars['ID'];
  /** 스로인 파울 */
  throwInFouls?: Maybe<Scalars['Float']>;
  /** 스로인 */
  throwIns?: Maybe<Scalars['Float']>;
  /** 최고 속도 */
  topSpeed?: Maybe<Scalars['Float']>;
  /** 총 차단 */
  totalBlocks?: Maybe<Scalars['Float']>;
  /** 총 거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 전체 파울 */
  totalFouls?: Maybe<Scalars['Float']>;
  /** 전체 슈팅 */
  totalShots?: Maybe<Scalars['Float']>;
  /** 턴오버 허용 */
  turnoversConceded?: Maybe<Scalars['Float']>;
  /** 턴오버 획득 */
  turnoversWon?: Maybe<Scalars['Float']>;
  /** VHIR 횟수 */
  vhirCount?: Maybe<Scalars['Float']>;
  /** VHIR 총 거리 */
  vhirDistance?: Maybe<Scalars['Float']>;
  /** 경고 */
  yellowCards?: Maybe<Scalars['Float']>;
};

/** 팀 피지컬 기준 데이터 생성 input */
export type CreateTeamPhysicalDataV2Threshold = {
  /** 연산자 */
  operator: OptionOperator;
  /** 순서 */
  order: Scalars['Int'];
  teamId: Scalars['ID'];
  /** 피지컬 데이터 타입 */
  type: PhysicalDataV2Type;
  /** 값 */
  value: Scalars['Float'];
};

export type CreateWorkloadAndSorenessInput = {
  /** 운동시간 */
  duration: Scalars['Int'];
  /** 운동강도 */
  intensity: Scalars['Int'];
  /** 운동 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 운동만족 */
  satisfaction: Scalars['Int'];
  /** 일정ID */
  scheduleId?: Maybe<Scalars['ID']>;
  /** 통증 목록 */
  sorenessList: Array<SorenessInput>;
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 운동부하 종류 */
  type: WorkoutType;
};

/** 운동부하 생성 input */
export type CreateWorkloadInput = {
  /** 운동시간 */
  duration: Scalars['Int'];
  /** 운동강도 */
  intensity: Scalars['Int'];
  /** 운동 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 운동만족 */
  satisfaction: Scalars['Int'];
  /** 일정ID */
  scheduleId?: Maybe<Scalars['ID']>;
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 운동부하 종류 */
  type: WorkoutType;
};

/** 유의 상태선수 통증 보유 */
export type CurrentSorenessUser = {
  __typename: 'CurrentSorenessUser';
  /** 통증 목록 */
  sorenessList: Array<Soreness>;
  /** 통증 종류 */
  type: UserSorenessLabelType;
  /** 유저 정보 */
  user: SportsUser;
};

/** 오늘 데이터 현황 acwr */
export type DailyAcwrData = DailyData & {
  __typename: 'DailyAcwrData';
  /** 범위 */
  range: Array<SportsTeamDataRange>;
  /** 값 */
  value: Scalars['Float'];
  /** 전날 값과의 차이 */
  varianceFromYesterday: Scalars['Float'];
};

/** 오늘 데이터 현황 컨디션 */
export type DailyConditionData = DailyData & {
  __typename: 'DailyConditionData';
  /** 범위 */
  range: Array<SportsTeamDataRange>;
  /** 값 */
  value: Scalars['Float'];
  /** 전날 값과의 차이 */
  varianceFromYesterday: Scalars['Float'];
};

/** 오늘 데이터 현황 */
export type DailyData = {
  /** 값 */
  value: Scalars['Float'];
  /** 전날 값과의 차이 */
  varianceFromYesterday: Scalars['Float'];
};

/** 오늘 데이터 현황 준비도 */
export type DailyReadinessData = DailyData & {
  __typename: 'DailyReadinessData';
  /** 값 */
  value: Scalars['Float'];
  /** 전날 값과의 차이 */
  varianceFromYesterday: Scalars['Float'];
};

/** 오늘 데이터 */
export type DailyTeamData = {
  __typename: 'DailyTeamData';
  /** acwr */
  acwr: DailyAcwrData;
  /** 컨디션 */
  condition: DailyConditionData;
  /** 준비도 */
  readiness: DailyReadinessData;
  /** 운동부하 */
  workload: DailyWorkloadData;
};

/** 오늘 데이터 현황 운동부하 */
export type DailyWorkloadData = DailyData & {
  __typename: 'DailyWorkloadData';
  /** 범위 */
  range: Array<SportsTeamDataRange>;
  /** 값 */
  value: Scalars['Float'];
  /** 전날 값과의 차이 */
  varianceFromYesterday: Scalars['Float'];
};


/** 날짜별 가용률 */
export type DateAvailability = {
  __typename: 'DateAvailability';
  /** 가용률 */
  availabilityRate: Scalars['Float'];
  /** 날짜 */
  date: Scalars['String'];
};



/** 팀 매치 이벤트 - 수비 지표 */
export type Defense = {
  __typename: 'Defense';
  /** 공중볼 경합 성공률 */
  aerialDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 */
  aerialDuels?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공 */
  aerialDuelsWon?: Maybe<Scalars['Float']>;
  /** 클리어 */
  clearances?: Maybe<Scalars['Float']>;
  /** 크로스 차단 */
  crossesBlocked?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공률 */
  groundDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 */
  groundDuels?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공 */
  groundDuelsWon?: Maybe<Scalars['Float']>;
  /** 인터셉트 */
  interceptions?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공률 */
  looseBallDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 */
  looseBallDuels?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공 */
  looseBallDuelsWon?: Maybe<Scalars['Float']>;
  /** 볼미스 */
  miscontrols?: Maybe<Scalars['Float']>;
  /** 자책골 */
  ownGoals?: Maybe<Scalars['Float']>;
  /** 획득 */
  recoveries?: Maybe<Scalars['Float']>;
  /** 슈팅 차단 */
  shotsBlocked?: Maybe<Scalars['Float']>;
  /** 태클 시도 */
  tackleAttempts?: Maybe<Scalars['Float']>;
  /** 태클 실패 */
  tacklesLost?: Maybe<Scalars['Float']>;
  /** 태클 성공률 */
  tacklesSuccessRate?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 미획득 */
  tacklesWonNoPossession?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 획득 */
  tacklesWonPossession?: Maybe<Scalars['Float']>;
  /** 총 차단 */
  totalBlocks?: Maybe<Scalars['Float']>;
  /** 턴오버 획득 */
  turnoversWon?: Maybe<Scalars['Float']>;
};

/** 배너 삭제 input */
export type DeleteBannerInput = {
  /** 배너 ID */
  id: Scalars['ID'];
};

/** 피드백 댓글 삭제 input */
export type DeleteFeedbackCommentInput = {
  /** 댓글ID */
  commentId: Scalars['ID'];
  /** 피드백ID */
  feedbackId: Scalars['ID'];
};

/** 파일 삭제 input */
export type DeleteFileInput = {
  /** 파일ID */
  id: Scalars['ID'];
};

/** 부상 삭제 input */
export type DeleteInjuryInput = {
  /** ID */
  id: Scalars['ID'];
  /** 팀ID */
  teamId: Scalars['ID'];
};

/** 나의 할일 삭제 input */
export type DeleteInput = {
  /** 나의 할일 ID */
  routineId: Scalars['ID'];
};

/** 라이센스 삭제 input */
export type DeleteLicenseInput = {
  /** 라이센스 ID */
  licenseId: Scalars['ID'];
};

/** 운동 안함 삭제 input */
export type DeleteNoWorkoutInput = {
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
};

/** 관찰 리포트 삭제 input */
export type DeleteObservationReportInput = {
  /** 관찰 리포트 ID */
  id: Scalars['String'];
};

/** 팝업 삭제 input */
export type DeletePopupInput = {
  /** 팝업ID */
  id: Scalars['ID'];
};

/** 스카우팅 선수 코멘트 삭제 input */
export type DeleteProspectPlayerCommentInput = {
  /** 코멘트 ID */
  id: Scalars['String'];
  /** 스카우팅 선수 ID */
  prospectPlayerId: Scalars['String'];
};

/** 스카우팅 선수 삭제 input */
export type DeleteProspectPlayerListInput = {
  /** 스카우팅 선수 ID 목록 */
  idList: Array<Scalars['String']>;
  /** 팀 ID */
  teamId: Scalars['String'];
};

/** 운동부하 데이터 삭제 input */
export type DeleteSportsDataInput = {
  /** 날짜 */
  date: Scalars['DateTime'];
  /** ID */
  id: Scalars['ID'];
};

/** 유저 삭제 input */
export type DeleteSportsUserInput = {
  /** 키클록 유저 ID */
  identityId: Scalars['ID'];
  /** 유저 ID */
  userId: Scalars['ID'];
};

/** 팀그룹 삭제 input */
export type DeleteTeamGroupInput = {
  /** 팀그룹ID */
  id: Scalars['ID'];
  /** 팀ID */
  teamId: Scalars['ID'];
};

/** 할인 정보 */
export type DiscountInfo = {
  __typename: 'DiscountInfo';
  /** 쿠폰 할인 종류 */
  type?: Maybe<CouponDiscountType>;
  /** 할인 가격 */
  value?: Maybe<Scalars['Int']>;
};

/** 팀 엔터프라이즈 정보 */
export type EnterpriseTeamInfo = {
  __typename: 'EnterpriseTeamInfo';
  /** 엔터프라이즈 이용팀 전용 로고 이미지 url */
  logoImageUrl: Scalars['String'];
  /** 엔터프라이즈 이용팀 전용 로고 텍스트 */
  logoText: Scalars['String'];
};

export type Equipment = {
  __typename: 'Equipment';
  code: EquipmentCode;
  requiredCount: Scalars['Int'];
  type: EquipmentType;
};

export enum EquipmentCode {
  AB = 'AB',
  BB = 'BB',
  BC = 'BC',
  BG = 'BG',
  BS = 'BS',
  CN = 'CN',
  DB = 'DB',
  FB = 'FB',
  FM = 'FM',
  GB = 'GB',
  HD = 'HD',
  IP = 'IP',
  JB = 'JB',
  LB = 'LB',
  LM = 'LM',
  MB = 'MB',
  NE = 'NE',
  PC = 'PC',
  PT = 'PT',
  SB = 'SB',
  SC = 'SC',
  SP = 'SP',
  ST = 'ST',
  SX = 'SX',
  TB = 'TB',
  TN = 'TN'
}

/** 장비 input */
export type EquipmentInput = {
  /** 장비 코드 */
  code: EquipmentCode;
  /** 필수 수행 횟수 */
  requiredCount: Scalars['Int'];
  /** 장비 종류 */
  type: EquipmentType;
};

export enum EquipmentType {
  FOR_SETUP = 'FOR_SETUP',
  FOR_WEIGHT = 'FOR_WEIGHT'
}

/** 기구 운동 */
export type EquipmentWorkout = {
  __typename: 'EquipmentWorkout';
  /** 세션 목록 */
  sessionList?: Maybe<Array<Session>>;
};

/** 기구 운동 input */
export type EquipmentWorkoutInput = {
  /** 세션 목록 */
  sessionList: Array<TrainingSolutionSessionInput>;
};

/** 에센셜 훈련 솔루션 팝업 input */
export type EssentialTrainingSolutionPopupInput = {
  /** 에센셜 훈련 팝업 유무 */
  essentialTrainingSolutionPopup: Scalars['Boolean'];
};

export type Event = {
  /** 종료일 */
  endAt: Scalars['Date'];
  eventInvitees: Array<EventInvitee>;
  expectedIntensity?: Maybe<Scalars['Int']>;
  hideExpectedIntensityFromPlayers?: Maybe<Scalars['Boolean']>;
  /** 일정 ID */
  id: Scalars['ID'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 시작일 */
  startAt: Scalars['Date'];
  team?: Maybe<SportsTeam>;
  /** 타임존 */
  timezone: Scalars['String'];
  /** 제목 */
  title: Scalars['String'];
  /** 종류 */
  type: ScheduleType;
};

export type EventInvitee = {
  event: Event;
  hasChecked: Scalars['Boolean'];
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  status?: Maybe<EventInviteeStatus>;
  /** the player who is invited to this event */
  user?: Maybe<SportsUser>;
  workoutType?: Maybe<WorkoutType>;
};

export enum EventInviteeStatus {
  ABSENCE_ETC = 'ABSENCE_ETC',
  ABSENCE_INJURY = 'ABSENCE_INJURY',
  NOT_CHECK = 'NOT_CHECK',
  NO_PLAY = 'NO_PLAY',
  PARTICIPATION = 'PARTICIPATION',
  STARTER = 'STARTER',
  SUBSTITUTE = 'SUBSTITUTE'
}

/** 일정 테이블 */
export type Eventable = {
  /** 일정 */
  event?: Maybe<EventInvitee>;
};

/** 일정 리포트 파일 추출 input */
export type ExportReportSchedule = {
  fileType: ReportFileType;
  nationality: CountryCode;
  scheduleId: Scalars['String'];
  timezone: Scalars['String'];
};

/** 팀 데이터 파일 추출 input */
export type ExportTeamSportData = {
  from: Scalars['DateTimeString'];
  teamId: Scalars['String'];
  to: Scalars['DateTimeString'];
};

/** 외적부하 */
export type ExternalWorkloadInfo = {
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 accelerationB2_3TotalCount 최댓값 대비 해당 세션의 accelerationB2_3TotalCount 비율 */
  accelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 가속 횟수 */
  accelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 가속 횟수 */
  accelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 가속 횟수 */
  accelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 평균 심박수 */
  averageHeartRate?: Maybe<Scalars['Float']>;
  /** 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeet?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetRight?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 decelerationB2_3TotalCount 최댓값 대비 해당 세션의 decelerationB2_3TotalCount 비율 */
  decelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 감속 횟수 */
  decelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 감속 횟수 */
  decelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 감속 횟수 */
  decelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 분당 이동거리 */
  distancePerMinute?: Maybe<Scalars['Float']>;
  /** 심박 기반 세션 부하 지표 */
  heartRateExertion?: Maybe<Scalars['Float']>;
  /** 대사적으로 높은 부하가 걸리는 상황에서 이동한 거리 */
  highMetabolicLoadDistance?: Maybe<Scalars['Float']>;
  /** 분당 고속주행 거리 */
  hsrPerMinute?: Maybe<Scalars['Float']>;
  /** 고강도 가속 이벤트 수 */
  imaAccelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 가속 이벤트 수 */
  imaAccelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 가속 이벤트 수 */
  imaAccelerationMedium?: Maybe<Scalars['Float']>;
  /** 고강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftHigh?: Maybe<Scalars['Float']>;
  /** 저강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftLow?: Maybe<Scalars['Float']>;
  /** 중강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftMedium?: Maybe<Scalars['Float']>;
  /** 고강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightHigh?: Maybe<Scalars['Float']>;
  /** 저강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightLow?: Maybe<Scalars['Float']>;
  /** 중강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightMedium?: Maybe<Scalars['Float']>;
  /** 고강도 감속 이벤트 수 */
  imaDecelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 감속 이벤트 수 */
  imaDecelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 감속 이벤트 수 */
  imaDecelerationMedium?: Maybe<Scalars['Float']>;
  /** B4 구간 점프 착지 횟수 */
  imaJumpCountBand4?: Maybe<Scalars['Float']>;
  /** 고강도 점프 착지 횟수 */
  imaJumpCountHighBand?: Maybe<Scalars['Float']>;
  /** 저강도 점프 착지 횟수 */
  imaJumpCountLowBand?: Maybe<Scalars['Float']>;
  /** 중강도 점프 착지 횟수 */
  imaJumpCountMediumBand?: Maybe<Scalars['Float']>;
  /** 최대 가속도 */
  maximumAcceleration?: Maybe<Scalars['Float']>;
  /** 최대 감속도 */
  maximumDeceleration?: Maybe<Scalars['Float']>;
  /** 최대 심박수 */
  maximumHeartRate?: Maybe<Scalars['Float']>;
  /** 최고 속력 */
  maximumSpeed?: Maybe<Scalars['Float']>;
  /** 선수 개인의 maximumSpeed 최댓값 대비 해당 세션의 maximumSpeed 비율 */
  maximumSpeedPerMax?: Maybe<Scalars['Float']>;
  /** 최대 힘 발휘해내는 능력 */
  metaEnergy?: Maybe<Scalars['Float']>;
  /** 좌우 다리 간 부하의 비대칭성 */
  runningImbalance?: Maybe<Scalars['Float']>;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 총 뛴 거리 기반 ACWR */
  totalDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalDistance 최댓값 대비 해당 세션의 totalDistance 비율 */
  totalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 다이브 한 횟수 */
  totalDiveCount?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 횟수 */
  totalDiveCountCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 횟수 */
  totalDiveCountLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 횟수 */
  totalDiveCountRight?: Maybe<Scalars['Float']>;
  /** 다이브 함으로써 생긴 부하 */
  totalDiveLoad?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadRight?: Maybe<Scalars['Float']>;
  /** 운동한 시간 */
  totalDuration?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** HSR 거리 기반 ACWR */
  totalHsrDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalHsrDistance 최댓값 대비 해당 세션의 totalHsrDistance 비율 */
  totalHsrDistancePerMax?: Maybe<Scalars['Float']>;
  /** 점프한 총 횟수 */
  totalJumpCount?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  totalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이상 횟수 */
  velocityB4TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이상 횟수 */
  velocityB5TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이상 횟수 */
  velocityB6TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동거리 */
  velocityBand1TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동시간 */
  velocityBand1TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동거리 */
  velocityBand2TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동시간 */
  velocityBand2TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동거리 */
  velocityBand3TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동시간 */
  velocityBand3TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동거리 */
  velocityBand4TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동시간 */
  velocityBand4TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동거리 */
  velocityBand5TotalDistance?: Maybe<Scalars['Float']>;
  /** 선수 개인의 velocityBand5TotalDistance 최댓값 대비 해당 세션의 velocityBand5TotalDistance 비율 */
  velocityBand5TotalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동시간 */
  velocityBand5TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동거리 */
  velocityBand6TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동시간 */
  velocityBand6TotalDuration?: Maybe<Scalars['Float']>;
};

/** 실패 파일 정보 */
export type FailedFile = {
  __typename: 'FailedFile';
  /** 파일명 */
  fileName: Scalars['String'];
  /** 실패 이유 */
  reason: Scalars['String'];
};

/** 피드백 */
export type Feedback = {
  __typename: 'Feedback';
  /** 피드백 댓글 목록 */
  commentList: Array<FeedbackComment>;
  /** 콘텐츠 데이터 */
  contentsData?: Maybe<FeedbackContentsData>;
  /** 작성 유저 정보 */
  createUser: SportsUser;
  /** 생성일 */
  createdAt: Scalars['Date'];
  /** 날짜 */
  date: Scalars['String'];
  /** 피드백ID */
  id: Scalars['ID'];
  /** 삭제 여부 */
  isDeleted: Scalars['Boolean'];
  /** 수정 여부 */
  isUpdated: Scalars['Boolean'];
  /** 메시지 */
  message: Scalars['String'];
  /** 선수 정보 */
  player: SportsUser;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 팀ID */
  teamId: Scalars['ID'];
  /** 피드백 종류 */
  type: FeedbackType;
};

/** 피드백 알림 */
export type FeedbackAlarm = Alarm & {
  __typename: 'FeedbackAlarm';
  /** 댓글 ID */
  commentId?: Maybe<Scalars['ID']>;
  /** 알람 생성 유저 정보 */
  createUser: SportsUser;
  /** 생성일 */
  createdAt: Scalars['DateTime'];
  /** 피드백 정보 */
  feedback: Feedback;
  /** 알림 ID */
  id: Scalars['ID'];
  /** 알림 읽음 여부 */
  isChecked: Scalars['Boolean'];
  /** 학부모 정보 */
  parent?: Maybe<SportsUser>;
  /** 플랜 정보 */
  plan?: Maybe<PlanV2Alarm>;
  /** 선수 정보 */
  player?: Maybe<SportsUser>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 알림 종류 */
  type: AlarmType;
};


/** 피드백 알림 */
export type FeedbackAlarmPlanArgs = {
  input: MultilingualTextInput;
};

/** 피드백 댓글 */
export type FeedbackComment = {
  __typename: 'FeedbackComment';
  /** 댓글 */
  comment: Scalars['String'];
  /** 작성일시 */
  createdAt: Scalars['Date'];
  /** 댓글 ID */
  id: Scalars['ID'];
  /** 수정 여부 */
  isUpdated: Scalars['Boolean'];
  /** 유저 정보 */
  user: SportsUser;
};

/** 피드백 컨디선 난조 데이터 */
export type FeedbackConditionNotGoodData = {
  __typename: 'FeedbackConditionNotGoodData';
  /** 컨디션 종류 데이터 목록 */
  dataList: Array<UserConditionDataType>;
  /** 피로도 */
  fatigue: Scalars['Int'];
  /** 기분 */
  mood: Scalars['Int'];
  /** 근육 */
  muscle: Scalars['Int'];
  /** 수면기간 */
  sleepDuration: Scalars['Int'];
  /** 수면점수 */
  sleepDurationScore: Scalars['Int'];
  /** 수면 품질 */
  sleepQuality: Scalars['Int'];
  /** 스트레스 */
  stress: Scalars['Int'];
  /** 피드백 제안 ID */
  suggestionId?: Maybe<Scalars['String']>;
};

/** 피드백 컨디션 좋지 않음 input */
export type FeedbackConditionNotGoodInput = {
  /** 컨디션 데이터 종류 */
  dataList: Array<UserConditionDataType>;
  /** 피로도 */
  fatigue: Scalars['Int'];
  /** 기분 */
  mood: Scalars['Int'];
  /** 근육 */
  muscle: Scalars['Int'];
  /** 수면기간 */
  sleepDuration: Scalars['Int'];
  /** 수면 기간 점수 */
  sleepDurationScore: Scalars['Int'];
  /** 수면 품질 */
  sleepQuality: Scalars['Int'];
  /** 스트레스 */
  stress: Scalars['Int'];
  /** 피드백 제안 ID */
  suggestionId: Scalars['String'];
};

/** 피드백 컨디션 급락 */
export type FeedbackConditionPlummetData = {
  __typename: 'FeedbackConditionPlummetData';
  /** 피드백 컨디션 종류 목록 */
  dataList: Array<UserConditionDataType>;
  /** 28일 피로도 목록 */
  fatigue28dayList: Array<Scalars['Int']>;
  /** 28일 기분 목록 */
  mood28dayList: Array<Scalars['Int']>;
  /** 28일 근육 목록 */
  muscle28dayList: Array<Scalars['Int']>;
  /** 28일 수면 기간 목록 */
  sleepDuration28dayList: Array<Scalars['Int']>;
  /** 28일 수면 품질 목록 */
  sleepQuality28dayList: Array<Scalars['Int']>;
  /** 28일 스트레스 목록 */
  stress28dayList: Array<Scalars['Int']>;
  /** 피드백 제안 ID */
  suggestionId?: Maybe<Scalars['String']>;
};

/** 피드백 컨디션 급락 input */
export type FeedbackConditionPlummetInput = {
  /** 컨디션 데이터 */
  dataList: Array<UserConditionDataType>;
  /** 피로도 28일 목록 */
  fatigue28dayList: Array<Scalars['Int']>;
  /** 기분 28일 목록 */
  mood28dayList: Array<Scalars['Int']>;
  /** 근육 28일 목록 */
  muscle28dayList: Array<Scalars['Int']>;
  /** 수면 기간 28일 목록 */
  sleepDuration28dayList: Array<Scalars['Int']>;
  /** 수면 품질 28일 목록 */
  sleepQuality28dayList: Array<Scalars['Int']>;
  /** 스트레스 28일 목록 */
  stress28dayList: Array<Scalars['Int']>;
  /** 피드백 제안 ID */
  suggestionId: Scalars['String'];
};

/** 피드백 목록 */
export type FeedbackConnection = {
  __typename: 'FeedbackConnection';
  edges: Array<FeedbackEdge>;
  pageInfo: PageInfo;
};

export type FeedbackContentsData = FeedbackConditionNotGoodData | FeedbackConditionPlummetData | FeedbackSorenessSevereData | FeedbackWorkloadMemoData | FeedbackWorkloadRiskAtInjuryData;

export type FeedbackEdge = {
  __typename: 'FeedbackEdge';
  cursor: Scalars['String'];
  node: Feedback;
};

/** 피드백 페이징 input */
export type FeedbackPageInput = {
  /** 뒤쪽 데이터를 가져오고 싶을 때 사용하는 기준 위치 값 (커서) */
  after?: Maybe<Scalars['String']>;
  /** 앞쪽 데이터를 가져오고 싶을 때 사용하는 기준 위치 값 (커서) */
  before?: Maybe<Scalars['String']>;
  /** 앞쪽 데이터  개수 */
  first?: Maybe<Scalars['Float']>;
  /** 뒤쪽 데이터 개수 */
  last?: Maybe<Scalars['Float']>;
  /** 타입 목록 */
  typeList?: Maybe<Array<FeedbackType>>;
  /** 유저ID 목록 */
  userIdList: Array<Scalars['String']>;
};

/** 피드백 통증 데이터 */
export type FeedbackSorenessSevereData = {
  __typename: 'FeedbackSorenessSevereData';
  /** 부위 */
  bodyPart: SportsBodyPart;
  isContact?: Maybe<Contact>;
  /** 단계 */
  level: Scalars['Int'];
  /** 메모 */
  memo: Scalars['String'];
  /** 피드백 제안 ID */
  suggestionId?: Maybe<Scalars['String']>;
};


/** 피드백 통증 데이터 */
export type FeedbackSorenessSevereDataBodyPartArgs = {
  input: MultilingualTextInput;
};

/** 피드백 통증  input */
export type FeedbackSorenessSevereInput = {
  /** 부위 */
  bodyPart: SportsBodyPartName;
  isContact?: Maybe<Contact>;
  /** 단계 */
  level: Scalars['Int'];
  /** 메모 */
  memo: Scalars['String'];
  /** 피드백 제안ID */
  suggestionId: Scalars['String'];
};

/** 피드백 제안 */
export type FeedbackSuggestion = {
  __typename: 'FeedbackSuggestion';
  /** 코치 이름 */
  coachName?: Maybe<Scalars['String']>;
  /** 콘텐츠 데이터 */
  contentsData?: Maybe<FeedbackContentsData>;
  /** 날짜 */
  date: Scalars['String'];
  /** 피드백 종류 */
  type: FeedbackType;
};

export enum FeedbackType {
  CONDITION_NOT_GOOD = 'CONDITION_NOT_GOOD',
  CONDITION_PLUMMET = 'CONDITION_PLUMMET',
  NORMAL = 'NORMAL',
  REQUEST = 'REQUEST',
  SORENESS_SEVERE = 'SORENESS_SEVERE',
  WORKLOAD_MEMO = 'WORKLOAD_MEMO',
  WORKLOAD_RISK_AT_INJURY = 'WORKLOAD_RISK_AT_INJURY'
}

/** 피드백 운동부하 메모 데이터 */
export type FeedbackWorkloadMemoData = {
  __typename: 'FeedbackWorkloadMemoData';
  /** 운동시간 */
  duration: Scalars['Int'];
  /** 운동강도 */
  intensity?: Maybe<Scalars['Int']>;
  /** 운동부하 */
  load?: Maybe<Scalars['Int']>;
  /** 메모 */
  memo: Scalars['String'];
  /** 운동만족 */
  satisfaction?: Maybe<Scalars['Int']>;
  /** 피드백 운동부하 일정 데이터 */
  scheduleData?: Maybe<FeedbackWorkloadScheduleData>;
  /** 피드백 제안 ID */
  suggestionId?: Maybe<Scalars['String']>;
  /** 시간 */
  time: Scalars['DateTimeString'];
  /** 타임존 */
  timezone: Scalars['String'];
};

/** 피드백 운동부하 메모 input */
export type FeedbackWorkloadMemoInput = {
  /** 운동시간 */
  duration: Scalars['Int'];
  /** 운동강도 */
  intensity: Scalars['Int'];
  /** 운동부하 */
  load: Scalars['Int'];
  /** 메모 */
  memo: Scalars['String'];
  /** 운동만족 */
  satisfaction: Scalars['Int'];
  /** 피드백 운동 부하 일정 */
  scheduleData?: Maybe<FeedbackWorkloadScheduleInput>;
  /** 피드백 제안 ID */
  suggestionId: Scalars['String'];
  /** 시간 */
  time: Scalars['DateTimeString'];
  /** 타임존 */
  timezone: Scalars['String'];
};

/** 피드백 운동부하 부상 위험 */
export type FeedbackWorkloadRiskAtInjuryData = {
  __typename: 'FeedbackWorkloadRiskAtInjuryData';
  /** 부상 위험 분석 */
  analysisType: UserWorkloadSuggestionDataType;
  /** 부상 위험 종류 */
  label: UserWorkloadRiskAtInjuryLabelType;
  /** 부상위험 이유 목록 */
  reasonList: Array<UserWorkloadRiskAtInjuryReasonType>;
  /** 피드백 제안 ID */
  suggestionId?: Maybe<Scalars['String']>;
};

/** 피드백 운동부하 부상 위험 input */
export type FeedbackWorkloadRiskAtInjuryInput = {
  /** 분석 제안 */
  analysisType: UserWorkloadSuggestionDataType;
  /** 유형 */
  label: UserWorkloadRiskAtInjuryLabelType;
  reasonList: Array<UserWorkloadRiskAtInjuryReasonType>;
  /** 피드백 제안 ID */
  suggestionId: Scalars['String'];
};

/** 피드백 운동부하 일정 데이터 */
export type FeedbackWorkloadScheduleData = {
  __typename: 'FeedbackWorkloadScheduleData';
  /** 일정 상세 종류 */
  detailType: ScheduleDetailType;
  /** 종료 시간 */
  endTime?: Maybe<Scalars['String']>;
  /** 지역 */
  location?: Maybe<Scalars['String']>;
  /** 일정 일자 */
  scheduleDate: Scalars['String'];
  /** 시작 시간 */
  startTime?: Maybe<Scalars['String']>;
  /** 피드백 제안 ID */
  suggestionId: Scalars['String'];
  /** 제목 */
  title?: Maybe<Scalars['String']>;
  /** 일정 종류 */
  type: ScheduleType;
};

/** 피드백 운동 부하 일정 input */
export type FeedbackWorkloadScheduleInput = {
  /** 일정 상세 종류 */
  detailType: ScheduleDetailType;
  /** 종료 시간 */
  endTime?: Maybe<Scalars['String']>;
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 일정 일자 */
  scheduleDate: Scalars['String'];
  /** 시작 시간 */
  startTime?: Maybe<Scalars['String']>;
  /** 제목 */
  title?: Maybe<Scalars['String']>;
  /** 일정 종류 */
  type: ScheduleType;
};

/** 파일 정보 */
export type FileEntity = {
  __typename: 'FileEntity';
  /** 사이즈 */
  byteSize: Scalars['Float'];
  /** content type */
  contentType: Scalars['String'];
  /** 생성일 */
  createdAt: Scalars['Date'];
  /** 파일ID */
  id: Scalars['ID'];
  /** 파일명 */
  name: Scalars['String'];
  /** 공개 여부 */
  private: Scalars['Boolean'];
  /** 태그 목록 */
  tags: Scalars['JSON'];
  /** 수정일 */
  updatedAt: Scalars['Date'];
  /** url */
  url: Scalars['String'];
};

/** 팀 매치 이벤트 - 파울 지표 */
export type Foul = {
  __typename: 'Foul';
  /** 파울 */
  fouls?: Maybe<Scalars['Float']>;
  /** 피파울 */
  foulsSuffered?: Maybe<Scalars['Float']>;
  /** 핸드볼 파울 */
  handballFouls?: Maybe<Scalars['Float']>;
  /** 오프사이드 */
  offsides?: Maybe<Scalars['Float']>;
  /** 페널티킥 허용 */
  penaltiesConceded?: Maybe<Scalars['Float']>;
  /** 페널티킥 획득 */
  penaltiesWon?: Maybe<Scalars['Float']>;
  /** 퇴장 */
  redCards?: Maybe<Scalars['Float']>;
  /** 스로인 파울 */
  throwInFouls?: Maybe<Scalars['Float']>;
  /** 전체 파울 */
  totalFouls?: Maybe<Scalars['Float']>;
  /** 경고 */
  yellowCards?: Maybe<Scalars['Float']>;
};

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  OTHER = 'OTHER'
}

export enum GenderType {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  OTHER = 'OTHER'
}

/** 코치 일정 조회 input */
export type GetCoachScheduleInput = {
  /** 시작일 */
  from: Scalars['String'];
  /** 종료일 */
  to: Scalars['String'];
};

/** 쿠폰 할인 가격 input */
export type GetCouponAppliedPriceInput = {
  /** 쿠폰ID */
  couponId?: Maybe<Scalars['String']>;
  /** 할인 전 가격 */
  originalPrice: Scalars['Int'];
};

/** 팀 쿠폰 발행 input */
export type GiveCouponToTeamsInput = {
  /** 팀 ID 목록 */
  teamIdList: Array<Scalars['ID']>;
};

/** 유저 쿠폰 발행 input */
export type GiveCouponToUserListInput = {
  /** 유저 ID 목록 */
  userIdList: Array<Scalars['ID']>;
};

/** 팀 매치 이벤트 - 골키퍼 지표 */
export type Goalkeeper = {
  __typename: 'Goalkeeper';
  /** 공중볼 처리 성공률 */
  aerialActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 */
  aerialActions?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 성공 */
  aerialActionsWon?: Maybe<Scalars['Float']>;
  /** 캐칭 */
  catches?: Maybe<Scalars['Float']>;
  /** 실점 */
  goalsConceded?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공률 */
  groundActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 */
  groundActions?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공 */
  groundActionsWon?: Maybe<Scalars['Float']>;
  /** 페널티킥 세이브 */
  penaltySaves?: Maybe<Scalars['Float']>;
  /** 펀칭 */
  punches?: Maybe<Scalars['Float']>;
  /** 세이브 */
  saves?: Maybe<Scalars['Float']>;
};

/** gps 데이터 */
export type GpsDataInfo = {
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
};

export enum GpsDataName {
  ACCELERATION_BAND1_TOTAL_COUNT = 'ACCELERATION_BAND1_TOTAL_COUNT',
  ACCELERATION_BAND2_TOTAL_COUNT = 'ACCELERATION_BAND2_TOTAL_COUNT',
  ACCELERATION_BAND3_TOTAL_COUNT = 'ACCELERATION_BAND3_TOTAL_COUNT',
  AVERAGE_HEART_RATE = 'AVERAGE_HEART_RATE',
  AVERAGE_TIME_TO_FEET = 'AVERAGE_TIME_TO_FEET',
  AVERAGE_TIME_TO_FEET_CENTRE = 'AVERAGE_TIME_TO_FEET_CENTRE',
  AVERAGE_TIME_TO_FEET_LEFT = 'AVERAGE_TIME_TO_FEET_LEFT',
  AVERAGE_TIME_TO_FEET_RIGHT = 'AVERAGE_TIME_TO_FEET_RIGHT',
  COUNT_OF_SPRINT = 'COUNT_OF_SPRINT',
  DATE = 'DATE',
  DECELERATION_BAND1_TOTAL_COUNT = 'DECELERATION_BAND1_TOTAL_COUNT',
  DECELERATION_BAND2_TOTAL_COUNT = 'DECELERATION_BAND2_TOTAL_COUNT',
  DECELERATION_BAND3_TOTAL_COUNT = 'DECELERATION_BAND3_TOTAL_COUNT',
  DISTANCE_PER_MINUTE = 'DISTANCE_PER_MINUTE',
  DRILL_NAME = 'DRILL_NAME',
  HEART_RATE_EXERTION = 'HEART_RATE_EXERTION',
  HIGH_METABOLIC_LOAD_DISTANCE = 'HIGH_METABOLIC_LOAD_DISTANCE',
  HSR_PER_MINUTE = 'HSR_PER_MINUTE',
  IMA_ACCELERATION_HIGH = 'IMA_ACCELERATION_HIGH',
  IMA_ACCELERATION_LOW = 'IMA_ACCELERATION_LOW',
  IMA_ACCELERATION_MEDIUM = 'IMA_ACCELERATION_MEDIUM',
  IMA_COD_LEFT_HIGH = 'IMA_COD_LEFT_HIGH',
  IMA_COD_LEFT_LOW = 'IMA_COD_LEFT_LOW',
  IMA_COD_LEFT_MEDIUM = 'IMA_COD_LEFT_MEDIUM',
  IMA_COD_RIGHT_HIGH = 'IMA_COD_RIGHT_HIGH',
  IMA_COD_RIGHT_LOW = 'IMA_COD_RIGHT_LOW',
  IMA_COD_RIGHT_MEDIUM = 'IMA_COD_RIGHT_MEDIUM',
  IMA_DECELERATION_HIGH = 'IMA_DECELERATION_HIGH',
  IMA_DECELERATION_LOW = 'IMA_DECELERATION_LOW',
  IMA_DECELERATION_MEDIUM = 'IMA_DECELERATION_MEDIUM',
  IMA_JUMP_COUNT_BAND4 = 'IMA_JUMP_COUNT_BAND4',
  IMA_JUMP_COUNT_HIGH_BAND = 'IMA_JUMP_COUNT_HIGH_BAND',
  IMA_JUMP_COUNT_LOW_BAND = 'IMA_JUMP_COUNT_LOW_BAND',
  IMA_JUMP_COUNT_MEDIUM_BAND = 'IMA_JUMP_COUNT_MEDIUM_BAND',
  MAXIMUM_ACCELERATION = 'MAXIMUM_ACCELERATION',
  MAXIMUM_DECELERATION = 'MAXIMUM_DECELERATION',
  MAXIMUM_HEART_RATE = 'MAXIMUM_HEART_RATE',
  MAXIMUM_SPEED = 'MAXIMUM_SPEED',
  META_ENERGY = 'META_ENERGY',
  PARTICIPATION = 'PARTICIPATION',
  PLAYER_NAME = 'PLAYER_NAME',
  POSITION = 'POSITION',
  RUNNING_IMBALANCE = 'RUNNING_IMBALANCE',
  TIME = 'TIME',
  TOTAL_DISTANCE = 'TOTAL_DISTANCE',
  TOTAL_DISTANCE_ACWR = 'TOTAL_DISTANCE_ACWR',
  TOTAL_DIVE_COUNT = 'TOTAL_DIVE_COUNT',
  TOTAL_DIVE_COUNT_CENTRE = 'TOTAL_DIVE_COUNT_CENTRE',
  TOTAL_DIVE_COUNT_LEFT = 'TOTAL_DIVE_COUNT_LEFT',
  TOTAL_DIVE_COUNT_RIGHT = 'TOTAL_DIVE_COUNT_RIGHT',
  TOTAL_DIVE_LOAD = 'TOTAL_DIVE_LOAD',
  TOTAL_DIVE_LOAD_CENTRE = 'TOTAL_DIVE_LOAD_CENTRE',
  TOTAL_DIVE_LOAD_LEFT = 'TOTAL_DIVE_LOAD_LEFT',
  TOTAL_DIVE_LOAD_RIGHT = 'TOTAL_DIVE_LOAD_RIGHT',
  TOTAL_DURATION = 'TOTAL_DURATION',
  TOTAL_HSR_DISTANCE = 'TOTAL_HSR_DISTANCE',
  TOTAL_HSR_DISTANCE_ACWR = 'TOTAL_HSR_DISTANCE_ACWR',
  TOTAL_JUMP_COUNT = 'TOTAL_JUMP_COUNT',
  TOTAL_PLAYER_LOAD = 'TOTAL_PLAYER_LOAD',
  TOTAL_RHIE_BOUT = 'TOTAL_RHIE_BOUT',
  TRAINING_NAME = 'TRAINING_NAME',
  VELOCITY_B4_TOTAL_COUNT = 'VELOCITY_B4_TOTAL_COUNT',
  VELOCITY_B5_TOTAL_COUNT = 'VELOCITY_B5_TOTAL_COUNT',
  VELOCITY_B6_TOTAL_COUNT = 'VELOCITY_B6_TOTAL_COUNT',
  VELOCITY_BAND1_TOTAL_DISTANCE = 'VELOCITY_BAND1_TOTAL_DISTANCE',
  VELOCITY_BAND1_TOTAL_DURATION = 'VELOCITY_BAND1_TOTAL_DURATION',
  VELOCITY_BAND2_TOTAL_DISTANCE = 'VELOCITY_BAND2_TOTAL_DISTANCE',
  VELOCITY_BAND2_TOTAL_DURATION = 'VELOCITY_BAND2_TOTAL_DURATION',
  VELOCITY_BAND3_TOTAL_DISTANCE = 'VELOCITY_BAND3_TOTAL_DISTANCE',
  VELOCITY_BAND3_TOTAL_DURATION = 'VELOCITY_BAND3_TOTAL_DURATION',
  VELOCITY_BAND4_TOTAL_DISTANCE = 'VELOCITY_BAND4_TOTAL_DISTANCE',
  VELOCITY_BAND4_TOTAL_DURATION = 'VELOCITY_BAND4_TOTAL_DURATION',
  VELOCITY_BAND5_TOTAL_DISTANCE = 'VELOCITY_BAND5_TOTAL_DISTANCE',
  VELOCITY_BAND5_TOTAL_DURATION = 'VELOCITY_BAND5_TOTAL_DURATION',
  VELOCITY_BAND6_TOTAL_DISTANCE = 'VELOCITY_BAND6_TOTAL_DISTANCE',
  VELOCITY_BAND6_TOTAL_DURATION = 'VELOCITY_BAND6_TOTAL_DURATION'
}

/** gps 드릴 데이터 input */
export type GpsDrillData = {
  /** 속도 1구간 가속 횟수 */
  accelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 가속 횟수 */
  accelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 가속 횟수 */
  accelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 평균 심박수 */
  averageHeartRate?: Maybe<Scalars['Float']>;
  /** 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeet?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetRight?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** 속도 1구간 감속 횟수 */
  decelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 감속 횟수 */
  decelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 감속 횟수 */
  decelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 분당 이동거리 */
  distancePerMinute?: Maybe<Scalars['Float']>;
  /** 심박 기반 세션 부하 지표 */
  heartRateExertion?: Maybe<Scalars['Float']>;
  /** 대사적으로 높은 부하가 걸리는 상황에서 이동한 거리 */
  highMetabolicLoadDistance?: Maybe<Scalars['Float']>;
  /** 분당 고속주행 거리 */
  hsrPerMinute?: Maybe<Scalars['Float']>;
  /** 고강도 가속 이벤트 수 */
  imaAccelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 가속 이벤트 수 */
  imaAccelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 가속 이벤트 수 */
  imaAccelerationMedium?: Maybe<Scalars['Float']>;
  /** 고강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftHigh?: Maybe<Scalars['Float']>;
  /** 저강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftLow?: Maybe<Scalars['Float']>;
  /** 중강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftMedium?: Maybe<Scalars['Float']>;
  /** 고강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightHigh?: Maybe<Scalars['Float']>;
  /** 저강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightLow?: Maybe<Scalars['Float']>;
  /** 중강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightMedium?: Maybe<Scalars['Float']>;
  /** 고강도 감속 이벤트 수 */
  imaDecelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 감속 이벤트 수 */
  imaDecelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 감속 이벤트 수 */
  imaDecelerationMedium?: Maybe<Scalars['Float']>;
  /** B4 구간 점프 착지 횟수 */
  imaJumpCountBand4?: Maybe<Scalars['Float']>;
  /** 고강도 점프 착지 횟수 */
  imaJumpCountHighBand?: Maybe<Scalars['Float']>;
  /** 저강도 점프 착지 횟수 */
  imaJumpCountLowBand?: Maybe<Scalars['Float']>;
  /** 중강도 점프 착지 횟수 */
  imaJumpCountMediumBand?: Maybe<Scalars['Float']>;
  /** 최대 가속도 */
  maximumAcceleration?: Maybe<Scalars['Float']>;
  /** 최대 감속도 */
  maximumDeceleration?: Maybe<Scalars['Float']>;
  /** 최대 심박수 */
  maximumHeartRate?: Maybe<Scalars['Float']>;
  /** 최고 속력 */
  maximumSpeed?: Maybe<Scalars['Float']>;
  /** 최대 힘 발휘해내는 능력 */
  metaEnergy?: Maybe<Scalars['Float']>;
  /** 드릴 이름 */
  name?: Maybe<Scalars['String']>;
  /** 참여 형태 */
  participation?: Maybe<Scalars['String']>;
  /** 포지션 */
  position?: Maybe<Scalars['String']>;
  /** 좌우 다리 간 부하의 비대칭성 */
  runningImbalance?: Maybe<Scalars['Float']>;
  /** 오전/오후 */
  time?: Maybe<Scalars['String']>;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 총 뛴 거리 기반 ACWR */
  totalDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 다이브 한 횟수 */
  totalDiveCount?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 횟수 */
  totalDiveCountCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 횟수 */
  totalDiveCountLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 횟수 */
  totalDiveCountRight?: Maybe<Scalars['Float']>;
  /** 다이브 함으로써 생긴 부하 */
  totalDiveLoad?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadRight?: Maybe<Scalars['Float']>;
  /** 운동한 시간 */
  totalDuration?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** HSR 거리 기반 ACWR */
  totalHsrDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 점프한 총 횟수 */
  totalJumpCount?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  totalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이상 횟수 */
  velocityB4TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이상 횟수 */
  velocityB5TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이상 횟수 */
  velocityB6TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동거리 */
  velocityBand1TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동시간 */
  velocityBand1TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동거리 */
  velocityBand2TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동시간 */
  velocityBand2TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동거리 */
  velocityBand3TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동시간 */
  velocityBand3TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동거리 */
  velocityBand4TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동시간 */
  velocityBand4TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동거리 */
  velocityBand5TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동시간 */
  velocityBand5TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동거리 */
  velocityBand6TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동시간 */
  velocityBand6TotalDuration?: Maybe<Scalars['Float']>;
};

/** gps 세션 데이터 input */
export type GpsSessionData = {
  /** 속도 1구간 가속 횟수 */
  accelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 가속 횟수 */
  accelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 가속 횟수 */
  accelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 평균 심박수 */
  averageHeartRate?: Maybe<Scalars['Float']>;
  /** 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeet?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetRight?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** 속도 1구간 감속 횟수 */
  decelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 감속 횟수 */
  decelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 감속 횟수 */
  decelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 분당 이동거리 */
  distancePerMinute?: Maybe<Scalars['Float']>;
  /** gps 세션 데이터 목록 */
  drillList?: Maybe<Array<GpsDrillData>>;
  /** 심박 기반 세션 부하 지표 */
  heartRateExertion?: Maybe<Scalars['Float']>;
  /** 대사적으로 높은 부하가 걸리는 상황에서 이동한 거리 */
  highMetabolicLoadDistance?: Maybe<Scalars['Float']>;
  /** 분당 고속주행 거리 */
  hsrPerMinute?: Maybe<Scalars['Float']>;
  /** 고강도 가속 이벤트 수 */
  imaAccelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 가속 이벤트 수 */
  imaAccelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 가속 이벤트 수 */
  imaAccelerationMedium?: Maybe<Scalars['Float']>;
  /** 고강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftHigh?: Maybe<Scalars['Float']>;
  /** 저강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftLow?: Maybe<Scalars['Float']>;
  /** 중강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftMedium?: Maybe<Scalars['Float']>;
  /** 고강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightHigh?: Maybe<Scalars['Float']>;
  /** 저강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightLow?: Maybe<Scalars['Float']>;
  /** 중강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightMedium?: Maybe<Scalars['Float']>;
  /** 고강도 감속 이벤트 수 */
  imaDecelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 감속 이벤트 수 */
  imaDecelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 감속 이벤트 수 */
  imaDecelerationMedium?: Maybe<Scalars['Float']>;
  /** B4 구간 점프 착지 횟수 */
  imaJumpCountBand4?: Maybe<Scalars['Float']>;
  /** 고강도 점프 착지 횟수 */
  imaJumpCountHighBand?: Maybe<Scalars['Float']>;
  /** 저강도 점프 착지 횟수 */
  imaJumpCountLowBand?: Maybe<Scalars['Float']>;
  /** 중강도 점프 착지 횟수 */
  imaJumpCountMediumBand?: Maybe<Scalars['Float']>;
  /** 최대 가속도 */
  maximumAcceleration?: Maybe<Scalars['Float']>;
  /** 최대 감속도 */
  maximumDeceleration?: Maybe<Scalars['Float']>;
  /** 최대 심박수 */
  maximumHeartRate?: Maybe<Scalars['Float']>;
  /** 최고 속력 */
  maximumSpeed?: Maybe<Scalars['Float']>;
  /** 최대 힘 발휘해내는 능력 */
  metaEnergy?: Maybe<Scalars['Float']>;
  /** 세션 이름 */
  name?: Maybe<Scalars['String']>;
  /** 참여 형태 */
  participation?: Maybe<Scalars['String']>;
  /** 포지션 */
  position?: Maybe<Scalars['String']>;
  /** 좌우 다리 간 부하의 비대칭성 */
  runningImbalance?: Maybe<Scalars['Float']>;
  /** 일정ID */
  scheduleId: Scalars['ID'];
  /** 오후/오전 */
  time?: Maybe<Scalars['String']>;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 총 뛴 거리 기반 ACWR */
  totalDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 다이브 한 횟수 */
  totalDiveCount?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 횟수 */
  totalDiveCountCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 횟수 */
  totalDiveCountLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 횟수 */
  totalDiveCountRight?: Maybe<Scalars['Float']>;
  /** 다이브 함으로써 생긴 부하 */
  totalDiveLoad?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadRight?: Maybe<Scalars['Float']>;
  /** 운동한 시간 */
  totalDuration?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** HSR 거리 기반 ACWR */
  totalHsrDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 점프한 총 횟수 */
  totalJumpCount?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  totalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이상 횟수 */
  velocityB4TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이상 횟수 */
  velocityB5TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이상 횟수 */
  velocityB6TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동거리 */
  velocityBand1TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동시간 */
  velocityBand1TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동거리 */
  velocityBand2TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동시간 */
  velocityBand2TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동거리 */
  velocityBand3TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동시간 */
  velocityBand3TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동거리 */
  velocityBand4TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동시간 */
  velocityBand4TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동거리 */
  velocityBand5TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동시간 */
  velocityBand5TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동거리 */
  velocityBand6TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동시간 */
  velocityBand6TotalDuration?: Maybe<Scalars['Float']>;
};

/** gps 유저 데이터 input */
export type GpsUserData = {
  /** 날짜 */
  date: Scalars['String'];
  /** 선수 이름 */
  playerName: Scalars['String'];
  /** gps 세션 데이터 목록 */
  sessionList: Array<GpsSessionData>;
  /** 유저ID */
  userId: Scalars['ID'];
};

/** 팝업 그룹핑 목록 */
export type GroupingPopup = {
  __typename: 'GroupingPopup';
  /** 오늘하루보지않기 표시 목록 */
  todayHiddenOffList?: Maybe<Array<Popup>>;
  /** 오늘하루보지않기 숨김 목록 */
  todayHiddenOnList?: Maybe<Array<Popup>>;
};

export type GuideReopenStatus = {
  __typename: 'GuideReopenStatus';
  alarm: GuideReopenStatusUnit;
  readiness: GuideReopenStatusUnit;
};

export type GuideReopenStatusUnit = {
  __typename: 'GuideReopenStatusUnit';
  app: ReopenStatus;
  web: ReopenStatus;
};

/** 햄스트링 */
export type Hamstring = {
  __typename: 'Hamstring';
  /** 근력 수치 */
  strengthList: Array<HamstringStrength>;
  /** 근력 불균형 */
  unbalanceList: Array<HamstringUnbalance>;
};

/** 햄스트링 근력수치 */
export type HamstringStrength = {
  __typename: 'HamstringStrength';
  /** 등척성 수축 */
  isoProneAvg?: Maybe<Scalars['Float']>;
  /** 신장성 수축 */
  nordicAvg?: Maybe<Scalars['Float']>;
  /** 유저 이름 */
  userName?: Maybe<Scalars['String']>;
};

/** 햄스트링 근력 불균형 */
export type HamstringUnbalance = {
  __typename: 'HamstringUnbalance';
  /** 등척성 수축 */
  isoProneRatio?: Maybe<Scalars['Float']>;
  /** 신장성 수축 */
  nordicRatio?: Maybe<Scalars['Float']>;
  /** 유저이름 */
  userName?: Maybe<Scalars['String']>;
};

export enum HeightUnit {
  cm = 'cm',
  ft = 'ft',
  in = 'in'
}

/** 고관절 */
export type HipJoint = {
  __typename: 'HipJoint';
  strengthList: Array<HipJointStrength>;
  unbalanceList: Array<HipJointUnBalance>;
};

/** 고관절 근력 수치 */
export type HipJointStrength = {
  __typename: 'HipJointStrength';
  /** 굽힘근 평균 */
  flexionKickerAvg?: Maybe<Scalars['Float']>;
  /** 벌림근 평균 */
  hipAbductionAvg?: Maybe<Scalars['Float']>;
  /** 모음근 평균 */
  hipAdductionAvg?: Maybe<Scalars['Float']>;
  /** 유저 이름 */
  userName?: Maybe<Scalars['String']>;
};

/** 고관절 근력 불균형 */
export type HipJointUnBalance = {
  __typename: 'HipJointUnBalance';
  /** 굽힘근 비율 */
  flexionKickerRatio?: Maybe<Scalars['Float']>;
  /** 벌림근 비율 */
  hipAbductionRatio?: Maybe<Scalars['Float']>;
  /** 모음근 비율 */
  hipAdductionRatio?: Maybe<Scalars['Float']>;
  /** 좌측 벌림근 대비 모음근 */
  hipAdductionToAbductionLeft?: Maybe<Scalars['Float']>;
  /** 우측 벌림근 대비 모음근 */
  hipAdductionToAbductionRight?: Maybe<Scalars['Float']>;
  /** 유저 이름 */
  userName?: Maybe<Scalars['String']>;
};

/** 부상 정보 */
export type Injury = {
  __typename: 'Injury';
  /** 부위 */
  bodyPart?: Maybe<SportsBodyPart>;
  /** 진단 */
  diagnosis?: Maybe<Scalars['String']>;
  /** 부상 파일 목록 */
  fileList: Array<InjuryFile>;
  /** 부상 기록 상태 */
  historyStatus: InjuryHistoryStatus;
  /** 부상ID */
  id: Scalars['ID'];
  /** 접촉 여부 */
  isContact?: Maybe<InjuryContact>;
  /** 의료 기록 */
  medicalRecord?: Maybe<Scalars['String']>;
  /** 발생일 */
  occurDate: Scalars['String'];
  /** 이유 */
  reason?: Maybe<Scalars['String']>;
  /** 복귀 */
  return: Return;
  /** 일정ID */
  schedule?: Maybe<Schedule>;
  /** 일정ID */
  scheduleId?: Maybe<Scalars['String']>;
  /** 부상 상태 */
  status: InjuryStatus;
  /** 직접 입력 내용 */
  symptomEnterDirectly?: Maybe<Scalars['String']>;
  /** 증상 타입 목록 */
  symptomList?: Maybe<Array<SymptomType>>;
  /** 유저 정보 */
  user: SportsUser;
};


/** 부상 정보 */
export type InjuryBodyPartArgs = {
  input: MultilingualTextInput;
};

export enum InjuryContact {
  CONTACT = 'CONTACT',
  NON_CONTACT = 'NON_CONTACT'
}

/** 부상 파일 */
export type InjuryFile = {
  __typename: 'InjuryFile';
  /** 부상ID */
  id: Scalars['ID'];
  /** 이름 */
  name: Scalars['String'];
  /** url */
  url: Scalars['String'];
};

/** 부상 이력 */
export type InjuryHistory = {
  __typename: 'InjuryHistory';
  /** 부상 종료 날짜 */
  endDate?: Maybe<Scalars['String']>;
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 부상 기간 */
  period?: Maybe<Scalars['String']>;
  /** 부상 시작 날짜 */
  startDate: Scalars['String'];
};

/** 부상 이력 input */
export type InjuryHistoryInput = {
  /** 부상 종료 날짜 */
  endDate?: Maybe<Scalars['String']>;
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 부상 기간 */
  period?: Maybe<Scalars['String']>;
  /** 부상 시작 날짜 */
  startDate: Scalars['String'];
};

export enum InjuryHistoryStatus {
  FIRST = 'FIRST',
  RELAPSE = 'RELAPSE'
}

export enum InjuryReturnStatus {
  DECIDED = 'DECIDED',
  UNDECIDED = 'UNDECIDED'
}

/** 부상 위험 */
export type InjuryRisk = {
  __typename: 'InjuryRisk';
  /** 햄스트링 근력 미달 선수 */
  hamstringStrength: TeamHamstringStrength;
  /** 햄스트링 불균형 선수 */
  hamstringUnbalance: TeamHamstringUnbalance;
  /** 벌림근 대비 모음근 불균형 선수 */
  hipAdductionToAbduction: TeamHipAdductionToAbduction;
  /** 고관절 근력 미달 선수 */
  hipJointStrength: TeamHipJointStrength;
  /** 고관절 불균형 선수 */
  hipJointUnbalance: TeamHipJointUnBalance;
};

export enum InjuryStatus {
  END = 'END',
  IN_PROGRESS = 'IN_PROGRESS'
}

/** 부상유저 */
export type InjuryUser = {
  __typename: 'InjuryUser';
  /** 부상 목록 */
  injuryList: Array<Injury>;
  /** 유저 정보 */
  user: SportsUser;
};

/** 부상 유저 목록 */
export type InjuryUserList = {
  __typename: 'InjuryUserList';
  /** 전체수 */
  total: Scalars['Float'];
  /** 부상 유저 수 */
  userList: Array<InjuryUser>;
};

/** 운동강도 유저 */
export type IntensityUser = {
  __typename: 'IntensityUser';
  /** 운동 강도 */
  intensity: Scalars['Float'];
  /** 유저 정보 */
  user: SportsUser;
};

/** 내적부하 상세 */
export type InternalWorkloadDetail = {
  __typename: 'InternalWorkloadDetail';
  /** 시간 */
  duration: Scalars['Float'];
  /** 내적부하 ID */
  id: Scalars['String'];
  /** 강도 */
  intensity: Scalars['Float'];
  /** 피드백 생성 여부 */
  isFeedbackCreated: Scalars['Boolean'];
  /** 다른 팀 운동 유무 */
  isOtherTeamWorkload: Scalars['Boolean'];
  /** 부하 */
  load: Scalars['Float'];
  /** 운동메모 */
  memo: Scalars['String'];
  /** 만족도 */
  satisfaction: Scalars['Float'];
  /** 운동 시작 시간 */
  time: Scalars['String'];
  /** 종류 */
  workloadType: WorkloadType;
};

/** 내적부하 */
export type InternalWorkloadInfo = {
  /** 부상 위험도 */
  acwr: Scalars['Float'];
  /** 급성 부하 */
  aw: Scalars['Float'];
  /** 단조로움 */
  awd: Scalars['Float'];
  /** 만성 부하 */
  cw: Scalars['Float'];
  /** 내적 부하 */
  internalWorkload?: Maybe<Scalars['Float']>;
  /** 훈련 부담 */
  strain: Scalars['Float'];
};

/** 초대 요청 input */
export type InvitationRequest = {
  /** 팀 요청 ID */
  id: Scalars['ID'];
  /** 팀 권한 */
  teamAuthority: SportsTeamAuthority;
  /** 유저 ID */
  userId: Scalars['ID'];
};

export type Invoice = {
  /** 결제 유저 이메일 */
  billingUserEmail: Scalars['String'];
  /** 결제 유저 이름 */
  billingUserName: Scalars['String'];
  /** 결제 유저 전화번호 */
  billingUserPhone: Scalars['String'];
  /** 카드명 */
  cardName: Scalars['String'];
  /** 카드번호 */
  cardNumber: Scalars['String'];
  /** 결제ID */
  id: Scalars['ID'];
  /** 결제명 */
  paymentName: Scalars['String'];
  /** 결제 상태 */
  paymentStatus: PaymentStatus;
  /** 영수증 url */
  receiptUrl?: Maybe<Scalars['String']>;
};

/** 인보이스 목록 */
export type InvoiceList = {
  __typename: 'InvoiceList';
  /** 다음 데이터 유무 */
  hasNext: Scalars['Boolean'];
  /** 이전 데이터 유무 */
  hasPrev: Scalars['Boolean'];
  /** 인보이스 목록 */
  invoiceList?: Maybe<Array<Maybe<Invoice>>>;
  /** 데이터 개수 */
  limit: Scalars['Float'];
  /** 오프셋 */
  offset: Scalars['Float'];
  /** 전체 개수 */
  total: Scalars['Float'];
};


export enum Language {
  EN = 'EN',
  JA = 'JA',
  KO = 'KO',
  VN = 'VN'
}

/** 라이센스 */
export type License = {
  __typename: 'License';
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 종료일 */
  endAt: Scalars['String'];
  /** ID */
  id: Scalars['ID'];
  /** 활성 여부 */
  isActivate: Scalars['Boolean'];
  /** 라이센스명 */
  licenseName: Scalars['String'];
  /** 라이센스 팀 목록 */
  licensedTeamList: Array<SportsTeam>;
  /** 메모 */
  memo: Scalars['String'];
  /** 옵저버 목록 */
  observerList: Array<SportsUser>;
  /** 시작일 */
  startAt: Scalars['String'];
  /** 팀 ID 목록 */
  teamIdList: Array<Scalars['String']>;
  /** 소속팀 최대 갯수 */
  teamVolume: Scalars['Float'];
  /** 수정일 */
  updatedAt: Scalars['String'];
};

/** 페이징 라이센스 목록 */
export type LicenseListByPage = {
  __typename: 'LicenseListByPage';
  /** 다음 데이터 여부 */
  hasNext: Scalars['Boolean'];
  /** 이전 데이터 여부 */
  hasPrev: Scalars['Boolean'];
  /** 라이센스 목록 */
  licenseList?: Maybe<Array<License>>;
  /** 개수 */
  limit: Scalars['Float'];
  /** offset */
  offset: Scalars['Float'];
  /** 전체 개수 */
  total: Scalars['Float'];
};

/** 일정 출전자 정보 */
export type LineupInviteeSchedule = {
  /** 출전 경기 메모 */
  comment?: Maybe<Scalars['String']>;
  /** 일정초대자 ID */
  id: Scalars['ID'];
  /** 포지션 */
  lineupPosition?: Maybe<SportsPosition>;
  /** 일정 경기 초대 상태 */
  matchStatus: MatchInviteeStatus;
  /** 출전시간 */
  playTime?: Maybe<Scalars['String']>;
};

export type MakeDoNotReopenAlarmGuideStatusInput = {
  platform: Platform;
  userId: Scalars['ID'];
};

export type MakeDoNotReopenReadinessGuideStatusInput = {
  platform: Platform;
  untilToday: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type Match = Event & {
  __typename: 'Match';
  attendeeChartData: AttendeeChartData;
  competition: Scalars['String'];
  /** 종료일 */
  endAt: Scalars['Date'];
  eventInvitees: Array<MatchInvitee>;
  expectedIntensity?: Maybe<Scalars['Int']>;
  hideExpectedIntensityFromPlayers?: Maybe<Scalars['Boolean']>;
  /** 일정 ID */
  id: Scalars['ID'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  opponent: Scalars['String'];
  result: MatchResult;
  /** 시작일 */
  startAt: Scalars['Date'];
  team?: Maybe<SportsTeam>;
  /** 타임존 */
  timezone: Scalars['String'];
  /** 제목 */
  title: Scalars['String'];
  /** 종류 */
  type: ScheduleType;
  venue: Venue;
  workloadCheckedUserCount: Scalars['Float'];
};


export type MatchAttendeeChartDataArgs = {
  dataType?: Maybe<AttendeeChartDataType>;
};

/** 지표 별 매치 이벤트 */
export type MatchEvent = {
  /** 공격 지표 */
  attack: Attack;
  /** 볼 배급 지표 */
  ballDistribution: BallDistribution;
  /** 수비 지표 */
  defense: Defense;
  /** 파울 지표 */
  foul: Foul;
  /** 골키퍼 지표 */
  goalkeeper: Goalkeeper;
  /** 피지컬 지표 */
  physical: Physical;
  /** 세트피스 지표 */
  setPiece: SetPiece;
};

/** 매치 이벤트 정보 */
export type MatchEventInfo = {
  /** 공중볼 처리 성공률 */
  aerialActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 */
  aerialActions?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 성공 */
  aerialActionsWon?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공률 */
  aerialDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 */
  aerialDuels?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공 */
  aerialDuelsWon?: Maybe<Scalars['Float']>;
  /** 도움 */
  assists?: Maybe<Scalars['Float']>;
  /** 평균 속도 */
  averageSpeed?: Maybe<Scalars['Float']>;
  /** 백패스 성공률 */
  backPassAccuracy?: Maybe<Scalars['Float']>;
  /** 백패스 */
  backPasses?: Maybe<Scalars['Float']>;
  /** 블락된 슈팅 */
  blockedShots?: Maybe<Scalars['Float']>;
  /** 캐칭 */
  catches?: Maybe<Scalars['Float']>;
  /** 클리어 */
  clearances?: Maybe<Scalars['Float']>;
  /** 코너킥 */
  cornerKicks?: Maybe<Scalars['Float']>;
  /** 크로스 성공률 */
  crossAccuracy?: Maybe<Scalars['Float']>;
  /** 크로스 */
  crosses?: Maybe<Scalars['Float']>;
  /** 크로스 차단 */
  crossesBlocked?: Maybe<Scalars['Float']>;
  /** 돌파 시도 */
  dribbleAttempts?: Maybe<Scalars['Float']>;
  /** 돌파 성공률 */
  dribbleSuccessRate?: Maybe<Scalars['Float']>;
  /** 전진 패스 성공률 */
  forwardPassAccuracy?: Maybe<Scalars['Float']>;
  /** 전진패스 */
  forwardPasses?: Maybe<Scalars['Float']>;
  /** 파울 */
  fouls?: Maybe<Scalars['Float']>;
  /** 피파울 */
  foulsSuffered?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 */
  freeKickCrosses?: Maybe<Scalars['Float']>;
  /** 프리킥 슈팅 */
  freeKickShots?: Maybe<Scalars['Float']>;
  /** 프리킥 유효 슈팅 */
  freeKickShotsOnTarget?: Maybe<Scalars['Float']>;
  /** 프리킥 */
  freeKicks?: Maybe<Scalars['Float']>;
  /** 골킥 */
  goalKicks?: Maybe<Scalars['Float']>;
  /** 득점 */
  goals?: Maybe<Scalars['Float']>;
  /** 실점 */
  goalsConceded?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공률 */
  groundActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 */
  groundActions?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공 */
  groundActionsWon?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공률 */
  groundDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 */
  groundDuels?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공 */
  groundDuelsWon?: Maybe<Scalars['Float']>;
  /** 핸드볼 파울 */
  handballFouls?: Maybe<Scalars['Float']>;
  /** 고강도 러닝 거리 비율 */
  highIntensityRunningRatio?: Maybe<Scalars['Float']>;
  /** 인터셉트 */
  interceptions?: Maybe<Scalars['Float']>;
  /** 키패스 */
  keyPasses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공률 */
  lateralPassAccuracy?: Maybe<Scalars['Float']>;
  /** 횡패스 */
  lateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리 패스 성공률 */
  longPassAccuracy?: Maybe<Scalars['Float']>;
  /** 장거리 패스 */
  longPasses?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공률 */
  looseBallDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 */
  looseBallDuels?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공 */
  looseBallDuelsWon?: Maybe<Scalars['Float']>;
  /** 중거리 패스 성공률 */
  mediumPassAccuracy?: Maybe<Scalars['Float']>;
  /** 중거리 패스 */
  mediumPasses?: Maybe<Scalars['Float']>;
  /** 볼미스 */
  miscontrols?: Maybe<Scalars['Float']>;
  /** 오프사이드 */
  offsides?: Maybe<Scalars['Float']>;
  /** 자책골 */
  ownGoals?: Maybe<Scalars['Float']>;
  /** 패스성공률 */
  passAccuracy?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 성공률 */
  passAccuracyInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비지역 패스 성공률 */
  passAccuracyInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공률 */
  passAccuracyInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 */
  passes?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 */
  passesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 */
  passesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 */
  passesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 받음 */
  passesReceived?: Maybe<Scalars['Float']>;
  /** 페널티킥 허용 */
  penaltiesConceded?: Maybe<Scalars['Float']>;
  /** 페널티킥 획득 */
  penaltiesWon?: Maybe<Scalars['Float']>;
  /** 페널티킥 */
  penaltyKicks?: Maybe<Scalars['Float']>;
  /** 페널티킥 세이브 */
  penaltySaves?: Maybe<Scalars['Float']>;
  /** 팀 점유율 */
  possession?: Maybe<Scalars['Float']>;
  /** 펀칭 */
  punches?: Maybe<Scalars['Float']>;
  /** 획득 */
  recoveries?: Maybe<Scalars['Float']>;
  /** 퇴장 */
  redCards?: Maybe<Scalars['Float']>;
  /** 세이브 */
  saves?: Maybe<Scalars['Float']>;
  /** 세트피스 득점 */
  setPieceGoals?: Maybe<Scalars['Float']>;
  /** 세트피스 득점 허용 */
  setPieceGoalsConceded?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 */
  setPieceShots?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 허용 */
  setPieceShotsConceded?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공률 */
  shortPassAccuracy?: Maybe<Scalars['Float']>;
  /** 단거리 패스 */
  shortPasses?: Maybe<Scalars['Float']>;
  /** 유효슈팅률 */
  shotAccuracy?: Maybe<Scalars['Float']>;
  /** 슈팅 차단 */
  shotsBlocked?: Maybe<Scalars['Float']>;
  /** 박스 안 슈팅 */
  shotsInsideBox?: Maybe<Scalars['Float']>;
  /** 벗어난 슈팅 */
  shotsOffTarget?: Maybe<Scalars['Float']>;
  /** 유효슈팅 */
  shotsOnTarget?: Maybe<Scalars['Float']>;
  /** 박스 밖 슈팅 */
  shotsOutsideBox?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  sprintCount?: Maybe<Scalars['Float']>;
  /** 스프린트 총 거리 */
  sprintDistance?: Maybe<Scalars['Float']>;
  /** 스텝인 */
  stepIns?: Maybe<Scalars['Float']>;
  /** 백패스 성공 */
  successfulBackPasses?: Maybe<Scalars['Float']>;
  /** 크로스 성공 */
  successfulCrosses?: Maybe<Scalars['Float']>;
  /** 돌파 성공 */
  successfulDribbles?: Maybe<Scalars['Float']>;
  /** 전진패스 성공 */
  successfulForwardPasses?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 성공 */
  successfulFreeKickCrosses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공 */
  successfulLateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리패스 성공 */
  successfulLongPasses?: Maybe<Scalars['Float']>;
  /** 중거리패스 성공 */
  successfulMediumPasses?: Maybe<Scalars['Float']>;
  /** 패스 성공 */
  successfulPasses?: Maybe<Scalars['Float']>;
  /** 공격 지역 패스 성공 */
  successfulPassesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 성공 */
  successfulPassesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공 */
  successfulPassesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공 */
  successfulShortPasses?: Maybe<Scalars['Float']>;
  /** 태클 시도 */
  tackleAttempts?: Maybe<Scalars['Float']>;
  /** 태클 실패 */
  tacklesLost?: Maybe<Scalars['Float']>;
  /** 태클 성공률 */
  tacklesSuccessRate?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 미획득 */
  tacklesWonNoPossession?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 획득 */
  tacklesWonPossession?: Maybe<Scalars['Float']>;
  /** 스로인 파울 */
  throwInFouls?: Maybe<Scalars['Float']>;
  /** 스로인 */
  throwIns?: Maybe<Scalars['Float']>;
  /** 최고 속도 */
  topSpeed?: Maybe<Scalars['Float']>;
  /** 총 차단 */
  totalBlocks?: Maybe<Scalars['Float']>;
  /** 총 거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 전체 파울 */
  totalFouls?: Maybe<Scalars['Float']>;
  /** 전체 슈팅 */
  totalShots?: Maybe<Scalars['Float']>;
  /** 턴오버 허용 */
  turnoversConceded?: Maybe<Scalars['Float']>;
  /** 턴오버 획득 */
  turnoversWon?: Maybe<Scalars['Float']>;
  /** VHIR 횟수 */
  vhirCount?: Maybe<Scalars['Float']>;
  /** VHIR 총 거리 */
  vhirDistance?: Maybe<Scalars['Float']>;
  /** 경고 */
  yellowCards?: Maybe<Scalars['Float']>;
};

export type MatchInvitee = EventInvitee & {
  __typename: 'MatchInvitee';
  comment?: Maybe<Scalars['String']>;
  event: Event;
  hasChecked: Scalars['Boolean'];
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  lineupPosition?: Maybe<Scalars['String']>;
  playTime?: Maybe<Scalars['String']>;
  status?: Maybe<EventInviteeStatus>;
  /** the player who is invited to this event */
  user?: Maybe<SportsUser>;
  workoutType?: Maybe<WorkoutType>;
};

export enum MatchInviteeStatus {
  NO_PLAY = 'NO_PLAY',
  STARTER = 'STARTER',
  SUBSTITUTE = 'SUBSTITUTE'
}

/** 일정 경기 리포트 솔루션 */
export type MatchReportSolution = {
  __typename: 'MatchReportSolution';
  /** 경기 운동부하 팀 솔루션 */
  matchWorkloadTeamSolution: MatchWorkloadTeamSolution;
  /** 솔루션 유저 목록 */
  solutionUserList: Array<MatchReportSolutionUser>;
};

/** 경기 리포트 솔루션 유저 */
export type MatchReportSolutionUser = {
  __typename: 'MatchReportSolutionUser';
  /** 유저 정보 */
  user: SportsUser;
  /** 경기 운동부하 솔루션  */
  workloadSolution: MatchWorkloadSolution;
};

export type MatchResult = {
  __typename: 'MatchResult';
  memo?: Maybe<Scalars['String']>;
  opponentScore?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  status?: Maybe<MatchResultStatus>;
};

/** 코디네이팅 리포트 경기 결과 */
export type MatchResultForCoordinatingReport = {
  __typename: 'MatchResultForCoordinatingReport';
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 상대팀 점수 */
  opponentScore?: Maybe<Scalars['Float']>;
  /** 점수 */
  score?: Maybe<Scalars['Float']>;
};

/** 일정 경기 결과 정보 */
export type MatchResultSchedule = {
  __typename: 'MatchResultSchedule';
  /** 상대팀 점수 */
  opponentScore?: Maybe<Scalars['Float']>;
  /** 점수 */
  score?: Maybe<Scalars['Float']>;
};

export enum MatchResultStatus {
  DRAW = 'DRAW',
  LOSE = 'LOSE',
  WIN = 'WIN'
}

/** 브리핑 리포트 - 경기 운동 부하 */
export type MatchSchedule = Schedule & {
  __typename: 'MatchSchedule';
  /** 참가 선수 차트 데이터 기록 */
  attendeeChartData: AttendeeChartDataSchedule;
  /** 브리핑 리포트 - 경기 스케쥴 데이터 */
  briefingReport?: Maybe<BriefingReportMatchScheduleData>;
  /** 대회명 */
  competition?: Maybe<Scalars['String']>;
  /** 상세 종류 */
  detailType: ScheduleDetailType;
  /** 종료시간 */
  endTime?: Maybe<Scalars['Time']>;
  /** 목표 강도 */
  expectedIntensity?: Maybe<Scalars['Int']>;
  /** 목표 운동 부하 */
  expectedWorkload?: Maybe<Scalars['Int']>;
  /** 첨부 파일 목록 */
  fileList?: Maybe<Array<ScheduleFile>>;
  /** 일정ID */
  id: Scalars['ID'];
  /** 삭제 여부 */
  isDeleted: Scalars['Boolean'];
  /** 선수 공지 유무 */
  isPlayerNotice: Scalars['Boolean'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 경기 포인트 */
  matchPoint?: Maybe<Scalars['String']>;
  /** 공지 */
  notice?: Maybe<Scalars['String']>;
  /** 일정 참석자 목록 */
  participatedScheduleInviteeList: Array<MatchScheduleInvitee>;
  /** 경기 결과 */
  result: MatchResultSchedule;
  /** 일정 일자 */
  scheduleDate: Scalars['String'];
  /** 일정 초대자 목록 */
  scheduleInviteeList: Array<MatchScheduleInvitee>;
  /** 시작시간 */
  startTime?: Maybe<Scalars['Time']>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 제목 */
  title?: Maybe<Scalars['String']>;
  /** 훈련 포인트 */
  trainingPoint?: Maybe<Scalars['String']>;
  /** 종류 */
  type: ScheduleType;
  /** 경기 장소 */
  venue?: Maybe<Venue>;
  /** 운동부하 체크 유저 수 */
  workloadCheckedUserCount: Scalars['Float'];
};


/** 브리핑 리포트 - 경기 운동 부하 */
export type MatchScheduleAttendeeChartDataArgs = {
  dataType?: Maybe<AttendeeChartDataType>;
};

/** 코디네이팅 리포트 일정 경기 */
export type MatchScheduleForCoordinatingReport = {
  __typename: 'MatchScheduleForCoordinatingReport';
  /** 일정 상세 종류 */
  detailType: ScheduleDetailType;
  /** 종료시간 */
  endTime?: Maybe<Scalars['Time']>;
  /** 목표 운동강도  */
  expectedIntensity?: Maybe<Scalars['Int']>;
  /** 일정ID */
  id: Scalars['ID'];
  /** 선수 공지 유무 */
  isPlayerNotice: Scalars['Boolean'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 공지사항 */
  notice?: Maybe<Scalars['String']>;
  /** 경기 결과 */
  result: MatchResultForCoordinatingReport;
  /** 일정 일자 */
  scheduleDate: Scalars['String'];
  /** 일정 초대자 목록 */
  scheduleInviteeList: Array<MatchScheduleInvitee>;
  /** 시작시간 */
  startTime?: Maybe<Scalars['Time']>;
  /** 제목 */
  title?: Maybe<Scalars['String']>;
  /** 일정 종류 */
  type: ScheduleType;
  /** 경기 지역 */
  venue?: Maybe<Venue>;
};

/** 경기 참여자 정보 */
export type MatchScheduleInvitee = ScheduleInvitee & {
  __typename: 'MatchScheduleInvitee';
  /** 불참사유 */
  absenceReason?: Maybe<Scalars['String']>;
  /** 선수 기록 및 평가 */
  comment?: Maybe<Scalars['String']>;
  /** 참여 체크 여부 */
  hasChecked: Scalars['Boolean'];
  /** 일정 초대자 ID */
  id: Scalars['ID'];
  /** 포지션 */
  lineupPosition?: Maybe<Scalars['String']>;
  /** 경기 출전 상태 */
  matchStatus?: Maybe<MatchInviteeStatus>;
  /** 출전 시간 */
  playTime?: Maybe<Scalars['String']>;
  /** 일정 정보 */
  schedule?: Maybe<Schedule>;
  /** 일정 초대자 상태 */
  status?: Maybe<ScheduleInviteeStatus>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** the player who is invited to this schedule */
  user?: Maybe<SportsUser>;
  /** 운동부하 종류 */
  workoutType: WorkoutType;
};


/** 경기 참여자 정보 */
export type MatchScheduleInviteeScheduleArgs = {
  teamId?: Maybe<Scalars['ID']>;
};

/** 경기 운동부하 솔루션  */
export type MatchWorkloadSolution = {
  __typename: 'MatchWorkloadSolution';
  /** 가이드 */
  guide: Scalars['String'];
  /** 경기 운동부하 솔루션 종류 */
  type: MatchWorkloadSolutionGuideType;
};

export enum MatchWorkloadSolutionGuideType {
  MD1 = 'MD1',
  MD2 = 'MD2',
  MD3 = 'MD3',
  ME1 = 'ME1',
  ME2 = 'ME2',
  ME3 = 'ME3'
}

/** 경기 운동부하 팀 솔루션 */
export type MatchWorkloadTeamSolution = {
  __typename: 'MatchWorkloadTeamSolution';
  /** 가이드 */
  guide: Scalars['String'];
  /** 경기 운동부하 팀 솔루션 가이트 종류 */
  type: MatchWorkloadTeamSolutionGuideType;
};

export enum MatchWorkloadTeamSolutionGuideType {
  MA = 'MA',
  MB1 = 'MB1',
  MB2 = 'MB2',
  MB3 = 'MB3',
  MBD1 = 'MBD1',
  MBD2 = 'MBD2',
  MBD3 = 'MBD3',
  MBL1 = 'MBL1',
  MBL2 = 'MBL2',
  MBL3 = 'MBL3',
  MBW1 = 'MBW1',
  MBW2 = 'MBW2',
  MBW3 = 'MBW3',
  MC1 = 'MC1',
  MC2 = 'MC2',
  MC3 = 'MC3',
  MCD1 = 'MCD1',
  MCD2 = 'MCD2',
  MCD3 = 'MCD3',
  MCL1 = 'MCL1',
  MCL2 = 'MCL2',
  MCL3 = 'MCL3',
  MCW1 = 'MCW1',
  MCW2 = 'MCW2',
  MCW3 = 'MCW3'
}

/** 관찰 리포트 심리 평가 */
export type Mental = {
  __typename: 'Mental';
  /** 대담성 */
  boldness?: Maybe<Scalars['Float']>;
  /** 평정심 */
  composure?: Maybe<Scalars['Float']>;
  /** 집중력 */
  focus?: Maybe<Scalars['Float']>;
  /** 정직함 */
  honesty?: Maybe<Scalars['Float']>;
  /** 리더십 */
  leadership?: Maybe<Scalars['Float']>;
  /** 인내심 */
  patience?: Maybe<Scalars['Float']>;
  /** 적극성 */
  proactivity?: Maybe<Scalars['Float']>;
  /** 책임감 */
  responsibility?: Maybe<Scalars['Float']>;
  /** 팀워크 */
  teamwork?: Maybe<Scalars['Float']>;
  /** 강인함 */
  toughness?: Maybe<Scalars['Float']>;
  /** 훈련 태도 */
  trainingAttitude?: Maybe<Scalars['Float']>;
  /** 승부욕 */
  willToWin?: Maybe<Scalars['Float']>;
};

export enum MentalMetricType {
  BOLDNESS = 'BOLDNESS',
  COMPOSURE = 'COMPOSURE',
  FOCUS = 'FOCUS',
  HONESTY = 'HONESTY',
  LEADERSHIP = 'LEADERSHIP',
  PATIENCE = 'PATIENCE',
  PROACTIVITY = 'PROACTIVITY',
  RESPONSIBILITY = 'RESPONSIBILITY',
  TEAMWORK = 'TEAMWORK',
  TOUGHNESS = 'TOUGHNESS',
  TRAINING_ATTITUDE = 'TRAINING_ATTITUDE',
  WILL_TO_WIN = 'WILL_TO_WIN'
}

/** 관찰 리포트 심리 평가 input */
export type MentalObservationReportInput = {
  /** 대담성 */
  boldness?: Maybe<Scalars['Int']>;
  /** 평정심 */
  composure?: Maybe<Scalars['Int']>;
  /** 집중력 */
  focus?: Maybe<Scalars['Int']>;
  /** 정직함 */
  honesty?: Maybe<Scalars['Int']>;
  /** 리더십 */
  leadership?: Maybe<Scalars['Int']>;
  /** 인내심 */
  patience?: Maybe<Scalars['Int']>;
  /** 적극성 */
  proactivity?: Maybe<Scalars['Int']>;
  /** 책임감 */
  responsibility?: Maybe<Scalars['Int']>;
  /** 팀워크 */
  teamwork?: Maybe<Scalars['Int']>;
  /** 강인함 */
  toughness?: Maybe<Scalars['Int']>;
  /** 훈련 태도 */
  trainingAttitude?: Maybe<Scalars['Int']>;
  /** 승부욕 */
  willToWin?: Maybe<Scalars['Int']>;
};

/** 스카우팅 모델 심리 기준 input */
export type MentalScoutingModelInput = {
  /** 대담성 */
  boldness?: Maybe<Scalars['Int']>;
  /** 평정심 */
  composure?: Maybe<Scalars['Int']>;
  /** 집중력 */
  focus?: Maybe<Scalars['Int']>;
  /** 정직함 */
  honesty?: Maybe<Scalars['Int']>;
  /** 리더십 */
  leadership?: Maybe<Scalars['Int']>;
  /** 인내심 */
  patience?: Maybe<Scalars['Int']>;
  /** 적극성 */
  proactivity?: Maybe<Scalars['Int']>;
  /** 책임감 */
  responsibility?: Maybe<Scalars['Int']>;
  /** 팀워크 */
  teamwork?: Maybe<Scalars['Int']>;
  /** 강인함 */
  toughness?: Maybe<Scalars['Int']>;
  /** 훈련 태도 */
  trainingAttitude?: Maybe<Scalars['Int']>;
  /** 승부욕 */
  willToWin?: Maybe<Scalars['Int']>;
};

export type MultilingualBodyPart = {
  __typename: 'MultilingualBodyPart';
  back: Scalars['Boolean'];
  front: Scalars['Boolean'];
  group: MultilingualBodyPartGroup;
  id: SportsBodyPartName;
  left: Scalars['Boolean'];
  right: Scalars['Boolean'];
  value: Scalars['String'];
};

export type MultilingualBodyPartGroup = {
  __typename: 'MultilingualBodyPartGroup';
  id: SportsBodyPartGroupName;
  value: Scalars['String'];
};

export type MultilingualCategory = {
  __typename: 'MultilingualCategory';
  coachPositionList: Array<MultilingualCoachPosition>;
  id: SportsCategory;
  playerPositionList: Array<MultilingualPlayerPosition>;
  value: Scalars['String'];
};

export type MultilingualCategoryGroup = {
  __typename: 'MultilingualCategoryGroup';
  categoryList: Array<MultilingualCategory>;
  id: SportsCategoryGroup;
  value: Scalars['String'];
};

export type MultilingualCoachPosition = {
  __typename: 'MultilingualCoachPosition';
  id: SportsPosition;
  value: Scalars['String'];
};

export type MultilingualCountry = {
  __typename: 'MultilingualCountry';
  id: CountryCode;
  value: Scalars['String'];
};

export type MultilingualPlayerPosition = {
  __typename: 'MultilingualPlayerPosition';
  id: SportsPosition;
  value: Scalars['String'];
};

export type MultilingualTextInput = {
  nationality?: Maybe<Scalars['String']>;
  osType?: Maybe<OsType>;
};

export type MultilingualTextQuery = {
  __typename: 'MultilingualTextQuery';
  bodyPartList: Array<MultilingualBodyPart>;
  categoryGroupList: Array<MultilingualCategoryGroup>;
  countryList: Array<MultilingualCountry>;
  timezoneList: Array<Timezone>;
};


export type MultilingualTextQueryBodyPartListArgs = {
  key?: Maybe<Scalars['String']>;
};


export type MultilingualTextQueryCategoryGroupListArgs = {
  key?: Maybe<Scalars['String']>;
};


export type MultilingualTextQueryCountryListArgs = {
  key?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename: 'Mutation';
  /** 팀 초대 목록 수락 */
  acceptInvitationList: Array<SportsTeamInvitationRequest>;
  addBannerLog: Scalars['Boolean'];
  /** 라이센스 옵저버 추가 */
  addLicenseObserverList: License;
  /** 라이센스 팀 추가 */
  addLicenseTeamList: License;
  /** 통증 추가 */
  appendSorenessList: SportsData;
  /** 구독 취소 */
  cancelSubscription: SubscriptionItem;
  /** 구독 v2 취소 */
  cancelSubscriptionV2: Scalars['Boolean'];
  /** 구독 빌링정보 수정 */
  changeSubscriptionBilling: Scalars['Boolean'];
  /** 구독일 변경 */
  changeSubscriptionDate: SubscriptionItem;
  /** 구독 상품 정보 변경 */
  changeSubscriptionProductCode: Scalars['Boolean'];
  /** 구독 배송지 정보 수정 */
  changeSubscriptionShipment: Scalars['Boolean'];
  /** 구독 v2 의 플랜 변경 */
  changeSubscriptionV2: Scalars['Boolean'];
  /** 디바이스 토큰 전체 삭제 */
  clearDeviceTokens: Scalars['Boolean'];
  /** 학부모/선수 연결 요청 */
  connectParentPlayer: SportsUser;
  /** 신체정보 생성 */
  createBody: SportsData;
  /** 통증 부위 이미지 생성 */
  createBodyPart: Popup;
  /** 팀 미체크 알림 발송 스케줄 생성 */
  createCheckReminderPushSchedule: Array<TeamCheckReminderSchedule>;
  /** 컨디션 생성 */
  createCondition: SportsData;
  /** 컨디션 통증 생성 */
  createConditionAndSoreness: SportsData;
  /** 쿠폰 생성 */
  createCoupon: CouponDetail;
  /** 고객키 생성 */
  createCustomerKey: BillingV2;
  /** 피드백 생성 */
  createFeedback: Feedback;
  /** 피드백 댓글 생성 */
  createFeedbackComment: Feedback;
  /** 하이퍼 유저 생성 */
  createHyperClient: Scalars['Boolean'];
  /** 부상 생성 */
  createInjury: Injury;
  /** 라이센스 생성 */
  createLicense: License;
  /** 운동안함 생성 */
  createNoWorkout: SportsData;
  /** 스카우팅 후보 선수 관찰 리포트 생성 */
  createObservationReport: ProspectPlayer;
  /** 개인 피지컬 솔루션 생성 */
  createPersonalPhysicalSolution?: Maybe<PersonalTrainingSolution>;
  /** 팝업 생성 */
  createPopup: Popup;
  /** 스카우팅 후보 선수 생성 */
  createProspectPlayer: Array<ProspectPlayer>;
  /** 스카우팅 후보 선수 코멘트 생성 */
  createProspectPlayerComment: ProspectPlayer;
  /** 나의 할일 생성 */
  createRoutine: Routine;
  /** 일정 생성 */
  createSchedule: Array<Schedule>;
  /** 일정 참석 여부 생성 */
  createScheduleAttendanceStatus: ScheduleInvitee;
  /** 스카우팅 모델 생성 */
  createScoutingModel: ScoutingModel;
  /** 배송지 생성 */
  createShipment: Shipment;
  /** 팀 생성 */
  createTeam: SportsTeam;
  /** 팀 컨디션 기준 데이터 생성 */
  createTeamConditionThreshold: Scalars['Boolean'];
  /** 팀 gps 데이터 기준 데이터 생성 */
  createTeamGpsDataThreshold: Scalars['Boolean'];
  /** 팀 그룹 생성 */
  createTeamGroup: TeamGroup;
  /** 팀 매치 이벤트 기준 데이터 생성 */
  createTeamMatchEventThreshold: Scalars['Boolean'];
  /** 팀 피지컬 데이터 기준 데이터 생성 */
  createTeamPhysicalDataV2Threshold: Scalars['Boolean'];
  /** 유저 솔루션 히스토리 생성 */
  createUserSolutionHistory: UserSolutionHistory;
  /** 운동부하 생성 */
  createWorkload: SportsData;
  /** 운동부하 통증 생성 */
  createWorkloadAndSoreness: SportsData;
  /** 유저 나의 할일 alrt 비활성화 */
  deactivateAppLocalPush: Scalars['Boolean'];
  /** 배너 삭제 */
  deleteBanner: Banner;
  /** 신체 정보 삭제 */
  deleteBody: SportsData;
  /** 카드 삭제 */
  deleteCard: Scalars['Boolean'];
  /** 팀 미체크 알림 발송 스케줄 삭제 */
  deleteCheckReminderPushSchedule: Scalars['Boolean'];
  /** 컨디션 삭제 */
  deleteCondition: SportsData;
  /** 쿠폰 삭제 */
  deleteCoupon: CouponDetail;
  /** 고객키 삭제 */
  deleteCustomerKey: Scalars['Boolean'];
  /** 피드백 삭제 */
  deleteFeedback: Scalars['Boolean'];
  /** 피드백 댓글 삭제 */
  deleteFeedbackComment: Feedback;
  /** @deprecated 기능별로 필요한 파일 삭제 기능을 개발할 계획으로 추후 삭제 예정 */
  deleteFile: Scalars['Boolean'];
  /** 부상 삭제 */
  deleteInjury: Scalars['Boolean'];
  /** 라이센스 삭제 */
  deleteLicense: License;
  /** 운동안함 삭제 */
  deleteNoWorkout: SportsData;
  /** 스카우팅 후보 선수 관찰 리포트 삭제 */
  deleteObservationReport: ProspectPlayer;
  /** 피지컬 데이터 삭제 */
  deletePhysicalData: Scalars['Boolean'];
  /** 피지컬 솔루션 삭제 */
  deletePhysicalSolution: Scalars['Boolean'];
  /** 팝업 삭제 */
  deletePopup: Scalars['Boolean'];
  /** 스카우팅 후보 선수 코멘트 수정 */
  deleteProspectPlayerComment: ProspectPlayer;
  /** 스카우팅 후보 선수 삭제 */
  deleteProspectPlayerList: Array<ProspectPlayer>;
  /** 나의 할일 삭제 */
  deleteRoutine: Routine;
  /** 일정 삭제 */
  deleteSchedule: Scalars['Boolean'];
  /** 배송지 삭제 */
  deleteShipment: Scalars['Boolean'];
  /** 팀 삭제 */
  deleteTeam: SportsTeam;
  /** 팀 그룹 삭제 */
  deleteTeamGroup: TeamGroup;
  /** 유저 삭제 */
  deleteUser: Scalars['Boolean'];
  /** 운동부하 삭제 */
  deleteWorkload: SportsData;
  /** 디바이스 토큰 삭제 */
  deregisterDeviceToken: Scalars['Boolean'];
  /** 학부모/선수 - 연결, 상태 변경 요청 */
  executeParentPlayerAction: Scalars['Boolean'];
  /** 경기 리포트 파일 추출 */
  exportMatchReportSchedule: Scalars['String'];
  /** 팀 스포츠데이터 파일 추출 */
  exportTeamSportDataService: Scalars['String'];
  /** 훈련 리포트 파일 추출 */
  exportTrainingReportSchedule: Scalars['String'];
  /** 피드백 온보딩 팝업 on/off 갱신 */
  feedbackOnboardingPopupOff: Scalars['Boolean'];
  /** 쿠폰 유저 발행 */
  giveCouponToUserList: CouponDetail;
  /** 쿠폰 팀 발행 */
  giveCoupons: CouponDetail;
  /** 피지컬 데이터 csv 임포트 */
  importPhysicalDataCsvFileList: PhysicalSolutionCsvFileList;
  /** 피지컬 솔루션 csv 임포트 */
  importPhysicalSolutionCsvFileList: PhysicalSolutionCsvFileList;
  /** 팀 방출 */
  kickoutTeamUserList: Scalars['Boolean'];
  /** 팀 나가기 */
  leaveTeam: Scalars['Boolean'];
  makeAlarmGuideDoNotReopenStatus: GuideReopenStatusUnit;
  /** 코치 알림 모두 읽음으로 표시 */
  makeCoachAlarmListChecked: Array<Alarm>;
  /** 피지컬 솔루션 리포트 열람 */
  makePhysicalSolutionReportOpened: Scalars['Boolean'];
  /** 플레이어 알림 모두 읽음으로 표시 */
  makePlayerAlarmListChecked: Array<Alarm>;
  makeReadinessGuideDoNotReopenStatus: GuideReopenStatusUnit;
  /** 학부모 - 연결 선수 최초 조회 여부 업데이트 */
  markConnectionAsRead: Scalars['Boolean'];
  /** 환불 */
  refund: RefundResponse;
  /** 구독 환불 */
  refundSubscription: SubscriptionResponse;
  /** 카드 등록 */
  registerCard: BillingV2;
  /** 디바이스 토큰 등록 */
  registerDeviceToken: Scalars['Boolean'];
  /** 팀 초대 거절 목록 */
  rejectTeamInvitationList: Array<SportsTeamInvitationRequest>;
  /** 팀 쿠폰 삭제 */
  removeCoupon: CouponDetail;
  /** 라이센스 옵저버 제거 */
  removeLicenseObserver: License;
  /** 라이센스 팀 제거 */
  removeLicenseTeam: License;
  /** 미사용 쿠폰 삭제 */
  removeUnusedCoupons: CouponDetail;
  /** 미사용 유저 쿠폰 삭제 */
  removeUnusedUserCoupon: CouponDetail;
  /** 유저 쿠폰 삭제 */
  removeUserCoupon: CouponDetail;
  /** 빌링 토큰 요청 */
  requestBillingToken: BillingToken;
  /** 팀 초대 요청 */
  requestTeamInvitation: SportsTeamInvitationRequest;
  /** 구독 재시작 */
  restartSubscription: SubscriptionResponse;
  /** 구독 재개 */
  resumeSubscription: SubscriptionItem;
  /** 구독 v2 재구독 */
  resumeSubscriptionV2: Scalars['Boolean'];
  /** 결제 재시도 */
  retryPayment: SubscriptionResponse;
  /** 매치 이벤트 (개인) 데이터 저장 */
  savePlayerMatchEventData: Scalars['Boolean'];
  /** 팀 GPS 데이터 저장 */
  saveTeamGpsData: Scalars['Boolean'];
  /** 매치 이벤트 (팀) 데이터 저장 */
  saveTeamMatchEventData: Scalars['Boolean'];
  /** 팀 피지컬 데이터 저장 */
  saveTeamPhysicalData: Scalars['Boolean'];
  /** 컨디션 체크 리마인드 푸시 */
  sendCheckConditionReminderPush: Scalars['Boolean'];
  /** 일정 초대자 리마인드 푸시 */
  sendCheckScheduleInviteeReminderPush: Scalars['Boolean'];
  /** 운동부하 체크 리마인드 푸시 */
  sendCheckWorkloadReminderPush: Scalars['Boolean'];
  /** 일정 운동부하 리마인드 푸시 */
  sendEventWorkloadReminderPush: Scalars['Boolean'];
  /** 구독 시작 */
  startSubscription: SubscriptionResponse;
  /** 구독 v2 시작 */
  startSubscriptionV2: PaymentV2;
  /** 팀 매치 이벤트 (개인) 임포트 파일 컬럼 제안 */
  suggestPlayerMatchEventDataName: Array<SuggestPlayerMatchEventDataName>;
  /** GPS 임포트 파일 컬럼 제안 */
  suggestTeamGpsDataName: Array<SuggestTeamGpsDataName>;
  /** 팀 매치 이벤트 (팀) 임포트 파일 컬럼 제안 */
  suggestTeamMatchEventDataName: Array<SuggestTeamMatchEventDataName>;
  /** 피지컬 임포트 파일 컬럼 제안 */
  suggestTeamPhysicalDataName: Array<SuggestTeamPhysicalDataName>;
  /** 대표카드 설정 */
  toggleDefaultCard: BillingV2;
  /** 나의 할일 완료 */
  toggleRoutine: RoutineToggle;
  /** 팀 유저 즐겨찾기 갱신 */
  toggleTeamUserStarStatus: StarredToggleResult;
  /** 팀 소유자 권한 변경 */
  transferTeamOwnership: TransferTeamOwnership;
  /** 앱 푸시 알림 수정 */
  updateAppPushAlarmFlag: Scalars['Boolean'];
  /** 배너 수정 */
  updateBanner: Banner;
  /** 빌링 이메일 수정 */
  updateBillingBuyerEmail: Billing;
  /** 빌링 구매자 이름 수정 */
  updateBillingBuyerName: Billing;
  /** 빌링 전화번호 수정 */
  updateBillingBuyerNumber: Billing;
  /** 빌링키 갱신 */
  updateBillingKey: Billing;
  /** 신체정보 수정 */
  updateBody: SportsData;
  /** 브리핑 리포트 열람 */
  updateBriefingViewedLog: BriefingViewedLog;
  updateCondition: SportsData;
  /** 컨디션 수정 */
  updateConditionAndSoreness: SportsData;
  /** 에션셜 트레이닝 솔루션 팝업 on/off 갱신 */
  updateEssentialTrainingSolutionPopup: Scalars['Boolean'];
  /** 피드백 수정 */
  updateFeedback: Feedback;
  /** 피드백 댓글 수정 */
  updateFeedbackComment: Feedback;
  /** 부상 수정 */
  updateInjury: Injury;
  /** 일정 출전 수정 */
  updateLineupSchedule: MatchSchedule;
  /** 일정 경기 포인트 수정 */
  updateMatchPoint: MatchSchedule;
  /** 일정 경기 결과 갱신 */
  updateMatchResultSchedule: MatchSchedule;
  /** 운동안함 수정 */
  updateNoWorkout: SportsData;
  /** 스카우팅 후보 선수 관찰 리포트 수정 */
  updateObservationReport: ProspectPlayer;
  /** 피지컬 솔루션 종료일 수정 */
  updatePhysicalSolutionEndDate: Scalars['Boolean'];
  /** 팝업 수정 */
  updatePopup: Popup;
  /** 스카우팅 후보 선수 수정 */
  updateProspectPlayer: ProspectPlayer;
  /** 스카우팅 후보 선수 코멘트 수정 */
  updateProspectPlayerComment: ProspectPlayer;
  updatePushAlarmLog: Scalars['Boolean'];
  /** 나의 할일 수정 */
  updateRoutine: Routine;
  /** 일정 수정 */
  updateSchedule: Schedule;
  /** 일정 참석 여부 수정 */
  updateScheduleAttendanceStatus: ScheduleInvitee;
  /** 일정 운동부하 기간 수정 */
  updateScheduleWorkloadDuration: Schedule;
  /** 스카우팅 모델 수정 */
  updateScoutingModel: ScoutingModel;
  /** 배송지 수정 */
  updateShipment: Shipment;
  /** 팀 수정 */
  updateTeam: SportsTeam;
  /** 팀 컨디션 기준 데이터 수정 */
  updateTeamConditionThreshold: Scalars['Boolean'];
  /** 팀 gps 데이터 기준 데이터 수정 */
  updateTeamGpsDataThreshold: Scalars['Boolean'];
  /** 팀 그룹 수정 */
  updateTeamGroup: TeamGroup;
  /** 팀 매치 이벤트 기준 데이터 수정 */
  updateTeamMatchEventThreshold: Scalars['Boolean'];
  /** 팀 피지컬 데이터 기준 데이터 수정 */
  updateTeamPhysicalDataV2Threshold: Scalars['Boolean'];
  /** 약관동의 수정 */
  updateTermAgreement: Scalars['Boolean'];
  /** 일정 훈련 포인트 수정 */
  updateTrainingPointSchedule: Schedule;
  /** 유저정보 수정 */
  updateUser: SportsUser;
  /** 운동부하 수정 */
  updateWorkload: SportsData;
  updateWorkloadAndSoreness: SportsData;
  /** 배너 upload */
  uploadBanner: Banner;
  /** 일정표 upload */
  uploadCalendar: Calendar;
  /** 코디네이팅 리포트 upload */
  uploadCoordinatingReport: Scalars['Boolean'];
  /** 팀 또는 유저 프로필 upload */
  uploadProfile: UploadProfileResponse;
  /** 일정 리포트 upload */
  uploadScheduleReport: Scalars['Boolean'];
  /** 일정 참석 여부 생성 or 수정 */
  upsertScheduleAttendanceStatus: ScheduleInvitee;
};


export type MutationAcceptInvitationListArgs = {
  input: SportsTeamInvitationAcceptListInput;
};


export type MutationAddBannerLogArgs = {
  input: AddBannerLogInput;
};


export type MutationAddLicenseObserverListArgs = {
  input: AddLicenseObserverList;
};


export type MutationAddLicenseTeamListArgs = {
  input: AddLicenseTeamListInput;
};


export type MutationAppendSorenessListArgs = {
  input: AppendSorenessListInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationCancelSubscriptionV2Args = {
  id: Scalars['Float'];
};


export type MutationChangeSubscriptionBillingArgs = {
  billingId: Scalars['Float'];
  id: Scalars['Float'];
};


export type MutationChangeSubscriptionDateArgs = {
  input: ChangeSubscriptionDateInput;
};


export type MutationChangeSubscriptionProductCodeArgs = {
  input: ChangeSubscriptionProductInput;
};


export type MutationChangeSubscriptionShipmentArgs = {
  id: Scalars['Float'];
  shipmentId: Scalars['Float'];
};


export type MutationChangeSubscriptionV2Args = {
  id: Scalars['Float'];
  nextPlanId: Scalars['Float'];
};


export type MutationConnectParentPlayerArgs = {
  userId: Scalars['String'];
};


export type MutationCreateBodyArgs = {
  input: CreateBodyInput;
};


export type MutationCreateBodyPartArgs = {
  fileList?: Maybe<Array<Scalars['Upload']>>;
};


export type MutationCreateCheckReminderPushScheduleArgs = {
  input: CreateCheckReminderPushSchedule;
};


export type MutationCreateConditionArgs = {
  input: CreateConditionInput;
};


export type MutationCreateConditionAndSorenessArgs = {
  input: CreateConditionAndSorenessInput;
};


export type MutationCreateCouponArgs = {
  input: CreateCouponInput;
};


export type MutationCreateFeedbackArgs = {
  input: CreateFeedbackInput;
};


export type MutationCreateFeedbackCommentArgs = {
  input: CreateFeedbackCommentInput;
};


export type MutationCreateHyperClientArgs = {
  input: CreateHyperClientInput;
};


export type MutationCreateInjuryArgs = {
  files: Array<Scalars['Upload']>;
  input: CreateInjuryInput;
};


export type MutationCreateLicenseArgs = {
  input: CreateLicenseInput;
};


export type MutationCreateNoWorkoutArgs = {
  input: CreateNoWorkoutInput;
};


export type MutationCreateObservationReportArgs = {
  input: CreateObservationReportInput;
};


export type MutationCreatePersonalPhysicalSolutionArgs = {
  input: TrainingSolutionInput;
};


export type MutationCreatePopupArgs = {
  file: Scalars['Upload'];
  input: CreatePopupInput;
};


export type MutationCreateProspectPlayerArgs = {
  file?: Maybe<Scalars['Upload']>;
  input: CreateProspectPlayerInput;
};


export type MutationCreateProspectPlayerCommentArgs = {
  input: CreateProspectPlayerCommentInput;
};


export type MutationCreateRoutineArgs = {
  input: CreateInput;
};


export type MutationCreateScheduleArgs = {
  fileList?: Maybe<Array<Scalars['Upload']>>;
  input: ScheduleCreateInput;
  teamId: Scalars['ID'];
};


export type MutationCreateScheduleAttendanceStatusArgs = {
  input: CreateScheduleAttendanceStatusInput;
};


export type MutationCreateScoutingModelArgs = {
  input: CreateScoutingModelInput;
};


export type MutationCreateShipmentArgs = {
  input: CreateShipmentInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTeamConditionThresholdArgs = {
  input: CreateTeamConditionThreshold;
};


export type MutationCreateTeamGpsDataThresholdArgs = {
  input: CreateTeamGpsDataThreshold;
};


export type MutationCreateTeamGroupArgs = {
  input: CreateTeamGroupInput;
};


export type MutationCreateTeamMatchEventThresholdArgs = {
  input: CreateTeamMatchEventThreshold;
};


export type MutationCreateTeamPhysicalDataV2ThresholdArgs = {
  input: CreateTeamPhysicalDataV2Threshold;
};


export type MutationCreateUserSolutionHistoryArgs = {
  input: UserSolutionHistoryInput;
};


export type MutationCreateWorkloadArgs = {
  input: CreateWorkloadInput;
};


export type MutationCreateWorkloadAndSorenessArgs = {
  input: CreateWorkloadAndSorenessInput;
};


export type MutationDeleteBannerArgs = {
  input: DeleteBannerInput;
};


export type MutationDeleteBodyArgs = {
  input: DeleteSportsDataInput;
};


export type MutationDeleteCardArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCheckReminderPushScheduleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteConditionArgs = {
  input: DeleteSportsDataInput;
};


export type MutationDeleteCouponArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCustomerKeyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFeedbackArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFeedbackCommentArgs = {
  input: DeleteFeedbackCommentInput;
};


export type MutationDeleteFileArgs = {
  input: DeleteFileInput;
};


export type MutationDeleteInjuryArgs = {
  input: DeleteInjuryInput;
};


export type MutationDeleteLicenseArgs = {
  input: DeleteLicenseInput;
};


export type MutationDeleteNoWorkoutArgs = {
  input: DeleteNoWorkoutInput;
};


export type MutationDeleteObservationReportArgs = {
  input: DeleteObservationReportInput;
};


export type MutationDeletePhysicalDataArgs = {
  id: Scalars['String'];
};


export type MutationDeletePhysicalSolutionArgs = {
  userId: Scalars['String'];
};


export type MutationDeletePopupArgs = {
  input: DeletePopupInput;
};


export type MutationDeleteProspectPlayerCommentArgs = {
  input: DeleteProspectPlayerCommentInput;
};


export type MutationDeleteProspectPlayerListArgs = {
  input: DeleteProspectPlayerListInput;
};


export type MutationDeleteRoutineArgs = {
  input: DeleteInput;
};


export type MutationDeleteScheduleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteShipmentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTeamArgs = {
  teamId: Scalars['ID'];
};


export type MutationDeleteTeamGroupArgs = {
  input: DeleteTeamGroupInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteSportsUserInput;
};


export type MutationDeleteWorkloadArgs = {
  input: DeleteSportsDataInput;
};


export type MutationDeregisterDeviceTokenArgs = {
  token: Scalars['String'];
};


export type MutationExecuteParentPlayerActionArgs = {
  input: ConnectParentPlayerInput;
};


export type MutationExportMatchReportScheduleArgs = {
  input: ExportReportSchedule;
};


export type MutationExportTeamSportDataServiceArgs = {
  input: ExportTeamSportData;
};


export type MutationExportTrainingReportScheduleArgs = {
  input: ExportReportSchedule;
};


export type MutationGiveCouponToUserListArgs = {
  id: Scalars['ID'];
  input: GiveCouponToUserListInput;
};


export type MutationGiveCouponsArgs = {
  id: Scalars['ID'];
  input: GiveCouponToTeamsInput;
};


export type MutationImportPhysicalDataCsvFileListArgs = {
  files: Array<Scalars['Upload']>;
};


export type MutationImportPhysicalSolutionCsvFileListArgs = {
  files: Array<Scalars['Upload']>;
};


export type MutationKickoutTeamUserListArgs = {
  input: TeamUserListInput;
};


export type MutationLeaveTeamArgs = {
  input: TeamUserInput;
};


export type MutationMakeAlarmGuideDoNotReopenStatusArgs = {
  input: MakeDoNotReopenAlarmGuideStatusInput;
};


export type MutationMakeCoachAlarmListCheckedArgs = {
  alarmId?: Maybe<Scalars['ID']>;
  date?: Maybe<Scalars['DateTime']>;
  teamId: Scalars['ID'];
};


export type MutationMakePhysicalSolutionReportOpenedArgs = {
  id: Scalars['String'];
};


export type MutationMakePlayerAlarmListCheckedArgs = {
  alarmId?: Maybe<Scalars['ID']>;
  date?: Maybe<Scalars['DateTime']>;
};


export type MutationMakeReadinessGuideDoNotReopenStatusArgs = {
  input: MakeDoNotReopenReadinessGuideStatusInput;
};


export type MutationRefundArgs = {
  input: Refund;
};


export type MutationRefundSubscriptionArgs = {
  input: RefundSubscriptionInput;
};


export type MutationRegisterCardArgs = {
  authKey: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationRegisterDeviceTokenArgs = {
  token: Scalars['String'];
};


export type MutationRejectTeamInvitationListArgs = {
  input: SportsTeamInvitationRejectListInput;
};


export type MutationRemoveCouponArgs = {
  id: Scalars['ID'];
  teamId: Scalars['ID'];
};


export type MutationRemoveLicenseObserverArgs = {
  input: RemoveLicenseObserver;
};


export type MutationRemoveLicenseTeamArgs = {
  input: RemoveLicenseTeamInput;
};


export type MutationRemoveUnusedCouponsArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveUnusedUserCouponArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveUserCouponArgs = {
  id: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRequestBillingTokenArgs = {
  input: RequestBillingTokenInput;
};


export type MutationRequestTeamInvitationArgs = {
  input: SportsTeamInvitationRequestInput;
};


export type MutationRestartSubscriptionArgs = {
  input: RestartSubscriptionInput;
};


export type MutationResumeSubscriptionArgs = {
  input: ResumeSubscriptionInput;
};


export type MutationResumeSubscriptionV2Args = {
  id: Scalars['Float'];
};


export type MutationRetryPaymentArgs = {
  input: RetryPayment;
};


export type MutationSavePlayerMatchEventDataArgs = {
  input: SavePlayerMatchEventData;
};


export type MutationSaveTeamGpsDataArgs = {
  input: SaveTeamGpsData;
};


export type MutationSaveTeamMatchEventDataArgs = {
  input: SaveTeamMatchEventData;
};


export type MutationSaveTeamPhysicalDataArgs = {
  input: SaveTeamPhysicalData;
};


export type MutationSendCheckConditionReminderPushArgs = {
  input: CheckReminderPushInput;
};


export type MutationSendCheckScheduleInviteeReminderPushArgs = {
  input: CheckScheduleInviteReminderPushInput;
};


export type MutationSendCheckWorkloadReminderPushArgs = {
  input: CheckReminderPushInput;
};


export type MutationSendEventWorkloadReminderPushArgs = {
  input: CheckScheduleInviteReminderPushInput;
};


export type MutationStartSubscriptionArgs = {
  input: StartSubscriptionInput;
};


export type MutationStartSubscriptionV2Args = {
  input: StartSubscriptionInputV2;
};


export type MutationSuggestPlayerMatchEventDataNameArgs = {
  file: Scalars['Upload'];
  sheetName?: Maybe<Scalars['String']>;
};


export type MutationSuggestTeamGpsDataNameArgs = {
  file: Scalars['Upload'];
  sheetName?: Maybe<Scalars['String']>;
};


export type MutationSuggestTeamMatchEventDataNameArgs = {
  file: Scalars['Upload'];
  sheetName?: Maybe<Scalars['String']>;
};


export type MutationSuggestTeamPhysicalDataNameArgs = {
  file: Scalars['Upload'];
  sheetName?: Maybe<Scalars['String']>;
};


export type MutationToggleDefaultCardArgs = {
  id: Scalars['ID'];
};


export type MutationToggleRoutineArgs = {
  input: ToggleInput;
};


export type MutationToggleTeamUserStarStatusArgs = {
  input: ToggleTeamUserStarredInput;
};


export type MutationTransferTeamOwnershipArgs = {
  input: TeamUserInput;
};


export type MutationUpdateAppPushAlarmFlagArgs = {
  input: AppPushAlarmFlagInput;
};


export type MutationUpdateBannerArgs = {
  file?: Maybe<Scalars['Upload']>;
  input: UpdateBannerInput;
};


export type MutationUpdateBillingBuyerEmailArgs = {
  input: UpdateBillingBuyerEmailInput;
};


export type MutationUpdateBillingBuyerNameArgs = {
  input: UpdateBillingBuyerNameInput;
};


export type MutationUpdateBillingBuyerNumberArgs = {
  input: UpdateBillingBuyerNumberInput;
};


export type MutationUpdateBillingKeyArgs = {
  input: UpdateBillingTokenInput;
};


export type MutationUpdateBodyArgs = {
  input: UpdateBodyInput;
};


export type MutationUpdateBriefingViewedLogArgs = {
  input: UpdateBriefingViewedAt;
};


export type MutationUpdateConditionArgs = {
  input: UpdateConditionInput;
};


export type MutationUpdateConditionAndSorenessArgs = {
  input: UpdateConditionAndSorenessInput;
};


export type MutationUpdateEssentialTrainingSolutionPopupArgs = {
  input: EssentialTrainingSolutionPopupInput;
};


export type MutationUpdateFeedbackArgs = {
  input: UpdateFeedbackInput;
};


export type MutationUpdateFeedbackCommentArgs = {
  input: UpdateFeedbackCommentInput;
};


export type MutationUpdateInjuryArgs = {
  files?: Maybe<Array<Scalars['Upload']>>;
  input: UpdateInjuryInput;
};


export type MutationUpdateLineupScheduleArgs = {
  input: UpdateLineupSchedule;
};


export type MutationUpdateMatchPointArgs = {
  input: UpdateScheduleMatchPointInput;
};


export type MutationUpdateMatchResultScheduleArgs = {
  input: UpdateMatchResultScheduleInput;
};


export type MutationUpdateNoWorkoutArgs = {
  input: UpdateNoWorkoutInput;
};


export type MutationUpdateObservationReportArgs = {
  input: UpdateObservationReportInput;
};


export type MutationUpdatePhysicalSolutionEndDateArgs = {
  input: PhysicalSolutionEndDateInput;
};


export type MutationUpdatePopupArgs = {
  file: Scalars['Upload'];
  input: UpdatePopupInput;
};


export type MutationUpdateProspectPlayerArgs = {
  file?: Maybe<Scalars['Upload']>;
  input: UpdateProspectPlayerInput;
};


export type MutationUpdateProspectPlayerCommentArgs = {
  input: UpdateProspectPlayerCommentInput;
};


export type MutationUpdatePushAlarmLogArgs = {
  input: UpdateNotificationLogInput;
};


export type MutationUpdateRoutineArgs = {
  input: UpdateInput;
};


export type MutationUpdateScheduleArgs = {
  fileList?: Maybe<Array<Scalars['Upload']>>;
  id: Scalars['ID'];
  input: ScheduleUpdateInput;
  teamId: Scalars['ID'];
};


export type MutationUpdateScheduleAttendanceStatusArgs = {
  input: UpdateScheduleAttendanceStatusInput;
};


export type MutationUpdateScheduleWorkloadDurationArgs = {
  input: UpdateScheduleWorkloadDurationInput;
};


export type MutationUpdateScoutingModelArgs = {
  input: UpdateScoutingModelInput;
};


export type MutationUpdateShipmentArgs = {
  input: UpdateShipmentInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateTeamConditionThresholdArgs = {
  input: CreateTeamConditionThreshold;
};


export type MutationUpdateTeamGpsDataThresholdArgs = {
  input: CreateTeamGpsDataThreshold;
};


export type MutationUpdateTeamGroupArgs = {
  input: UpdateTeamGroupInput;
};


export type MutationUpdateTeamMatchEventThresholdArgs = {
  input: CreateTeamMatchEventThreshold;
};


export type MutationUpdateTeamPhysicalDataV2ThresholdArgs = {
  input: UpdateTeamPhysicalDataV2Threshold;
};


export type MutationUpdateTermAgreementArgs = {
  input: TermAgreementInput;
};


export type MutationUpdateTrainingPointScheduleArgs = {
  input: UpdateTrainingPointScheduleInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateSportsUserInput;
};


export type MutationUpdateWorkloadArgs = {
  input: UpdateWorkloadInput;
};


export type MutationUpdateWorkloadAndSorenessArgs = {
  input: UpdateWorkloadAndSorenessInput;
};


export type MutationUploadBannerArgs = {
  file: Scalars['Upload'];
  input: UploadBannerInput;
};


export type MutationUploadCalendarArgs = {
  file: Scalars['Upload'];
  input: UploadCalendarInput;
};


export type MutationUploadCoordinatingReportArgs = {
  file: Scalars['Upload'];
  input: UploadCoordinatingReportInput;
};


export type MutationUploadProfileArgs = {
  file: Scalars['Upload'];
  teamId?: Maybe<Scalars['ID']>;
};


export type MutationUploadScheduleReportArgs = {
  file: Scalars['Upload'];
  input: UploadScheduleReportInput;
};


export type MutationUpsertScheduleAttendanceStatusArgs = {
  input: UpsertScheduleAttendanceStatusInput;
};

export enum NoWorkoutType {
  INJURY = 'INJURY',
  REST = 'REST'
}

export enum OsType {
  android = 'android',
  ios = 'ios',
  web = 'web'
}

/** 스카우팅 선수 관찰 리포트 */
export type ObservationReport = {
  __typename: 'ObservationReport';
  /** 종합 코멘트 */
  comprehensiveComment?: Maybe<Scalars['String']>;
  /** 코멘트 작성 유저 정보 */
  createUser: SportsUser;
  /** 생성 날짜 */
  createdDate: Scalars['String'];
  /** 적합도 */
  fit?: Maybe<Scalars['Float']>;
  /** ID */
  id: Scalars['ID'];
  /** 심리 평가 */
  mental: Mental;
  /** 심리 적합도 */
  mentalFit?: Maybe<Scalars['Float']>;
  /** 모델 내 심리 강점 */
  mentalStrengthListWithinModel: Array<MentalMetricType>;
  /** 모델 외 심리 강점 */
  mentalStrengthListWithoutModel: Array<MentalMetricType>;
  /** 모델 내 심리 약점 */
  mentalWeaknessListWithinModel: Array<MentalMetricType>;
  /** 모델 외 심리 약점 */
  mentalWeaknessListWithoutModel: Array<MentalMetricType>;
  /** 신체 평가 */
  physical: ScoutingPhysical;
  /** 신체 적합도 */
  physicalFit?: Maybe<Scalars['Float']>;
  /** 모델 내 신체 강점 */
  physicalStrengthListWithinModel: Array<PhysicalMetricType>;
  /** 모델 외 신체 강점 */
  physicalStrengthListWithoutModel: Array<PhysicalMetricType>;
  /** 모델 내 신체 약점 */
  physicalWeaknessListWithinModel: Array<PhysicalMetricType>;
  /** 모델 외 신체 약점 */
  physicalWeaknessListWithoutModel: Array<PhysicalMetricType>;
  /** 일정 정보 */
  schedule: ObservationReportSchedule;
  /** 전술 평가 */
  tactic: Tactic;
  /** 전술 적합도 */
  tacticFit?: Maybe<Scalars['Float']>;
  /** 모델 내 전술 강점 */
  tacticStrengthListWithinModel: Array<TacticMetricType>;
  /** 모델 외 전술 강점 */
  tacticStrengthListWithoutModel: Array<TacticMetricType>;
  /** 모델 내 전술 약점 */
  tacticWeaknessListWithinModel: Array<TacticMetricType>;
  /** 모델 외 전술 약점 */
  tacticWeaknessListWithoutModel: Array<TacticMetricType>;
  /** 기술 평가 */
  technic: Technic;
  /** 기술 적합도 */
  technicFit?: Maybe<Scalars['Float']>;
  /** 모델 내 기술 강점 */
  technicStrengthListWithinModel: Array<TechnicMetricType>;
  /** 모델 외 기술 강점 */
  technicStrengthListWithoutModel: Array<TechnicMetricType>;
  /** 모델 내 기술 약점 */
  technicWeaknessListWithinModel: Array<TechnicMetricType>;
  /** 모델 외 기술 약점 */
  technicWeaknessListWithoutModel: Array<TechnicMetricType>;
};

/** 관찰 리포트 일정 정보 */
export type ObservationReportSchedule = {
  __typename: 'ObservationReportSchedule';
  /** 날짜 */
  date: Scalars['String'];
  /** 이름 */
  name?: Maybe<Scalars['String']>;
  otherType?: Maybe<Scalars['String']>;
  /** 장소 */
  place?: Maybe<Scalars['String']>;
  /** 시간 */
  time?: Maybe<Scalars['String']>;
  /** 일정 타입 */
  type: ObservationReportScheduleType;
};

/** 관찰 리포트 일정 정보 input */
export type ObservationReportScheduleInput = {
  /** 날짜 */
  date: Scalars['String'];
  /** 이름 */
  name?: Maybe<Scalars['String']>;
  /** 장소 */
  otherType?: Maybe<Scalars['String']>;
  /** 장소 */
  place?: Maybe<Scalars['String']>;
  /** 시간 */
  time?: Maybe<Scalars['String']>;
  /** 일정 타입 */
  type: ObservationReportScheduleType;
};

export enum ObservationReportScheduleType {
  MATCH = 'MATCH',
  OTHER = 'OTHER',
  PRACTICE = 'PRACTICE',
  TRAINING = 'TRAINING'
}

export enum ObservationStatusType {
  INTENSIVE = 'INTENSIVE',
  PENDING = 'PENDING',
  SINGLE = 'SINGLE'
}

export enum Option {
  AGE = 'AGE',
  GENDER = 'GENDER',
  LANGUAGE = 'LANGUAGE',
  TEAM = 'TEAM'
}

export enum OptionOperator {
  EQ = 'EQ',
  GT = 'GT',
  GTE = 'GTE',
  LT = 'LT',
  LTE = 'LTE',
  NE = 'NE'
}

/** 페이징 정보 */
export type Page = {
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** 학부모 액션 알림 */
export type ParentAlarm = Alarm & {
  __typename: 'ParentAlarm';
  /** 알람 생성 유저 정보 */
  createUser: SportsUser;
  /** 생성일 */
  createdAt: Scalars['DateTime'];
  /** 알림 ID */
  id: Scalars['ID'];
  /** 알림 읽음 여부 */
  isChecked: Scalars['Boolean'];
  /** 학부모 정보 */
  parent?: Maybe<SportsUser>;
  /** 플랜 정보 */
  plan?: Maybe<PlanV2Alarm>;
  /** 선수 정보 */
  player?: Maybe<SportsUser>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 알림 종류 */
  type: AlarmType;
};


/** 학부모 액션 알림 */
export type ParentAlarmPlanArgs = {
  input: MultilingualTextInput;
};

/** 결제 인보이스 */
export type PayInvoice = Invoice & {
  __typename: 'PayInvoice';
  /** 금액 */
  amount: Scalars['Float'];
  /** 결제 유저 이메일 */
  billingUserEmail: Scalars['String'];
  /** 결제 유저 이름 */
  billingUserName: Scalars['String'];
  /** 결제 유저 전화번호 */
  billingUserPhone: Scalars['String'];
  /** 카드명 */
  cardName: Scalars['String'];
  /** 카드번호 */
  cardNumber: Scalars['String'];
  /** 결제ID */
  id: Scalars['ID'];
  /** 결제일 */
  paidAt?: Maybe<Scalars['String']>;
  /** 결제명 */
  paymentName: Scalars['String'];
  /** 결제 상태 */
  paymentStatus: PaymentStatus;
  /** 영수증 url */
  receiptUrl?: Maybe<Scalars['String']>;
};

export enum PaymentStatus {
  FAIL = 'FAIL',
  PAY = 'PAY',
  REFUND = 'REFUND',
  SCHEDULED_CANCEL = 'SCHEDULED_CANCEL',
  SCHEDULED_PAY = 'SCHEDULED_PAY'
}

/** 결제 v2 */
export type PaymentV2 = {
  __typename: 'PaymentV2';
  /** 금액 */
  amount: Scalars['Float'];
  /** 이메일 */
  buyerEmail: Scalars['String'];
  /** 이름 */
  buyerName: Scalars['String'];
  /** 전화번호 */
  buyerPhoneNumber: Scalars['String'];
  /** 환불 금액 */
  canceledAmount?: Maybe<Scalars['Float']>;
  /** 결제일 */
  date: Scalars['String'];
  /** 실패 이유 */
  failReason?: Maybe<Scalars['String']>;
  /** 결제 ID */
  id: Scalars['ID'];
  /** 결제 고유번호 */
  paymentNumber: Scalars['Float'];
  /** 상품 코드 */
  productCode?: Maybe<ProductCode>;
  /** 영수증 url */
  receiptUrl?: Maybe<Scalars['String']>;
  /** 상태 */
  status: PaymentV2Type;
  /** 구독 정보 */
  subscription: SubscriptionV2WithBillingAndPlanAndShipment;
};

export enum PaymentV2Type {
  CANCEL = 'CANCEL',
  FAIL = 'FAIL',
  SCHEDULED = 'SCHEDULED',
  SCHEDULED_CANCEL = 'SCHEDULED_CANCEL',
  SUCCESS = 'SUCCESS'
}

/** 주요 퍼포먼스 */
export type Performance = {
  __typename: 'Performance';
  /** 수직 점프 최대값 */
  cmjBothMax?: Maybe<Scalars['Float']>;
  /** 최대 근력 */
  deadlift?: Maybe<Scalars['Float']>;
  /** 반응 속도 off the ball */
  reactiveTimeOffTheBall?: Maybe<Scalars['Float']>;
  /** 가속도 시간 최소값 */
  sprint10mMin?: Maybe<Scalars['Float']>;
  /** 스쿼트 근력 */
  squatPowerAvg?: Maybe<Scalars['Float']>;
  /** 유저 이름 */
  userName?: Maybe<Scalars['String']>;
  /** Y-민첩반응 최소값 */
  yShapedTimeMin?: Maybe<Scalars['Float']>;
};

/** 퍼포먼스 측정 상세 결과 */
export type PerformanceMeasurementDetail = {
  __typename: 'PerformanceMeasurementDetail';
  /** 수직점프 팀 평균 */
  cmjBothMax: Scalars['Float'];
  /** 데드리프트 팀 평균 */
  deadlift: Scalars['Float'];
  /** 반응속도 팀 평균 */
  reactiveTimeOffTheBall: Scalars['Float'];
  /** 10m 스프린트 팀 평균 */
  sprint10mMin: Scalars['Float'];
  /** 스쿼트 팀 평균 */
  squatPowerAvg: Scalars['Float'];
  /** Y-민첩반응 팀 평균 */
  yShapedTimeMin: Scalars['Float'];
};

/** 퍼포먼스 점수 */
export type PerformanceScore = {
  __typename: 'PerformanceScore';
  agility?: Maybe<Scalars['Float']>;
  endurance?: Maybe<Scalars['Float']>;
  power?: Maybe<Scalars['Float']>;
  preAgility?: Maybe<Scalars['Float']>;
  preEndurance?: Maybe<Scalars['Float']>;
  prePower?: Maybe<Scalars['Float']>;
  preReaction?: Maybe<Scalars['Float']>;
  preSpeed?: Maybe<Scalars['Float']>;
  preStrength?: Maybe<Scalars['Float']>;
  reaction?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  strength?: Maybe<Scalars['Float']>;
};

/** 개인 훈련 솔루션 */
export type PersonalTrainingSolution = {
  __typename: 'PersonalTrainingSolution';
  /** 맨몸 운동 */
  bodyWeightWorkout?: Maybe<BodyWeightWorkout>;
  /** 기구 운동 */
  equipmentWorkout?: Maybe<EquipmentWorkout>;
  /** 개인 훈련 솔루션 ID */
  id?: Maybe<Scalars['ID']>;
  /** 제목 */
  title: Scalars['String'];
  /** 솔루션 종류 */
  type: SolutionType;
};

/** 팀 매치 이벤트 - 피지컬 지표 */
export type Physical = {
  __typename: 'Physical';
  /** 평균 속도 */
  averageSpeed?: Maybe<Scalars['Float']>;
  /** 고강도 러닝 거리 비율 */
  highIntensityRunningRatio?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  sprintCount?: Maybe<Scalars['Float']>;
  /** 스프린트 총 거리 */
  sprintDistance?: Maybe<Scalars['Float']>;
  /** 최고 속도 */
  topSpeed?: Maybe<Scalars['Float']>;
  /** 총 거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** VHIR 횟수 */
  vhirCount?: Maybe<Scalars['Float']>;
  /** VHIR 총 거리 */
  vhirDistance?: Maybe<Scalars['Float']>;
};

/** 피지컬 데이터 정보 */
export type PhysicalData = {
  __typename: 'PhysicalData';
  /** 수직 점프 */
  cmjBothRep: Array<Scalars['Float']>;
  /** 수직 점프 - 왼쪽 */
  cmjLeftRep: Array<Scalars['Float']>;
  /** 수직 점프 - 오른쪽 */
  cmjRightRep: Array<Scalars['Float']>;
  /** 생성 시간 */
  createdAt: Scalars['Date'];
  /** 최대 근력 */
  deadlift: Scalars['Float'];
  /** 고관절 굽힘근 - 왼쪽 */
  flexionKickerLeft: Scalars['Float'];
  /** 고관절 굽힘근 - 오른쪽 */
  flexionKickerRight: Scalars['Float'];
  /** 고관절 벌림근 - 왼쪽 */
  hipAbductionLeft: Scalars['Float'];
  /** 고관절 벌림근 - 오른쪽 */
  hipAbductionRight: Scalars['Float'];
  /** 고관절 모음근 - 왼쪽 */
  hipAdductionLeft: Scalars['Float'];
  /** 고관절 모음근 - 오른쪽 */
  hipAdductionRight: Scalars['Float'];
  /** 피컬데이터 ID */
  id: Scalars['String'];
  /** 체지방률 */
  infoBodyFat: Scalars['Float'];
  /** 생년월일 */
  infoDateBirth: Scalars['String'];
  /** 측정 날짜 */
  infoDateTest: Scalars['String'];
  /** 성별 */
  infoGender: Scalars['String'];
  /** 키 */
  infoHeight: Scalars['Float'];
  /** 근육량 */
  infoMuscleMass: Scalars['Float'];
  /** 측정 시 소속팀 이름 */
  infoNameTeam: Scalars['String'];
  /** 이름 */
  infoNameUser: Scalars['String'];
  /** 포지션 */
  infoPosition: Scalars['String'];
  /** 주발 */
  infoPreferredFoot: Scalars['String'];
  /** 측정 장소 */
  infoVenue: Scalars['String'];
  /** 몸무게 */
  infoWeight: Scalars['Float'];
  /** 햄스트링 등척성 - 왼쪽 */
  isoProneLeft: Scalars['Float'];
  /** 햄스트링 등척성  -오른쪽 */
  isoProneRight: Scalars['Float'];
  /** 햄스트링 신장성 - 왼쪽 */
  nordicLeft: Scalars['Float'];
  /** 햄스트링 신장성 - 오른쪽 */
  nordicRight: Scalars['Float'];
  /** 반응 속도 off the ball */
  reactiveTimeOffTheBall: Scalars['Float'];
  /** 반응 속도 on the ball */
  reactiveTimeOnTheBall: Scalars['Float'];
  /** 가속도 시간 */
  sprint10mRep: Array<Scalars['Float']>;
  /** 스쿼드 파워 */
  squatPowerRep: Array<Scalars['Float']>;
  /** 스쿼드 근력 */
  squatStrengthRep: Array<Scalars['Float']>;
  /** 팀 ID */
  teamId?: Maybe<Scalars['String']>;
  /** 팀 슬러그 */
  teamSlug?: Maybe<Scalars['String']>;
  /** 수정 시간 */
  updatedAt: Scalars['Date'];
  /** 유저 ID */
  userId: Scalars['String'];
  /** 반응 속도 리액션 평가 */
  yShapedReactionRep: Array<Scalars['Float']>;
  /** 반응 속도 시간 */
  yShapedTimeRep: Array<Scalars['Float']>;
};

export enum PhysicalDataInjuryRiskAnalysisInfo {
  FLEXION_KICKER_RATIO = 'FLEXION_KICKER_RATIO',
  HIP_ABDUCTION_RATIO = 'HIP_ABDUCTION_RATIO',
  HIP_ADDUCTION_RATIO = 'HIP_ADDUCTION_RATIO',
  HIP_ADDUCTION_TO_ABDUCTION_LEFT = 'HIP_ADDUCTION_TO_ABDUCTION_LEFT',
  HIP_ADDUCTION_TO_ABDUCTION_RIGHT = 'HIP_ADDUCTION_TO_ABDUCTION_RIGHT',
  ISO_PRONE_RATIO = 'ISO_PRONE_RATIO',
  NORDIC_RATIO = 'NORDIC_RATIO'
}

export enum PhysicalDataInjuryRiskAnalysisLabel {
  DANGER = 'DANGER',
  NORMAL = 'NORMAL',
  WARNING = 'WARNING'
}

export enum PhysicalDataName {
  CMJ_CONCENTRIC_FORCE = 'CMJ_CONCENTRIC_FORCE',
  CMJ_ECCENTRIC_FORCE = 'CMJ_ECCENTRIC_FORCE',
  CMJ_HEIGHT = 'CMJ_HEIGHT',
  CMJ_PEAK_POWER = 'CMJ_PEAK_POWER',
  DATE = 'DATE',
  FAT_PERCENTAGE = 'FAT_PERCENTAGE',
  NORDIC_HAMSTRING_ASYMMETRY = 'NORDIC_HAMSTRING_ASYMMETRY',
  NORDIC_HAMSTRING_AVERAGE_FORCE_LEFT = 'NORDIC_HAMSTRING_AVERAGE_FORCE_LEFT',
  NORDIC_HAMSTRING_AVERAGE_FORCE_RIGHT = 'NORDIC_HAMSTRING_AVERAGE_FORCE_RIGHT',
  NORDIC_HAMSTRING_MAX_FORCE_LEFT = 'NORDIC_HAMSTRING_MAX_FORCE_LEFT',
  NORDIC_HAMSTRING_MAX_FORCE_RIGHT = 'NORDIC_HAMSTRING_MAX_FORCE_RIGHT',
  PLAYER_NAME = 'PLAYER_NAME',
  REACTIVE_STRENGTH_INDEX = 'REACTIVE_STRENGTH_INDEX',
  SUM_9P = 'SUM_9P',
  WEIGHT = 'WEIGHT'
}

export enum PhysicalDataPerformanceInfo {
  CMJ_BOTH_MAX = 'CMJ_BOTH_MAX',
  DEADLIFT = 'DEADLIFT',
  FLEXION_KICKER_AVG = 'FLEXION_KICKER_AVG',
  HIP_ABDUCTION_AVG = 'HIP_ABDUCTION_AVG',
  HIP_ADDUCTION_AVG = 'HIP_ADDUCTION_AVG',
  ISO_PRONE_AVG = 'ISO_PRONE_AVG',
  NORDIC_AVG = 'NORDIC_AVG',
  REACTIVE_TIME_OFF_THE_BALL = 'REACTIVE_TIME_OFF_THE_BALL',
  SPRINT_10M_MIN = 'SPRINT_10M_MIN',
  SQUAT_POWER_AVG = 'SQUAT_POWER_AVG',
  Y_SHAPED_TIME_MIN = 'Y_SHAPED_TIME_MIN'
}

export enum PhysicalDataV2Type {
  CMJ_CONCENTRIC_FORCE = 'CMJ_CONCENTRIC_FORCE',
  CMJ_ECCENTRIC_FORCE = 'CMJ_ECCENTRIC_FORCE',
  CMJ_HEIGHT = 'CMJ_HEIGHT',
  CMJ_PEAK_POWER = 'CMJ_PEAK_POWER',
  FAT_PERCENTAGE = 'FAT_PERCENTAGE',
  NORDIC_HAMSTRING_ASYMMETRY = 'NORDIC_HAMSTRING_ASYMMETRY',
  NORDIC_HAMSTRING_AVERAGE_FORCE_LEFT = 'NORDIC_HAMSTRING_AVERAGE_FORCE_LEFT',
  NORDIC_HAMSTRING_AVERAGE_FORCE_RIGHT = 'NORDIC_HAMSTRING_AVERAGE_FORCE_RIGHT',
  NORDIC_HAMSTRING_MAX_FORCE_LEFT = 'NORDIC_HAMSTRING_MAX_FORCE_LEFT',
  NORDIC_HAMSTRING_MAX_FORCE_RIGHT = 'NORDIC_HAMSTRING_MAX_FORCE_RIGHT',
  REACTIVE_STRENGTH_INDEX = 'REACTIVE_STRENGTH_INDEX',
  SUM_9P = 'SUM_9P',
  WEIGHT = 'WEIGHT'
}

export enum PhysicalElementType {
  AG = 'AG',
  ME = 'ME',
  PW = 'PW',
  RX = 'RX',
  SP = 'SP',
  ST = 'ST'
}

export enum PhysicalImportType {
  IMPORTED = 'IMPORTED',
  NOT_IMPORTED = 'NOT_IMPORTED'
}

export enum PhysicalMetricType {
  ACCELERATION = 'ACCELERATION',
  AEROBIC_ENDURANCE = 'AEROBIC_ENDURANCE',
  AEROBIC_POWER = 'AEROBIC_POWER',
  AGILITY = 'AGILITY',
  BALANCE = 'BALANCE',
  COMPETITION = 'COMPETITION',
  DECELERATION = 'DECELERATION',
  DIRECTION_CHANGE = 'DIRECTION_CHANGE',
  HEIGHT = 'HEIGHT',
  JUMP = 'JUMP',
  POWER = 'POWER',
  REACTIVITY = 'REACTIVITY',
  RECOVERY_SPEED = 'RECOVERY_SPEED',
  SPEED = 'SPEED',
  SPEED_ENDURANCE = 'SPEED_ENDURANCE',
  WEIGHT = 'WEIGHT'
}

/** 관찰 리포트 신체 평가 input */
export type PhysicalObservationReportInput = {
  /** 가속 */
  acceleration?: Maybe<Scalars['Int']>;
  /** 유산소 지구력 */
  aerobicEndurance?: Maybe<Scalars['Int']>;
  /** 유산소 파워 */
  aerobicPower?: Maybe<Scalars['Int']>;
  /** 민첩성 */
  agility?: Maybe<Scalars['Int']>;
  /** 밸런스 */
  balance?: Maybe<Scalars['Int']>;
  /** 경합 */
  competition?: Maybe<Scalars['Int']>;
  /** 감속 */
  deceleration?: Maybe<Scalars['Int']>;
  /** 방향전환 */
  directionChange?: Maybe<Scalars['Int']>;
  /** 키 */
  height?: Maybe<Scalars['Int']>;
  /** 점프력 */
  jump?: Maybe<Scalars['Int']>;
  /** 파워 */
  power?: Maybe<Scalars['Int']>;
  /** 반응성 */
  reactivity?: Maybe<Scalars['Int']>;
  /** 회복 속도 */
  recoverySpeed?: Maybe<Scalars['Int']>;
  /** 스피드 */
  speed?: Maybe<Scalars['Int']>;
  /** 스피드지구력 */
  speedEndurance?: Maybe<Scalars['Int']>;
  /** 체중 */
  weight?: Maybe<Scalars['Int']>;
};

/** 피지컬 리포트 */
export type PhysicalReport = {
  __typename: 'PhysicalReport';
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 피지컬 리포트 ID */
  id: Scalars['ID'];
  /** 열람 여부 */
  isOpened: Scalars['Boolean'];
  /** 회차 */
  round: Scalars['Int'];
};

/** 피지컬 리포트 기본 정보 */
export type PhysicalReportBasicInfo = {
  __typename: 'PhysicalReportBasicInfo';
  /** 이름 */
  name: Scalars['String'];
  /** 포지션 */
  position?: Maybe<Scalars['String']>;
  /** 주발 */
  preferredFoot?: Maybe<Scalars['String']>;
  /** 팀명 */
  teamName?: Maybe<Scalars['String']>;
};

/** 피지컬 리포트 정보 */
export type PhysicalReportBodyInfo = {
  __typename: 'PhysicalReportBodyInfo';
  bodyFM: PhysicalReportBodyInfoDetail;
  bodyFat: PhysicalReportBodyInfoDetail;
  /** 키 */
  height: PhysicalReportBodyInfoDetail;
  muscleMass: PhysicalReportBodyInfoDetail;
  skeletalMM: PhysicalReportBodyInfoDetail;
  /** 몸무게 */
  weight: PhysicalReportBodyInfoDetail;
};

/** 피지컬 리포트 상세 정보 */
export type PhysicalReportBodyInfoDetail = {
  __typename: 'PhysicalReportBodyInfoDetail';
  /** 연령 평균 */
  ageGroupAvg: Scalars['Float'];
  /** 이전 값 */
  prevValue?: Maybe<Scalars['Float']>;
  /** 팀 평균 */
  teamAvg?: Maybe<Scalars['Float']>;
  /** 값 */
  value: Scalars['Float'];
};

export type PhysicalReportDetail = {
  __typename: 'PhysicalReportDetail';
  basicInfo: PhysicalReportBasicInfo;
  bodyInfo: PhysicalReportBodyInfo;
  date: Scalars['String'];
  id: Scalars['ID'];
  injuryRiskAnalysis: PhysicalReportInjuryRiskAnalysis;
  performanceInfo: PhysicalReportPerformanceInfo;
  round: Scalars['Int'];
  teamId?: Maybe<Scalars['String']>;
  venue?: Maybe<Scalars['String']>;
};

export type PhysicalReportInjuryRiskAnalysis = {
  __typename: 'PhysicalReportInjuryRiskAnalysis';
  flexionKickerRatio: PhysicalReportInjuryRiskAnalysisDetail;
  guide: Scalars['String'];
  hipAbductionRatio: PhysicalReportInjuryRiskAnalysisDetail;
  hipAdductionRatio: PhysicalReportInjuryRiskAnalysisDetail;
  hipAdductionToAbductionLeft: PhysicalReportInjuryRiskAnalysisDetail;
  hipAdductionToAbductionRight: PhysicalReportInjuryRiskAnalysisDetail;
  injuryRiskDangerList: Array<PhysicalDataInjuryRiskAnalysisInfo>;
  injuryRiskWarningList: Array<PhysicalDataInjuryRiskAnalysisInfo>;
  isoProneRatio: PhysicalReportInjuryRiskAnalysisDetail;
  nordicRatio: PhysicalReportInjuryRiskAnalysisDetail;
};

export type PhysicalReportInjuryRiskAnalysisDetail = {
  __typename: 'PhysicalReportInjuryRiskAnalysisDetail';
  label: PhysicalDataInjuryRiskAnalysisLabel;
  prevLabel?: Maybe<PhysicalDataInjuryRiskAnalysisLabel>;
  prevValue?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

export type PhysicalReportPerformanceInfo = {
  __typename: 'PhysicalReportPerformanceInfo';
  cmjBothMax: PhysicalReportPerformanceInfoDetail;
  coreValue: PhysicalReportPerformanceInfoCoreValue;
  deadlift: PhysicalReportPerformanceInfoDetail;
  flexionKickerAvg: PhysicalReportPerformanceInfoDetail;
  guide: Scalars['String'];
  hipAbductionAvg: PhysicalReportPerformanceInfoDetail;
  hipAdductionAvg: PhysicalReportPerformanceInfoDetail;
  insight: PhysicalReportPerformanceInfoInsight;
  isoProneAvg: PhysicalReportPerformanceInfoDetail;
  needToImproveList: Array<PhysicalDataPerformanceInfo>;
  nordicAvg: PhysicalReportPerformanceInfoDetail;
  reactiveTimeOffTheBall: PhysicalReportPerformanceInfoDetail;
  sprint10mMin: PhysicalReportPerformanceInfoDetail;
  squatPowerAvg: PhysicalReportPerformanceInfoDetail;
  yShapedTimeMin: PhysicalReportPerformanceInfoDetail;
};

export type PhysicalReportPerformanceInfoCoreValue = {
  __typename: 'PhysicalReportPerformanceInfoCoreValue';
  agility: PhysicalReportPerformanceInfoCoreValueDetail;
  endurance: PhysicalReportPerformanceInfoCoreValueDetail;
  power: PhysicalReportPerformanceInfoCoreValueDetail;
  reaction: PhysicalReportPerformanceInfoCoreValueDetail;
  speed: PhysicalReportPerformanceInfoCoreValueDetail;
  strength: PhysicalReportPerformanceInfoCoreValueDetail;
};

export type PhysicalReportPerformanceInfoCoreValueDetail = {
  __typename: 'PhysicalReportPerformanceInfoCoreValueDetail';
  ageGroupAvg: Scalars['Float'];
  teamAvg?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

export type PhysicalReportPerformanceInfoDetail = {
  __typename: 'PhysicalReportPerformanceInfoDetail';
  ageGroupLevelAvg: Scalars['Float'];
  level: Scalars['Float'];
  needToImprove: Scalars['Boolean'];
  prevValue?: Maybe<Scalars['Float']>;
  teamLevelAvg?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

export type PhysicalReportPerformanceInfoInsight = {
  __typename: 'PhysicalReportPerformanceInfoInsight';
  ageGroupAvg: Scalars['Float'];
  ageGroupRank: Scalars['Float'];
  prevValue?: Maybe<Scalars['Float']>;
  teamAvg?: Maybe<Scalars['Float']>;
  teamRank?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

/** 스카우팅 모델 신체 기준 input */
export type PhysicalScoutingModelInput = {
  /** 가속 */
  acceleration?: Maybe<Scalars['Int']>;
  /** 유산소 지구력 */
  aerobicEndurance?: Maybe<Scalars['Int']>;
  /** 유산소 파워 */
  aerobicPower?: Maybe<Scalars['Int']>;
  /** 민첩성 */
  agility?: Maybe<Scalars['Int']>;
  /** 밸런스 */
  balance?: Maybe<Scalars['Int']>;
  /** 경합 */
  competition?: Maybe<Scalars['Int']>;
  /** 감속 */
  deceleration?: Maybe<Scalars['Int']>;
  /** 방향전환 */
  directionChange?: Maybe<Scalars['Int']>;
  /** 키 */
  height?: Maybe<Scalars['Int']>;
  /** 점프력 */
  jump?: Maybe<Scalars['Int']>;
  /** 파워 */
  power?: Maybe<Scalars['Int']>;
  /** 반응성 */
  reactivity?: Maybe<Scalars['Int']>;
  /** 회복 속도 */
  recoverySpeed?: Maybe<Scalars['Int']>;
  /** 스피드 */
  speed?: Maybe<Scalars['Int']>;
  /** 스피드지구력 */
  speedEndurance?: Maybe<Scalars['Int']>;
  /** 체중 */
  weight?: Maybe<Scalars['Int']>;
};

export type PhysicalSolution = {
  __typename: 'PhysicalSolution';
  bodyWeightWorkout: PhysicalSolutionWorkout;
  equipmentWorkout: PhysicalSolutionWorkout;
  id: Scalars['ID'];
  isActivated: Scalars['Boolean'];
  isReportOpened: Scalars['Boolean'];
  reportPdfLink?: Maybe<Scalars['String']>;
};

/** 피지컬 솔루션 페이징 목록 */
export type PhysicalSolutionByPage = {
  __typename: 'PhysicalSolutionByPage';
  /** 피지컬 솔루션 쿼리 목록 */
  data: Array<PhysicalSolutionQuery>;
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

/** 피지컬 솔루션 csv 임포트 결과 정보 */
export type PhysicalSolutionCsvFileList = {
  __typename: 'PhysicalSolutionCsvFileList';
  /** 실패 파일 목록 */
  failedFileList: Array<FailedFile>;
  /** 성공 파일 목록 */
  successFileList: Array<Scalars['String']>;
};

/** 피지컬 솔루션 종료일 수정 input */
export type PhysicalSolutionEndDateInput = {
  /** 종료일 */
  endDate: Scalars['String'];
  /** 피지컬 솔루션 ID */
  id: Scalars['String'];
};

/** 피지컬 솔루션 쿼리 */
export type PhysicalSolutionQuery = {
  __typename: 'PhysicalSolutionQuery';
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 이메일 */
  email: Scalars['String'];
  /** 종료일 */
  endDate?: Maybe<Scalars['String']>;
  /** 피지컬 솔루션 ID */
  id: Scalars['ID'];
  /** 측정 회차 */
  infoTestRound?: Maybe<Scalars['String']>;
  /** 시작일 */
  startDate?: Maybe<Scalars['String']>;
  /** 팀 슬러그 */
  teamSlug?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt: Scalars['String'];
  /** 유저ID */
  userId: Scalars['String'];
  /** 유저 이름 */
  userName: Scalars['String'];
  /** 유저 슬러그 */
  userSlug: Scalars['String'];
};

export type PhysicalSolutionWorkout = {
  __typename: 'PhysicalSolutionWorkout';
  sessionList: Array<Session>;
};

/** 피지컬 유저 데이터 input */
export type PhysicalUserData = {
  /** 수직 점프 상승 국면 근력 */
  cmjConcentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 하강 국면 근력 */
  cmjEccentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 높이 */
  cmjHeight?: Maybe<Scalars['Float']>;
  /** 수직 점프 순간 최대 파워 */
  cmjPeakPower?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 체지방률 */
  fatPercentage?: Maybe<Scalars['Float']>;
  /** 햄스트링 좌우 불균형 지수 */
  nordicHamstringAsymmetry?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (좌) */
  nordicHamstringAverageForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (우) */
  nordicHamstringAverageForceRight?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (좌) */
  nordicHamstringMaxForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (우) */
  nordicHamstringMaxForceRight?: Maybe<Scalars['Float']>;
  /** 선수 이름 */
  playerName: Scalars['String'];
  /** RSI */
  reactiveStrengthIndex?: Maybe<Scalars['Float']>;
  /** 9개 부위 피부두겹 두께 합 */
  sum9P?: Maybe<Scalars['Float']>;
  /** 유저ID */
  userId: Scalars['ID'];
  /** 몸무게 */
  weight?: Maybe<Scalars['Float']>;
};

/** 플랜 정보 */
export type Plan = {
  __typename: 'Plan';
  /** 할일 종료일 */
  discountEndAt?: Maybe<Scalars['Date']>;
  /** 할인 시작일 */
  discountStartAt?: Maybe<Scalars['Date']>;
  /** 플랜ID */
  id: Scalars['ID'];
  /** 최대 사용 횟수 */
  limitCount?: Maybe<Scalars['Int']>;
  /** 원가 시작일 */
  originalPriceStartAt?: Maybe<Scalars['Date']>;
  /** 플랜명 */
  planName: Scalars['String'];
  /** 플랜 옵션 쿠폰 목록 */
  planOptionInfoList?: Maybe<Array<Maybe<PlanOptionWithCoupon>>>;
  /** 플랜 종류 */
  planType: Scalars['String'];
};

/** 플랜 혜택 정보 */
export type PlanBenefit = {
  __typename: 'PlanBenefit';
  /** 이미지 url */
  imageUrl: Scalars['String'];
  /** 부제목 리스트 */
  subTitleList: Array<Scalars['String']>;
  /** 제목 */
  title: Scalars['String'];
};


/** 플랜 혜택 정보 */
export type PlanBenefitSubTitleListArgs = {
  input: MultilingualTextInput;
};


/** 플랜 혜택 정보 */
export type PlanBenefitTitleArgs = {
  input: MultilingualTextInput;
};

export enum PlanMainCategory {
  COACH = 'COACH',
  PLAYER = 'PLAYER'
}

/** 플랜 옵션 */
export type PlanOption = {
  __typename: 'PlanOption';
  /** 금액 */
  amount: Scalars['Float'];
  /** 화폐단위 */
  currency: Scalars['String'];
  /** 설명 */
  description: Scalars['String'];
  /** 기간 */
  duration: Scalars['Float'];
  /** 플랜 옵션ID */
  id: Scalars['ID'];
  /** 최대 선수 명수 */
  maxPlayerCount: Scalars['Float'];
  /** 최대 팀 갯수 */
  maxTeamCount: Scalars['Float'];
  /** 다음 결제일 */
  nextPaymentDay: Scalars['Date'];
  /** 기간 종류 */
  period: Scalars['String'];
  /** 플랜 온션 이름 */
  planOptionName: Scalars['String'];
};

/** 플랜 옵션, 쿠폰 */
export type PlanOptionWithCoupon = {
  __typename: 'PlanOptionWithCoupon';
  /** 화폐단위 */
  currency: Scalars['String'];
  /** 설명 */
  description: Scalars['String'];
  /** 할인된 금액 */
  discountedPrice?: Maybe<Scalars['Int']>;
  /** 기간 */
  duration: Scalars['Float'];
  /** 플랜옵션ID */
  id: Scalars['ID'];
  /** 최대 선수 명수 */
  maxPlayerCount: Scalars['Float'];
  /** 최대 팀 갯수 */
  maxTeamCount: Scalars['Float'];
  /** 다음 결제일 */
  nextPaymentDay: Scalars['Date'];
  /** 할인전 금액 */
  originalPrice: Scalars['Int'];
  /** 기간 종류 */
  period: Scalars['String'];
  /** 플랜 옵션명 */
  planOptionName: Scalars['String'];
};

export enum PlanSubCategory {
  DEPRECATED = 'DEPRECATED',
  GYM_MEMBERSHIP = 'GYM_MEMBERSHIP',
  PLAYER_MEMBERSHIP = 'PLAYER_MEMBERSHIP'
}

/** 플랜 정보 */
export type PlanV2 = BasicPlanV2 & {
  __typename: 'PlanV2';
  /** 혜택 목록 */
  benefitList: Array<PlanBenefit>;
  /** 공통 혜택 목록 */
  commonBenefitList: Array<PlanBenefit>;
  /** 소분류 */
  detailCategory: Scalars['String'];
  /** 플랜 세부 이름 */
  detailName: Scalars['String'];
  /** 원가 */
  fakePrice: Scalars['Float'];
  /** 플랜 ID */
  id: Scalars['ID'];
  /** 플랜 키 */
  key: Scalars['String'];
  /** 약정 */
  lockInMonth?: Maybe<Scalars['Float']>;
  /** 대분류 */
  mainCategory: PlanMainCategory;
  /** 최소 구독 유지 기간 */
  minimumSubscriptionMonth?: Maybe<Scalars['Float']>;
  /** 플랜 이름 */
  name: Scalars['String'];
  /** 소분류 */
  planName: Scalars['String'];
  /** 유의 사항 목록 */
  precautionList: Array<Scalars['String']>;
  /** 가격 */
  price: Scalars['Float'];
  /** 중분류 */
  subCategory: PlanSubCategory;
};


/** 플랜 정보 */
export type PlanV2DetailNameArgs = {
  input: MultilingualTextInput;
};


/** 플랜 정보 */
export type PlanV2PlanNameArgs = {
  input: MultilingualTextInput;
};


/** 플랜 정보 */
export type PlanV2PrecautionListArgs = {
  input: MultilingualTextInput;
};

/** 내부 알림을 위한 플랜 정보 */
export type PlanV2Alarm = BasicPlanV2 & {
  __typename: 'PlanV2Alarm';
  /** 소분류 */
  detailCategory: Scalars['String'];
  /** 플랜 ID */
  id: Scalars['ID'];
  /** 대분류 */
  mainCategory: PlanMainCategory;
  /** 플랜 명 국제화 */
  name?: Maybe<Scalars['String']>;
  /** 가격 */
  price: Scalars['Float'];
  /** 중분류 */
  subCategory: PlanSubCategory;
};

/** 플랜 쿠폰 정보 */
export type PlanV2WithCoupon = BasicPlanV2 & {
  __typename: 'PlanV2WithCoupon';
  /** 쿠폰 ID */
  couponId?: Maybe<Scalars['String']>;
  /** 쿠폰 이름 */
  couponName?: Maybe<Scalars['String']>;
  /** 할인 가격 */
  deductedPrice: Scalars['Float'];
  /** 소분류 */
  detailCategory: Scalars['String'];
  /** 플랜 세부 이름 */
  detailName: Scalars['String'];
  /** 할인된 가격 */
  discountedPrice: Scalars['Float'];
  /** 종료일 */
  endAt: Scalars['String'];
  /** 플랜 ID */
  id: Scalars['ID'];
  /** 약정 */
  lockInMonth: Scalars['Float'];
  /** 대분류 */
  mainCategory: PlanMainCategory;
  /** 플랜명 */
  name: Scalars['String'];
  /** 국제화 플랜명 */
  planName: Scalars['String'];
  /** 가격 */
  price: Scalars['Float'];
  /** 시작일 */
  startAt: Scalars['String'];
  /** 중분류 */
  subCategory: PlanSubCategory;
};

/** 플랜, 플랜옵션 목록 */
export type PlanWithOption = {
  __typename: 'PlanWithOption';
  /** 플랜ID */
  id: Scalars['ID'];
  /** 플랜명 */
  planName: Scalars['String'];
  /** 플랜 옵션 정보 */
  planOptionInfo: PlanOption;
  /** 플랜 종류 */
  planType: Scalars['String'];
};

export enum Platform {
  APP = 'APP',
  WEB = 'WEB'
}

/** 팀 매치 이벤트 (개인) 데이터 input */
export type PlayerMatchEventData = {
  /** 공중볼 처리 성공률 */
  aerialActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 */
  aerialActions?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 성공 */
  aerialActionsWon?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공률 */
  aerialDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 */
  aerialDuels?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공 */
  aerialDuelsWon?: Maybe<Scalars['Float']>;
  /** 도움 */
  assists?: Maybe<Scalars['Float']>;
  /** 평균 속도 */
  averageSpeed?: Maybe<Scalars['Float']>;
  /** 백패스 성공률 */
  backPassAccuracy?: Maybe<Scalars['Float']>;
  /** 백패스 */
  backPasses?: Maybe<Scalars['Float']>;
  /** 블락된 슈팅 */
  blockedShots?: Maybe<Scalars['Float']>;
  /** 캐칭 */
  catches?: Maybe<Scalars['Float']>;
  /** 클리어 */
  clearances?: Maybe<Scalars['Float']>;
  /** 코너킥 */
  cornerKicks?: Maybe<Scalars['Float']>;
  /** 크로스 성공률 */
  crossAccuracy?: Maybe<Scalars['Float']>;
  /** 크로스 */
  crosses?: Maybe<Scalars['Float']>;
  /** 크로스 차단 */
  crossesBlocked?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 돌파 시도 */
  dribbleAttempts?: Maybe<Scalars['Float']>;
  /** 돌파 성공률 */
  dribbleSuccessRate?: Maybe<Scalars['Float']>;
  /** 전진 패스 성공률 */
  forwardPassAccuracy?: Maybe<Scalars['Float']>;
  /** 전진패스 */
  forwardPasses?: Maybe<Scalars['Float']>;
  /** 파울 */
  fouls?: Maybe<Scalars['Float']>;
  /** 피파울 */
  foulsSuffered?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 */
  freeKickCrosses?: Maybe<Scalars['Float']>;
  /** 프리킥 슈팅 */
  freeKickShots?: Maybe<Scalars['Float']>;
  /** 프리킥 유효 슈팅 */
  freeKickShotsOnTarget?: Maybe<Scalars['Float']>;
  /** 프리킥 */
  freeKicks?: Maybe<Scalars['Float']>;
  /** 골킥 */
  goalKicks?: Maybe<Scalars['Float']>;
  /** 득점 */
  goals?: Maybe<Scalars['Float']>;
  /** 실점 */
  goalsConceded?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공률 */
  groundActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 */
  groundActions?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공 */
  groundActionsWon?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공률 */
  groundDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 */
  groundDuels?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공 */
  groundDuelsWon?: Maybe<Scalars['Float']>;
  /** 핸드볼 파울 */
  handballFouls?: Maybe<Scalars['Float']>;
  /** 고강도 러닝 거리 비율 */
  highIntensityRunningRatio?: Maybe<Scalars['Float']>;
  /** 인터셉트 */
  interceptions?: Maybe<Scalars['Float']>;
  /** 키패스 */
  keyPasses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공률 */
  lateralPassAccuracy?: Maybe<Scalars['Float']>;
  /** 횡패스 */
  lateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리 패스 성공률 */
  longPassAccuracy?: Maybe<Scalars['Float']>;
  /** 장거리 패스 */
  longPasses?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공률 */
  looseBallDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 */
  looseBallDuels?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공 */
  looseBallDuelsWon?: Maybe<Scalars['Float']>;
  /** 중거리 패스 성공률 */
  mediumPassAccuracy?: Maybe<Scalars['Float']>;
  /** 중거리 패스 */
  mediumPasses?: Maybe<Scalars['Float']>;
  /** 출전 시간 */
  minutesPlayed?: Maybe<Scalars['Float']>;
  /** 볼미스 */
  miscontrols?: Maybe<Scalars['Float']>;
  /** 오프사이드 */
  offsides?: Maybe<Scalars['Float']>;
  /** 상대팀 */
  opponent: Scalars['String'];
  /** 자책골 */
  ownGoals?: Maybe<Scalars['Float']>;
  /** 패스성공률 */
  passAccuracy?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 성공률 */
  passAccuracyInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비지역 패스 성공률 */
  passAccuracyInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공률 */
  passAccuracyInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 */
  passes?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 */
  passesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 */
  passesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 */
  passesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 받음 */
  passesReceived?: Maybe<Scalars['Float']>;
  /** 페널티킥 허용 */
  penaltiesConceded?: Maybe<Scalars['Float']>;
  /** 페널티킥 획득 */
  penaltiesWon?: Maybe<Scalars['Float']>;
  /** 페널티킥 */
  penaltyKicks?: Maybe<Scalars['Float']>;
  /** 페널티킥 세이브 */
  penaltySaves?: Maybe<Scalars['Float']>;
  /** 선수 이름 */
  playerName: Scalars['String'];
  /** 포지션 */
  position?: Maybe<Scalars['String']>;
  /** 펀칭 */
  punches?: Maybe<Scalars['Float']>;
  /** 평점 */
  rating?: Maybe<Scalars['Float']>;
  /** 획득 */
  recoveries?: Maybe<Scalars['Float']>;
  /** 퇴장 */
  redCards?: Maybe<Scalars['Float']>;
  /** 세이브 */
  saves?: Maybe<Scalars['Float']>;
  /** 일정ID */
  scheduleId: Scalars['ID'];
  /** 세트피스 득점 */
  setPieceGoals?: Maybe<Scalars['Float']>;
  /** 세트피스 득점 허용 */
  setPieceGoalsConceded?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 */
  setPieceShots?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 허용 */
  setPieceShotsConceded?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공률 */
  shortPassAccuracy?: Maybe<Scalars['Float']>;
  /** 단거리 패스 */
  shortPasses?: Maybe<Scalars['Float']>;
  /** 유효슈팅률 */
  shotAccuracy?: Maybe<Scalars['Float']>;
  /** 슈팅 차단 */
  shotsBlocked?: Maybe<Scalars['Float']>;
  /** 박스 안 슈팅 */
  shotsInsideBox?: Maybe<Scalars['Float']>;
  /** 벗어난 슈팅 */
  shotsOffTarget?: Maybe<Scalars['Float']>;
  /** 유효슈팅 */
  shotsOnTarget?: Maybe<Scalars['Float']>;
  /** 박스 밖 슈팅 */
  shotsOutsideBox?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  sprintCount?: Maybe<Scalars['Float']>;
  /** 스프린트 총 거리 */
  sprintDistance?: Maybe<Scalars['Float']>;
  /** 스텝인 */
  stepIns?: Maybe<Scalars['Float']>;
  /** 백패스 성공 */
  successfulBackPasses?: Maybe<Scalars['Float']>;
  /** 크로스 성공 */
  successfulCrosses?: Maybe<Scalars['Float']>;
  /** 돌파 성공 */
  successfulDribbles?: Maybe<Scalars['Float']>;
  /** 전진패스 성공 */
  successfulForwardPasses?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 성공 */
  successfulFreeKickCrosses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공 */
  successfulLateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리패스 성공 */
  successfulLongPasses?: Maybe<Scalars['Float']>;
  /** 중거리패스 성공 */
  successfulMediumPasses?: Maybe<Scalars['Float']>;
  /** 패스 성공 */
  successfulPasses?: Maybe<Scalars['Float']>;
  /** 공격 지역 패스 성공 */
  successfulPassesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 성공 */
  successfulPassesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공 */
  successfulPassesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공 */
  successfulShortPasses?: Maybe<Scalars['Float']>;
  /** 태클 시도 */
  tackleAttempts?: Maybe<Scalars['Float']>;
  /** 태클 실패 */
  tacklesLost?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 미획득 */
  tacklesWonNoPossession?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 획득 */
  tacklesWonPossession?: Maybe<Scalars['Float']>;
  /** 스로인 파울 */
  throwInFouls?: Maybe<Scalars['Float']>;
  /** 스로인 */
  throwIns?: Maybe<Scalars['Float']>;
  /** 최고 속도 */
  topSpeed?: Maybe<Scalars['Float']>;
  /** 총 차단 */
  totalBlocks?: Maybe<Scalars['Float']>;
  /** 총 거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 전체 파울 */
  totalFouls?: Maybe<Scalars['Float']>;
  /** 전체 슈팅 */
  totalShots?: Maybe<Scalars['Float']>;
  /** 턴오버 허용 */
  turnoversConceded?: Maybe<Scalars['Float']>;
  /** 턴오버 획득 */
  turnoversWon?: Maybe<Scalars['Float']>;
  /** 유저ID */
  userId: Scalars['ID'];
  /** VHIR 횟수 */
  vhirCount?: Maybe<Scalars['Float']>;
  /** VHIR 총 거리 */
  vhirDistance?: Maybe<Scalars['Float']>;
  /** 경고 */
  yellowCards?: Maybe<Scalars['Float']>;
};

export enum PlayerMatchEventDataName {
  AERIAL_ACTIONS = 'AERIAL_ACTIONS',
  AERIAL_ACTIONS_WON = 'AERIAL_ACTIONS_WON',
  AERIAL_ACTION_SUCCESS_RATE = 'AERIAL_ACTION_SUCCESS_RATE',
  AERIAL_DUELS = 'AERIAL_DUELS',
  AERIAL_DUELS_WON = 'AERIAL_DUELS_WON',
  AERIAL_DUEL_SUCCESS_RATE = 'AERIAL_DUEL_SUCCESS_RATE',
  ASSISTS = 'ASSISTS',
  AVERAGE_SPEED = 'AVERAGE_SPEED',
  BACK_PASSES = 'BACK_PASSES',
  BACK_PASS_ACCURACY = 'BACK_PASS_ACCURACY',
  BLOCKED_SHOTS = 'BLOCKED_SHOTS',
  CATCHES = 'CATCHES',
  CLEARANCES = 'CLEARANCES',
  CORNER_KICKS = 'CORNER_KICKS',
  CROSSES = 'CROSSES',
  CROSSES_BLOCKED = 'CROSSES_BLOCKED',
  CROSS_ACCURACY = 'CROSS_ACCURACY',
  DATE = 'DATE',
  DRIBBLE_ATTEMPTS = 'DRIBBLE_ATTEMPTS',
  DRIBBLE_SUCCESS_RATE = 'DRIBBLE_SUCCESS_RATE',
  FORWARD_PASSES = 'FORWARD_PASSES',
  FORWARD_PASS_ACCURACY = 'FORWARD_PASS_ACCURACY',
  FOULS = 'FOULS',
  FOULS_SUFFERED = 'FOULS_SUFFERED',
  FREE_KICKS = 'FREE_KICKS',
  FREE_KICK_CROSSES = 'FREE_KICK_CROSSES',
  FREE_KICK_SHOTS = 'FREE_KICK_SHOTS',
  FREE_KICK_SHOTS_ON_TARGET = 'FREE_KICK_SHOTS_ON_TARGET',
  GOALS = 'GOALS',
  GOALS_CONCEDED = 'GOALS_CONCEDED',
  GOAL_KICKS = 'GOAL_KICKS',
  GROUND_ACTIONS = 'GROUND_ACTIONS',
  GROUND_ACTIONS_WON = 'GROUND_ACTIONS_WON',
  GROUND_ACTION_SUCCESS_RATE = 'GROUND_ACTION_SUCCESS_RATE',
  GROUND_DUELS = 'GROUND_DUELS',
  GROUND_DUELS_WON = 'GROUND_DUELS_WON',
  GROUND_DUEL_SUCCESS_RATE = 'GROUND_DUEL_SUCCESS_RATE',
  HANDBALL_FOULS = 'HANDBALL_FOULS',
  HIGH_INTENSITY_RUNNING_RATIO = 'HIGH_INTENSITY_RUNNING_RATIO',
  INTERCEPTIONS = 'INTERCEPTIONS',
  KEY_PASSES = 'KEY_PASSES',
  LATERAL_PASSES = 'LATERAL_PASSES',
  LATERAL_PASS_ACCURACY = 'LATERAL_PASS_ACCURACY',
  LONG_PASSES = 'LONG_PASSES',
  LONG_PASS_ACCURACY = 'LONG_PASS_ACCURACY',
  LOOSE_BALL_DUELS = 'LOOSE_BALL_DUELS',
  LOOSE_BALL_DUELS_WON = 'LOOSE_BALL_DUELS_WON',
  LOOSE_BALL_DUEL_SUCCESS_RATE = 'LOOSE_BALL_DUEL_SUCCESS_RATE',
  MEDIUM_PASSES = 'MEDIUM_PASSES',
  MEDIUM_PASS_ACCURACY = 'MEDIUM_PASS_ACCURACY',
  MINUTES_PLAYED = 'MINUTES_PLAYED',
  MISCONTROLS = 'MISCONTROLS',
  OFFSIDES = 'OFFSIDES',
  OPPONENT = 'OPPONENT',
  OWN_GOALS = 'OWN_GOALS',
  PASSES = 'PASSES',
  PASSES_IN_ATTACKING_THIRD = 'PASSES_IN_ATTACKING_THIRD',
  PASSES_IN_DEFENSIVE_THIRD = 'PASSES_IN_DEFENSIVE_THIRD',
  PASSES_IN_MIDDLE_THIRD = 'PASSES_IN_MIDDLE_THIRD',
  PASSES_RECEIVED = 'PASSES_RECEIVED',
  PASS_ACCURACY = 'PASS_ACCURACY',
  PASS_ACCURACY_IN_ATTACKING_THIRD = 'PASS_ACCURACY_IN_ATTACKING_THIRD',
  PASS_ACCURACY_IN_DEFENSIVE_THIRD = 'PASS_ACCURACY_IN_DEFENSIVE_THIRD',
  PASS_ACCURACY_IN_MIDDLE_THIRD = 'PASS_ACCURACY_IN_MIDDLE_THIRD',
  PENALTIES_CONCEDED = 'PENALTIES_CONCEDED',
  PENALTIES_WON = 'PENALTIES_WON',
  PENALTY_KICKS = 'PENALTY_KICKS',
  PENALTY_SAVES = 'PENALTY_SAVES',
  PLAYER_NAME = 'PLAYER_NAME',
  POSITION = 'POSITION',
  PUNCHES = 'PUNCHES',
  RATING = 'RATING',
  RECOVERIES = 'RECOVERIES',
  RED_CARDS = 'RED_CARDS',
  SAVES = 'SAVES',
  SET_PIECE_GOALS = 'SET_PIECE_GOALS',
  SET_PIECE_GOALS_CONCEDED = 'SET_PIECE_GOALS_CONCEDED',
  SET_PIECE_SHOTS = 'SET_PIECE_SHOTS',
  SET_PIECE_SHOTS_CONCEDED = 'SET_PIECE_SHOTS_CONCEDED',
  SHORT_PASSES = 'SHORT_PASSES',
  SHORT_PASS_ACCURACY = 'SHORT_PASS_ACCURACY',
  SHOTS_BLOCKED = 'SHOTS_BLOCKED',
  SHOTS_INSIDE_BOX = 'SHOTS_INSIDE_BOX',
  SHOTS_OFF_TARGET = 'SHOTS_OFF_TARGET',
  SHOTS_ON_TARGET = 'SHOTS_ON_TARGET',
  SHOTS_OUTSIDE_BOX = 'SHOTS_OUTSIDE_BOX',
  SHOT_ACCURACY = 'SHOT_ACCURACY',
  SPRINT_COUNT = 'SPRINT_COUNT',
  SPRINT_DISTANCE = 'SPRINT_DISTANCE',
  STEP_INS = 'STEP_INS',
  SUCCESSFUL_BACK_PASSES = 'SUCCESSFUL_BACK_PASSES',
  SUCCESSFUL_CROSSES = 'SUCCESSFUL_CROSSES',
  SUCCESSFUL_DRIBBLES = 'SUCCESSFUL_DRIBBLES',
  SUCCESSFUL_FORWARD_PASSES = 'SUCCESSFUL_FORWARD_PASSES',
  SUCCESSFUL_FREE_KICK_CROSSES = 'SUCCESSFUL_FREE_KICK_CROSSES',
  SUCCESSFUL_LATERAL_PASSES = 'SUCCESSFUL_LATERAL_PASSES',
  SUCCESSFUL_LONG_PASSES = 'SUCCESSFUL_LONG_PASSES',
  SUCCESSFUL_MEDIUM_PASSES = 'SUCCESSFUL_MEDIUM_PASSES',
  SUCCESSFUL_PASSES = 'SUCCESSFUL_PASSES',
  SUCCESSFUL_PASSES_IN_ATTACKING_THIRD = 'SUCCESSFUL_PASSES_IN_ATTACKING_THIRD',
  SUCCESSFUL_PASSES_IN_DEFENSIVE_THIRD = 'SUCCESSFUL_PASSES_IN_DEFENSIVE_THIRD',
  SUCCESSFUL_PASSES_IN_MIDDLE_THIRD = 'SUCCESSFUL_PASSES_IN_MIDDLE_THIRD',
  SUCCESSFUL_SHORT_PASSES = 'SUCCESSFUL_SHORT_PASSES',
  TACKLES_LOST = 'TACKLES_LOST',
  TACKLES_WON_NO_POSSESSION = 'TACKLES_WON_NO_POSSESSION',
  TACKLES_WON_POSSESSION = 'TACKLES_WON_POSSESSION',
  TACKLE_ATTEMPTS = 'TACKLE_ATTEMPTS',
  THROW_INS = 'THROW_INS',
  THROW_IN_FOULS = 'THROW_IN_FOULS',
  TOP_SPEED = 'TOP_SPEED',
  TOTAL_BLOCKS = 'TOTAL_BLOCKS',
  TOTAL_DISTANCE = 'TOTAL_DISTANCE',
  TOTAL_FOULS = 'TOTAL_FOULS',
  TOTAL_SHOTS = 'TOTAL_SHOTS',
  TURNOVERS_CONCEDED = 'TURNOVERS_CONCEDED',
  TURNOVERS_WON = 'TURNOVERS_WON',
  VHIR_COUNT = 'VHIR_COUNT',
  VHIR_DISTANCE = 'VHIR_DISTANCE',
  YELLOW_CARDS = 'YELLOW_CARDS'
}

/** 선수 일정 정보 */
export type PlayerSchedule = {
  __typename: 'PlayerSchedule';
  /** 일정 목록 */
  scheduleList: Array<ScheduleInvitee>;
  /** 다가올 일정 목록 */
  upcomingScheduleList: Array<ScheduleInvitee>;
  /** 유저 정보 */
  user: SportsUser;
};


/** 선수 일정 정보 */
export type PlayerScheduleScheduleListArgs = {
  from: Scalars['DateTime'];
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


/** 선수 일정 정보 */
export type PlayerScheduleUpcomingScheduleListArgs = {
  from: Scalars['DateTime'];
};

/** 팝업 정보 */
export type Popup = {
  __typename: 'Popup';
  /** 생성일 */
  createdAt: Scalars['Date'];
  /** 성별 목록 */
  genderList: Array<GenderType>;
  /** 팝업ID */
  id: Scalars['ID'];
  /** 이미지 Url */
  imageUrl: Scalars['String'];
  /** 오늘 하루 보지 않기 버튼 여부 */
  isTodayHidden: Scalars['Boolean'];
  /** 연결 url */
  landingUrl?: Maybe<Scalars['String']>;
  /** 언어 목록 */
  languageList: Array<Language>;
  /** 최대나이 */
  maxAge?: Maybe<Scalars['Float']>;
  /** 최소나이 */
  minAge?: Maybe<Scalars['Float']>;
  /** os종류 목록 */
  osTypeList: Array<OsType>;
  /** 게시 종료일 */
  publishEndAt?: Maybe<Scalars['Date']>;
  /** 게시 시작일 */
  publishStartAt: Scalars['Date'];
  /** 게시 상태 */
  publishStatus?: Maybe<PopupPublishStatus>;
  /** 팝업 제목 */
  title: Scalars['String'];
};

export enum PopupPublishStatus {
  PUBLISHED = 'PUBLISHED',
  RESERVATION = 'RESERVATION'
}

export enum PreferredFootType {
  BOTH = 'BOTH',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export enum ProductCode {
  ALMOND_CACAO = 'ALMOND_CACAO',
  GRAIN = 'GRAIN',
  RANDOM = 'RANDOM',
  SWEET_POTATO = 'SWEET_POTATO'
}

/** 스카우팅 선수 */
export type ProspectPlayer = {
  __typename: 'ProspectPlayer';
  /** 에이전트/소속사 */
  agent?: Maybe<Scalars['String']>;
  /** 수상 이력 목록 */
  awardHistoryList: Array<AwardHistory>;
  /** 생년월일 */
  birthDate: Scalars['String'];
  /** 코멘트 목록 */
  commentList: Array<Comment>;
  /** 생성한 스카우터 */
  createUserId: Scalars['String'];
  /** 기타 사항 */
  etc?: Maybe<Scalars['String']>;
  /** 적합도 평균 */
  fitAvg?: Maybe<Scalars['Float']>;
  /** 키 */
  height?: Maybe<Scalars['Float']>;
  /** ID */
  id: Scalars['ID'];
  /** 부상 이력 목록 */
  injuryHistoryList: Array<InjuryHistory>;
  /** 만 나이 */
  internationalAge: Scalars['Float'];
  /** 이름 */
  name: Scalars['String'];
  /** 국적 */
  nationalityMultilingualInfo?: Maybe<MultilingualCountry>;
  /** 관찰 리포트 목록 */
  observationReportList: Array<ObservationReport>;
  /** 관찰 상태 */
  observationStatus: ObservationStatusType;
  /** 포지션 목록 */
  positionList: Array<ProspectPlayerPositionType>;
  /** 주발 */
  preferredFoot?: Maybe<PreferredFootType>;
  /** 프로필 이미지 링크 */
  profileImageLink?: Maybe<Scalars['String']>;
  /** 소셜 미디어 목록 */
  socialMediaList: Array<SocialMedia>;
  /** 팀 소속 이력 목록 */
  teamHistoryList: Array<TeamHistory>;
  /** 팀 ID */
  teamId: Scalars['String'];
  /** 몸무게 */
  weight?: Maybe<Scalars['Float']>;
};


/** 스카우팅 선수 */
export type ProspectPlayerNationalityMultilingualInfoArgs = {
  input: MultilingualTextInput;
};

export enum ProspectPlayerPositionType {
  AM = 'AM',
  CB = 'CB',
  CF = 'CF',
  CM = 'CM',
  DM = 'DM',
  GK = 'GK',
  LB = 'LB',
  LM = 'LM',
  LW = 'LW',
  RB = 'RB',
  RM = 'RM',
  RW = 'RW',
  SS = 'SS'
}

/** 자격 정보 */
export type Qualification = {
  __typename: 'Qualification';
  /** 자격ID */
  id: Scalars['ID'];
  /** 자격 만료 여부 */
  isExpired: Scalars['Boolean'];
  /** 자격 종류 */
  qualificationType: QualificationType;
};

export enum QualificationType {
  LICENSE = 'LICENSE',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export type Query = {
  __typename: 'Query';
  /** 배너 조회 */
  banner: Banner;
  /** 배너 목록 조회 */
  bannerList: Array<Banner>;
  /** 빌링정보 조회 */
  billing?: Maybe<Billing>;
  /** 서버 접근 가능여부 (코치 서비스 점검 on/off 에서 사용) */
  checkServerInspection: AccessAuthorization;
  /** 쿠폰 조회 */
  coupon: CouponDetail;
  /** 쿠폰 할인 가격 조회 */
  couponAppliedPrice: CouponApplied;
  /** 팀 쿠폰 지급 확인 */
  couponIsGivenTeamList: CouponIsGivenTeamList;
  /** 유저 쿠폰 지급 확인 */
  couponIsGivenUserList: CouponIsGivenUserList;
  /** 쿠폰 목록 조회 */
  couponList: CouponListByPage;
  /** 팀 쿠폰 목록 조회 */
  couponListByTeam: CouponListByTeam;
  /** 피드백 */
  feedback: Feedback;
  /** 파일 조회 */
  findFile: FileEntity;
  /** 플레이어 플랜 목록 조회 */
  getPlayerPlanList: Array<PlanV2>;
  /** 쿠폰 적용된 플랜 정보 조회 */
  getPlayerPlanWithCoupon: PlanV2WithCoupon;
  /** 그룹별 팝업 조회 */
  groupingPopup: GroupingPopup;
  /** 팀 이익이 가장 큰 쿠폰 조회 */
  highestBenefitCouponByTeam?: Maybe<CouponSimple>;
  /** 인보이스 목록 페이징 */
  invoicesByPage: InvoiceList;
  /** 라이센스 조회 */
  licenseById: License;
  /** 팀 라이센스 조회 */
  licenseByTeam?: Maybe<License>;
  /** 라이센스 목록 페이징 조회 */
  licenseListByPage: LicenseListByPage;
  multilingualText: MultilingualTextQuery;
  /** 피지컬 솔루션 페이징 목록 */
  physicalSolutionByPage: PhysicalSolutionByPage;
  /** 팝업 조회 */
  popup: Popup;
  /** 팝업 목록 조회 */
  popupList: Array<Popup>;
  /** 자격 조회 */
  qualification: Qualification;
  /** 나의 할일 조회 */
  routine?: Maybe<Routine>;
  /** 나의 할일 목록 조회 */
  routineList?: Maybe<Array<Routine>>;
  /** 일정 조회 (코치용) */
  scheduleForCoach: Schedule;
  /** 선수가 초대된 일정 조회 */
  scheduleForPlayer: ScheduleInvitee;
  /** 일정 목록 조회 (코치용) */
  scheduleListForCoach: Array<Schedule>;
  /** 서비스 메타 정보 */
  serviceMeta: ServiceMeta;
  sports: SportsQuery;
  /** 팀 미체크 알림 발송스케줄 페이징 목록 */
  teamCheckReminderScheduleByPage: TeamCheckReminderScheduleByPage;
  /** 팀 플랜 목록 */
  teamPlanList: Array<Plan>;
  /** 팀 구독 조회 */
  teamSubscriptionItem?: Maybe<SubscriptionItem>;
  /** 전체 배너 목록 조회 */
  totalBannerList: Array<Banner>;
};


export type QueryBannerArgs = {
  id: Scalars['ID'];
};


export type QueryBannerListArgs = {
  language: Language;
  nowDate: Scalars['Date'];
};


export type QueryBillingArgs = {
  identityToken: Scalars['ID'];
};


export type QueryCouponArgs = {
  id: Scalars['ID'];
};


export type QueryCouponAppliedPriceArgs = {
  input: GetCouponAppliedPriceInput;
};


export type QueryCouponIsGivenTeamListArgs = {
  id: Scalars['ID'];
  input: CheckIsGivenTeamsInput;
};


export type QueryCouponIsGivenUserListArgs = {
  id: Scalars['ID'];
  input: CheckIsGivenUserListInput;
};


export type QueryCouponListArgs = {
  isActivated: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  search?: Maybe<Scalars['String']>;
};


export type QueryCouponListByTeamArgs = {
  teamId: Scalars['ID'];
};


export type QueryFeedbackArgs = {
  id: Scalars['ID'];
};


export type QueryFindFileArgs = {
  id: Scalars['ID'];
};


export type QueryGetPlayerPlanWithCouponArgs = {
  couponId?: Maybe<Scalars['String']>;
  highestBenefit?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  input: MultilingualTextInput;
  timezone?: Maybe<Scalars['String']>;
};


export type QueryGroupingPopupArgs = {
  language: Language;
  nowDate: Scalars['Date'];
  osType: OsType;
};


export type QueryHighestBenefitCouponByTeamArgs = {
  originalPrice: Scalars['Float'];
  teamId: Scalars['ID'];
};


export type QueryInvoicesByPageArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  subscriptionId: Scalars['ID'];
};


export type QueryLicenseByIdArgs = {
  licenseId: Scalars['ID'];
};


export type QueryLicenseByTeamArgs = {
  teamId: Scalars['ID'];
};


export type QueryLicenseListByPageArgs = {
  isActivate?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
};


export type QueryMultilingualTextArgs = {
  input: MultilingualTextInput;
};


export type QueryPhysicalSolutionByPageArgs = {
  isSolution?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
};


export type QueryPopupArgs = {
  id: Scalars['ID'];
};


export type QueryPopupListArgs = {
  isExpired?: Maybe<Scalars['Boolean']>;
};


export type QueryQualificationArgs = {
  teamId: Scalars['ID'];
};


export type QueryRoutineArgs = {
  routineId: Scalars['ID'];
};


export type QueryRoutineListArgs = {
  cursor?: Maybe<Scalars['DateTime']>;
  timezone?: Maybe<Scalars['String']>;
};


export type QueryScheduleForCoachArgs = {
  id: Scalars['ID'];
};


export type QueryScheduleForPlayerArgs = {
  id: Scalars['ID'];
};


export type QueryScheduleListForCoachArgs = {
  input: GetCoachScheduleInput;
  teamId: Scalars['ID'];
};


export type QueryServiceMetaArgs = {
  appId: Scalars['String'];
  os: OsType;
  since: Scalars['String'];
};


export type QueryTeamCheckReminderScheduleByPageArgs = {
  filter?: Maybe<TeamCheckReminderScheduleFilter>;
  limit?: Scalars['Float'];
  offset?: Scalars['Float'];
  searchTerm?: Maybe<Scalars['String']>;
};


export type QueryTeamPlanListArgs = {
  couponId?: Maybe<Scalars['String']>;
};


export type QueryTeamSubscriptionItemArgs = {
  teamId: Scalars['ID'];
};


export type QueryTotalBannerListArgs = {
  isExpired?: Maybe<Scalars['Boolean']>;
  nowDate: Scalars['Date'];
};

export enum QueryOperation {
  eq = 'eq',
  ilike = 'ilike',
  in = 'in'
}

/** raw 데이터 커서 정보 */
export type RawDataByCursor = {
  __typename: 'RawDataByCursor';
  /** 커서 */
  cursor: Scalars['Date'];
  /** raw 데이터 */
  entries: Array<RawDataEntry>;
  /** raw 데이터명 목록 */
  names: Array<SportsRawDataName>;
  /** 다음 데이터 커서 */
  nextCursor: Scalars['Date'];
  /** 데이터 범위 */
  stride: SportsDataStride;
  /** 타임존 */
  timezone: Scalars['String'];
};

export type RawDataEntry = SportsRawBody | SportsRawCondition | SportsRawInjury | SportsRawSleep | SportsRawWellness | SportsRawWorkload;

/** 환불 input */
export type Refund = {
  /** 금액 */
  amount?: Maybe<Scalars['Float']>;
  /** 아임포트 결제ID */
  impUid: Scalars['String'];
  /** 사유 */
  reason?: Maybe<Scalars['String']>;
};

/** 환불 인보이스 */
export type RefundInvoice = Invoice & {
  __typename: 'RefundInvoice';
  /** 결제 유저 이메일 */
  billingUserEmail: Scalars['String'];
  /** 결제 유저 이름 */
  billingUserName: Scalars['String'];
  /** 결제 유저 전화번호 */
  billingUserPhone: Scalars['String'];
  /** 카드명 */
  cardName: Scalars['String'];
  /** 카드번호 */
  cardNumber: Scalars['String'];
  /** 결제ID */
  id: Scalars['ID'];
  /** 결제명 */
  paymentName: Scalars['String'];
  /** 결제 상태 */
  paymentStatus: PaymentStatus;
  /** 영수증 url */
  receiptUrl?: Maybe<Scalars['String']>;
  /** 환불 금액 */
  refundAmount: Scalars['Float'];
  /** 환불일 */
  refundAt: Scalars['String'];
};

/** 환불 응답 */
export type RefundResponse = {
  __typename: 'RefundResponse';
  /** 이유 */
  reason?: Maybe<Scalars['String']>;
  /** 환불 성공 여부 */
  success: Scalars['Boolean'];
};

export type RefundSubscriptionInput = {
  subscriptionId: Scalars['ID'];
};

export type Region = {
  __typename: 'Region';
  defaultLanguage?: Maybe<Scalars['String']>;
  defaultUTCOffset?: Maybe<Scalars['Int']>;
  id?: Maybe<CountryCode>;
};

export enum ReminderPushMessageType {
  CONDITION = 'CONDITION',
  EVENT_WORKLOAD = 'EVENT_WORKLOAD',
  SCHEDULE_WORKLOAD = 'SCHEDULE_WORKLOAD',
  WORKLOAD = 'WORKLOAD'
}

/** 라이센스 옵저버 제거 input */
export type RemoveLicenseObserver = {
  /** 라이센스ID */
  licenseId: Scalars['ID'];
  /** 유저ID */
  userId: Scalars['ID'];
};

/** 라이센스 팀 제거 input */
export type RemoveLicenseTeamInput = {
  /** 라이센스ID */
  licenseId: Scalars['ID'];
  /** 팀ID */
  teamId: Scalars['ID'];
};

export enum ReopenStatus {
  DO_NOT_REOPEN = 'DO_NOT_REOPEN',
  REOPEN = 'REOPEN'
}

export enum ReportFileType {
  IMAGE = 'IMAGE',
  PDF = 'PDF'
}

/** 리포트 요약 */
export type ReportSummery = {
  __typename: 'ReportSummery';
  /** 측정날짜 */
  date: Scalars['String'];
  /** 플레이어 수 */
  playerCount: Scalars['Float'];
  /** 회차 */
  round: Scalars['Float'];
};

export enum ReportType {
  COORDINATING_DAILY = 'COORDINATING_DAILY',
  COORDINATING_WEEKLY = 'COORDINATING_WEEKLY',
  EVENT_MATCH = 'EVENT_MATCH',
  EVENT_TRAINING = 'EVENT_TRAINING'
}

/** 빌링 토큰 요청 input */
export type RequestBillingTokenInput = {
  /** 결제 팀 ID */
  identityToken: Scalars['ID'];
};

/** 구독 재시작 input */
export type RestartSubscriptionInput = {
  /** 이메일 */
  buyerEmail: Scalars['String'];
  /** 이름 */
  buyerName: Scalars['String'];
  /** 전화번호 */
  buyerTel: Scalars['String'];
  /** 쿠폰ID */
  couponId?: Maybe<Scalars['ID']>;
  /** 플랜ID */
  planId: Scalars['ID'];
  /** 플랜 옵션 ID */
  planOptionId: Scalars['ID'];
  /** 구독ID */
  subscriptionId?: Maybe<Scalars['ID']>;
  /** 팀ID */
  teamId: Scalars['ID'];
};

/** 재구독 input */
export type ResumeSubscriptionInput = {
  /** 구독ID */
  subscriptionId: Scalars['ID'];
  /** 팀ID */
  teamId: Scalars['ID'];
};

/** 결제 재시도 input */
export type RetryPayment = {
  /** 구독ID */
  subscriptionId: Scalars['ID'];
};

/** 복귀 정보 */
export type Return = {
  __typename: 'Return';
  /** 날짜 */
  date: Scalars['String'];
  /** 정보 */
  info?: Maybe<Scalars['String']>;
  /** 상태 */
  status: InjuryReturnStatus;
};

/** 부상 복귀 input */
export type ReturnInput = {
  /** 날짜 */
  date: Scalars['DateTime'];
  /** 최대 100자 */
  info?: Maybe<Scalars['String']>;
  /** 부상 상태 */
  status: InjuryReturnStatus;
};

/** 부상 위험 유저 */
export type RiskAtInjuryUser = {
  __typename: 'RiskAtInjuryUser';
  /** 제안 종류 */
  analysisType: UserWorkloadSuggestionDataType;
  /** 유형 */
  label: UserWorkloadRiskAtInjuryLabelType;
  /** 부상 위험 이유 목록 */
  reasonList: Array<UserWorkloadRiskAtInjuryReasonType>;
  /** 유저 정보 */
  user: SportsUser;
};

/** 나의 할일 정보 */
export type Routine = {
  __typename: 'Routine';
  /** 나의 할 일 체크 */
  activity?: Maybe<RoutineActivity>;
  /** 나의 할일 ID */
  id: Scalars['ID'];
  /** 나의 할 일 알림 스케줄 */
  schedule?: Maybe<RoutineSchedule>;
  /** 제목 */
  title: Scalars['String'];
};

/** 나의 할일 체크 */
export type RoutineActivity = {
  __typename: 'RoutineActivity';
  /** 완료 여부 */
  hasCompleted: Scalars['Boolean'];
  /** 체크 시간 */
  lastCompletedAt?: Maybe<Scalars['Date']>;
};

export enum RoutineActivityStatus {
  DONE = 'DONE',
  UNDONE = 'UNDONE'
}

/** 나의 할일 알림 스케줄 */
export type RoutineSchedule = {
  __typename: 'RoutineSchedule';
  /** 알림 시간 */
  alertAt: Scalars['String'];
  /** 알림 요일 */
  dayNums: Array<Scalars['Int']>;
  /** 나의 할일 알림 스케줄 ID */
  id: Scalars['ID'];
  /** 알림 보낼지 여부 */
  isAlertEnabled: Scalars['Boolean'];
};

/** 나의 할 일 체크 응답 */
export type RoutineToggle = {
  __typename: 'RoutineToggle';
  res: Scalars['Boolean'];
};

/** 운동 만족 유저 */
export type SatisfactionUser = {
  __typename: 'SatisfactionUser';
  /** 운동 만족도 */
  satisfaction: Scalars['Float'];
  /** 유저 정보 */
  user: SportsUser;
};

/** 만족 유저 ID */
export type SatisfactionUserId = {
  __typename: 'SatisfactionUserId';
  /** 만족 */
  satisfaction: Scalars['Float'];
  /** 유저ID */
  userId: Scalars['ID'];
};

/** 팀 매치 이벤트 (개인) 데이터 저장 input */
export type SavePlayerMatchEventData = {
  /** 팀ID */
  teamId: Scalars['ID'];
  /** 팀 매치 이벤트 (개인) 데이터 목록 */
  userDataList: Array<PlayerMatchEventData>;
};

/** 팀 gps 데이터 저장 input */
export type SaveTeamGpsData = {
  /** 팀ID */
  teamId: Scalars['ID'];
  /** gps 유저 데이터 목록 */
  userDataList: Array<GpsUserData>;
};

/** 팀 매치 이벤트 (팀) 데이터 저장 input */
export type SaveTeamMatchEventData = {
  /** 팀 매치 이벤트 (팀) 데이터 목록 */
  teamDataList: Array<TeamMatchEventData>;
  teamId: Scalars['ID'];
};

/** 팀 피지컬 데이터 저장 input */
export type SaveTeamPhysicalData = {
  /** 팀ID */
  teamId: Scalars['ID'];
  /** 피지컬 유저 데이터 목록 */
  userDataList: Array<PhysicalUserData>;
};

export type Schedule = {
  /** 상세 종류 */
  detailType: ScheduleDetailType;
  /** 종료시간 */
  endTime?: Maybe<Scalars['Time']>;
  /** 목표 강도 */
  expectedIntensity?: Maybe<Scalars['Int']>;
  /** 목표 운동 부하 */
  expectedWorkload?: Maybe<Scalars['Int']>;
  /** 첨부 파일 목록 */
  fileList?: Maybe<Array<ScheduleFile>>;
  /** 일정ID */
  id: Scalars['ID'];
  /** 삭제 여부 */
  isDeleted: Scalars['Boolean'];
  /** 선수 공지 유무 */
  isPlayerNotice: Scalars['Boolean'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 공지 */
  notice?: Maybe<Scalars['String']>;
  /** 일정 일자 */
  scheduleDate: Scalars['String'];
  /** 일정 초대자 */
  scheduleInviteeList: Array<ScheduleInvitee>;
  /** 시작시간 */
  startTime?: Maybe<Scalars['Time']>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 제목 */
  title?: Maybe<Scalars['String']>;
  /** 훈련 포인트 */
  trainingPoint?: Maybe<Scalars['String']>;
  /** 종류 */
  type: ScheduleType;
};

/** 일정 알림 */
export type ScheduleAlarm = Alarm & {
  __typename: 'ScheduleAlarm';
  /** 알람 생성 유저 정보 */
  createUser: SportsUser;
  /** 생성일 */
  createdAt: Scalars['DateTime'];
  /** 알림 ID */
  id: Scalars['ID'];
  /** 알림 읽음 여부 */
  isChecked: Scalars['Boolean'];
  /** 학부모 정보 */
  parent?: Maybe<SportsUser>;
  /** 플랜 정보 */
  plan?: Maybe<PlanV2Alarm>;
  /** 선수 정보 */
  player?: Maybe<SportsUser>;
  /** 일정 정보 */
  schedule: Schedule;
  /** 일정 개수 */
  scheduleCount?: Maybe<Scalars['Float']>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 알림 종류 */
  type: AlarmType;
};


/** 일정 알림 */
export type ScheduleAlarmPlanArgs = {
  input: MultilingualTextInput;
};

/** 일정 생성 input */
export type ScheduleCreateInput = {
  /** 상대팀 */
  competition?: Maybe<Scalars['String']>;
  /** 종류 상세 */
  detailType: ScheduleDetailType;
  /** 종료시간 */
  endTime?: Maybe<Scalars['Time']>;
  /** 목표 강도 */
  expectedIntensity?: Maybe<Scalars['Int']>;
  /** 선수 공지 유무 */
  isPlayerNotice: Scalars['Boolean'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 공지사항 */
  notice?: Maybe<Scalars['String']>;
  /** 일정 날짜 목록 */
  scheduleDateList: Array<Scalars['DateTime']>;
  /** 일정 초대자 목록 */
  scheduleInviteIdentityList: Array<ScheduleInviteIdentityInput>;
  /** 시작시간 */
  startTime?: Maybe<Scalars['Time']>;
  /** 타임존 */
  timezone: Scalars['String'];
  /** 제목 */
  title?: Maybe<Scalars['String']>;
  /** 종류 */
  type: ScheduleType;
  /** 경기 장소 */
  venue?: Maybe<Venue>;
};

export enum ScheduleDetailType {
  COACH_SCHEDULE = 'COACH_SCHEDULE',
  COMPETITION_MATCH = 'COMPETITION_MATCH',
  ETC = 'ETC',
  FRIENDLY_MATCH = 'FRIENDLY_MATCH',
  GROUP_TRAINING = 'GROUP_TRAINING',
  INDIV_TRAINING = 'INDIV_TRAINING',
  LEAGUE_MATCH = 'LEAGUE_MATCH',
  PRACTICE_MATCH = 'PRACTICE_MATCH',
  REST = 'REST',
  TEAM_TRAINING = 'TEAM_TRAINING'
}

/** 일정 파일 정보 */
export type ScheduleFile = {
  __typename: 'ScheduleFile';
  /** 일정 파일 ID */
  id?: Maybe<Scalars['String']>;
  /** 일정 파일명 */
  name: Scalars['String'];
  /** 썸네일 url */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** 첨부된 파일 url */
  url: Scalars['String'];
};

/** 나의 할 일 알림 스케줄 input */
export type ScheduleInput = {
  /** 알림 시간 */
  alertAt: Scalars['String'];
  /** 알림 요일 */
  dayNums: Array<Scalars['Int']>;
  /** 알림 보낼지 여부 */
  isAlertEnabled: Scalars['Boolean'];
};

/** 일정 초대자 input */
export type ScheduleInviteIdentityInput = {
  /** 유저ID */
  id: Scalars['ID'];
};

export type ScheduleInvitee = {
  /** 불참사유 */
  absenceReason?: Maybe<Scalars['String']>;
  /** 참여 체크 여부 */
  hasChecked: Scalars['Boolean'];
  /** 일정 초대자 ID */
  id: Scalars['ID'];
  /** 일정 정보 */
  schedule?: Maybe<Schedule>;
  /** 일정 초대자 상태 */
  status?: Maybe<ScheduleInviteeStatus>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** the player who is invited to this schedule */
  user?: Maybe<SportsUser>;
  /** 운동부하 종류 */
  workoutType: WorkoutType;
};


export type ScheduleInviteeScheduleArgs = {
  teamId?: Maybe<Scalars['ID']>;
};

export enum ScheduleInviteeStatus {
  ABSENCE_ETC = 'ABSENCE_ETC',
  ABSENCE_INJURY = 'ABSENCE_INJURY',
  NOT_CHECK = 'NOT_CHECK',
  PARTICIPATION = 'PARTICIPATION'
}

export enum ScheduleReportType {
  MATCH = 'MATCH',
  TRAINING = 'TRAINING'
}

export enum ScheduleType {
  ETC = 'ETC',
  MATCH = 'MATCH',
  TRAINING = 'TRAINING'
}

/** 일정 수정 input */
export type ScheduleUpdateInput = {
  /** 종류 상세 */
  detailType: ScheduleDetailType;
  /** 종료시간 */
  endTime?: Maybe<Scalars['Time']>;
  /** 목표 강도 */
  expectedIntensity?: Maybe<Scalars['Int']>;
  /** 공지 여부 */
  isPlayerNotice: Scalars['Boolean'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 공지사항 */
  notice?: Maybe<Scalars['String']>;
  /** 일정 초대자 목록 */
  scheduleInviteIdentityList: Array<ScheduleInviteIdentityInput>;
  /** 시작시간 */
  startTime?: Maybe<Scalars['Time']>;
  /** 타임존 */
  timezone: Scalars['String'];
  /** 제목 */
  title?: Maybe<Scalars['String']>;
  /** 종류 */
  type: ScheduleType;
  /** 경기 장소 */
  venue?: Maybe<Venue>;
};

/** 일정 운동부하 변경 알림 */
export type ScheduleWorkloadUpdateAlarm = Alarm & {
  __typename: 'ScheduleWorkloadUpdateAlarm';
  /** 알람 생성 유저 정보 */
  createUser: SportsUser;
  /** 생성일 */
  createdAt: Scalars['DateTime'];
  /** 알림 ID */
  id: Scalars['ID'];
  /** 알림 읽음 여부 */
  isChecked: Scalars['Boolean'];
  /** 학부모 정보 */
  parent?: Maybe<SportsUser>;
  /** 플랜 정보 */
  plan?: Maybe<PlanV2Alarm>;
  /** 선수 정보 */
  player?: Maybe<SportsUser>;
  /** 일정 정보 */
  schedule: Schedule;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 알림 종류 */
  type: AlarmType;
};


/** 일정 운동부하 변경 알림 */
export type ScheduleWorkloadUpdateAlarmPlanArgs = {
  input: MultilingualTextInput;
};

export enum ScoutingAuthorityType {
  SCOUTING_ADMIN = 'SCOUTING_ADMIN',
  SCOUTING_SCOUTER = 'SCOUTING_SCOUTER',
  SCOUTING_SUPER_ADMIN = 'SCOUTING_SUPER_ADMIN'
}

/** 스카우팅 모델 */
export type ScoutingModel = {
  __typename: 'ScoutingModel';
  /** ID */
  id: Scalars['ID'];
  /** 심리 기준 */
  mental: Mental;
  /** 심리 항목 가중치 */
  mentalWeight: Scalars['Float'];
  /** 신체 기준 */
  physical: ScoutingPhysical;
  /** 신체 항목 가중치 */
  physicalWeight: Scalars['Float'];
  /** 포지션 */
  position: ProspectPlayerPositionType;
  /** 전술 기준 */
  tactic: Tactic;
  /** 전술 항목 가중치 */
  tacticWeight: Scalars['Float'];
  /** 기술 기준 */
  technic: Technic;
  /** 기술 항목 가중치 */
  technicWeight: Scalars['Float'];
};

/** 관찰 리포트 신체 평가 */
export type ScoutingPhysical = {
  __typename: 'ScoutingPhysical';
  /** 가속 */
  acceleration?: Maybe<Scalars['Float']>;
  /** 유산소 지구력 */
  aerobicEndurance?: Maybe<Scalars['Float']>;
  /** 유산소 파워 */
  aerobicPower?: Maybe<Scalars['Float']>;
  /** 민첩성 */
  agility?: Maybe<Scalars['Float']>;
  /** 밸런스 */
  balance?: Maybe<Scalars['Float']>;
  /** 경합 */
  competition?: Maybe<Scalars['Float']>;
  /** 감속 */
  deceleration?: Maybe<Scalars['Float']>;
  /** 방향전환 */
  directionChange?: Maybe<Scalars['Float']>;
  /** 키 */
  height?: Maybe<Scalars['Float']>;
  /** 점프력 */
  jump?: Maybe<Scalars['Float']>;
  /** 파워 */
  power?: Maybe<Scalars['Float']>;
  /** 반응성 */
  reactivity?: Maybe<Scalars['Float']>;
  /** 회복 속도 */
  recoverySpeed?: Maybe<Scalars['Float']>;
  /** 스피드 */
  speed?: Maybe<Scalars['Float']>;
  /** 스피드지구력 */
  speedEndurance?: Maybe<Scalars['Float']>;
  /** 체중 */
  weight?: Maybe<Scalars['Float']>;
};

/** 서비스 메타 정보 */
export type ServiceMeta = {
  __typename: 'ServiceMeta';
  /** 강제 업데이트 여부 */
  forceUpdate: Scalars['Boolean'];
  higherVersionList: Array<VersionRevision>;
  /** 최신 버전 */
  latestVersion: Scalars['String'];
  versionRevisions: Array<VersionRevision>;
};


/** 서비스 메타 정보 */
export type ServiceMetaVersionRevisionsArgs = {
  appId: Scalars['String'];
  os: OsType;
  since: Scalars['String'];
};

export type Session = {
  __typename: 'Session';
  buildList?: Maybe<Array<Build>>;
  completedCount: CompletedCount;
  title?: Maybe<SessionTitle>;
};

export enum SessionTitle {
  AGILITY_SESSION = 'AGILITY_SESSION',
  MUSCULAR_ENDURANCE_SESSION = 'MUSCULAR_ENDURANCE_SESSION',
  POWER_SESSION = 'POWER_SESSION',
  REACTIVITY_SESSION = 'REACTIVITY_SESSION',
  SPEED_SESSION = 'SPEED_SESSION',
  STRENGTH_IMPROVEMENT_SESSION = 'STRENGTH_IMPROVEMENT_SESSION'
}

/** 팀 매치 이벤트 - 세트피스 지표 */
export type SetPiece = {
  __typename: 'SetPiece';
  /** 코너킥 */
  cornerKicks?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 */
  freeKickCrosses?: Maybe<Scalars['Float']>;
  /** 프리킥 슈팅 */
  freeKickShots?: Maybe<Scalars['Float']>;
  /** 프리킥 유효 슈팅 */
  freeKickShotsOnTarget?: Maybe<Scalars['Float']>;
  /** 프리킥 */
  freeKicks?: Maybe<Scalars['Float']>;
  /** 골킥 */
  goalKicks?: Maybe<Scalars['Float']>;
  /** 페널티킥 */
  penaltyKicks?: Maybe<Scalars['Float']>;
  /** 세트피스 득점 */
  setPieceGoals?: Maybe<Scalars['Float']>;
  /** 세트피스 득점 허용 */
  setPieceGoalsConceded?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 */
  setPieceShots?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 허용 */
  setPieceShotsConceded?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 성공 */
  successfulFreeKickCrosses?: Maybe<Scalars['Float']>;
  /** 스로인 */
  throwIns?: Maybe<Scalars['Float']>;
};

/** 배송 정보 */
export type Shipment = {
  __typename: 'Shipment';
  /** 주소 */
  address: Scalars['String'];
  /** 상세 주소 */
  detailAddress: Scalars['String'];
  /** 배송 ID */
  id: Scalars['ID'];
  /** 기본 배송지 여부 */
  isDefault: Scalars['Boolean'];
  /** 이름 */
  name: Scalars['String'];
  /** 휴대폰 번호 */
  phoneNumber: Scalars['String'];
  /** 우편 번호 */
  postCode: Scalars['String'];
  /** 배송 요청 메세지 */
  requestMessage?: Maybe<Scalars['String']>;
};

export enum SimpleOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** 소셜 미디어 */
export type SocialMedia = {
  __typename: 'SocialMedia';
  /** 소셜 미디어 링크 */
  link: Scalars['String'];
  /** 소셜 미디어 타입 */
  type: SocialMediaType;
};

/** 소셜 미디어 input */
export type SocialMediaInput = {
  /** 소셜 미디어 링크 */
  link: Scalars['String'];
  /** 소셜 미디어 타입 */
  type: SocialMediaType;
};

export enum SocialMediaType {
  ETC = 'ETC',
  INSTAGRAM = 'INSTAGRAM',
  YOUTUBE = 'YOUTUBE'
}

/** 브리핑 컨디션 & 통증 리포트 - 솔루션 데이터 */
export type SolutionData = {
  __typename: 'SolutionData';
  /** 팀 컨디션 솔루션 */
  conditionTeamSolution?: Maybe<ConditionTeamSolution>;
  /** 솔루션 조회 여부 */
  isViewed: Scalars['Boolean'];
  /** 유저 데이터 리스트 */
  userList: Array<BriefingReportSolutionData>;
};

/** 브리핑 리포트 솔루션 */
export type SolutionDetailData = {
  __typename: 'SolutionDetailData';
  /** 컨디션 팀 솔루션 */
  conditionTeamSolution?: Maybe<ConditionTeamSolution>;
  /** 솔루션 유저 목록 */
  solutionUserList: Array<BriefingReportSolutionData>;
};

export enum SolutionType {
  ESSENTIAL_TRAINING_SOLUTION = 'ESSENTIAL_TRAINING_SOLUTION',
  PHYSICAL_SOLUTION = 'PHYSICAL_SOLUTION'
}

/** 통증 */
export type Soreness = {
  __typename: 'Soreness';
  /** 부위 */
  bodyPart: SportsBodyPart;
  isContact: Contact;
  /** 단계 */
  level: Scalars['Float'];
  /** 메모 */
  memo: Scalars['String'];
  /** 지속일 */
  streak: Scalars['Float'];
};


/** 통증 */
export type SorenessBodyPartArgs = {
  input: MultilingualTextInput;
};

/** 통증 데이터 */
export type SorenessData = {
  __typename: 'SorenessData';
  /** 체크 여부 */
  isChecked: Scalars['Boolean'];
  /** 최신 업데이트 일자 */
  lastUpdatedAt?: Maybe<Scalars['String']>;
  /** 통증 목록 */
  sorenessList: Array<Soreness>;
};

/** 통증 input */
export type SorenessInput = {
  /** 부위 */
  bodyPart: SportsBodyPartName;
  isContact: Contact;
  /** 단계 */
  level: Scalars['Float'];
  /** 메모, 최대 50자 */
  memo: Scalars['String'];
};

/** 통증 개수 데이터 */
export type SorenessLevelData = {
  __typename: 'SorenessLevelData';
  /** 개수 */
  count: Scalars['Float'];
  /** 통증 파트 목록 */
  parts: Array<SorenessParts>;
};

/** 통증 부위 */
export type SorenessParts = {
  __typename: 'SorenessParts';
  /** 통증 파트 */
  bodyPart: SportsBodyPart;
  /** 통증 파트 그룹 */
  bodyPartGroup: SportsBodyPartGroupName;
};


/** 통증 부위 */
export type SorenessPartsBodyPartArgs = {
  input: MultilingualTextInput;
};

/** 통증 솔루션 */
export type SorenessSolution = {
  __typename: 'SorenessSolution';
  /** 부위 */
  bodyPart?: Maybe<Scalars['String']>;
  /** 가이드 */
  guide: Scalars['String'];
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 몇일 전 통증 */
  sorenessDaysAgo?: Maybe<Scalars['Float']>;
  /** 오늘 통증 레벨 */
  todayLevel?: Maybe<Scalars['Float']>;
  /** 통증 솔루션 종류 */
  type: SorenessSolutionType;
  /** 어제 통증 레벨 */
  yesterdayLevel?: Maybe<Scalars['Float']>;
};

export enum SorenessSolutionType {
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE'
}

/** 브리핑 통증 리포트 - 통증 별 데이터 */
export type SorenessUserData = {
  __typename: 'SorenessUserData';
  /** 새로운 통증 데이터 */
  newSoreness: SorenessUserListData;
  /** 회복 통증 데이터 */
  recoverSoreness: SorenessUserListData;
  /** 심각한 통증 데이터 */
  severeSoreness: SorenessUserListData;
};

/** 브리핑 통증 리포트 - 유저 상세 데이터 */
export type SorenessUserDetailData = {
  __typename: 'SorenessUserDetailData';
  /** 유저 조회 여부 */
  isViewed: Scalars['Boolean'];
  /** 통증 목록 */
  sorenessList: Array<Soreness>;
  /** 유저 정보 */
  user: SportsUser;
};

/** 브리핑 통증 리포트 - 유저 데이터 */
export type SorenessUserListData = {
  __typename: 'SorenessUserListData';
  /** 통증 조회 여부 */
  isViewed: Scalars['Boolean'];
  /** 통증 유저 데이터 리스트 */
  userList: Array<SorenessUserDetailData>;
};

/** 부위 */
export type SportsBodyPart = {
  __typename: 'SportsBodyPart';
  /** 뒤 */
  back: Scalars['Boolean'];
  /** 앞 */
  front: Scalars['Boolean'];
  /** 부위 그룹 */
  group: SportsBodyPartGroup;
  /** 부위명 */
  id: SportsBodyPartName;
  /** 부위 이미지Url */
  imageUrl?: Maybe<Scalars['String']>;
  /** 왼쪽 */
  left: Scalars['Boolean'];
  /** 오른쪽 */
  right: Scalars['Boolean'];
  /** 값 */
  value: Scalars['String'];
};

/** 부위 그룹 */
export type SportsBodyPartGroup = {
  __typename: 'SportsBodyPartGroup';
  /** 부위 그룹 */
  id: SportsBodyPartGroupName;
  /** 부위 */
  parts: Array<SportsBodyPart>;
};


/** 부위 그룹 */
export type SportsBodyPartGroupPartsArgs = {
  input: MultilingualTextInput;
};

export enum SportsBodyPartGroupName {
  all_body_part_group__arm = 'all_body_part_group__arm',
  all_body_part_group__head = 'all_body_part_group__head',
  all_body_part_group__leg = 'all_body_part_group__leg',
  all_body_part_group__torso = 'all_body_part_group__torso'
}

export enum SportsBodyPartName {
  all_body_part__back_head = 'all_body_part__back_head',
  all_body_part__back_neck = 'all_body_part__back_neck',
  all_body_part__face = 'all_body_part__face',
  all_body_part__forehead = 'all_body_part__forehead',
  all_body_part__front_neck = 'all_body_part__front_neck',
  all_body_part__left_achilles_tendon = 'all_body_part__left_achilles_tendon',
  all_body_part__left_ankle = 'all_body_part__left_ankle',
  all_body_part__left_back_leg = 'all_body_part__left_back_leg',
  all_body_part__left_back_of_hand = 'all_body_part__left_back_of_hand',
  all_body_part__left_back_of_knee = 'all_body_part__left_back_of_knee',
  all_body_part__left_back_thigh = 'all_body_part__left_back_thigh',
  all_body_part__left_chest = 'all_body_part__left_chest',
  all_body_part__left_elbow = 'all_body_part__left_elbow',
  all_body_part__left_finger = 'all_body_part__left_finger',
  all_body_part__left_forearm = 'all_body_part__left_forearm',
  all_body_part__left_front_knee = 'all_body_part__left_front_knee',
  all_body_part__left_front_thigh = 'all_body_part__left_front_thigh',
  all_body_part__left_groin = 'all_body_part__left_groin',
  all_body_part__left_hip = 'all_body_part__left_hip',
  all_body_part__left_hip_joint = 'all_body_part__left_hip_joint',
  all_body_part__left_instep = 'all_body_part__left_instep',
  all_body_part__left_palm = 'all_body_part__left_palm',
  all_body_part__left_rib = 'all_body_part__left_rib',
  all_body_part__left_shin = 'all_body_part__left_shin',
  all_body_part__left_shoulder = 'all_body_part__left_shoulder',
  all_body_part__left_sole = 'all_body_part__left_sole',
  all_body_part__left_toe = 'all_body_part__left_toe',
  all_body_part__left_upper_arm = 'all_body_part__left_upper_arm',
  all_body_part__left_wing = 'all_body_part__left_wing',
  all_body_part__left_wrist = 'all_body_part__left_wrist',
  all_body_part__lower_abdomen = 'all_body_part__lower_abdomen',
  all_body_part__lower_back = 'all_body_part__lower_back',
  all_body_part__middle_back = 'all_body_part__middle_back',
  all_body_part__reproductive_organs = 'all_body_part__reproductive_organs',
  all_body_part__right_achilles_tendon = 'all_body_part__right_achilles_tendon',
  all_body_part__right_ankle = 'all_body_part__right_ankle',
  all_body_part__right_back_leg = 'all_body_part__right_back_leg',
  all_body_part__right_back_of_hand = 'all_body_part__right_back_of_hand',
  all_body_part__right_back_of_knee = 'all_body_part__right_back_of_knee',
  all_body_part__right_back_thigh = 'all_body_part__right_back_thigh',
  all_body_part__right_chest = 'all_body_part__right_chest',
  all_body_part__right_elbow = 'all_body_part__right_elbow',
  all_body_part__right_finger = 'all_body_part__right_finger',
  all_body_part__right_forearm = 'all_body_part__right_forearm',
  all_body_part__right_front_knee = 'all_body_part__right_front_knee',
  all_body_part__right_front_thigh = 'all_body_part__right_front_thigh',
  all_body_part__right_groin = 'all_body_part__right_groin',
  all_body_part__right_hip = 'all_body_part__right_hip',
  all_body_part__right_hip_joint = 'all_body_part__right_hip_joint',
  all_body_part__right_instep = 'all_body_part__right_instep',
  all_body_part__right_palm = 'all_body_part__right_palm',
  all_body_part__right_rib = 'all_body_part__right_rib',
  all_body_part__right_shin = 'all_body_part__right_shin',
  all_body_part__right_shoulder = 'all_body_part__right_shoulder',
  all_body_part__right_sole = 'all_body_part__right_sole',
  all_body_part__right_toe = 'all_body_part__right_toe',
  all_body_part__right_upper_arm = 'all_body_part__right_upper_arm',
  all_body_part__right_wing = 'all_body_part__right_wing',
  all_body_part__right_wrist = 'all_body_part__right_wrist',
  all_body_part__tailbone = 'all_body_part__tailbone',
  all_body_part__upper_abdomen = 'all_body_part__upper_abdomen',
  all_body_part__upper_back = 'all_body_part__upper_back'
}

export enum SportsCategory {
  sports_category__3x3_basketball = 'sports_category__3x3_basketball',
  sports_category__aerobics = 'sports_category__aerobics',
  sports_category__alpine_skiing = 'sports_category__alpine_skiing',
  sports_category__american_football = 'sports_category__american_football',
  sports_category__archery = 'sports_category__archery',
  sports_category__arm_wrestling = 'sports_category__arm_wrestling',
  sports_category__artistic_gymnastics = 'sports_category__artistic_gymnastics',
  sports_category__artistic_swimming = 'sports_category__artistic_swimming',
  sports_category__badminton = 'sports_category__badminton',
  sports_category__baseball = 'sports_category__baseball',
  sports_category__basketball = 'sports_category__basketball',
  sports_category__biathlon = 'sports_category__biathlon',
  sports_category__billiards = 'sports_category__billiards',
  sports_category__bmx_freestyle = 'sports_category__bmx_freestyle',
  sports_category__bmx_racing = 'sports_category__bmx_racing',
  sports_category__bobsleigh = 'sports_category__bobsleigh',
  sports_category__boccia = 'sports_category__boccia',
  sports_category__bowling = 'sports_category__bowling',
  sports_category__boxing = 'sports_category__boxing',
  sports_category__breaking = 'sports_category__breaking',
  sports_category__canoe = 'sports_category__canoe',
  sports_category__cricket = 'sports_category__cricket',
  sports_category__cross_country_skiing = 'sports_category__cross_country_skiing',
  sports_category__curling = 'sports_category__curling',
  sports_category__cycling_mtb = 'sports_category__cycling_mtb',
  sports_category__cycling_road = 'sports_category__cycling_road',
  sports_category__cycling_track = 'sports_category__cycling_track',
  sports_category__decathlon = 'sports_category__decathlon',
  sports_category__discus_throw = 'sports_category__discus_throw',
  sports_category__diving = 'sports_category__diving',
  sports_category__dressage = 'sports_category__dressage',
  sports_category__etc = 'sports_category__etc',
  sports_category__eventing = 'sports_category__eventing',
  sports_category__fencing = 'sports_category__fencing',
  sports_category__field_hockey = 'sports_category__field_hockey',
  sports_category__fin_swimming = 'sports_category__fin_swimming',
  sports_category__foot_volleyball = 'sports_category__foot_volleyball',
  sports_category__freestyle_skiing = 'sports_category__freestyle_skiing',
  sports_category__futsal = 'sports_category__futsal',
  sports_category__golf = 'sports_category__golf',
  sports_category__hammer_throw = 'sports_category__hammer_throw',
  sports_category__handball = 'sports_category__handball',
  sports_category__heptathlon = 'sports_category__heptathlon',
  sports_category__high_jump = 'sports_category__high_jump',
  sports_category__hurdle = 'sports_category__hurdle',
  sports_category__ice_hockey = 'sports_category__ice_hockey',
  sports_category__ice_skating = 'sports_category__ice_skating',
  sports_category__javelin_throw = 'sports_category__javelin_throw',
  sports_category__judo = 'sports_category__judo',
  sports_category__karate = 'sports_category__karate',
  sports_category__kayak = 'sports_category__kayak',
  sports_category__kickboxing = 'sports_category__kickboxing',
  sports_category__kung_fu = 'sports_category__kung_fu',
  sports_category__lacrosse = 'sports_category__lacrosse',
  sports_category__long_distance_running = 'sports_category__long_distance_running',
  sports_category__long_jump = 'sports_category__long_jump',
  sports_category__luge = 'sports_category__luge',
  sports_category__marathon = 'sports_category__marathon',
  sports_category__marathon_swimming = 'sports_category__marathon_swimming',
  sports_category__middle_distance_running = 'sports_category__middle_distance_running',
  sports_category__modern_pentathlon = 'sports_category__modern_pentathlon',
  sports_category__nordic_skiing = 'sports_category__nordic_skiing',
  sports_category__pole_vault = 'sports_category__pole_vault',
  sports_category__race_walking = 'sports_category__race_walking',
  sports_category__racquetball = 'sports_category__racquetball',
  sports_category__rhythmic_gymnastics = 'sports_category__rhythmic_gymnastics',
  sports_category__roller = 'sports_category__roller',
  sports_category__rowing = 'sports_category__rowing',
  sports_category__rugby = 'sports_category__rugby',
  sports_category__rugby_sevens = 'sports_category__rugby_sevens',
  sports_category__sepak_takraw = 'sports_category__sepak_takraw',
  sports_category__shooting = 'sports_category__shooting',
  sports_category__shot_put = 'sports_category__shot_put',
  sports_category__show_jumping = 'sports_category__show_jumping',
  sports_category__skateboard = 'sports_category__skateboard',
  sports_category__skeleton = 'sports_category__skeleton',
  sports_category__ski_jumping = 'sports_category__ski_jumping',
  sports_category__ski_mountaineering = 'sports_category__ski_mountaineering',
  sports_category__snowboarding = 'sports_category__snowboarding',
  sports_category__soccer = 'sports_category__soccer',
  sports_category__soft_tennis = 'sports_category__soft_tennis',
  sports_category__softball = 'sports_category__softball',
  sports_category__sports_climbing = 'sports_category__sports_climbing',
  sports_category__sprint = 'sports_category__sprint',
  sports_category__squash = 'sports_category__squash',
  sports_category__ssireum = 'sports_category__ssireum',
  sports_category__surfing = 'sports_category__surfing',
  sports_category__swimming = 'sports_category__swimming',
  sports_category__table_tennis = 'sports_category__table_tennis',
  sports_category__taekwondo = 'sports_category__taekwondo',
  sports_category__takkyeon = 'sports_category__takkyeon',
  sports_category__tee_ball = 'sports_category__tee_ball',
  sports_category__tennis = 'sports_category__tennis',
  sports_category__trampoline = 'sports_category__trampoline',
  sports_category__triathlon = 'sports_category__triathlon',
  sports_category__triple_jump = 'sports_category__triple_jump',
  sports_category__volleyball = 'sports_category__volleyball',
  sports_category__water_polo = 'sports_category__water_polo',
  sports_category__water_skiing = 'sports_category__water_skiing',
  sports_category__weightlifting = 'sports_category__weightlifting',
  sports_category__wrestling = 'sports_category__wrestling',
  sports_category__yacht = 'sports_category__yacht'
}

/** 스포츠 카테고리 정보 */
export type SportsCategoryCollection = {
  __typename: 'SportsCategoryCollection';
  /** 코치 포지션 목록 */
  coachPositions: Array<SportsPosition>;
  /** 스포츠 카테고리 그룹 */
  group?: Maybe<SportsCategoryGroup>;
  /** 스포츠 카테고리ID */
  id?: Maybe<SportsCategory>;
  /** 플레이어 포지션 목록 */
  playerPositions: Array<SportsPosition>;
};

export enum SportsCategoryGroup {
  sports_category_group__archery = 'sports_category_group__archery',
  sports_category_group__athletics = 'sports_category_group__athletics',
  sports_category_group__ball = 'sports_category_group__ball',
  sports_category_group__combat = 'sports_category_group__combat',
  sports_category_group__cycling = 'sports_category_group__cycling',
  sports_category_group__equestrian = 'sports_category_group__equestrian',
  sports_category_group__etc = 'sports_category_group__etc',
  sports_category_group__fencing = 'sports_category_group__fencing',
  sports_category_group__gymnastics = 'sports_category_group__gymnastics',
  sports_category_group__modern_pentathlon = 'sports_category_group__modern_pentathlon',
  sports_category_group__racket = 'sports_category_group__racket',
  sports_category_group__roller = 'sports_category_group__roller',
  sports_category_group__shooting = 'sports_category_group__shooting',
  sports_category_group__triathlon = 'sports_category_group__triathlon',
  sports_category_group__water = 'sports_category_group__water',
  sports_category_group__weightlifting = 'sports_category_group__weightlifting',
  sports_category_group__winter = 'sports_category_group__winter'
}

/** 스포츠 카테고리 그룹 정보 */
export type SportsCategoryGroupCollection = {
  __typename: 'SportsCategoryGroupCollection';
  /** 스포츠 카테고리 정보 */
  categories: Array<SportsCategoryCollection>;
  /** 스포츠 카테고리 그룹 */
  id: SportsCategoryGroup;
};

/** 스포츠 데이터 */
export type SportsData = {
  __typename: 'SportsData';
  /** 신체 */
  body?: Maybe<BodyData>;
  /** 컨디션 */
  condition?: Maybe<Condition>;
  /** 날짜 */
  date: Scalars['DateTimeString'];
  /** 스포츠 데이터 ID */
  id?: Maybe<Scalars['ID']>;
  /** 통증 */
  soreness?: Maybe<SorenessData>;
  /** 유저 정보 */
  user: SportsUser;
  /** 운동부하 */
  workload?: Maybe<WorkloadData>;
};


/** 스포츠 데이터 */
export type SportsDataBodyArgs = {
  heightUnit?: HeightUnit;
  weightUnit?: WeightUnit;
};

export type SportsDataEntry = {
  __typename: 'SportsDataEntry';
  time: Scalars['DateTimeString'];
  value?: Maybe<Scalars['JSON']>;
};

export enum SportsDataGroup {
  BODY = 'BODY',
  CONDITION = 'CONDITION',
  INJURY = 'INJURY',
  READINESS = 'READINESS',
  WORKLOAD = 'WORKLOAD'
}

export enum SportsDataName {
  BODY = 'BODY',
  BODY_MONTHLY_STAT = 'BODY_MONTHLY_STAT',
  BODY_WEEKLY_STAT = 'BODY_WEEKLY_STAT',
  CONDITION = 'CONDITION',
  CONDITION_AX = 'CONDITION_AX',
  CONDITION_CX = 'CONDITION_CX',
  CONDITION_MONTHLY_AVG = 'CONDITION_MONTHLY_AVG',
  CONDITION_ROLLING_AVG_7DAY = 'CONDITION_ROLLING_AVG_7DAY',
  CONDITION_ROLLING_AVG_28DAY = 'CONDITION_ROLLING_AVG_28DAY',
  CONDITION_WEEKLY_AVG = 'CONDITION_WEEKLY_AVG',
  INJURY = 'INJURY',
  RAW_BODY = 'RAW_BODY',
  RAW_INJURY = 'RAW_INJURY',
  RAW_WORKLOAD = 'RAW_WORKLOAD',
  READINESS = 'READINESS',
  SLEEP_MONTHLY_STAT = 'SLEEP_MONTHLY_STAT',
  SLEEP_ROLLING_AVG_7DAY = 'SLEEP_ROLLING_AVG_7DAY',
  SLEEP_ROLLING_AVG_28DAY = 'SLEEP_ROLLING_AVG_28DAY',
  SLEEP_WEEKLY_STAT = 'SLEEP_WEEKLY_STAT',
  SORENESS = 'SORENESS',
  WELLNESS_MONTHLY_STAT = 'WELLNESS_MONTHLY_STAT',
  WELLNESS_ROLLING_AVG_7DAY = 'WELLNESS_ROLLING_AVG_7DAY',
  WELLNESS_ROLLING_AVG_28DAY = 'WELLNESS_ROLLING_AVG_28DAY',
  WELLNESS_WEEKLY_STAT = 'WELLNESS_WEEKLY_STAT',
  WORKLOAD = 'WORKLOAD',
  WORKLOAD_ACXR = 'WORKLOAD_ACXR',
  WORKLOAD_ACXRAXD_ROLLING_AVG_7DAY = 'WORKLOAD_ACXRAXD_ROLLING_AVG_7DAY',
  WORKLOAD_ACXRAXD_ROLLING_AVG_28DAY = 'WORKLOAD_ACXRAXD_ROLLING_AVG_28DAY',
  WORKLOAD_AX = 'WORKLOAD_AX',
  WORKLOAD_AXD = 'WORKLOAD_AXD',
  WORKLOAD_AXI = 'WORKLOAD_AXI',
  WORKLOAD_CX = 'WORKLOAD_CX',
  WORKLOAD_MONTHLY_STAT = 'WORKLOAD_MONTHLY_STAT',
  WORKLOAD_ROLLING_AVG_7DAY = 'WORKLOAD_ROLLING_AVG_7DAY',
  WORKLOAD_ROLLING_AVG_28DAY = 'WORKLOAD_ROLLING_AVG_28DAY',
  WORKLOAD_WEEKLY_STAT = 'WORKLOAD_WEEKLY_STAT',
  WORKLOAD_X = 'WORKLOAD_X'
}

export type SportsDataRange = {
  __typename: 'SportsDataRange';
  entries: Array<SportsDataEntry>;
  from: Scalars['DateTimeString'];
  to: Scalars['DateTimeString'];
};

export enum SportsDataStride {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export enum SportsInjuryQuality {
  BURNING = 'BURNING',
  COMES_AND_GOES = 'COMES_AND_GOES',
  CRAMPING = 'CRAMPING',
  CUTTING = 'CUTTING',
  DULL = 'DULL',
  NUMBING = 'NUMBING',
  PRESSING = 'PRESSING',
  RADIATING = 'RADIATING',
  SHARP = 'SHARP',
  TINGLING = 'TINGLING'
}

export enum SportsInjuryTiming {
  GRADUAL = 'GRADUAL',
  OCCASIONAL = 'OCCASIONAL',
  SUDDEN = 'SUDDEN',
  SUSTAINING = 'SUSTAINING'
}

export enum SportsPosition {
  coach_position__3x3_basketball__assistant_coach = 'coach_position__3x3_basketball__assistant_coach',
  coach_position__3x3_basketball__athletic_trainer = 'coach_position__3x3_basketball__athletic_trainer',
  coach_position__3x3_basketball__coach = 'coach_position__3x3_basketball__coach',
  coach_position__3x3_basketball__head_coach = 'coach_position__3x3_basketball__head_coach',
  coach_position__3x3_basketball__playing_coach = 'coach_position__3x3_basketball__playing_coach',
  coach_position__aerobics__athletic_trainer = 'coach_position__aerobics__athletic_trainer',
  coach_position__aerobics__coach = 'coach_position__aerobics__coach',
  coach_position__aerobics__first_coach = 'coach_position__aerobics__first_coach',
  coach_position__aerobics__head_coach = 'coach_position__aerobics__head_coach',
  coach_position__aerobics__playing_coach = 'coach_position__aerobics__playing_coach',
  coach_position__alpine_skiing__athletic_trainer = 'coach_position__alpine_skiing__athletic_trainer',
  coach_position__alpine_skiing__coach = 'coach_position__alpine_skiing__coach',
  coach_position__alpine_skiing__first_coach = 'coach_position__alpine_skiing__first_coach',
  coach_position__alpine_skiing__head_coach = 'coach_position__alpine_skiing__head_coach',
  coach_position__alpine_skiing__playing_coach = 'coach_position__alpine_skiing__playing_coach',
  coach_position__american_football__assistant_coach = 'coach_position__american_football__assistant_coach',
  coach_position__american_football__athletic_trainer = 'coach_position__american_football__athletic_trainer',
  coach_position__american_football__coach = 'coach_position__american_football__coach',
  coach_position__american_football__defensive_coach = 'coach_position__american_football__defensive_coach',
  coach_position__american_football__fitness_coach = 'coach_position__american_football__fitness_coach',
  coach_position__american_football__head_coach = 'coach_position__american_football__head_coach',
  coach_position__american_football__offensive_coach = 'coach_position__american_football__offensive_coach',
  coach_position__american_football__playing_coach = 'coach_position__american_football__playing_coach',
  coach_position__american_football__scrum_coach = 'coach_position__american_football__scrum_coach',
  coach_position__american_football__skill_coach = 'coach_position__american_football__skill_coach',
  coach_position__american_football__strength_and_conditioning_coach = 'coach_position__american_football__strength_and_conditioning_coach',
  coach_position__archery__assistant_coach = 'coach_position__archery__assistant_coach',
  coach_position__archery__athletic_trainer = 'coach_position__archery__athletic_trainer',
  coach_position__archery__coach = 'coach_position__archery__coach',
  coach_position__archery__head_coach = 'coach_position__archery__head_coach',
  coach_position__archery__playing_coach = 'coach_position__archery__playing_coach',
  coach_position__arm_wrestling__athletic_trainer = 'coach_position__arm_wrestling__athletic_trainer',
  coach_position__arm_wrestling__coach = 'coach_position__arm_wrestling__coach',
  coach_position__arm_wrestling__first_coach = 'coach_position__arm_wrestling__first_coach',
  coach_position__arm_wrestling__head_coach = 'coach_position__arm_wrestling__head_coach',
  coach_position__arm_wrestling__playing_coach = 'coach_position__arm_wrestling__playing_coach',
  coach_position__artistic_gymnastics__athletic_trainer = 'coach_position__artistic_gymnastics__athletic_trainer',
  coach_position__artistic_gymnastics__coach = 'coach_position__artistic_gymnastics__coach',
  coach_position__artistic_gymnastics__first_coach = 'coach_position__artistic_gymnastics__first_coach',
  coach_position__artistic_gymnastics__head_coach = 'coach_position__artistic_gymnastics__head_coach',
  coach_position__artistic_gymnastics__playing_coach = 'coach_position__artistic_gymnastics__playing_coach',
  coach_position__artistic_swimming__athletic_trainer = 'coach_position__artistic_swimming__athletic_trainer',
  coach_position__artistic_swimming__coach = 'coach_position__artistic_swimming__coach',
  coach_position__artistic_swimming__first_coach = 'coach_position__artistic_swimming__first_coach',
  coach_position__artistic_swimming__head_coach = 'coach_position__artistic_swimming__head_coach',
  coach_position__badminton__assistant_coach = 'coach_position__badminton__assistant_coach',
  coach_position__badminton__athletic_trainer = 'coach_position__badminton__athletic_trainer',
  coach_position__badminton__coach = 'coach_position__badminton__coach',
  coach_position__badminton__head_coach = 'coach_position__badminton__head_coach',
  coach_position__baseball__athletic_trainer = 'coach_position__baseball__athletic_trainer',
  coach_position__baseball__base_coach = 'coach_position__baseball__base_coach',
  coach_position__baseball__bench_coach = 'coach_position__baseball__bench_coach',
  coach_position__baseball__coach = 'coach_position__baseball__coach',
  coach_position__baseball__defensive_coach = 'coach_position__baseball__defensive_coach',
  coach_position__baseball__head_coach = 'coach_position__baseball__head_coach',
  coach_position__baseball__hitting_coach = 'coach_position__baseball__hitting_coach',
  coach_position__baseball__pitching_coach = 'coach_position__baseball__pitching_coach',
  coach_position__baseball__playing_coach = 'coach_position__baseball__playing_coach',
  coach_position__basketball__assistant_coach = 'coach_position__basketball__assistant_coach',
  coach_position__basketball__athletic_trainer = 'coach_position__basketball__athletic_trainer',
  coach_position__basketball__coach = 'coach_position__basketball__coach',
  coach_position__basketball__first_coach = 'coach_position__basketball__first_coach',
  coach_position__basketball__head_coach = 'coach_position__basketball__head_coach',
  coach_position__basketball__playing_coach = 'coach_position__basketball__playing_coach',
  coach_position__biathlon__athletic_trainer = 'coach_position__biathlon__athletic_trainer',
  coach_position__biathlon__coach = 'coach_position__biathlon__coach',
  coach_position__biathlon__first_coach = 'coach_position__biathlon__first_coach',
  coach_position__biathlon__head_coach = 'coach_position__biathlon__head_coach',
  coach_position__biathlon__playing_coach = 'coach_position__biathlon__playing_coach',
  coach_position__billiards__athletic_trainer = 'coach_position__billiards__athletic_trainer',
  coach_position__billiards__coach = 'coach_position__billiards__coach',
  coach_position__bmx_freestyle__assistant_coach = 'coach_position__bmx_freestyle__assistant_coach',
  coach_position__bmx_freestyle__athletic_trainer = 'coach_position__bmx_freestyle__athletic_trainer',
  coach_position__bmx_freestyle__coach = 'coach_position__bmx_freestyle__coach',
  coach_position__bmx_freestyle__head_coach = 'coach_position__bmx_freestyle__head_coach',
  coach_position__bmx_freestyle__playing_coach = 'coach_position__bmx_freestyle__playing_coach',
  coach_position__bmx_racing__assistant_coach = 'coach_position__bmx_racing__assistant_coach',
  coach_position__bmx_racing__athletic_trainer = 'coach_position__bmx_racing__athletic_trainer',
  coach_position__bmx_racing__coach = 'coach_position__bmx_racing__coach',
  coach_position__bmx_racing__head_coach = 'coach_position__bmx_racing__head_coach',
  coach_position__bmx_racing__playing_coach = 'coach_position__bmx_racing__playing_coach',
  coach_position__bobsleigh__athletic_trainer = 'coach_position__bobsleigh__athletic_trainer',
  coach_position__bobsleigh__coach = 'coach_position__bobsleigh__coach',
  coach_position__bobsleigh__first_coach = 'coach_position__bobsleigh__first_coach',
  coach_position__bobsleigh__head_coach = 'coach_position__bobsleigh__head_coach',
  coach_position__bobsleigh__playing_coach = 'coach_position__bobsleigh__playing_coach',
  coach_position__boccia__athletic_trainer = 'coach_position__boccia__athletic_trainer',
  coach_position__boccia__coach = 'coach_position__boccia__coach',
  coach_position__boccia__first_coach = 'coach_position__boccia__first_coach',
  coach_position__boccia__head_coach = 'coach_position__boccia__head_coach',
  coach_position__boccia__playing_coach = 'coach_position__boccia__playing_coach',
  coach_position__bowling__athletic_trainer = 'coach_position__bowling__athletic_trainer',
  coach_position__bowling__coach = 'coach_position__bowling__coach',
  coach_position__bowling__first_coach = 'coach_position__bowling__first_coach',
  coach_position__bowling__head_coach = 'coach_position__bowling__head_coach',
  coach_position__bowling__playing_coach = 'coach_position__bowling__playing_coach',
  coach_position__boxing__athletic_trainer = 'coach_position__boxing__athletic_trainer',
  coach_position__boxing__coach = 'coach_position__boxing__coach',
  coach_position__boxing__first_coach = 'coach_position__boxing__first_coach',
  coach_position__boxing__head_coach = 'coach_position__boxing__head_coach',
  coach_position__boxing__playing_coach = 'coach_position__boxing__playing_coach',
  coach_position__breaking__athletic_trainer = 'coach_position__breaking__athletic_trainer',
  coach_position__breaking__coach = 'coach_position__breaking__coach',
  coach_position__breaking__head_coach = 'coach_position__breaking__head_coach',
  coach_position__breaking__playing_coach = 'coach_position__breaking__playing_coach',
  coach_position__canoe__athletic_trainer = 'coach_position__canoe__athletic_trainer',
  coach_position__canoe__coach = 'coach_position__canoe__coach',
  coach_position__canoe__first_coach = 'coach_position__canoe__first_coach',
  coach_position__canoe__head_coach = 'coach_position__canoe__head_coach',
  coach_position__cricket__athletic_trainer = 'coach_position__cricket__athletic_trainer',
  coach_position__cricket__coach = 'coach_position__cricket__coach',
  coach_position__cricket__first_coach = 'coach_position__cricket__first_coach',
  coach_position__cricket__head_coach = 'coach_position__cricket__head_coach',
  coach_position__cricket__playing_coach = 'coach_position__cricket__playing_coach',
  coach_position__cross_country_skiing__athletic_trainer = 'coach_position__cross_country_skiing__athletic_trainer',
  coach_position__cross_country_skiing__coach = 'coach_position__cross_country_skiing__coach',
  coach_position__cross_country_skiing__first_coach = 'coach_position__cross_country_skiing__first_coach',
  coach_position__cross_country_skiing__head_coach = 'coach_position__cross_country_skiing__head_coach',
  coach_position__cross_country_skiing__playing_coach = 'coach_position__cross_country_skiing__playing_coach',
  coach_position__curling__athletic_trainer = 'coach_position__curling__athletic_trainer',
  coach_position__curling__coach = 'coach_position__curling__coach',
  coach_position__curling__first_coach = 'coach_position__curling__first_coach',
  coach_position__curling__head_coach = 'coach_position__curling__head_coach',
  coach_position__curling__playing_coach = 'coach_position__curling__playing_coach',
  coach_position__cycling_mtb__assistant_coach = 'coach_position__cycling_mtb__assistant_coach',
  coach_position__cycling_mtb__athletic_trainer = 'coach_position__cycling_mtb__athletic_trainer',
  coach_position__cycling_mtb__coach = 'coach_position__cycling_mtb__coach',
  coach_position__cycling_mtb__head_coach = 'coach_position__cycling_mtb__head_coach',
  coach_position__cycling_mtb__playing_coach = 'coach_position__cycling_mtb__playing_coach',
  coach_position__cycling_road__assistant_coach = 'coach_position__cycling_road__assistant_coach',
  coach_position__cycling_road__athletic_trainer = 'coach_position__cycling_road__athletic_trainer',
  coach_position__cycling_road__coach = 'coach_position__cycling_road__coach',
  coach_position__cycling_road__head_coach = 'coach_position__cycling_road__head_coach',
  coach_position__cycling_road__playing_coach = 'coach_position__cycling_road__playing_coach',
  coach_position__cycling_track__assistant_coach = 'coach_position__cycling_track__assistant_coach',
  coach_position__cycling_track__athletic_trainer = 'coach_position__cycling_track__athletic_trainer',
  coach_position__cycling_track__coach = 'coach_position__cycling_track__coach',
  coach_position__cycling_track__head_coach = 'coach_position__cycling_track__head_coach',
  coach_position__cycling_track__playing_coach = 'coach_position__cycling_track__playing_coach',
  coach_position__discus_throw__athletic_trainer = 'coach_position__discus_throw__athletic_trainer',
  coach_position__discus_throw__coach = 'coach_position__discus_throw__coach',
  coach_position__discus_throw__first_coach = 'coach_position__discus_throw__first_coach',
  coach_position__discus_throw__head_coach = 'coach_position__discus_throw__head_coach',
  coach_position__discus_throw__playing_coach = 'coach_position__discus_throw__playing_coach',
  coach_position__diving__athletic_trainer = 'coach_position__diving__athletic_trainer',
  coach_position__diving__coach = 'coach_position__diving__coach',
  coach_position__diving__first_coach = 'coach_position__diving__first_coach',
  coach_position__diving__head_coach = 'coach_position__diving__head_coach',
  coach_position__dressage__assistant_coach = 'coach_position__dressage__assistant_coach',
  coach_position__dressage__athletic_trainer = 'coach_position__dressage__athletic_trainer',
  coach_position__dressage__coach = 'coach_position__dressage__coach',
  coach_position__dressage__head_coach = 'coach_position__dressage__head_coach',
  coach_position__dressage__playing_coach = 'coach_position__dressage__playing_coach',
  coach_position__etc__athletic_trainer = 'coach_position__etc__athletic_trainer',
  coach_position__etc__coach = 'coach_position__etc__coach',
  coach_position__etc__head_coach = 'coach_position__etc__head_coach',
  coach_position__etc__playing_coach = 'coach_position__etc__playing_coach',
  coach_position__eventing__assistant_coach = 'coach_position__eventing__assistant_coach',
  coach_position__eventing__athletic_trainer = 'coach_position__eventing__athletic_trainer',
  coach_position__eventing__coach = 'coach_position__eventing__coach',
  coach_position__eventing__head_coach = 'coach_position__eventing__head_coach',
  coach_position__eventing__playing_coach = 'coach_position__eventing__playing_coach',
  coach_position__fencing__athletic_trainer = 'coach_position__fencing__athletic_trainer',
  coach_position__fencing__coach = 'coach_position__fencing__coach',
  coach_position__fencing__first_coach = 'coach_position__fencing__first_coach',
  coach_position__fencing__head_coach = 'coach_position__fencing__head_coach',
  coach_position__fencing__playing_coach = 'coach_position__fencing__playing_coach',
  coach_position__field_hockey__assistant_coach = 'coach_position__field_hockey__assistant_coach',
  coach_position__field_hockey__athletic_trainer = 'coach_position__field_hockey__athletic_trainer',
  coach_position__field_hockey__coach = 'coach_position__field_hockey__coach',
  coach_position__field_hockey__gk_coach = 'coach_position__field_hockey__gk_coach',
  coach_position__field_hockey__head_coach = 'coach_position__field_hockey__head_coach',
  coach_position__field_hockey__playing_coach = 'coach_position__field_hockey__playing_coach',
  coach_position__fin_swimming__athletic_trainer = 'coach_position__fin_swimming__athletic_trainer',
  coach_position__fin_swimming__coach = 'coach_position__fin_swimming__coach',
  coach_position__fin_swimming__first_coach = 'coach_position__fin_swimming__first_coach',
  coach_position__fin_swimming__head_coach = 'coach_position__fin_swimming__head_coach',
  coach_position__foot_volleyball__athletic_trainer = 'coach_position__foot_volleyball__athletic_trainer',
  coach_position__foot_volleyball__coach = 'coach_position__foot_volleyball__coach',
  coach_position__foot_volleyball__first_coach = 'coach_position__foot_volleyball__first_coach',
  coach_position__foot_volleyball__head_coach = 'coach_position__foot_volleyball__head_coach',
  coach_position__foot_volleyball__playing_coach = 'coach_position__foot_volleyball__playing_coach',
  coach_position__freestyle_skiing__athletic_trainer = 'coach_position__freestyle_skiing__athletic_trainer',
  coach_position__freestyle_skiing__coach = 'coach_position__freestyle_skiing__coach',
  coach_position__freestyle_skiing__first_coach = 'coach_position__freestyle_skiing__first_coach',
  coach_position__freestyle_skiing__head_coach = 'coach_position__freestyle_skiing__head_coach',
  coach_position__freestyle_skiing__playing_coach = 'coach_position__freestyle_skiing__playing_coach',
  coach_position__futsal__athletic_trainer = 'coach_position__futsal__athletic_trainer',
  coach_position__futsal__coach = 'coach_position__futsal__coach',
  coach_position__futsal__first_coach = 'coach_position__futsal__first_coach',
  coach_position__futsal__head_coach = 'coach_position__futsal__head_coach',
  coach_position__futsal__playing_coach = 'coach_position__futsal__playing_coach',
  coach_position__golf__athletic_trainer = 'coach_position__golf__athletic_trainer',
  coach_position__golf__coach = 'coach_position__golf__coach',
  coach_position__hammer_throw__athletic_trainer = 'coach_position__hammer_throw__athletic_trainer',
  coach_position__hammer_throw__coach = 'coach_position__hammer_throw__coach',
  coach_position__hammer_throw__first_coach = 'coach_position__hammer_throw__first_coach',
  coach_position__hammer_throw__head_coach = 'coach_position__hammer_throw__head_coach',
  coach_position__hammer_throw__playing_coach = 'coach_position__hammer_throw__playing_coach',
  coach_position__handball__assistant_coach = 'coach_position__handball__assistant_coach',
  coach_position__handball__athletic_trainer = 'coach_position__handball__athletic_trainer',
  coach_position__handball__coach = 'coach_position__handball__coach',
  coach_position__handball__first_coach = 'coach_position__handball__first_coach',
  coach_position__handball__head_coach = 'coach_position__handball__head_coach',
  coach_position__handball__playing_coach = 'coach_position__handball__playing_coach',
  coach_position__high_jump__athletic_trainer = 'coach_position__high_jump__athletic_trainer',
  coach_position__high_jump__coach = 'coach_position__high_jump__coach',
  coach_position__high_jump__first_coach = 'coach_position__high_jump__first_coach',
  coach_position__high_jump__head_coach = 'coach_position__high_jump__head_coach',
  coach_position__high_jump__playing_coach = 'coach_position__high_jump__playing_coach',
  coach_position__hurdle__athletic_trainer = 'coach_position__hurdle__athletic_trainer',
  coach_position__hurdle__coach = 'coach_position__hurdle__coach',
  coach_position__hurdle__first_coach = 'coach_position__hurdle__first_coach',
  coach_position__hurdle__head_coach = 'coach_position__hurdle__head_coach',
  coach_position__hurdle__playing_coach = 'coach_position__hurdle__playing_coach',
  coach_position__ice_hockey__assistant_coach = 'coach_position__ice_hockey__assistant_coach',
  coach_position__ice_hockey__athletic_trainer = 'coach_position__ice_hockey__athletic_trainer',
  coach_position__ice_hockey__coach = 'coach_position__ice_hockey__coach',
  coach_position__ice_hockey__gk_coach = 'coach_position__ice_hockey__gk_coach',
  coach_position__ice_hockey__head_coach = 'coach_position__ice_hockey__head_coach',
  coach_position__ice_hockey__playing_coach = 'coach_position__ice_hockey__playing_coach',
  coach_position__ice_skating__athletic_trainer = 'coach_position__ice_skating__athletic_trainer',
  coach_position__ice_skating__coach = 'coach_position__ice_skating__coach',
  coach_position__ice_skating__first_coach = 'coach_position__ice_skating__first_coach',
  coach_position__ice_skating__head_coach = 'coach_position__ice_skating__head_coach',
  coach_position__ice_skating__playing_coach = 'coach_position__ice_skating__playing_coach',
  coach_position__javelin_throw__athletic_trainer = 'coach_position__javelin_throw__athletic_trainer',
  coach_position__javelin_throw__coach = 'coach_position__javelin_throw__coach',
  coach_position__javelin_throw__first_coach = 'coach_position__javelin_throw__first_coach',
  coach_position__javelin_throw__head_coach = 'coach_position__javelin_throw__head_coach',
  coach_position__javelin_throw__playing_coach = 'coach_position__javelin_throw__playing_coach',
  coach_position__judo__athletic_trainer = 'coach_position__judo__athletic_trainer',
  coach_position__judo__coach = 'coach_position__judo__coach',
  coach_position__judo__first_coach = 'coach_position__judo__first_coach',
  coach_position__judo__head_coach = 'coach_position__judo__head_coach',
  coach_position__judo__playing_coach = 'coach_position__judo__playing_coach',
  coach_position__karate__athletic_trainer = 'coach_position__karate__athletic_trainer',
  coach_position__karate__coach = 'coach_position__karate__coach',
  coach_position__karate__first_coach = 'coach_position__karate__first_coach',
  coach_position__karate__head_coach = 'coach_position__karate__head_coach',
  coach_position__karate__playing_coach = 'coach_position__karate__playing_coach',
  coach_position__kayak__athletic_trainer = 'coach_position__kayak__athletic_trainer',
  coach_position__kayak__coach = 'coach_position__kayak__coach',
  coach_position__kayak__first_coach = 'coach_position__kayak__first_coach',
  coach_position__kayak__head_coach = 'coach_position__kayak__head_coach',
  coach_position__kickboxing__athletic_trainer = 'coach_position__kickboxing__athletic_trainer',
  coach_position__kickboxing__coach = 'coach_position__kickboxing__coach',
  coach_position__kickboxing__first_coach = 'coach_position__kickboxing__first_coach',
  coach_position__kickboxing__head_coach = 'coach_position__kickboxing__head_coach',
  coach_position__kickboxing__playing_coach = 'coach_position__kickboxing__playing_coach',
  coach_position__kung_fu__athletic_trainer = 'coach_position__kung_fu__athletic_trainer',
  coach_position__kung_fu__coach = 'coach_position__kung_fu__coach',
  coach_position__kung_fu__first_coach = 'coach_position__kung_fu__first_coach',
  coach_position__kung_fu__head_coach = 'coach_position__kung_fu__head_coach',
  coach_position__kung_fu__playing_coach = 'coach_position__kung_fu__playing_coach',
  coach_position__lacrosse__assistant_coach = 'coach_position__lacrosse__assistant_coach',
  coach_position__lacrosse__athletic_trainer = 'coach_position__lacrosse__athletic_trainer',
  coach_position__lacrosse__coach = 'coach_position__lacrosse__coach',
  coach_position__lacrosse__gk_coach = 'coach_position__lacrosse__gk_coach',
  coach_position__lacrosse__head_coach = 'coach_position__lacrosse__head_coach',
  coach_position__lacrosse__playing_coach = 'coach_position__lacrosse__playing_coach',
  coach_position__long_distance_running__athletic_trainer = 'coach_position__long_distance_running__athletic_trainer',
  coach_position__long_distance_running__coach = 'coach_position__long_distance_running__coach',
  coach_position__long_distance_running__first_coach = 'coach_position__long_distance_running__first_coach',
  coach_position__long_distance_running__head_coach = 'coach_position__long_distance_running__head_coach',
  coach_position__long_distance_running__playing_coach = 'coach_position__long_distance_running__playing_coach',
  coach_position__long_jump__athletic_trainer = 'coach_position__long_jump__athletic_trainer',
  coach_position__long_jump__coach = 'coach_position__long_jump__coach',
  coach_position__long_jump__first_coach = 'coach_position__long_jump__first_coach',
  coach_position__long_jump__head_coach = 'coach_position__long_jump__head_coach',
  coach_position__long_jump__playing_coach = 'coach_position__long_jump__playing_coach',
  coach_position__luge__athletic_trainer = 'coach_position__luge__athletic_trainer',
  coach_position__luge__coach = 'coach_position__luge__coach',
  coach_position__luge__first_coach = 'coach_position__luge__first_coach',
  coach_position__luge__head_coach = 'coach_position__luge__head_coach',
  coach_position__luge__playing_coach = 'coach_position__luge__playing_coach',
  coach_position__marathon__athletic_trainer = 'coach_position__marathon__athletic_trainer',
  coach_position__marathon__coach = 'coach_position__marathon__coach',
  coach_position__marathon__first_coach = 'coach_position__marathon__first_coach',
  coach_position__marathon__head_coach = 'coach_position__marathon__head_coach',
  coach_position__marathon__playing_coach = 'coach_position__marathon__playing_coach',
  coach_position__marathon_swimming__athletic_trainer = 'coach_position__marathon_swimming__athletic_trainer',
  coach_position__marathon_swimming__coach = 'coach_position__marathon_swimming__coach',
  coach_position__marathon_swimming__first_coach = 'coach_position__marathon_swimming__first_coach',
  coach_position__marathon_swimming__head_coach = 'coach_position__marathon_swimming__head_coach',
  coach_position__men_decathlon__athletic_trainer = 'coach_position__men_decathlon__athletic_trainer',
  coach_position__men_decathlon__coach = 'coach_position__men_decathlon__coach',
  coach_position__men_decathlon__first_coach = 'coach_position__men_decathlon__first_coach',
  coach_position__men_decathlon__head_coach = 'coach_position__men_decathlon__head_coach',
  coach_position__men_decathlon__playing_coach = 'coach_position__men_decathlon__playing_coach',
  coach_position__middle_distance_running__athletic_trainer = 'coach_position__middle_distance_running__athletic_trainer',
  coach_position__middle_distance_running__coach = 'coach_position__middle_distance_running__coach',
  coach_position__middle_distance_running__first_coach = 'coach_position__middle_distance_running__first_coach',
  coach_position__middle_distance_running__head_coach = 'coach_position__middle_distance_running__head_coach',
  coach_position__middle_distance_running__playing_coach = 'coach_position__middle_distance_running__playing_coach',
  coach_position__modern_pentathlon__athletic_trainer = 'coach_position__modern_pentathlon__athletic_trainer',
  coach_position__modern_pentathlon__coach = 'coach_position__modern_pentathlon__coach',
  coach_position__modern_pentathlon__first_coach = 'coach_position__modern_pentathlon__first_coach',
  coach_position__modern_pentathlon__head_coach = 'coach_position__modern_pentathlon__head_coach',
  coach_position__modern_pentathlon__playing_coach = 'coach_position__modern_pentathlon__playing_coach',
  coach_position__nordic_skiing__athletic_trainer = 'coach_position__nordic_skiing__athletic_trainer',
  coach_position__nordic_skiing__coach = 'coach_position__nordic_skiing__coach',
  coach_position__nordic_skiing__first_coach = 'coach_position__nordic_skiing__first_coach',
  coach_position__nordic_skiing__head_coach = 'coach_position__nordic_skiing__head_coach',
  coach_position__nordic_skiing__playing_coach = 'coach_position__nordic_skiing__playing_coach',
  coach_position__pole_vault__athletic_trainer = 'coach_position__pole_vault__athletic_trainer',
  coach_position__pole_vault__coach = 'coach_position__pole_vault__coach',
  coach_position__pole_vault__first_coach = 'coach_position__pole_vault__first_coach',
  coach_position__pole_vault__head_coach = 'coach_position__pole_vault__head_coach',
  coach_position__pole_vault__playing_coach = 'coach_position__pole_vault__playing_coach',
  coach_position__race_walking__athletic_trainer = 'coach_position__race_walking__athletic_trainer',
  coach_position__race_walking__coach = 'coach_position__race_walking__coach',
  coach_position__race_walking__first_coach = 'coach_position__race_walking__first_coach',
  coach_position__race_walking__head_coach = 'coach_position__race_walking__head_coach',
  coach_position__race_walking__playing_coach = 'coach_position__race_walking__playing_coach',
  coach_position__racquetball__assistant_coach = 'coach_position__racquetball__assistant_coach',
  coach_position__racquetball__athletic_trainer = 'coach_position__racquetball__athletic_trainer',
  coach_position__racquetball__coach = 'coach_position__racquetball__coach',
  coach_position__racquetball__head_coach = 'coach_position__racquetball__head_coach',
  coach_position__rhythmic_gymnastics__athletic_trainer = 'coach_position__rhythmic_gymnastics__athletic_trainer',
  coach_position__rhythmic_gymnastics__coach = 'coach_position__rhythmic_gymnastics__coach',
  coach_position__rhythmic_gymnastics__first_coach = 'coach_position__rhythmic_gymnastics__first_coach',
  coach_position__rhythmic_gymnastics__head_coach = 'coach_position__rhythmic_gymnastics__head_coach',
  coach_position__rhythmic_gymnastics__playing_coach = 'coach_position__rhythmic_gymnastics__playing_coach',
  coach_position__roller__athletic_trainer = 'coach_position__roller__athletic_trainer',
  coach_position__roller__coach = 'coach_position__roller__coach',
  coach_position__roller__first_coach = 'coach_position__roller__first_coach',
  coach_position__roller__head_coach = 'coach_position__roller__head_coach',
  coach_position__roller__playing_coach = 'coach_position__roller__playing_coach',
  coach_position__rowing__athletic_trainer = 'coach_position__rowing__athletic_trainer',
  coach_position__rowing__coach = 'coach_position__rowing__coach',
  coach_position__rowing__first_coach = 'coach_position__rowing__first_coach',
  coach_position__rowing__head_coach = 'coach_position__rowing__head_coach',
  coach_position__rugby__assistant_coach = 'coach_position__rugby__assistant_coach',
  coach_position__rugby__athletic_trainer = 'coach_position__rugby__athletic_trainer',
  coach_position__rugby__coach = 'coach_position__rugby__coach',
  coach_position__rugby__defensive_coach = 'coach_position__rugby__defensive_coach',
  coach_position__rugby__fitness_coach = 'coach_position__rugby__fitness_coach',
  coach_position__rugby__head_coach = 'coach_position__rugby__head_coach',
  coach_position__rugby__offensive_coach = 'coach_position__rugby__offensive_coach',
  coach_position__rugby__playing_coach = 'coach_position__rugby__playing_coach',
  coach_position__rugby__scrum_coach = 'coach_position__rugby__scrum_coach',
  coach_position__rugby__skill_coach = 'coach_position__rugby__skill_coach',
  coach_position__rugby__strength_and_conditioning_coach = 'coach_position__rugby__strength_and_conditioning_coach',
  coach_position__rugby_sevens__assistant_coach = 'coach_position__rugby_sevens__assistant_coach',
  coach_position__rugby_sevens__athletic_trainer = 'coach_position__rugby_sevens__athletic_trainer',
  coach_position__rugby_sevens__coach = 'coach_position__rugby_sevens__coach',
  coach_position__rugby_sevens__defensive_coach = 'coach_position__rugby_sevens__defensive_coach',
  coach_position__rugby_sevens__fitness_coach = 'coach_position__rugby_sevens__fitness_coach',
  coach_position__rugby_sevens__head_coach = 'coach_position__rugby_sevens__head_coach',
  coach_position__rugby_sevens__offensive_coach = 'coach_position__rugby_sevens__offensive_coach',
  coach_position__rugby_sevens__playing_coach = 'coach_position__rugby_sevens__playing_coach',
  coach_position__rugby_sevens__scrum_coach = 'coach_position__rugby_sevens__scrum_coach',
  coach_position__rugby_sevens__skill_coach = 'coach_position__rugby_sevens__skill_coach',
  coach_position__rugby_sevens__strength_and_conditioning_coach = 'coach_position__rugby_sevens__strength_and_conditioning_coach',
  coach_position__sepak_takraw__athletic_trainer = 'coach_position__sepak_takraw__athletic_trainer',
  coach_position__sepak_takraw__coach = 'coach_position__sepak_takraw__coach',
  coach_position__sepak_takraw__first_coach = 'coach_position__sepak_takraw__first_coach',
  coach_position__sepak_takraw__head_coach = 'coach_position__sepak_takraw__head_coach',
  coach_position__sepak_takraw__playing_coach = 'coach_position__sepak_takraw__playing_coach',
  coach_position__shooting__athletic_trainer = 'coach_position__shooting__athletic_trainer',
  coach_position__shooting__coach = 'coach_position__shooting__coach',
  coach_position__shooting__first_coach = 'coach_position__shooting__first_coach',
  coach_position__shooting__head_coach = 'coach_position__shooting__head_coach',
  coach_position__shot_put__athletic_trainer = 'coach_position__shot_put__athletic_trainer',
  coach_position__shot_put__coach = 'coach_position__shot_put__coach',
  coach_position__shot_put__first_coach = 'coach_position__shot_put__first_coach',
  coach_position__shot_put__head_coach = 'coach_position__shot_put__head_coach',
  coach_position__shot_put__playing_coach = 'coach_position__shot_put__playing_coach',
  coach_position__show_jumping__assistant_coach = 'coach_position__show_jumping__assistant_coach',
  coach_position__show_jumping__athletic_trainer = 'coach_position__show_jumping__athletic_trainer',
  coach_position__show_jumping__coach = 'coach_position__show_jumping__coach',
  coach_position__show_jumping__head_coach = 'coach_position__show_jumping__head_coach',
  coach_position__show_jumping__playing_coach = 'coach_position__show_jumping__playing_coach',
  coach_position__skateboard__athletic_trainer = 'coach_position__skateboard__athletic_trainer',
  coach_position__skateboard__coach = 'coach_position__skateboard__coach',
  coach_position__skateboard__head_coach = 'coach_position__skateboard__head_coach',
  coach_position__skateboard__playing_coach = 'coach_position__skateboard__playing_coach',
  coach_position__skeleton__athletic_trainer = 'coach_position__skeleton__athletic_trainer',
  coach_position__skeleton__coach = 'coach_position__skeleton__coach',
  coach_position__skeleton__first_coach = 'coach_position__skeleton__first_coach',
  coach_position__skeleton__head_coach = 'coach_position__skeleton__head_coach',
  coach_position__skeleton__playing_coach = 'coach_position__skeleton__playing_coach',
  coach_position__ski_jumping__athletic_trainer = 'coach_position__ski_jumping__athletic_trainer',
  coach_position__ski_jumping__coach = 'coach_position__ski_jumping__coach',
  coach_position__ski_jumping__first_coach = 'coach_position__ski_jumping__first_coach',
  coach_position__ski_jumping__head_coach = 'coach_position__ski_jumping__head_coach',
  coach_position__ski_jumping__playing_coach = 'coach_position__ski_jumping__playing_coach',
  coach_position__ski_mountaineering__athletic_trainer = 'coach_position__ski_mountaineering__athletic_trainer',
  coach_position__ski_mountaineering__coach = 'coach_position__ski_mountaineering__coach',
  coach_position__ski_mountaineering__first_coach = 'coach_position__ski_mountaineering__first_coach',
  coach_position__ski_mountaineering__head_coach = 'coach_position__ski_mountaineering__head_coach',
  coach_position__ski_mountaineering__playing_coach = 'coach_position__ski_mountaineering__playing_coach',
  coach_position__snowboarding__athletic_trainer = 'coach_position__snowboarding__athletic_trainer',
  coach_position__snowboarding__coach = 'coach_position__snowboarding__coach',
  coach_position__snowboarding__first_coach = 'coach_position__snowboarding__first_coach',
  coach_position__snowboarding__head_coach = 'coach_position__snowboarding__head_coach',
  coach_position__snowboarding__playing_coach = 'coach_position__snowboarding__playing_coach',
  coach_position__soccer__athletic_trainer = 'coach_position__soccer__athletic_trainer',
  coach_position__soccer__coach = 'coach_position__soccer__coach',
  coach_position__soccer__first_coach = 'coach_position__soccer__first_coach',
  coach_position__soccer__fitness_coach = 'coach_position__soccer__fitness_coach',
  coach_position__soccer__gk_coach = 'coach_position__soccer__gk_coach',
  coach_position__soccer__head_coach = 'coach_position__soccer__head_coach',
  coach_position__soccer__playing_coach = 'coach_position__soccer__playing_coach',
  coach_position__soccer__tactical_coach = 'coach_position__soccer__tactical_coach',
  coach_position__soft_tennis__assistant_coach = 'coach_position__soft_tennis__assistant_coach',
  coach_position__soft_tennis__athletic_trainer = 'coach_position__soft_tennis__athletic_trainer',
  coach_position__soft_tennis__coach = 'coach_position__soft_tennis__coach',
  coach_position__soft_tennis__head_coach = 'coach_position__soft_tennis__head_coach',
  coach_position__softball__athletic_trainer = 'coach_position__softball__athletic_trainer',
  coach_position__softball__base_coach = 'coach_position__softball__base_coach',
  coach_position__softball__bench_coach = 'coach_position__softball__bench_coach',
  coach_position__softball__coach = 'coach_position__softball__coach',
  coach_position__softball__defensive_coach = 'coach_position__softball__defensive_coach',
  coach_position__softball__head_coach = 'coach_position__softball__head_coach',
  coach_position__softball__hitting_coach = 'coach_position__softball__hitting_coach',
  coach_position__softball__pitching_coach = 'coach_position__softball__pitching_coach',
  coach_position__softball__playing_coach = 'coach_position__softball__playing_coach',
  coach_position__sports_climbing__athletic_trainer = 'coach_position__sports_climbing__athletic_trainer',
  coach_position__sports_climbing__coach = 'coach_position__sports_climbing__coach',
  coach_position__sports_climbing__head_coach = 'coach_position__sports_climbing__head_coach',
  coach_position__sports_climbing__playing_coach = 'coach_position__sports_climbing__playing_coach',
  coach_position__sprint__athletic_trainer = 'coach_position__sprint__athletic_trainer',
  coach_position__sprint__coach = 'coach_position__sprint__coach',
  coach_position__sprint__first_coach = 'coach_position__sprint__first_coach',
  coach_position__sprint__head_coach = 'coach_position__sprint__head_coach',
  coach_position__sprint__playing_coach = 'coach_position__sprint__playing_coach',
  coach_position__squash__assistant_coach = 'coach_position__squash__assistant_coach',
  coach_position__squash__athletic_trainer = 'coach_position__squash__athletic_trainer',
  coach_position__squash__coach = 'coach_position__squash__coach',
  coach_position__squash__head_coach = 'coach_position__squash__head_coach',
  coach_position__ssireum__athletic_trainer = 'coach_position__ssireum__athletic_trainer',
  coach_position__ssireum__coach = 'coach_position__ssireum__coach',
  coach_position__ssireum__first_coach = 'coach_position__ssireum__first_coach',
  coach_position__ssireum__head_coach = 'coach_position__ssireum__head_coach',
  coach_position__ssireum__playing_coach = 'coach_position__ssireum__playing_coach',
  coach_position__surfing__athletic_trainer = 'coach_position__surfing__athletic_trainer',
  coach_position__surfing__coach = 'coach_position__surfing__coach',
  coach_position__surfing__first_coach = 'coach_position__surfing__first_coach',
  coach_position__surfing__head_coach = 'coach_position__surfing__head_coach',
  coach_position__swimming__athletic_trainer = 'coach_position__swimming__athletic_trainer',
  coach_position__swimming__coach = 'coach_position__swimming__coach',
  coach_position__swimming__first_coach = 'coach_position__swimming__first_coach',
  coach_position__swimming__head_coach = 'coach_position__swimming__head_coach',
  coach_position__table_tennis__assistant_coach = 'coach_position__table_tennis__assistant_coach',
  coach_position__table_tennis__athletic_trainer = 'coach_position__table_tennis__athletic_trainer',
  coach_position__table_tennis__coach = 'coach_position__table_tennis__coach',
  coach_position__table_tennis__head_coach = 'coach_position__table_tennis__head_coach',
  coach_position__taekwondo__athletic_trainer = 'coach_position__taekwondo__athletic_trainer',
  coach_position__taekwondo__coach = 'coach_position__taekwondo__coach',
  coach_position__taekwondo__first_coach = 'coach_position__taekwondo__first_coach',
  coach_position__taekwondo__head_coach = 'coach_position__taekwondo__head_coach',
  coach_position__taekwondo__playing_coach = 'coach_position__taekwondo__playing_coach',
  coach_position__takkyeon__athletic_trainer = 'coach_position__takkyeon__athletic_trainer',
  coach_position__takkyeon__coach = 'coach_position__takkyeon__coach',
  coach_position__takkyeon__first_coach = 'coach_position__takkyeon__first_coach',
  coach_position__takkyeon__head_coach = 'coach_position__takkyeon__head_coach',
  coach_position__takkyeon__playing_coach = 'coach_position__takkyeon__playing_coach',
  coach_position__tee_ball__athletic_trainer = 'coach_position__tee_ball__athletic_trainer',
  coach_position__tee_ball__coach = 'coach_position__tee_ball__coach',
  coach_position__tee_ball__first_coach = 'coach_position__tee_ball__first_coach',
  coach_position__tee_ball__head_coach = 'coach_position__tee_ball__head_coach',
  coach_position__tee_ball__playing_coach = 'coach_position__tee_ball__playing_coach',
  coach_position__tennis__assistant_coach = 'coach_position__tennis__assistant_coach',
  coach_position__tennis__athletic_trainer = 'coach_position__tennis__athletic_trainer',
  coach_position__tennis__coach = 'coach_position__tennis__coach',
  coach_position__tennis__head_coach = 'coach_position__tennis__head_coach',
  coach_position__trampoline__athletic_trainer = 'coach_position__trampoline__athletic_trainer',
  coach_position__trampoline__coach = 'coach_position__trampoline__coach',
  coach_position__trampoline__first_coach = 'coach_position__trampoline__first_coach',
  coach_position__trampoline__head_coach = 'coach_position__trampoline__head_coach',
  coach_position__trampoline__playing_coach = 'coach_position__trampoline__playing_coach',
  coach_position__triathlon__athletic_trainer = 'coach_position__triathlon__athletic_trainer',
  coach_position__triathlon__bike_coach = 'coach_position__triathlon__bike_coach',
  coach_position__triathlon__coach = 'coach_position__triathlon__coach',
  coach_position__triathlon__first_coach = 'coach_position__triathlon__first_coach',
  coach_position__triathlon__head_coach = 'coach_position__triathlon__head_coach',
  coach_position__triathlon__playing_coach = 'coach_position__triathlon__playing_coach',
  coach_position__triathlon__running_coach = 'coach_position__triathlon__running_coach',
  coach_position__triathlon__swimming_coach = 'coach_position__triathlon__swimming_coach',
  coach_position__triple_jump__athletic_trainer = 'coach_position__triple_jump__athletic_trainer',
  coach_position__triple_jump__coach = 'coach_position__triple_jump__coach',
  coach_position__triple_jump__first_coach = 'coach_position__triple_jump__first_coach',
  coach_position__triple_jump__head_coach = 'coach_position__triple_jump__head_coach',
  coach_position__triple_jump__playing_coach = 'coach_position__triple_jump__playing_coach',
  coach_position__volleyball__assistant_coach = 'coach_position__volleyball__assistant_coach',
  coach_position__volleyball__athletic_trainer = 'coach_position__volleyball__athletic_trainer',
  coach_position__volleyball__coach = 'coach_position__volleyball__coach',
  coach_position__volleyball__first_coach = 'coach_position__volleyball__first_coach',
  coach_position__volleyball__head_coach = 'coach_position__volleyball__head_coach',
  coach_position__volleyball__playing_coach = 'coach_position__volleyball__playing_coach',
  coach_position__water_polo__athletic_trainer = 'coach_position__water_polo__athletic_trainer',
  coach_position__water_polo__coach = 'coach_position__water_polo__coach',
  coach_position__water_polo__first_coach = 'coach_position__water_polo__first_coach',
  coach_position__water_polo__head_coach = 'coach_position__water_polo__head_coach',
  coach_position__water_skiing__athletic_trainer = 'coach_position__water_skiing__athletic_trainer',
  coach_position__water_skiing__coach = 'coach_position__water_skiing__coach',
  coach_position__water_skiing__first_coach = 'coach_position__water_skiing__first_coach',
  coach_position__water_skiing__head_coach = 'coach_position__water_skiing__head_coach',
  coach_position__weightlifting__assistant_coach = 'coach_position__weightlifting__assistant_coach',
  coach_position__weightlifting__athletic_trainer = 'coach_position__weightlifting__athletic_trainer',
  coach_position__weightlifting__coach = 'coach_position__weightlifting__coach',
  coach_position__weightlifting__head_coach = 'coach_position__weightlifting__head_coach',
  coach_position__weightlifting__playing_coach = 'coach_position__weightlifting__playing_coach',
  coach_position__women_heptathlon__athletic_trainer = 'coach_position__women_heptathlon__athletic_trainer',
  coach_position__women_heptathlon__coach = 'coach_position__women_heptathlon__coach',
  coach_position__women_heptathlon__first_coach = 'coach_position__women_heptathlon__first_coach',
  coach_position__women_heptathlon__head_coach = 'coach_position__women_heptathlon__head_coach',
  coach_position__women_heptathlon__playing_coach = 'coach_position__women_heptathlon__playing_coach',
  coach_position__wrestling__athletic_trainer = 'coach_position__wrestling__athletic_trainer',
  coach_position__wrestling__coach = 'coach_position__wrestling__coach',
  coach_position__wrestling__first_coach = 'coach_position__wrestling__first_coach',
  coach_position__wrestling__head_coach = 'coach_position__wrestling__head_coach',
  coach_position__wrestling__playing_coach = 'coach_position__wrestling__playing_coach',
  coach_position__yacht__athletic_trainer = 'coach_position__yacht__athletic_trainer',
  coach_position__yacht__coach = 'coach_position__yacht__coach',
  coach_position__yacht__first_coach = 'coach_position__yacht__first_coach',
  coach_position__yacht__head_coach = 'coach_position__yacht__head_coach',
  player_position__american_football__center = 'player_position__american_football__center',
  player_position__american_football__conner_back = 'player_position__american_football__conner_back',
  player_position__american_football__defensive_end = 'player_position__american_football__defensive_end',
  player_position__american_football__defensive_tackle = 'player_position__american_football__defensive_tackle',
  player_position__american_football__dime_back = 'player_position__american_football__dime_back',
  player_position__american_football__free_safety = 'player_position__american_football__free_safety',
  player_position__american_football__full_back = 'player_position__american_football__full_back',
  player_position__american_football__half_back = 'player_position__american_football__half_back',
  player_position__american_football__middle_linebacker = 'player_position__american_football__middle_linebacker',
  player_position__american_football__nickle_back = 'player_position__american_football__nickle_back',
  player_position__american_football__offensive_guard = 'player_position__american_football__offensive_guard',
  player_position__american_football__offensive_tackle = 'player_position__american_football__offensive_tackle',
  player_position__american_football__outside_linebacker = 'player_position__american_football__outside_linebacker',
  player_position__american_football__quarter_back = 'player_position__american_football__quarter_back',
  player_position__american_football__running_back = 'player_position__american_football__running_back',
  player_position__american_football__strong_safety = 'player_position__american_football__strong_safety',
  player_position__american_football__tight_end = 'player_position__american_football__tight_end',
  player_position__american_football__wide_receiver = 'player_position__american_football__wide_receiver',
  player_position__baseball__catcher = 'player_position__baseball__catcher',
  player_position__baseball__center_fielder = 'player_position__baseball__center_fielder',
  player_position__baseball__designated_hitter = 'player_position__baseball__designated_hitter',
  player_position__baseball__first_baseman = 'player_position__baseball__first_baseman',
  player_position__baseball__left_fielder = 'player_position__baseball__left_fielder',
  player_position__baseball__pitcher = 'player_position__baseball__pitcher',
  player_position__baseball__right_fielder = 'player_position__baseball__right_fielder',
  player_position__baseball__second_baseman = 'player_position__baseball__second_baseman',
  player_position__baseball__short_stop = 'player_position__baseball__short_stop',
  player_position__baseball__third_baseman = 'player_position__baseball__third_baseman',
  player_position__basketball__center = 'player_position__basketball__center',
  player_position__basketball__point_guard = 'player_position__basketball__point_guard',
  player_position__basketball__power_forward = 'player_position__basketball__power_forward',
  player_position__basketball__shooting_guard = 'player_position__basketball__shooting_guard',
  player_position__basketball__small_forward = 'player_position__basketball__small_forward',
  player_position__cricket__batsman = 'player_position__cricket__batsman',
  player_position__cricket__bowler = 'player_position__cricket__bowler',
  player_position__cricket__wicket = 'player_position__cricket__wicket',
  player_position__curling__lead = 'player_position__curling__lead',
  player_position__curling__second = 'player_position__curling__second',
  player_position__curling__skip = 'player_position__curling__skip',
  player_position__curling__vice = 'player_position__curling__vice',
  player_position__empty = 'player_position__empty',
  player_position__field_hockey__defense = 'player_position__field_hockey__defense',
  player_position__field_hockey__forward = 'player_position__field_hockey__forward',
  player_position__field_hockey__goalkeeper = 'player_position__field_hockey__goalkeeper',
  player_position__field_hockey__midfielder = 'player_position__field_hockey__midfielder',
  player_position__foot_volleyball__attacker = 'player_position__foot_volleyball__attacker',
  player_position__foot_volleyball__defender = 'player_position__foot_volleyball__defender',
  player_position__foot_volleyball__setter = 'player_position__foot_volleyball__setter',
  player_position__futsal__ala = 'player_position__futsal__ala',
  player_position__futsal__fixo = 'player_position__futsal__fixo',
  player_position__futsal__goleiro = 'player_position__futsal__goleiro',
  player_position__futsal__pivo = 'player_position__futsal__pivo',
  player_position__handball__center_back = 'player_position__handball__center_back',
  player_position__handball__goalkeeper = 'player_position__handball__goalkeeper',
  player_position__handball__left_back = 'player_position__handball__left_back',
  player_position__handball__left_wing = 'player_position__handball__left_wing',
  player_position__handball__pivot = 'player_position__handball__pivot',
  player_position__handball__right_back = 'player_position__handball__right_back',
  player_position__handball__right_wing = 'player_position__handball__right_wing',
  player_position__ice_hockey__center = 'player_position__ice_hockey__center',
  player_position__ice_hockey__goaltender = 'player_position__ice_hockey__goaltender',
  player_position__ice_hockey__left_defense = 'player_position__ice_hockey__left_defense',
  player_position__ice_hockey__left_wing = 'player_position__ice_hockey__left_wing',
  player_position__ice_hockey__right_defense = 'player_position__ice_hockey__right_defense',
  player_position__ice_hockey__right_wing = 'player_position__ice_hockey__right_wing',
  player_position__rugby__centre = 'player_position__rugby__centre',
  player_position__rugby__flanker = 'player_position__rugby__flanker',
  player_position__rugby__full_back = 'player_position__rugby__full_back',
  player_position__rugby__hooker = 'player_position__rugby__hooker',
  player_position__rugby__lock = 'player_position__rugby__lock',
  player_position__rugby__number_eight = 'player_position__rugby__number_eight',
  player_position__rugby__prop = 'player_position__rugby__prop',
  player_position__rugby__scrum_half = 'player_position__rugby__scrum_half',
  player_position__rugby__stand_off = 'player_position__rugby__stand_off',
  player_position__rugby__wing = 'player_position__rugby__wing',
  player_position__rugby_sevens__center = 'player_position__rugby_sevens__center',
  player_position__rugby_sevens__hooker = 'player_position__rugby_sevens__hooker',
  player_position__rugby_sevens__prop = 'player_position__rugby_sevens__prop',
  player_position__rugby_sevens__scrum_half = 'player_position__rugby_sevens__scrum_half',
  player_position__rugby_sevens__stand_off = 'player_position__rugby_sevens__stand_off',
  player_position__rugby_sevens__wing = 'player_position__rugby_sevens__wing',
  player_position__sepak_takraw__feeder = 'player_position__sepak_takraw__feeder',
  player_position__sepak_takraw__killer = 'player_position__sepak_takraw__killer',
  player_position__sepak_takraw__tekong = 'player_position__sepak_takraw__tekong',
  player_position__soccer__defense = 'player_position__soccer__defense',
  player_position__soccer__forward = 'player_position__soccer__forward',
  player_position__soccer__goalkeeper = 'player_position__soccer__goalkeeper',
  player_position__soccer__midfielder = 'player_position__soccer__midfielder',
  player_position__tee_ball__catcher = 'player_position__tee_ball__catcher',
  player_position__tee_ball__first_baseman = 'player_position__tee_ball__first_baseman',
  player_position__tee_ball__first_center_fielder = 'player_position__tee_ball__first_center_fielder',
  player_position__tee_ball__first_short_stop = 'player_position__tee_ball__first_short_stop',
  player_position__tee_ball__left_fielder = 'player_position__tee_ball__left_fielder',
  player_position__tee_ball__right_fielder = 'player_position__tee_ball__right_fielder',
  player_position__tee_ball__second_baseman = 'player_position__tee_ball__second_baseman',
  player_position__tee_ball__second_center_fielder = 'player_position__tee_ball__second_center_fielder',
  player_position__tee_ball__second_short_stop = 'player_position__tee_ball__second_short_stop',
  player_position__tee_ball__third_baseman = 'player_position__tee_ball__third_baseman',
  player_position__volleyball__libero = 'player_position__volleyball__libero',
  player_position__volleyball__middle_blocker = 'player_position__volleyball__middle_blocker',
  player_position__volleyball__opposite_spiker = 'player_position__volleyball__opposite_spiker',
  player_position__volleyball__outside_hitter = 'player_position__volleyball__outside_hitter',
  player_position__volleyball__setter = 'player_position__volleyball__setter'
}

export type SportsQuery = {
  __typename: 'SportsQuery';
  bodyPartGroups: Array<SportsBodyPartGroup>;
  bodyParts: Array<SportsBodyPart>;
  categories: Array<SportsCategoryCollection>;
  category: SportsCategoryCollection;
  categoryGroups: Array<SportsCategoryGroupCollection>;
  countryList: Array<Country>;
  regions: Array<Region>;
  team?: Maybe<SportsTeam>;
  teamsByPage: SportsTeamByPage;
  user?: Maybe<SportsUser>;
  usersByPage: SportsUserByPage;
  viewer?: Maybe<SportsUser>;
};


export type SportsQueryBodyPartsArgs = {
  groups?: Maybe<Array<SportsBodyPartGroupName>>;
  input: MultilingualTextInput;
};


export type SportsQueryCategoriesArgs = {
  groups?: Maybe<Array<Scalars['String']>>;
};


export type SportsQueryCategoryArgs = {
  id: Scalars['String'];
};


export type SportsQueryTeamArgs = {
  id: Scalars['ID'];
};


export type SportsQueryTeamsByPageArgs = {
  activeOnly?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<TeamFilterInput>;
  filterBy?: Maybe<TeamFilter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type SportsQueryUserArgs = {
  id: Scalars['ID'];
};


export type SportsQueryUsersByPageArgs = {
  activeOnly?: Maybe<Scalars['Boolean']>;
  filterBy?: Maybe<UserFilter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

/** 신체 raw 데이터  */
export type SportsRawBody = SportsRawData & TimeSerializable & {
  __typename: 'SportsRawBody';
  /** 신장 */
  height: Scalars['Float'];
  /** 신장 단위 */
  heightUnit?: Maybe<HeightUnit>;
  /** ID */
  id: Scalars['ID'];
  /** 이름 */
  name: SportsRawDataName;
  /** 시간 */
  time: Scalars['DateTimeString'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 유저 정보 */
  user: SportsUser;
  /** 체중 */
  weight: Scalars['Float'];
  /** 체중 단위 */
  weightUnit?: Maybe<WeightUnit>;
};

/** 컨디션 raw 데이터  */
export type SportsRawCondition = SportsRawData & TimeSerializable & {
  __typename: 'SportsRawCondition';
  /** ID */
  id: Scalars['ID'];
  /** 이름 */
  name: SportsRawDataName;
  /** 수면 raw 데이터 */
  rawSleep: SportsRawSleep;
  rawWellness: SportsRawWellness;
  /** 시간 */
  time: Scalars['DateTimeString'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 유저 정보 */
  user: SportsUser;
};

/** raw 데이터 */
export type SportsRawData = {
  /** ID */
  id: Scalars['ID'];
  /** 이름 */
  name: SportsRawDataName;
  /** 유저 정보 */
  user: SportsUser;
};

export enum SportsRawDataName {
  RAW_BODY = 'RAW_BODY',
  RAW_CONDITION = 'RAW_CONDITION',
  RAW_INJURY = 'RAW_INJURY',
  RAW_SLEEP = 'RAW_SLEEP',
  RAW_WELLNESS = 'RAW_WELLNESS',
  RAW_WORKLOAD = 'RAW_WORKLOAD'
}

/** 부상 raw 데이터 */
export type SportsRawInjury = Eventable & SportsRawData & TimeSerializable & {
  __typename: 'SportsRawInjury';
  /** 부위 */
  bodyPart: SportsBodyPart;
  /** 그룹 */
  bodyPartGroup: SportsBodyPartGroup;
  /** 댓글 */
  comment?: Maybe<Scalars['String']>;
  /** 일정 */
  event?: Maybe<EventInvitee>;
  /** ID */
  id: Scalars['ID'];
  /** 이름 */
  name: SportsRawDataName;
  /** 부상 위험 단위 */
  quality: Array<SportsInjuryQuality>;
  /** 일정 */
  schedule?: Maybe<ScheduleInvitee>;
  /** 통증 */
  soreness: Scalars['Int'];
  /** 시간 */
  time: Scalars['DateTimeString'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 부상 시기 */
  timing: Array<SportsInjuryTiming>;
  /** 유저 정보 */
  user: SportsUser;
};


/** 부상 raw 데이터 */
export type SportsRawInjuryScheduleArgs = {
  teamId?: Maybe<Scalars['ID']>;
};

/** 수면 raw 데이터 */
export type SportsRawSleep = SportsRawData & TimeSerializable & {
  __typename: 'SportsRawSleep';
  /** 수면 기간 */
  duration: Scalars['Int'];
  /** ID */
  id: Scalars['ID'];
  /** 이름 */
  name: SportsRawDataName;
  /** 수면 품질 */
  quality: Scalars['Int'];
  /** 시간 */
  time: Scalars['DateTimeString'];
  /** 시간 오프셋 */
  timeHourlyOffset: Scalars['Float'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 유저 정보 */
  user: SportsUser;
};

export type SportsRawWellness = SportsRawData & TimeSerializable & {
  __typename: 'SportsRawWellness';
  /** 피로도 */
  fatigue: Scalars['Int'];
  /** ID */
  id: Scalars['ID'];
  /** 기분 */
  mood: Scalars['Int'];
  /** 근육 */
  muscle: Scalars['Int'];
  /** 이름 */
  name: SportsRawDataName;
  /** 스트레스 */
  stress: Scalars['Int'];
  /** 시간 */
  time: Scalars['DateTimeString'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 유저 정보 */
  user: SportsUser;
};

/** 운동부하 raw 데이터 */
export type SportsRawWorkload = Eventable & SportsRawData & TimeSerializable & {
  __typename: 'SportsRawWorkload';
  /** 운동기간 */
  duration: Scalars['Int'];
  /** 일정 */
  event?: Maybe<EventInvitee>;
  /** ID */
  id: Scalars['ID'];
  /** 운동강도 */
  intensity: Scalars['Int'];
  /** 운동부하 */
  load: Scalars['Int'];
  /** 운동메모 */
  memo?: Maybe<Scalars['String']>;
  /** 이름 */
  name: SportsRawDataName;
  /** 운동만족 */
  satisfaction: Scalars['Int'];
  /** 일정 */
  schedule?: Maybe<ScheduleInvitee>;
  /** 시간 */
  time: Scalars['DateTimeString'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 운동 종류 */
  type: WorkoutType;
  /** 유저 정보 */
  user: SportsUser;
};


/** 운동부하 raw 데이터 */
export type SportsRawWorkloadScheduleArgs = {
  teamId?: Maybe<Scalars['ID']>;
};

export enum SportsRole {
  COACH = 'COACH',
  PARENT = 'PARENT',
  PLAYER = 'PLAYER'
}

/** 팀 정보 */
export type SportsTeam = {
  __typename: 'SportsTeam';
  /** 어드민 유저 목록 */
  adminUserList: SportsUserList;
  /** 관리자 소유자 유저 목록 */
  adminWithOwnerUserList: SportsUserList;
  /** 알림 목록 */
  alarmConnection: AlarmConnection;
  /** 스카우팅 기능을 사용할 수 있는지 여부 */
  canUseScouting: Scalars['Boolean'];
  /** 테크니컬 기능을 사용할 수 있는지 여부 */
  canUseTechnical: Scalars['Boolean'];
  /** 코드 */
  code: Scalars['String'];
  /** 생성일 */
  createdAt: Scalars['Date'];
  /** 팀 데이터 */
  data: Array<SportsTimeSeriesTeamData>;
  /** 엔터프라이즈 이용팀 전용 */
  enterpriseTeamInfo?: Maybe<EnterpriseTeamInfo>;
  /** 팀 그룹 정보 */
  group: TeamGroup;
  /** 그룹 목록 */
  groupList: Array<TeamGroup>;
  /** 피지컬 측정 컨텐츠 접속 가능 여부 */
  hasPhysicalMeasureContentAccess?: Maybe<Scalars['Boolean']>;
  /** 팀ID */
  id: Scalars['ID'];
  /** 부상 목록 */
  injuryList: Array<Injury>;
  /** 소개글 */
  introduction?: Maybe<Scalars['String']>;
  /** 웰컴 쿠폰 지급 여부 */
  isGivenWelcomeCoupon: Scalars['Boolean'];
  /** 라이센스 */
  license?: Maybe<License>;
  /** 맴버 유저 목록 */
  memberUserList: SportsUserList;
  /** 이름 */
  name: Scalars['String'];
  /** 읽지 않은 알람 */
  notCheckedAlarm: Scalars['Int'];
  /** 소유자 정보 */
  ownedBy: SportsUser;
  /** 보류 초대자 요청 목록 */
  pendingInvitationRequestList: Array<TeamInvitationRequest>;
  /** 프로필 사진 파일ID */
  pictureFileId?: Maybe<Scalars['String']>;
  /** 프로필 사진 url */
  pictureUrl?: Maybe<Scalars['String']>;
  /** 지역 */
  region: Region;
  /** 팀 스카우팅 데이터 */
  scouting: TeamScouting;
  /** export 버튼 유무 */
  showDataExportButton: Scalars['Boolean'];
  /** 팀슬러그 */
  slug?: Maybe<Scalars['String']>;
  /** 스포츠 카테고리 정보 */
  sportsCategory: SportsCategoryCollection;
  /** 팀 스포츠 데이터 */
  sportsData: TeamSportsData;
  /** 팀 유저 즐겨찾기 목록 */
  starredUserMaps: Array<SportsTeamUserStarred>;
  /** 구독 아이템 */
  subscriptionItem?: Maybe<SubscriptionItem>;
  /** 팀 피지컬 데이터 */
  teamPhysicalData?: Maybe<TeamPhysicalData>;
  teamPhysicalRoundList: Array<TeamPhysicalDataRound>;
  /** 전체 유저 수 */
  totalUserList: SportsUserList;
  /** 팀 종류 */
  type: TeamType;
  /** 수정일 */
  updatedAt: Scalars['Date'];
  /** 팀 유저 맵 페이징 목록 */
  userMapsByPage: SportsTeamUserMapByPage;
  /** 로그인된 유저가 팀에 가지는 권한 */
  viewerAuthority?: Maybe<SportsTeamAuthority>;
  /** 로그인된 유저의 팀 초대 요청 상태 */
  viewerInvitationRequestStatus: SportsTeamInvitationRequestStatus;
};


/** 팀 정보 */
export type SportsTeamAlarmConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Float']>;
  last?: Maybe<Scalars['Float']>;
  mode?: Maybe<Platform>;
  timezone: Scalars['String'];
};


/** 팀 정보 */
export type SportsTeamDataArgs = {
  filter?: Maybe<TeamUserMapForTeamDataFilterInput>;
  from: Scalars['DateTime'];
  names: Array<SportsTeamDataName>;
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


/** 팀 정보 */
export type SportsTeamGroupArgs = {
  id: Scalars['ID'];
};


/** 팀 정보 */
export type SportsTeamNotCheckedAlarmArgs = {
  mode?: Maybe<Platform>;
  timezone: Scalars['String'];
};


/** 팀 정보 */
export type SportsTeamStarredUserMapsArgs = {
  order?: Maybe<UserDataOrderByInput>;
  starerId: Scalars['ID'];
};


/** 팀 정보 */
export type SportsTeamTeamPhysicalDataArgs = {
  groupId?: Maybe<Scalars['String']>;
  measurementId?: Maybe<Scalars['String']>;
};


/** 팀 정보 */
export type SportsTeamUserMapsByPageArgs = {
  filter?: Maybe<TeamUserMapFilterInput>;
  filterBy?: Maybe<TeamUserFilter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<UserDataOrderByInput>;
};

export enum SportsTeamAuthority {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  OBSERVER = 'OBSERVER',
  OWNER = 'OWNER',
  PENDING_MEMBER = 'PENDING_MEMBER',
  VIEWER = 'VIEWER'
}

export type SportsTeamByPage = {
  __typename: 'SportsTeamByPage';
  entries: Array<SportsTeam>;
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type SportsTeamDataEntry = {
  __typename: 'SportsTeamDataEntry';
  meta?: Maybe<Scalars['JSON']>;
  time: Scalars['DateTimeString'];
  value?: Maybe<Scalars['JSON']>;
};

export enum SportsTeamDataName {
  TEAM_CONDITION_AVG = 'TEAM_CONDITION_AVG',
  TEAM_INJURY_BY_SORENESS = 'TEAM_INJURY_BY_SORENESS',
  TEAM_READINESS_AVG = 'TEAM_READINESS_AVG',
  TEAM_WORKLOAD_ACXR_AVG = 'TEAM_WORKLOAD_ACXR_AVG',
  TEAM_WORKLOAD_AVG = 'TEAM_WORKLOAD_AVG'
}

export type SportsTeamDataRange = {
  __typename: 'SportsTeamDataRange';
  entries: Array<SportsTeamDataEntry>;
  from: Scalars['DateTimeString'];
  to: Scalars['DateTimeString'];
};

/** 팀 초대 수락 input */
export type SportsTeamInvitationAcceptListInput = {
  /** 팀 요청 목록 */
  invitationRequestList: Array<InvitationRequest>;
  /** 팀 정보 */
  team: SportsTeamInvitationRejectTeam;
};

/** 팀 초대 거절 input */
export type SportsTeamInvitationRejectListInput = {
  /** 요청 ID 목록 */
  requestIdList: Array<Scalars['ID']>;
  /** 팀 정보 */
  team: SportsTeamInvitationRejectTeam;
};

/** 팀 초대 거절 input */
export type SportsTeamInvitationRejectTeam = {
  /** 팀 초대 ID */
  id: Scalars['ID'];
  /** 이름 */
  name: Scalars['String'];
};

/** 팀 초대 요청 */
export type SportsTeamInvitationRequest = {
  __typename: 'SportsTeamInvitationRequest';
  /** 생성일 */
  createdAt: Scalars['Date'];
  /** 팀 초대 요청 ID */
  id: Scalars['ID'];
  /** 포지션 */
  position?: Maybe<SportsPosition>;
  /** 역할 */
  role?: Maybe<SportsRole>;
  /** 팀초대 요청 상태 */
  status: SportsTeamInvitationRequestStatus;
  /** 팀 정보 */
  team: SportsTeam;
  /** 팀 권한 */
  teamAuthority?: Maybe<SportsTeamAuthority>;
  /** 수정일 */
  updatedAt: Scalars['Date'];
  /** 유저 정보 */
  user: SportsUser;
};

/** 팀 초대 요청 input */
export type SportsTeamInvitationRequestInput = {
  /** 팀 코드 */
  code: Scalars['String'];
  /** 포지션 */
  position?: Maybe<SportsPosition>;
  /** 역할 */
  role?: Maybe<SportsRole>;
  /** 팀 권한 */
  teamAuthority?: Maybe<SportsTeamAuthority>;
  /** 유저ID */
  userId: Scalars['ID'];
};

export enum SportsTeamInvitationRequestStatus {
  CONFIRMING = 'CONFIRMING',
  LEFT = 'LEFT',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

/** 팀 유저 맵 정보 */
export type SportsTeamUserMap = {
  __typename: 'SportsTeamUserMap';
  /** 메모 */
  comment?: Maybe<Scalars['String']>;
  /** 그룹 목록 */
  groups: Array<TeamGroup>;
  /** 팀유저맵ID */
  id: Scalars['ID'];
  /** 즐겨찾기 유무 */
  isStarredByViewer: Scalars['Boolean'];
  /** 피지컬 데이터 import 여부 */
  physicalImportType?: Maybe<PhysicalImportType>;
  /** 포지션 */
  position?: Maybe<SportsPosition>;
  /** 역할 */
  role?: Maybe<SportsRole>;
  /** 팀 정보 */
  team: SportsTeam;
  /** 팀 권한 정보 */
  teamAuthority: SportsTeamAuthority;
  /** 유저 정보 */
  user: SportsUser;
};

export type SportsTeamUserMapByPage = {
  __typename: 'SportsTeamUserMapByPage';
  entries: Array<SportsTeamUserMap>;
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

/** 팀유저 즐겨찾기 정보 */
export type SportsTeamUserStarred = {
  __typename: 'SportsTeamUserStarred';
  /** 로그인 된 유저에 의해 즐겨찾기 되었는지 여부 */
  isStarredByViewer: Scalars['Boolean'];
  /** 즐겨찾기를 한 유저 */
  starer: SportsUser;
  /** 팀 정보 */
  team: SportsTeam;
  /** 유저 정보 */
  user: SportsUser;
};

/** 운동부하 데이터 */
export type SportsTimeSeriesData = {
  __typename: 'SportsTimeSeriesData';
  /** 그룹 */
  group: SportsDataGroup;
  /** 이름 */
  name: SportsDataName;
  /** 범위 */
  ranges: Array<SportsDataRange>;
  /** 기간범위 */
  stride: SportsDataStride;
};


/** 운동부하 데이터 */
export type SportsTimeSeriesDataRangesArgs = {
  input: MultilingualTextInput;
};

/** 팀 데이터 */
export type SportsTimeSeriesTeamData = {
  __typename: 'SportsTimeSeriesTeamData';
  /** 팀 데이터명 */
  name: SportsTeamDataName;
  /** 범위 */
  ranges: Array<SportsTeamDataRange>;
  /** 기간 */
  stride: SportsDataStride;
};

/** 유저 정보 */
export type SportsUser = {
  __typename: 'SportsUser';
  /** 알림 목록 */
  alarmConnection: AlarmConnection;
  /** 앱 푸시 알림 설정 */
  appPushAlarmSetting?: Maybe<AppPushAlarmSetting>;
  /** 빌링 v2 목록 */
  billingList?: Maybe<Array<BillingV2>>;
  /** 생년월일 */
  birthdate?: Maybe<Scalars['String']>;
  body: UserBodyData;
  /** 선수 - 연결된 학부모 리스트 조회 */
  connectedParentList: Array<SportsUser>;
  /** 학부모 - 연결된 특정 선수 상세 조회 */
  connectedPlayer: SportsUser;
  /** 학부모 - 연결된 선수 리스트 조회 */
  connectedPlayerList: Array<SportsUser>;
  /** 학부모 - 선수와 연결 상태 확인 */
  connectedStatus?: Maybe<ConnectedStatus>;
  /** 쿠폰 목록 */
  couponList?: Maybe<Array<UserCoupon>>;
  /** 생성일 */
  createdAt: Scalars['Date'];
  currentInjuryList: Array<Injury>;
  /** 스포츠 데이터 */
  data: Array<SportsTimeSeriesData>;
  /** 디바이스 토큰 */
  deviceTokens?: Maybe<Array<Scalars['String']>>;
  /** 이메일 */
  email: Scalars['String'];
  /** 에센셜 트레이닝 솔루션 */
  essentialTrainingSolution: PersonalTrainingSolution;
  essentialTrainingSolutionPopup: Scalars['Boolean'];
  federation?: Maybe<Array<Scalars['String']>>;
  /** 피드백 페이징 목록 */
  feedbackConnection: FeedbackConnection;
  feedbackOnboardingPopup: Scalars['Boolean'];
  /** 피드백 제안 목록 */
  feedbackSuggestionList: Array<FeedbackSuggestion>;
  /** Parent, Player 이메일 조회 */
  findUserByEmail: SportsUser;
  /** 성별 */
  gender?: Maybe<Gender>;
  guideReopenStatus: GuideReopenStatus;
  /** 학부모 - 선수와 연결 여부 확인 */
  hasConnectedPlayer: Scalars['Boolean'];
  /** 학부모 - 연결된 선수 최초 조회 여부 조회 */
  hasUnreadConnection: Scalars['Boolean'];
  /** 유저ID */
  id: Scalars['ID'];
  /** 키클록 ID */
  identityId: Scalars['String'];
  /** 부상 */
  injury?: Maybe<Injury>;
  /** 소개 */
  introduction?: Maybe<Scalars['String']>;
  isFirstTermsEntry?: Maybe<Scalars['Boolean']>;
  /** 즐겨찾기 유무 */
  isStarredBy: Scalars['Boolean'];
  /** 최신 신체 raw 데이터 */
  latestRawBody?: Maybe<SportsRawBody>;
  /** 이름 */
  name?: Maybe<Scalars['String']>;
  /** 국가 */
  nationality?: Maybe<CountryCode>;
  /** 안 읽은 알림 */
  notCheckedAlarm: Scalars['Float'];
  pastInjuryList: Array<Injury>;
  /** 결제 v2 */
  payment?: Maybe<PaymentV2>;
  /** 결제 v2 목록 */
  paymentList?: Maybe<Array<PaymentV2>>;
  /** 전화번호 */
  phoneNumber?: Maybe<Scalars['String']>;
  /** 피지컬 데이터 목록 */
  physicalDataList?: Maybe<Array<PhysicalData>>;
  /** 피지컬 리포트 상세 */
  physicalReport?: Maybe<PhysicalReportDetail>;
  /** 피지컬 리포트 목록 */
  physicalReportList?: Maybe<Array<PhysicalReport>>;
  /** 피지컬 솔루션 */
  physicalSolution?: Maybe<PhysicalSolution>;
  /** 프로필 사진 파일 ID */
  pictureFileId?: Maybe<Scalars['String']>;
  /** 프로필 사진 url */
  pictureUrl?: Maybe<Scalars['String']>;
  /** 종목 */
  priorSportsCategory?: Maybe<SportsCategoryCollection>;
  /** 포지션 */
  priorSportsPosition?: Maybe<SportsPosition>;
  /** 역할 */
  priorSportsRole?: Maybe<SportsRole>;
  /** 일정 컨디션 체크 리마인드 푸시 */
  pushConditionCheckReminderSchedule?: Maybe<Scalars['String']>;
  pushConditionReminderAllowed: Scalars['Boolean'];
  /** 리마인드 푸시 동의 */
  pushReminderAllowed: Scalars['Boolean'];
  /** 일정 운동부하 체크 리마인드 푸시 */
  pushWorkloadCheckReminderSchedule?: Maybe<Scalars['String']>;
  pushWorkloadReminderAllowed: Scalars['Boolean'];
  /** 신체 raw 데이터 */
  rawBody: SportsRawBody;
  /** 컨디션 raw 데이터 */
  rawCondition: SportsRawCondition;
  /** raw 데이터 커서 */
  rawDataByCursor: RawDataByCursor;
  /** 부상 raw 데이터 */
  rawInjury: SportsRawInjury;
  /** 수면 raw 데이터 */
  rawSleep: SportsRawSleep;
  /** 웰니스 raw 데이터 */
  rawWellness: SportsRawWellness;
  /** 운동부하 raw 데이터 */
  rawWorkload: SportsRawWorkload;
  recentSorenessRecoveryList?: Maybe<Array<SportsBodyPart>>;
  /** 나의 할 일 목록 */
  routineList: Array<Routine>;
  /** 일정 */
  schedule: PlayerSchedule;
  scoutingAuthority?: Maybe<ScoutingAuthorityType>;
  /** 결제 배송지 목록 */
  shipmentList?: Maybe<Array<Shipment>>;
  /** 슬러그 */
  slug?: Maybe<Scalars['String']>;
  sorenessHistory: SportsUserSorenessHistory;
  /** 스포츠 데이터 */
  sportsData?: Maybe<SportsData>;
  /** 스포츠 데이터 목록 */
  sportsDataList: Array<SportsData>;
  /** 구독 v2 상세 목록 */
  subscriptionDetailList?: Maybe<Array<SubscriptionV2Detail>>;
  /** 구독 v2 목록 */
  subscriptionList?: Maybe<Array<SubscriptionV2Simple>>;
  /** 팀 목록 */
  teamList: Array<SportsTeam>;
  /** 팀 목록 for 코치 */
  teamListForCoach: Array<SportsTeam>;
  /** 유저 팀맵 */
  teamMaps: Array<SportsTeamUserMap>;
  /** 유저 팀맵 페이징 */
  teamMapsByPage: SportsTeamUserMapByPage;
  /** 팀 페이징 */
  teamsByPage: SportsTeamByPage;
  /** 약관 동의 */
  termAgreement?: Maybe<TermAgreement>;
  /** 전체 피드백 갯수 */
  totalFeedbackCount: Scalars['Int'];
  /** 번역된 국적 이름 */
  translatedNationality?: Maybe<Scalars['String']>;
  /** 번역된 종목 이름 */
  translatedSportsCategory?: Maybe<Scalars['String']>;
  /** 번역된 포지션 */
  translatedSportsPosition?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt: Scalars['Date'];
  /** 운동부하 데이터 */
  workload: Array<UserWorkloadData>;
};


/** 유저 정보 */
export type SportsUserAlarmConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Float']>;
  last?: Maybe<Scalars['Float']>;
  timezone: Scalars['String'];
};


/** 유저 정보 */
export type SportsUserBodyArgs = {
  date: Scalars['DateTime'];
  heightUnit?: HeightUnit;
  weightUnit?: WeightUnit;
};


/** 유저 정보 */
export type SportsUserConnectedPlayerArgs = {
  userId: Scalars['String'];
};


/** 유저 정보 */
export type SportsUserCurrentInjuryListArgs = {
  teamId: Scalars['ID'];
};


/** 유저 정보 */
export type SportsUserDataArgs = {
  from?: Maybe<Scalars['DateTime']>;
  groups?: Maybe<Array<SportsDataGroup>>;
  names?: Maybe<Array<SportsDataName>>;
  raw?: Maybe<Scalars['Boolean']>;
  stride?: Maybe<SportsDataStride>;
  timezone: Scalars['String'];
  to?: Maybe<Scalars['DateTime']>;
};


/** 유저 정보 */
export type SportsUserFeedbackConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Float']>;
  last?: Maybe<Scalars['Float']>;
  teamId?: Maybe<Scalars['ID']>;
  typeList?: Maybe<Array<FeedbackType>>;
};


/** 유저 정보 */
export type SportsUserFeedbackSuggestionListArgs = {
  teamId: Scalars['ID'];
  timezone: Scalars['String'];
};


/** 유저 정보 */
export type SportsUserFindUserByEmailArgs = {
  email: Scalars['String'];
};


/** 유저 정보 */
export type SportsUserIsStarredByArgs = {
  starerId: Scalars['ID'];
  teamId: Scalars['ID'];
};


/** 유저 정보 */
export type SportsUserLatestRawBodyArgs = {
  cursor?: Maybe<Scalars['DateTime']>;
  heightUnit?: HeightUnit;
  timezone: Scalars['String'];
  weightUnit?: WeightUnit;
};


/** 유저 정보 */
export type SportsUserNotCheckedAlarmArgs = {
  timezone: Scalars['String'];
};


/** 유저 정보 */
export type SportsUserPastInjuryListArgs = {
  teamId: Scalars['ID'];
};


/** 유저 정보 */
export type SportsUserPaymentArgs = {
  id: Scalars['Float'];
};


/** 유저 정보 */
export type SportsUserPhysicalReportArgs = {
  id: Scalars['ID'];
};


/** 유저 정보 */
export type SportsUserPhysicalReportListArgs = {
  userId?: Maybe<Scalars['String']>;
};


/** 유저 정보 */
export type SportsUserRawBodyArgs = {
  heightUnit?: HeightUnit;
  id: Scalars['ID'];
  weightUnit?: WeightUnit;
};


/** 유저 정보 */
export type SportsUserRawConditionArgs = {
  id: Scalars['ID'];
};


/** 유저 정보 */
export type SportsUserRawSleepArgs = {
  id: Scalars['ID'];
};


/** 유저 정보 */
export type SportsUserRawWellnessArgs = {
  id: Scalars['ID'];
};


/** 유저 정보 */
export type SportsUserRawWorkloadArgs = {
  id: Scalars['ID'];
};


/** 유저 정보 */
export type SportsUserRecentSorenessRecoveryListArgs = {
  from: Scalars['DateTime'];
  input: MultilingualTextInput;
  to: Scalars['DateTime'];
};


/** 유저 정보 */
export type SportsUserRoutineListArgs = {
  cursor?: Maybe<Scalars['DateTime']>;
  timezone?: Maybe<Scalars['String']>;
};


/** 유저 정보 */
export type SportsUserSportsDataArgs = {
  date: Scalars['String'];
  timezone: Scalars['String'];
};


/** 유저 정보 */
export type SportsUserSportsDataListArgs = {
  from: Scalars['DateTime'];
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


/** 유저 정보 */
export type SportsUserSubscriptionDetailListArgs = {
  userId?: Maybe<Scalars['String']>;
};


/** 유저 정보 */
export type SportsUserSubscriptionListArgs = {
  userId?: Maybe<Scalars['String']>;
};


/** 유저 정보 */
export type SportsUserTeamMapsByPageArgs = {
  filter?: Maybe<TeamUserMapFilterInput>;
  filterBy?: Maybe<TeamUserFilter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<TeamMapOrderByInput>;
};


/** 유저 정보 */
export type SportsUserTeamsByPageArgs = {
  activeOnly?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<TeamFilterInput>;
  filterBy?: Maybe<TeamFilter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** 유저 정보 */
export type SportsUserTranslatedNationalityArgs = {
  input: MultilingualTextInput;
};


/** 유저 정보 */
export type SportsUserTranslatedSportsCategoryArgs = {
  input: MultilingualTextInput;
};


/** 유저 정보 */
export type SportsUserTranslatedSportsPositionArgs = {
  input: MultilingualTextInput;
};


/** 유저 정보 */
export type SportsUserWorkloadArgs = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type SportsUserByPage = {
  __typename: 'SportsUserByPage';
  entries: Array<SportsUser>;
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type SportsUserList = {
  __typename: 'SportsUserList';
  count: Scalars['Int'];
  userList: Array<SportsUser>;
};

/** 통증 데이터 */
export type SportsUserSorenessDataValue = {
  __typename: 'SportsUserSorenessDataValue';
  /** 결측 데이터 유무 */
  isFake?: Maybe<Scalars['Boolean']>;
  /** 단계 */
  level?: Maybe<Scalars['Int']>;
  /** 날짜 */
  time: Scalars['DateTimeString'];
};

export type SportsUserSorenessHistory = {
  __typename: 'SportsUserSorenessHistory';
  /** 최근 통증 데이터 */
  recentData: SportsUserSorenessRecentData;
  /** 최근 통증 데이터 */
  sorenessTrend: SportsUserSorenessTrend;
};


export type SportsUserSorenessHistoryRecentDataArgs = {
  bodyPart: SportsBodyPartName;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type SportsUserSorenessHistorySorenessTrendArgs = {
  bodyPart: SportsBodyPartName;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

/** 최근 통증 데이터 */
export type SportsUserSorenessRecentData = {
  __typename: 'SportsUserSorenessRecentData';
  /** 부위 */
  bodyPart: SportsBodyPart;
  /** 다음 데이터 유무 */
  hasNext: Scalars['Boolean'];
  /** 전체 데이터 수 */
  total: Scalars['Int'];
  /** 통증 데이터 */
  values: Array<SportsUserSorenessRecentDataValue>;
};


/** 최근 통증 데이터 */
export type SportsUserSorenessRecentDataBodyPartArgs = {
  input: MultilingualTextInput;
};

/** 최근 통증 데이터 */
export type SportsUserSorenessRecentDataValue = {
  __typename: 'SportsUserSorenessRecentDataValue';
  isContact?: Maybe<Contact>;
  /** 단계 */
  level: Scalars['Int'];
  /** 메모 */
  memo: Scalars['String'];
  /** 날짜 */
  time: Scalars['DateTimeString'];
};

/** 통증 추세 */
export type SportsUserSorenessTrend = {
  __typename: 'SportsUserSorenessTrend';
  /** 부위 */
  bodyPart: SportsBodyPart;
  /** 통증 추세 */
  trend: Array<SportsUserSorenessDataValue>;
};


/** 통증 추세 */
export type SportsUserSorenessTrendBodyPartArgs = {
  input: MultilingualTextInput;
};

export type StarredToggleResult = {
  __typename: 'StarredToggleResult';
  /** 상태 */
  status: Scalars['Boolean'];
};

/** 구독 시작 input */
export type StartSubscriptionInput = {
  /** 이메일 */
  buyerEmail: Scalars['String'];
  /** 이름 */
  buyerName: Scalars['String'];
  /** 전화번호 */
  buyerTel: Scalars['String'];
  /** 쿠폰 ID */
  couponId?: Maybe<Scalars['ID']>;
  /** 플랜ID */
  planId: Scalars['ID'];
  /** 플랜 옵션 ID */
  planOptionId: Scalars['ID'];
  /** 구독 ID */
  subscriptionId?: Maybe<Scalars['ID']>;
  /** 팀ID */
  teamId: Scalars['ID'];
};

/** 구독 v2 시작 input */
export type StartSubscriptionInputV2 = {
  /** 빌링ID */
  billingId: Scalars['ID'];
  /** 결제 유저 이메일 */
  buyerEmail: Scalars['String'];
  /** 결제 유저 이름 */
  buyerName: Scalars['String'];
  /** 결제 유저 전화번호 */
  buyerPhoneNumber: Scalars['String'];
  /** 쿠폰ID */
  couponId?: Maybe<Scalars['ID']>;
  /** 플랜ID */
  planId: Scalars['ID'];
  /** 대신 결제할 유저 ID */
  playerId?: Maybe<Scalars['String']>;
  /** 쉐이크 상품 코드 */
  productCode?: Maybe<ProductCode>;
  /** 배송ID */
  shipmentId?: Maybe<Scalars['ID']>;
};

/** 통계 정보 */
export type Statistic = {
  __typename: 'Statistic';
  /** 평균값 */
  avg: Scalars['Float'];
  /** 최대값 */
  max: Scalars['Float'];
  /** 최소값 */
  min: Scalars['Float'];
  /** 합 */
  sum: Scalars['Float'];
};


/** 팀 구독 정보 */
export type SubscriptionItem = {
  __typename: 'SubscriptionItem';
  /** 쿠폰 정보 */
  coupon: UseCoupon;
  /** 최초 결제일 */
  cycleAnchor?: Maybe<Scalars['String']>;
  /** 종료일 */
  endAt: Scalars['Date'];
  /** 팀ID */
  id: Scalars['ID'];
  /** 인보이스 페이징 목록 */
  invoicesByPage: InvoiceList;
  /** 활성 상태 유무 */
  isActivate: Scalars['Boolean'];
  /** 무료 트리얼 유무 */
  isFreeTrial: Scalars['Boolean'];
  /** 구독 환불 가능 여부 */
  isRefundable: Scalars['Boolean'];
  /** 구독 갱신 예정 여부 */
  isSubscripting: Scalars['Boolean'];
  /** 플랜, 플랜옵션 */
  plan: PlanWithOption;
  /** 플랜ID */
  planId: Scalars['String'];
  /** 플랜옵션 ID */
  planOptionId: Scalars['String'];
  /** 시작일 */
  startAt: Scalars['Date'];
  /** 상태 */
  status: SubscriptionStatusEnum;
  /** 팀ID */
  teamId: Scalars['String'];
};


/** 팀 구독 정보 */
export type SubscriptionItemInvoicesByPageArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

/** 구독 응답 */
export type SubscriptionResponse = {
  __typename: 'SubscriptionResponse';
  /** 인보이스 정보 목록 */
  paymentList: Array<Invoice>;
  /** 구독 정보 */
  subscription: SubscriptionItem;
};

export enum SubscriptionStatusEnum {
  ACTIVATE = 'ACTIVATE',
  GRACE_PERIOD = 'GRACE_PERIOD',
  INACTIVATE = 'INACTIVATE'
}

/** 구독 v2 상세 정보 */
export type SubscriptionV2Detail = {
  __typename: 'SubscriptionV2Detail';
  /** 빌링 v2 정보 */
  billing?: Maybe<BillingV2>;
  /** 취소 가능여부 */
  canCancel: Scalars['Boolean'];
  /** 환불 가능여부 */
  canRefund: Scalars['Boolean'];
  /** 종료일 */
  endAt: Scalars['String'];
  /** 구독ID */
  id: Scalars['ID'];
  /** 다음 쿠폰 할인 가격 */
  nextCouponDeductedAmount?: Maybe<Scalars['Float']>;
  /** 다음 결제일 */
  nextPaymentAt: Scalars['String'];
  /** 다음 플랜 v2 */
  nextPlan?: Maybe<PlanV2>;
  /** 다음 결제 가격 */
  nextPriceAmount?: Maybe<Scalars['Float']>;
  /** 플랜 v2 정보 */
  plan: PlanV2;
  /** 쉐이크 상품 코드 */
  productCode?: Maybe<ProductCode>;
  /** 배송지 정보 */
  shipment?: Maybe<Shipment>;
  /** 시작일 */
  startAt: Scalars['String'];
  /** 구독 상태 */
  status: SubscriptionV2Type;
};

/** 구독 v2 정보 */
export type SubscriptionV2Simple = {
  __typename: 'SubscriptionV2Simple';
  /** 종료일 */
  endAt?: Maybe<Scalars['String']>;
  /** 구독ID */
  id: Scalars['ID'];
  /** 플랜v2 정보 */
  plan: PlanV2;
};

export enum SubscriptionV2Type {
  ACTIVE = 'ACTIVE',
  CANCEL_REQUEST = 'CANCEL_REQUEST',
  GRACE_PERIOD = 'GRACE_PERIOD',
  INACTIVE = 'INACTIVE'
}

/** 구독 v2 빌링, 플랜 정보 */
export type SubscriptionV2WithBillingAndPlanAndShipment = {
  __typename: 'SubscriptionV2WithBillingAndPlanAndShipment';
  /** 빌링 v2 정보 */
  billing: BillingV2;
  /** 종료일 */
  endAt: Scalars['String'];
  /** 구독ID */
  id: Scalars['ID'];
  /** 다음 결제일 */
  nextPaymentAt: Scalars['String'];
  /** 플랜 정보 */
  plan: PlanV2;
  /** 배송지 정보 */
  shipment?: Maybe<Shipment>;
  /** 시작일 */
  startAt: Scalars['String'];
};

/** 팀 매치 이벤트 (개인) 임포트 파일 컬럼 제안 */
export type SuggestPlayerMatchEventDataName = {
  __typename: 'SuggestPlayerMatchEventDataName';
  /** 임포트 파일 컬럼명 */
  fileColumnName: Scalars['String'];
  /** 임포트 파일 컬럼명에 대한 제안 */
  suggestedDataName?: Maybe<PlayerMatchEventDataName>;
};

/** 팀 GPS 임포트 파일 컬럼 제안 */
export type SuggestTeamGpsDataName = {
  __typename: 'SuggestTeamGpsDataName';
  /** 임포트 파일 컬럼명 */
  fileColumnName: Scalars['String'];
  /** 임포트 파일 컬럼명에 대한 제안 */
  suggestedDataName?: Maybe<GpsDataName>;
};

/** 팀 매치 이벤트 (팀) 임포트 파일 컬럼 제안 */
export type SuggestTeamMatchEventDataName = {
  __typename: 'SuggestTeamMatchEventDataName';
  /** 임포트 파일 컬럼명 */
  fileColumnName: Scalars['String'];
  /** 임포트 파일 컬럼명에 대한 제안 */
  suggestedDataName?: Maybe<TeamMatchEventDataName>;
};

/** 팀 피지컬 임포트 파일 컬럼 제안 */
export type SuggestTeamPhysicalDataName = {
  __typename: 'SuggestTeamPhysicalDataName';
  /** 임포트 파일 컬럼명 */
  fileColumnName: Scalars['String'];
  /** 임포트 파일 컬럼명에 대한 제안 */
  suggestedDataName?: Maybe<PhysicalDataName>;
};

export enum SymptomType {
  EFFUSION = 'EFFUSION',
  ENTER_DIRECTLY = 'ENTER_DIRECTLY',
  GIVING_WAY = 'GIVING_WAY',
  HEATING = 'HEATING',
  PAIN = 'PAIN',
  STIFFNESS = 'STIFFNESS',
  TENDERNESS = 'TENDERNESS'
}

/** 관찰 리포트 전술 평가 */
export type Tactic = {
  __typename: 'Tactic';
  /** 판단력 */
  decisionMaking?: Maybe<Scalars['Float']>;
  /** 게임 통찰력 */
  gameInsight?: Maybe<Scalars['Float']>;
  /** 포지셔닝 */
  positioning?: Maybe<Scalars['Float']>;
  /** 세트피스 공격 */
  setPieceAttack?: Maybe<Scalars['Float']>;
  /** 세트피스 수비 */
  setPieceDefense?: Maybe<Scalars['Float']>;
  /** 공간 창출 */
  spaceCreation?: Maybe<Scalars['Float']>;
  /** 전술 이해도 */
  tacticalUnderstanding?: Maybe<Scalars['Float']>;
  /** 팀 커뮤니케이션 */
  teamCommunication?: Maybe<Scalars['Float']>;
};

export enum TacticMetricType {
  DECISION_MAKING = 'DECISION_MAKING',
  GAME_INSIGHT = 'GAME_INSIGHT',
  POSITIONING = 'POSITIONING',
  SET_PIECE_ATTACK = 'SET_PIECE_ATTACK',
  SET_PIECE_DEFENSE = 'SET_PIECE_DEFENSE',
  SPACE_CREATION = 'SPACE_CREATION',
  TACTICAL_UNDERSTANDING = 'TACTICAL_UNDERSTANDING',
  TEAM_COMMUNICATION = 'TEAM_COMMUNICATION'
}

/** 관찰 리포트 전술 평가 input */
export type TacticObservationReportInput = {
  /** 판단력 */
  decisionMaking?: Maybe<Scalars['Int']>;
  /** 게임 통찰력 */
  gameInsight?: Maybe<Scalars['Int']>;
  /** 포지셔닝 */
  positioning?: Maybe<Scalars['Int']>;
  /** 세트피스 공격 */
  setPieceAttack?: Maybe<Scalars['Int']>;
  /** 세트피스 수비 */
  setPieceDefense?: Maybe<Scalars['Int']>;
  /** 공간 창출 */
  spaceCreation?: Maybe<Scalars['Int']>;
  /** 전술 이해도 */
  tacticalUnderstanding?: Maybe<Scalars['Int']>;
  /** 팀 커뮤니케이션 */
  teamCommunication?: Maybe<Scalars['Int']>;
};

/** 스카우팅 모델 전술 기준 input */
export type TacticScoutingModelInput = {
  /** 판단력 */
  decisionMaking?: Maybe<Scalars['Int']>;
  /** 게임 통찰력 */
  gameInsight?: Maybe<Scalars['Int']>;
  /** 포지셔닝 */
  positioning?: Maybe<Scalars['Int']>;
  /** 세트피스 공격 */
  setPieceAttack?: Maybe<Scalars['Int']>;
  /** 세트피스 수비 */
  setPieceDefense?: Maybe<Scalars['Int']>;
  /** 공간 창출 */
  spaceCreation?: Maybe<Scalars['Int']>;
  /** 전술 이해도 */
  tacticalUnderstanding?: Maybe<Scalars['Int']>;
  /** 팀 커뮤니케이션 */
  teamCommunication?: Maybe<Scalars['Int']>;
};

/** 타겟 옵션 */
export type TargetOption = {
  __typename: 'TargetOption';
  /** 배너 연산자 */
  operator: OptionOperator;
  /** 배너 옵션 */
  option: Option;
  /** 배너 값 */
  value: Scalars['StringOrFloat'];
};

/** 타겟 옵션 input */
export type TargetOptionInput = {
  /** 배너 연산자 */
  operator: OptionOperator;
  /** 배너 옵션 */
  option: Option;
  /** 배너 값 */
  value: Scalars['StringOrFloat'];
};

/** 팀 가용률 정보 */
export type TeamAvailability = {
  __typename: 'TeamAvailability';
  /** 날짜별 가용률 목록 */
  dateList: Array<DateAvailability>;
  /** 선수 가용 여부 목록 */
  userDataList: Array<UserAvailability>;
};

/** 팀 미체크 알림 발송 스케줄 */
export type TeamCheckReminderSchedule = {
  __typename: 'TeamCheckReminderSchedule';
  /** 팀 미체크 알림 발송 스케줄 ID */
  id: Scalars['ID'];
  /** 메시지 타입 */
  pushMessageType: ReminderPushMessageType;
  /** 전송 시간 */
  scheduleTime: Scalars['String'];
  /** 팀 정보 */
  team: SportsTeam;
};

/** 팀 미체크 알림 발송 스케줄 페이징 목록 */
export type TeamCheckReminderScheduleByPage = {
  __typename: 'TeamCheckReminderScheduleByPage';
  /** 팀 미체크 알림 발송 스케줄 목록 */
  teamCheckReminderScheduleList: Array<TeamCheckReminderSchedule>;
  /** 전체 데이터 수 */
  total: Scalars['Float'];
};

/** 팀 미체크 알림 발송 스케줄 필터 input */
export type TeamCheckReminderScheduleFilter = {
  /** 메시지 타입 */
  pushMessageTypeList?: Maybe<Array<ReminderPushMessageType>>;
  /** 전송시간 목록 */
  scheduleTimeList?: Maybe<Array<Scalars['String']>>;
};

/** 팀 컨디션 */
export type TeamCondition = {
  __typename: 'TeamCondition';
  /** 날짜별 팀 컨디션 평균 목록 및 점수 평균 */
  avg: TeamConditionAvgInfo;
  /** 팀 선수 컨디션 데이터 목록 및 평균 */
  individualData: TeamConditionIndividualData;
};


/** 팀 컨디션 */
export type TeamConditionAvgArgs = {
  from: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
  to: Scalars['String'];
};


/** 팀 컨디션 */
export type TeamConditionIndividualDataArgs = {
  date: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
};

/** 팀 컨디션 평균 */
export type TeamConditionAvg = ConditionInfo & {
  __typename: 'TeamConditionAvg';
  /** 피로도 */
  fatigue?: Maybe<Scalars['Float']>;
  /** 기분 */
  mood?: Maybe<Scalars['Float']>;
  /** 근육 */
  muscle?: Maybe<Scalars['Float']>;
  /** 컨디션 점수 */
  score?: Maybe<Scalars['Float']>;
  /** 수면 시간 */
  sleepDuration?: Maybe<Scalars['Float']>;
  /** 수면 품질 */
  sleepQuality?: Maybe<Scalars['Float']>;
  /** 스트레스 */
  stress?: Maybe<Scalars['Float']>;
};

/** 날짜별 팀 컨디션 평균 */
export type TeamConditionAvgInfo = {
  __typename: 'TeamConditionAvgInfo';
  /** 날짜별 컨디션 평균 목록 */
  dateList: Array<TeamConditionDateAvg>;
  /** 날짜별 컨디션 점수 평균의 평균 */
  scoreAvg?: Maybe<Scalars['Float']>;
};

/** 컨디션 비교 분석 */
export type TeamConditionCompareAnalysis = {
  __typename: 'TeamConditionCompareAnalysis';
  /** 컨디션 비교 분석 대상 목록 */
  compareTargetList: Array<TeamConditionCompareTarget>;
  /** 팀 컨디션 기준 */
  teamThreshold?: Maybe<TeamConditionThreshold>;
};

/** 팀 컨디션 비교 분석 대상 */
export type TeamConditionCompareTarget = ConditionInfo & {
  __typename: 'TeamConditionCompareTarget';
  /** 피로도 */
  fatigue?: Maybe<Scalars['Float']>;
  /** 비교 분석 대상 ID (user || group || team) */
  id: Scalars['String'];
  /** 기분 */
  mood?: Maybe<Scalars['Float']>;
  /** 근육 */
  muscle?: Maybe<Scalars['Float']>;
  /** 컨디션 점수 */
  score?: Maybe<Scalars['Float']>;
  /** 수면 시간 */
  sleepDuration?: Maybe<Scalars['Float']>;
  /** 수면 품질 */
  sleepQuality?: Maybe<Scalars['Float']>;
  /** 스트레스 */
  stress?: Maybe<Scalars['Float']>;
};

/** 날짜별 팀 컨디션 평균 */
export type TeamConditionDateAvg = ConditionInfo & {
  __typename: 'TeamConditionDateAvg';
  /** 날짜 */
  date: Scalars['String'];
  /** 피로도 */
  fatigue?: Maybe<Scalars['Float']>;
  /** 기분 */
  mood?: Maybe<Scalars['Float']>;
  /** 근육 */
  muscle?: Maybe<Scalars['Float']>;
  /** 컨디션 점수 */
  score?: Maybe<Scalars['Float']>;
  /** 수면 시간 */
  sleepDuration?: Maybe<Scalars['Float']>;
  /** 수면 품질 */
  sleepQuality?: Maybe<Scalars['Float']>;
  /** 스트레스 */
  stress?: Maybe<Scalars['Float']>;
};

/** 팀 선수 컨디션 데이터 목록 및 평균 */
export type TeamConditionIndividualData = {
  __typename: 'TeamConditionIndividualData';
  /** 팀 선수 컨디션 평균 */
  avg: TeamConditionAvg;
  /** 팀 선수 컨디션 데이터 목록 */
  userDataList: Array<TeamConditionUser>;
};

/** 팀 컨디션 기준 */
export type TeamConditionThreshold = ConditionInfo & {
  __typename: 'TeamConditionThreshold';
  /** 피로도 */
  fatigue?: Maybe<Scalars['Float']>;
  /** 기분 */
  mood?: Maybe<Scalars['Float']>;
  /** 근육 */
  muscle?: Maybe<Scalars['Float']>;
  /** 컨디션 점수 */
  score?: Maybe<Scalars['Float']>;
  /** 수면 시간 */
  sleepDuration?: Maybe<Scalars['Float']>;
  /** 수면 품질 */
  sleepQuality?: Maybe<Scalars['Float']>;
  /** 스트레스 */
  stress?: Maybe<Scalars['Float']>;
};

/** 유저 컨디션 */
export type TeamConditionUser = ConditionInfo & {
  __typename: 'TeamConditionUser';
  /** 피로도 */
  fatigue?: Maybe<Scalars['Float']>;
  /** 기분 */
  mood?: Maybe<Scalars['Float']>;
  /** 근육 */
  muscle?: Maybe<Scalars['Float']>;
  /** 컨디션 점수 */
  score?: Maybe<Scalars['Float']>;
  /** 수면 시간 */
  sleepDuration?: Maybe<Scalars['Float']>;
  /** 수면 품질 */
  sleepQuality?: Maybe<Scalars['Float']>;
  /** 스트레스 */
  stress?: Maybe<Scalars['Float']>;
  /** 선수 정보 */
  user: SportsUser;
};

/** 팀 쿠폰 아이템 정보 */
export type TeamCouponItem = {
  __typename: 'TeamCouponItem';
  /** 코드 */
  code: Scalars['String'];
  /** 종료일 */
  endAt?: Maybe<Scalars['Date']>;
  /** 팀ID */
  ownerToken: Scalars['String'];
  /** 시작일 */
  startAt?: Maybe<Scalars['Date']>;
  /** 상태 */
  state: CouponItemStateType;
  /** 팀 정보 */
  team: SportsTeam;
  /** 중도 해지일 */
  terminatedAt?: Maybe<Scalars['Date']>;
  /** 사용횟수 */
  useCount: Scalars['Int'];
};

/** 팀 쿠폰 아이템 페이징 목록 */
export type TeamCouponItemByPage = Page & {
  __typename: 'TeamCouponItemByPage';
  /** 팀 쿠폰 아이템 */
  content?: Maybe<Array<TeamCouponItem>>;
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

/** 팀데이터 선수 데이터 신체 */
export type TeamDataPlayerDataBody = {
  __typename: 'TeamDataPlayerDataBody';
  /** bmi */
  bmi?: Maybe<Scalars['Float']>;
  /** 키 */
  height?: Maybe<Scalars['Float']>;
  /** 권장 수분 섭취량 */
  recommendedHydration?: Maybe<Scalars['Float']>;
  /** 유저 정보 */
  user?: Maybe<SportsUser>;
  /** 체중 */
  weight?: Maybe<Scalars['Float']>;
};

/** 팀데이터 선수 데이터 컨디션 */
export type TeamDataPlayerDataCondition = {
  __typename: 'TeamDataPlayerDataCondition';
  /** 컨디션 점수 */
  condition?: Maybe<Scalars['Float']>;
  /** 피로도 */
  fatigue?: Maybe<Scalars['Float']>;
  /** 기분 */
  mood?: Maybe<Scalars['Float']>;
  /** 근육 */
  muscle?: Maybe<Scalars['Float']>;
  /** 수면 기간 */
  sleepDuration?: Maybe<Scalars['Float']>;
  /** 수면 품질 */
  sleepQuality?: Maybe<Scalars['Float']>;
  /** 스트레스 */
  stress?: Maybe<Scalars['Float']>;
  /** 유저 정보 */
  user?: Maybe<SportsUser>;
};

/** 팀 데이터 선수 데이터 통증 */
export type TeamDataPlayerDataSoreness = {
  __typename: 'TeamDataPlayerDataSoreness';
  /** 1단계 */
  level1?: Maybe<Array<TeamDataPlayerDataSorenessBodyPart>>;
  /** 2단계 */
  level2?: Maybe<Array<TeamDataPlayerDataSorenessBodyPart>>;
  /** 3단계 */
  level3?: Maybe<Array<TeamDataPlayerDataSorenessBodyPart>>;
  /** 4단계 */
  level4?: Maybe<Array<TeamDataPlayerDataSorenessBodyPart>>;
  /** 5단계 */
  level5?: Maybe<Array<TeamDataPlayerDataSorenessBodyPart>>;
  /** 유저 정보 */
  user?: Maybe<SportsUser>;
};

/** 팀 데이터 선수 데이터 통증 부위 */
export type TeamDataPlayerDataSorenessBodyPart = {
  __typename: 'TeamDataPlayerDataSorenessBodyPart';
  /** 통증ID */
  id?: Maybe<Scalars['String']>;
  /** 값 */
  value?: Maybe<Scalars['String']>;
};

/** 팀 데이터 선수 데이터 운동부하 */
export type TeamDataPlayerDataWorkload = {
  __typename: 'TeamDataPlayerDataWorkload';
  /** acwr */
  acwr?: Maybe<Scalars['Float']>;
  /** 급성부하 */
  aw?: Maybe<Scalars['Float']>;
  /** 단조로움 */
  awd?: Maybe<Scalars['Float']>;
  /** 만성부하 */
  cw?: Maybe<Scalars['Float']>;
  /** 팀 데이터 선수데이터 운동부하 상세 목록 */
  list?: Maybe<Array<TeamDataPlayerDataWorkloadDetail>>;
  /** 운동 안 함 이유 */
  reasonForNoWorkout?: Maybe<NoWorkoutType>;
  /** 유저 정보 */
  user?: Maybe<SportsUser>;
  /** 운동부하 */
  workload?: Maybe<Scalars['Float']>;
};

/** 팀 데이터 선수 데이터 운동부하 상세 */
export type TeamDataPlayerDataWorkloadDetail = {
  __typename: 'TeamDataPlayerDataWorkloadDetail';
  /** 운동시간 */
  duration: Scalars['Float'];
  /** 운동부하ID */
  id: Scalars['String'];
  /** 운동강도 */
  intensity: Scalars['Float'];
  /** 피드백 생성 여부 */
  isFeedbackCreated: Scalars['Boolean'];
  /** 다른팀 운동부하 유무 */
  isOtherTeamWorkload: Scalars['Boolean'];
  /** 운동부하 */
  load: Scalars['Float'];
  /** 운동메모 */
  memo: Scalars['String'];
  /** 운동만족 */
  satisfaction: Scalars['Float'];
  /** 일정명 */
  scheduleName?: Maybe<Scalars['String']>;
  /** 시간 */
  time: Scalars['String'];
  /** 종류 */
  workloadType: WorkloadType;
};

/** 팀 데이터 추이 */
export type TeamDataTrend = {
  __typename: 'TeamDataTrend';
  /** 컨디션 목록 */
  conditionList?: Maybe<Array<TeamDataTrendCondition>>;
  /** 준비도 목록 */
  readinessList?: Maybe<Array<TeamDataTrendReadiness>>;
  /** 통증 목록 */
  sorenessList?: Maybe<Array<TeamDataTrendSoreness>>;
  /** 운동부하 목록 */
  workloadList?: Maybe<Array<TeamDataTrendWorkload>>;
};

/** 팀 데이터 추이 컨디션 */
export type TeamDataTrendCondition = {
  __typename: 'TeamDataTrendCondition';
  /** 컨디션 점수 */
  condition?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 피로도 */
  fatigue?: Maybe<Scalars['Float']>;
  /** 기분 */
  mood?: Maybe<Scalars['Float']>;
  /** 근육 */
  muscle?: Maybe<Scalars['Float']>;
  /** 수면기간 */
  sleepDuration?: Maybe<Scalars['Float']>;
  /** 수면품질 */
  sleepQuality?: Maybe<Scalars['Float']>;
  /** 스트레스 */
  stress?: Maybe<Scalars['Float']>;
};

/** 팀 데이터 추이 준비도 */
export type TeamDataTrendReadiness = {
  __typename: 'TeamDataTrendReadiness';
  /** 날짜 */
  date: Scalars['String'];
  /** 준비도 */
  readiness?: Maybe<Scalars['Float']>;
};

/** 팀 데이터 추이 통증 */
export type TeamDataTrendSoreness = {
  __typename: 'TeamDataTrendSoreness';
  /** 날짜 */
  date: Scalars['String'];
  /** 1단계 */
  level1?: Maybe<Array<TeamDataTrendSorenessUserBodyPart>>;
  /** 2단계 */
  level2?: Maybe<Array<TeamDataTrendSorenessUserBodyPart>>;
  /** 3단계 */
  level3?: Maybe<Array<TeamDataTrendSorenessUserBodyPart>>;
  /** 4단계 */
  level4?: Maybe<Array<TeamDataTrendSorenessUserBodyPart>>;
  /** 5단계 */
  level5?: Maybe<Array<TeamDataTrendSorenessUserBodyPart>>;
};

/** 팀 데이터 추이 통증 유저별 부위 */
export type TeamDataTrendSorenessUserBodyPart = {
  __typename: 'TeamDataTrendSorenessUserBodyPart';
  /** 부위  */
  bodyPartNameList: Array<Scalars['String']>;
  /** 유저 이름 */
  name?: Maybe<Scalars['String']>;
};

/** 팀 데이터 추이 운동부하 */
export type TeamDataTrendWorkload = {
  __typename: 'TeamDataTrendWorkload';
  /** acwr */
  acwr?: Maybe<Scalars['Float']>;
  /** 급성부하 */
  aw?: Maybe<Scalars['Float']>;
  /** 단조로움 */
  awd?: Maybe<Scalars['Float']>;
  /** 만성부하 */
  cw?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 운동부하 */
  workload?: Maybe<Scalars['Float']>;
};

/** 팀 세션 드릴 별 운동부하 평균 */
export type TeamDrillWorkloadInfo = ExternalWorkloadInfo & {
  __typename: 'TeamDrillWorkloadInfo';
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 accelerationB2_3TotalCount 최댓값 대비 해당 세션의 accelerationB2_3TotalCount 비율 */
  accelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 가속 횟수 */
  accelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 가속 횟수 */
  accelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 가속 횟수 */
  accelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 평균 심박수 */
  averageHeartRate?: Maybe<Scalars['Float']>;
  /** 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeet?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetRight?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 decelerationB2_3TotalCount 최댓값 대비 해당 세션의 decelerationB2_3TotalCount 비율 */
  decelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 감속 횟수 */
  decelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 감속 횟수 */
  decelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 감속 횟수 */
  decelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 분당 이동거리 */
  distancePerMinute?: Maybe<Scalars['Float']>;
  /** 심박 기반 세션 부하 지표 */
  heartRateExertion?: Maybe<Scalars['Float']>;
  /** 대사적으로 높은 부하가 걸리는 상황에서 이동한 거리 */
  highMetabolicLoadDistance?: Maybe<Scalars['Float']>;
  /** 분당 고속주행 거리 */
  hsrPerMinute?: Maybe<Scalars['Float']>;
  /** 고강도 가속 이벤트 수 */
  imaAccelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 가속 이벤트 수 */
  imaAccelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 가속 이벤트 수 */
  imaAccelerationMedium?: Maybe<Scalars['Float']>;
  /** 고강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftHigh?: Maybe<Scalars['Float']>;
  /** 저강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftLow?: Maybe<Scalars['Float']>;
  /** 중강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftMedium?: Maybe<Scalars['Float']>;
  /** 고강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightHigh?: Maybe<Scalars['Float']>;
  /** 저강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightLow?: Maybe<Scalars['Float']>;
  /** 중강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightMedium?: Maybe<Scalars['Float']>;
  /** 고강도 감속 이벤트 수 */
  imaDecelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 감속 이벤트 수 */
  imaDecelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 감속 이벤트 수 */
  imaDecelerationMedium?: Maybe<Scalars['Float']>;
  /** B4 구간 점프 착지 횟수 */
  imaJumpCountBand4?: Maybe<Scalars['Float']>;
  /** 고강도 점프 착지 횟수 */
  imaJumpCountHighBand?: Maybe<Scalars['Float']>;
  /** 저강도 점프 착지 횟수 */
  imaJumpCountLowBand?: Maybe<Scalars['Float']>;
  /** 중강도 점프 착지 횟수 */
  imaJumpCountMediumBand?: Maybe<Scalars['Float']>;
  /** 최대 가속도 */
  maximumAcceleration?: Maybe<Scalars['Float']>;
  /** 최대 감속도 */
  maximumDeceleration?: Maybe<Scalars['Float']>;
  /** 최대 심박수 */
  maximumHeartRate?: Maybe<Scalars['Float']>;
  /** 최고 속력 */
  maximumSpeed?: Maybe<Scalars['Float']>;
  /** 선수 개인의 maximumSpeed 최댓값 대비 해당 세션의 maximumSpeed 비율 */
  maximumSpeedPerMax?: Maybe<Scalars['Float']>;
  /** 최대 힘 발휘해내는 능력 */
  metaEnergy?: Maybe<Scalars['Float']>;
  /** 드릴 이름 */
  name: Scalars['String'];
  /** 좌우 다리 간 부하의 비대칭성 */
  runningImbalance?: Maybe<Scalars['Float']>;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 총 뛴 거리 기반 ACWR */
  totalDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalDistance 최댓값 대비 해당 세션의 totalDistance 비율 */
  totalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 다이브 한 횟수 */
  totalDiveCount?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 횟수 */
  totalDiveCountCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 횟수 */
  totalDiveCountLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 횟수 */
  totalDiveCountRight?: Maybe<Scalars['Float']>;
  /** 다이브 함으로써 생긴 부하 */
  totalDiveLoad?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadRight?: Maybe<Scalars['Float']>;
  /** 운동한 시간 */
  totalDuration?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** HSR 거리 기반 ACWR */
  totalHsrDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalHsrDistance 최댓값 대비 해당 세션의 totalHsrDistance 비율 */
  totalHsrDistancePerMax?: Maybe<Scalars['Float']>;
  /** 점프한 총 횟수 */
  totalJumpCount?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  totalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이상 횟수 */
  velocityB4TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이상 횟수 */
  velocityB5TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이상 횟수 */
  velocityB6TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동거리 */
  velocityBand1TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동시간 */
  velocityBand1TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동거리 */
  velocityBand2TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동시간 */
  velocityBand2TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동거리 */
  velocityBand3TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동시간 */
  velocityBand3TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동거리 */
  velocityBand4TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동시간 */
  velocityBand4TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동거리 */
  velocityBand5TotalDistance?: Maybe<Scalars['Float']>;
  /** 선수 개인의 velocityBand5TotalDistance 최댓값 대비 해당 세션의 velocityBand5TotalDistance 비율 */
  velocityBand5TotalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동시간 */
  velocityBand5TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동거리 */
  velocityBand6TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동시간 */
  velocityBand6TotalDuration?: Maybe<Scalars['Float']>;
};

/** 팀 외적부하 */
export type TeamExternalWorkload = {
  __typename: 'TeamExternalWorkload';
  /** 세션별 팀 외적부하 평균 */
  avg: TeamExternalWorkloadSessionAvg;
  /** 팀 선수 외적부하 데이터 목록 및 평균 */
  individualData: TeamExternalWorkloadIndividualData;
};


/** 팀 외적부하 */
export type TeamExternalWorkloadAvgArgs = {
  from: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
  to: Scalars['String'];
};


/** 팀 외적부하 */
export type TeamExternalWorkloadIndividualDataArgs = {
  groupId?: Maybe<Scalars['ID']>;
  scheduleId: Scalars['ID'];
};

/** 팀 외적부하 평균 */
export type TeamExternalWorkloadAvg = ExternalWorkloadInfo & {
  __typename: 'TeamExternalWorkloadAvg';
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 accelerationB2_3TotalCount 최댓값 대비 해당 세션의 accelerationB2_3TotalCount 비율 */
  accelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 가속 횟수 */
  accelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 가속 횟수 */
  accelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 가속 횟수 */
  accelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 평균 심박수 */
  averageHeartRate?: Maybe<Scalars['Float']>;
  /** 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeet?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetRight?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 decelerationB2_3TotalCount 최댓값 대비 해당 세션의 decelerationB2_3TotalCount 비율 */
  decelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 감속 횟수 */
  decelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 감속 횟수 */
  decelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 감속 횟수 */
  decelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 분당 이동거리 */
  distancePerMinute?: Maybe<Scalars['Float']>;
  /** 심박 기반 세션 부하 지표 */
  heartRateExertion?: Maybe<Scalars['Float']>;
  /** 대사적으로 높은 부하가 걸리는 상황에서 이동한 거리 */
  highMetabolicLoadDistance?: Maybe<Scalars['Float']>;
  /** 분당 고속주행 거리 */
  hsrPerMinute?: Maybe<Scalars['Float']>;
  /** 고강도 가속 이벤트 수 */
  imaAccelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 가속 이벤트 수 */
  imaAccelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 가속 이벤트 수 */
  imaAccelerationMedium?: Maybe<Scalars['Float']>;
  /** 고강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftHigh?: Maybe<Scalars['Float']>;
  /** 저강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftLow?: Maybe<Scalars['Float']>;
  /** 중강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftMedium?: Maybe<Scalars['Float']>;
  /** 고강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightHigh?: Maybe<Scalars['Float']>;
  /** 저강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightLow?: Maybe<Scalars['Float']>;
  /** 중강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightMedium?: Maybe<Scalars['Float']>;
  /** 고강도 감속 이벤트 수 */
  imaDecelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 감속 이벤트 수 */
  imaDecelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 감속 이벤트 수 */
  imaDecelerationMedium?: Maybe<Scalars['Float']>;
  /** B4 구간 점프 착지 횟수 */
  imaJumpCountBand4?: Maybe<Scalars['Float']>;
  /** 고강도 점프 착지 횟수 */
  imaJumpCountHighBand?: Maybe<Scalars['Float']>;
  /** 저강도 점프 착지 횟수 */
  imaJumpCountLowBand?: Maybe<Scalars['Float']>;
  /** 중강도 점프 착지 횟수 */
  imaJumpCountMediumBand?: Maybe<Scalars['Float']>;
  /** 최대 가속도 */
  maximumAcceleration?: Maybe<Scalars['Float']>;
  /** 최대 감속도 */
  maximumDeceleration?: Maybe<Scalars['Float']>;
  /** 최대 심박수 */
  maximumHeartRate?: Maybe<Scalars['Float']>;
  /** 최고 속력 */
  maximumSpeed?: Maybe<Scalars['Float']>;
  /** 선수 개인의 maximumSpeed 최댓값 대비 해당 세션의 maximumSpeed 비율 */
  maximumSpeedPerMax?: Maybe<Scalars['Float']>;
  /** 최대 힘 발휘해내는 능력 */
  metaEnergy?: Maybe<Scalars['Float']>;
  /** 좌우 다리 간 부하의 비대칭성 */
  runningImbalance?: Maybe<Scalars['Float']>;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 총 뛴 거리 기반 ACWR */
  totalDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalDistance 최댓값 대비 해당 세션의 totalDistance 비율 */
  totalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 다이브 한 횟수 */
  totalDiveCount?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 횟수 */
  totalDiveCountCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 횟수 */
  totalDiveCountLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 횟수 */
  totalDiveCountRight?: Maybe<Scalars['Float']>;
  /** 다이브 함으로써 생긴 부하 */
  totalDiveLoad?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadRight?: Maybe<Scalars['Float']>;
  /** 운동한 시간 */
  totalDuration?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** HSR 거리 기반 ACWR */
  totalHsrDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalHsrDistance 최댓값 대비 해당 세션의 totalHsrDistance 비율 */
  totalHsrDistancePerMax?: Maybe<Scalars['Float']>;
  /** 점프한 총 횟수 */
  totalJumpCount?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  totalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이상 횟수 */
  velocityB4TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이상 횟수 */
  velocityB5TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이상 횟수 */
  velocityB6TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동거리 */
  velocityBand1TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동시간 */
  velocityBand1TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동거리 */
  velocityBand2TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동시간 */
  velocityBand2TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동거리 */
  velocityBand3TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동시간 */
  velocityBand3TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동거리 */
  velocityBand4TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동시간 */
  velocityBand4TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동거리 */
  velocityBand5TotalDistance?: Maybe<Scalars['Float']>;
  /** 선수 개인의 velocityBand5TotalDistance 최댓값 대비 해당 세션의 velocityBand5TotalDistance 비율 */
  velocityBand5TotalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동시간 */
  velocityBand5TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동거리 */
  velocityBand6TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동시간 */
  velocityBand6TotalDuration?: Maybe<Scalars['Float']>;
};

/** 팀 외적부하 데이터 임포트 히스토리 */
export type TeamExternalWorkloadImportHistory = {
  __typename: 'TeamExternalWorkloadImportHistory';
  accelerationB2_3TotalCount: Scalars['Boolean'];
  accelerationB2_3TotalCountPerMax: Scalars['Boolean'];
  accelerationBand1TotalCount: Scalars['Boolean'];
  accelerationBand2TotalCount: Scalars['Boolean'];
  accelerationBand3TotalCount: Scalars['Boolean'];
  averageHeartRate: Scalars['Boolean'];
  averageTimeToFeet: Scalars['Boolean'];
  averageTimeToFeetCentre: Scalars['Boolean'];
  averageTimeToFeetLeft: Scalars['Boolean'];
  averageTimeToFeetRight: Scalars['Boolean'];
  countOfSprint: Scalars['Boolean'];
  decelerationB2_3TotalCount: Scalars['Boolean'];
  decelerationB2_3TotalCountPerMax: Scalars['Boolean'];
  decelerationBand1TotalCount: Scalars['Boolean'];
  decelerationBand2TotalCount: Scalars['Boolean'];
  decelerationBand3TotalCount: Scalars['Boolean'];
  distancePerMinute: Scalars['Boolean'];
  heartRateExertion: Scalars['Boolean'];
  highMetabolicLoadDistance: Scalars['Boolean'];
  hsrPerMinute: Scalars['Boolean'];
  id: Scalars['ID'];
  imaAccelerationHigh: Scalars['Boolean'];
  imaAccelerationLow: Scalars['Boolean'];
  imaAccelerationMedium: Scalars['Boolean'];
  imaCodLeftHigh: Scalars['Boolean'];
  imaCodLeftLow: Scalars['Boolean'];
  imaCodLeftMedium: Scalars['Boolean'];
  imaCodRightHigh: Scalars['Boolean'];
  imaCodRightLow: Scalars['Boolean'];
  imaCodRightMedium: Scalars['Boolean'];
  imaDecelerationHigh: Scalars['Boolean'];
  imaDecelerationLow: Scalars['Boolean'];
  imaDecelerationMedium: Scalars['Boolean'];
  imaJumpCountBand4: Scalars['Boolean'];
  imaJumpCountHighBand: Scalars['Boolean'];
  imaJumpCountLowBand: Scalars['Boolean'];
  imaJumpCountMediumBand: Scalars['Boolean'];
  maximumAcceleration: Scalars['Boolean'];
  maximumDeceleration: Scalars['Boolean'];
  maximumHeartRate: Scalars['Boolean'];
  maximumSpeed: Scalars['Boolean'];
  maximumSpeedPerMax: Scalars['Boolean'];
  metaEnergy: Scalars['Boolean'];
  runningImbalance: Scalars['Boolean'];
  totalDistance: Scalars['Boolean'];
  totalDistanceAcwr: Scalars['Boolean'];
  totalDistancePerMax: Scalars['Boolean'];
  totalDiveCount: Scalars['Boolean'];
  totalDiveCountCentre: Scalars['Boolean'];
  totalDiveCountLeft: Scalars['Boolean'];
  totalDiveCountRight: Scalars['Boolean'];
  totalDiveLoad: Scalars['Boolean'];
  totalDiveLoadCentre: Scalars['Boolean'];
  totalDiveLoadLeft: Scalars['Boolean'];
  totalDiveLoadRight: Scalars['Boolean'];
  totalDuration: Scalars['Boolean'];
  totalHsrDistance: Scalars['Boolean'];
  totalHsrDistanceAcwr: Scalars['Boolean'];
  totalHsrDistancePerMax: Scalars['Boolean'];
  totalJumpCount: Scalars['Boolean'];
  totalPlayerLoad: Scalars['Boolean'];
  totalRhieBout: Scalars['Boolean'];
  velocityB4TotalCount: Scalars['Boolean'];
  velocityB5TotalCount: Scalars['Boolean'];
  velocityB6TotalCount: Scalars['Boolean'];
  velocityBand1TotalDistance: Scalars['Boolean'];
  velocityBand1TotalDuration: Scalars['Boolean'];
  velocityBand2TotalDistance: Scalars['Boolean'];
  velocityBand2TotalDuration: Scalars['Boolean'];
  velocityBand3TotalDistance: Scalars['Boolean'];
  velocityBand3TotalDuration: Scalars['Boolean'];
  velocityBand4TotalDistance: Scalars['Boolean'];
  velocityBand4TotalDuration: Scalars['Boolean'];
  velocityBand5TotalDistance: Scalars['Boolean'];
  velocityBand5TotalDistancePerMax: Scalars['Boolean'];
  velocityBand5TotalDuration: Scalars['Boolean'];
  velocityBand6TotalDistance: Scalars['Boolean'];
  velocityBand6TotalDuration: Scalars['Boolean'];
};

/** 팀 선수 외적부하 데이터 목록 및 평균 */
export type TeamExternalWorkloadIndividualData = {
  __typename: 'TeamExternalWorkloadIndividualData';
  /** 팀 선수 외적부하 평균 */
  avg: TeamExternalWorkloadAvg;
  /** 팀 선수 외적부하 데이터 목록 */
  userDataList: Array<TeamExternalWorkloadUser>;
};

/** 세션별 팀 외적부하 평균 */
export type TeamExternalWorkloadSessionAvg = {
  __typename: 'TeamExternalWorkloadSessionAvg';
  /** 날짜별 외적부하 정보 */
  dateList: Array<TeamExternalWorkloadSessionDateAvg>;
  /** 날짜별 총 뛴 거리 평균의 평균 */
  totalDistanceAvg?: Maybe<Scalars['Float']>;
};

/** 세션별 날짜별 팀 외적부하 평균 */
export type TeamExternalWorkloadSessionDateAvg = ExternalWorkloadInfo & {
  __typename: 'TeamExternalWorkloadSessionDateAvg';
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 accelerationB2_3TotalCount 최댓값 대비 해당 세션의 accelerationB2_3TotalCount 비율 */
  accelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 가속 횟수 */
  accelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 가속 횟수 */
  accelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 가속 횟수 */
  accelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 평균 심박수 */
  averageHeartRate?: Maybe<Scalars['Float']>;
  /** 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeet?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetRight?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 decelerationB2_3TotalCount 최댓값 대비 해당 세션의 decelerationB2_3TotalCount 비율 */
  decelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 감속 횟수 */
  decelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 감속 횟수 */
  decelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 감속 횟수 */
  decelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 분당 이동거리 */
  distancePerMinute?: Maybe<Scalars['Float']>;
  /** 심박 기반 세션 부하 지표 */
  heartRateExertion?: Maybe<Scalars['Float']>;
  /** 대사적으로 높은 부하가 걸리는 상황에서 이동한 거리 */
  highMetabolicLoadDistance?: Maybe<Scalars['Float']>;
  /** 분당 고속주행 거리 */
  hsrPerMinute?: Maybe<Scalars['Float']>;
  /** 고강도 가속 이벤트 수 */
  imaAccelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 가속 이벤트 수 */
  imaAccelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 가속 이벤트 수 */
  imaAccelerationMedium?: Maybe<Scalars['Float']>;
  /** 고강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftHigh?: Maybe<Scalars['Float']>;
  /** 저강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftLow?: Maybe<Scalars['Float']>;
  /** 중강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftMedium?: Maybe<Scalars['Float']>;
  /** 고강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightHigh?: Maybe<Scalars['Float']>;
  /** 저강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightLow?: Maybe<Scalars['Float']>;
  /** 중강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightMedium?: Maybe<Scalars['Float']>;
  /** 고강도 감속 이벤트 수 */
  imaDecelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 감속 이벤트 수 */
  imaDecelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 감속 이벤트 수 */
  imaDecelerationMedium?: Maybe<Scalars['Float']>;
  /** B4 구간 점프 착지 횟수 */
  imaJumpCountBand4?: Maybe<Scalars['Float']>;
  /** 고강도 점프 착지 횟수 */
  imaJumpCountHighBand?: Maybe<Scalars['Float']>;
  /** 저강도 점프 착지 횟수 */
  imaJumpCountLowBand?: Maybe<Scalars['Float']>;
  /** 중강도 점프 착지 횟수 */
  imaJumpCountMediumBand?: Maybe<Scalars['Float']>;
  /** 최대 가속도 */
  maximumAcceleration?: Maybe<Scalars['Float']>;
  /** 최대 감속도 */
  maximumDeceleration?: Maybe<Scalars['Float']>;
  /** 최대 심박수 */
  maximumHeartRate?: Maybe<Scalars['Float']>;
  /** 최고 속력 */
  maximumSpeed?: Maybe<Scalars['Float']>;
  /** 선수 개인의 maximumSpeed 최댓값 대비 해당 세션의 maximumSpeed 비율 */
  maximumSpeedPerMax?: Maybe<Scalars['Float']>;
  /** 최대 힘 발휘해내는 능력 */
  metaEnergy?: Maybe<Scalars['Float']>;
  /** 좌우 다리 간 부하의 비대칭성 */
  runningImbalance?: Maybe<Scalars['Float']>;
  /** 세션 이름 */
  scheduleName?: Maybe<Scalars['String']>;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 총 뛴 거리 기반 ACWR */
  totalDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalDistance 최댓값 대비 해당 세션의 totalDistance 비율 */
  totalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 다이브 한 횟수 */
  totalDiveCount?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 횟수 */
  totalDiveCountCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 횟수 */
  totalDiveCountLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 횟수 */
  totalDiveCountRight?: Maybe<Scalars['Float']>;
  /** 다이브 함으로써 생긴 부하 */
  totalDiveLoad?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadRight?: Maybe<Scalars['Float']>;
  /** 운동한 시간 */
  totalDuration?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** HSR 거리 기반 ACWR */
  totalHsrDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalHsrDistance 최댓값 대비 해당 세션의 totalHsrDistance 비율 */
  totalHsrDistancePerMax?: Maybe<Scalars['Float']>;
  /** 점프한 총 횟수 */
  totalJumpCount?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  totalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이상 횟수 */
  velocityB4TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이상 횟수 */
  velocityB5TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이상 횟수 */
  velocityB6TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동거리 */
  velocityBand1TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동시간 */
  velocityBand1TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동거리 */
  velocityBand2TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동시간 */
  velocityBand2TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동거리 */
  velocityBand3TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동시간 */
  velocityBand3TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동거리 */
  velocityBand4TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동시간 */
  velocityBand4TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동거리 */
  velocityBand5TotalDistance?: Maybe<Scalars['Float']>;
  /** 선수 개인의 velocityBand5TotalDistance 최댓값 대비 해당 세션의 velocityBand5TotalDistance 비율 */
  velocityBand5TotalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동시간 */
  velocityBand5TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동거리 */
  velocityBand6TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동시간 */
  velocityBand6TotalDuration?: Maybe<Scalars['Float']>;
};

/** 유저 내적부하 */
export type TeamExternalWorkloadUser = ExternalWorkloadInfo & {
  __typename: 'TeamExternalWorkloadUser';
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 accelerationB2_3TotalCount 최댓값 대비 해당 세션의 accelerationB2_3TotalCount 비율 */
  accelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 가속 횟수 */
  accelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 가속 횟수 */
  accelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 가속 횟수 */
  accelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 평균 심박수 */
  averageHeartRate?: Maybe<Scalars['Float']>;
  /** 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeet?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetRight?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 decelerationB2_3TotalCount 최댓값 대비 해당 세션의 decelerationB2_3TotalCount 비율 */
  decelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 감속 횟수 */
  decelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 감속 횟수 */
  decelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 감속 횟수 */
  decelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 분당 이동거리 */
  distancePerMinute?: Maybe<Scalars['Float']>;
  /** 심박 기반 세션 부하 지표 */
  heartRateExertion?: Maybe<Scalars['Float']>;
  /** 대사적으로 높은 부하가 걸리는 상황에서 이동한 거리 */
  highMetabolicLoadDistance?: Maybe<Scalars['Float']>;
  /** 분당 고속주행 거리 */
  hsrPerMinute?: Maybe<Scalars['Float']>;
  /** 고강도 가속 이벤트 수 */
  imaAccelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 가속 이벤트 수 */
  imaAccelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 가속 이벤트 수 */
  imaAccelerationMedium?: Maybe<Scalars['Float']>;
  /** 고강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftHigh?: Maybe<Scalars['Float']>;
  /** 저강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftLow?: Maybe<Scalars['Float']>;
  /** 중강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftMedium?: Maybe<Scalars['Float']>;
  /** 고강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightHigh?: Maybe<Scalars['Float']>;
  /** 저강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightLow?: Maybe<Scalars['Float']>;
  /** 중강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightMedium?: Maybe<Scalars['Float']>;
  /** 고강도 감속 이벤트 수 */
  imaDecelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 감속 이벤트 수 */
  imaDecelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 감속 이벤트 수 */
  imaDecelerationMedium?: Maybe<Scalars['Float']>;
  /** B4 구간 점프 착지 횟수 */
  imaJumpCountBand4?: Maybe<Scalars['Float']>;
  /** 고강도 점프 착지 횟수 */
  imaJumpCountHighBand?: Maybe<Scalars['Float']>;
  /** 저강도 점프 착지 횟수 */
  imaJumpCountLowBand?: Maybe<Scalars['Float']>;
  /** 중강도 점프 착지 횟수 */
  imaJumpCountMediumBand?: Maybe<Scalars['Float']>;
  /** 최대 가속도 */
  maximumAcceleration?: Maybe<Scalars['Float']>;
  /** 최대 감속도 */
  maximumDeceleration?: Maybe<Scalars['Float']>;
  /** 최대 심박수 */
  maximumHeartRate?: Maybe<Scalars['Float']>;
  /** 최고 속력 */
  maximumSpeed?: Maybe<Scalars['Float']>;
  /** 선수 개인의 maximumSpeed 최댓값 대비 해당 세션의 maximumSpeed 비율 */
  maximumSpeedPerMax?: Maybe<Scalars['Float']>;
  /** 최대 힘 발휘해내는 능력 */
  metaEnergy?: Maybe<Scalars['Float']>;
  /** 좌우 다리 간 부하의 비대칭성 */
  runningImbalance?: Maybe<Scalars['Float']>;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 총 뛴 거리 기반 ACWR */
  totalDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalDistance 최댓값 대비 해당 세션의 totalDistance 비율 */
  totalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 다이브 한 횟수 */
  totalDiveCount?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 횟수 */
  totalDiveCountCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 횟수 */
  totalDiveCountLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 횟수 */
  totalDiveCountRight?: Maybe<Scalars['Float']>;
  /** 다이브 함으로써 생긴 부하 */
  totalDiveLoad?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadRight?: Maybe<Scalars['Float']>;
  /** 운동한 시간 */
  totalDuration?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** HSR 거리 기반 ACWR */
  totalHsrDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalHsrDistance 최댓값 대비 해당 세션의 totalHsrDistance 비율 */
  totalHsrDistancePerMax?: Maybe<Scalars['Float']>;
  /** 점프한 총 횟수 */
  totalJumpCount?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  totalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
  /** 선수 정보 */
  user: SportsUser;
  /** 속도 4구간 이상 횟수 */
  velocityB4TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이상 횟수 */
  velocityB5TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이상 횟수 */
  velocityB6TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동거리 */
  velocityBand1TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동시간 */
  velocityBand1TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동거리 */
  velocityBand2TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동시간 */
  velocityBand2TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동거리 */
  velocityBand3TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동시간 */
  velocityBand3TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동거리 */
  velocityBand4TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동시간 */
  velocityBand4TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동거리 */
  velocityBand5TotalDistance?: Maybe<Scalars['Float']>;
  /** 선수 개인의 velocityBand5TotalDistance 최댓값 대비 해당 세션의 velocityBand5TotalDistance 비율 */
  velocityBand5TotalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동시간 */
  velocityBand5TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동거리 */
  velocityBand6TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동시간 */
  velocityBand6TotalDuration?: Maybe<Scalars['Float']>;
};

export enum TeamField {
  name = 'name',
  region = 'region',
  slug = 'slug',
  sportsCategory = 'sportsCategory'
}

/** 팀 검색 필터 input */
export type TeamFilter = {
  /** 검색어 */
  searchTerm?: Maybe<Scalars['String']>;
};

/** 팀 필터 input */
export type TeamFilterExpressionInput = {
  /** 팀 필터 */
  field: TeamField;
  /** 쿼리 오퍼레이션 */
  op: QueryOperation;
  /** 값 */
  value: Scalars['String'];
};

/** 팀 필터 input */
export type TeamFilterInput = {
  /** and 조건 */
  and?: Maybe<Array<TeamFilterInput>>;
  /** 팀 필터 input */
  expression?: Maybe<TeamFilterExpressionInput>;
  /** not 조건 */
  not?: Maybe<TeamFilterInput>;
  /** or 조건 */
  or?: Maybe<Array<TeamFilterInput>>;
};

/** gps 데이터 비교 분석 */
export type TeamGpsDataCompareAnalysis = {
  __typename: 'TeamGpsDataCompareAnalysis';
  /** gps 데이터 비교 분석 대상 목록 */
  compareTargetList: Array<TeamGpsDataCompareTarget>;
  /** 팀 gps 데이터 기준 */
  teamThreshold?: Maybe<TeamGpsDataThreshold>;
};

/** 팀 gps 데이터 비교 분석 대상 */
export type TeamGpsDataCompareTarget = GpsDataInfo & {
  __typename: 'TeamGpsDataCompareTarget';
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  scheduleId: Scalars['String'];
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
};

/** 팀 gps 데이터 기준 */
export type TeamGpsDataThreshold = GpsDataInfo & {
  __typename: 'TeamGpsDataThreshold';
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
};

/** 팀그룹 정보 */
export type TeamGroup = {
  __typename: 'TeamGroup';
  /** 생성일 */
  createdAt?: Maybe<Scalars['Date']>;
  /** 생성 유저 정보 */
  createdBy: SportsUser;
  /** 그룹 맴버 목록 */
  groupMemberList: Array<TeamGroupUser>;
  /** 팀 그룹ID */
  id: Scalars['ID'];
  /** 이름 */
  name: Scalars['String'];
  /** 정렬 순서 키 */
  orderRanking?: Maybe<Scalars['String']>;
  /** 팀 정보 */
  team: SportsTeam;
  /** 팀ID */
  teamId: Scalars['String'];
  /** 수정일 */
  updatedAt?: Maybe<Scalars['Date']>;
  /** 유저ID */
  userId: Scalars['String'];
};

/** 팀 그룹 유저 */
export type TeamGroupUser = {
  __typename: 'TeamGroupUser';
  /** 그룹 목록 */
  groups: Array<TeamGroup>;
  /** 팀그룹 ID */
  id: Scalars['ID'];
  /** 팀 정보 */
  team: SportsTeam;
  /** 유저 정보 */
  user: SportsUser;
};

/** 햄스트링 근력 미달 선수 */
export type TeamHamstringStrength = {
  __typename: 'TeamHamstringStrength';
  /** 등축성 수축 미달 선수 수 */
  isoProneAvgCount?: Maybe<Scalars['Float']>;
  /** 신장성 수축 미달 선수 수 */
  nordicAvgCount?: Maybe<Scalars['Float']>;
};

/** 햄스트링 불균형 선수 */
export type TeamHamstringUnbalance = {
  __typename: 'TeamHamstringUnbalance';
  /** 등축성 수축 선수 수 */
  isoProneRatioCount?: Maybe<Scalars['Float']>;
  /** 신장성 수축 선수 수 */
  nordicRatioCount?: Maybe<Scalars['Float']>;
};

/** 벌림근 대비 모음근 불균형 선수 */
export type TeamHipAdductionToAbduction = {
  __typename: 'TeamHipAdductionToAbduction';
  /** 좌측 벌림근 대비 모음근 불균형 선수 수 */
  hipAdductionToAbductionLeftCount?: Maybe<Scalars['Float']>;
  /** 우측 벌림근 대비 모음근 불균형 선수 수 */
  hipAdductionToAbductionRightCount?: Maybe<Scalars['Float']>;
};

/** 고관절 근력 미달 선수 */
export type TeamHipJointStrength = {
  __typename: 'TeamHipJointStrength';
  /** 굽힘근 선수 수 */
  flexionKickerAvgLevelCount?: Maybe<Scalars['Float']>;
  /** 벌림근 선수 수 */
  hipAbductionAvgLevelCount?: Maybe<Scalars['Float']>;
  /** 모음근 선수 수 */
  hipAdductionAvgCount?: Maybe<Scalars['Float']>;
};

/** 고관절 불균형 선수 */
export type TeamHipJointUnBalance = {
  __typename: 'TeamHipJointUnBalance';
  /** 굽힘근 비율 선수 수 */
  flexionKickerRatioCount?: Maybe<Scalars['Float']>;
  /** 벌림근 비율 선수 수 */
  hipAbductionCount?: Maybe<Scalars['Float']>;
  /** 모음근 선수 수 */
  hipAdductionRatioCount?: Maybe<Scalars['Float']>;
};

/** 팀 소속 이력 */
export type TeamHistory = {
  __typename: 'TeamHistory';
  /** 소속 종료 날짜 */
  endDate?: Maybe<Scalars['String']>;
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 팀 이름 */
  name?: Maybe<Scalars['String']>;
  /** 연봉 */
  salary?: Maybe<Scalars['String']>;
  /** 소속 시작 날짜 */
  startDate: Scalars['String'];
};

/** 팀 소속 이력 input */
export type TeamHistoryInput = {
  /** 소속 종료 날짜 */
  endDate?: Maybe<Scalars['String']>;
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 팀 이름 */
  name?: Maybe<Scalars['String']>;
  /** 연봉 */
  salary?: Maybe<Scalars['String']>;
  /** 소속 시작 날짜 */
  startDate: Scalars['String'];
};

/** 인바디 측정 */
export type TeamInBody = {
  __typename: 'TeamInBody';
  /** 신장 */
  height: Scalars['Float'];
  /** 체지방량 */
  infoBodyFM: Scalars['Float'];
  /** 체지방률 */
  infoBodyFat: Scalars['Float'];
  /** 근육량 */
  infoMuscleMass: Scalars['Float'];
  /** 골격근량 */
  infoSkeletalMM: Scalars['Float'];
  /** 체중 */
  weight: Scalars['Float'];
};

/** 팀 메디컬 평균 정보 */
export type TeamIndividualMedicalAvg = {
  __typename: 'TeamIndividualMedicalAvg';
  /** 팀 부상 평균 정보 */
  injury: TeamIndividualMedicalAvgDetail;
  /** 팀 통증 평균 정보 */
  soreness: TeamIndividualMedicalAvgDetail;
};

/** 팀 메디컬 평균 정보 상세 */
export type TeamIndividualMedicalAvgDetail = {
  __typename: 'TeamIndividualMedicalAvgDetail';
  /** 평균 개수 */
  cnt: Scalars['Float'];
  /** 접촉 평균 개수 */
  contactCnt: Scalars['Float'];
  /** 비접촉 평균 개수 */
  nonContactCnt: Scalars['Float'];
};

/** 부상 정보 */
export type TeamInjury = {
  __typename: 'TeamInjury';
  /** 부상 부위 */
  bodyPart: SportsBodyPart;
  /** 접촉 여부 */
  isContact: InjuryContact;
};


/** 부상 정보 */
export type TeamInjuryBodyPartArgs = {
  input: MultilingualTextInput;
};

/** 팀 부상 평균 정보 */
export type TeamInjuryAvg = {
  __typename: 'TeamInjuryAvg';
  /** 부상 평균 개수 */
  avgCnt: Scalars['Float'];
  /** 부상 부위별 갯수 */
  bodyPartCntList: Array<TeamInjuryBodyPartCnt>;
  /** 누적 부상 개수 */
  cumulativeCnt: Scalars['Float'];
  /** 날짜별 선수 부상 정보 */
  dateList: Array<TeamInjuryDate>;
  /** 부상 유형별 갯수 */
  isContactCnt: TeamInjuryIsContactCnt;
};

/** 부상 부위별 갯수 */
export type TeamInjuryBodyPartCnt = {
  __typename: 'TeamInjuryBodyPartCnt';
  /** 부상 부위 */
  bodyPart: SportsBodyPart;
  /** 부상 갯수 */
  cnt: Scalars['Float'];
};


/** 부상 부위별 갯수 */
export type TeamInjuryBodyPartCntBodyPartArgs = {
  input: MultilingualTextInput;
};

/** 날짜별 선수 부상 정보 */
export type TeamInjuryDate = {
  __typename: 'TeamInjuryDate';
  /** 날짜 */
  date: Scalars['String'];
  /** 선수 부상 정보 */
  userDataList: Array<TeamInjuryUser>;
};

/** 부상 유형별 갯수 */
export type TeamInjuryIsContactCnt = {
  __typename: 'TeamInjuryIsContactCnt';
  /** 접촉 부상 갯수 */
  contact: Scalars['Float'];
  /** 비접촉 부상 갯수 */
  nonContact: Scalars['Float'];
};

/** 선수 부상 정보 */
export type TeamInjuryUser = {
  __typename: 'TeamInjuryUser';
  /** 부상 목록 */
  injuryList: Array<TeamInjury>;
  /** 선수 정보 */
  user: SportsUser;
};

/** 팀 데이터 인사이트 */
export type TeamInsight = {
  __typename: 'TeamInsight';
  /** 팀 가용률 정보 */
  availability: TeamAvailability;
  /** 날짜별 종합 분석 */
  comprehensiveAnalysis: Array<ComprehensiveAnalysisByDate>;
  /** 팀 컨디션 비교 분석 */
  condition: TeamConditionCompareAnalysis;
  /** 팀 gps 데이터 비교 분석 */
  gpsDataCompareAnalysis: TeamGpsDataCompareAnalysis;
  /** 팀 매치 이벤트 데이터 비교 분석 */
  matchEventCompareAnalysis: TeamMatchEventCompareAnalysis;
  /** 팀 메디컬 통계 */
  medicalStatistics: TeamMedicalAvg;
  /** 팀 피지컬 데이터 기준 대비 비교 분석 목록 */
  physicalDataV2CompareAnalysis: Array<TeamPhysicalDataV2CompareAnalysis>;
  /** 팀 RHIE vs RPE 데이터 비교 분석 목록 */
  rhieVsRpeCompareAnalysis: Array<TeamRhieVsRpeCompareAnalysis>;
  /** 팀 스피드존 기반 비교 분석 */
  speedZoneCompareAnalysis: TeamSpeedZoneCompareAnalysis;
  /** 팀 운동부하 비교 분석 목록 */
  workloadCompareAnalysis: Array<TeamWorkloadCompareAnalysis>;
};


/** 팀 데이터 인사이트 */
export type TeamInsightAvailabilityArgs = {
  date: Scalars['String'];
};


/** 팀 데이터 인사이트 */
export type TeamInsightComprehensiveAnalysisArgs = {
  dataList: Array<ComprehensiveAnalysisType>;
  from: Scalars['String'];
  timezone: Scalars['String'];
  to: Scalars['String'];
};


/** 팀 데이터 인사이트 */
export type TeamInsightConditionArgs = {
  date: Scalars['String'];
  groupIdList: Array<Scalars['String']>;
  isTeamCompare: Scalars['Boolean'];
  userIdList: Array<Scalars['String']>;
};


/** 팀 데이터 인사이트 */
export type TeamInsightGpsDataCompareAnalysisArgs = {
  scheduleIdList: Array<Scalars['String']>;
};


/** 팀 데이터 인사이트 */
export type TeamInsightMatchEventCompareAnalysisArgs = {
  scheduleIdList: Array<Scalars['String']>;
};


/** 팀 데이터 인사이트 */
export type TeamInsightMedicalStatisticsArgs = {
  from: Scalars['String'];
  timezone: Scalars['String'];
  to: Scalars['String'];
};


/** 팀 데이터 인사이트 */
export type TeamInsightRhieVsRpeCompareAnalysisArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** 팀 데이터 인사이트 */
export type TeamInsightSpeedZoneCompareAnalysisArgs = {
  scheduleId: Scalars['String'];
};


/** 팀 데이터 인사이트 */
export type TeamInsightWorkloadCompareAnalysisArgs = {
  from: Scalars['String'];
  timezone: Scalars['String'];
  to: Scalars['String'];
};

/** 선수단 인사이트 */
export type TeamInsightData = {
  __typename: 'TeamInsightData';
  /** acwr최적 목록 */
  acwrList: Array<TeamInsightDataAcwr>;
  /** 컨디션 목록 */
  conditionList: Array<TeamInsightDataCondition>;
};

/** 선수단 인사이트 acwr 목록 */
export type TeamInsightDataAcwr = {
  __typename: 'TeamInsightDataAcwr';
  /** acwr */
  acwr: Scalars['Float'];
  /** 유저 정보 */
  user: SportsUser;
};

/** 선수단 인사이트 컨디션 목록 */
export type TeamInsightDataCondition = {
  __typename: 'TeamInsightDataCondition';
  /** 컨디션 점수 */
  condition: Scalars['Float'];
  /** 유저 정보 */
  user: SportsUser;
};

/** 팀 내적부하 */
export type TeamInternalWorkload = {
  __typename: 'TeamInternalWorkload';
  /** 날짜별 팀 내적부하 평균 */
  avg: TeamInternalWorkloadDateAvgInfo;
  /** 팀 선수 내적부하 데이터 목록 및 평균 */
  individualData: TeamInternalWorkloadIndividualData;
};


/** 팀 내적부하 */
export type TeamInternalWorkloadAvgArgs = {
  from: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
  scheduleOnly?: Maybe<Scalars['Boolean']>;
  timezone: Scalars['String'];
  to: Scalars['String'];
};


/** 팀 내적부하 */
export type TeamInternalWorkloadIndividualDataArgs = {
  date: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
  timezone: Scalars['String'];
};

/** 팀 내적부하 평균 */
export type TeamInternalWorkloadAvg = InternalWorkloadInfo & {
  __typename: 'TeamInternalWorkloadAvg';
  /** 부상 위험도 */
  acwr: Scalars['Float'];
  /** 급성 부하 */
  aw: Scalars['Float'];
  /** 단조로움 */
  awd: Scalars['Float'];
  /** 만성 부하 */
  cw: Scalars['Float'];
  /** 내적 부하 */
  internalWorkload?: Maybe<Scalars['Float']>;
  /** 훈련 부담 */
  strain: Scalars['Float'];
};

/** 날짜별 팀 내적부하 평균 */
export type TeamInternalWorkloadDateAvg = InternalWorkloadInfo & {
  __typename: 'TeamInternalWorkloadDateAvg';
  /** 부상 위험도 */
  acwr: Scalars['Float'];
  /** 급성 부하 */
  aw: Scalars['Float'];
  /** 단조로움 */
  awd: Scalars['Float'];
  /** 만성 부하 */
  cw: Scalars['Float'];
  /** 날짜 */
  date: Scalars['String'];
  /** 내적 부하 */
  internalWorkload?: Maybe<Scalars['Float']>;
  /** 훈련 부담 */
  strain: Scalars['Float'];
};

/** 날짜별 팀 내적부하 평균 */
export type TeamInternalWorkloadDateAvgInfo = {
  __typename: 'TeamInternalWorkloadDateAvgInfo';
  /** 날짜별 내적부하 평균 목록 */
  dateList: Array<TeamInternalWorkloadDateAvg>;
  /** 날짜별 내적부하 평균의 합 */
  loadSum?: Maybe<Scalars['Float']>;
};

/** 팀 선수 내적부하 데이터 목록 및 평균 */
export type TeamInternalWorkloadIndividualData = {
  __typename: 'TeamInternalWorkloadIndividualData';
  /** 팀 선수 내적부하 평균 */
  avg: TeamInternalWorkloadAvg;
  /** 팀 선수 내적부하 데이터 목록 */
  userDataList: Array<TeamInternalWorkloadUser>;
};

/** 유저 내적부하 */
export type TeamInternalWorkloadUser = InternalWorkloadInfo & {
  __typename: 'TeamInternalWorkloadUser';
  /** 부상 위험도 */
  acwr: Scalars['Float'];
  /** 급성 부하 */
  aw: Scalars['Float'];
  /** 단조로움 */
  awd: Scalars['Float'];
  /** 만성 부하 */
  cw: Scalars['Float'];
  /** 내적 부하 */
  internalWorkload?: Maybe<Scalars['Float']>;
  /** 내적부하 상세 목록 */
  list: Array<InternalWorkloadDetail>;
  /** 운동 안 함 이유 */
  reasonForNoWorkout?: Maybe<NoWorkoutType>;
  /** 훈련 부담 */
  strain: Scalars['Float'];
  /** 선수 정보 */
  user: SportsUser;
};

/** 팀 초대 요청 알림 */
export type TeamInvitationAlarm = Alarm & {
  __typename: 'TeamInvitationAlarm';
  /** 알람 생성 유저 정보 */
  createUser: SportsUser;
  /** 생성일 */
  createdAt: Scalars['DateTime'];
  /** 알림 ID */
  id: Scalars['ID'];
  /** 알림 읽음 여부 */
  isChecked: Scalars['Boolean'];
  /** 학부모 정보 */
  parent?: Maybe<SportsUser>;
  /** 플랜 정보 */
  plan?: Maybe<PlanV2Alarm>;
  /** 선수 정보 */
  player?: Maybe<SportsUser>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 팀 초대 요청 정보 */
  teamInvitationRequest: TeamInvitationRequest;
  /** 알림 종류 */
  type: AlarmType;
};


/** 팀 초대 요청 알림 */
export type TeamInvitationAlarmPlanArgs = {
  input: MultilingualTextInput;
};

/** 팀 초대 요청 */
export type TeamInvitationRequest = {
  __typename: 'TeamInvitationRequest';
  /** 팀 초대 요청ID */
  id: Scalars['ID'];
  /** 이전 팀 권한 */
  prevTeamAuthority?: Maybe<SportsTeamAuthority>;
  /** 역할 */
  role?: Maybe<SportsRole>;
  /** 초대 상태 */
  status: SportsTeamInvitationRequestStatus;
  /** 팀 권한 */
  teamAuthority?: Maybe<SportsTeamAuthority>;
  /** 유저 정보 */
  user: SportsUser;
};

export enum TeamMapField {
  createdAt = 'createdAt'
}

/** 팀맵 정렬 input */
export type TeamMapOrderByInput = {
  /** 팀맵 필드 */
  field: TeamMapField;
  /** 정렬 조건 */
  sort: SimpleOrder;
};

/** 팀 매치 이벤트 상세 */
export type TeamMatchEvent = MatchEvent & {
  __typename: 'TeamMatchEvent';
  /** 공격 지표 */
  attack: Attack;
  /** 볼 배급 지표 */
  ballDistribution: BallDistribution;
  /** 날짜 */
  date: Scalars['String'];
  /** 수비 지표 */
  defense: Defense;
  /** 파울 지표 */
  foul: Foul;
  /** 골키퍼 지표 */
  goalkeeper: Goalkeeper;
  /** 매치 이벤트 ID */
  id: Scalars['String'];
  /** 상대팀 */
  opponent: Scalars['String'];
  /** 피지컬 지표 */
  physical: Physical;
  /** 라운드 */
  round?: Maybe<Scalars['String']>;
  /** 세트피스 지표 */
  setPiece: SetPiece;
  /** 선수 매치 이벤트 상세 목록 */
  userDataList: Array<UserMatchEvent>;
};

/** 매치 이벤트 데이터 비교 분석 */
export type TeamMatchEventCompareAnalysis = {
  __typename: 'TeamMatchEventCompareAnalysis';
  /** 매치 이벤트 데이터 비교 분석 대상 목록 */
  compareTargetList: Array<TeamMatchEventCompareTarget>;
  /** 팀 매치 이벤트 데이터 기준 */
  teamThreshold?: Maybe<TeamMatchEventThreshold>;
};

/** 팀 매치 이벤트 데이터 비교 분석 대상 */
export type TeamMatchEventCompareTarget = MatchEventInfo & {
  __typename: 'TeamMatchEventCompareTarget';
  /** 공중볼 처리 성공률 */
  aerialActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 */
  aerialActions?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 성공 */
  aerialActionsWon?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공률 */
  aerialDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 */
  aerialDuels?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공 */
  aerialDuelsWon?: Maybe<Scalars['Float']>;
  /** 도움 */
  assists?: Maybe<Scalars['Float']>;
  /** 평균 속도 */
  averageSpeed?: Maybe<Scalars['Float']>;
  /** 백패스 성공률 */
  backPassAccuracy?: Maybe<Scalars['Float']>;
  /** 백패스 */
  backPasses?: Maybe<Scalars['Float']>;
  /** 블락된 슈팅 */
  blockedShots?: Maybe<Scalars['Float']>;
  /** 캐칭 */
  catches?: Maybe<Scalars['Float']>;
  /** 클리어 */
  clearances?: Maybe<Scalars['Float']>;
  /** 코너킥 */
  cornerKicks?: Maybe<Scalars['Float']>;
  /** 크로스 성공률 */
  crossAccuracy?: Maybe<Scalars['Float']>;
  /** 크로스 */
  crosses?: Maybe<Scalars['Float']>;
  /** 크로스 차단 */
  crossesBlocked?: Maybe<Scalars['Float']>;
  /** 돌파 시도 */
  dribbleAttempts?: Maybe<Scalars['Float']>;
  /** 돌파 성공률 */
  dribbleSuccessRate?: Maybe<Scalars['Float']>;
  /** 전진 패스 성공률 */
  forwardPassAccuracy?: Maybe<Scalars['Float']>;
  /** 전진패스 */
  forwardPasses?: Maybe<Scalars['Float']>;
  /** 파울 */
  fouls?: Maybe<Scalars['Float']>;
  /** 피파울 */
  foulsSuffered?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 */
  freeKickCrosses?: Maybe<Scalars['Float']>;
  /** 프리킥 슈팅 */
  freeKickShots?: Maybe<Scalars['Float']>;
  /** 프리킥 유효 슈팅 */
  freeKickShotsOnTarget?: Maybe<Scalars['Float']>;
  /** 프리킥 */
  freeKicks?: Maybe<Scalars['Float']>;
  /** 골킥 */
  goalKicks?: Maybe<Scalars['Float']>;
  /** 득점 */
  goals?: Maybe<Scalars['Float']>;
  /** 실점 */
  goalsConceded?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공률 */
  groundActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 */
  groundActions?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공 */
  groundActionsWon?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공률 */
  groundDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 */
  groundDuels?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공 */
  groundDuelsWon?: Maybe<Scalars['Float']>;
  /** 핸드볼 파울 */
  handballFouls?: Maybe<Scalars['Float']>;
  /** 고강도 러닝 거리 비율 */
  highIntensityRunningRatio?: Maybe<Scalars['Float']>;
  /** 인터셉트 */
  interceptions?: Maybe<Scalars['Float']>;
  /** 키패스 */
  keyPasses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공률 */
  lateralPassAccuracy?: Maybe<Scalars['Float']>;
  /** 횡패스 */
  lateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리 패스 성공률 */
  longPassAccuracy?: Maybe<Scalars['Float']>;
  /** 장거리 패스 */
  longPasses?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공률 */
  looseBallDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 */
  looseBallDuels?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공 */
  looseBallDuelsWon?: Maybe<Scalars['Float']>;
  /** 중거리 패스 성공률 */
  mediumPassAccuracy?: Maybe<Scalars['Float']>;
  /** 중거리 패스 */
  mediumPasses?: Maybe<Scalars['Float']>;
  /** 볼미스 */
  miscontrols?: Maybe<Scalars['Float']>;
  /** 오프사이드 */
  offsides?: Maybe<Scalars['Float']>;
  /** 자책골 */
  ownGoals?: Maybe<Scalars['Float']>;
  /** 패스성공률 */
  passAccuracy?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 성공률 */
  passAccuracyInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비지역 패스 성공률 */
  passAccuracyInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공률 */
  passAccuracyInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 */
  passes?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 */
  passesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 */
  passesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 */
  passesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 받음 */
  passesReceived?: Maybe<Scalars['Float']>;
  /** 페널티킥 허용 */
  penaltiesConceded?: Maybe<Scalars['Float']>;
  /** 페널티킥 획득 */
  penaltiesWon?: Maybe<Scalars['Float']>;
  /** 페널티킥 */
  penaltyKicks?: Maybe<Scalars['Float']>;
  /** 페널티킥 세이브 */
  penaltySaves?: Maybe<Scalars['Float']>;
  /** 팀 점유율 */
  possession?: Maybe<Scalars['Float']>;
  /** 펀칭 */
  punches?: Maybe<Scalars['Float']>;
  /** 획득 */
  recoveries?: Maybe<Scalars['Float']>;
  /** 퇴장 */
  redCards?: Maybe<Scalars['Float']>;
  /** 세이브 */
  saves?: Maybe<Scalars['Float']>;
  scheduleId: Scalars['String'];
  /** 세트피스 득점 */
  setPieceGoals?: Maybe<Scalars['Float']>;
  /** 세트피스 득점 허용 */
  setPieceGoalsConceded?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 */
  setPieceShots?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 허용 */
  setPieceShotsConceded?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공률 */
  shortPassAccuracy?: Maybe<Scalars['Float']>;
  /** 단거리 패스 */
  shortPasses?: Maybe<Scalars['Float']>;
  /** 유효슈팅률 */
  shotAccuracy?: Maybe<Scalars['Float']>;
  /** 슈팅 차단 */
  shotsBlocked?: Maybe<Scalars['Float']>;
  /** 박스 안 슈팅 */
  shotsInsideBox?: Maybe<Scalars['Float']>;
  /** 벗어난 슈팅 */
  shotsOffTarget?: Maybe<Scalars['Float']>;
  /** 유효슈팅 */
  shotsOnTarget?: Maybe<Scalars['Float']>;
  /** 박스 밖 슈팅 */
  shotsOutsideBox?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  sprintCount?: Maybe<Scalars['Float']>;
  /** 스프린트 총 거리 */
  sprintDistance?: Maybe<Scalars['Float']>;
  /** 스텝인 */
  stepIns?: Maybe<Scalars['Float']>;
  /** 백패스 성공 */
  successfulBackPasses?: Maybe<Scalars['Float']>;
  /** 크로스 성공 */
  successfulCrosses?: Maybe<Scalars['Float']>;
  /** 돌파 성공 */
  successfulDribbles?: Maybe<Scalars['Float']>;
  /** 전진패스 성공 */
  successfulForwardPasses?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 성공 */
  successfulFreeKickCrosses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공 */
  successfulLateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리패스 성공 */
  successfulLongPasses?: Maybe<Scalars['Float']>;
  /** 중거리패스 성공 */
  successfulMediumPasses?: Maybe<Scalars['Float']>;
  /** 패스 성공 */
  successfulPasses?: Maybe<Scalars['Float']>;
  /** 공격 지역 패스 성공 */
  successfulPassesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 성공 */
  successfulPassesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공 */
  successfulPassesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공 */
  successfulShortPasses?: Maybe<Scalars['Float']>;
  /** 태클 시도 */
  tackleAttempts?: Maybe<Scalars['Float']>;
  /** 태클 실패 */
  tacklesLost?: Maybe<Scalars['Float']>;
  /** 태클 성공률 */
  tacklesSuccessRate?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 미획득 */
  tacklesWonNoPossession?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 획득 */
  tacklesWonPossession?: Maybe<Scalars['Float']>;
  /** 스로인 파울 */
  throwInFouls?: Maybe<Scalars['Float']>;
  /** 스로인 */
  throwIns?: Maybe<Scalars['Float']>;
  /** 최고 속도 */
  topSpeed?: Maybe<Scalars['Float']>;
  /** 총 차단 */
  totalBlocks?: Maybe<Scalars['Float']>;
  /** 총 거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 전체 파울 */
  totalFouls?: Maybe<Scalars['Float']>;
  /** 전체 슈팅 */
  totalShots?: Maybe<Scalars['Float']>;
  /** 턴오버 허용 */
  turnoversConceded?: Maybe<Scalars['Float']>;
  /** 턴오버 획득 */
  turnoversWon?: Maybe<Scalars['Float']>;
  /** VHIR 횟수 */
  vhirCount?: Maybe<Scalars['Float']>;
  /** VHIR 총 거리 */
  vhirDistance?: Maybe<Scalars['Float']>;
  /** 경고 */
  yellowCards?: Maybe<Scalars['Float']>;
};

/** 팀 매치 이벤트 (팀) 데이터 input */
export type TeamMatchEventData = {
  /** 공중볼 처리 성공률 */
  aerialActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 */
  aerialActions?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 성공 */
  aerialActionsWon?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공률 */
  aerialDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 */
  aerialDuels?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공 */
  aerialDuelsWon?: Maybe<Scalars['Float']>;
  /** 도움 */
  assists?: Maybe<Scalars['Float']>;
  /** 평균 속도 */
  averageSpeed?: Maybe<Scalars['Float']>;
  /** 백패스 성공률 */
  backPassAccuracy?: Maybe<Scalars['Float']>;
  /** 백패스 */
  backPasses?: Maybe<Scalars['Float']>;
  /** 블락된 슈팅 */
  blockedShots?: Maybe<Scalars['Float']>;
  /** 캐칭 */
  catches?: Maybe<Scalars['Float']>;
  /** 클리어 */
  clearances?: Maybe<Scalars['Float']>;
  /** 코너킥 */
  cornerKicks?: Maybe<Scalars['Float']>;
  /** 크로스 성공률 */
  crossAccuracy?: Maybe<Scalars['Float']>;
  /** 크로스 */
  crosses?: Maybe<Scalars['Float']>;
  /** 크로스 차단 */
  crossesBlocked?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 돌파 시도 */
  dribbleAttempts?: Maybe<Scalars['Float']>;
  /** 돌파 성공률 */
  dribbleSuccessRate?: Maybe<Scalars['Float']>;
  /** 전진 패스 성공률 */
  forwardPassAccuracy?: Maybe<Scalars['Float']>;
  /** 전진패스 */
  forwardPasses?: Maybe<Scalars['Float']>;
  /** 파울 */
  fouls?: Maybe<Scalars['Float']>;
  /** 피파울 */
  foulsSuffered?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 */
  freeKickCrosses?: Maybe<Scalars['Float']>;
  /** 프리킥 슈팅 */
  freeKickShots?: Maybe<Scalars['Float']>;
  /** 프리킥 유효 슈팅 */
  freeKickShotsOnTarget?: Maybe<Scalars['Float']>;
  /** 프리킥 */
  freeKicks?: Maybe<Scalars['Float']>;
  /** 골킥 */
  goalKicks?: Maybe<Scalars['Float']>;
  /** 득점 */
  goals?: Maybe<Scalars['Float']>;
  /** 실점 */
  goalsConceded?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공률 */
  groundActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 */
  groundActions?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공 */
  groundActionsWon?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공률 */
  groundDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 */
  groundDuels?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공 */
  groundDuelsWon?: Maybe<Scalars['Float']>;
  /** 핸드볼 파울 */
  handballFouls?: Maybe<Scalars['Float']>;
  /** 고강도 러닝 거리 비율 */
  highIntensityRunningRatio?: Maybe<Scalars['Float']>;
  /** 인터셉트 */
  interceptions?: Maybe<Scalars['Float']>;
  /** 키패스 */
  keyPasses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공률 */
  lateralPassAccuracy?: Maybe<Scalars['Float']>;
  /** 횡패스 */
  lateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리 패스 성공률 */
  longPassAccuracy?: Maybe<Scalars['Float']>;
  /** 장거리 패스 */
  longPasses?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공률 */
  looseBallDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 */
  looseBallDuels?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공 */
  looseBallDuelsWon?: Maybe<Scalars['Float']>;
  /** 중거리 패스 성공률 */
  mediumPassAccuracy?: Maybe<Scalars['Float']>;
  /** 중거리 패스 */
  mediumPasses?: Maybe<Scalars['Float']>;
  /** 볼미스 */
  miscontrols?: Maybe<Scalars['Float']>;
  /** 오프사이드 */
  offsides?: Maybe<Scalars['Float']>;
  /** 상대팀 */
  opponent: Scalars['String'];
  /** 자책골 */
  ownGoals?: Maybe<Scalars['Float']>;
  /** 패스성공률 */
  passAccuracy?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 성공률 */
  passAccuracyInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비지역 패스 성공률 */
  passAccuracyInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공률 */
  passAccuracyInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 */
  passes?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 */
  passesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 */
  passesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 */
  passesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 받음 */
  passesReceived?: Maybe<Scalars['Float']>;
  /** 페널티킥 허용 */
  penaltiesConceded?: Maybe<Scalars['Float']>;
  /** 페널티킥 획득 */
  penaltiesWon?: Maybe<Scalars['Float']>;
  /** 페널티킥 */
  penaltyKicks?: Maybe<Scalars['Float']>;
  /** 페널티킥 세이브 */
  penaltySaves?: Maybe<Scalars['Float']>;
  /** 점유율 */
  possession?: Maybe<Scalars['Float']>;
  /** 펀칭 */
  punches?: Maybe<Scalars['Float']>;
  /** 획득 */
  recoveries?: Maybe<Scalars['Float']>;
  /** 퇴장 */
  redCards?: Maybe<Scalars['Float']>;
  /** 라운드 */
  round?: Maybe<Scalars['String']>;
  /** 세이브 */
  saves?: Maybe<Scalars['Float']>;
  /** 일정ID */
  scheduleId: Scalars['ID'];
  /** 세트피스 득점 */
  setPieceGoals?: Maybe<Scalars['Float']>;
  /** 세트피스 득점 허용 */
  setPieceGoalsConceded?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 */
  setPieceShots?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 허용 */
  setPieceShotsConceded?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공률 */
  shortPassAccuracy?: Maybe<Scalars['Float']>;
  /** 단거리 패스 */
  shortPasses?: Maybe<Scalars['Float']>;
  /** 유효슈팅률 */
  shotAccuracy?: Maybe<Scalars['Float']>;
  /** 슈팅 차단 */
  shotsBlocked?: Maybe<Scalars['Float']>;
  /** 박스 안 슈팅 */
  shotsInsideBox?: Maybe<Scalars['Float']>;
  /** 벗어난 슈팅 */
  shotsOffTarget?: Maybe<Scalars['Float']>;
  /** 유효슈팅 */
  shotsOnTarget?: Maybe<Scalars['Float']>;
  /** 박스 밖 슈팅 */
  shotsOutsideBox?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  sprintCount?: Maybe<Scalars['Float']>;
  /** 스프린트 총 거리 */
  sprintDistance?: Maybe<Scalars['Float']>;
  /** 스텝인 */
  stepIns?: Maybe<Scalars['Float']>;
  /** 백패스 성공 */
  successfulBackPasses?: Maybe<Scalars['Float']>;
  /** 크로스 성공 */
  successfulCrosses?: Maybe<Scalars['Float']>;
  /** 돌파 성공 */
  successfulDribbles?: Maybe<Scalars['Float']>;
  /** 전진패스 성공 */
  successfulForwardPasses?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 성공 */
  successfulFreeKickCrosses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공 */
  successfulLateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리패스 성공 */
  successfulLongPasses?: Maybe<Scalars['Float']>;
  /** 중거리패스 성공 */
  successfulMediumPasses?: Maybe<Scalars['Float']>;
  /** 패스 성공 */
  successfulPasses?: Maybe<Scalars['Float']>;
  /** 공격 지역 패스 성공 */
  successfulPassesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 성공 */
  successfulPassesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공 */
  successfulPassesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공 */
  successfulShortPasses?: Maybe<Scalars['Float']>;
  /** 태클 시도 */
  tackleAttempts?: Maybe<Scalars['Float']>;
  /** 태클 실패 */
  tacklesLost?: Maybe<Scalars['Float']>;
  /** 태클 성공률 */
  tacklesSuccessRate?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 미획득 */
  tacklesWonNoPossession?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 획득 */
  tacklesWonPossession?: Maybe<Scalars['Float']>;
  /** 스로인 파울 */
  throwInFouls?: Maybe<Scalars['Float']>;
  /** 스로인 */
  throwIns?: Maybe<Scalars['Float']>;
  /** 최고 속도 */
  topSpeed?: Maybe<Scalars['Float']>;
  /** 총 차단 */
  totalBlocks?: Maybe<Scalars['Float']>;
  /** 총 거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 전체 파울 */
  totalFouls?: Maybe<Scalars['Float']>;
  /** 전체 슈팅 */
  totalShots?: Maybe<Scalars['Float']>;
  /** 턴오버 허용 */
  turnoversConceded?: Maybe<Scalars['Float']>;
  /** 턴오버 획득 */
  turnoversWon?: Maybe<Scalars['Float']>;
  /** VHIR 횟수 */
  vhirCount?: Maybe<Scalars['Float']>;
  /** VHIR 총 거리 */
  vhirDistance?: Maybe<Scalars['Float']>;
  /** 경고 */
  yellowCards?: Maybe<Scalars['Float']>;
};

export enum TeamMatchEventDataName {
  AERIAL_ACTIONS = 'AERIAL_ACTIONS',
  AERIAL_ACTIONS_WON = 'AERIAL_ACTIONS_WON',
  AERIAL_ACTION_SUCCESS_RATE = 'AERIAL_ACTION_SUCCESS_RATE',
  AERIAL_DUELS = 'AERIAL_DUELS',
  AERIAL_DUELS_WON = 'AERIAL_DUELS_WON',
  AERIAL_DUEL_SUCCESS_RATE = 'AERIAL_DUEL_SUCCESS_RATE',
  ASSISTS = 'ASSISTS',
  AVERAGE_SPEED = 'AVERAGE_SPEED',
  BACK_PASSES = 'BACK_PASSES',
  BACK_PASS_ACCURACY = 'BACK_PASS_ACCURACY',
  BLOCKED_SHOTS = 'BLOCKED_SHOTS',
  CATCHES = 'CATCHES',
  CLEARANCES = 'CLEARANCES',
  CORNER_KICKS = 'CORNER_KICKS',
  CROSSES = 'CROSSES',
  CROSSES_BLOCKED = 'CROSSES_BLOCKED',
  CROSS_ACCURACY = 'CROSS_ACCURACY',
  DATE = 'DATE',
  DRIBBLE_ATTEMPTS = 'DRIBBLE_ATTEMPTS',
  DRIBBLE_SUCCESS_RATE = 'DRIBBLE_SUCCESS_RATE',
  FORWARD_PASSES = 'FORWARD_PASSES',
  FORWARD_PASS_ACCURACY = 'FORWARD_PASS_ACCURACY',
  FOULS = 'FOULS',
  FOULS_SUFFERED = 'FOULS_SUFFERED',
  FREE_KICKS = 'FREE_KICKS',
  FREE_KICK_CROSSES = 'FREE_KICK_CROSSES',
  FREE_KICK_SHOTS = 'FREE_KICK_SHOTS',
  FREE_KICK_SHOTS_ON_TARGET = 'FREE_KICK_SHOTS_ON_TARGET',
  GOALS = 'GOALS',
  GOALS_CONCEDED = 'GOALS_CONCEDED',
  GOAL_KICKS = 'GOAL_KICKS',
  GROUND_ACTIONS = 'GROUND_ACTIONS',
  GROUND_ACTIONS_WON = 'GROUND_ACTIONS_WON',
  GROUND_ACTION_SUCCESS_RATE = 'GROUND_ACTION_SUCCESS_RATE',
  GROUND_DUELS = 'GROUND_DUELS',
  GROUND_DUELS_WON = 'GROUND_DUELS_WON',
  GROUND_DUEL_SUCCESS_RATE = 'GROUND_DUEL_SUCCESS_RATE',
  HANDBALL_FOULS = 'HANDBALL_FOULS',
  HIGH_INTENSITY_RUNNING_RATIO = 'HIGH_INTENSITY_RUNNING_RATIO',
  INTERCEPTIONS = 'INTERCEPTIONS',
  KEY_PASSES = 'KEY_PASSES',
  LATERAL_PASSES = 'LATERAL_PASSES',
  LATERAL_PASS_ACCURACY = 'LATERAL_PASS_ACCURACY',
  LONG_PASSES = 'LONG_PASSES',
  LONG_PASS_ACCURACY = 'LONG_PASS_ACCURACY',
  LOOSE_BALL_DUELS = 'LOOSE_BALL_DUELS',
  LOOSE_BALL_DUELS_WON = 'LOOSE_BALL_DUELS_WON',
  LOOSE_BALL_DUEL_SUCCESS_RATE = 'LOOSE_BALL_DUEL_SUCCESS_RATE',
  MEDIUM_PASSES = 'MEDIUM_PASSES',
  MEDIUM_PASS_ACCURACY = 'MEDIUM_PASS_ACCURACY',
  MISCONTROLS = 'MISCONTROLS',
  OFFSIDES = 'OFFSIDES',
  OPPONENT = 'OPPONENT',
  OWN_GOALS = 'OWN_GOALS',
  PASSES = 'PASSES',
  PASSES_IN_ATTACKING_THIRD = 'PASSES_IN_ATTACKING_THIRD',
  PASSES_IN_DEFENSIVE_THIRD = 'PASSES_IN_DEFENSIVE_THIRD',
  PASSES_IN_MIDDLE_THIRD = 'PASSES_IN_MIDDLE_THIRD',
  PASSES_RECEIVED = 'PASSES_RECEIVED',
  PASS_ACCURACY = 'PASS_ACCURACY',
  PASS_ACCURACY_IN_ATTACKING_THIRD = 'PASS_ACCURACY_IN_ATTACKING_THIRD',
  PASS_ACCURACY_IN_DEFENSIVE_THIRD = 'PASS_ACCURACY_IN_DEFENSIVE_THIRD',
  PASS_ACCURACY_IN_MIDDLE_THIRD = 'PASS_ACCURACY_IN_MIDDLE_THIRD',
  PENALTIES_CONCEDED = 'PENALTIES_CONCEDED',
  PENALTIES_WON = 'PENALTIES_WON',
  PENALTY_KICKS = 'PENALTY_KICKS',
  PENALTY_SAVES = 'PENALTY_SAVES',
  POSSESSION = 'POSSESSION',
  PUNCHES = 'PUNCHES',
  RECOVERIES = 'RECOVERIES',
  RED_CARDS = 'RED_CARDS',
  ROUND = 'ROUND',
  SAVES = 'SAVES',
  SET_PIECE_GOALS = 'SET_PIECE_GOALS',
  SET_PIECE_GOALS_CONCEDED = 'SET_PIECE_GOALS_CONCEDED',
  SET_PIECE_SHOTS = 'SET_PIECE_SHOTS',
  SET_PIECE_SHOTS_CONCEDED = 'SET_PIECE_SHOTS_CONCEDED',
  SHORT_PASSES = 'SHORT_PASSES',
  SHORT_PASS_ACCURACY = 'SHORT_PASS_ACCURACY',
  SHOTS_BLOCKED = 'SHOTS_BLOCKED',
  SHOTS_INSIDE_BOX = 'SHOTS_INSIDE_BOX',
  SHOTS_OFF_TARGET = 'SHOTS_OFF_TARGET',
  SHOTS_ON_TARGET = 'SHOTS_ON_TARGET',
  SHOTS_OUTSIDE_BOX = 'SHOTS_OUTSIDE_BOX',
  SHOT_ACCURACY = 'SHOT_ACCURACY',
  SPRINT_COUNT = 'SPRINT_COUNT',
  SPRINT_DISTANCE = 'SPRINT_DISTANCE',
  STEP_INS = 'STEP_INS',
  SUCCESSFUL_BACK_PASSES = 'SUCCESSFUL_BACK_PASSES',
  SUCCESSFUL_CROSSES = 'SUCCESSFUL_CROSSES',
  SUCCESSFUL_DRIBBLES = 'SUCCESSFUL_DRIBBLES',
  SUCCESSFUL_FORWARD_PASSES = 'SUCCESSFUL_FORWARD_PASSES',
  SUCCESSFUL_FREE_KICK_CROSSES = 'SUCCESSFUL_FREE_KICK_CROSSES',
  SUCCESSFUL_LATERAL_PASSES = 'SUCCESSFUL_LATERAL_PASSES',
  SUCCESSFUL_LONG_PASSES = 'SUCCESSFUL_LONG_PASSES',
  SUCCESSFUL_MEDIUM_PASSES = 'SUCCESSFUL_MEDIUM_PASSES',
  SUCCESSFUL_PASSES = 'SUCCESSFUL_PASSES',
  SUCCESSFUL_PASSES_IN_ATTACKING_THIRD = 'SUCCESSFUL_PASSES_IN_ATTACKING_THIRD',
  SUCCESSFUL_PASSES_IN_DEFENSIVE_THIRD = 'SUCCESSFUL_PASSES_IN_DEFENSIVE_THIRD',
  SUCCESSFUL_PASSES_IN_MIDDLE_THIRD = 'SUCCESSFUL_PASSES_IN_MIDDLE_THIRD',
  SUCCESSFUL_SHORT_PASSES = 'SUCCESSFUL_SHORT_PASSES',
  TACKLES_LOST = 'TACKLES_LOST',
  TACKLES_SUCCESS_RATE = 'TACKLES_SUCCESS_RATE',
  TACKLES_WON_NO_POSSESSION = 'TACKLES_WON_NO_POSSESSION',
  TACKLES_WON_POSSESSION = 'TACKLES_WON_POSSESSION',
  TACKLE_ATTEMPTS = 'TACKLE_ATTEMPTS',
  THROW_INS = 'THROW_INS',
  THROW_IN_FOULS = 'THROW_IN_FOULS',
  TOP_SPEED = 'TOP_SPEED',
  TOTAL_BLOCKS = 'TOTAL_BLOCKS',
  TOTAL_DISTANCE = 'TOTAL_DISTANCE',
  TOTAL_FOULS = 'TOTAL_FOULS',
  TOTAL_SHOTS = 'TOTAL_SHOTS',
  TURNOVERS_CONCEDED = 'TURNOVERS_CONCEDED',
  TURNOVERS_WON = 'TURNOVERS_WON',
  VHIR_COUNT = 'VHIR_COUNT',
  VHIR_DISTANCE = 'VHIR_DISTANCE',
  YELLOW_CARDS = 'YELLOW_CARDS'
}

/** 팀 매치 이벤트 데이터 임포트 히스토리 */
export type TeamMatchEventImportHistory = {
  __typename: 'TeamMatchEventImportHistory';
  aerialActionSuccessRate: Scalars['Boolean'];
  aerialActions: Scalars['Boolean'];
  aerialActionsWon: Scalars['Boolean'];
  aerialDuelSuccessRate: Scalars['Boolean'];
  aerialDuels: Scalars['Boolean'];
  aerialDuelsWon: Scalars['Boolean'];
  assists: Scalars['Boolean'];
  averageSpeed: Scalars['Boolean'];
  backPassAccuracy: Scalars['Boolean'];
  backPasses: Scalars['Boolean'];
  blockedShots: Scalars['Boolean'];
  catches: Scalars['Boolean'];
  clearances: Scalars['Boolean'];
  cornerKicks: Scalars['Boolean'];
  crossAccuracy: Scalars['Boolean'];
  crosses: Scalars['Boolean'];
  crossesBlocked: Scalars['Boolean'];
  dribbleAttempts: Scalars['Boolean'];
  dribbleSuccessRate: Scalars['Boolean'];
  forwardPassAccuracy: Scalars['Boolean'];
  forwardPasses: Scalars['Boolean'];
  fouls: Scalars['Boolean'];
  foulsSuffered: Scalars['Boolean'];
  freeKickCrosses: Scalars['Boolean'];
  freeKickShots: Scalars['Boolean'];
  freeKickShotsOnTarget: Scalars['Boolean'];
  freeKicks: Scalars['Boolean'];
  goalKicks: Scalars['Boolean'];
  goals: Scalars['Boolean'];
  goalsConceded: Scalars['Boolean'];
  groundActionSuccessRate: Scalars['Boolean'];
  groundActions: Scalars['Boolean'];
  groundActionsWon: Scalars['Boolean'];
  groundDuelSuccessRate: Scalars['Boolean'];
  groundDuels: Scalars['Boolean'];
  groundDuelsWon: Scalars['Boolean'];
  handballFouls: Scalars['Boolean'];
  highIntensityRunningRatio: Scalars['Boolean'];
  id: Scalars['ID'];
  interceptions: Scalars['Boolean'];
  keyPasses: Scalars['Boolean'];
  lateralPassAccuracy: Scalars['Boolean'];
  lateralPasses: Scalars['Boolean'];
  longPassAccuracy: Scalars['Boolean'];
  longPasses: Scalars['Boolean'];
  looseBallDuelSuccessRate: Scalars['Boolean'];
  looseBallDuels: Scalars['Boolean'];
  looseBallDuelsWon: Scalars['Boolean'];
  mediumPassAccuracy: Scalars['Boolean'];
  mediumPasses: Scalars['Boolean'];
  miscontrols: Scalars['Boolean'];
  offsides: Scalars['Boolean'];
  ownGoals: Scalars['Boolean'];
  passAccuracy: Scalars['Boolean'];
  passAccuracyInAttackingThird: Scalars['Boolean'];
  passAccuracyInDefensiveThird: Scalars['Boolean'];
  passAccuracyInMiddleThird: Scalars['Boolean'];
  passes: Scalars['Boolean'];
  passesInAttackingThird: Scalars['Boolean'];
  passesInDefensiveThird: Scalars['Boolean'];
  passesInMiddleThird: Scalars['Boolean'];
  passesReceived: Scalars['Boolean'];
  penaltiesConceded: Scalars['Boolean'];
  penaltiesWon: Scalars['Boolean'];
  penaltyKicks: Scalars['Boolean'];
  penaltySaves: Scalars['Boolean'];
  possession: Scalars['Boolean'];
  punches: Scalars['Boolean'];
  recoveries: Scalars['Boolean'];
  redCards: Scalars['Boolean'];
  saves: Scalars['Boolean'];
  setPieceGoals: Scalars['Boolean'];
  setPieceGoalsConceded: Scalars['Boolean'];
  setPieceShots: Scalars['Boolean'];
  setPieceShotsConceded: Scalars['Boolean'];
  shortPassAccuracy: Scalars['Boolean'];
  shortPasses: Scalars['Boolean'];
  shotAccuracy: Scalars['Boolean'];
  shotsBlocked: Scalars['Boolean'];
  shotsInsideBox: Scalars['Boolean'];
  shotsOffTarget: Scalars['Boolean'];
  shotsOnTarget: Scalars['Boolean'];
  shotsOutsideBox: Scalars['Boolean'];
  sprintCount: Scalars['Boolean'];
  sprintDistance: Scalars['Boolean'];
  stepIns: Scalars['Boolean'];
  successfulBackPasses: Scalars['Boolean'];
  successfulCrosses: Scalars['Boolean'];
  successfulDribbles: Scalars['Boolean'];
  successfulForwardPasses: Scalars['Boolean'];
  successfulFreeKickCrosses: Scalars['Boolean'];
  successfulLateralPasses: Scalars['Boolean'];
  successfulLongPasses: Scalars['Boolean'];
  successfulMediumPasses: Scalars['Boolean'];
  successfulPasses: Scalars['Boolean'];
  successfulPassesInAttackingThird: Scalars['Boolean'];
  successfulPassesInDefensiveThird: Scalars['Boolean'];
  successfulPassesInMiddleThird: Scalars['Boolean'];
  successfulShortPasses: Scalars['Boolean'];
  tackleAttempts: Scalars['Boolean'];
  tacklesLost: Scalars['Boolean'];
  tacklesSuccessRate: Scalars['Boolean'];
  tacklesWonNoPossession: Scalars['Boolean'];
  tacklesWonPossession: Scalars['Boolean'];
  throwInFouls: Scalars['Boolean'];
  throwIns: Scalars['Boolean'];
  topSpeed: Scalars['Boolean'];
  totalBlocks: Scalars['Boolean'];
  totalDistance: Scalars['Boolean'];
  totalFouls: Scalars['Boolean'];
  totalShots: Scalars['Boolean'];
  turnoversConceded: Scalars['Boolean'];
  turnoversWon: Scalars['Boolean'];
  vhirCount: Scalars['Boolean'];
  vhirDistance: Scalars['Boolean'];
  yellowCards: Scalars['Boolean'];
};

/** 팀 매치 이벤트 */
export type TeamMatchEventSimple = {
  __typename: 'TeamMatchEventSimple';
  /** 날짜 */
  date: Scalars['String'];
  /** 득점 */
  goals?: Maybe<Scalars['Float']>;
  /** 실점 */
  goalsConceded?: Maybe<Scalars['Float']>;
  /** 매치 이벤트 ID */
  id: Scalars['String'];
  /** 상대팀 */
  opponent: Scalars['String'];
  /** 라운드 */
  round?: Maybe<Scalars['String']>;
  /** 일정 ID */
  scheduleId: Scalars['String'];
};

/** 팀 매치 이벤트 데이터 기준 */
export type TeamMatchEventThreshold = MatchEventInfo & {
  __typename: 'TeamMatchEventThreshold';
  /** 공중볼 처리 성공률 */
  aerialActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 */
  aerialActions?: Maybe<Scalars['Float']>;
  /** 공중볼 처리 성공 */
  aerialActionsWon?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공률 */
  aerialDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 */
  aerialDuels?: Maybe<Scalars['Float']>;
  /** 공중볼 경합 성공 */
  aerialDuelsWon?: Maybe<Scalars['Float']>;
  /** 도움 */
  assists?: Maybe<Scalars['Float']>;
  /** 평균 속도 */
  averageSpeed?: Maybe<Scalars['Float']>;
  /** 백패스 성공률 */
  backPassAccuracy?: Maybe<Scalars['Float']>;
  /** 백패스 */
  backPasses?: Maybe<Scalars['Float']>;
  /** 블락된 슈팅 */
  blockedShots?: Maybe<Scalars['Float']>;
  /** 캐칭 */
  catches?: Maybe<Scalars['Float']>;
  /** 클리어 */
  clearances?: Maybe<Scalars['Float']>;
  /** 코너킥 */
  cornerKicks?: Maybe<Scalars['Float']>;
  /** 크로스 성공률 */
  crossAccuracy?: Maybe<Scalars['Float']>;
  /** 크로스 */
  crosses?: Maybe<Scalars['Float']>;
  /** 크로스 차단 */
  crossesBlocked?: Maybe<Scalars['Float']>;
  /** 돌파 시도 */
  dribbleAttempts?: Maybe<Scalars['Float']>;
  /** 돌파 성공률 */
  dribbleSuccessRate?: Maybe<Scalars['Float']>;
  /** 전진 패스 성공률 */
  forwardPassAccuracy?: Maybe<Scalars['Float']>;
  /** 전진패스 */
  forwardPasses?: Maybe<Scalars['Float']>;
  /** 파울 */
  fouls?: Maybe<Scalars['Float']>;
  /** 피파울 */
  foulsSuffered?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 */
  freeKickCrosses?: Maybe<Scalars['Float']>;
  /** 프리킥 슈팅 */
  freeKickShots?: Maybe<Scalars['Float']>;
  /** 프리킥 유효 슈팅 */
  freeKickShotsOnTarget?: Maybe<Scalars['Float']>;
  /** 프리킥 */
  freeKicks?: Maybe<Scalars['Float']>;
  /** 골킥 */
  goalKicks?: Maybe<Scalars['Float']>;
  /** 득점 */
  goals?: Maybe<Scalars['Float']>;
  /** 실점 */
  goalsConceded?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공률 */
  groundActionSuccessRate?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 */
  groundActions?: Maybe<Scalars['Float']>;
  /** 그라운드 처리 성공 */
  groundActionsWon?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공률 */
  groundDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 */
  groundDuels?: Maybe<Scalars['Float']>;
  /** 피지컬 경합 성공 */
  groundDuelsWon?: Maybe<Scalars['Float']>;
  /** 핸드볼 파울 */
  handballFouls?: Maybe<Scalars['Float']>;
  /** 고강도 러닝 거리 비율 */
  highIntensityRunningRatio?: Maybe<Scalars['Float']>;
  /** 인터셉트 */
  interceptions?: Maybe<Scalars['Float']>;
  /** 키패스 */
  keyPasses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공률 */
  lateralPassAccuracy?: Maybe<Scalars['Float']>;
  /** 횡패스 */
  lateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리 패스 성공률 */
  longPassAccuracy?: Maybe<Scalars['Float']>;
  /** 장거리 패스 */
  longPasses?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공률 */
  looseBallDuelSuccessRate?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 */
  looseBallDuels?: Maybe<Scalars['Float']>;
  /** 루즈볼 경합 성공 */
  looseBallDuelsWon?: Maybe<Scalars['Float']>;
  /** 중거리 패스 성공률 */
  mediumPassAccuracy?: Maybe<Scalars['Float']>;
  /** 중거리 패스 */
  mediumPasses?: Maybe<Scalars['Float']>;
  /** 볼미스 */
  miscontrols?: Maybe<Scalars['Float']>;
  /** 오프사이드 */
  offsides?: Maybe<Scalars['Float']>;
  /** 자책골 */
  ownGoals?: Maybe<Scalars['Float']>;
  /** 패스성공률 */
  passAccuracy?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 성공률 */
  passAccuracyInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비지역 패스 성공률 */
  passAccuracyInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공률 */
  passAccuracyInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 */
  passes?: Maybe<Scalars['Float']>;
  /** 공격지역 패스 */
  passesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 */
  passesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 */
  passesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 패스 받음 */
  passesReceived?: Maybe<Scalars['Float']>;
  /** 페널티킥 허용 */
  penaltiesConceded?: Maybe<Scalars['Float']>;
  /** 페널티킥 획득 */
  penaltiesWon?: Maybe<Scalars['Float']>;
  /** 페널티킥 */
  penaltyKicks?: Maybe<Scalars['Float']>;
  /** 페널티킥 세이브 */
  penaltySaves?: Maybe<Scalars['Float']>;
  /** 팀 점유율 */
  possession?: Maybe<Scalars['Float']>;
  /** 펀칭 */
  punches?: Maybe<Scalars['Float']>;
  /** 획득 */
  recoveries?: Maybe<Scalars['Float']>;
  /** 퇴장 */
  redCards?: Maybe<Scalars['Float']>;
  /** 세이브 */
  saves?: Maybe<Scalars['Float']>;
  /** 세트피스 득점 */
  setPieceGoals?: Maybe<Scalars['Float']>;
  /** 세트피스 득점 허용 */
  setPieceGoalsConceded?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 */
  setPieceShots?: Maybe<Scalars['Float']>;
  /** 세트피스 슈팅 허용 */
  setPieceShotsConceded?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공률 */
  shortPassAccuracy?: Maybe<Scalars['Float']>;
  /** 단거리 패스 */
  shortPasses?: Maybe<Scalars['Float']>;
  /** 유효슈팅률 */
  shotAccuracy?: Maybe<Scalars['Float']>;
  /** 슈팅 차단 */
  shotsBlocked?: Maybe<Scalars['Float']>;
  /** 박스 안 슈팅 */
  shotsInsideBox?: Maybe<Scalars['Float']>;
  /** 벗어난 슈팅 */
  shotsOffTarget?: Maybe<Scalars['Float']>;
  /** 유효슈팅 */
  shotsOnTarget?: Maybe<Scalars['Float']>;
  /** 박스 밖 슈팅 */
  shotsOutsideBox?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  sprintCount?: Maybe<Scalars['Float']>;
  /** 스프린트 총 거리 */
  sprintDistance?: Maybe<Scalars['Float']>;
  /** 스텝인 */
  stepIns?: Maybe<Scalars['Float']>;
  /** 백패스 성공 */
  successfulBackPasses?: Maybe<Scalars['Float']>;
  /** 크로스 성공 */
  successfulCrosses?: Maybe<Scalars['Float']>;
  /** 돌파 성공 */
  successfulDribbles?: Maybe<Scalars['Float']>;
  /** 전진패스 성공 */
  successfulForwardPasses?: Maybe<Scalars['Float']>;
  /** 프리킥 크로스 성공 */
  successfulFreeKickCrosses?: Maybe<Scalars['Float']>;
  /** 횡패스 성공 */
  successfulLateralPasses?: Maybe<Scalars['Float']>;
  /** 장거리패스 성공 */
  successfulLongPasses?: Maybe<Scalars['Float']>;
  /** 중거리패스 성공 */
  successfulMediumPasses?: Maybe<Scalars['Float']>;
  /** 패스 성공 */
  successfulPasses?: Maybe<Scalars['Float']>;
  /** 공격 지역 패스 성공 */
  successfulPassesInAttackingThird?: Maybe<Scalars['Float']>;
  /** 수비진영 패스 성공 */
  successfulPassesInDefensiveThird?: Maybe<Scalars['Float']>;
  /** 중앙지역 패스 성공 */
  successfulPassesInMiddleThird?: Maybe<Scalars['Float']>;
  /** 단거리 패스 성공 */
  successfulShortPasses?: Maybe<Scalars['Float']>;
  /** 태클 시도 */
  tackleAttempts?: Maybe<Scalars['Float']>;
  /** 태클 실패 */
  tacklesLost?: Maybe<Scalars['Float']>;
  /** 태클 성공률 */
  tacklesSuccessRate?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 미획득 */
  tacklesWonNoPossession?: Maybe<Scalars['Float']>;
  /** 태클 성공: 소유권 획득 */
  tacklesWonPossession?: Maybe<Scalars['Float']>;
  /** 스로인 파울 */
  throwInFouls?: Maybe<Scalars['Float']>;
  /** 스로인 */
  throwIns?: Maybe<Scalars['Float']>;
  /** 최고 속도 */
  topSpeed?: Maybe<Scalars['Float']>;
  /** 총 차단 */
  totalBlocks?: Maybe<Scalars['Float']>;
  /** 총 거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 전체 파울 */
  totalFouls?: Maybe<Scalars['Float']>;
  /** 전체 슈팅 */
  totalShots?: Maybe<Scalars['Float']>;
  /** 턴오버 허용 */
  turnoversConceded?: Maybe<Scalars['Float']>;
  /** 턴오버 획득 */
  turnoversWon?: Maybe<Scalars['Float']>;
  /** VHIR 횟수 */
  vhirCount?: Maybe<Scalars['Float']>;
  /** VHIR 총 거리 */
  vhirDistance?: Maybe<Scalars['Float']>;
  /** 경고 */
  yellowCards?: Maybe<Scalars['Float']>;
};

/** 팀 메디컬 */
export type TeamMedical = {
  __typename: 'TeamMedical';
  /** 팀 메디컬 평균 정보 */
  avg: TeamMedicalAvg;
  /** 팀 선수 메디컬 데이터 목록 및 평균 */
  individualData: TeamMedicalIndividualData;
};


/** 팀 메디컬 */
export type TeamMedicalAvgArgs = {
  from: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
  timezone: Scalars['String'];
  to: Scalars['String'];
};


/** 팀 메디컬 */
export type TeamMedicalIndividualDataArgs = {
  date: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
  timezone: Scalars['String'];
};

/** 팀 메디컬 평균 정보 */
export type TeamMedicalAvg = {
  __typename: 'TeamMedicalAvg';
  /** 팀 부상 평균 정보 */
  injury: TeamInjuryAvg;
  /** 팀 통증 평균 정보 */
  soreness: TeamSorenessAvg;
};

/** 팀 선수 메디컬 데이터 목록 및 평균 */
export type TeamMedicalIndividualData = {
  __typename: 'TeamMedicalIndividualData';
  /** 팀 선수 메디컬 평균 */
  avg: TeamIndividualMedicalAvg;
  /** 팀 선수 메디컬 데이터 목록 */
  userDataList: Array<TeamMedicalUser>;
};

/** 선수 메디컬 정보 */
export type TeamMedicalUser = {
  __typename: 'TeamMedicalUser';
  /** 부상 목록 */
  injuryList: Array<TeamInjury>;
  /** 통증 목록 */
  sorenessList: Array<TeamSoreness>;
  /** 선수 정보 */
  user: SportsUser;
};

/** 팀 데이터 피지컬 데이터 */
export type TeamPhysicalData = {
  __typename: 'TeamPhysicalData';
  /** 햄스트링 */
  hamstring: Hamstring;
  /** 고관절 */
  hipJoint: HipJoint;
  /** 인바디 */
  inBody: TeamInBody;
  /** 퍼포먼스 상세 */
  performance: PerformanceMeasurementDetail;
  /** 주요 퍼포먼스 목록 */
  performanceList: Array<Performance>;
  performanceScore: PerformanceScore;
  /** 부상 위험 */
  riskAtInjury: InjuryRisk;
  /** 리포트 요약 */
  summary: ReportSummery;
};

/** 팀데이터 피지컬 데이터 회차 정보 */
export type TeamPhysicalDataRound = {
  __typename: 'TeamPhysicalDataRound';
  /** 측정 날짜 */
  date: Scalars['String'];
  /** 팀 피지컬 데이터 회차 ID (클라이언트 캐싱용) */
  id: Scalars['String'];
  /** 회차 */
  round: Scalars['Float'];
};

/** 팀 데이터 피지컬 데이터 v2 */
export type TeamPhysicalDataV2 = {
  __typename: 'TeamPhysicalDataV2';
  /** 팀 피지컬 데이터 v2 평균 */
  avg?: Maybe<TeamPhysicalDataV2Avg>;
  /** 지난 5회차 팀 피지컬 데이터 v2 평균 목록 */
  prevAvgList: Array<TeamPhysicalDataV2AvgDate>;
  /** 선수 피지컬 데이터 v2 목록 */
  userDataList: Array<TeamPhysicalDataV2AvgUser>;
};

/** 선수 피지컬 데이터 v2 평균 */
export type TeamPhysicalDataV2Avg = TeamPhysicalDataV2Info & {
  __typename: 'TeamPhysicalDataV2Avg';
  /** 수직 점프 상승 국면 근력 */
  cmjConcentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 하강 국면 근력 */
  cmjEccentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 높이 */
  cmjHeight?: Maybe<Scalars['Float']>;
  /** 수직 점프 순간 최대 파워 */
  cmjPeakPower?: Maybe<Scalars['Float']>;
  /** 체지방률 */
  fatPercentage?: Maybe<Scalars['Float']>;
  /** 햄스트링 좌우 불균형 지수 */
  nordicHamstringAsymmetry?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (좌) */
  nordicHamstringAverageForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (우) */
  nordicHamstringAverageForceRight?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (좌) */
  nordicHamstringMaxForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (우) */
  nordicHamstringMaxForceRight?: Maybe<Scalars['Float']>;
  /** RSI */
  reactiveStrengthIndex?: Maybe<Scalars['Float']>;
  /** 9개 부위 피부두겹 두께 합 */
  sum9P?: Maybe<Scalars['Float']>;
  /** 몸무게 */
  weight?: Maybe<Scalars['Float']>;
};

/** 날짜별 팀 피지컬 데이터 v2 평균 */
export type TeamPhysicalDataV2AvgDate = TeamPhysicalDataV2Info & {
  __typename: 'TeamPhysicalDataV2AvgDate';
  /** 수직 점프 상승 국면 근력 */
  cmjConcentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 하강 국면 근력 */
  cmjEccentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 높이 */
  cmjHeight?: Maybe<Scalars['Float']>;
  /** 수직 점프 순간 최대 파워 */
  cmjPeakPower?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 체지방률 */
  fatPercentage?: Maybe<Scalars['Float']>;
  /** 햄스트링 좌우 불균형 지수 */
  nordicHamstringAsymmetry?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (좌) */
  nordicHamstringAverageForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (우) */
  nordicHamstringAverageForceRight?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (좌) */
  nordicHamstringMaxForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (우) */
  nordicHamstringMaxForceRight?: Maybe<Scalars['Float']>;
  /** RSI */
  reactiveStrengthIndex?: Maybe<Scalars['Float']>;
  /** 9개 부위 피부두겹 두께 합 */
  sum9P?: Maybe<Scalars['Float']>;
  /** 몸무게 */
  weight?: Maybe<Scalars['Float']>;
};

/** 선수 피지컬 데이터 v2 */
export type TeamPhysicalDataV2AvgUser = TeamPhysicalDataV2Info & {
  __typename: 'TeamPhysicalDataV2AvgUser';
  /** 수직 점프 상승 국면 근력 */
  cmjConcentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 하강 국면 근력 */
  cmjEccentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 높이 */
  cmjHeight?: Maybe<Scalars['Float']>;
  /** 수직 점프 순간 최대 파워 */
  cmjPeakPower?: Maybe<Scalars['Float']>;
  /** 체지방률 */
  fatPercentage?: Maybe<Scalars['Float']>;
  /** 햄스트링 좌우 불균형 지수 */
  nordicHamstringAsymmetry?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (좌) */
  nordicHamstringAverageForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (우) */
  nordicHamstringAverageForceRight?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (좌) */
  nordicHamstringMaxForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (우) */
  nordicHamstringMaxForceRight?: Maybe<Scalars['Float']>;
  /** RSI */
  reactiveStrengthIndex?: Maybe<Scalars['Float']>;
  /** 9개 부위 피부두겹 두께 합 */
  sum9P?: Maybe<Scalars['Float']>;
  /** 선수 정보 */
  user: SportsUser;
  /** 몸무게 */
  weight?: Maybe<Scalars['Float']>;
};

/** 피지컬 데이터 기준 대비 비교 분석 */
export type TeamPhysicalDataV2CompareAnalysis = {
  __typename: 'TeamPhysicalDataV2CompareAnalysis';
  /** 피지컬 데이터 기준 */
  threshold?: Maybe<TeamPhysicalDataV2Threshold>;
  /** 피지컬 데이터 기준 대비 비교 분석 상세 목록 */
  userDataList: Array<TeamPhysicalDataV2CompareAnalysisDetail>;
};

/** 피지컬 데이터 기준 대비 비교 분석 상세 */
export type TeamPhysicalDataV2CompareAnalysisDetail = {
  __typename: 'TeamPhysicalDataV2CompareAnalysisDetail';
  /** 선수 정보 */
  user: SportsUser;
  /** 값 */
  value: Scalars['Float'];
};

/** 팀 피지컬 데이터 임포트 히스토리 */
export type TeamPhysicalDataV2ImportHistory = {
  __typename: 'TeamPhysicalDataV2ImportHistory';
  cmjConcentricForce: Scalars['Boolean'];
  cmjEccentricForce: Scalars['Boolean'];
  cmjHeight: Scalars['Boolean'];
  cmjPeakPower: Scalars['Boolean'];
  fatPercentage: Scalars['Boolean'];
  id: Scalars['ID'];
  nordicHamstringAsymmetry: Scalars['Boolean'];
  nordicHamstringAverageForceLeft: Scalars['Boolean'];
  nordicHamstringAverageForceRight: Scalars['Boolean'];
  nordicHamstringMaxForceLeft: Scalars['Boolean'];
  nordicHamstringMaxForceRight: Scalars['Boolean'];
  reactiveStrengthIndex: Scalars['Boolean'];
  sum9P: Scalars['Boolean'];
  weight: Scalars['Boolean'];
};

/** 피지컬 데이터 v2 */
export type TeamPhysicalDataV2Info = {
  /** 수직 점프 상승 국면 근력 */
  cmjConcentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 하강 국면 근력 */
  cmjEccentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 높이 */
  cmjHeight?: Maybe<Scalars['Float']>;
  /** 수직 점프 순간 최대 파워 */
  cmjPeakPower?: Maybe<Scalars['Float']>;
  /** 체지방률 */
  fatPercentage?: Maybe<Scalars['Float']>;
  /** 햄스트링 좌우 불균형 지수 */
  nordicHamstringAsymmetry?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (좌) */
  nordicHamstringAverageForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (우) */
  nordicHamstringAverageForceRight?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (좌) */
  nordicHamstringMaxForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (우) */
  nordicHamstringMaxForceRight?: Maybe<Scalars['Float']>;
  /** RSI */
  reactiveStrengthIndex?: Maybe<Scalars['Float']>;
  /** 9개 부위 피부두겹 두께 합 */
  sum9P?: Maybe<Scalars['Float']>;
  /** 몸무게 */
  weight?: Maybe<Scalars['Float']>;
};

/** 피지컬 데이터 기준 */
export type TeamPhysicalDataV2Threshold = {
  __typename: 'TeamPhysicalDataV2Threshold';
  /** 피지컬 데이터 기준 ID */
  id: Scalars['String'];
  /** 연산자 */
  operator: OptionOperator;
  /** 순서 */
  order: Scalars['Float'];
  /** 타입 */
  type: PhysicalDataV2Type;
  /** 값 */
  value: Scalars['Float'];
};

/** 팀 선수 데이터 */
export type TeamPlayerData = {
  __typename: 'TeamPlayerData';
  /** 신체 목록 */
  bodyList?: Maybe<Array<TeamDataPlayerDataBody>>;
  /** 컨디션 목록 */
  conditionList?: Maybe<Array<TeamDataPlayerDataCondition>>;
  /** 통증 목록 */
  sorenessList?: Maybe<Array<TeamDataPlayerDataSoreness>>;
  /** 운동부하 목록 */
  workloadList?: Maybe<Array<TeamDataPlayerDataWorkload>>;
};

/** 팀 선수 개별 데이터  */
export type TeamPlayerIndividualData = {
  __typename: 'TeamPlayerIndividualData';
  /** 신체 목록 */
  bodyList: Array<TeamPlayerIndividualDataBody>;
  /** 컨디션 목록 */
  conditionList: Array<TeamPlayerIndividualDataCondition>;
  /** 통증 목록 */
  sorenessList: Array<TeamPlayerIndividualDataSoreness>;
  /** 운동부하 목록 */
  workloadList: Array<TeamPlayerIndividualDataWorkload>;
};

/** 팀데이터 선수 데이터 신체 */
export type TeamPlayerIndividualDataBody = {
  __typename: 'TeamPlayerIndividualDataBody';
  /** bmi */
  bmi?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 키 */
  height?: Maybe<Scalars['Float']>;
  /** 결측 여부 */
  isFake: Scalars['Boolean'];
  /** 권장 수분 섭취량 */
  recommendedHydration?: Maybe<Scalars['Float']>;
  /** 체중 */
  weight?: Maybe<Scalars['Float']>;
};

/** 팀 데이터 선수 데이터 신체 */
export type TeamPlayerIndividualDataBodyInfo = {
  __typename: 'TeamPlayerIndividualDataBodyInfo';
  /** bmi */
  bmi?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 키 */
  height?: Maybe<Scalars['Float']>;
  /** 권장 수분 섭취량 */
  recommendedHydration?: Maybe<Scalars['Float']>;
  /** 체중 */
  weight?: Maybe<Scalars['Float']>;
};

/** 팀 선수 데이터 컨디션 */
export type TeamPlayerIndividualDataCondition = {
  __typename: 'TeamPlayerIndividualDataCondition';
  /** 컨디션 점수 */
  condition?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 피로도 */
  fatigue?: Maybe<Scalars['Float']>;
  /** 기분 */
  mood?: Maybe<Scalars['Float']>;
  /** 근육 */
  muscle?: Maybe<Scalars['Float']>;
  /** 컨디션 점수 */
  score?: Maybe<Scalars['Float']>;
  /** 수면기간 */
  sleepDuration?: Maybe<Scalars['Float']>;
  /** 수면품질 */
  sleepQuality?: Maybe<Scalars['Float']>;
  /** 스트레스 */
  stress?: Maybe<Scalars['Float']>;
};

/** 팀 데이터 선수 외적부하 (날짜별) */
export type TeamPlayerIndividualDataExternalWorkloadByDate = {
  __typename: 'TeamPlayerIndividualDataExternalWorkloadByDate';
  /** 일간 스프린트 횟수 */
  dailyCountOfSprint?: Maybe<Scalars['Float']>;
  /** 일간 이동거리 */
  dailyTotalDistance?: Maybe<Scalars['Float']>;
  /** 일간 운동한 시간 */
  dailyTotalDuration?: Maybe<Scalars['Float']>;
  /** 일간 HSR 거리 */
  dailyTotalHsrDistance?: Maybe<Scalars['Float']>;
  /** 일간 외적 운동부하 */
  dailyTotalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
};

/** 팀 데이터 선수 외적부하 (일정별) */
export type TeamPlayerIndividualDataExternalWorkloadBySchedule = ExternalWorkloadInfo & {
  __typename: 'TeamPlayerIndividualDataExternalWorkloadBySchedule';
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 accelerationB2_3TotalCount 최댓값 대비 해당 세션의 accelerationB2_3TotalCount 비율 */
  accelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 가속 횟수 */
  accelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 가속 횟수 */
  accelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 가속 횟수 */
  accelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 평균 심박수 */
  averageHeartRate?: Maybe<Scalars['Float']>;
  /** 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeet?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetRight?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 decelerationB2_3TotalCount 최댓값 대비 해당 세션의 decelerationB2_3TotalCount 비율 */
  decelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 감속 횟수 */
  decelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 감속 횟수 */
  decelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 감속 횟수 */
  decelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 분당 이동거리 */
  distancePerMinute?: Maybe<Scalars['Float']>;
  /** 심박 기반 세션 부하 지표 */
  heartRateExertion?: Maybe<Scalars['Float']>;
  /** 대사적으로 높은 부하가 걸리는 상황에서 이동한 거리 */
  highMetabolicLoadDistance?: Maybe<Scalars['Float']>;
  /** 분당 고속주행 거리 */
  hsrPerMinute?: Maybe<Scalars['Float']>;
  /** 고강도 가속 이벤트 수 */
  imaAccelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 가속 이벤트 수 */
  imaAccelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 가속 이벤트 수 */
  imaAccelerationMedium?: Maybe<Scalars['Float']>;
  /** 고강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftHigh?: Maybe<Scalars['Float']>;
  /** 저강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftLow?: Maybe<Scalars['Float']>;
  /** 중강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftMedium?: Maybe<Scalars['Float']>;
  /** 고강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightHigh?: Maybe<Scalars['Float']>;
  /** 저강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightLow?: Maybe<Scalars['Float']>;
  /** 중강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightMedium?: Maybe<Scalars['Float']>;
  /** 고강도 감속 이벤트 수 */
  imaDecelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 감속 이벤트 수 */
  imaDecelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 감속 이벤트 수 */
  imaDecelerationMedium?: Maybe<Scalars['Float']>;
  /** B4 구간 점프 착지 횟수 */
  imaJumpCountBand4?: Maybe<Scalars['Float']>;
  /** 고강도 점프 착지 횟수 */
  imaJumpCountHighBand?: Maybe<Scalars['Float']>;
  /** 저강도 점프 착지 횟수 */
  imaJumpCountLowBand?: Maybe<Scalars['Float']>;
  /** 중강도 점프 착지 횟수 */
  imaJumpCountMediumBand?: Maybe<Scalars['Float']>;
  /** 최대 가속도 */
  maximumAcceleration?: Maybe<Scalars['Float']>;
  /** 최대 감속도 */
  maximumDeceleration?: Maybe<Scalars['Float']>;
  /** 최대 심박수 */
  maximumHeartRate?: Maybe<Scalars['Float']>;
  /** 최고 속력 */
  maximumSpeed?: Maybe<Scalars['Float']>;
  /** 선수 개인의 maximumSpeed 최댓값 대비 해당 세션의 maximumSpeed 비율 */
  maximumSpeedPerMax?: Maybe<Scalars['Float']>;
  /** 최대 힘 발휘해내는 능력 */
  metaEnergy?: Maybe<Scalars['Float']>;
  /** 좌우 다리 간 부하의 비대칭성 */
  runningImbalance?: Maybe<Scalars['Float']>;
  /** 일정 이름 */
  scheduleName?: Maybe<Scalars['String']>;
  /** 일정 타입 */
  scheduleType: ScheduleDetailType;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 총 뛴 거리 기반 ACWR */
  totalDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalDistance 최댓값 대비 해당 세션의 totalDistance 비율 */
  totalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 다이브 한 횟수 */
  totalDiveCount?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 횟수 */
  totalDiveCountCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 횟수 */
  totalDiveCountLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 횟수 */
  totalDiveCountRight?: Maybe<Scalars['Float']>;
  /** 다이브 함으로써 생긴 부하 */
  totalDiveLoad?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadRight?: Maybe<Scalars['Float']>;
  /** 운동한 시간 */
  totalDuration?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** HSR 거리 기반 ACWR */
  totalHsrDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalHsrDistance 최댓값 대비 해당 세션의 totalHsrDistance 비율 */
  totalHsrDistancePerMax?: Maybe<Scalars['Float']>;
  /** 점프한 총 횟수 */
  totalJumpCount?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  totalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이상 횟수 */
  velocityB4TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이상 횟수 */
  velocityB5TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이상 횟수 */
  velocityB6TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동거리 */
  velocityBand1TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동시간 */
  velocityBand1TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동거리 */
  velocityBand2TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동시간 */
  velocityBand2TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동거리 */
  velocityBand3TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동시간 */
  velocityBand3TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동거리 */
  velocityBand4TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동시간 */
  velocityBand4TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동거리 */
  velocityBand5TotalDistance?: Maybe<Scalars['Float']>;
  /** 선수 개인의 velocityBand5TotalDistance 최댓값 대비 해당 세션의 velocityBand5TotalDistance 비율 */
  velocityBand5TotalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동시간 */
  velocityBand5TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동거리 */
  velocityBand6TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동시간 */
  velocityBand6TotalDuration?: Maybe<Scalars['Float']>;
};

/** 날짜별 팀 선수 피지컬 데이터 v2 */
export type TeamPlayerIndividualDataPhysicalDataV2 = TeamPhysicalDataV2Info & {
  __typename: 'TeamPlayerIndividualDataPhysicalDataV2';
  /** 수직 점프 상승 국면 근력 */
  cmjConcentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 하강 국면 근력 */
  cmjEccentricForce?: Maybe<Scalars['Float']>;
  /** 수직 점프 높이 */
  cmjHeight?: Maybe<Scalars['Float']>;
  /** 수직 점프 순간 최대 파워 */
  cmjPeakPower?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 체지방률 */
  fatPercentage?: Maybe<Scalars['Float']>;
  /** 햄스트링 좌우 불균형 지수 */
  nordicHamstringAsymmetry?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (좌) */
  nordicHamstringAverageForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 평균 근력 (우) */
  nordicHamstringAverageForceRight?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (좌) */
  nordicHamstringMaxForceLeft?: Maybe<Scalars['Float']>;
  /** 햄스트링 최대 근력 (우) */
  nordicHamstringMaxForceRight?: Maybe<Scalars['Float']>;
  /** RSI */
  reactiveStrengthIndex?: Maybe<Scalars['Float']>;
  /** 9개 부위 피부두겹 두께 합 */
  sum9P?: Maybe<Scalars['Float']>;
  /** 몸무게 */
  weight?: Maybe<Scalars['Float']>;
};

/** 팀 데이터 선수 데이터 운동부하 상세 */
export type TeamPlayerIndividualDataPlayerDataWorkloadDetail = {
  __typename: 'TeamPlayerIndividualDataPlayerDataWorkloadDetail';
  /** 운동시간 */
  duration: Scalars['Float'];
  /** 운동부하ID */
  id: Scalars['String'];
  /** 운동강도 */
  intensity: Scalars['Float'];
  /** 피드백 작성여부 */
  isFeedbackCreated: Scalars['Boolean'];
  /** 다른팀 운동부하 작성 여부 */
  isOtherTeamWorkload: Scalars['Boolean'];
  /** 운동부하 */
  load: Scalars['Float'];
  /** 운동메모 */
  memo: Scalars['String'];
  /** 운동만족 */
  satisfaction: Scalars['Float'];
  /** 일정 상세 종류 */
  scheduleDetailType?: Maybe<ScheduleDetailType>;
  /** 일정명 */
  scheduleName?: Maybe<Scalars['String']>;
  /** 운동부하 종류 */
  workloadType: WorkloadType;
  /** 운동 종류 */
  workoutType: WorkoutType;
};

/** 팀 데이터 선수 데이터 통증 상세 목록 */
export type TeamPlayerIndividualDataSoreness = {
  __typename: 'TeamPlayerIndividualDataSoreness';
  /** 날짜 */
  date: Scalars['String'];
  /** 1단계 */
  level1?: Maybe<Array<TeamDataPlayerDataSorenessBodyPart>>;
  /** 2단계 */
  level2?: Maybe<Array<TeamDataPlayerDataSorenessBodyPart>>;
  /** 3단계 */
  level3?: Maybe<Array<TeamDataPlayerDataSorenessBodyPart>>;
  /** 4단계 */
  level4?: Maybe<Array<TeamDataPlayerDataSorenessBodyPart>>;
  /** 5단계 */
  level5?: Maybe<Array<TeamDataPlayerDataSorenessBodyPart>>;
};

/** 팀 데이터 선수 데이터 통증 상세 */
export type TeamPlayerIndividualDataSorenessInfo = {
  __typename: 'TeamPlayerIndividualDataSorenessInfo';
  /** 최신 업데이트 일자 */
  lastUpdatedAt?: Maybe<Scalars['String']>;
  /** 통증 목록 */
  sorenessList: Array<Soreness>;
};

/** 팀 선수 데이터 운동부하 */
export type TeamPlayerIndividualDataWorkload = {
  __typename: 'TeamPlayerIndividualDataWorkload';
  /** acwr */
  acwr?: Maybe<Scalars['Float']>;
  /** 급성부하 */
  aw?: Maybe<Scalars['Float']>;
  /** 단조로움 */
  awd?: Maybe<Scalars['Float']>;
  /** 만성부하 */
  cw?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 팀 데이터 선수데이터 운동부하 상세 목록 */
  list?: Maybe<Array<TeamPlayerIndividualDataPlayerDataWorkloadDetail>>;
  /** 운동 안 함 이유 */
  reasonForNoWorkout?: Maybe<NoWorkoutType>;
  /** 중압감 */
  strain?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  workload?: Maybe<Scalars['Float']>;
};

/** 팀 데이터 선수 데이터 운동부하 상세 */
export type TeamPlayerIndividualDataWorkloadInfo = {
  __typename: 'TeamPlayerIndividualDataWorkloadInfo';
  /** 운동시간 */
  duration: Scalars['Float'];
  /** 운동 종료 시간 */
  endTime: Scalars['String'];
  /** 운동부하ID */
  id: Scalars['String'];
  /** 운동강도 */
  intensity: Scalars['Float'];
  /** 피드백 작성여부 */
  isFeedbackCreated: Scalars['Boolean'];
  /** 다른팀 운동부하 작성 여부 */
  isOtherTeamWorkload: Scalars['Boolean'];
  /** 운동부하 */
  load: Scalars['Float'];
  /** 운동메모 */
  memo: Scalars['String'];
  /** 운동만족 */
  satisfaction: Scalars['Float'];
  /** 일정명 */
  scheduleName?: Maybe<Scalars['String']>;
  /** 일정 상세 종류 */
  scheduleType?: Maybe<ScheduleDetailType>;
  /** 운동 시작 시간 */
  startTime: Scalars['String'];
  /** 운동 종류 */
  workoutType: WorkoutType;
};

/** 팀 데이터 선수 데이터 매치 이벤트 */
export type TeamPlayerIndividualMatchEvent = MatchEvent & {
  __typename: 'TeamPlayerIndividualMatchEvent';
  /** 공격 지표 */
  attack: Attack;
  /** 볼 배급 지표 */
  ballDistribution: BallDistribution;
  /** 날짜 */
  date: Scalars['String'];
  /** 수비 지표 */
  defense: Defense;
  /** 파울 지표 */
  foul: Foul;
  /** 골키퍼 지표 */
  goalkeeper: Goalkeeper;
  /** 상대팀 */
  opponent: Scalars['String'];
  /** 피지컬 지표 */
  physical: Physical;
  /** 세트피스 지표 */
  setPiece: SetPiece;
};

/** 팀 선수 데이터 운동부하 */
export type TeamPlayerIndividualWorkload = {
  __typename: 'TeamPlayerIndividualWorkload';
  /** acwr */
  acwr?: Maybe<Scalars['Float']>;
  /** 급성부하 */
  aw?: Maybe<Scalars['Float']>;
  /** 단조로움 */
  awd?: Maybe<Scalars['Float']>;
  /** 만성부하 */
  cw?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 팀 데이터 선수데이터 운동부하 상세 목록 */
  list?: Maybe<Array<TeamPlayerIndividualDataWorkloadInfo>>;
  /** 운동 안 함 이유 */
  reasonForNoWorkout?: Maybe<NoWorkoutType>;
  /** 중압감 */
  strain?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  workload?: Maybe<Scalars['Float']>;
};

/** 팀 선수 이름 매칭 히스토리 */
export type TeamPlayerNameMatchHistory = {
  __typename: 'TeamPlayerNameMatchHistory';
  /** 선수 이름 */
  playerName: Scalars['String'];
  /** 선수 ID */
  userId: Scalars['String'];
};

/** 팀 선수단 개별 데이터  */
export type TeamPlayerSquadIndividualData = {
  __typename: 'TeamPlayerSquadIndividualData';
  /** 신체 목록 */
  bodyList: Array<TeamPlayerIndividualDataBodyInfo>;
  /** 컨디션 목록 */
  conditionList: Array<TeamPlayerIndividualDataCondition>;
  /** 현재 부상 목록 */
  currentInjuryList: Array<Injury>;
  /** 날짜별 외적부하 목록 */
  externalWorkloadListByDate: Array<TeamPlayerIndividualDataExternalWorkloadByDate>;
  /** 일정별 외적부하 목록 */
  externalWorkloadListBySchedule: Array<TeamPlayerIndividualDataExternalWorkloadBySchedule>;
  /** 매치 이벤트 목록 */
  matchEventList: Array<TeamPlayerIndividualMatchEvent>;
  /** 과거 부상 목록 */
  pastInjuryList: Array<Injury>;
  /** 피지컬 목록 */
  physicalDataV2List: Array<TeamPlayerIndividualDataPhysicalDataV2>;
  /** 최근 회복된 통증 목록 */
  recentSorenessRecoveryList: Array<SportsBodyPart>;
  /** 통증 */
  soreness: TeamPlayerIndividualDataSorenessInfo;
  /** 날짜별 통증 목록 */
  sorenessList: Array<TeamPlayerIndividualDataSoreness>;
  /** 내적부하 목록 */
  workloadList: Array<TeamPlayerIndividualWorkload>;
};


/** 팀 선수단 개별 데이터  */
export type TeamPlayerSquadIndividualDataBodyListArgs = {
  date: Scalars['String'];
};


/** 팀 선수단 개별 데이터  */
export type TeamPlayerSquadIndividualDataConditionListArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** 팀 선수단 개별 데이터  */
export type TeamPlayerSquadIndividualDataExternalWorkloadListByDateArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** 팀 선수단 개별 데이터  */
export type TeamPlayerSquadIndividualDataExternalWorkloadListByScheduleArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** 팀 선수단 개별 데이터  */
export type TeamPlayerSquadIndividualDataMatchEventListArgs = {
  date: Scalars['String'];
};


/** 팀 선수단 개별 데이터  */
export type TeamPlayerSquadIndividualDataPhysicalDataV2ListArgs = {
  date: Scalars['String'];
};


/** 팀 선수단 개별 데이터  */
export type TeamPlayerSquadIndividualDataRecentSorenessRecoveryListArgs = {
  date: Scalars['String'];
  input: MultilingualTextInput;
};


/** 팀 선수단 개별 데이터  */
export type TeamPlayerSquadIndividualDataSorenessArgs = {
  date: Scalars['String'];
};


/** 팀 선수단 개별 데이터  */
export type TeamPlayerSquadIndividualDataSorenessListArgs = {
  from: Scalars['String'];
  input: MultilingualTextInput;
  timezone: Scalars['String'];
  to: Scalars['String'];
};


/** 팀 선수단 개별 데이터  */
export type TeamPlayerSquadIndividualDataWorkloadListArgs = {
  from: Scalars['String'];
  scheduleOnly?: Maybe<Scalars['Boolean']>;
  timezone: Scalars['String'];
  to: Scalars['String'];
};

/** RHIE vs RPE 데이터 비교 분석 */
export type TeamRhieVsRpeCompareAnalysis = {
  __typename: 'TeamRhieVsRpeCompareAnalysis';
  /** 날짜 */
  date: Scalars['String'];
  /** 강도 */
  intensity?: Maybe<Scalars['Float']>;
  /** 세션 이름 */
  scheduleName?: Maybe<Scalars['String']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
};

/** 팀 스카우팅 데이터 */
export type TeamScouting = {
  __typename: 'TeamScouting';
  /** ID */
  id: Scalars['ID'];
  /** 스카우팅 모델 목록 */
  modelList: Array<ScoutingModel>;
  /** 스카우팅 선수 상세 */
  prospectPlayer: ProspectPlayer;
  /** 스카우팅 선수 목록 */
  prospectPlayerList: Array<ProspectPlayer>;
};


/** 팀 스카우팅 데이터 */
export type TeamScoutingProspectPlayerArgs = {
  id: Scalars['ID'];
};

/** 팀 세션 종합 운동부하 */
export type TeamSessionWorkload = {
  __typename: 'TeamSessionWorkload';
  /** 팀 세션 종합 운동부하 */
  avg: TeamSessionWorkloadInfo;
  /** 팀 세션 드릴 별 운동부하 평균 목록 */
  drillList: Array<TeamDrillWorkloadInfo>;
  /** 선수 세션 종합 운동부하 목록 */
  individualData: Array<TeamSessionWorkloadUser>;
  /** 세션 (일정) 정보 */
  schedule: Schedule;
};

/** 세션 종합 운동부하 평균 */
export type TeamSessionWorkloadInfo = ExternalWorkloadInfo & {
  __typename: 'TeamSessionWorkloadInfo';
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 accelerationB2_3TotalCount 최댓값 대비 해당 세션의 accelerationB2_3TotalCount 비율 */
  accelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 가속 횟수 */
  accelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 가속 횟수 */
  accelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 가속 횟수 */
  accelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 내적부하 acwr */
  acwr?: Maybe<Scalars['Float']>;
  /** 평균 심박수 */
  averageHeartRate?: Maybe<Scalars['Float']>;
  /** 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeet?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetRight?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 decelerationB2_3TotalCount 최댓값 대비 해당 세션의 decelerationB2_3TotalCount 비율 */
  decelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 감속 횟수 */
  decelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 감속 횟수 */
  decelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 감속 횟수 */
  decelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 분당 이동거리 */
  distancePerMinute?: Maybe<Scalars['Float']>;
  /** 심박 기반 세션 부하 지표 */
  heartRateExertion?: Maybe<Scalars['Float']>;
  /** 대사적으로 높은 부하가 걸리는 상황에서 이동한 거리 */
  highMetabolicLoadDistance?: Maybe<Scalars['Float']>;
  /** 분당 고속주행 거리 */
  hsrPerMinute?: Maybe<Scalars['Float']>;
  /** 고강도 가속 이벤트 수 */
  imaAccelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 가속 이벤트 수 */
  imaAccelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 가속 이벤트 수 */
  imaAccelerationMedium?: Maybe<Scalars['Float']>;
  /** 고강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftHigh?: Maybe<Scalars['Float']>;
  /** 저강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftLow?: Maybe<Scalars['Float']>;
  /** 중강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftMedium?: Maybe<Scalars['Float']>;
  /** 고강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightHigh?: Maybe<Scalars['Float']>;
  /** 저강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightLow?: Maybe<Scalars['Float']>;
  /** 중강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightMedium?: Maybe<Scalars['Float']>;
  /** 고강도 감속 이벤트 수 */
  imaDecelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 감속 이벤트 수 */
  imaDecelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 감속 이벤트 수 */
  imaDecelerationMedium?: Maybe<Scalars['Float']>;
  /** B4 구간 점프 착지 횟수 */
  imaJumpCountBand4?: Maybe<Scalars['Float']>;
  /** 고강도 점프 착지 횟수 */
  imaJumpCountHighBand?: Maybe<Scalars['Float']>;
  /** 저강도 점프 착지 횟수 */
  imaJumpCountLowBand?: Maybe<Scalars['Float']>;
  /** 중강도 점프 착지 횟수 */
  imaJumpCountMediumBand?: Maybe<Scalars['Float']>;
  /** 내적부하 운동 강도 */
  intensity?: Maybe<Scalars['Float']>;
  /** 내적부하 */
  internalWorkload?: Maybe<Scalars['Float']>;
  /** 최대 가속도 */
  maximumAcceleration?: Maybe<Scalars['Float']>;
  /** 최대 감속도 */
  maximumDeceleration?: Maybe<Scalars['Float']>;
  /** 최대 심박수 */
  maximumHeartRate?: Maybe<Scalars['Float']>;
  /** 최고 속력 */
  maximumSpeed?: Maybe<Scalars['Float']>;
  /** 선수 개인의 maximumSpeed 최댓값 대비 해당 세션의 maximumSpeed 비율 */
  maximumSpeedPerMax?: Maybe<Scalars['Float']>;
  /** 최대 힘 발휘해내는 능력 */
  metaEnergy?: Maybe<Scalars['Float']>;
  /** 좌우 다리 간 부하의 비대칭성 */
  runningImbalance?: Maybe<Scalars['Float']>;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 총 뛴 거리 기반 ACWR */
  totalDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalDistance 최댓값 대비 해당 세션의 totalDistance 비율 */
  totalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 다이브 한 횟수 */
  totalDiveCount?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 횟수 */
  totalDiveCountCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 횟수 */
  totalDiveCountLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 횟수 */
  totalDiveCountRight?: Maybe<Scalars['Float']>;
  /** 다이브 함으로써 생긴 부하 */
  totalDiveLoad?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadRight?: Maybe<Scalars['Float']>;
  /** 운동한 시간 */
  totalDuration?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** HSR 거리 기반 ACWR */
  totalHsrDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalHsrDistance 최댓값 대비 해당 세션의 totalHsrDistance 비율 */
  totalHsrDistancePerMax?: Maybe<Scalars['Float']>;
  /** 점프한 총 횟수 */
  totalJumpCount?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  totalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이상 횟수 */
  velocityB4TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이상 횟수 */
  velocityB5TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이상 횟수 */
  velocityB6TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동거리 */
  velocityBand1TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동시간 */
  velocityBand1TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동거리 */
  velocityBand2TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동시간 */
  velocityBand2TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동거리 */
  velocityBand3TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동시간 */
  velocityBand3TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동거리 */
  velocityBand4TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동시간 */
  velocityBand4TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동거리 */
  velocityBand5TotalDistance?: Maybe<Scalars['Float']>;
  /** 선수 개인의 velocityBand5TotalDistance 최댓값 대비 해당 세션의 velocityBand5TotalDistance 비율 */
  velocityBand5TotalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동시간 */
  velocityBand5TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동거리 */
  velocityBand6TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동시간 */
  velocityBand6TotalDuration?: Maybe<Scalars['Float']>;
};

/** 선수 세션 종합 운동부하 */
export type TeamSessionWorkloadUser = ExternalWorkloadInfo & {
  __typename: 'TeamSessionWorkloadUser';
  /** accelerationBand2TotalCount 와 accelerationBand3TotalCount 합한 값 */
  accelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 accelerationB2_3TotalCount 최댓값 대비 해당 세션의 accelerationB2_3TotalCount 비율 */
  accelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 가속 횟수 */
  accelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 가속 횟수 */
  accelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 가속 횟수 */
  accelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 평균 심박수 */
  averageHeartRate?: Maybe<Scalars['Float']>;
  /** 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeet?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 후 다시 일어나서 두 발로 선 자세로 복귀하는 데 걸린 평균 시간 */
  averageTimeToFeetRight?: Maybe<Scalars['Float']>;
  /** 스프린트 횟수 */
  countOfSprint?: Maybe<Scalars['Float']>;
  /** decelerationBand2TotalCount 와 decelerationBand3TotalCount 합한 값 */
  decelerationB2_3TotalCount?: Maybe<Scalars['Float']>;
  /** 선수 개인의 decelerationB2_3TotalCount 최댓값 대비 해당 세션의 decelerationB2_3TotalCount 비율 */
  decelerationB2_3TotalCountPerMax?: Maybe<Scalars['Float']>;
  /** 속도 1구간 감속 횟수 */
  decelerationBand1TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 2구간 감속 횟수 */
  decelerationBand2TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 3구간 감속 횟수 */
  decelerationBand3TotalCount?: Maybe<Scalars['Float']>;
  /** 분당 이동거리 */
  distancePerMinute?: Maybe<Scalars['Float']>;
  /** 심박 기반 세션 부하 지표 */
  heartRateExertion?: Maybe<Scalars['Float']>;
  /** 대사적으로 높은 부하가 걸리는 상황에서 이동한 거리 */
  highMetabolicLoadDistance?: Maybe<Scalars['Float']>;
  /** 분당 고속주행 거리 */
  hsrPerMinute?: Maybe<Scalars['Float']>;
  /** 고강도 가속 이벤트 수 */
  imaAccelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 가속 이벤트 수 */
  imaAccelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 가속 이벤트 수 */
  imaAccelerationMedium?: Maybe<Scalars['Float']>;
  /** 고강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftHigh?: Maybe<Scalars['Float']>;
  /** 저강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftLow?: Maybe<Scalars['Float']>;
  /** 중강도 왼쪽 방향 전환 이벤트 수 */
  imaCodLeftMedium?: Maybe<Scalars['Float']>;
  /** 고강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightHigh?: Maybe<Scalars['Float']>;
  /** 저강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightLow?: Maybe<Scalars['Float']>;
  /** 중강도 오른쪽 방향 전환 이벤트 수 */
  imaCodRightMedium?: Maybe<Scalars['Float']>;
  /** 고강도 감속 이벤트 수 */
  imaDecelerationHigh?: Maybe<Scalars['Float']>;
  /** 저강도 감속 이벤트 수 */
  imaDecelerationLow?: Maybe<Scalars['Float']>;
  /** 중강도 감속 이벤트 수 */
  imaDecelerationMedium?: Maybe<Scalars['Float']>;
  /** B4 구간 점프 착지 횟수 */
  imaJumpCountBand4?: Maybe<Scalars['Float']>;
  /** 고강도 점프 착지 횟수 */
  imaJumpCountHighBand?: Maybe<Scalars['Float']>;
  /** 저강도 점프 착지 횟수 */
  imaJumpCountLowBand?: Maybe<Scalars['Float']>;
  /** 중강도 점프 착지 횟수 */
  imaJumpCountMediumBand?: Maybe<Scalars['Float']>;
  /** 내적부하 운동 강도 */
  intensity?: Maybe<Scalars['Float']>;
  /** 내적부하 */
  internalWorkload?: Maybe<Scalars['Float']>;
  /** 최대 가속도 */
  maximumAcceleration?: Maybe<Scalars['Float']>;
  /** 최대 감속도 */
  maximumDeceleration?: Maybe<Scalars['Float']>;
  /** 최대 심박수 */
  maximumHeartRate?: Maybe<Scalars['Float']>;
  /** 최고 속력 */
  maximumSpeed?: Maybe<Scalars['Float']>;
  /** 선수 개인의 maximumSpeed 최댓값 대비 해당 세션의 maximumSpeed 비율 */
  maximumSpeedPerMax?: Maybe<Scalars['Float']>;
  /** 최대 힘 발휘해내는 능력 */
  metaEnergy?: Maybe<Scalars['Float']>;
  /** 좌우 다리 간 부하의 비대칭성 */
  runningImbalance?: Maybe<Scalars['Float']>;
  /** 내적부하 운동 만족 */
  satisfaction?: Maybe<Scalars['Float']>;
  /** 이동거리 */
  totalDistance?: Maybe<Scalars['Float']>;
  /** 총 뛴 거리 기반 ACWR */
  totalDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalDistance 최댓값 대비 해당 세션의 totalDistance 비율 */
  totalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 다이브 한 횟수 */
  totalDiveCount?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 한 횟수 */
  totalDiveCountCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 한 횟수 */
  totalDiveCountLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 한 횟수 */
  totalDiveCountRight?: Maybe<Scalars['Float']>;
  /** 다이브 함으로써 생긴 부하 */
  totalDiveLoad?: Maybe<Scalars['Float']>;
  /** 정면으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadCentre?: Maybe<Scalars['Float']>;
  /** 왼쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadLeft?: Maybe<Scalars['Float']>;
  /** 오른쪽으로 다이브 함으로써 생긴 부하 */
  totalDiveLoadRight?: Maybe<Scalars['Float']>;
  /** 운동한 시간 */
  totalDuration?: Maybe<Scalars['Float']>;
  /** 고강도 이동 거리 */
  totalHsrDistance?: Maybe<Scalars['Float']>;
  /** HSR 거리 기반 ACWR */
  totalHsrDistanceAcwr?: Maybe<Scalars['Float']>;
  /** 선수 개인의 totalHsrDistance 최댓값 대비 해당 세션의 totalHsrDistance 비율 */
  totalHsrDistancePerMax?: Maybe<Scalars['Float']>;
  /** 점프한 총 횟수 */
  totalJumpCount?: Maybe<Scalars['Float']>;
  /** 운동부하 */
  totalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 고강도 액션 횟수 */
  totalRhieBout?: Maybe<Scalars['Float']>;
  /** 선수 정보 */
  user: SportsUser;
  /** 속도 4구간 이상 횟수 */
  velocityB4TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이상 횟수 */
  velocityB5TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이상 횟수 */
  velocityB6TotalCount?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동거리 */
  velocityBand1TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동시간 */
  velocityBand1TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동거리 */
  velocityBand2TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동시간 */
  velocityBand2TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동거리 */
  velocityBand3TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동시간 */
  velocityBand3TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동거리 */
  velocityBand4TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동시간 */
  velocityBand4TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동거리 */
  velocityBand5TotalDistance?: Maybe<Scalars['Float']>;
  /** 선수 개인의 velocityBand5TotalDistance 최댓값 대비 해당 세션의 velocityBand5TotalDistance 비율 */
  velocityBand5TotalDistancePerMax?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동시간 */
  velocityBand5TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동거리 */
  velocityBand6TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 6구간 이동시간 */
  velocityBand6TotalDuration?: Maybe<Scalars['Float']>;
};

/** 통증 정보 */
export type TeamSoreness = {
  __typename: 'TeamSoreness';
  /** 통증 부위 */
  bodyPart: SportsBodyPart;
  /** 접촉 여부 */
  isContact: Contact;
  /** 심각도 */
  level: Scalars['Float'];
};


/** 통증 정보 */
export type TeamSorenessBodyPartArgs = {
  input: MultilingualTextInput;
};

/** 팀 통증 평균 정보 */
export type TeamSorenessAvg = {
  __typename: 'TeamSorenessAvg';
  /** 통증 평균 개수 */
  avgCnt: Scalars['Float'];
  /** 통증 부위별 갯수 */
  bodyPartCntList: Array<TeamSorenessBodyPartCnt>;
  /** 날짜별 선수 통증 정보 */
  dateList: Array<TeamSorenessDate>;
  /** 통증 유형별 갯수 */
  isContactCnt: TeamSorenessIsContactCnt;
};

/** 통증 부위별 갯수 */
export type TeamSorenessBodyPartCnt = {
  __typename: 'TeamSorenessBodyPartCnt';
  /** 통증 부위 */
  bodyPart: SportsBodyPart;
  /** 통증 갯수 */
  cnt: Scalars['Float'];
};


/** 통증 부위별 갯수 */
export type TeamSorenessBodyPartCntBodyPartArgs = {
  input: MultilingualTextInput;
};

/** 날짜별 선수 통증 정보 */
export type TeamSorenessDate = {
  __typename: 'TeamSorenessDate';
  /** 날짜 */
  date: Scalars['String'];
  /** 선수 통증 정보 */
  userDataList: Array<TeamSorenessUser>;
};

/** 통증 유형별 갯수 */
export type TeamSorenessIsContactCnt = {
  __typename: 'TeamSorenessIsContactCnt';
  /** 접촉 통증 갯수 */
  contact: Scalars['Float'];
  /** 비접촉 통증 갯수 */
  nonContact: Scalars['Float'];
};

/** 선수 통증 정보 */
export type TeamSorenessUser = {
  __typename: 'TeamSorenessUser';
  /** 통증 목록 */
  sorenessList: Array<TeamSoreness>;
  /** 선수 정보 */
  user: SportsUser;
};

/** 스피드존 기반 비교 분석 */
export type TeamSpeedZoneCompareAnalysis = {
  __typename: 'TeamSpeedZoneCompareAnalysis';
  /** 속도 1구간 이동거리 */
  velocityBand1TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 1구간 이동시간 */
  velocityBand1TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동거리 */
  velocityBand2TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 2구간 이동시간 */
  velocityBand2TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동거리 */
  velocityBand3TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 3구간 이동시간 */
  velocityBand3TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동거리 */
  velocityBand4TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 4구간 이동시간 */
  velocityBand4TotalDuration?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동거리 */
  velocityBand5TotalDistance?: Maybe<Scalars['Float']>;
  /** 속도 5구간 이동시간 */
  velocityBand5TotalDuration?: Maybe<Scalars['Float']>;
};

/** 팀 데이터 */
export type TeamSportsData = {
  __typename: 'TeamSportsData';
  /** 브리핑 리포트 데이터 */
  briefingReportData: BriefingReportData;
  /** 차트 데이터 */
  chartData: ChartData;
  /** 컨디션, 운동부하 체크 목록 */
  checkedList: Array<CheckedData>;
  /** 팀 컨디션 데이터 */
  condition: TeamCondition;
  /** 유의상태 선수, 컨디셔 난조  */
  conditionCareUserList: Array<ConditionCareUser>;
  /** 코디네이팅 컨디션 리포트 데이터 */
  coordinatingConditionReportData: CoordinatingConditionReportData;
  /** 코디네이팅 경기 리포트 데이터 목록 */
  coordinatingMatchReportDataList: Array<CoordinatingMatchReportData>;
  /** 코디네이팅 훈련 리포트 데이터 목록 */
  coordinatingTrainingReportDataList: Array<CoordinatingTrainingReportData>;
  /** 부상 위험 선수 */
  currentInjuryUserList: InjuryUserList;
  /** 현재 통증 유저 목록 */
  currentSorenessUserList: Array<CurrentSorenessUser>;
  /** 오늘 데이터 */
  dailyData: DailyTeamData;
  /** 팀 데이터 추이 */
  dataTrend: TeamDataTrend;
  /** 팀 외적부하 데이터 */
  externalWorkload: TeamExternalWorkload;
  /** 팀 외적부하 데이터 임포트 히스토리 */
  externalWorkloadImportHistory: TeamExternalWorkloadImportHistory;
  /** 피드백 목록 */
  feedbackList: FeedbackConnection;
  id: Scalars['ID'];
  /** 부상 목록 */
  injuryList: Array<Injury>;
  /** 팀 데이터 인사이트 */
  insight: TeamInsight;
  /** 인사이트 데이터 */
  insightData: TeamInsightData;
  /** 팀 내적부하 데이터 */
  internalWorkload: TeamInternalWorkload;
  /** 팀 매치 이벤트 상세 */
  matchEvent?: Maybe<TeamMatchEvent>;
  /** 팀 매치 이벤트 데이터 임포트 히스토리 */
  matchEventImportHistory: TeamMatchEventImportHistory;
  /** 팀 매치 이벤트 목록 */
  matchEventList: Array<TeamMatchEventSimple>;
  /** 팀 메디컬 데이터 */
  medical: TeamMedical;
  /** 팀 피지컬 데이터 */
  physicalData?: Maybe<TeamPhysicalData>;
  /** 팀 피지컬 데이터 v2 */
  physicalDataV2: TeamPhysicalDataV2;
  /** 팀 피지컬 데이터 임포트 히스토리 */
  physicalDataV2ImportHistory: TeamPhysicalDataV2ImportHistory;
  /** 팀 선수 데이터 */
  playerData: TeamPlayerData;
  /** 팀 선수 개별 데이터 */
  playerIndividualData: TeamPlayerIndividualData;
  /** 팀 선수 이름 매칭 히스토리 목록 */
  playerNameMatchHistoryList: Array<TeamPlayerNameMatchHistory>;
  /** 팀 선수단 개별 데이터 */
  playerSquadIndividualData: TeamPlayerSquadIndividualData;
  /** 부상 위험 선수 목록 */
  riskAtInjuryUserList: Array<RiskAtInjuryUser>;
  /** 팀 세션 종합 운동부하 데이터 */
  sessionWorkload: TeamSessionWorkload;
  /** 팀 주간 운동부하 현황 */
  weeklyWorkloadSum: WeeklyWorkloadSum;
};


/** 팀 데이터 */
export type TeamSportsDataBriefingReportDataArgs = {
  date: Scalars['DateTime'];
  input: MultilingualTextInput;
  timezone: Scalars['String'];
};


/** 팀 데이터 */
export type TeamSportsDataCheckedListArgs = {
  from: Scalars['DateTime'];
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


/** 팀 데이터 */
export type TeamSportsDataConditionCareUserListArgs = {
  timezone: Scalars['String'];
};


/** 팀 데이터 */
export type TeamSportsDataCoordinatingConditionReportDataArgs = {
  date: Scalars['DateTime'];
  timezone: Scalars['String'];
};


/** 팀 데이터 */
export type TeamSportsDataCoordinatingMatchReportDataListArgs = {
  date: Scalars['DateTime'];
  timezone: Scalars['String'];
};


/** 팀 데이터 */
export type TeamSportsDataCoordinatingTrainingReportDataListArgs = {
  date: Scalars['DateTime'];
  timezone: Scalars['String'];
};


/** 팀 데이터 */
export type TeamSportsDataCurrentSorenessUserListArgs = {
  timezone: Scalars['String'];
};


/** 팀 데이터 */
export type TeamSportsDataDataTrendArgs = {
  from: Scalars['DateTime'];
  groupId?: Maybe<Scalars['ID']>;
  input: MultilingualTextInput;
  scheduleOnly?: Maybe<Scalars['Boolean']>;
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


/** 팀 데이터 */
export type TeamSportsDataFeedbackListArgs = {
  input: FeedbackPageInput;
};


/** 팀 데이터 */
export type TeamSportsDataInsightArgs = {
  groupId?: Maybe<Scalars['ID']>;
};


/** 팀 데이터 */
export type TeamSportsDataInsightDataArgs = {
  groupId?: Maybe<Scalars['ID']>;
  isConditionGood: Scalars['Boolean'];
  timezone: Scalars['String'];
};


/** 팀 데이터 */
export type TeamSportsDataMatchEventArgs = {
  scheduleId: Scalars['ID'];
};


/** 팀 데이터 */
export type TeamSportsDataPhysicalDataV2Args = {
  date: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
};


/** 팀 데이터 */
export type TeamSportsDataPlayerDataArgs = {
  from: Scalars['DateTime'];
  groupId?: Maybe<Scalars['ID']>;
  input: MultilingualTextInput;
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
};


/** 팀 데이터 */
export type TeamSportsDataPlayerIndividualDataArgs = {
  from: Scalars['DateTime'];
  input: MultilingualTextInput;
  scheduleOnly?: Maybe<Scalars['Boolean']>;
  timezone: Scalars['String'];
  to: Scalars['DateTime'];
  userId: Scalars['ID'];
};


/** 팀 데이터 */
export type TeamSportsDataPlayerSquadIndividualDataArgs = {
  userId: Scalars['ID'];
};


/** 팀 데이터 */
export type TeamSportsDataRiskAtInjuryUserListArgs = {
  timezone: Scalars['String'];
};


/** 팀 데이터 */
export type TeamSportsDataSessionWorkloadArgs = {
  groupId?: Maybe<Scalars['ID']>;
  scheduleId: Scalars['ID'];
};


/** 팀 데이터 */
export type TeamSportsDataWeeklyWorkloadSumArgs = {
  groupId?: Maybe<Scalars['String']>;
  scheduleOnly: Scalars['Boolean'];
  timezone: Scalars['String'];
};

export enum TeamType {
  ORG = 'ORG',
  TEAM = 'TEAM'
}

/** 팀 유저 필터 input */
export type TeamUserFilter = {
  /** 팀 권한 */
  teamAuthority?: Maybe<SportsTeamAuthority>;
};

/** 팀 유저 input */
export type TeamUserInput = {
  /** 팀 ID */
  teamId: Scalars['ID'];
  /** 유저 ID */
  userId: Scalars['ID'];
};

export type TeamUserListInput = {
  teamId: Scalars['ID'];
  userIdList?: Maybe<Array<Scalars['ID']>>;
};

export enum TeamUserMapField {
  groupId = 'groupId',
  position = 'position',
  role = 'role',
  teamAuthority = 'teamAuthority',
  userId = 'userId',
  userName = 'userName'
}

/** 팀 유저 맵 필터 input */
export type TeamUserMapFilterExpressionInput = {
  /** 필드 */
  field: TeamUserMapField;
  /** 쿼리 오퍼레이션 */
  op: QueryOperation;
  /** 값 */
  value: Scalars['String'];
};

/** 팀 유저 맵 필터 input */
export type TeamUserMapFilterInput = {
  /** and 조건 */
  and?: Maybe<Array<TeamUserMapFilterInput>>;
  /** 팀 유저 맵 필터 input */
  expression?: Maybe<TeamUserMapFilterExpressionInput>;
  /** not 조건 */
  not?: Maybe<TeamUserMapFilterInput>;
  /** or 조건 */
  or?: Maybe<Array<TeamUserMapFilterInput>>;
};

export enum TeamUserMapForTeamDataField {
  groupId = 'groupId',
  position = 'position',
  role = 'role',
  teamAuthority = 'teamAuthority',
  userId = 'userId'
}

/** 팀 유저 맵 조회 input */
export type TeamUserMapForTeamDataFilterExpressionInput = {
  /** 필드 */
  field: TeamUserMapForTeamDataField;
  /** 쿼리 오퍼레이션 */
  op: QueryOperation;
  /** 값 */
  value: Scalars['String'];
};

/** 팀유저 맵 조회 input */
export type TeamUserMapForTeamDataFilterInput = {
  /** and 조건 목록 */
  and?: Maybe<Array<TeamUserMapForTeamDataFilterInput>>;
  /** 팀 유저 맵 조회 조건 */
  expression?: Maybe<TeamUserMapForTeamDataFilterExpressionInput>;
  /** not 조건 목록 */
  not?: Maybe<TeamUserMapForTeamDataFilterInput>;
  /** or 조건 목록 */
  or?: Maybe<Array<TeamUserMapForTeamDataFilterInput>>;
};

/** 운동부하 비교 분석 */
export type TeamWorkloadCompareAnalysis = {
  __typename: 'TeamWorkloadCompareAnalysis';
  /** 부상 위험도 */
  acwr?: Maybe<Scalars['Float']>;
  /** 일간 외적 운동부하 */
  dailyTotalPlayerLoad?: Maybe<Scalars['Float']>;
  /** 날짜 */
  date: Scalars['String'];
  /** 내적 부하 */
  internalWorkload?: Maybe<Scalars['Float']>;
  /** 총 뛴 거리 기반 ACWR */
  totalDistanceAcwr?: Maybe<Scalars['Float']>;
  /** HSR 거리 기반 ACWR */
  totalHsrDistanceAcwr?: Maybe<Scalars['Float']>;
};

/** 관찰 리포트 기술 평가 */
export type Technic = {
  __typename: 'Technic';
  /** 공중 경합 */
  aerialDuel?: Maybe<Scalars['Float']>;
  /** 볼 소유 */
  ballPossession?: Maybe<Scalars['Float']>;
  /** 캐칭 능력 */
  catching?: Maybe<Scalars['Float']>;
  /** 코너킥 */
  cornerKick?: Maybe<Scalars['Float']>;
  /** 커버링 */
  covering?: Maybe<Scalars['Float']>;
  /** 크로스 */
  cross?: Maybe<Scalars['Float']>;
  /** 크로스 처리 */
  crossHandling?: Maybe<Scalars['Float']>;
  /** 수비 위치 선정 */
  defensivePositioning?: Maybe<Scalars['Float']>;
  /** 드리블 */
  dribble?: Maybe<Scalars['Float']>;
  /** 골 결정력 */
  finishing?: Maybe<Scalars['Float']>;
  /** 퍼스트 터치 */
  firstTouch?: Maybe<Scalars['Float']>;
  /** 프리킥 */
  freeKick?: Maybe<Scalars['Float']>;
  /** 하프턴 */
  halfTurn?: Maybe<Scalars['Float']>;
  /** 핸들링 */
  handling?: Maybe<Scalars['Float']>;
  /** 헤더 */
  header?: Maybe<Scalars['Float']>;
  /** 롱패스 */
  longPass?: Maybe<Scalars['Float']>;
  /** 오프더볼 */
  offTheBall?: Maybe<Scalars['Float']>;
  /** 공격 위치 선정 */
  offensivePositioning?: Maybe<Scalars['Float']>;
  /** 1:1 공격 */
  oneOnOneAttack?: Maybe<Scalars['Float']>;
  /** 1:1 수비 */
  oneOnOneDefense?: Maybe<Scalars['Float']>;
  /** 패스 정확성 */
  passAccuracy?: Maybe<Scalars['Float']>;
  /** 패스 타이밍 */
  passTiming?: Maybe<Scalars['Float']>;
  /** 페널티킥 */
  penaltyKick?: Maybe<Scalars['Float']>;
  /** 세이브 */
  save?: Maybe<Scalars['Float']>;
  /** 슈팅 */
  shooting?: Maybe<Scalars['Float']>;
  /** 태클 */
  tackle?: Maybe<Scalars['Float']>;
  /** 침투 패스 */
  throughPass?: Maybe<Scalars['Float']>;
  /** 스로인 */
  throwIn?: Maybe<Scalars['Float']>;
  /** 던지기 */
  throwing?: Maybe<Scalars['Float']>;
  /** 양발 사용 능력 */
  useOfBothFeet?: Maybe<Scalars['Float']>;
  /** 넓은 시야 */
  vision?: Maybe<Scalars['Float']>;
};

export enum TechnicMetricType {
  AERIAL_DUEL = 'AERIAL_DUEL',
  BALL_POSSESSION = 'BALL_POSSESSION',
  CATCHING = 'CATCHING',
  CORNER_KICK = 'CORNER_KICK',
  COVERING = 'COVERING',
  CROSS = 'CROSS',
  CROSS_HANDLING = 'CROSS_HANDLING',
  DEFENSIVE_POSITIONING = 'DEFENSIVE_POSITIONING',
  DRIBBLE = 'DRIBBLE',
  FINISHING = 'FINISHING',
  FIRST_TOUCH = 'FIRST_TOUCH',
  FREE_KICK = 'FREE_KICK',
  HALF_TURN = 'HALF_TURN',
  HANDLING = 'HANDLING',
  HEADER = 'HEADER',
  LONG_PASS = 'LONG_PASS',
  OFFENSIVE_POSITIONING = 'OFFENSIVE_POSITIONING',
  OFF_THE_BALL = 'OFF_THE_BALL',
  ONE_ON_ONE_ATTACK = 'ONE_ON_ONE_ATTACK',
  ONE_ON_ONE_DEFENSE = 'ONE_ON_ONE_DEFENSE',
  PASS_ACCURACY = 'PASS_ACCURACY',
  PASS_TIMING = 'PASS_TIMING',
  PENALTY_KICK = 'PENALTY_KICK',
  SAVE = 'SAVE',
  SHOOTING = 'SHOOTING',
  TACKLE = 'TACKLE',
  THROUGH_PASS = 'THROUGH_PASS',
  THROWING = 'THROWING',
  THROW_IN = 'THROW_IN',
  USE_OF_BOTH_FEET = 'USE_OF_BOTH_FEET',
  VISION = 'VISION'
}

/** 관찰 리포트 기술 평가 input */
export type TechnicObservationReportInput = {
  /** 공중 경합 */
  aerialDuel?: Maybe<Scalars['Int']>;
  /** 볼 소유 */
  ballPossession?: Maybe<Scalars['Int']>;
  /** 캐칭 능력 */
  catching?: Maybe<Scalars['Int']>;
  /** 코너킥 */
  cornerKick?: Maybe<Scalars['Int']>;
  /** 커버링 */
  covering?: Maybe<Scalars['Int']>;
  /** 크로스 */
  cross?: Maybe<Scalars['Int']>;
  /** 크로스 처리 */
  crossHandling?: Maybe<Scalars['Int']>;
  /** 수비 위치 선정 */
  defensivePositioning?: Maybe<Scalars['Int']>;
  /** 드리블 */
  dribble?: Maybe<Scalars['Int']>;
  /** 골 결정력 */
  finishing?: Maybe<Scalars['Int']>;
  /** 퍼스트 터치 */
  firstTouch?: Maybe<Scalars['Int']>;
  /** 프리킥 */
  freeKick?: Maybe<Scalars['Int']>;
  /** 하프턴 */
  halfTurn?: Maybe<Scalars['Int']>;
  /** 핸들링 */
  handling?: Maybe<Scalars['Int']>;
  /** 헤더 */
  header?: Maybe<Scalars['Int']>;
  /** 롱패스 */
  longPass?: Maybe<Scalars['Int']>;
  /** 오프더볼 */
  offTheBall?: Maybe<Scalars['Int']>;
  /** 공격 위치 선정 */
  offensivePositioning?: Maybe<Scalars['Int']>;
  /** 1:1 공격 */
  oneOnOneAttack?: Maybe<Scalars['Int']>;
  /** 1:1 수비 */
  oneOnOneDefense?: Maybe<Scalars['Int']>;
  /** 패스 정확성 */
  passAccuracy?: Maybe<Scalars['Int']>;
  /** 패스 타이밍 */
  passTiming?: Maybe<Scalars['Int']>;
  /** 페널티킥 */
  penaltyKick?: Maybe<Scalars['Int']>;
  /** 세이브 */
  save?: Maybe<Scalars['Int']>;
  /** 슈팅 */
  shooting?: Maybe<Scalars['Int']>;
  /** 태클 */
  tackle?: Maybe<Scalars['Int']>;
  /** 침투 패스 */
  throughPass?: Maybe<Scalars['Int']>;
  /** 스로인 */
  throwIn?: Maybe<Scalars['Int']>;
  /** 던지기 */
  throwing?: Maybe<Scalars['Int']>;
  /** 양발 사용 능력 */
  useOfBothFeet?: Maybe<Scalars['Int']>;
  /** 넓은 시야 */
  vision?: Maybe<Scalars['Int']>;
};

/** 스카우팅 모델 기술 기준 input */
export type TechnicScoutingModelInput = {
  /** 공중 경합 */
  aerialDuel?: Maybe<Scalars['Int']>;
  /** 볼 소유 */
  ballPossession?: Maybe<Scalars['Int']>;
  /** 캐칭 능력 */
  catching?: Maybe<Scalars['Int']>;
  /** 코너킥 */
  cornerKick?: Maybe<Scalars['Int']>;
  /** 커버링 */
  covering?: Maybe<Scalars['Int']>;
  /** 크로스 */
  cross?: Maybe<Scalars['Int']>;
  /** 크로스 처리 */
  crossHandling?: Maybe<Scalars['Int']>;
  /** 수비 위치 선정 */
  defensivePositioning?: Maybe<Scalars['Int']>;
  /** 드리블 */
  dribble?: Maybe<Scalars['Int']>;
  /** 골 결정력 */
  finishing?: Maybe<Scalars['Int']>;
  /** 퍼스트 터치 */
  firstTouch?: Maybe<Scalars['Int']>;
  /** 프리킥 */
  freeKick?: Maybe<Scalars['Int']>;
  /** 하프턴 */
  halfTurn?: Maybe<Scalars['Int']>;
  /** 핸들링 */
  handling?: Maybe<Scalars['Int']>;
  /** 헤더 */
  header?: Maybe<Scalars['Int']>;
  /** 롱패스 */
  longPass?: Maybe<Scalars['Int']>;
  /** 오프더볼 */
  offTheBall?: Maybe<Scalars['Int']>;
  /** 공격 위치 선정 */
  offensivePositioning?: Maybe<Scalars['Int']>;
  /** 1:1 공격 */
  oneOnOneAttack?: Maybe<Scalars['Int']>;
  /** 1:1 수비 */
  oneOnOneDefense?: Maybe<Scalars['Int']>;
  /** 패스 정확성 */
  passAccuracy?: Maybe<Scalars['Int']>;
  /** 패스 타이밍 */
  passTiming?: Maybe<Scalars['Int']>;
  /** 페널티킥 */
  penaltyKick?: Maybe<Scalars['Int']>;
  /** 세이브 */
  save?: Maybe<Scalars['Int']>;
  /** 슈팅 */
  shooting?: Maybe<Scalars['Int']>;
  /** 태클 */
  tackle?: Maybe<Scalars['Int']>;
  /** 침투 패스 */
  throughPass?: Maybe<Scalars['Int']>;
  /** 스로인 */
  throwIn?: Maybe<Scalars['Int']>;
  /** 던지기 */
  throwing?: Maybe<Scalars['Int']>;
  /** 양발 사용 능력 */
  useOfBothFeet?: Maybe<Scalars['Int']>;
  /** 넓은 시야 */
  vision?: Maybe<Scalars['Int']>;
};

/** 약관 동의 */
export type TermAgreement = {
  __typename: 'TermAgreement';
  /** 마케팅 수신 동의 */
  marketingAgreed: Scalars['Boolean'];
  /** 개인정보 약관 동의 */
  privacyPolicyAgreed: Scalars['Boolean'];
  /** 서비스 이용 약관 동의 */
  termsOfServiceAgreed: Scalars['Boolean'];
};

/** 약관 동의 input */
export type TermAgreementInput = {
  /** 마케팅 수신 동의 */
  marketingAgreed?: Maybe<Scalars['Boolean']>;
  /** 개인 정보 동의 */
  privacyPolicyAgreed?: Maybe<Scalars['Boolean']>;
  /** 서비스 약관 동의 */
  termsOfServiceAgreed?: Maybe<Scalars['Boolean']>;
};


/** 시간 직렬화 */
export type TimeSerializable = {
  /** 시간 */
  time: Scalars['DateTimeString'];
  /** 타임존 */
  timezone: Scalars['String'];
};

export type Timezone = {
  __typename: 'Timezone';
  value: Scalars['String'];
};

/** 나의 할일 완료 input */
export type ToggleInput = {
  /** 나의 할일 ID */
  routineId: Scalars['ID'];
  /** 나의 할일 행동 여부 */
  status: RoutineActivityStatus;
  /** 타임존 */
  timezone: Scalars['String'];
  /** 나의 할일 완료일 */
  toggledAt: Scalars['Date'];
};

/** 팀 유저 즐겨찾기 input */
export type ToggleTeamUserStarredInput = {
  /** 코치 ID */
  starerId: Scalars['ID'];
  /** 상태 */
  status: Scalars['Boolean'];
  /** 팀 ID */
  teamId: Scalars['ID'];
  /** 유저 ID */
  userId: Scalars['ID'];
};

export type Training = Event & {
  __typename: 'Training';
  attendeeChartData: AttendeeChartData;
  /** 종료일 */
  endAt: Scalars['Date'];
  eventInvitees: Array<TrainingInvitee>;
  expectedIntensity?: Maybe<Scalars['Int']>;
  hideExpectedIntensityFromPlayers?: Maybe<Scalars['Boolean']>;
  /** 일정 ID */
  id: Scalars['ID'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  specialNote?: Maybe<Scalars['String']>;
  /** 시작일 */
  startAt: Scalars['Date'];
  team?: Maybe<SportsTeam>;
  /** 타임존 */
  timezone: Scalars['String'];
  /** 제목 */
  title: Scalars['String'];
  trainingPoint?: Maybe<Scalars['String']>;
  /** 종류 */
  type: ScheduleType;
  workloadCheckedUserCount: Scalars['Float'];
};

export type TrainingInvitee = EventInvitee & {
  __typename: 'TrainingInvitee';
  absenceReason?: Maybe<Scalars['String']>;
  event: Event;
  hasChecked: Scalars['Boolean'];
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  status?: Maybe<EventInviteeStatus>;
  /** the player who is invited to this event */
  user?: Maybe<SportsUser>;
  workoutType?: Maybe<WorkoutType>;
};

/** 훈련 초대자 정보 */
export type TrainingInviteeSchedule = ScheduleInvitee & {
  __typename: 'TrainingInviteeSchedule';
  /** 훈련 불참 사유 */
  absenceReason?: Maybe<Scalars['String']>;
  /** 참여 체크 여부 */
  hasChecked: Scalars['Boolean'];
  /** 일정 초대자 ID */
  id: Scalars['ID'];
  /** 일정 정보 */
  schedule?: Maybe<Schedule>;
  /** 일정 초대자 상태 */
  status?: Maybe<ScheduleInviteeStatus>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** the player who is invited to this schedule */
  user?: Maybe<SportsUser>;
  /** 운동부하 종류 */
  workoutType: WorkoutType;
};


/** 훈련 초대자 정보 */
export type TrainingInviteeScheduleScheduleArgs = {
  teamId?: Maybe<Scalars['ID']>;
};

/** 브리핑 리포트 - 운동 부하 솔루션 */
export type TrainingReportSolution = {
  __typename: 'TrainingReportSolution';
  /** 훈련 리포트 솔루션 유저 목록 */
  solutionUserList: Array<TrainingReportSolutionUser>;
  /** 훈련 운동부하 팀 솔루션 */
  trainingWorkloadTeamSolution: TrainingWorkloadTeamSolution;
};

/** 훈련 리포트 솔루션 유저 */
export type TrainingReportSolutionUser = {
  __typename: 'TrainingReportSolutionUser';
  /** 유저 정보 */
  user: SportsUser;
  /** 운동부하 솔루션 목록 */
  workloadSolutionList: Array<TrainingWorkloadSolution>;
};

/** 브리핑 리포트 - 훈련 운동 부하 */
export type TrainingSchedule = Schedule & {
  __typename: 'TrainingSchedule';
  /** 참석 선수 기록 */
  attendeeChartData: AttendeeChartDataSchedule;
  /** 브리핑 리포트 - 훈련 스케쥴 데이터 */
  briefingReport?: Maybe<BriefingReportTrainingScheduleData>;
  /** 상세 종류 */
  detailType: ScheduleDetailType;
  /** 종료시간 */
  endTime?: Maybe<Scalars['Time']>;
  /** 목표 강도 */
  expectedIntensity?: Maybe<Scalars['Int']>;
  /** 목표 운동 부하 */
  expectedWorkload?: Maybe<Scalars['Int']>;
  /** 첨부 파일 목록 */
  fileList?: Maybe<Array<ScheduleFile>>;
  /** 일정ID */
  id: Scalars['ID'];
  /** 삭제 여부 */
  isDeleted: Scalars['Boolean'];
  /** 선수 공지 유무 */
  isPlayerNotice: Scalars['Boolean'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 공지 */
  notice?: Maybe<Scalars['String']>;
  /** 일정 일자 */
  scheduleDate: Scalars['String'];
  /** 일정 초대자 목록 */
  scheduleInviteeList: Array<TrainingInviteeSchedule>;
  /** 시작시간 */
  startTime?: Maybe<Scalars['Time']>;
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 제목 */
  title?: Maybe<Scalars['String']>;
  /** 훈련 포인트 */
  trainingPoint?: Maybe<Scalars['String']>;
  /** 종류 */
  type: ScheduleType;
  /** 운동부하 체크 유저 수 */
  workloadCheckedUserCount: Scalars['Float'];
};

/** 코디네이팅 리포트 훈련 일정 */
export type TrainingScheduleForCoordinatingReport = {
  __typename: 'TrainingScheduleForCoordinatingReport';
  /** 일정 상세 종류 */
  detailType: ScheduleDetailType;
  /** 종료시간 */
  endTime?: Maybe<Scalars['Time']>;
  /** 목표운동강도 */
  expectedIntensity?: Maybe<Scalars['Int']>;
  /** 일정ID */
  id: Scalars['ID'];
  /** 선수 공지 유무 */
  isPlayerNotice: Scalars['Boolean'];
  /** 장소 */
  location?: Maybe<Scalars['String']>;
  /** 공지사항 */
  notice?: Maybe<Scalars['String']>;
  /** 일정 일자 */
  scheduleDate: Scalars['String'];
  /** 일정 초대자 목록 */
  scheduleInviteeList: Array<TrainingInviteeSchedule>;
  /** 시작시간 */
  startTime?: Maybe<Scalars['Time']>;
  /** 제목 */
  title?: Maybe<Scalars['String']>;
  /** 일정 종류 */
  type: ScheduleType;
};

export enum TrainingSolutionBuildStatus {
  FINISHED = 'FINISHED',
  ONGOING = 'ONGOING'
}

/** 훈련 솔루션 input */
export type TrainingSolutionInput = {
  /** 맨몸운동  */
  bodyWeightWorkout: BodyWeightWorkoutInput;
  /** 기구운동 */
  equipmentWorkout: EquipmentWorkoutInput;
  /** 솔루션ID */
  id?: Maybe<Scalars['ID']>;
  /** 제목 */
  title: Scalars['String'];
  /** 솔루션 종류 */
  type: SolutionType;
};

/** 훈련 솔수션 세션 input */
export type TrainingSolutionSessionInput = {
  /** 빌드 목록 */
  buildList?: Maybe<Array<BuildMetaInput>>;
  /** 세션ID */
  id?: Maybe<Scalars['ID']>;
  /** 제목 */
  title: SessionTitle;
};

export enum TrainingSolutionType {
  BODY_WEIGHT = 'BODY_WEIGHT',
  EQUIPMENT = 'EQUIPMENT'
}

/** 훈련 운동부하 솔루션 */
export type TrainingWorkloadSolution = {
  __typename: 'TrainingWorkloadSolution';
  /** 가이드 */
  guide: Scalars['String'];
  /** 훈련 운동부하 솔루션 가이드 종류 */
  type: TrainingWorkloadSolutionGuideType;
};

export enum TrainingWorkloadSolutionGuideType {
  TE = 'TE',
  TF = 'TF',
  TG1 = 'TG1',
  TG2 = 'TG2',
  TG3 = 'TG3'
}

/** 훈련 운동부하 솔루션 */
export type TrainingWorkloadTeamSolution = {
  __typename: 'TrainingWorkloadTeamSolution';
  /** 가이드 */
  guide: Scalars['String'];
  /** 훈련 운동부하 팀 솔루션 가이드 종류 */
  type: TrainingWorkloadTeamSolutionGuideType;
};

export enum TrainingWorkloadTeamSolutionGuideType {
  TA = 'TA',
  TB1 = 'TB1',
  TB2 = 'TB2',
  TB3 = 'TB3',
  TB4 = 'TB4',
  TB5 = 'TB5',
  TC1 = 'TC1',
  TC2 = 'TC2',
  TC3 = 'TC3',
  TC4 = 'TC4',
  TC5 = 'TC5',
  TD1 = 'TD1',
  TD2 = 'TD2',
  TD3 = 'TD3',
  TD4 = 'TD4',
  TD5 = 'TD5'
}

/** 팀 권한 수정 */
export type TransferTeamOwnership = {
  __typename: 'TransferTeamOwnership';
  /** 어드민 팀 유저 맵 정보 */
  adminTeamUserMap: SportsTeamUserMap;
  /** 소유자 팀 유저 맵 정보 */
  ownerTeamUserMap: SportsTeamUserMap;
};

/** 배너 수정 input */
export type UpdateBannerInput = {
  /** 생성일 */
  createdAt: Scalars['Date'];
  /** 게시 종료일 */
  endAt?: Maybe<Scalars['Date']>;
  /** 배너ID */
  id: Scalars['ID'];
  /** url */
  landingUrl?: Maybe<Scalars['String']>;
  /** 게시 시작일 */
  startAt: Scalars['Date'];
  targetOptionList?: Maybe<Array<Maybe<TargetOptionInput>>>;
  /** 제목 */
  title: Scalars['String'];
};

/** 빌링 이메일 수정 input */
export type UpdateBillingBuyerEmailInput = {
  /** 빌링 ID */
  billingId?: Maybe<Scalars['ID']>;
  /** 이메일 */
  buyerEmail: Scalars['String'];
  /** 결제 팀 ID */
  identityToken: Scalars['ID'];
};

/** 빌링 이름 수정 input */
export type UpdateBillingBuyerNameInput = {
  /** 빌링ID */
  billingId?: Maybe<Scalars['ID']>;
  /** 이름 */
  buyerName: Scalars['String'];
  /** 빌링 팀 ID */
  identityToken: Scalars['ID'];
};

/** 빌링 전화번호 수정 input */
export type UpdateBillingBuyerNumberInput = {
  /** 빌링 ID */
  billingId?: Maybe<Scalars['ID']>;
  /** 전화번호 */
  buyerTel: Scalars['String'];
  /** 결제 팀 ID */
  identityToken: Scalars['ID'];
};

/** 빌링 토큰 갱신 input */
export type UpdateBillingTokenInput = {
  /** 결제 팀 ID */
  identityToken: Scalars['ID'];
  /** 아임포트 결제 ID */
  impUid: Scalars['String'];
};

/** 신체 수정 input */
export type UpdateBodyInput = {
  /** 신장 */
  height: Scalars['Float'];
  /** 신장 단위 */
  heightUnit?: Maybe<HeightUnit>;
  id: Scalars['ID'];
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 체중 */
  weight: Scalars['Float'];
  /** 체중 단위 */
  weightUnit?: Maybe<WeightUnit>;
};

/** 브리핑 리포터 열람 */
export type UpdateBriefingViewedAt = {
  /** 브리핑 조회 로그 아이디 */
  id: Scalars['String'];
  /** 브리핑 리포트 타입 */
  type: BriefingReportType;
  /** 유저 아이디 */
  userId?: Scalars['String'];
};

export type UpdateConditionAndSorenessInput = {
  /** 피로도 */
  fatigue: Scalars['Int'];
  id: Scalars['ID'];
  /** 기분 */
  mood: Scalars['Int'];
  /** 근육 */
  muscle: Scalars['Int'];
  /** 수면 기간 */
  sleepDuration: Scalars['Int'];
  /** 수면 품질 */
  sleepQuality: Scalars['Int'];
  /** 수면시간 */
  sleepTime: Scalars['DateTime'];
  /** 통증 목록 */
  sorenessList: Array<SorenessInput>;
  /** 스트레스 */
  stress: Scalars['Int'];
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
};

/** 컨디션 수정 input */
export type UpdateConditionInput = {
  /** 피로도 */
  fatigue: Scalars['Int'];
  id: Scalars['ID'];
  /** 기분 */
  mood: Scalars['Int'];
  /** 근육 */
  muscle: Scalars['Int'];
  /** 수면 기간 */
  sleepDuration: Scalars['Int'];
  /** 수면 품질 */
  sleepQuality: Scalars['Int'];
  /** 수면시간 */
  sleepTime: Scalars['DateTime'];
  /** 스트레스 */
  stress: Scalars['Int'];
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
};

/** 피드백 댓글 수정 input */
export type UpdateFeedbackCommentInput = {
  /** 댓글 */
  comment: Scalars['String'];
  /** 댓글ID */
  commentId: Scalars['ID'];
  /** 피드백ID */
  feedbackId: Scalars['ID'];
};

/** 피드백 수정 input */
export type UpdateFeedbackInput = {
  /** 피드백 ID */
  id: Scalars['ID'];
  /** 메시지 */
  message: Scalars['String'];
};

/** 부상 수정 input */
export type UpdateInjuryInput = {
  /** 부위 */
  bodyPart?: Maybe<SportsBodyPartName>;
  /** 진단, 최대 100자 */
  diagnosis?: Maybe<Scalars['String']>;
  /** 부상 히스토리 상태 */
  historyStatus: InjuryHistoryStatus;
  /** ID */
  id: Scalars['ID'];
  /** 접촉 여부 */
  isContact?: Maybe<InjuryContact>;
  /** 유지ID 목록 */
  maintainFileIdList: Array<Scalars['ID']>;
  /** 의료 기록, 최대 100자 */
  medicalRecord?: Maybe<Scalars['String']>;
  /** 발생일 */
  occurDate: Scalars['DateTime'];
  /** 이유, 최대 100자 */
  reason?: Maybe<Scalars['String']>;
  /** 부상 복귀 */
  return: ReturnInput;
  /** 일정ID */
  scheduleId?: Maybe<Scalars['String']>;
  /** 부상 상태 */
  status: InjuryStatus;
  /** 직접 입력 내용 */
  symptomEnterDirectly?: Maybe<Scalars['String']>;
  /** 증상 타입 목록 */
  symptomList?: Maybe<Array<SymptomType>>;
  /** 팀ID */
  teamId: Scalars['ID'];
  /** 유저ID */
  userId: Scalars['ID'];
};

/** 나의 할일 수정 input */
export type UpdateInput = {
  /** 나의 할일 ID */
  routineId: Scalars['ID'];
  /** 나의 할일 스케줄 정보 */
  schedule?: Maybe<ScheduleInput>;
  /** 제목 */
  title: Scalars['String'];
};

/** 일정 초대자 출전 정보 수정 input */
export type UpdateLineupSchedule = {
  /** 일정 ID */
  scheduleId: Scalars['String'];
  /** 일정 출전자 목록 */
  scheduleInviteeList: Array<LineupInviteeSchedule>;
};

/** 일정 경기 결과 갱신 input */
export type UpdateMatchResultScheduleInput = {
  /** 일정ID */
  scheduleId: Scalars['String'];
  /** 점수 */
  score?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

/** 운동 안함 수정 input */
export type UpdateNoWorkoutInput = {
  /** 운동 안함 사유 */
  reasonForNoWorkout: NoWorkoutType;
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
};

export type UpdateNotificationLogInput = {
  actionType: ActionType;
  dateTime: Scalars['String'];
  landingUrl: Scalars['String'];
};

/** 관찰 리포트 수정 input */
export type UpdateObservationReportInput = {
  /** 종합 코멘트 */
  comprehensiveComment?: Maybe<Scalars['String']>;
  /** 관찰 리포트 ID */
  id: Scalars['String'];
  /** 심리 평가 */
  mental: MentalObservationReportInput;
  /** 신체 평가 */
  physical: PhysicalObservationReportInput;
  /** 일정 정보 */
  schedule: ObservationReportScheduleInput;
  /** 전술 평가 */
  tactic: TacticObservationReportInput;
  /** 기술 평가 */
  technic: TechnicObservationReportInput;
};

/** 팝업 수정 input */
export type UpdatePopupInput = {
  /** 생성일 */
  createdAt: Scalars['Date'];
  /** 성별 */
  genderList: Array<GenderType>;
  id: Scalars['ID'];
  /** 오늘 보지 않음 버튼 여부 */
  isTodayHidden: Scalars['Boolean'];
  /** url */
  landingUrl?: Maybe<Scalars['String']>;
  /** 언어 */
  languageList: Array<Language>;
  /** 최대 연령 */
  maxAge?: Maybe<Scalars['Float']>;
  /** 최소 연령 */
  minAge?: Maybe<Scalars['Float']>;
  /** os 종류 */
  osTypeList: Array<OsType>;
  /** 게시 종료일 */
  publishEndAt?: Maybe<Scalars['Date']>;
  /** 게시 시작일 */
  publishStartAt: Scalars['Date'];
  /** 제목 */
  title: Scalars['String'];
};

/** 스카우팅 선수 코멘트 수정 input */
export type UpdateProspectPlayerCommentInput = {
  /** 코멘트 */
  comment: Scalars['String'];
  /** 코멘트 ID */
  id: Scalars['String'];
  /** 스카우팅 선수 ID */
  prospectPlayerId: Scalars['String'];
};

/** 스카우팅 선수 수정 input */
export type UpdateProspectPlayerInput = {
  /** 에이전트/소속사 */
  agent?: Maybe<Scalars['String']>;
  /** 수상 이력 목록 */
  awardHistoryList: Array<AwardHistoryInput>;
  /** 생년월일 */
  birthDate: Scalars['String'];
  /** 기타 사항 */
  etc?: Maybe<Scalars['String']>;
  /** 키 */
  height?: Maybe<Scalars['Float']>;
  /** 스카우팅 선수 ID */
  id: Scalars['String'];
  /** 부상 이력 목록 */
  injuryHistoryList: Array<InjuryHistoryInput>;
  /** 이름 */
  name: Scalars['String'];
  /** 국적 */
  nationality?: Maybe<CountryCode>;
  /** 포지션 목록 */
  positionList: Array<ProspectPlayerPositionType>;
  /** 주발 */
  preferredFoot?: Maybe<PreferredFootType>;
  /** 프로필 이미지 링크 */
  profileImageLink?: Maybe<Scalars['String']>;
  /** 소셜 미디어 목록 */
  socialMediaList: Array<SocialMediaInput>;
  /** 팀 소속 이력 목록 */
  teamHistoryList: Array<TeamHistoryInput>;
  /** 팀 ID */
  teamId: Scalars['String'];
  /** 몸무게 */
  weight?: Maybe<Scalars['Float']>;
};

export type UpdateScheduleAttendanceStatusInput = {
  absenceReason?: Maybe<Scalars['String']>;
  scheduleId: Scalars['ID'];
  status: ScheduleInviteeStatus;
};

/** 일정 경기 포인트 수정 input */
export type UpdateScheduleMatchPointInput = {
  /** 경기 포인트 */
  matchPoint: Scalars['String'];
  /** 일정ID */
  scheduleId: Scalars['ID'];
};

/** 일정 운동 기간 수정 input */
export type UpdateScheduleWorkloadDurationInput = {
  /** 종료시간 */
  endTime: Scalars['Time'];
  /** 일정ID */
  scheduleId: Scalars['String'];
  /** 시작시간 */
  startTime: Scalars['Time'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 유저ID 목록 */
  userIdList: Array<Scalars['ID']>;
};

/** 스카우팅 모델 수정 input */
export type UpdateScoutingModelInput = {
  /** ID */
  id: Scalars['String'];
  /** 심리 기준 */
  mental: MentalScoutingModelInput;
  /** 신체 가중치 */
  mentalWeight: Scalars['Int'];
  /** 신체 기준 */
  physical: PhysicalScoutingModelInput;
  /** 신체 가중치 */
  physicalWeight: Scalars['Int'];
  /** 전술 기준 */
  tactic: TacticScoutingModelInput;
  /** 신체 가중치 */
  tacticWeight: Scalars['Int'];
  /** 기술 기준 */
  technic: TechnicScoutingModelInput;
  /** 신체 가중치 */
  technicWeight: Scalars['Int'];
};

/** 배송지 수정 input */
export type UpdateShipmentInput = {
  /** 주소 */
  address: Scalars['String'];
  /** 상세 주소 */
  detailAddress: Scalars['String'];
  /** 배송지 ID */
  id: Scalars['ID'];
  /** 기본 배송지 여부 */
  isDefault: Scalars['Boolean'];
  /** 이름 */
  name: Scalars['String'];
  /** 휴대폰 번호 */
  phoneNumber: Scalars['String'];
  /** 우편 번호 */
  postCode: Scalars['String'];
  /** 배송 요청 메세지 */
  requestMessage?: Maybe<Scalars['String']>;
};

/** 유저 정보 수정 input */
export type UpdateSportsUserInput = {
  /** 생년월일 */
  birthdate?: Maybe<Scalars['String']>;
  /** 성별 */
  gender?: Maybe<Gender>;
  /** 유저 ID */
  id?: Maybe<Scalars['ID']>;
  /** 소개글 */
  introduction?: Maybe<Scalars['String']>;
  /** 이름 */
  name?: Maybe<Scalars['String']>;
  /** 국적 */
  nationality?: Maybe<CountryCode>;
  /** 전화번호 */
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberVerified?: Maybe<Scalars['Boolean']>;
  /** 프로필 사진 ID */
  pictureFileId?: Maybe<Scalars['String']>;
  /** 종목 */
  priorSportsCategory?: Maybe<SportsCategory>;
  /** 포지션 */
  priorSportsPosition?: Maybe<SportsPosition>;
  /** 역할 */
  priorSportsRole?: Maybe<SportsRole>;
  /** 일정 컨디션 체크 리마인드 푸시 수신 동의 유무 */
  pushConditionCheckReminderSchedule?: Maybe<Scalars['String']>;
  /** 컨디션 리마인드 푸시 수신 동의 유무 */
  pushConditionReminderAllowed?: Maybe<Scalars['Boolean']>;
  /** 리마인드 푸시 수신 동의 유무 */
  pushReminderAllowed?: Maybe<Scalars['Boolean']>;
  /** 일정 운동부하 체크 리마인드 푸시 수신 동의 유무 */
  pushWorkloadCheckReminderSchedule?: Maybe<Scalars['String']>;
  /** 운동부하 리마인드 푸시 수신 동의 유무 */
  pushWorkloadReminderAllowed?: Maybe<Scalars['Boolean']>;
};

/** 팀그룹 수정 input */
export type UpdateTeamGroupInput = {
  /** 팀 그룹 ID */
  id: Scalars['ID'];
  /** 순서 */
  index?: Maybe<Scalars['Int']>;
  /** 이름 */
  name?: Maybe<Scalars['String']>;
  /** 팀ID */
  teamId: Scalars['ID'];
  /** 유저ID 목록 */
  userIds?: Maybe<Array<Scalars['String']>>;
};

/** 팀 수정 input */
export type UpdateTeamInput = {
  /** 피지컬 측정 컨텐츠 접근 가능여부 */
  hasPhysicalMeasureContentAccess?: Maybe<Scalars['Boolean']>;
  /** 팀ID */
  id: Scalars['ID'];
  /** 이름 */
  name?: Maybe<Scalars['String']>;
  /** 이미지 파일 ID */
  pictureFileId?: Maybe<Scalars['String']>;
};

/** 팀 피지컬 기준 데이터 수정 input */
export type UpdateTeamPhysicalDataV2Threshold = {
  id: Scalars['ID'];
  /** 연산자 */
  operator: OptionOperator;
  /** 순서 */
  order: Scalars['Int'];
  teamId: Scalars['ID'];
  /** 피지컬 데이터 타입 */
  type: PhysicalDataV2Type;
  /** 값 */
  value: Scalars['Float'];
};

/** 일정 훈련 포인트 수정 input */
export type UpdateTrainingPointScheduleInput = {
  /** 일정 ID */
  scheduleId: Scalars['ID'];
  /** 훈련 포인트 */
  trainingPoint: Scalars['String'];
};

export type UpdateWorkloadAndSorenessInput = {
  /** 운동시간 */
  duration: Scalars['Int'];
  id: Scalars['ID'];
  /** 운동강도 */
  intensity: Scalars['Int'];
  /** 운동 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 운동만족 */
  satisfaction: Scalars['Int'];
  /** 일정ID */
  scheduleId?: Maybe<Scalars['ID']>;
  /** 통증 목록 */
  sorenessList: Array<SorenessInput>;
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 운동부하 종류 */
  type: WorkoutType;
};

/** 운동부하 수정 */
export type UpdateWorkloadInput = {
  /** 운동시간 */
  duration: Scalars['Int'];
  /** ID */
  id: Scalars['ID'];
  /** 운동강도 */
  intensity: Scalars['Int'];
  /** 운동 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 운동만족 */
  satisfaction: Scalars['Int'];
  /** 일정ID */
  scheduleId?: Maybe<Scalars['ID']>;
  /** 시간 */
  time: Scalars['DateTime'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 운동부하 종류 */
  type: WorkoutType;
};


/** 배너 upload input */
export type UploadBannerInput = {
  /** 생성일 */
  createdAt: Scalars['Date'];
  /** 게시 종료일 */
  endAt?: Maybe<Scalars['Date']>;
  /** url */
  landingUrl?: Maybe<Scalars['String']>;
  /** 게시 시작일 */
  startAt: Scalars['Date'];
  targetOptionList?: Maybe<Array<Maybe<TargetOptionInput>>>;
  /** 제목 */
  title: Scalars['String'];
};

/** 일정표 upload input */
export type UploadCalendarInput = {
  /** 종료일 */
  endAt?: Maybe<Scalars['Date']>;
  /** 파일명 */
  name?: Maybe<Scalars['String']>;
  /** 일정 상세 */
  scheduleDetailType?: Maybe<Array<ScheduleDetailType>>;
  /** 시작일 */
  startAt?: Maybe<Scalars['Date']>;
  /** 팀ID */
  teamId: Scalars['ID'];
  /** 캘린더 종류 */
  type?: Maybe<CalendarType>;
};

/** 코디네이팅 업로드 input */
export type UploadCoordinatingReportInput = {
  /** 종료일 */
  endAt?: Maybe<Scalars['Date']>;
  /** 리포트 종류 */
  reportType: ReportType;
  /** 시작일 */
  startAt: Scalars['Date'];
  /** 팀 ID 목록 */
  teamIdList: Array<Scalars['ID']>;
};

/** 프로필 upload 응답 */
export type UploadProfileResponse = {
  __typename: 'UploadProfileResponse';
  /** 팀 정보 */
  team?: Maybe<SportsTeam>;
  /** 유저 정보 */
  user?: Maybe<SportsUser>;
};

/** 일정 리포트 upload input */
export type UploadScheduleReportInput = {
  /** 일정 날짜 */
  scheduleDate: Scalars['Date'];
  /** 일정ID */
  scheduleId: Scalars['ID'];
  /** 팀ID */
  teamId: Scalars['ID'];
  /** 일정 리포트 종류 */
  type: ScheduleReportType;
};

/** 일정 참자가 상태 생성 또는 수정 input */
export type UpsertScheduleAttendanceStatusInput = {
  /** 미참석 사유 */
  absenceReason?: Maybe<Scalars['String']>;
  /** 일정 ID */
  scheduleId: Scalars['ID'];
  /** 참가상태 */
  status: ScheduleInviteeStatus;
};

/** 쿠폰 사용 정보 */
export type UseCoupon = {
  __typename: 'UseCoupon';
  /** 쿠폰ID */
  id?: Maybe<Scalars['ID']>;
  /** 쿠폰 사용여부  */
  isUsed: Scalars['Boolean'];
};

/** 선수 가용 여부 */
export type UserAvailability = {
  __typename: 'UserAvailability';
  /** 가용 여부 */
  isAvailable: Scalars['Boolean'];
  /** 선수 정보 */
  user: SportsUser;
};

export type UserBodyData = {
  __typename: 'UserBodyData';
  /** BMI */
  BMI?: Maybe<Scalars['Float']>;
  /** 신장 */
  height?: Maybe<Scalars['Float']>;
  /** 신장 단위 */
  heightUnit?: Maybe<HeightUnit>;
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** 권장 수분섭취량 */
  recommendedHydration?: Maybe<Scalars['Float']>;
  /** 체중 */
  weight?: Maybe<Scalars['Float']>;
  /** 체중 단위 */
  weightUnit?: Maybe<WeightUnit>;
};

export enum UserConditionDataType {
  FATIGUE = 'FATIGUE',
  MOOD = 'MOOD',
  MUSCLE = 'MUSCLE',
  SLEEP_DURATION = 'SLEEP_DURATION',
  SLEEP_QUALITY = 'SLEEP_QUALITY',
  STRESS = 'STRESS'
}

export enum UserConditionLabelType {
  NOT_GOOD = 'NOT_GOOD',
  PLUMMET = 'PLUMMET'
}

/** 유저 쿠폰 정보 */
export type UserCoupon = {
  __typename: 'UserCoupon';
  /** 쿠폰ID */
  couponId: Scalars['ID'];
  /** 할인 정보 */
  discountInfo: DiscountInfo;
  /** 종료일 */
  endAt: Scalars['Date'];
  /** 적용 가능 횟수 */
  limitCount: Scalars['Int'];
  /** 이름 */
  name: Scalars['String'];
  /** 시작일 */
  startAt: Scalars['Date'];
};

/** 유저 쿠폰 아이템 */
export type UserCouponItem = {
  __typename: 'UserCouponItem';
  /** 코드 */
  code: Scalars['String'];
  /** 종료일 */
  endAt?: Maybe<Scalars['Date']>;
  /** 시작일 */
  startAt?: Maybe<Scalars['Date']>;
  /** 상태 */
  state: UserCouponItemStateType;
  /** 중도 해지일 */
  terminatedAt?: Maybe<Scalars['Date']>;
  /** 사용횟수 */
  useCount: Scalars['Int'];
  /** 유저 정보 */
  user?: Maybe<SportsUser>;
  /** 유저ID */
  userId: Scalars['String'];
};

/** 유저 쿠폰 아이템 페이징 목록 */
export type UserCouponItemByPage = Page & {
  __typename: 'UserCouponItemByPage';
  /** 유저 쿠폰 아이템 */
  content?: Maybe<Array<UserCouponItem>>;
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum UserCouponItemStateType {
  EXTINCTION = 'EXTINCTION',
  TERMINATED = 'TERMINATED',
  UNUSED = 'UNUSED',
  USE_COMPLETE = 'USE_COMPLETE',
  USING = 'USING'
}

/** 유저 데이터 정렬 input */
export type UserDataOrderByInput = {
  /** 커서 */
  cursor?: Maybe<Scalars['DateTime']>;
  /** 유저 데이터 종류 */
  field: UserDataType;
  /** 정렬 조건 */
  sort: SimpleOrder;
  /** 기간폭 */
  stride: UserDataStride;
  /** 타임존 */
  timezone: Scalars['String'];
};

export enum UserDataStride {
  DAY = 'DAY'
}

export enum UserDataType {
  condition = 'condition',
  createdAt = 'createdAt',
  fatigue = 'fatigue',
  height = 'height',
  mood = 'mood',
  muscle = 'muscle',
  name = 'name',
  sleepDuration = 'sleepDuration',
  sleepQuality = 'sleepQuality',
  stress = 'stress',
  weight = 'weight',
  worklaodACWR = 'worklaodACWR',
  worklaodAX = 'worklaodAX',
  worklaodCX = 'worklaodCX',
  workload = 'workload',
  workloadAXD = 'workloadAXD',
  workloadDuration = 'workloadDuration',
  workloadIntensity = 'workloadIntensity',
  workloadSatisfaction = 'workloadSatisfaction'
}

/** 유저 조회 필터 input */
export type UserFilter = {
  /** 유저 검색어 */
  searchTerm?: Maybe<Scalars['String']>;
};

/** 선수 매치 이벤트 상세 */
export type UserMatchEvent = MatchEvent & {
  __typename: 'UserMatchEvent';
  /** 공격 지표 */
  attack: Attack;
  /** 볼 배급 지표 */
  ballDistribution: BallDistribution;
  /** 수비 지표 */
  defense: Defense;
  /** 파울 지표 */
  foul: Foul;
  /** 골키퍼 지표 */
  goalkeeper: Goalkeeper;
  /** 출전 시간 */
  minutesPlayed?: Maybe<Scalars['Float']>;
  /** 피지컬 지표 */
  physical: Physical;
  /** 포지션 */
  position?: Maybe<Scalars['String']>;
  /** 평점 */
  rating?: Maybe<Scalars['Float']>;
  /** 세트피스 지표 */
  setPiece: SetPiece;
  /** 선수 정보 */
  user: SportsUser;
};

/** 유저 솔루션 히스토리 */
export type UserSolutionHistory = {
  __typename: 'UserSolutionHistory';
  /** 빌드ID */
  buildId: Scalars['String'];
  /** 세션ID */
  sessionId: Scalars['String'];
  /** 솔루션ID */
  solutionId: Scalars['String'];
  /** 솔루션 종류 */
  solutionType: SolutionType;
  /** 유저ID */
  userId: Scalars['String'];
};

/** 유저 솔루션 히스토리 input */
export type UserSolutionHistoryInput = {
  /** 빌드ID */
  buildId: Scalars['String'];
  /** 솔루션 종류 */
  type?: SolutionType;
};

export enum UserSorenessLabelType {
  MULTIPLE = 'MULTIPLE',
  SEVERE = 'SEVERE'
}

/** 유저 운동부하 데이터 */
export type UserWorkloadData = {
  __typename: 'UserWorkloadData';
  /** acwr */
  acwr?: Maybe<Scalars['Float']>;
  /** 급성부하 */
  aw?: Maybe<Scalars['Int']>;
  /** 단조로움 */
  awd?: Maybe<Scalars['Float']>;
  awi?: Maybe<Scalars['Float']>;
  /** 갯수 */
  count: Scalars['Float'];
  /** 만성부하 */
  cw?: Maybe<Scalars['Int']>;
  /** 운동기간 */
  duration: Statistic;
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** 운동강도 */
  intensity: Statistic;
  /** 운동안함 이유 */
  reasonForNoWorkout?: Maybe<NoWorkoutType>;
  /** 운동만족 */
  satisfaction: Statistic;
  /** 시간 */
  time: Scalars['Date'];
  /** 운동부하 */
  workload: Statistic;
  /** 운동 부하 상세 목록 */
  workloadList: Array<SportsRawWorkload>;
};

export enum UserWorkloadRiskAtInjuryLabelType {
  RISK_CAUTION = 'RISK_CAUTION',
  RISK_DETECTED = 'RISK_DETECTED',
  RISK_INCREASED = 'RISK_INCREASED'
}

export enum UserWorkloadRiskAtInjuryReasonType {
  HIGH_ACWR = 'HIGH_ACWR',
  HIGH_WEEKLY_WORKLOAD = 'HIGH_WEEKLY_WORKLOAD',
  LOW_ACWR = 'LOW_ACWR',
  MONOTONY = 'MONOTONY',
  NON_ELASTIC_INTENSITY = 'NON_ELASTIC_INTENSITY',
  STRAIN = 'STRAIN',
  WEEKLY_WORKLOAD_SURGE = 'WEEKLY_WORKLOAD_SURGE'
}

export enum UserWorkloadSuggestionDataType {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  O = 'O',
  P = 'P',
  Q = 'Q',
  R = 'R',
  S = 'S',
  T = 'T',
  U = 'U',
  V = 'V',
  W = 'W',
  X = 'X'
}

export enum Venue {
  AWAY = 'AWAY',
  ETC = 'ETC',
  HOME = 'HOME'
}

/** Player 서비스 버전 */
export type VersionRevision = {
  __typename: 'VersionRevision';
  /** app ID */
  appId: Scalars['String'];
  enabled: Scalars['Boolean'];
  /** 강제 업데이트 여부 */
  forceUpdate: Scalars['Boolean'];
  /** 버전ID */
  id: Scalars['ID'];
  optionalUpdate: Scalars['Boolean'];
  /** os */
  os?: Maybe<Scalars['String']>;
  /** 결제 숨김 여부 */
  paymentEnable: Scalars['Boolean'];
  /** 버전 */
  version: Scalars['String'];
};

export type ViewSummary = {
  __typename: 'ViewSummary';
  /** 브리핑 리포트 조회 상태 */
  status: BriefingSummaryType;
  /** 브리핑 리포트 전체 개수 */
  totalCount: Scalars['Float'];
  /** 브리핑 리포트 조회한 섹션 개수 */
  viewedCount: Scalars['Float'];
};

/** 브리핑 컨디션 & 통증 리포트 - 조회 통계 데이터 */
export type ViewSummaryData = {
  __typename: 'ViewSummaryData';
  /** 브리핑 조회 타입 */
  status: BriefingSummaryType;
  /** 전제 섹션 합 */
  totalCount: Scalars['Float'];
  /** 조회 섹션 합 */
  viewedCount: Scalars['Float'];
};

/** 팀 주간 운동부하 현황 */
export type WeeklyWorkloadSum = {
  __typename: 'WeeklyWorkloadSum';
  /** 지난 주 */
  lastWeek: Array<Scalars['Int']>;
  /** 이번 주 */
  thisWeek: Array<Scalars['Int']>;
};

export enum WeightUnit {
  kg = 'kg',
  lb = 'lb'
}

/** 운동부하 데이터 */
export type Workload = {
  __typename: 'Workload';
  /** 운동시간 */
  duration: Scalars['Int'];
  /** 매핑된 일정 정보 */
  event?: Maybe<EventInvitee>;
  /** ID */
  id: Scalars['ID'];
  /** 운동강도 */
  intensity: Scalars['Int'];
  /** 피드백 작성 여부 */
  isFeedbackCreated: Scalars['Boolean'];
  /** 코치 수정 여부 */
  isUpdatedByCoach: Scalars['Boolean'];
  /** 운동부하 */
  load: Scalars['Int'];
  /** 메모 */
  memo?: Maybe<Scalars['String']>;
  /** 운동만족 */
  satisfaction: Scalars['Int'];
  /** 일정 */
  schedule?: Maybe<ScheduleInvitee>;
  /** 시간 */
  time: Scalars['DateTimeString'];
  /** 타임존 */
  timezone: Scalars['String'];
  /** 운동부하 종류 */
  type: WorkoutType;
};

/** 운동부하 데이터 */
export type WorkloadData = {
  __typename: 'WorkloadData';
  /** acwr */
  acwr?: Maybe<Scalars['Float']>;
  /** 급성부하 */
  aw?: Maybe<Scalars['Int']>;
  /** 단조로움 */
  awd?: Maybe<Scalars['Float']>;
  awi?: Maybe<Scalars['Float']>;
  /** 갯수 */
  count: Scalars['Float'];
  /** 만성부하 */
  cw?: Maybe<Scalars['Int']>;
  /** 운동기간 */
  duration: Statistic;
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** 운동강도 */
  intensity: Statistic;
  /** 체크 여부 */
  isChecked: Scalars['Boolean'];
  /** 운동안함 이유 */
  reasonForNoWorkout?: Maybe<NoWorkoutType>;
  /** 운동만족 */
  satisfaction: Statistic;
  /** 운동부하 */
  workload: Statistic;
  /** 운동부하 데이터 목록 */
  workloadList: Array<Workload>;
};

export enum WorkloadType {
  MATCH_WORKLOAD = 'MATCH_WORKLOAD',
  NORMAL_WORKLOAD = 'NORMAL_WORKLOAD',
  TRAINING_WORKLOAD = 'TRAINING_WORKLOAD'
}

export enum WorkoutType {
  MATCH = 'MATCH',
  NORMAL = 'NORMAL',
  REHAB = 'REHAB',
  TRAINING = 'TRAINING'
}

export const UserInjuryDataFragmentDoc = gql`
    fragment UserInjuryData on Injury {
  id
  bodyPart(input: $input) {
    id
    value
  }
  occurDate
  historyStatus
  reason
  diagnosis
  medicalRecord
  return {
    date
    info
    status
  }
  fileList {
    id
    name
    url
  }
  status
}
    `;
export const FeedbackDataFragmentDoc = gql`
    fragment FeedbackData on Feedback {
  id
  date
  type
  message
  contentsData {
    ... on FeedbackWorkloadMemoData {
      duration
      time
      timezone
      memo
      scheduleData {
        type
        detailType
        title
        location
        scheduleDate
        startTime
        endTime
      }
    }
    ... on FeedbackSorenessSevereData {
      bodyPart(input: $multilingualTextInput) {
        id
        value
        front
        back
        left
        right
      }
      level
      memo
      isContact
    }
    ... on FeedbackConditionNotGoodData {
      dataList
      mood
      fatigue
      stress
      muscle
      sleepDuration
      sleepDurationScore
      sleepQuality
    }
    ... on FeedbackConditionPlummetData {
      dataList
      mood28dayList
      fatigue28dayList
      stress28dayList
      muscle28dayList
      sleepDuration28dayList
      sleepQuality28dayList
    }
    ... on FeedbackWorkloadRiskAtInjuryData {
      label
      analysisType
      reasonList
    }
  }
  commentList {
    id
    comment
    isUpdated
    createdAt
    user {
      id
      pictureUrl
      name
    }
  }
  isUpdated
  createUser {
    id
    name
    pictureUrl
    gender
  }
  player {
    id
    name
    pictureUrl
  }
  createdAt
  teamId
  team {
    id
  }
}
    `;
export const ModalTeamCreateTeamFragmentDoc = gql`
    fragment ModalTeamCreateTeam on SportsTeam {
  id
  name
  pictureUrl
  sportsCategory {
    id
    group
  }
  region {
    id
  }
  createdAt
  allUsers: userMapsByPage(
    filter: {expression: {field: teamAuthority, op: in, value: "[\\"PLCO:OWNER\\", \\"PLCO:ADMIN\\", \\"PLCO:MEMBER\\"]"}}
  ) {
    total
  }
  players: userMapsByPage(
    filter: {expression: {field: teamAuthority, op: eq, value: "PLCO:MEMBER"}}
  ) {
    total
  }
}
    `;
export const NavbarTeamsTeamFragmentDoc = gql`
    fragment NavbarTeamsTeam on SportsTeam {
  id
  name
  pictureUrl
  sportsCategory {
    id
    group
  }
  region {
    id
  }
  createdAt
  allUsers: userMapsByPage(
    filter: {expression: {field: teamAuthority, op: in, value: "[\\"PLCO:OWNER\\", \\"PLCO:ADMIN\\", \\"PLCO:MEMBER\\"]"}}
  ) {
    total
  }
  players: userMapsByPage(
    filter: {expression: {field: teamAuthority, op: eq, value: "PLCO:MEMBER"}}
  ) {
    total
  }
}
    `;
export const FSportsTeamFragmentDoc = gql`
    fragment FSportsTeam on SportsTeam {
  id
  type
  region {
    id
  }
  sportsCategory {
    id
  }
  slug
  name
  code
  viewerAuthority
  pictureUrl
  allUsers: userMapsByPage {
    total
  }
  players: userMapsByPage(filterBy: {teamAuthority: MEMBER}) {
    total
  }
}
    `;
export const FSportsTeamInvitationRequestFragmentDoc = gql`
    fragment FSportsTeamInvitationRequest on SportsTeamInvitationRequest {
  id
  status
  teamAuthority
  user {
    id
  }
  team {
    ...FSportsTeam
  }
}
    ${FSportsTeamFragmentDoc}`;
export const FSportsTeamUserMapFragmentDoc = gql`
    fragment FSportsTeamUserMap on SportsTeamUserMap {
  id
  teamAuthority
  team {
    subscriptionItem {
      id
      planId
    }
    ...FSportsTeam
  }
}
    ${FSportsTeamFragmentDoc}`;
export const FSportsUserFragmentDoc = gql`
    fragment FSportsUser on SportsUser {
  id
  slug
  name
  introduction
  pictureUrl
  priorSportsCategory {
    id
    group
  }
  priorSportsPosition
  priorSportsRole
  createdAt
  birthdate
  email
  federation
  gender
  name
  nationality
  phoneNumber
}
    `;
export const FTeamGroupFragmentDoc = gql`
    fragment FTeamGroup on TeamGroup {
  id
  name
  orderRanking
  teamId
  userId
  createdAt
  updatedAt
}
    `;
export const PaymentSubscrptionFragmentDoc = gql`
    fragment PaymentSubscrption on SubscriptionItem {
  id
  status
  cycleAnchor
  startAt
  endAt
  teamId
  planId
  planOptionId
  plan {
    id
    planName
    planType
    planOptionInfo {
      id
    }
  }
  isSubscripting
  isRefundable
  isFreeTrial
  isActivate
  coupon {
    id
    isUsed
  }
}
    `;
export const AnalyticsTeamFragmentDoc = gql`
    fragment AnalyticsTeam on SportsTeam {
  id
  name
  pictureUrl
  code
  allUsers: userMapsByPage {
    total
  }
  players: userMapsByPage(filterBy: {teamAuthority: MEMBER}) {
    total
  }
}
    `;
export const AnalyticsViewerFragmentDoc = gql`
    fragment AnalyticsViewer on SportsUser {
  id
  name
  pictureUrl
  priorSportsRole
  priorSportsCategory {
    id
    group
  }
  email
  birthdate
  phoneNumber
  gender
  nationality
  createdAt
  teamMaps {
    id
    teamAuthority
    team {
      ...AnalyticsTeam
    }
  }
}
    ${AnalyticsTeamFragmentDoc}`;
export const InvoiceBillingItemFragmentDoc = gql`
    fragment InvoiceBillingItem on Billing {
  id
  identityToken
  customerUid
  cardName
  cardNumber
  buyerName
  buyerTel
  buyerEmail
}
    `;
export const PlanOptionInfoFragmentDoc = gql`
    fragment PlanOptionInfo on PlanOptionWithCoupon {
  id
  currency
  description
  originalPrice
  discountedPrice
  duration
  maxPlayerCount
  maxTeamCount
  nextPaymentDay
  originalPrice
  period
  planOptionName
}
    `;
export const PlayerSummaryIdentityFragmentDoc = gql`
    fragment PlayerSummaryIdentity on SportsUser {
  pictureUrl
  name
  gender
  birthdate
  priorSportsCategory {
    id
    group
  }
  priorSportsPosition
  priorSportsRole
}
    `;
export const TGroupMemberMapFragmentDoc = gql`
    fragment TGroupMemberMap on TeamGroup {
  id
  name
  orderRanking
  groupMemberList {
    user {
      id
      name
      pictureUrl
      nationality
    }
  }
}
    `;
export const PlanBillingPayInvoiceInfoFragmentDoc = gql`
    fragment PlanBillingPayInvoiceInfo on PayInvoice {
  id
  paidAt
  paymentName
  paymentStatus
  amount
  cardName
  cardNumber
  receiptUrl
}
    `;
export const PlanBillingTeamSubscriptionFragmentDoc = gql`
    fragment PlanBillingTeamSubscription on SubscriptionItem {
  invoicesByPage(limit: $limit, offset: $offset) {
    offset
    limit
    total
    hasNext
    hasPrev
    invoiceList {
      ...PlanBillingPayInvoiceInfo
      ... on RefundInvoice {
        id
        refundAt
        paymentName
        paymentStatus
        refundAmount
        cardName
        cardNumber
        receiptUrl
      }
    }
  }
  id
  status
  cycleAnchor
  startAt
  endAt
  teamId
  isSubscripting
  isRefundable
  isFreeTrial
  coupon {
    id
    isUsed
  }
  plan {
    id
    planName
    planType
    planOptionInfo {
      id
      planOptionName
      description
      amount
      currency
      period
      duration
      maxPlayerCount
      maxTeamCount
    }
  }
}
    ${PlanBillingPayInvoiceInfoFragmentDoc}`;
export const PlanPayPricingSubscriptionFragmentDoc = gql`
    fragment PlanPayPricingSubscription on SubscriptionItem {
  id
  status
  cycleAnchor
  startAt
  endAt
  teamId
  isSubscripting
  isRefundable
  isFreeTrial
  plan {
    id
    planName
    planType
    planOptionInfo {
      id
      planOptionName
      description
      currency
      period
      duration
      maxPlayerCount
      maxTeamCount
      amount
    }
  }
}
    `;
export const PlanPayPricingBillingItemFragmentDoc = gql`
    fragment PlanPayPricingBillingItem on Billing {
  id
  identityToken
  customerUid
  cardName
  cardNumber
  buyerName
  buyerTel
  buyerEmail
}
    `;
export const TRegisterViewerFragmentDoc = gql`
    fragment TRegisterViewer on SportsUser {
  id
  priorSportsCategory {
    id
    group
  }
  priorSportsPosition
  pictureUrl
  name
  gender
  birthdate
  nationality
  phoneNumber
}
    `;
export const NavigationViewerFragmentDoc = gql`
    fragment NavigationViewer on SportsUser {
  id
  name
  slug
  pictureUrl
  priorSportsRole
  priorSportsCategory {
    id
    group
  }
  priorSportsPosition
  createdAt
}
    `;
export const NavigationTeamSubscriptionFragmentDoc = gql`
    fragment NavigationTeamSubscription on SubscriptionItem {
  id
  status
  teamId
  isFreeTrial
  isSubscripting
  startAt
  endAt
  planId
  planOptionId
  plan {
    id
    planType
    planOptionInfo {
      id
      maxPlayerCount
      maxTeamCount
      amount
      currency
      period
      description
      planOptionName
      nextPaymentDay
    }
  }
}
    `;
export const NavigationTeamLicenseFragmentDoc = gql`
    fragment NavigationTeamLicense on License {
  id
  isActivate
}
    `;
export const CardDiscountDetailsCouponContentsDocument = gql`
    query CardDiscountDetailsCouponContents($teamId: ID!) {
  couponListByTeam(teamId: $teamId) {
    content {
      couponId
      name
    }
  }
}
    `;

/**
 * __useCardDiscountDetailsCouponContentsQuery__
 *
 * To run a query within a React component, call `useCardDiscountDetailsCouponContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardDiscountDetailsCouponContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardDiscountDetailsCouponContentsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useCardDiscountDetailsCouponContentsQuery(baseOptions: Apollo.QueryHookOptions<CardDiscountDetailsCouponContentsQuery, CardDiscountDetailsCouponContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardDiscountDetailsCouponContentsQuery, CardDiscountDetailsCouponContentsQueryVariables>(CardDiscountDetailsCouponContentsDocument, options);
      }
export function useCardDiscountDetailsCouponContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardDiscountDetailsCouponContentsQuery, CardDiscountDetailsCouponContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardDiscountDetailsCouponContentsQuery, CardDiscountDetailsCouponContentsQueryVariables>(CardDiscountDetailsCouponContentsDocument, options);
        }
export type CardDiscountDetailsCouponContentsQueryHookResult = ReturnType<typeof useCardDiscountDetailsCouponContentsQuery>;
export type CardDiscountDetailsCouponContentsLazyQueryHookResult = ReturnType<typeof useCardDiscountDetailsCouponContentsLazyQuery>;
export type CardDiscountDetailsCouponContentsQueryResult = Apollo.QueryResult<CardDiscountDetailsCouponContentsQuery, CardDiscountDetailsCouponContentsQueryVariables>;
export function refetchCardDiscountDetailsCouponContentsQuery(variables?: CardDiscountDetailsCouponContentsQueryVariables) {
      return { query: CardDiscountDetailsCouponContentsDocument, variables: variables }
    }
export const InvitationRequestBadgeRequestsDocument = gql`
    query InvitationRequestBadgeRequests {
  sports {
    viewer {
      id
      teamMaps {
        id
        team {
          id
          pendingInvitationRequestList {
            id
            status
          }
        }
      }
    }
  }
}
    `;

/**
 * __useInvitationRequestBadgeRequestsQuery__
 *
 * To run a query within a React component, call `useInvitationRequestBadgeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationRequestBadgeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationRequestBadgeRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvitationRequestBadgeRequestsQuery(baseOptions?: Apollo.QueryHookOptions<InvitationRequestBadgeRequestsQuery, InvitationRequestBadgeRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationRequestBadgeRequestsQuery, InvitationRequestBadgeRequestsQueryVariables>(InvitationRequestBadgeRequestsDocument, options);
      }
export function useInvitationRequestBadgeRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationRequestBadgeRequestsQuery, InvitationRequestBadgeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationRequestBadgeRequestsQuery, InvitationRequestBadgeRequestsQueryVariables>(InvitationRequestBadgeRequestsDocument, options);
        }
export type InvitationRequestBadgeRequestsQueryHookResult = ReturnType<typeof useInvitationRequestBadgeRequestsQuery>;
export type InvitationRequestBadgeRequestsLazyQueryHookResult = ReturnType<typeof useInvitationRequestBadgeRequestsLazyQuery>;
export type InvitationRequestBadgeRequestsQueryResult = Apollo.QueryResult<InvitationRequestBadgeRequestsQuery, InvitationRequestBadgeRequestsQueryVariables>;
export function refetchInvitationRequestBadgeRequestsQuery(variables?: InvitationRequestBadgeRequestsQueryVariables) {
      return { query: InvitationRequestBadgeRequestsDocument, variables: variables }
    }
export const UserCurrentInjuryListDocument = gql`
    query UserCurrentInjuryList($teamId: ID!, $userId: ID!, $input: MultilingualTextInput!) {
  sports {
    user(id: $userId) {
      id
      currentInjuryList(teamId: $teamId) {
        ...UserInjuryData
      }
    }
  }
}
    ${UserInjuryDataFragmentDoc}`;

/**
 * __useUserCurrentInjuryListQuery__
 *
 * To run a query within a React component, call `useUserCurrentInjuryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCurrentInjuryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCurrentInjuryListQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCurrentInjuryListQuery(baseOptions: Apollo.QueryHookOptions<UserCurrentInjuryListQuery, UserCurrentInjuryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCurrentInjuryListQuery, UserCurrentInjuryListQueryVariables>(UserCurrentInjuryListDocument, options);
      }
export function useUserCurrentInjuryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCurrentInjuryListQuery, UserCurrentInjuryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCurrentInjuryListQuery, UserCurrentInjuryListQueryVariables>(UserCurrentInjuryListDocument, options);
        }
export type UserCurrentInjuryListQueryHookResult = ReturnType<typeof useUserCurrentInjuryListQuery>;
export type UserCurrentInjuryListLazyQueryHookResult = ReturnType<typeof useUserCurrentInjuryListLazyQuery>;
export type UserCurrentInjuryListQueryResult = Apollo.QueryResult<UserCurrentInjuryListQuery, UserCurrentInjuryListQueryVariables>;
export function refetchUserCurrentInjuryListQuery(variables?: UserCurrentInjuryListQueryVariables) {
      return { query: UserCurrentInjuryListDocument, variables: variables }
    }
export const UserPastInjuryListDocument = gql`
    query UserPastInjuryList($teamId: ID!, $userId: ID!, $input: MultilingualTextInput!) {
  sports {
    user(id: $userId) {
      id
      pastInjuryList(teamId: $teamId) {
        ...UserInjuryData
      }
    }
  }
}
    ${UserInjuryDataFragmentDoc}`;

/**
 * __useUserPastInjuryListQuery__
 *
 * To run a query within a React component, call `useUserPastInjuryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPastInjuryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPastInjuryListQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserPastInjuryListQuery(baseOptions: Apollo.QueryHookOptions<UserPastInjuryListQuery, UserPastInjuryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPastInjuryListQuery, UserPastInjuryListQueryVariables>(UserPastInjuryListDocument, options);
      }
export function useUserPastInjuryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPastInjuryListQuery, UserPastInjuryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPastInjuryListQuery, UserPastInjuryListQueryVariables>(UserPastInjuryListDocument, options);
        }
export type UserPastInjuryListQueryHookResult = ReturnType<typeof useUserPastInjuryListQuery>;
export type UserPastInjuryListLazyQueryHookResult = ReturnType<typeof useUserPastInjuryListLazyQuery>;
export type UserPastInjuryListQueryResult = Apollo.QueryResult<UserPastInjuryListQuery, UserPastInjuryListQueryVariables>;
export function refetchUserPastInjuryListQuery(variables?: UserPastInjuryListQueryVariables) {
      return { query: UserPastInjuryListDocument, variables: variables }
    }
export const FeedbackDetailDocument = gql`
    query FeedbackDetail($id: ID!, $multilingualTextInput: MultilingualTextInput!) {
  feedback(id: $id) {
    ...FeedbackData
  }
}
    ${FeedbackDataFragmentDoc}`;

/**
 * __useFeedbackDetailQuery__
 *
 * To run a query within a React component, call `useFeedbackDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      multilingualTextInput: // value for 'multilingualTextInput'
 *   },
 * });
 */
export function useFeedbackDetailQuery(baseOptions: Apollo.QueryHookOptions<FeedbackDetailQuery, FeedbackDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackDetailQuery, FeedbackDetailQueryVariables>(FeedbackDetailDocument, options);
      }
export function useFeedbackDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackDetailQuery, FeedbackDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackDetailQuery, FeedbackDetailQueryVariables>(FeedbackDetailDocument, options);
        }
export type FeedbackDetailQueryHookResult = ReturnType<typeof useFeedbackDetailQuery>;
export type FeedbackDetailLazyQueryHookResult = ReturnType<typeof useFeedbackDetailLazyQuery>;
export type FeedbackDetailQueryResult = Apollo.QueryResult<FeedbackDetailQuery, FeedbackDetailQueryVariables>;
export function refetchFeedbackDetailQuery(variables?: FeedbackDetailQueryVariables) {
      return { query: FeedbackDetailDocument, variables: variables }
    }
export const FeedbackSuggestionListDocument = gql`
    query FeedbackSuggestionList($userId: ID!, $teamId: ID!, $timezone: String!, $input: MultilingualTextInput!) {
  sports {
    user(id: $userId) {
      id
      name
      pictureUrl
      feedbackSuggestionList(teamId: $teamId, timezone: $timezone) {
        date
        type
        contentsData {
          ... on FeedbackWorkloadMemoData {
            memo
            duration
            time
            timezone
            scheduleData {
              type
              detailType
              title
              location
              scheduleDate
              startTime
              endTime
            }
          }
          ... on FeedbackSorenessSevereData {
            bodyPart(input: $input) {
              id
              value
              group {
                id
              }
              front
              back
              left
              right
            }
            level
            memo
            isContact
          }
          ... on FeedbackConditionNotGoodData {
            dataList
            mood
            fatigue
            stress
            muscle
            sleepDuration
            sleepDurationScore
            sleepQuality
          }
          ... on FeedbackConditionPlummetData {
            dataList
            mood28dayList
            fatigue28dayList
            stress28dayList
            muscle28dayList
            sleepDuration28dayList
            sleepQuality28dayList
          }
          ... on FeedbackWorkloadRiskAtInjuryData {
            label
            analysisType
            reasonList
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFeedbackSuggestionListQuery__
 *
 * To run a query within a React component, call `useFeedbackSuggestionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackSuggestionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackSuggestionListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      teamId: // value for 'teamId'
 *      timezone: // value for 'timezone'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFeedbackSuggestionListQuery(baseOptions: Apollo.QueryHookOptions<FeedbackSuggestionListQuery, FeedbackSuggestionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackSuggestionListQuery, FeedbackSuggestionListQueryVariables>(FeedbackSuggestionListDocument, options);
      }
export function useFeedbackSuggestionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackSuggestionListQuery, FeedbackSuggestionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackSuggestionListQuery, FeedbackSuggestionListQueryVariables>(FeedbackSuggestionListDocument, options);
        }
export type FeedbackSuggestionListQueryHookResult = ReturnType<typeof useFeedbackSuggestionListQuery>;
export type FeedbackSuggestionListLazyQueryHookResult = ReturnType<typeof useFeedbackSuggestionListLazyQuery>;
export type FeedbackSuggestionListQueryResult = Apollo.QueryResult<FeedbackSuggestionListQuery, FeedbackSuggestionListQueryVariables>;
export function refetchFeedbackSuggestionListQuery(variables?: FeedbackSuggestionListQueryVariables) {
      return { query: FeedbackSuggestionListDocument, variables: variables }
    }
export const DialogTeamPlayerListDocument = gql`
    query DialogTeamPlayerList($teamId: ID!) {
  sports {
    team(id: $teamId) {
      id
      userMapsByPage(limit: 6535, filterBy: {teamAuthority: MEMBER}) {
        entries {
          user {
            id
            name
            pictureUrl
            gender
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDialogTeamPlayerListQuery__
 *
 * To run a query within a React component, call `useDialogTeamPlayerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialogTeamPlayerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDialogTeamPlayerListQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDialogTeamPlayerListQuery(baseOptions: Apollo.QueryHookOptions<DialogTeamPlayerListQuery, DialogTeamPlayerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DialogTeamPlayerListQuery, DialogTeamPlayerListQueryVariables>(DialogTeamPlayerListDocument, options);
      }
export function useDialogTeamPlayerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DialogTeamPlayerListQuery, DialogTeamPlayerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DialogTeamPlayerListQuery, DialogTeamPlayerListQueryVariables>(DialogTeamPlayerListDocument, options);
        }
export type DialogTeamPlayerListQueryHookResult = ReturnType<typeof useDialogTeamPlayerListQuery>;
export type DialogTeamPlayerListLazyQueryHookResult = ReturnType<typeof useDialogTeamPlayerListLazyQuery>;
export type DialogTeamPlayerListQueryResult = Apollo.QueryResult<DialogTeamPlayerListQuery, DialogTeamPlayerListQueryVariables>;
export function refetchDialogTeamPlayerListQuery(variables?: DialogTeamPlayerListQueryVariables) {
      return { query: DialogTeamPlayerListDocument, variables: variables }
    }
export const DrawerPlayersListDocument = gql`
    query DrawerPlayersList($teamId: ID!, $starerId: ID!) {
  sports {
    team(id: $teamId) {
      id
      memberUserList {
        count
        userList {
          id
          name
          pictureUrl
          priorSportsCategory {
            id
            group
          }
          priorSportsPosition
          priorSportsRole
          isStarredBy(starerId: $starerId, teamId: $teamId)
        }
      }
    }
  }
}
    `;

/**
 * __useDrawerPlayersListQuery__
 *
 * To run a query within a React component, call `useDrawerPlayersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrawerPlayersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrawerPlayersListQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      starerId: // value for 'starerId'
 *   },
 * });
 */
export function useDrawerPlayersListQuery(baseOptions: Apollo.QueryHookOptions<DrawerPlayersListQuery, DrawerPlayersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DrawerPlayersListQuery, DrawerPlayersListQueryVariables>(DrawerPlayersListDocument, options);
      }
export function useDrawerPlayersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DrawerPlayersListQuery, DrawerPlayersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DrawerPlayersListQuery, DrawerPlayersListQueryVariables>(DrawerPlayersListDocument, options);
        }
export type DrawerPlayersListQueryHookResult = ReturnType<typeof useDrawerPlayersListQuery>;
export type DrawerPlayersListLazyQueryHookResult = ReturnType<typeof useDrawerPlayersListLazyQuery>;
export type DrawerPlayersListQueryResult = Apollo.QueryResult<DrawerPlayersListQuery, DrawerPlayersListQueryVariables>;
export function refetchDrawerPlayersListQuery(variables?: DrawerPlayersListQueryVariables) {
      return { query: DrawerPlayersListDocument, variables: variables }
    }
export const BodyPartsDocument = gql`
    query BodyParts($input: MultilingualTextInput!) {
  sports {
    bodyParts(input: $input) {
      back
      front
      group {
        id
      }
      id
      left
      right
      value
    }
  }
}
    `;

/**
 * __useBodyPartsQuery__
 *
 * To run a query within a React component, call `useBodyPartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBodyPartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBodyPartsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBodyPartsQuery(baseOptions: Apollo.QueryHookOptions<BodyPartsQuery, BodyPartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BodyPartsQuery, BodyPartsQueryVariables>(BodyPartsDocument, options);
      }
export function useBodyPartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BodyPartsQuery, BodyPartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BodyPartsQuery, BodyPartsQueryVariables>(BodyPartsDocument, options);
        }
export type BodyPartsQueryHookResult = ReturnType<typeof useBodyPartsQuery>;
export type BodyPartsLazyQueryHookResult = ReturnType<typeof useBodyPartsLazyQuery>;
export type BodyPartsQueryResult = Apollo.QueryResult<BodyPartsQuery, BodyPartsQueryVariables>;
export function refetchBodyPartsQuery(variables?: BodyPartsQueryVariables) {
      return { query: BodyPartsDocument, variables: variables }
    }
export const BodyPartMultilingualTextDocument = gql`
    query BodyPartMultilingualText($input: MultilingualTextInput!, $key: String) {
  multilingualText(input: $input) {
    bodyPartList(key: $key) {
      id
      value
    }
  }
}
    `;

/**
 * __useBodyPartMultilingualTextQuery__
 *
 * To run a query within a React component, call `useBodyPartMultilingualTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useBodyPartMultilingualTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBodyPartMultilingualTextQuery({
 *   variables: {
 *      input: // value for 'input'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useBodyPartMultilingualTextQuery(baseOptions: Apollo.QueryHookOptions<BodyPartMultilingualTextQuery, BodyPartMultilingualTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BodyPartMultilingualTextQuery, BodyPartMultilingualTextQueryVariables>(BodyPartMultilingualTextDocument, options);
      }
export function useBodyPartMultilingualTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BodyPartMultilingualTextQuery, BodyPartMultilingualTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BodyPartMultilingualTextQuery, BodyPartMultilingualTextQueryVariables>(BodyPartMultilingualTextDocument, options);
        }
export type BodyPartMultilingualTextQueryHookResult = ReturnType<typeof useBodyPartMultilingualTextQuery>;
export type BodyPartMultilingualTextLazyQueryHookResult = ReturnType<typeof useBodyPartMultilingualTextLazyQuery>;
export type BodyPartMultilingualTextQueryResult = Apollo.QueryResult<BodyPartMultilingualTextQuery, BodyPartMultilingualTextQueryVariables>;
export function refetchBodyPartMultilingualTextQuery(variables?: BodyPartMultilingualTextQueryVariables) {
      return { query: BodyPartMultilingualTextDocument, variables: variables }
    }
export const ModalTeamCreateViewerDocument = gql`
    query ModalTeamCreateViewer {
  sports {
    viewer {
      id
      name
      priorSportsCategory {
        id
      }
      nationality
    }
  }
}
    `;

/**
 * __useModalTeamCreateViewerQuery__
 *
 * To run a query within a React component, call `useModalTeamCreateViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalTeamCreateViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalTeamCreateViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useModalTeamCreateViewerQuery(baseOptions?: Apollo.QueryHookOptions<ModalTeamCreateViewerQuery, ModalTeamCreateViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModalTeamCreateViewerQuery, ModalTeamCreateViewerQueryVariables>(ModalTeamCreateViewerDocument, options);
      }
export function useModalTeamCreateViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModalTeamCreateViewerQuery, ModalTeamCreateViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModalTeamCreateViewerQuery, ModalTeamCreateViewerQueryVariables>(ModalTeamCreateViewerDocument, options);
        }
export type ModalTeamCreateViewerQueryHookResult = ReturnType<typeof useModalTeamCreateViewerQuery>;
export type ModalTeamCreateViewerLazyQueryHookResult = ReturnType<typeof useModalTeamCreateViewerLazyQuery>;
export type ModalTeamCreateViewerQueryResult = Apollo.QueryResult<ModalTeamCreateViewerQuery, ModalTeamCreateViewerQueryVariables>;
export function refetchModalTeamCreateViewerQuery(variables?: ModalTeamCreateViewerQueryVariables) {
      return { query: ModalTeamCreateViewerDocument, variables: variables }
    }
export const ModalTeamCreateTeamDataDocument = gql`
    query ModalTeamCreateTeamData($id: ID!) {
  sports {
    team(id: $id) {
      ...ModalTeamCreateTeam
      userMapsByPage {
        entries {
          teamAuthority
          user {
            id
          }
        }
      }
    }
    viewer {
      id
      teamMapsByPage(offset: 0, limit: 1, order: {field: createdAt, sort: ASC}) {
        total
        entries {
          team {
            ...ModalTeamCreateTeam
          }
          teamAuthority
        }
      }
    }
  }
}
    ${ModalTeamCreateTeamFragmentDoc}`;

/**
 * __useModalTeamCreateTeamDataQuery__
 *
 * To run a query within a React component, call `useModalTeamCreateTeamDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalTeamCreateTeamDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalTeamCreateTeamDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModalTeamCreateTeamDataQuery(baseOptions: Apollo.QueryHookOptions<ModalTeamCreateTeamDataQuery, ModalTeamCreateTeamDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModalTeamCreateTeamDataQuery, ModalTeamCreateTeamDataQueryVariables>(ModalTeamCreateTeamDataDocument, options);
      }
export function useModalTeamCreateTeamDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModalTeamCreateTeamDataQuery, ModalTeamCreateTeamDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModalTeamCreateTeamDataQuery, ModalTeamCreateTeamDataQueryVariables>(ModalTeamCreateTeamDataDocument, options);
        }
export type ModalTeamCreateTeamDataQueryHookResult = ReturnType<typeof useModalTeamCreateTeamDataQuery>;
export type ModalTeamCreateTeamDataLazyQueryHookResult = ReturnType<typeof useModalTeamCreateTeamDataLazyQuery>;
export type ModalTeamCreateTeamDataQueryResult = Apollo.QueryResult<ModalTeamCreateTeamDataQuery, ModalTeamCreateTeamDataQueryVariables>;
export function refetchModalTeamCreateTeamDataQuery(variables?: ModalTeamCreateTeamDataQueryVariables) {
      return { query: ModalTeamCreateTeamDataDocument, variables: variables }
    }
export const ModalTeamJoinViewerDocument = gql`
    query ModalTeamJoinViewer {
  sports {
    viewer {
      id
      name
      priorSportsCategory {
        id
      }
      nationality
    }
  }
}
    `;

/**
 * __useModalTeamJoinViewerQuery__
 *
 * To run a query within a React component, call `useModalTeamJoinViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalTeamJoinViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalTeamJoinViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useModalTeamJoinViewerQuery(baseOptions?: Apollo.QueryHookOptions<ModalTeamJoinViewerQuery, ModalTeamJoinViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModalTeamJoinViewerQuery, ModalTeamJoinViewerQueryVariables>(ModalTeamJoinViewerDocument, options);
      }
export function useModalTeamJoinViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModalTeamJoinViewerQuery, ModalTeamJoinViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModalTeamJoinViewerQuery, ModalTeamJoinViewerQueryVariables>(ModalTeamJoinViewerDocument, options);
        }
export type ModalTeamJoinViewerQueryHookResult = ReturnType<typeof useModalTeamJoinViewerQuery>;
export type ModalTeamJoinViewerLazyQueryHookResult = ReturnType<typeof useModalTeamJoinViewerLazyQuery>;
export type ModalTeamJoinViewerQueryResult = Apollo.QueryResult<ModalTeamJoinViewerQuery, ModalTeamJoinViewerQueryVariables>;
export function refetchModalTeamJoinViewerQuery(variables?: ModalTeamJoinViewerQueryVariables) {
      return { query: ModalTeamJoinViewerDocument, variables: variables }
    }
export const NavbarTeamsTeamDataDocument = gql`
    query NavbarTeamsTeamData($id: ID!) {
  sports {
    team(id: $id) {
      ...NavbarTeamsTeam
      userMapsByPage {
        total
        entries {
          teamAuthority
          user {
            id
          }
        }
      }
    }
    viewer {
      id
      teamMapsByPage(offset: 0, limit: 1, order: {field: createdAt, sort: ASC}) {
        total
        entries {
          team {
            ...NavbarTeamsTeam
          }
          teamAuthority
        }
      }
    }
  }
}
    ${NavbarTeamsTeamFragmentDoc}`;

/**
 * __useNavbarTeamsTeamDataQuery__
 *
 * To run a query within a React component, call `useNavbarTeamsTeamDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavbarTeamsTeamDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavbarTeamsTeamDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNavbarTeamsTeamDataQuery(baseOptions: Apollo.QueryHookOptions<NavbarTeamsTeamDataQuery, NavbarTeamsTeamDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavbarTeamsTeamDataQuery, NavbarTeamsTeamDataQueryVariables>(NavbarTeamsTeamDataDocument, options);
      }
export function useNavbarTeamsTeamDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavbarTeamsTeamDataQuery, NavbarTeamsTeamDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavbarTeamsTeamDataQuery, NavbarTeamsTeamDataQueryVariables>(NavbarTeamsTeamDataDocument, options);
        }
export type NavbarTeamsTeamDataQueryHookResult = ReturnType<typeof useNavbarTeamsTeamDataQuery>;
export type NavbarTeamsTeamDataLazyQueryHookResult = ReturnType<typeof useNavbarTeamsTeamDataLazyQuery>;
export type NavbarTeamsTeamDataQueryResult = Apollo.QueryResult<NavbarTeamsTeamDataQuery, NavbarTeamsTeamDataQueryVariables>;
export function refetchNavbarTeamsTeamDataQuery(variables?: NavbarTeamsTeamDataQueryVariables) {
      return { query: NavbarTeamsTeamDataDocument, variables: variables }
    }
export const CreateFeedbackDocument = gql`
    mutation CreateFeedback($input: CreateFeedbackInput!, $multilingualTextInput: MultilingualTextInput!) {
  createFeedback(input: $input) {
    ...FeedbackData
  }
}
    ${FeedbackDataFragmentDoc}`;
export type CreateFeedbackMutationFn = Apollo.MutationFunction<CreateFeedbackMutation, CreateFeedbackMutationVariables>;

/**
 * __useCreateFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackMutation, { data, loading, error }] = useCreateFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *      multilingualTextInput: // value for 'multilingualTextInput'
 *   },
 * });
 */
export function useCreateFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument, options);
      }
export type CreateFeedbackMutationHookResult = ReturnType<typeof useCreateFeedbackMutation>;
export type CreateFeedbackMutationResult = Apollo.MutationResult<CreateFeedbackMutation>;
export type CreateFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const DeleteFeedbackDocument = gql`
    mutation DeleteFeedback($id: ID!) {
  deleteFeedback(id: $id)
}
    `;
export type DeleteFeedbackMutationFn = Apollo.MutationFunction<DeleteFeedbackMutation, DeleteFeedbackMutationVariables>;

/**
 * __useDeleteFeedbackMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackMutation, { data, loading, error }] = useDeleteFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeedbackMutation, DeleteFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeedbackMutation, DeleteFeedbackMutationVariables>(DeleteFeedbackDocument, options);
      }
export type DeleteFeedbackMutationHookResult = ReturnType<typeof useDeleteFeedbackMutation>;
export type DeleteFeedbackMutationResult = Apollo.MutationResult<DeleteFeedbackMutation>;
export type DeleteFeedbackMutationOptions = Apollo.BaseMutationOptions<DeleteFeedbackMutation, DeleteFeedbackMutationVariables>;
export const UpdateFeedbackDocument = gql`
    mutation UpdateFeedback($input: UpdateFeedbackInput!, $multilingualTextInput: MultilingualTextInput!) {
  updateFeedback(input: $input) {
    ...FeedbackData
  }
}
    ${FeedbackDataFragmentDoc}`;
export type UpdateFeedbackMutationFn = Apollo.MutationFunction<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>;

/**
 * __useUpdateFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackMutation, { data, loading, error }] = useUpdateFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *      multilingualTextInput: // value for 'multilingualTextInput'
 *   },
 * });
 */
export function useUpdateFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>(UpdateFeedbackDocument, options);
      }
export type UpdateFeedbackMutationHookResult = ReturnType<typeof useUpdateFeedbackMutation>;
export type UpdateFeedbackMutationResult = Apollo.MutationResult<UpdateFeedbackMutation>;
export type UpdateFeedbackMutationOptions = Apollo.BaseMutationOptions<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>;
export const CreateFeedbackCommentsDocument = gql`
    mutation CreateFeedbackComments($input: CreateFeedbackCommentInput!, $multilingualTextInput: MultilingualTextInput!) {
  createFeedbackComment(input: $input) {
    ...FeedbackData
  }
}
    ${FeedbackDataFragmentDoc}`;
export type CreateFeedbackCommentsMutationFn = Apollo.MutationFunction<CreateFeedbackCommentsMutation, CreateFeedbackCommentsMutationVariables>;

/**
 * __useCreateFeedbackCommentsMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackCommentsMutation, { data, loading, error }] = useCreateFeedbackCommentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      multilingualTextInput: // value for 'multilingualTextInput'
 *   },
 * });
 */
export function useCreateFeedbackCommentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackCommentsMutation, CreateFeedbackCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackCommentsMutation, CreateFeedbackCommentsMutationVariables>(CreateFeedbackCommentsDocument, options);
      }
export type CreateFeedbackCommentsMutationHookResult = ReturnType<typeof useCreateFeedbackCommentsMutation>;
export type CreateFeedbackCommentsMutationResult = Apollo.MutationResult<CreateFeedbackCommentsMutation>;
export type CreateFeedbackCommentsMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackCommentsMutation, CreateFeedbackCommentsMutationVariables>;
export const UpdateFeedbackCommentsDocument = gql`
    mutation UpdateFeedbackComments($input: UpdateFeedbackCommentInput!, $multilingualTextInput: MultilingualTextInput!) {
  updateFeedbackComment(input: $input) {
    ...FeedbackData
  }
}
    ${FeedbackDataFragmentDoc}`;
export type UpdateFeedbackCommentsMutationFn = Apollo.MutationFunction<UpdateFeedbackCommentsMutation, UpdateFeedbackCommentsMutationVariables>;

/**
 * __useUpdateFeedbackCommentsMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackCommentsMutation, { data, loading, error }] = useUpdateFeedbackCommentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      multilingualTextInput: // value for 'multilingualTextInput'
 *   },
 * });
 */
export function useUpdateFeedbackCommentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedbackCommentsMutation, UpdateFeedbackCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedbackCommentsMutation, UpdateFeedbackCommentsMutationVariables>(UpdateFeedbackCommentsDocument, options);
      }
export type UpdateFeedbackCommentsMutationHookResult = ReturnType<typeof useUpdateFeedbackCommentsMutation>;
export type UpdateFeedbackCommentsMutationResult = Apollo.MutationResult<UpdateFeedbackCommentsMutation>;
export type UpdateFeedbackCommentsMutationOptions = Apollo.BaseMutationOptions<UpdateFeedbackCommentsMutation, UpdateFeedbackCommentsMutationVariables>;
export const DeleteFeedbackCommentsDocument = gql`
    mutation DeleteFeedbackComments($input: DeleteFeedbackCommentInput!, $multilingualTextInput: MultilingualTextInput!) {
  deleteFeedbackComment(input: $input) {
    ...FeedbackData
  }
}
    ${FeedbackDataFragmentDoc}`;
export type DeleteFeedbackCommentsMutationFn = Apollo.MutationFunction<DeleteFeedbackCommentsMutation, DeleteFeedbackCommentsMutationVariables>;

/**
 * __useDeleteFeedbackCommentsMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackCommentsMutation, { data, loading, error }] = useDeleteFeedbackCommentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      multilingualTextInput: // value for 'multilingualTextInput'
 *   },
 * });
 */
export function useDeleteFeedbackCommentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeedbackCommentsMutation, DeleteFeedbackCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeedbackCommentsMutation, DeleteFeedbackCommentsMutationVariables>(DeleteFeedbackCommentsDocument, options);
      }
export type DeleteFeedbackCommentsMutationHookResult = ReturnType<typeof useDeleteFeedbackCommentsMutation>;
export type DeleteFeedbackCommentsMutationResult = Apollo.MutationResult<DeleteFeedbackCommentsMutation>;
export type DeleteFeedbackCommentsMutationOptions = Apollo.BaseMutationOptions<DeleteFeedbackCommentsMutation, DeleteFeedbackCommentsMutationVariables>;
export const CreateInjuryDocument = gql`
    mutation CreateInjury($input: CreateInjuryInput!, $files: [Upload!]!, $multilingualTextInput: MultilingualTextInput!) {
  createInjury(input: $input, files: $files) {
    id
    bodyPart(input: $multilingualTextInput) {
      id
      value
    }
    occurDate
    historyStatus
    reason
    diagnosis
    medicalRecord
    return {
      date
      status
      info
    }
    fileList {
      id
      name
      url
    }
    status
    user {
      id
    }
  }
}
    `;
export type CreateInjuryMutationFn = Apollo.MutationFunction<CreateInjuryMutation, CreateInjuryMutationVariables>;

/**
 * __useCreateInjuryMutation__
 *
 * To run a mutation, you first call `useCreateInjuryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInjuryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInjuryMutation, { data, loading, error }] = useCreateInjuryMutation({
 *   variables: {
 *      input: // value for 'input'
 *      files: // value for 'files'
 *      multilingualTextInput: // value for 'multilingualTextInput'
 *   },
 * });
 */
export function useCreateInjuryMutation(baseOptions?: Apollo.MutationHookOptions<CreateInjuryMutation, CreateInjuryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInjuryMutation, CreateInjuryMutationVariables>(CreateInjuryDocument, options);
      }
export type CreateInjuryMutationHookResult = ReturnType<typeof useCreateInjuryMutation>;
export type CreateInjuryMutationResult = Apollo.MutationResult<CreateInjuryMutation>;
export type CreateInjuryMutationOptions = Apollo.BaseMutationOptions<CreateInjuryMutation, CreateInjuryMutationVariables>;
export const UpdateInjuryDocument = gql`
    mutation UpdateInjury($input: UpdateInjuryInput!, $files: [Upload!], $multilingualTextInput: MultilingualTextInput!) {
  updateInjury(input: $input, files: $files) {
    id
    bodyPart(input: $multilingualTextInput) {
      id
      value
    }
    occurDate
    historyStatus
    reason
    diagnosis
    medicalRecord
    return {
      date
      info
      status
    }
    fileList {
      id
      name
      url
    }
    status
  }
}
    `;
export type UpdateInjuryMutationFn = Apollo.MutationFunction<UpdateInjuryMutation, UpdateInjuryMutationVariables>;

/**
 * __useUpdateInjuryMutation__
 *
 * To run a mutation, you first call `useUpdateInjuryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInjuryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInjuryMutation, { data, loading, error }] = useUpdateInjuryMutation({
 *   variables: {
 *      input: // value for 'input'
 *      files: // value for 'files'
 *      multilingualTextInput: // value for 'multilingualTextInput'
 *   },
 * });
 */
export function useUpdateInjuryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInjuryMutation, UpdateInjuryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInjuryMutation, UpdateInjuryMutationVariables>(UpdateInjuryDocument, options);
      }
export type UpdateInjuryMutationHookResult = ReturnType<typeof useUpdateInjuryMutation>;
export type UpdateInjuryMutationResult = Apollo.MutationResult<UpdateInjuryMutation>;
export type UpdateInjuryMutationOptions = Apollo.BaseMutationOptions<UpdateInjuryMutation, UpdateInjuryMutationVariables>;
export const DeleteInjuryDocument = gql`
    mutation DeleteInjury($input: DeleteInjuryInput!) {
  deleteInjury(input: $input)
}
    `;
export type DeleteInjuryMutationFn = Apollo.MutationFunction<DeleteInjuryMutation, DeleteInjuryMutationVariables>;

/**
 * __useDeleteInjuryMutation__
 *
 * To run a mutation, you first call `useDeleteInjuryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInjuryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInjuryMutation, { data, loading, error }] = useDeleteInjuryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInjuryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInjuryMutation, DeleteInjuryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInjuryMutation, DeleteInjuryMutationVariables>(DeleteInjuryDocument, options);
      }
export type DeleteInjuryMutationHookResult = ReturnType<typeof useDeleteInjuryMutation>;
export type DeleteInjuryMutationResult = Apollo.MutationResult<DeleteInjuryMutation>;
export type DeleteInjuryMutationOptions = Apollo.BaseMutationOptions<DeleteInjuryMutation, DeleteInjuryMutationVariables>;
export const SendCheckConditionReminderPushDocument = gql`
    mutation SendCheckConditionReminderPush($input: CheckReminderPushInput!) {
  sendCheckConditionReminderPush(input: $input)
}
    `;
export type SendCheckConditionReminderPushMutationFn = Apollo.MutationFunction<SendCheckConditionReminderPushMutation, SendCheckConditionReminderPushMutationVariables>;

/**
 * __useSendCheckConditionReminderPushMutation__
 *
 * To run a mutation, you first call `useSendCheckConditionReminderPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCheckConditionReminderPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCheckConditionReminderPushMutation, { data, loading, error }] = useSendCheckConditionReminderPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCheckConditionReminderPushMutation(baseOptions?: Apollo.MutationHookOptions<SendCheckConditionReminderPushMutation, SendCheckConditionReminderPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCheckConditionReminderPushMutation, SendCheckConditionReminderPushMutationVariables>(SendCheckConditionReminderPushDocument, options);
      }
export type SendCheckConditionReminderPushMutationHookResult = ReturnType<typeof useSendCheckConditionReminderPushMutation>;
export type SendCheckConditionReminderPushMutationResult = Apollo.MutationResult<SendCheckConditionReminderPushMutation>;
export type SendCheckConditionReminderPushMutationOptions = Apollo.BaseMutationOptions<SendCheckConditionReminderPushMutation, SendCheckConditionReminderPushMutationVariables>;
export const SendCheckWorkloadReminderPushDocument = gql`
    mutation SendCheckWorkloadReminderPush($input: CheckReminderPushInput!) {
  sendCheckWorkloadReminderPush(input: $input)
}
    `;
export type SendCheckWorkloadReminderPushMutationFn = Apollo.MutationFunction<SendCheckWorkloadReminderPushMutation, SendCheckWorkloadReminderPushMutationVariables>;

/**
 * __useSendCheckWorkloadReminderPushMutation__
 *
 * To run a mutation, you first call `useSendCheckWorkloadReminderPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCheckWorkloadReminderPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCheckWorkloadReminderPushMutation, { data, loading, error }] = useSendCheckWorkloadReminderPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCheckWorkloadReminderPushMutation(baseOptions?: Apollo.MutationHookOptions<SendCheckWorkloadReminderPushMutation, SendCheckWorkloadReminderPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCheckWorkloadReminderPushMutation, SendCheckWorkloadReminderPushMutationVariables>(SendCheckWorkloadReminderPushDocument, options);
      }
export type SendCheckWorkloadReminderPushMutationHookResult = ReturnType<typeof useSendCheckWorkloadReminderPushMutation>;
export type SendCheckWorkloadReminderPushMutationResult = Apollo.MutationResult<SendCheckWorkloadReminderPushMutation>;
export type SendCheckWorkloadReminderPushMutationOptions = Apollo.BaseMutationOptions<SendCheckWorkloadReminderPushMutation, SendCheckWorkloadReminderPushMutationVariables>;
export const RequestBillingTokenDocument = gql`
    mutation RequestBillingToken($input: RequestBillingTokenInput!) {
  requestBillingToken(input: $input) {
    customerUid
    paymentToken
  }
}
    `;
export type RequestBillingTokenMutationFn = Apollo.MutationFunction<RequestBillingTokenMutation, RequestBillingTokenMutationVariables>;

/**
 * __useRequestBillingTokenMutation__
 *
 * To run a mutation, you first call `useRequestBillingTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBillingTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBillingTokenMutation, { data, loading, error }] = useRequestBillingTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestBillingTokenMutation(baseOptions?: Apollo.MutationHookOptions<RequestBillingTokenMutation, RequestBillingTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBillingTokenMutation, RequestBillingTokenMutationVariables>(RequestBillingTokenDocument, options);
      }
export type RequestBillingTokenMutationHookResult = ReturnType<typeof useRequestBillingTokenMutation>;
export type RequestBillingTokenMutationResult = Apollo.MutationResult<RequestBillingTokenMutation>;
export type RequestBillingTokenMutationOptions = Apollo.BaseMutationOptions<RequestBillingTokenMutation, RequestBillingTokenMutationVariables>;
export const UpdateBillingKeyDocument = gql`
    mutation UpdateBillingKey($input: UpdateBillingTokenInput!) {
  updateBillingKey(input: $input) {
    id
    identityToken
    customerUid
    cardName
    cardNumber
    buyerName
    buyerTel
    buyerEmail
  }
}
    `;
export type UpdateBillingKeyMutationFn = Apollo.MutationFunction<UpdateBillingKeyMutation, UpdateBillingKeyMutationVariables>;

/**
 * __useUpdateBillingKeyMutation__
 *
 * To run a mutation, you first call `useUpdateBillingKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingKeyMutation, { data, loading, error }] = useUpdateBillingKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingKeyMutation, UpdateBillingKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingKeyMutation, UpdateBillingKeyMutationVariables>(UpdateBillingKeyDocument, options);
      }
export type UpdateBillingKeyMutationHookResult = ReturnType<typeof useUpdateBillingKeyMutation>;
export type UpdateBillingKeyMutationResult = Apollo.MutationResult<UpdateBillingKeyMutation>;
export type UpdateBillingKeyMutationOptions = Apollo.BaseMutationOptions<UpdateBillingKeyMutation, UpdateBillingKeyMutationVariables>;
export const UpdateBillingBuyerNameDocument = gql`
    mutation UpdateBillingBuyerName($input: UpdateBillingBuyerNameInput!) {
  updateBillingBuyerName(input: $input) {
    id
  }
}
    `;
export type UpdateBillingBuyerNameMutationFn = Apollo.MutationFunction<UpdateBillingBuyerNameMutation, UpdateBillingBuyerNameMutationVariables>;

/**
 * __useUpdateBillingBuyerNameMutation__
 *
 * To run a mutation, you first call `useUpdateBillingBuyerNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingBuyerNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingBuyerNameMutation, { data, loading, error }] = useUpdateBillingBuyerNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingBuyerNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingBuyerNameMutation, UpdateBillingBuyerNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingBuyerNameMutation, UpdateBillingBuyerNameMutationVariables>(UpdateBillingBuyerNameDocument, options);
      }
export type UpdateBillingBuyerNameMutationHookResult = ReturnType<typeof useUpdateBillingBuyerNameMutation>;
export type UpdateBillingBuyerNameMutationResult = Apollo.MutationResult<UpdateBillingBuyerNameMutation>;
export type UpdateBillingBuyerNameMutationOptions = Apollo.BaseMutationOptions<UpdateBillingBuyerNameMutation, UpdateBillingBuyerNameMutationVariables>;
export const UpdateBillingBuyerNumberDocument = gql`
    mutation UpdateBillingBuyerNumber($input: UpdateBillingBuyerNumberInput!) {
  updateBillingBuyerNumber(input: $input) {
    id
  }
}
    `;
export type UpdateBillingBuyerNumberMutationFn = Apollo.MutationFunction<UpdateBillingBuyerNumberMutation, UpdateBillingBuyerNumberMutationVariables>;

/**
 * __useUpdateBillingBuyerNumberMutation__
 *
 * To run a mutation, you first call `useUpdateBillingBuyerNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingBuyerNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingBuyerNumberMutation, { data, loading, error }] = useUpdateBillingBuyerNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingBuyerNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingBuyerNumberMutation, UpdateBillingBuyerNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingBuyerNumberMutation, UpdateBillingBuyerNumberMutationVariables>(UpdateBillingBuyerNumberDocument, options);
      }
export type UpdateBillingBuyerNumberMutationHookResult = ReturnType<typeof useUpdateBillingBuyerNumberMutation>;
export type UpdateBillingBuyerNumberMutationResult = Apollo.MutationResult<UpdateBillingBuyerNumberMutation>;
export type UpdateBillingBuyerNumberMutationOptions = Apollo.BaseMutationOptions<UpdateBillingBuyerNumberMutation, UpdateBillingBuyerNumberMutationVariables>;
export const UpdateBillingBuyerEmailDocument = gql`
    mutation UpdateBillingBuyerEmail($input: UpdateBillingBuyerEmailInput!) {
  updateBillingBuyerEmail(input: $input) {
    id
  }
}
    `;
export type UpdateBillingBuyerEmailMutationFn = Apollo.MutationFunction<UpdateBillingBuyerEmailMutation, UpdateBillingBuyerEmailMutationVariables>;

/**
 * __useUpdateBillingBuyerEmailMutation__
 *
 * To run a mutation, you first call `useUpdateBillingBuyerEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingBuyerEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingBuyerEmailMutation, { data, loading, error }] = useUpdateBillingBuyerEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingBuyerEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingBuyerEmailMutation, UpdateBillingBuyerEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingBuyerEmailMutation, UpdateBillingBuyerEmailMutationVariables>(UpdateBillingBuyerEmailDocument, options);
      }
export type UpdateBillingBuyerEmailMutationHookResult = ReturnType<typeof useUpdateBillingBuyerEmailMutation>;
export type UpdateBillingBuyerEmailMutationResult = Apollo.MutationResult<UpdateBillingBuyerEmailMutation>;
export type UpdateBillingBuyerEmailMutationOptions = Apollo.BaseMutationOptions<UpdateBillingBuyerEmailMutation, UpdateBillingBuyerEmailMutationVariables>;
export const StartSubscriptionDocument = gql`
    mutation StartSubscription($input: StartSubscriptionInput!) {
  startSubscription(input: $input) {
    subscription {
      ...PaymentSubscrption
    }
    paymentList {
      ... on PayInvoice {
        id
        paymentName
        paymentStatus
        cardName
        cardNumber
        billingUserName
        billingUserEmail
        billingUserPhone
        receiptUrl
        paidAt
        amount
      }
    }
  }
}
    ${PaymentSubscrptionFragmentDoc}`;
export type StartSubscriptionMutationFn = Apollo.MutationFunction<StartSubscriptionMutation, StartSubscriptionMutationVariables>;

/**
 * __useStartSubscriptionMutation__
 *
 * To run a mutation, you first call `useStartSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSubscriptionMutation, { data, loading, error }] = useStartSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<StartSubscriptionMutation, StartSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSubscriptionMutation, StartSubscriptionMutationVariables>(StartSubscriptionDocument, options);
      }
export type StartSubscriptionMutationHookResult = ReturnType<typeof useStartSubscriptionMutation>;
export type StartSubscriptionMutationResult = Apollo.MutationResult<StartSubscriptionMutation>;
export type StartSubscriptionMutationOptions = Apollo.BaseMutationOptions<StartSubscriptionMutation, StartSubscriptionMutationVariables>;
export const RestartSubscriptionDocument = gql`
    mutation RestartSubscription($input: RestartSubscriptionInput!) {
  restartSubscription(input: $input) {
    subscription {
      ...PaymentSubscrption
    }
    paymentList {
      ... on PayInvoice {
        id
        paymentName
        paymentStatus
        cardName
        cardNumber
        billingUserName
        billingUserEmail
        billingUserPhone
        receiptUrl
        paidAt
        amount
      }
    }
  }
}
    ${PaymentSubscrptionFragmentDoc}`;
export type RestartSubscriptionMutationFn = Apollo.MutationFunction<RestartSubscriptionMutation, RestartSubscriptionMutationVariables>;

/**
 * __useRestartSubscriptionMutation__
 *
 * To run a mutation, you first call `useRestartSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartSubscriptionMutation, { data, loading, error }] = useRestartSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestartSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RestartSubscriptionMutation, RestartSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestartSubscriptionMutation, RestartSubscriptionMutationVariables>(RestartSubscriptionDocument, options);
      }
export type RestartSubscriptionMutationHookResult = ReturnType<typeof useRestartSubscriptionMutation>;
export type RestartSubscriptionMutationResult = Apollo.MutationResult<RestartSubscriptionMutation>;
export type RestartSubscriptionMutationOptions = Apollo.BaseMutationOptions<RestartSubscriptionMutation, RestartSubscriptionMutationVariables>;
export const RefundSubscriptionDocument = gql`
    mutation RefundSubscription($input: RefundSubscriptionInput!) {
  refundSubscription(input: $input) {
    subscription {
      ...PaymentSubscrption
    }
    paymentList {
      ... on RefundInvoice {
        id
        paymentName
        paymentStatus
        cardName
        cardNumber
        billingUserName
        billingUserEmail
        billingUserPhone
        receiptUrl
        refundAt
        refundAmount
      }
    }
  }
}
    ${PaymentSubscrptionFragmentDoc}`;
export type RefundSubscriptionMutationFn = Apollo.MutationFunction<RefundSubscriptionMutation, RefundSubscriptionMutationVariables>;

/**
 * __useRefundSubscriptionMutation__
 *
 * To run a mutation, you first call `useRefundSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundSubscriptionMutation, { data, loading, error }] = useRefundSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefundSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RefundSubscriptionMutation, RefundSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundSubscriptionMutation, RefundSubscriptionMutationVariables>(RefundSubscriptionDocument, options);
      }
export type RefundSubscriptionMutationHookResult = ReturnType<typeof useRefundSubscriptionMutation>;
export type RefundSubscriptionMutationResult = Apollo.MutationResult<RefundSubscriptionMutation>;
export type RefundSubscriptionMutationOptions = Apollo.BaseMutationOptions<RefundSubscriptionMutation, RefundSubscriptionMutationVariables>;
export const ResumeSubscriptionDocument = gql`
    mutation ResumeSubscription($input: ResumeSubscriptionInput!) {
  resumeSubscription(input: $input) {
    id
  }
}
    `;
export type ResumeSubscriptionMutationFn = Apollo.MutationFunction<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>;

/**
 * __useResumeSubscriptionMutation__
 *
 * To run a mutation, you first call `useResumeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSubscriptionMutation, { data, loading, error }] = useResumeSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>(ResumeSubscriptionDocument, options);
      }
export type ResumeSubscriptionMutationHookResult = ReturnType<typeof useResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationResult = Apollo.MutationResult<ResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationOptions = Apollo.BaseMutationOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($input: CancelSubscriptionInput!) {
  cancelSubscription(input: $input) {
    id
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const RefundDocument = gql`
    mutation Refund($input: Refund!) {
  refund(input: $input) {
    success
  }
}
    `;
export type RefundMutationFn = Apollo.MutationFunction<RefundMutation, RefundMutationVariables>;

/**
 * __useRefundMutation__
 *
 * To run a mutation, you first call `useRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundMutation, { data, loading, error }] = useRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefundMutation(baseOptions?: Apollo.MutationHookOptions<RefundMutation, RefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundMutation, RefundMutationVariables>(RefundDocument, options);
      }
export type RefundMutationHookResult = ReturnType<typeof useRefundMutation>;
export type RefundMutationResult = Apollo.MutationResult<RefundMutation>;
export type RefundMutationOptions = Apollo.BaseMutationOptions<RefundMutation, RefundMutationVariables>;
export const RePaymentRequestDocument = gql`
    mutation RePaymentRequest($input: RetryPayment!) {
  retryPayment(input: $input) {
    subscription {
      ...PaymentSubscrption
    }
    paymentList {
      ... on PayInvoice {
        id
        paymentName
        paymentStatus
        cardName
        cardNumber
        billingUserName
        billingUserEmail
        billingUserPhone
        receiptUrl
        paidAt
        amount
      }
    }
  }
}
    ${PaymentSubscrptionFragmentDoc}`;
export type RePaymentRequestMutationFn = Apollo.MutationFunction<RePaymentRequestMutation, RePaymentRequestMutationVariables>;

/**
 * __useRePaymentRequestMutation__
 *
 * To run a mutation, you first call `useRePaymentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRePaymentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rePaymentRequestMutation, { data, loading, error }] = useRePaymentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRePaymentRequestMutation(baseOptions?: Apollo.MutationHookOptions<RePaymentRequestMutation, RePaymentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RePaymentRequestMutation, RePaymentRequestMutationVariables>(RePaymentRequestDocument, options);
      }
export type RePaymentRequestMutationHookResult = ReturnType<typeof useRePaymentRequestMutation>;
export type RePaymentRequestMutationResult = Apollo.MutationResult<RePaymentRequestMutation>;
export type RePaymentRequestMutationOptions = Apollo.BaseMutationOptions<RePaymentRequestMutation, RePaymentRequestMutationVariables>;
export const LeaveTeamDocument = gql`
    mutation LeaveTeam($input: TeamUserInput!) {
  leaveTeam(input: $input)
}
    `;
export type LeaveTeamMutationFn = Apollo.MutationFunction<LeaveTeamMutation, LeaveTeamMutationVariables>;

/**
 * __useLeaveTeamMutation__
 *
 * To run a mutation, you first call `useLeaveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveTeamMutation, { data, loading, error }] = useLeaveTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeaveTeamMutation(baseOptions?: Apollo.MutationHookOptions<LeaveTeamMutation, LeaveTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveTeamMutation, LeaveTeamMutationVariables>(LeaveTeamDocument, options);
      }
export type LeaveTeamMutationHookResult = ReturnType<typeof useLeaveTeamMutation>;
export type LeaveTeamMutationResult = Apollo.MutationResult<LeaveTeamMutation>;
export type LeaveTeamMutationOptions = Apollo.BaseMutationOptions<LeaveTeamMutation, LeaveTeamMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation DeleteTeam($teamId: ID!) {
  deleteTeam(teamId: $teamId) {
    id
  }
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const TransferTeamOwnershipDocument = gql`
    mutation TransferTeamOwnership($input: TeamUserInput!) {
  transferTeamOwnership(input: $input) {
    ownerTeamUserMap {
      id
    }
    adminTeamUserMap {
      id
    }
  }
}
    `;
export type TransferTeamOwnershipMutationFn = Apollo.MutationFunction<TransferTeamOwnershipMutation, TransferTeamOwnershipMutationVariables>;

/**
 * __useTransferTeamOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferTeamOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferTeamOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferTeamOwnershipMutation, { data, loading, error }] = useTransferTeamOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferTeamOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<TransferTeamOwnershipMutation, TransferTeamOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferTeamOwnershipMutation, TransferTeamOwnershipMutationVariables>(TransferTeamOwnershipDocument, options);
      }
export type TransferTeamOwnershipMutationHookResult = ReturnType<typeof useTransferTeamOwnershipMutation>;
export type TransferTeamOwnershipMutationResult = Apollo.MutationResult<TransferTeamOwnershipMutation>;
export type TransferTeamOwnershipMutationOptions = Apollo.BaseMutationOptions<TransferTeamOwnershipMutation, TransferTeamOwnershipMutationVariables>;
export const KickoutTeamUserListDocument = gql`
    mutation KickoutTeamUserList($input: TeamUserListInput!) {
  kickoutTeamUserList(input: $input)
}
    `;
export type KickoutTeamUserListMutationFn = Apollo.MutationFunction<KickoutTeamUserListMutation, KickoutTeamUserListMutationVariables>;

/**
 * __useKickoutTeamUserListMutation__
 *
 * To run a mutation, you first call `useKickoutTeamUserListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKickoutTeamUserListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kickoutTeamUserListMutation, { data, loading, error }] = useKickoutTeamUserListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKickoutTeamUserListMutation(baseOptions?: Apollo.MutationHookOptions<KickoutTeamUserListMutation, KickoutTeamUserListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KickoutTeamUserListMutation, KickoutTeamUserListMutationVariables>(KickoutTeamUserListDocument, options);
      }
export type KickoutTeamUserListMutationHookResult = ReturnType<typeof useKickoutTeamUserListMutation>;
export type KickoutTeamUserListMutationResult = Apollo.MutationResult<KickoutTeamUserListMutation>;
export type KickoutTeamUserListMutationOptions = Apollo.BaseMutationOptions<KickoutTeamUserListMutation, KickoutTeamUserListMutationVariables>;
export const CreateTeamGroupDocument = gql`
    mutation CreateTeamGroup($input: CreateTeamGroupInput!) {
  createTeamGroup(input: $input) {
    ...FTeamGroup
    groupMemberList {
      user {
        ...FSportsUser
      }
    }
  }
}
    ${FTeamGroupFragmentDoc}
${FSportsUserFragmentDoc}`;
export type CreateTeamGroupMutationFn = Apollo.MutationFunction<CreateTeamGroupMutation, CreateTeamGroupMutationVariables>;

/**
 * __useCreateTeamGroupMutation__
 *
 * To run a mutation, you first call `useCreateTeamGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamGroupMutation, { data, loading, error }] = useCreateTeamGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamGroupMutation, CreateTeamGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamGroupMutation, CreateTeamGroupMutationVariables>(CreateTeamGroupDocument, options);
      }
export type CreateTeamGroupMutationHookResult = ReturnType<typeof useCreateTeamGroupMutation>;
export type CreateTeamGroupMutationResult = Apollo.MutationResult<CreateTeamGroupMutation>;
export type CreateTeamGroupMutationOptions = Apollo.BaseMutationOptions<CreateTeamGroupMutation, CreateTeamGroupMutationVariables>;
export const UpdateTeamGroupDocument = gql`
    mutation UpdateTeamGroup($input: UpdateTeamGroupInput!) {
  updateTeamGroup(input: $input) {
    ...FTeamGroup
    groupMemberList {
      user {
        ...FSportsUser
      }
    }
  }
}
    ${FTeamGroupFragmentDoc}
${FSportsUserFragmentDoc}`;
export type UpdateTeamGroupMutationFn = Apollo.MutationFunction<UpdateTeamGroupMutation, UpdateTeamGroupMutationVariables>;

/**
 * __useUpdateTeamGroupMutation__
 *
 * To run a mutation, you first call `useUpdateTeamGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamGroupMutation, { data, loading, error }] = useUpdateTeamGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamGroupMutation, UpdateTeamGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamGroupMutation, UpdateTeamGroupMutationVariables>(UpdateTeamGroupDocument, options);
      }
export type UpdateTeamGroupMutationHookResult = ReturnType<typeof useUpdateTeamGroupMutation>;
export type UpdateTeamGroupMutationResult = Apollo.MutationResult<UpdateTeamGroupMutation>;
export type UpdateTeamGroupMutationOptions = Apollo.BaseMutationOptions<UpdateTeamGroupMutation, UpdateTeamGroupMutationVariables>;
export const DeleteTeamGroupDocument = gql`
    mutation DeleteTeamGroup($input: DeleteTeamGroupInput!) {
  deleteTeamGroup(input: $input) {
    ...FTeamGroup
  }
}
    ${FTeamGroupFragmentDoc}`;
export type DeleteTeamGroupMutationFn = Apollo.MutationFunction<DeleteTeamGroupMutation, DeleteTeamGroupMutationVariables>;

/**
 * __useDeleteTeamGroupMutation__
 *
 * To run a mutation, you first call `useDeleteTeamGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamGroupMutation, { data, loading, error }] = useDeleteTeamGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTeamGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamGroupMutation, DeleteTeamGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamGroupMutation, DeleteTeamGroupMutationVariables>(DeleteTeamGroupDocument, options);
      }
export type DeleteTeamGroupMutationHookResult = ReturnType<typeof useDeleteTeamGroupMutation>;
export type DeleteTeamGroupMutationResult = Apollo.MutationResult<DeleteTeamGroupMutation>;
export type DeleteTeamGroupMutationOptions = Apollo.BaseMutationOptions<DeleteTeamGroupMutation, DeleteTeamGroupMutationVariables>;
export const RequestTeamInvitationDocument = gql`
    mutation RequestTeamInvitation($input: SportsTeamInvitationRequestInput!) {
  requestTeamInvitation(input: $input) {
    id
    team {
      id
      code
      name
    }
    user {
      id
    }
  }
}
    `;
export type RequestTeamInvitationMutationFn = Apollo.MutationFunction<RequestTeamInvitationMutation, RequestTeamInvitationMutationVariables>;

/**
 * __useRequestTeamInvitationMutation__
 *
 * To run a mutation, you first call `useRequestTeamInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTeamInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTeamInvitationMutation, { data, loading, error }] = useRequestTeamInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestTeamInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RequestTeamInvitationMutation, RequestTeamInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestTeamInvitationMutation, RequestTeamInvitationMutationVariables>(RequestTeamInvitationDocument, options);
      }
export type RequestTeamInvitationMutationHookResult = ReturnType<typeof useRequestTeamInvitationMutation>;
export type RequestTeamInvitationMutationResult = Apollo.MutationResult<RequestTeamInvitationMutation>;
export type RequestTeamInvitationMutationOptions = Apollo.BaseMutationOptions<RequestTeamInvitationMutation, RequestTeamInvitationMutationVariables>;
export const AcceptInvitationListDocument = gql`
    mutation AcceptInvitationList($input: SportsTeamInvitationAcceptListInput!) {
  acceptInvitationList(input: $input) {
    id
  }
}
    `;
export type AcceptInvitationListMutationFn = Apollo.MutationFunction<AcceptInvitationListMutation, AcceptInvitationListMutationVariables>;

/**
 * __useAcceptInvitationListMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationListMutation, { data, loading, error }] = useAcceptInvitationListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptInvitationListMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInvitationListMutation, AcceptInvitationListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInvitationListMutation, AcceptInvitationListMutationVariables>(AcceptInvitationListDocument, options);
      }
export type AcceptInvitationListMutationHookResult = ReturnType<typeof useAcceptInvitationListMutation>;
export type AcceptInvitationListMutationResult = Apollo.MutationResult<AcceptInvitationListMutation>;
export type AcceptInvitationListMutationOptions = Apollo.BaseMutationOptions<AcceptInvitationListMutation, AcceptInvitationListMutationVariables>;
export const RejectTeamInvitationListDocument = gql`
    mutation RejectTeamInvitationList($input: SportsTeamInvitationRejectListInput!) {
  rejectTeamInvitationList(input: $input) {
    id
  }
}
    `;
export type RejectTeamInvitationListMutationFn = Apollo.MutationFunction<RejectTeamInvitationListMutation, RejectTeamInvitationListMutationVariables>;

/**
 * __useRejectTeamInvitationListMutation__
 *
 * To run a mutation, you first call `useRejectTeamInvitationListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectTeamInvitationListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectTeamInvitationListMutation, { data, loading, error }] = useRejectTeamInvitationListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectTeamInvitationListMutation(baseOptions?: Apollo.MutationHookOptions<RejectTeamInvitationListMutation, RejectTeamInvitationListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectTeamInvitationListMutation, RejectTeamInvitationListMutationVariables>(RejectTeamInvitationListDocument, options);
      }
export type RejectTeamInvitationListMutationHookResult = ReturnType<typeof useRejectTeamInvitationListMutation>;
export type RejectTeamInvitationListMutationResult = Apollo.MutationResult<RejectTeamInvitationListMutation>;
export type RejectTeamInvitationListMutationOptions = Apollo.BaseMutationOptions<RejectTeamInvitationListMutation, RejectTeamInvitationListMutationVariables>;
export const ToggleTeamUserStarStatusDocument = gql`
    mutation ToggleTeamUserStarStatus($input: ToggleTeamUserStarredInput!) {
  toggleTeamUserStarStatus(input: $input) {
    status
  }
}
    `;
export type ToggleTeamUserStarStatusMutationFn = Apollo.MutationFunction<ToggleTeamUserStarStatusMutation, ToggleTeamUserStarStatusMutationVariables>;

/**
 * __useToggleTeamUserStarStatusMutation__
 *
 * To run a mutation, you first call `useToggleTeamUserStarStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTeamUserStarStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTeamUserStarStatusMutation, { data, loading, error }] = useToggleTeamUserStarStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleTeamUserStarStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleTeamUserStarStatusMutation, ToggleTeamUserStarStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleTeamUserStarStatusMutation, ToggleTeamUserStarStatusMutationVariables>(ToggleTeamUserStarStatusDocument, options);
      }
export type ToggleTeamUserStarStatusMutationHookResult = ReturnType<typeof useToggleTeamUserStarStatusMutation>;
export type ToggleTeamUserStarStatusMutationResult = Apollo.MutationResult<ToggleTeamUserStarStatusMutation>;
export type ToggleTeamUserStarStatusMutationOptions = Apollo.BaseMutationOptions<ToggleTeamUserStarStatusMutation, ToggleTeamUserStarStatusMutationVariables>;
export const UploadProfileDocument = gql`
    mutation UploadProfile($file: Upload!) {
  uploadProfile(file: $file) {
    user {
      id
    }
  }
}
    `;
export type UploadProfileMutationFn = Apollo.MutationFunction<UploadProfileMutation, UploadProfileMutationVariables>;

/**
 * __useUploadProfileMutation__
 *
 * To run a mutation, you first call `useUploadProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProfileMutation, { data, loading, error }] = useUploadProfileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadProfileMutation(baseOptions?: Apollo.MutationHookOptions<UploadProfileMutation, UploadProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProfileMutation, UploadProfileMutationVariables>(UploadProfileDocument, options);
      }
export type UploadProfileMutationHookResult = ReturnType<typeof useUploadProfileMutation>;
export type UploadProfileMutationResult = Apollo.MutationResult<UploadProfileMutation>;
export type UploadProfileMutationOptions = Apollo.BaseMutationOptions<UploadProfileMutation, UploadProfileMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateSportsUserInput!) {
  updateUser(input: $input) {
    ...FSportsUser
  }
}
    ${FSportsUserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const AnalyticsViewerDocument = gql`
    query AnalyticsViewer {
  sports {
    viewer {
      ...AnalyticsViewer
    }
  }
}
    ${AnalyticsViewerFragmentDoc}`;

/**
 * __useAnalyticsViewerQuery__
 *
 * To run a query within a React component, call `useAnalyticsViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsViewerQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsViewerQuery, AnalyticsViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsViewerQuery, AnalyticsViewerQueryVariables>(AnalyticsViewerDocument, options);
      }
export function useAnalyticsViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsViewerQuery, AnalyticsViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsViewerQuery, AnalyticsViewerQueryVariables>(AnalyticsViewerDocument, options);
        }
export type AnalyticsViewerQueryHookResult = ReturnType<typeof useAnalyticsViewerQuery>;
export type AnalyticsViewerLazyQueryHookResult = ReturnType<typeof useAnalyticsViewerLazyQuery>;
export type AnalyticsViewerQueryResult = Apollo.QueryResult<AnalyticsViewerQuery, AnalyticsViewerQueryVariables>;
export function refetchAnalyticsViewerQuery(variables?: AnalyticsViewerQueryVariables) {
      return { query: AnalyticsViewerDocument, variables: variables }
    }
export const InvoiceBillingDocument = gql`
    query InvoiceBilling($identityToken: ID!) {
  billing(identityToken: $identityToken) {
    id
    ...InvoiceBillingItem
  }
}
    ${InvoiceBillingItemFragmentDoc}`;

/**
 * __useInvoiceBillingQuery__
 *
 * To run a query within a React component, call `useInvoiceBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceBillingQuery({
 *   variables: {
 *      identityToken: // value for 'identityToken'
 *   },
 * });
 */
export function useInvoiceBillingQuery(baseOptions: Apollo.QueryHookOptions<InvoiceBillingQuery, InvoiceBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceBillingQuery, InvoiceBillingQueryVariables>(InvoiceBillingDocument, options);
      }
export function useInvoiceBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceBillingQuery, InvoiceBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceBillingQuery, InvoiceBillingQueryVariables>(InvoiceBillingDocument, options);
        }
export type InvoiceBillingQueryHookResult = ReturnType<typeof useInvoiceBillingQuery>;
export type InvoiceBillingLazyQueryHookResult = ReturnType<typeof useInvoiceBillingLazyQuery>;
export type InvoiceBillingQueryResult = Apollo.QueryResult<InvoiceBillingQuery, InvoiceBillingQueryVariables>;
export function refetchInvoiceBillingQuery(variables?: InvoiceBillingQueryVariables) {
      return { query: InvoiceBillingDocument, variables: variables }
    }
export const MultilingualDataDocument = gql`
    query MultilingualData($input: MultilingualTextInput!) {
  multilingualText(input: $input) {
    categoryGroupList {
      id
      value
      categoryList {
        id
        value
        coachPositionList {
          id
          value
        }
        id
        value
        playerPositionList {
          id
          value
        }
      }
    }
    countryList {
      id
      value
    }
  }
}
    `;

/**
 * __useMultilingualDataQuery__
 *
 * To run a query within a React component, call `useMultilingualDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultilingualDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultilingualDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMultilingualDataQuery(baseOptions: Apollo.QueryHookOptions<MultilingualDataQuery, MultilingualDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MultilingualDataQuery, MultilingualDataQueryVariables>(MultilingualDataDocument, options);
      }
export function useMultilingualDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MultilingualDataQuery, MultilingualDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MultilingualDataQuery, MultilingualDataQueryVariables>(MultilingualDataDocument, options);
        }
export type MultilingualDataQueryHookResult = ReturnType<typeof useMultilingualDataQuery>;
export type MultilingualDataLazyQueryHookResult = ReturnType<typeof useMultilingualDataLazyQuery>;
export type MultilingualDataQueryResult = Apollo.QueryResult<MultilingualDataQuery, MultilingualDataQueryVariables>;
export function refetchMultilingualDataQuery(variables?: MultilingualDataQueryVariables) {
      return { query: MultilingualDataDocument, variables: variables }
    }
export const TeamPlanListDocument = gql`
    query TeamPlanList($couponId: String) {
  teamPlanList(couponId: $couponId) {
    id
    planName
    planType
    limitCount
    discountStartAt
    discountEndAt
    originalPriceStartAt
    planOptionInfoList {
      ...PlanOptionInfo
    }
  }
}
    ${PlanOptionInfoFragmentDoc}`;

/**
 * __useTeamPlanListQuery__
 *
 * To run a query within a React component, call `useTeamPlanListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPlanListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPlanListQuery({
 *   variables: {
 *      couponId: // value for 'couponId'
 *   },
 * });
 */
export function useTeamPlanListQuery(baseOptions?: Apollo.QueryHookOptions<TeamPlanListQuery, TeamPlanListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamPlanListQuery, TeamPlanListQueryVariables>(TeamPlanListDocument, options);
      }
export function useTeamPlanListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamPlanListQuery, TeamPlanListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamPlanListQuery, TeamPlanListQueryVariables>(TeamPlanListDocument, options);
        }
export type TeamPlanListQueryHookResult = ReturnType<typeof useTeamPlanListQuery>;
export type TeamPlanListLazyQueryHookResult = ReturnType<typeof useTeamPlanListLazyQuery>;
export type TeamPlanListQueryResult = Apollo.QueryResult<TeamPlanListQuery, TeamPlanListQueryVariables>;
export function refetchTeamPlanListQuery(variables?: TeamPlanListQueryVariables) {
      return { query: TeamPlanListDocument, variables: variables }
    }
export const PlayerInjuryDocument = gql`
    query PlayerInjury($playerId: ID!, $from: DateTime!, $to: DateTime!, $timezone: String!, $input: MultilingualTextInput!) {
  sports {
    user(id: $playerId) {
      id
      ...PlayerSummaryIdentity
      data(
        from: $from
        to: $to
        timezone: $timezone
        stride: DAY
        names: [INJURY, SORENESS]
      ) {
        name
        ranges(input: $input) {
          entries {
            time
            value
          }
        }
      }
    }
  }
}
    ${PlayerSummaryIdentityFragmentDoc}`;

/**
 * __usePlayerInjuryQuery__
 *
 * To run a query within a React component, call `usePlayerInjuryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerInjuryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerInjuryQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlayerInjuryQuery(baseOptions: Apollo.QueryHookOptions<PlayerInjuryQuery, PlayerInjuryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerInjuryQuery, PlayerInjuryQueryVariables>(PlayerInjuryDocument, options);
      }
export function usePlayerInjuryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerInjuryQuery, PlayerInjuryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerInjuryQuery, PlayerInjuryQueryVariables>(PlayerInjuryDocument, options);
        }
export type PlayerInjuryQueryHookResult = ReturnType<typeof usePlayerInjuryQuery>;
export type PlayerInjuryLazyQueryHookResult = ReturnType<typeof usePlayerInjuryLazyQuery>;
export type PlayerInjuryQueryResult = Apollo.QueryResult<PlayerInjuryQuery, PlayerInjuryQueryVariables>;
export function refetchPlayerInjuryQuery(variables?: PlayerInjuryQueryVariables) {
      return { query: PlayerInjuryDocument, variables: variables }
    }
export const PlayerSelectAllUserMapsByGroupDocument = gql`
    query PlayerSelectAllUserMapsByGroup($id: ID!) {
  sports {
    team(id: $id) {
      id
      memberUserList {
        count
        userList {
          id
          name
          pictureUrl
          nationality
        }
      }
    }
  }
}
    `;

/**
 * __usePlayerSelectAllUserMapsByGroupQuery__
 *
 * To run a query within a React component, call `usePlayerSelectAllUserMapsByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerSelectAllUserMapsByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerSelectAllUserMapsByGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlayerSelectAllUserMapsByGroupQuery(baseOptions: Apollo.QueryHookOptions<PlayerSelectAllUserMapsByGroupQuery, PlayerSelectAllUserMapsByGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerSelectAllUserMapsByGroupQuery, PlayerSelectAllUserMapsByGroupQueryVariables>(PlayerSelectAllUserMapsByGroupDocument, options);
      }
export function usePlayerSelectAllUserMapsByGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerSelectAllUserMapsByGroupQuery, PlayerSelectAllUserMapsByGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerSelectAllUserMapsByGroupQuery, PlayerSelectAllUserMapsByGroupQueryVariables>(PlayerSelectAllUserMapsByGroupDocument, options);
        }
export type PlayerSelectAllUserMapsByGroupQueryHookResult = ReturnType<typeof usePlayerSelectAllUserMapsByGroupQuery>;
export type PlayerSelectAllUserMapsByGroupLazyQueryHookResult = ReturnType<typeof usePlayerSelectAllUserMapsByGroupLazyQuery>;
export type PlayerSelectAllUserMapsByGroupQueryResult = Apollo.QueryResult<PlayerSelectAllUserMapsByGroupQuery, PlayerSelectAllUserMapsByGroupQueryVariables>;
export function refetchPlayerSelectAllUserMapsByGroupQuery(variables?: PlayerSelectAllUserMapsByGroupQueryVariables) {
      return { query: PlayerSelectAllUserMapsByGroupDocument, variables: variables }
    }
export const GroupsMemberMapByTeamDocument = gql`
    query GroupsMemberMapByTeam($id: ID!) {
  sports {
    team(id: $id) {
      id
      groupList {
        ...FTeamGroup
        groupMemberList {
          user {
            ...FSportsUser
          }
        }
      }
    }
  }
}
    ${FTeamGroupFragmentDoc}
${FSportsUserFragmentDoc}`;

/**
 * __useGroupsMemberMapByTeamQuery__
 *
 * To run a query within a React component, call `useGroupsMemberMapByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsMemberMapByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsMemberMapByTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupsMemberMapByTeamQuery(baseOptions: Apollo.QueryHookOptions<GroupsMemberMapByTeamQuery, GroupsMemberMapByTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsMemberMapByTeamQuery, GroupsMemberMapByTeamQueryVariables>(GroupsMemberMapByTeamDocument, options);
      }
export function useGroupsMemberMapByTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsMemberMapByTeamQuery, GroupsMemberMapByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsMemberMapByTeamQuery, GroupsMemberMapByTeamQueryVariables>(GroupsMemberMapByTeamDocument, options);
        }
export type GroupsMemberMapByTeamQueryHookResult = ReturnType<typeof useGroupsMemberMapByTeamQuery>;
export type GroupsMemberMapByTeamLazyQueryHookResult = ReturnType<typeof useGroupsMemberMapByTeamLazyQuery>;
export type GroupsMemberMapByTeamQueryResult = Apollo.QueryResult<GroupsMemberMapByTeamQuery, GroupsMemberMapByTeamQueryVariables>;
export function refetchGroupsMemberMapByTeamQuery(variables?: GroupsMemberMapByTeamQueryVariables) {
      return { query: GroupsMemberMapByTeamDocument, variables: variables }
    }
export const ViewerDocument = gql`
    query Viewer {
  sports {
    viewer {
      id
      ...FSportsUser
      guideReopenStatus {
        alarm {
          web
        }
      }
      teamMaps {
        ...FSportsTeamUserMap
      }
    }
  }
}
    ${FSportsUserFragmentDoc}
${FSportsTeamUserMapFragmentDoc}`;

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerQuery(baseOptions?: Apollo.QueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
      }
export function useViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerQueryResult = Apollo.QueryResult<ViewerQuery, ViewerQueryVariables>;
export function refetchViewerQuery(variables?: ViewerQueryVariables) {
      return { query: ViewerDocument, variables: variables }
    }
export const QuerySystemUserDataDocument = gql`
    query QuerySystemUserData($id: ID!, $from: DateTime!, $to: DateTime!, $groups: [SportsDataGroup!], $names: [SportsDataName!], $timezone: String!, $input: MultilingualTextInput!) {
  sports {
    user(id: $id) {
      id
      name
      pictureUrl
      data(
        from: $from
        to: $to
        stride: DAY
        groups: $groups
        names: $names
        timezone: $timezone
      ) {
        name
        ranges(input: $input) {
          from
          entries {
            value
            time
          }
        }
      }
      workload(from: $from, to: $to) {
        time
        count
        reasonForNoWorkout
        workload {
          sum
        }
        duration {
          sum
        }
        intensity {
          avg
        }
        satisfaction {
          avg
        }
        workloadList {
          id
          name
          time
          load
          duration
          intensity
          satisfaction
          type
          event {
            event {
              id
              title
              hideExpectedIntensityFromPlayers
              startAt
              endAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuerySystemUserDataQuery__
 *
 * To run a query within a React component, call `useQuerySystemUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuerySystemUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuerySystemUserDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      groups: // value for 'groups'
 *      names: // value for 'names'
 *      timezone: // value for 'timezone'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuerySystemUserDataQuery(baseOptions: Apollo.QueryHookOptions<QuerySystemUserDataQuery, QuerySystemUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuerySystemUserDataQuery, QuerySystemUserDataQueryVariables>(QuerySystemUserDataDocument, options);
      }
export function useQuerySystemUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuerySystemUserDataQuery, QuerySystemUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuerySystemUserDataQuery, QuerySystemUserDataQueryVariables>(QuerySystemUserDataDocument, options);
        }
export type QuerySystemUserDataQueryHookResult = ReturnType<typeof useQuerySystemUserDataQuery>;
export type QuerySystemUserDataLazyQueryHookResult = ReturnType<typeof useQuerySystemUserDataLazyQuery>;
export type QuerySystemUserDataQueryResult = Apollo.QueryResult<QuerySystemUserDataQuery, QuerySystemUserDataQueryVariables>;
export function refetchQuerySystemUserDataQuery(variables?: QuerySystemUserDataQueryVariables) {
      return { query: QuerySystemUserDataDocument, variables: variables }
    }
export const QuerySystemUserWorkloadDataDocument = gql`
    query QuerySystemUserWorkloadData($id: ID!, $from: DateTime!, $to: DateTime!, $timezone: String!, $teamId: ID) {
  sports {
    user(id: $id) {
      id
      name
      pictureUrl
      sportsDataList(from: $from, to: $to, timezone: $timezone) {
        id
        date
        workload {
          count
          reasonForNoWorkout
          isChecked
          workload {
            sum
          }
          duration {
            sum
          }
          intensity {
            avg
          }
          satisfaction {
            avg
          }
          workloadList {
            id
            time
            load
            duration
            intensity
            satisfaction
            type
            schedule {
              id
              schedule(teamId: $teamId) {
                id
                title
                startTime
                endTime
                team {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuerySystemUserWorkloadDataQuery__
 *
 * To run a query within a React component, call `useQuerySystemUserWorkloadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuerySystemUserWorkloadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuerySystemUserWorkloadDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useQuerySystemUserWorkloadDataQuery(baseOptions: Apollo.QueryHookOptions<QuerySystemUserWorkloadDataQuery, QuerySystemUserWorkloadDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuerySystemUserWorkloadDataQuery, QuerySystemUserWorkloadDataQueryVariables>(QuerySystemUserWorkloadDataDocument, options);
      }
export function useQuerySystemUserWorkloadDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuerySystemUserWorkloadDataQuery, QuerySystemUserWorkloadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuerySystemUserWorkloadDataQuery, QuerySystemUserWorkloadDataQueryVariables>(QuerySystemUserWorkloadDataDocument, options);
        }
export type QuerySystemUserWorkloadDataQueryHookResult = ReturnType<typeof useQuerySystemUserWorkloadDataQuery>;
export type QuerySystemUserWorkloadDataLazyQueryHookResult = ReturnType<typeof useQuerySystemUserWorkloadDataLazyQuery>;
export type QuerySystemUserWorkloadDataQueryResult = Apollo.QueryResult<QuerySystemUserWorkloadDataQuery, QuerySystemUserWorkloadDataQueryVariables>;
export function refetchQuerySystemUserWorkloadDataQuery(variables?: QuerySystemUserWorkloadDataQueryVariables) {
      return { query: QuerySystemUserWorkloadDataDocument, variables: variables }
    }
export const QuerySystemTeamUserMapsDataDocument = gql`
    query QuerySystemTeamUserMapsData($id: ID!, $cursor: DateTime!, $offset: Int, $limit: Int, $timezone: String!, $groups: [SportsDataGroup!], $names: [SportsDataName!], $filter: TeamUserMapFilterInput, $order: UserDataOrderByInput, $input: MultilingualTextInput!) {
  sports {
    team(id: $id) {
      id
      userMapsByPage(limit: $limit, offset: $offset, filter: $filter, order: $order) {
        offset
        limit
        total
        hasPrev
        hasNext
        entries {
          id
          teamAuthority
          user {
            id
            name
            pictureUrl
            data(
              from: $cursor
              to: $cursor
              stride: DAY
              groups: $groups
              names: $names
              timezone: $timezone
            ) {
              name
              stride
              ranges(input: $input) {
                from
                entries {
                  time
                  value
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuerySystemTeamUserMapsDataQuery__
 *
 * To run a query within a React component, call `useQuerySystemTeamUserMapsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuerySystemTeamUserMapsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuerySystemTeamUserMapsDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cursor: // value for 'cursor'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      timezone: // value for 'timezone'
 *      groups: // value for 'groups'
 *      names: // value for 'names'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuerySystemTeamUserMapsDataQuery(baseOptions: Apollo.QueryHookOptions<QuerySystemTeamUserMapsDataQuery, QuerySystemTeamUserMapsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuerySystemTeamUserMapsDataQuery, QuerySystemTeamUserMapsDataQueryVariables>(QuerySystemTeamUserMapsDataDocument, options);
      }
export function useQuerySystemTeamUserMapsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuerySystemTeamUserMapsDataQuery, QuerySystemTeamUserMapsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuerySystemTeamUserMapsDataQuery, QuerySystemTeamUserMapsDataQueryVariables>(QuerySystemTeamUserMapsDataDocument, options);
        }
export type QuerySystemTeamUserMapsDataQueryHookResult = ReturnType<typeof useQuerySystemTeamUserMapsDataQuery>;
export type QuerySystemTeamUserMapsDataLazyQueryHookResult = ReturnType<typeof useQuerySystemTeamUserMapsDataLazyQuery>;
export type QuerySystemTeamUserMapsDataQueryResult = Apollo.QueryResult<QuerySystemTeamUserMapsDataQuery, QuerySystemTeamUserMapsDataQueryVariables>;
export function refetchQuerySystemTeamUserMapsDataQuery(variables?: QuerySystemTeamUserMapsDataQueryVariables) {
      return { query: QuerySystemTeamUserMapsDataDocument, variables: variables }
    }
export const QuerySystemTeamAverageDataDocument = gql`
    query QuerySystemTeamAverageData($id: ID!, $from: DateTime!, $to: DateTime!, $timezone: String!, $names: [SportsTeamDataName!]!, $filter: TeamUserMapForTeamDataFilterInput) {
  sports {
    team(id: $id) {
      id
      data(from: $from, to: $to, timezone: $timezone, names: $names, filter: $filter) {
        stride
        name
        ranges {
          from
          to
          entries {
            time
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuerySystemTeamAverageDataQuery__
 *
 * To run a query within a React component, call `useQuerySystemTeamAverageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuerySystemTeamAverageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuerySystemTeamAverageDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *      names: // value for 'names'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQuerySystemTeamAverageDataQuery(baseOptions: Apollo.QueryHookOptions<QuerySystemTeamAverageDataQuery, QuerySystemTeamAverageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuerySystemTeamAverageDataQuery, QuerySystemTeamAverageDataQueryVariables>(QuerySystemTeamAverageDataDocument, options);
      }
export function useQuerySystemTeamAverageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuerySystemTeamAverageDataQuery, QuerySystemTeamAverageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuerySystemTeamAverageDataQuery, QuerySystemTeamAverageDataQueryVariables>(QuerySystemTeamAverageDataDocument, options);
        }
export type QuerySystemTeamAverageDataQueryHookResult = ReturnType<typeof useQuerySystemTeamAverageDataQuery>;
export type QuerySystemTeamAverageDataLazyQueryHookResult = ReturnType<typeof useQuerySystemTeamAverageDataLazyQuery>;
export type QuerySystemTeamAverageDataQueryResult = Apollo.QueryResult<QuerySystemTeamAverageDataQuery, QuerySystemTeamAverageDataQueryVariables>;
export function refetchQuerySystemTeamAverageDataQuery(variables?: QuerySystemTeamAverageDataQueryVariables) {
      return { query: QuerySystemTeamAverageDataDocument, variables: variables }
    }
export const PlanBillingTeamSubscriptionDocument = gql`
    query PlanBillingTeamSubscription($teamId: ID!, $limit: Int, $offset: Int) {
  teamSubscriptionItem(teamId: $teamId) {
    ...PlanBillingTeamSubscription
  }
}
    ${PlanBillingTeamSubscriptionFragmentDoc}`;

/**
 * __usePlanBillingTeamSubscriptionQuery__
 *
 * To run a query within a React component, call `usePlanBillingTeamSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanBillingTeamSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanBillingTeamSubscriptionQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function usePlanBillingTeamSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<PlanBillingTeamSubscriptionQuery, PlanBillingTeamSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanBillingTeamSubscriptionQuery, PlanBillingTeamSubscriptionQueryVariables>(PlanBillingTeamSubscriptionDocument, options);
      }
export function usePlanBillingTeamSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanBillingTeamSubscriptionQuery, PlanBillingTeamSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanBillingTeamSubscriptionQuery, PlanBillingTeamSubscriptionQueryVariables>(PlanBillingTeamSubscriptionDocument, options);
        }
export type PlanBillingTeamSubscriptionQueryHookResult = ReturnType<typeof usePlanBillingTeamSubscriptionQuery>;
export type PlanBillingTeamSubscriptionLazyQueryHookResult = ReturnType<typeof usePlanBillingTeamSubscriptionLazyQuery>;
export type PlanBillingTeamSubscriptionQueryResult = Apollo.QueryResult<PlanBillingTeamSubscriptionQuery, PlanBillingTeamSubscriptionQueryVariables>;
export function refetchPlanBillingTeamSubscriptionQuery(variables?: PlanBillingTeamSubscriptionQueryVariables) {
      return { query: PlanBillingTeamSubscriptionDocument, variables: variables }
    }
export const PlanBillingBillingDocument = gql`
    query PlanBillingBilling($identityToken: ID!) {
  billing(identityToken: $identityToken) {
    id
    identityToken
    customerUid
    cardName
    cardNumber
    buyerName
    buyerTel
    buyerEmail
  }
}
    `;

/**
 * __usePlanBillingBillingQuery__
 *
 * To run a query within a React component, call `usePlanBillingBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanBillingBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanBillingBillingQuery({
 *   variables: {
 *      identityToken: // value for 'identityToken'
 *   },
 * });
 */
export function usePlanBillingBillingQuery(baseOptions: Apollo.QueryHookOptions<PlanBillingBillingQuery, PlanBillingBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanBillingBillingQuery, PlanBillingBillingQueryVariables>(PlanBillingBillingDocument, options);
      }
export function usePlanBillingBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanBillingBillingQuery, PlanBillingBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanBillingBillingQuery, PlanBillingBillingQueryVariables>(PlanBillingBillingDocument, options);
        }
export type PlanBillingBillingQueryHookResult = ReturnType<typeof usePlanBillingBillingQuery>;
export type PlanBillingBillingLazyQueryHookResult = ReturnType<typeof usePlanBillingBillingLazyQuery>;
export type PlanBillingBillingQueryResult = Apollo.QueryResult<PlanBillingBillingQuery, PlanBillingBillingQueryVariables>;
export function refetchPlanBillingBillingQuery(variables?: PlanBillingBillingQueryVariables) {
      return { query: PlanBillingBillingDocument, variables: variables }
    }
export const PlanBillingInvoicesByPageDocument = gql`
    query PlanBillingInvoicesByPage($subscriptionId: ID!, $offset: Int, $limit: Int) {
  invoicesByPage(subscriptionId: $subscriptionId, offset: $offset, limit: $limit) {
    offset
    limit
    total
    hasNext
    hasPrev
    invoiceList {
      ...PlanBillingPayInvoiceInfo
      ... on RefundInvoice {
        id
        refundAt
        paymentName
        paymentStatus
        refundAmount
        cardName
        cardNumber
        receiptUrl
      }
    }
  }
}
    ${PlanBillingPayInvoiceInfoFragmentDoc}`;

/**
 * __usePlanBillingInvoicesByPageQuery__
 *
 * To run a query within a React component, call `usePlanBillingInvoicesByPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanBillingInvoicesByPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanBillingInvoicesByPageQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePlanBillingInvoicesByPageQuery(baseOptions: Apollo.QueryHookOptions<PlanBillingInvoicesByPageQuery, PlanBillingInvoicesByPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanBillingInvoicesByPageQuery, PlanBillingInvoicesByPageQueryVariables>(PlanBillingInvoicesByPageDocument, options);
      }
export function usePlanBillingInvoicesByPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanBillingInvoicesByPageQuery, PlanBillingInvoicesByPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanBillingInvoicesByPageQuery, PlanBillingInvoicesByPageQueryVariables>(PlanBillingInvoicesByPageDocument, options);
        }
export type PlanBillingInvoicesByPageQueryHookResult = ReturnType<typeof usePlanBillingInvoicesByPageQuery>;
export type PlanBillingInvoicesByPageLazyQueryHookResult = ReturnType<typeof usePlanBillingInvoicesByPageLazyQuery>;
export type PlanBillingInvoicesByPageQueryResult = Apollo.QueryResult<PlanBillingInvoicesByPageQuery, PlanBillingInvoicesByPageQueryVariables>;
export function refetchPlanBillingInvoicesByPageQuery(variables?: PlanBillingInvoicesByPageQueryVariables) {
      return { query: PlanBillingInvoicesByPageDocument, variables: variables }
    }
export const PlanBillingLicenseDocument = gql`
    query PlanBillingLicense($teamId: ID!) {
  sports {
    team(id: $teamId) {
      id
      license {
        id
        startAt
        endAt
        licenseName
        teamVolume
        teamIdList
      }
    }
  }
}
    `;

/**
 * __usePlanBillingLicenseQuery__
 *
 * To run a query within a React component, call `usePlanBillingLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanBillingLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanBillingLicenseQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function usePlanBillingLicenseQuery(baseOptions: Apollo.QueryHookOptions<PlanBillingLicenseQuery, PlanBillingLicenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanBillingLicenseQuery, PlanBillingLicenseQueryVariables>(PlanBillingLicenseDocument, options);
      }
export function usePlanBillingLicenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanBillingLicenseQuery, PlanBillingLicenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanBillingLicenseQuery, PlanBillingLicenseQueryVariables>(PlanBillingLicenseDocument, options);
        }
export type PlanBillingLicenseQueryHookResult = ReturnType<typeof usePlanBillingLicenseQuery>;
export type PlanBillingLicenseLazyQueryHookResult = ReturnType<typeof usePlanBillingLicenseLazyQuery>;
export type PlanBillingLicenseQueryResult = Apollo.QueryResult<PlanBillingLicenseQuery, PlanBillingLicenseQueryVariables>;
export function refetchPlanBillingLicenseQuery(variables?: PlanBillingLicenseQueryVariables) {
      return { query: PlanBillingLicenseDocument, variables: variables }
    }
export const PlanPayPricingBillingDocument = gql`
    query PlanPayPricingBilling($identityToken: ID!) {
  billing(identityToken: $identityToken) {
    ...PlanPayPricingBillingItem
  }
}
    ${PlanPayPricingBillingItemFragmentDoc}`;

/**
 * __usePlanPayPricingBillingQuery__
 *
 * To run a query within a React component, call `usePlanPayPricingBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPayPricingBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPayPricingBillingQuery({
 *   variables: {
 *      identityToken: // value for 'identityToken'
 *   },
 * });
 */
export function usePlanPayPricingBillingQuery(baseOptions: Apollo.QueryHookOptions<PlanPayPricingBillingQuery, PlanPayPricingBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanPayPricingBillingQuery, PlanPayPricingBillingQueryVariables>(PlanPayPricingBillingDocument, options);
      }
export function usePlanPayPricingBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanPayPricingBillingQuery, PlanPayPricingBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanPayPricingBillingQuery, PlanPayPricingBillingQueryVariables>(PlanPayPricingBillingDocument, options);
        }
export type PlanPayPricingBillingQueryHookResult = ReturnType<typeof usePlanPayPricingBillingQuery>;
export type PlanPayPricingBillingLazyQueryHookResult = ReturnType<typeof usePlanPayPricingBillingLazyQuery>;
export type PlanPayPricingBillingQueryResult = Apollo.QueryResult<PlanPayPricingBillingQuery, PlanPayPricingBillingQueryVariables>;
export function refetchPlanPayPricingBillingQuery(variables?: PlanPayPricingBillingQueryVariables) {
      return { query: PlanPayPricingBillingDocument, variables: variables }
    }
export const PlanPayPricingTeamSubscriptionDocument = gql`
    query PlanPayPricingTeamSubscription($teamId: ID!) {
  teamSubscriptionItem(teamId: $teamId) {
    ...PlanPayPricingSubscription
  }
}
    ${PlanPayPricingSubscriptionFragmentDoc}`;

/**
 * __usePlanPayPricingTeamSubscriptionQuery__
 *
 * To run a query within a React component, call `usePlanPayPricingTeamSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPayPricingTeamSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPayPricingTeamSubscriptionQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function usePlanPayPricingTeamSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<PlanPayPricingTeamSubscriptionQuery, PlanPayPricingTeamSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanPayPricingTeamSubscriptionQuery, PlanPayPricingTeamSubscriptionQueryVariables>(PlanPayPricingTeamSubscriptionDocument, options);
      }
export function usePlanPayPricingTeamSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanPayPricingTeamSubscriptionQuery, PlanPayPricingTeamSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanPayPricingTeamSubscriptionQuery, PlanPayPricingTeamSubscriptionQueryVariables>(PlanPayPricingTeamSubscriptionDocument, options);
        }
export type PlanPayPricingTeamSubscriptionQueryHookResult = ReturnType<typeof usePlanPayPricingTeamSubscriptionQuery>;
export type PlanPayPricingTeamSubscriptionLazyQueryHookResult = ReturnType<typeof usePlanPayPricingTeamSubscriptionLazyQuery>;
export type PlanPayPricingTeamSubscriptionQueryResult = Apollo.QueryResult<PlanPayPricingTeamSubscriptionQuery, PlanPayPricingTeamSubscriptionQueryVariables>;
export function refetchPlanPayPricingTeamSubscriptionQuery(variables?: PlanPayPricingTeamSubscriptionQueryVariables) {
      return { query: PlanPayPricingTeamSubscriptionDocument, variables: variables }
    }
export const PlanPayPricingTeamCouponsDocument = gql`
    query PlanPayPricingTeamCoupons($teamId: ID!) {
  couponListByTeam(teamId: $teamId) {
    content {
      couponId
      name
    }
  }
}
    `;

/**
 * __usePlanPayPricingTeamCouponsQuery__
 *
 * To run a query within a React component, call `usePlanPayPricingTeamCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPayPricingTeamCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPayPricingTeamCouponsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function usePlanPayPricingTeamCouponsQuery(baseOptions: Apollo.QueryHookOptions<PlanPayPricingTeamCouponsQuery, PlanPayPricingTeamCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanPayPricingTeamCouponsQuery, PlanPayPricingTeamCouponsQueryVariables>(PlanPayPricingTeamCouponsDocument, options);
      }
export function usePlanPayPricingTeamCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanPayPricingTeamCouponsQuery, PlanPayPricingTeamCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanPayPricingTeamCouponsQuery, PlanPayPricingTeamCouponsQueryVariables>(PlanPayPricingTeamCouponsDocument, options);
        }
export type PlanPayPricingTeamCouponsQueryHookResult = ReturnType<typeof usePlanPayPricingTeamCouponsQuery>;
export type PlanPayPricingTeamCouponsLazyQueryHookResult = ReturnType<typeof usePlanPayPricingTeamCouponsLazyQuery>;
export type PlanPayPricingTeamCouponsQueryResult = Apollo.QueryResult<PlanPayPricingTeamCouponsQuery, PlanPayPricingTeamCouponsQueryVariables>;
export function refetchPlanPayPricingTeamCouponsQuery(variables?: PlanPayPricingTeamCouponsQueryVariables) {
      return { query: PlanPayPricingTeamCouponsDocument, variables: variables }
    }
export const PlanPayPricingAppliedPriceDocument = gql`
    query PlanPayPricingAppliedPrice($input: GetCouponAppliedPriceInput!) {
  couponAppliedPrice(input: $input) {
    deductedPrice
    discountedPrice
    originalPrice
    discountInfo {
      type
      value
    }
  }
}
    `;

/**
 * __usePlanPayPricingAppliedPriceQuery__
 *
 * To run a query within a React component, call `usePlanPayPricingAppliedPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPayPricingAppliedPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPayPricingAppliedPriceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlanPayPricingAppliedPriceQuery(baseOptions: Apollo.QueryHookOptions<PlanPayPricingAppliedPriceQuery, PlanPayPricingAppliedPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanPayPricingAppliedPriceQuery, PlanPayPricingAppliedPriceQueryVariables>(PlanPayPricingAppliedPriceDocument, options);
      }
export function usePlanPayPricingAppliedPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanPayPricingAppliedPriceQuery, PlanPayPricingAppliedPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanPayPricingAppliedPriceQuery, PlanPayPricingAppliedPriceQueryVariables>(PlanPayPricingAppliedPriceDocument, options);
        }
export type PlanPayPricingAppliedPriceQueryHookResult = ReturnType<typeof usePlanPayPricingAppliedPriceQuery>;
export type PlanPayPricingAppliedPriceLazyQueryHookResult = ReturnType<typeof usePlanPayPricingAppliedPriceLazyQuery>;
export type PlanPayPricingAppliedPriceQueryResult = Apollo.QueryResult<PlanPayPricingAppliedPriceQuery, PlanPayPricingAppliedPriceQueryVariables>;
export function refetchPlanPayPricingAppliedPriceQuery(variables?: PlanPayPricingAppliedPriceQueryVariables) {
      return { query: PlanPayPricingAppliedPriceDocument, variables: variables }
    }
export const HighestBenefitCouponByTeamDocument = gql`
    query HighestBenefitCouponByTeam($originalPrice: Float!, $teamId: ID!) {
  highestBenefitCouponByTeam(originalPrice: $originalPrice, teamId: $teamId) {
    couponId
    endAt
    name
    remainDays
    startAt
  }
}
    `;

/**
 * __useHighestBenefitCouponByTeamQuery__
 *
 * To run a query within a React component, call `useHighestBenefitCouponByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighestBenefitCouponByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighestBenefitCouponByTeamQuery({
 *   variables: {
 *      originalPrice: // value for 'originalPrice'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useHighestBenefitCouponByTeamQuery(baseOptions: Apollo.QueryHookOptions<HighestBenefitCouponByTeamQuery, HighestBenefitCouponByTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighestBenefitCouponByTeamQuery, HighestBenefitCouponByTeamQueryVariables>(HighestBenefitCouponByTeamDocument, options);
      }
export function useHighestBenefitCouponByTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighestBenefitCouponByTeamQuery, HighestBenefitCouponByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighestBenefitCouponByTeamQuery, HighestBenefitCouponByTeamQueryVariables>(HighestBenefitCouponByTeamDocument, options);
        }
export type HighestBenefitCouponByTeamQueryHookResult = ReturnType<typeof useHighestBenefitCouponByTeamQuery>;
export type HighestBenefitCouponByTeamLazyQueryHookResult = ReturnType<typeof useHighestBenefitCouponByTeamLazyQuery>;
export type HighestBenefitCouponByTeamQueryResult = Apollo.QueryResult<HighestBenefitCouponByTeamQuery, HighestBenefitCouponByTeamQueryVariables>;
export function refetchHighestBenefitCouponByTeamQuery(variables?: HighestBenefitCouponByTeamQueryVariables) {
      return { query: HighestBenefitCouponByTeamDocument, variables: variables }
    }
export const RegisterPostionPositionsDocument = gql`
    query RegisterPostionPositions($categoryId: String!) {
  sports {
    category(id: $categoryId) {
      id
      coachPositions
    }
  }
}
    `;

/**
 * __useRegisterPostionPositionsQuery__
 *
 * To run a query within a React component, call `useRegisterPostionPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterPostionPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterPostionPositionsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useRegisterPostionPositionsQuery(baseOptions: Apollo.QueryHookOptions<RegisterPostionPositionsQuery, RegisterPostionPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegisterPostionPositionsQuery, RegisterPostionPositionsQueryVariables>(RegisterPostionPositionsDocument, options);
      }
export function useRegisterPostionPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisterPostionPositionsQuery, RegisterPostionPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegisterPostionPositionsQuery, RegisterPostionPositionsQueryVariables>(RegisterPostionPositionsDocument, options);
        }
export type RegisterPostionPositionsQueryHookResult = ReturnType<typeof useRegisterPostionPositionsQuery>;
export type RegisterPostionPositionsLazyQueryHookResult = ReturnType<typeof useRegisterPostionPositionsLazyQuery>;
export type RegisterPostionPositionsQueryResult = Apollo.QueryResult<RegisterPostionPositionsQuery, RegisterPostionPositionsQueryVariables>;
export function refetchRegisterPostionPositionsQuery(variables?: RegisterPostionPositionsQueryVariables) {
      return { query: RegisterPostionPositionsDocument, variables: variables }
    }
export const UploadUserProfileImageDocument = gql`
    mutation UploadUserProfileImage($file: Upload!) {
  uploadProfile(file: $file) {
    user {
      id
      pictureFileId
    }
  }
}
    `;
export type UploadUserProfileImageMutationFn = Apollo.MutationFunction<UploadUserProfileImageMutation, UploadUserProfileImageMutationVariables>;

/**
 * __useUploadUserProfileImageMutation__
 *
 * To run a mutation, you first call `useUploadUserProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadUserProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadUserProfileImageMutation, { data, loading, error }] = useUploadUserProfileImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadUserProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadUserProfileImageMutation, UploadUserProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadUserProfileImageMutation, UploadUserProfileImageMutationVariables>(UploadUserProfileImageDocument, options);
      }
export type UploadUserProfileImageMutationHookResult = ReturnType<typeof useUploadUserProfileImageMutation>;
export type UploadUserProfileImageMutationResult = Apollo.MutationResult<UploadUserProfileImageMutation>;
export type UploadUserProfileImageMutationOptions = Apollo.BaseMutationOptions<UploadUserProfileImageMutation, UploadUserProfileImageMutationVariables>;
export const NavigationViewerDocument = gql`
    query NavigationViewer {
  sports {
    viewer {
      id
      ...FSportsUser
      teamMaps {
        ...FSportsTeamUserMap
      }
      guideReopenStatus {
        alarm {
          web
        }
      }
    }
  }
}
    ${FSportsUserFragmentDoc}
${FSportsTeamUserMapFragmentDoc}`;

/**
 * __useNavigationViewerQuery__
 *
 * To run a query within a React component, call `useNavigationViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavigationViewerQuery(baseOptions?: Apollo.QueryHookOptions<NavigationViewerQuery, NavigationViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationViewerQuery, NavigationViewerQueryVariables>(NavigationViewerDocument, options);
      }
export function useNavigationViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationViewerQuery, NavigationViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationViewerQuery, NavigationViewerQueryVariables>(NavigationViewerDocument, options);
        }
export type NavigationViewerQueryHookResult = ReturnType<typeof useNavigationViewerQuery>;
export type NavigationViewerLazyQueryHookResult = ReturnType<typeof useNavigationViewerLazyQuery>;
export type NavigationViewerQueryResult = Apollo.QueryResult<NavigationViewerQuery, NavigationViewerQueryVariables>;
export function refetchNavigationViewerQuery(variables?: NavigationViewerQueryVariables) {
      return { query: NavigationViewerDocument, variables: variables }
    }
export const NavigationByPlanDocument = gql`
    query NavigationByPlan($teamId: ID!, $includeSubscription: Boolean = false, $includeLicense: Boolean = false) {
  teamSubscriptionItem(teamId: $teamId) @include(if: $includeSubscription) {
    ...NavigationTeamSubscription
  }
  licenseByTeam(teamId: $teamId) @include(if: $includeLicense) {
    ...NavigationTeamLicense
  }
}
    ${NavigationTeamSubscriptionFragmentDoc}
${NavigationTeamLicenseFragmentDoc}`;

/**
 * __useNavigationByPlanQuery__
 *
 * To run a query within a React component, call `useNavigationByPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationByPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationByPlanQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      includeSubscription: // value for 'includeSubscription'
 *      includeLicense: // value for 'includeLicense'
 *   },
 * });
 */
export function useNavigationByPlanQuery(baseOptions: Apollo.QueryHookOptions<NavigationByPlanQuery, NavigationByPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationByPlanQuery, NavigationByPlanQueryVariables>(NavigationByPlanDocument, options);
      }
export function useNavigationByPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationByPlanQuery, NavigationByPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationByPlanQuery, NavigationByPlanQueryVariables>(NavigationByPlanDocument, options);
        }
export type NavigationByPlanQueryHookResult = ReturnType<typeof useNavigationByPlanQuery>;
export type NavigationByPlanLazyQueryHookResult = ReturnType<typeof useNavigationByPlanLazyQuery>;
export type NavigationByPlanQueryResult = Apollo.QueryResult<NavigationByPlanQuery, NavigationByPlanQueryVariables>;
export function refetchNavigationByPlanQuery(variables?: NavigationByPlanQueryVariables) {
      return { query: NavigationByPlanDocument, variables: variables }
    }
export const NavigationQualificationDocument = gql`
    query NavigationQualification($teamId: ID!) {
  qualification(teamId: $teamId) {
    id
    qualificationType
    isExpired
  }
}
    `;

/**
 * __useNavigationQualificationQuery__
 *
 * To run a query within a React component, call `useNavigationQualificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationQualificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationQualificationQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useNavigationQualificationQuery(baseOptions: Apollo.QueryHookOptions<NavigationQualificationQuery, NavigationQualificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationQualificationQuery, NavigationQualificationQueryVariables>(NavigationQualificationDocument, options);
      }
export function useNavigationQualificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationQualificationQuery, NavigationQualificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationQualificationQuery, NavigationQualificationQueryVariables>(NavigationQualificationDocument, options);
        }
export type NavigationQualificationQueryHookResult = ReturnType<typeof useNavigationQualificationQuery>;
export type NavigationQualificationLazyQueryHookResult = ReturnType<typeof useNavigationQualificationLazyQuery>;
export type NavigationQualificationQueryResult = Apollo.QueryResult<NavigationQualificationQuery, NavigationQualificationQueryVariables>;
export function refetchNavigationQualificationQuery(variables?: NavigationQualificationQueryVariables) {
      return { query: NavigationQualificationDocument, variables: variables }
    }
export type CardDiscountDetailsCouponContentsQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type CardDiscountDetailsCouponContentsQuery = (
  { __typename: 'Query' }
  & { couponListByTeam: (
    { __typename: 'CouponListByTeam' }
    & { content?: Maybe<Array<(
      { __typename: 'CouponSimple' }
      & Pick<CouponSimple, 'couponId' | 'name'>
    )>> }
  ) }
);

export type InvitationRequestBadgeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type InvitationRequestBadgeRequestsQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { viewer?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id'>
      & { teamMaps: Array<(
        { __typename: 'SportsTeamUserMap' }
        & Pick<SportsTeamUserMap, 'id'>
        & { team: (
          { __typename: 'SportsTeam' }
          & Pick<SportsTeam, 'id'>
          & { pendingInvitationRequestList: Array<(
            { __typename: 'TeamInvitationRequest' }
            & Pick<TeamInvitationRequest, 'id' | 'status'>
          )> }
        ) }
      )> }
    )> }
  ) }
);

export type UserCurrentInjuryListQueryVariables = Exact<{
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
  input: MultilingualTextInput;
}>;


export type UserCurrentInjuryListQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { user?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id'>
      & { currentInjuryList: Array<(
        { __typename: 'Injury' }
        & UserInjuryDataFragment
      )> }
    )> }
  ) }
);

export type UserPastInjuryListQueryVariables = Exact<{
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
  input: MultilingualTextInput;
}>;


export type UserPastInjuryListQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { user?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id'>
      & { pastInjuryList: Array<(
        { __typename: 'Injury' }
        & UserInjuryDataFragment
      )> }
    )> }
  ) }
);

export type UserInjuryDataFragment = (
  { __typename: 'Injury' }
  & Pick<Injury, 'id' | 'occurDate' | 'historyStatus' | 'reason' | 'diagnosis' | 'medicalRecord' | 'status'>
  & { bodyPart?: Maybe<(
    { __typename: 'SportsBodyPart' }
    & Pick<SportsBodyPart, 'id' | 'value'>
  )>, return: (
    { __typename: 'Return' }
    & Pick<Return, 'date' | 'info' | 'status'>
  ), fileList: Array<(
    { __typename: 'InjuryFile' }
    & Pick<InjuryFile, 'id' | 'name' | 'url'>
  )> }
);

export type FeedbackDetailQueryVariables = Exact<{
  id: Scalars['ID'];
  multilingualTextInput: MultilingualTextInput;
}>;


export type FeedbackDetailQuery = (
  { __typename: 'Query' }
  & { feedback: (
    { __typename: 'Feedback' }
    & FeedbackDataFragment
  ) }
);

export type FeedbackDataFragment = (
  { __typename: 'Feedback' }
  & Pick<Feedback, 'id' | 'date' | 'type' | 'message' | 'isUpdated' | 'createdAt' | 'teamId'>
  & { contentsData?: Maybe<(
    { __typename: 'FeedbackConditionNotGoodData' }
    & Pick<FeedbackConditionNotGoodData, 'dataList' | 'mood' | 'fatigue' | 'stress' | 'muscle' | 'sleepDuration' | 'sleepDurationScore' | 'sleepQuality'>
  ) | (
    { __typename: 'FeedbackConditionPlummetData' }
    & Pick<FeedbackConditionPlummetData, 'dataList' | 'mood28dayList' | 'fatigue28dayList' | 'stress28dayList' | 'muscle28dayList' | 'sleepDuration28dayList' | 'sleepQuality28dayList'>
  ) | (
    { __typename: 'FeedbackSorenessSevereData' }
    & Pick<FeedbackSorenessSevereData, 'level' | 'memo' | 'isContact'>
    & { bodyPart: (
      { __typename: 'SportsBodyPart' }
      & Pick<SportsBodyPart, 'id' | 'value' | 'front' | 'back' | 'left' | 'right'>
    ) }
  ) | (
    { __typename: 'FeedbackWorkloadMemoData' }
    & Pick<FeedbackWorkloadMemoData, 'duration' | 'time' | 'timezone' | 'memo'>
    & { scheduleData?: Maybe<(
      { __typename: 'FeedbackWorkloadScheduleData' }
      & Pick<FeedbackWorkloadScheduleData, 'type' | 'detailType' | 'title' | 'location' | 'scheduleDate' | 'startTime' | 'endTime'>
    )> }
  ) | (
    { __typename: 'FeedbackWorkloadRiskAtInjuryData' }
    & Pick<FeedbackWorkloadRiskAtInjuryData, 'label' | 'analysisType' | 'reasonList'>
  )>, commentList: Array<(
    { __typename: 'FeedbackComment' }
    & Pick<FeedbackComment, 'id' | 'comment' | 'isUpdated' | 'createdAt'>
    & { user: (
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id' | 'pictureUrl' | 'name'>
    ) }
  )>, createUser: (
    { __typename: 'SportsUser' }
    & Pick<SportsUser, 'id' | 'name' | 'pictureUrl' | 'gender'>
  ), player: (
    { __typename: 'SportsUser' }
    & Pick<SportsUser, 'id' | 'name' | 'pictureUrl'>
  ), team?: Maybe<(
    { __typename: 'SportsTeam' }
    & Pick<SportsTeam, 'id'>
  )> }
);

export type FeedbackSuggestionListQueryVariables = Exact<{
  userId: Scalars['ID'];
  teamId: Scalars['ID'];
  timezone: Scalars['String'];
  input: MultilingualTextInput;
}>;


export type FeedbackSuggestionListQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { user?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id' | 'name' | 'pictureUrl'>
      & { feedbackSuggestionList: Array<(
        { __typename: 'FeedbackSuggestion' }
        & Pick<FeedbackSuggestion, 'date' | 'type'>
        & { contentsData?: Maybe<(
          { __typename: 'FeedbackConditionNotGoodData' }
          & Pick<FeedbackConditionNotGoodData, 'dataList' | 'mood' | 'fatigue' | 'stress' | 'muscle' | 'sleepDuration' | 'sleepDurationScore' | 'sleepQuality'>
        ) | (
          { __typename: 'FeedbackConditionPlummetData' }
          & Pick<FeedbackConditionPlummetData, 'dataList' | 'mood28dayList' | 'fatigue28dayList' | 'stress28dayList' | 'muscle28dayList' | 'sleepDuration28dayList' | 'sleepQuality28dayList'>
        ) | (
          { __typename: 'FeedbackSorenessSevereData' }
          & Pick<FeedbackSorenessSevereData, 'level' | 'memo' | 'isContact'>
          & { bodyPart: (
            { __typename: 'SportsBodyPart' }
            & Pick<SportsBodyPart, 'id' | 'value' | 'front' | 'back' | 'left' | 'right'>
            & { group: (
              { __typename: 'SportsBodyPartGroup' }
              & Pick<SportsBodyPartGroup, 'id'>
            ) }
          ) }
        ) | (
          { __typename: 'FeedbackWorkloadMemoData' }
          & Pick<FeedbackWorkloadMemoData, 'memo' | 'duration' | 'time' | 'timezone'>
          & { scheduleData?: Maybe<(
            { __typename: 'FeedbackWorkloadScheduleData' }
            & Pick<FeedbackWorkloadScheduleData, 'type' | 'detailType' | 'title' | 'location' | 'scheduleDate' | 'startTime' | 'endTime'>
          )> }
        ) | (
          { __typename: 'FeedbackWorkloadRiskAtInjuryData' }
          & Pick<FeedbackWorkloadRiskAtInjuryData, 'label' | 'analysisType' | 'reasonList'>
        )> }
      )> }
    )> }
  ) }
);

export type DialogTeamPlayerListQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type DialogTeamPlayerListQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { team?: Maybe<(
      { __typename: 'SportsTeam' }
      & Pick<SportsTeam, 'id'>
      & { userMapsByPage: (
        { __typename: 'SportsTeamUserMapByPage' }
        & { entries: Array<(
          { __typename: 'SportsTeamUserMap' }
          & { user: (
            { __typename: 'SportsUser' }
            & Pick<SportsUser, 'id' | 'name' | 'pictureUrl' | 'gender'>
          ) }
        )> }
      ) }
    )> }
  ) }
);

export type DrawerPlayersListQueryVariables = Exact<{
  teamId: Scalars['ID'];
  starerId: Scalars['ID'];
}>;


export type DrawerPlayersListQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { team?: Maybe<(
      { __typename: 'SportsTeam' }
      & Pick<SportsTeam, 'id'>
      & { memberUserList: (
        { __typename: 'SportsUserList' }
        & Pick<SportsUserList, 'count'>
        & { userList: Array<(
          { __typename: 'SportsUser' }
          & Pick<SportsUser, 'id' | 'name' | 'pictureUrl' | 'priorSportsPosition' | 'priorSportsRole' | 'isStarredBy'>
          & { priorSportsCategory?: Maybe<(
            { __typename: 'SportsCategoryCollection' }
            & Pick<SportsCategoryCollection, 'id' | 'group'>
          )> }
        )> }
      ) }
    )> }
  ) }
);

export type BodyPartsQueryVariables = Exact<{
  input: MultilingualTextInput;
}>;


export type BodyPartsQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { bodyParts: Array<(
      { __typename: 'SportsBodyPart' }
      & Pick<SportsBodyPart, 'back' | 'front' | 'id' | 'left' | 'right' | 'value'>
      & { group: (
        { __typename: 'SportsBodyPartGroup' }
        & Pick<SportsBodyPartGroup, 'id'>
      ) }
    )> }
  ) }
);

export type BodyPartMultilingualTextQueryVariables = Exact<{
  input: MultilingualTextInput;
  key?: Maybe<Scalars['String']>;
}>;


export type BodyPartMultilingualTextQuery = (
  { __typename: 'Query' }
  & { multilingualText: (
    { __typename: 'MultilingualTextQuery' }
    & { bodyPartList: Array<(
      { __typename: 'MultilingualBodyPart' }
      & Pick<MultilingualBodyPart, 'id' | 'value'>
    )> }
  ) }
);

export type ModalTeamCreateViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ModalTeamCreateViewerQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { viewer?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id' | 'name' | 'nationality'>
      & { priorSportsCategory?: Maybe<(
        { __typename: 'SportsCategoryCollection' }
        & Pick<SportsCategoryCollection, 'id'>
      )> }
    )> }
  ) }
);

export type ModalTeamCreateTeamDataQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ModalTeamCreateTeamDataQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { team?: Maybe<(
      { __typename: 'SportsTeam' }
      & { userMapsByPage: (
        { __typename: 'SportsTeamUserMapByPage' }
        & { entries: Array<(
          { __typename: 'SportsTeamUserMap' }
          & Pick<SportsTeamUserMap, 'teamAuthority'>
          & { user: (
            { __typename: 'SportsUser' }
            & Pick<SportsUser, 'id'>
          ) }
        )> }
      ) }
      & ModalTeamCreateTeamFragment
    )>, viewer?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id'>
      & { teamMapsByPage: (
        { __typename: 'SportsTeamUserMapByPage' }
        & Pick<SportsTeamUserMapByPage, 'total'>
        & { entries: Array<(
          { __typename: 'SportsTeamUserMap' }
          & Pick<SportsTeamUserMap, 'teamAuthority'>
          & { team: (
            { __typename: 'SportsTeam' }
            & ModalTeamCreateTeamFragment
          ) }
        )> }
      ) }
    )> }
  ) }
);

export type ModalTeamCreateTeamFragment = (
  { __typename: 'SportsTeam' }
  & Pick<SportsTeam, 'id' | 'name' | 'pictureUrl' | 'createdAt'>
  & { sportsCategory: (
    { __typename: 'SportsCategoryCollection' }
    & Pick<SportsCategoryCollection, 'id' | 'group'>
  ), region: (
    { __typename: 'Region' }
    & Pick<Region, 'id'>
  ), allUsers: (
    { __typename: 'SportsTeamUserMapByPage' }
    & Pick<SportsTeamUserMapByPage, 'total'>
  ), players: (
    { __typename: 'SportsTeamUserMapByPage' }
    & Pick<SportsTeamUserMapByPage, 'total'>
  ) }
);

export type ModalTeamJoinViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ModalTeamJoinViewerQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { viewer?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id' | 'name' | 'nationality'>
      & { priorSportsCategory?: Maybe<(
        { __typename: 'SportsCategoryCollection' }
        & Pick<SportsCategoryCollection, 'id'>
      )> }
    )> }
  ) }
);

export type NavbarTeamsTeamDataQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NavbarTeamsTeamDataQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { team?: Maybe<(
      { __typename: 'SportsTeam' }
      & { userMapsByPage: (
        { __typename: 'SportsTeamUserMapByPage' }
        & Pick<SportsTeamUserMapByPage, 'total'>
        & { entries: Array<(
          { __typename: 'SportsTeamUserMap' }
          & Pick<SportsTeamUserMap, 'teamAuthority'>
          & { user: (
            { __typename: 'SportsUser' }
            & Pick<SportsUser, 'id'>
          ) }
        )> }
      ) }
      & NavbarTeamsTeamFragment
    )>, viewer?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id'>
      & { teamMapsByPage: (
        { __typename: 'SportsTeamUserMapByPage' }
        & Pick<SportsTeamUserMapByPage, 'total'>
        & { entries: Array<(
          { __typename: 'SportsTeamUserMap' }
          & Pick<SportsTeamUserMap, 'teamAuthority'>
          & { team: (
            { __typename: 'SportsTeam' }
            & NavbarTeamsTeamFragment
          ) }
        )> }
      ) }
    )> }
  ) }
);

export type NavbarTeamsTeamFragment = (
  { __typename: 'SportsTeam' }
  & Pick<SportsTeam, 'id' | 'name' | 'pictureUrl' | 'createdAt'>
  & { sportsCategory: (
    { __typename: 'SportsCategoryCollection' }
    & Pick<SportsCategoryCollection, 'id' | 'group'>
  ), region: (
    { __typename: 'Region' }
    & Pick<Region, 'id'>
  ), allUsers: (
    { __typename: 'SportsTeamUserMapByPage' }
    & Pick<SportsTeamUserMapByPage, 'total'>
  ), players: (
    { __typename: 'SportsTeamUserMapByPage' }
    & Pick<SportsTeamUserMapByPage, 'total'>
  ) }
);

export type FSportsTeamFragment = (
  { __typename: 'SportsTeam' }
  & Pick<SportsTeam, 'id' | 'type' | 'slug' | 'name' | 'code' | 'viewerAuthority' | 'pictureUrl'>
  & { region: (
    { __typename: 'Region' }
    & Pick<Region, 'id'>
  ), sportsCategory: (
    { __typename: 'SportsCategoryCollection' }
    & Pick<SportsCategoryCollection, 'id'>
  ), allUsers: (
    { __typename: 'SportsTeamUserMapByPage' }
    & Pick<SportsTeamUserMapByPage, 'total'>
  ), players: (
    { __typename: 'SportsTeamUserMapByPage' }
    & Pick<SportsTeamUserMapByPage, 'total'>
  ) }
);

export type FSportsTeamInvitationRequestFragment = (
  { __typename: 'SportsTeamInvitationRequest' }
  & Pick<SportsTeamInvitationRequest, 'id' | 'status' | 'teamAuthority'>
  & { user: (
    { __typename: 'SportsUser' }
    & Pick<SportsUser, 'id'>
  ), team: (
    { __typename: 'SportsTeam' }
    & FSportsTeamFragment
  ) }
);

export type FSportsTeamUserMapFragment = (
  { __typename: 'SportsTeamUserMap' }
  & Pick<SportsTeamUserMap, 'id' | 'teamAuthority'>
  & { team: (
    { __typename: 'SportsTeam' }
    & { subscriptionItem?: Maybe<(
      { __typename: 'SubscriptionItem' }
      & Pick<SubscriptionItem, 'id' | 'planId'>
    )> }
    & FSportsTeamFragment
  ) }
);

export type FSportsUserFragment = (
  { __typename: 'SportsUser' }
  & Pick<SportsUser, 'id' | 'slug' | 'name' | 'introduction' | 'pictureUrl' | 'priorSportsPosition' | 'priorSportsRole' | 'createdAt' | 'birthdate' | 'email' | 'federation' | 'gender' | 'nationality' | 'phoneNumber'>
  & { priorSportsCategory?: Maybe<(
    { __typename: 'SportsCategoryCollection' }
    & Pick<SportsCategoryCollection, 'id' | 'group'>
  )> }
);

export type FTeamGroupFragment = (
  { __typename: 'TeamGroup' }
  & Pick<TeamGroup, 'id' | 'name' | 'orderRanking' | 'teamId' | 'userId' | 'createdAt' | 'updatedAt'>
);

export type CreateFeedbackMutationVariables = Exact<{
  input: CreateFeedbackInput;
  multilingualTextInput: MultilingualTextInput;
}>;


export type CreateFeedbackMutation = (
  { __typename: 'Mutation' }
  & { createFeedback: (
    { __typename: 'Feedback' }
    & FeedbackDataFragment
  ) }
);

export type DeleteFeedbackMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFeedbackMutation = (
  { __typename: 'Mutation' }
  & Pick<Mutation, 'deleteFeedback'>
);

export type UpdateFeedbackMutationVariables = Exact<{
  input: UpdateFeedbackInput;
  multilingualTextInput: MultilingualTextInput;
}>;


export type UpdateFeedbackMutation = (
  { __typename: 'Mutation' }
  & { updateFeedback: (
    { __typename: 'Feedback' }
    & FeedbackDataFragment
  ) }
);

export type CreateFeedbackCommentsMutationVariables = Exact<{
  input: CreateFeedbackCommentInput;
  multilingualTextInput: MultilingualTextInput;
}>;


export type CreateFeedbackCommentsMutation = (
  { __typename: 'Mutation' }
  & { createFeedbackComment: (
    { __typename: 'Feedback' }
    & FeedbackDataFragment
  ) }
);

export type UpdateFeedbackCommentsMutationVariables = Exact<{
  input: UpdateFeedbackCommentInput;
  multilingualTextInput: MultilingualTextInput;
}>;


export type UpdateFeedbackCommentsMutation = (
  { __typename: 'Mutation' }
  & { updateFeedbackComment: (
    { __typename: 'Feedback' }
    & FeedbackDataFragment
  ) }
);

export type DeleteFeedbackCommentsMutationVariables = Exact<{
  input: DeleteFeedbackCommentInput;
  multilingualTextInput: MultilingualTextInput;
}>;


export type DeleteFeedbackCommentsMutation = (
  { __typename: 'Mutation' }
  & { deleteFeedbackComment: (
    { __typename: 'Feedback' }
    & FeedbackDataFragment
  ) }
);

export type CreateInjuryMutationVariables = Exact<{
  input: CreateInjuryInput;
  files: Array<Scalars['Upload']> | Scalars['Upload'];
  multilingualTextInput: MultilingualTextInput;
}>;


export type CreateInjuryMutation = (
  { __typename: 'Mutation' }
  & { createInjury: (
    { __typename: 'Injury' }
    & Pick<Injury, 'id' | 'occurDate' | 'historyStatus' | 'reason' | 'diagnosis' | 'medicalRecord' | 'status'>
    & { bodyPart?: Maybe<(
      { __typename: 'SportsBodyPart' }
      & Pick<SportsBodyPart, 'id' | 'value'>
    )>, return: (
      { __typename: 'Return' }
      & Pick<Return, 'date' | 'status' | 'info'>
    ), fileList: Array<(
      { __typename: 'InjuryFile' }
      & Pick<InjuryFile, 'id' | 'name' | 'url'>
    )>, user: (
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id'>
    ) }
  ) }
);

export type UpdateInjuryMutationVariables = Exact<{
  input: UpdateInjuryInput;
  files?: Maybe<Array<Scalars['Upload']> | Scalars['Upload']>;
  multilingualTextInput: MultilingualTextInput;
}>;


export type UpdateInjuryMutation = (
  { __typename: 'Mutation' }
  & { updateInjury: (
    { __typename: 'Injury' }
    & Pick<Injury, 'id' | 'occurDate' | 'historyStatus' | 'reason' | 'diagnosis' | 'medicalRecord' | 'status'>
    & { bodyPart?: Maybe<(
      { __typename: 'SportsBodyPart' }
      & Pick<SportsBodyPart, 'id' | 'value'>
    )>, return: (
      { __typename: 'Return' }
      & Pick<Return, 'date' | 'info' | 'status'>
    ), fileList: Array<(
      { __typename: 'InjuryFile' }
      & Pick<InjuryFile, 'id' | 'name' | 'url'>
    )> }
  ) }
);

export type DeleteInjuryMutationVariables = Exact<{
  input: DeleteInjuryInput;
}>;


export type DeleteInjuryMutation = (
  { __typename: 'Mutation' }
  & Pick<Mutation, 'deleteInjury'>
);

export type SendCheckConditionReminderPushMutationVariables = Exact<{
  input: CheckReminderPushInput;
}>;


export type SendCheckConditionReminderPushMutation = (
  { __typename: 'Mutation' }
  & Pick<Mutation, 'sendCheckConditionReminderPush'>
);

export type SendCheckWorkloadReminderPushMutationVariables = Exact<{
  input: CheckReminderPushInput;
}>;


export type SendCheckWorkloadReminderPushMutation = (
  { __typename: 'Mutation' }
  & Pick<Mutation, 'sendCheckWorkloadReminderPush'>
);

export type RequestBillingTokenMutationVariables = Exact<{
  input: RequestBillingTokenInput;
}>;


export type RequestBillingTokenMutation = (
  { __typename: 'Mutation' }
  & { requestBillingToken: (
    { __typename: 'BillingToken' }
    & Pick<BillingToken, 'customerUid' | 'paymentToken'>
  ) }
);

export type UpdateBillingKeyMutationVariables = Exact<{
  input: UpdateBillingTokenInput;
}>;


export type UpdateBillingKeyMutation = (
  { __typename: 'Mutation' }
  & { updateBillingKey: (
    { __typename: 'Billing' }
    & Pick<Billing, 'id' | 'identityToken' | 'customerUid' | 'cardName' | 'cardNumber' | 'buyerName' | 'buyerTel' | 'buyerEmail'>
  ) }
);

export type UpdateBillingBuyerNameMutationVariables = Exact<{
  input: UpdateBillingBuyerNameInput;
}>;


export type UpdateBillingBuyerNameMutation = (
  { __typename: 'Mutation' }
  & { updateBillingBuyerName: (
    { __typename: 'Billing' }
    & Pick<Billing, 'id'>
  ) }
);

export type UpdateBillingBuyerNumberMutationVariables = Exact<{
  input: UpdateBillingBuyerNumberInput;
}>;


export type UpdateBillingBuyerNumberMutation = (
  { __typename: 'Mutation' }
  & { updateBillingBuyerNumber: (
    { __typename: 'Billing' }
    & Pick<Billing, 'id'>
  ) }
);

export type UpdateBillingBuyerEmailMutationVariables = Exact<{
  input: UpdateBillingBuyerEmailInput;
}>;


export type UpdateBillingBuyerEmailMutation = (
  { __typename: 'Mutation' }
  & { updateBillingBuyerEmail: (
    { __typename: 'Billing' }
    & Pick<Billing, 'id'>
  ) }
);

export type StartSubscriptionMutationVariables = Exact<{
  input: StartSubscriptionInput;
}>;


export type StartSubscriptionMutation = (
  { __typename: 'Mutation' }
  & { startSubscription: (
    { __typename: 'SubscriptionResponse' }
    & { subscription: (
      { __typename: 'SubscriptionItem' }
      & PaymentSubscrptionFragment
    ), paymentList: Array<(
      { __typename: 'PayInvoice' }
      & Pick<PayInvoice, 'id' | 'paymentName' | 'paymentStatus' | 'cardName' | 'cardNumber' | 'billingUserName' | 'billingUserEmail' | 'billingUserPhone' | 'receiptUrl' | 'paidAt' | 'amount'>
    ) | { __typename: 'RefundInvoice' }> }
  ) }
);

export type RestartSubscriptionMutationVariables = Exact<{
  input: RestartSubscriptionInput;
}>;


export type RestartSubscriptionMutation = (
  { __typename: 'Mutation' }
  & { restartSubscription: (
    { __typename: 'SubscriptionResponse' }
    & { subscription: (
      { __typename: 'SubscriptionItem' }
      & PaymentSubscrptionFragment
    ), paymentList: Array<(
      { __typename: 'PayInvoice' }
      & Pick<PayInvoice, 'id' | 'paymentName' | 'paymentStatus' | 'cardName' | 'cardNumber' | 'billingUserName' | 'billingUserEmail' | 'billingUserPhone' | 'receiptUrl' | 'paidAt' | 'amount'>
    ) | { __typename: 'RefundInvoice' }> }
  ) }
);

export type RefundSubscriptionMutationVariables = Exact<{
  input: RefundSubscriptionInput;
}>;


export type RefundSubscriptionMutation = (
  { __typename: 'Mutation' }
  & { refundSubscription: (
    { __typename: 'SubscriptionResponse' }
    & { subscription: (
      { __typename: 'SubscriptionItem' }
      & PaymentSubscrptionFragment
    ), paymentList: Array<{ __typename: 'PayInvoice' } | (
      { __typename: 'RefundInvoice' }
      & Pick<RefundInvoice, 'id' | 'paymentName' | 'paymentStatus' | 'cardName' | 'cardNumber' | 'billingUserName' | 'billingUserEmail' | 'billingUserPhone' | 'receiptUrl' | 'refundAt' | 'refundAmount'>
    )> }
  ) }
);

export type ResumeSubscriptionMutationVariables = Exact<{
  input: ResumeSubscriptionInput;
}>;


export type ResumeSubscriptionMutation = (
  { __typename: 'Mutation' }
  & { resumeSubscription: (
    { __typename: 'SubscriptionItem' }
    & Pick<SubscriptionItem, 'id'>
  ) }
);

export type CancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = (
  { __typename: 'Mutation' }
  & { cancelSubscription: (
    { __typename: 'SubscriptionItem' }
    & Pick<SubscriptionItem, 'id'>
  ) }
);

export type RefundMutationVariables = Exact<{
  input: Refund;
}>;


export type RefundMutation = (
  { __typename: 'Mutation' }
  & { refund: (
    { __typename: 'RefundResponse' }
    & Pick<RefundResponse, 'success'>
  ) }
);

export type RePaymentRequestMutationVariables = Exact<{
  input: RetryPayment;
}>;


export type RePaymentRequestMutation = (
  { __typename: 'Mutation' }
  & { retryPayment: (
    { __typename: 'SubscriptionResponse' }
    & { subscription: (
      { __typename: 'SubscriptionItem' }
      & PaymentSubscrptionFragment
    ), paymentList: Array<(
      { __typename: 'PayInvoice' }
      & Pick<PayInvoice, 'id' | 'paymentName' | 'paymentStatus' | 'cardName' | 'cardNumber' | 'billingUserName' | 'billingUserEmail' | 'billingUserPhone' | 'receiptUrl' | 'paidAt' | 'amount'>
    ) | { __typename: 'RefundInvoice' }> }
  ) }
);

export type PaymentSubscrptionFragment = (
  { __typename: 'SubscriptionItem' }
  & Pick<SubscriptionItem, 'id' | 'status' | 'cycleAnchor' | 'startAt' | 'endAt' | 'teamId' | 'planId' | 'planOptionId' | 'isSubscripting' | 'isRefundable' | 'isFreeTrial' | 'isActivate'>
  & { plan: (
    { __typename: 'PlanWithOption' }
    & Pick<PlanWithOption, 'id' | 'planName' | 'planType'>
    & { planOptionInfo: (
      { __typename: 'PlanOption' }
      & Pick<PlanOption, 'id'>
    ) }
  ), coupon: (
    { __typename: 'UseCoupon' }
    & Pick<UseCoupon, 'id' | 'isUsed'>
  ) }
);

export type LeaveTeamMutationVariables = Exact<{
  input: TeamUserInput;
}>;


export type LeaveTeamMutation = (
  { __typename: 'Mutation' }
  & Pick<Mutation, 'leaveTeam'>
);

export type DeleteTeamMutationVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type DeleteTeamMutation = (
  { __typename: 'Mutation' }
  & { deleteTeam: (
    { __typename: 'SportsTeam' }
    & Pick<SportsTeam, 'id'>
  ) }
);

export type TransferTeamOwnershipMutationVariables = Exact<{
  input: TeamUserInput;
}>;


export type TransferTeamOwnershipMutation = (
  { __typename: 'Mutation' }
  & { transferTeamOwnership: (
    { __typename: 'TransferTeamOwnership' }
    & { ownerTeamUserMap: (
      { __typename: 'SportsTeamUserMap' }
      & Pick<SportsTeamUserMap, 'id'>
    ), adminTeamUserMap: (
      { __typename: 'SportsTeamUserMap' }
      & Pick<SportsTeamUserMap, 'id'>
    ) }
  ) }
);

export type KickoutTeamUserListMutationVariables = Exact<{
  input: TeamUserListInput;
}>;


export type KickoutTeamUserListMutation = (
  { __typename: 'Mutation' }
  & Pick<Mutation, 'kickoutTeamUserList'>
);

export type CreateTeamGroupMutationVariables = Exact<{
  input: CreateTeamGroupInput;
}>;


export type CreateTeamGroupMutation = (
  { __typename: 'Mutation' }
  & { createTeamGroup: (
    { __typename: 'TeamGroup' }
    & { groupMemberList: Array<(
      { __typename: 'TeamGroupUser' }
      & { user: (
        { __typename: 'SportsUser' }
        & FSportsUserFragment
      ) }
    )> }
    & FTeamGroupFragment
  ) }
);

export type UpdateTeamGroupMutationVariables = Exact<{
  input: UpdateTeamGroupInput;
}>;


export type UpdateTeamGroupMutation = (
  { __typename: 'Mutation' }
  & { updateTeamGroup: (
    { __typename: 'TeamGroup' }
    & { groupMemberList: Array<(
      { __typename: 'TeamGroupUser' }
      & { user: (
        { __typename: 'SportsUser' }
        & FSportsUserFragment
      ) }
    )> }
    & FTeamGroupFragment
  ) }
);

export type DeleteTeamGroupMutationVariables = Exact<{
  input: DeleteTeamGroupInput;
}>;


export type DeleteTeamGroupMutation = (
  { __typename: 'Mutation' }
  & { deleteTeamGroup: (
    { __typename: 'TeamGroup' }
    & FTeamGroupFragment
  ) }
);

export type RequestTeamInvitationMutationVariables = Exact<{
  input: SportsTeamInvitationRequestInput;
}>;


export type RequestTeamInvitationMutation = (
  { __typename: 'Mutation' }
  & { requestTeamInvitation: (
    { __typename: 'SportsTeamInvitationRequest' }
    & Pick<SportsTeamInvitationRequest, 'id'>
    & { team: (
      { __typename: 'SportsTeam' }
      & Pick<SportsTeam, 'id' | 'code' | 'name'>
    ), user: (
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id'>
    ) }
  ) }
);

export type AcceptInvitationListMutationVariables = Exact<{
  input: SportsTeamInvitationAcceptListInput;
}>;


export type AcceptInvitationListMutation = (
  { __typename: 'Mutation' }
  & { acceptInvitationList: Array<(
    { __typename: 'SportsTeamInvitationRequest' }
    & Pick<SportsTeamInvitationRequest, 'id'>
  )> }
);

export type RejectTeamInvitationListMutationVariables = Exact<{
  input: SportsTeamInvitationRejectListInput;
}>;


export type RejectTeamInvitationListMutation = (
  { __typename: 'Mutation' }
  & { rejectTeamInvitationList: Array<(
    { __typename: 'SportsTeamInvitationRequest' }
    & Pick<SportsTeamInvitationRequest, 'id'>
  )> }
);

export type ToggleTeamUserStarStatusMutationVariables = Exact<{
  input: ToggleTeamUserStarredInput;
}>;


export type ToggleTeamUserStarStatusMutation = (
  { __typename: 'Mutation' }
  & { toggleTeamUserStarStatus: (
    { __typename: 'StarredToggleResult' }
    & Pick<StarredToggleResult, 'status'>
  ) }
);

export type UploadProfileMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadProfileMutation = (
  { __typename: 'Mutation' }
  & { uploadProfile: (
    { __typename: 'UploadProfileResponse' }
    & { user?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id'>
    )> }
  ) }
);

export type UpdateUserMutationVariables = Exact<{
  input: UpdateSportsUserInput;
}>;


export type UpdateUserMutation = (
  { __typename: 'Mutation' }
  & { updateUser: (
    { __typename: 'SportsUser' }
    & FSportsUserFragment
  ) }
);

export type AnalyticsViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsViewerQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { viewer?: Maybe<(
      { __typename: 'SportsUser' }
      & AnalyticsViewerFragment
    )> }
  ) }
);

export type AnalyticsViewerFragment = (
  { __typename: 'SportsUser' }
  & Pick<SportsUser, 'id' | 'name' | 'pictureUrl' | 'priorSportsRole' | 'email' | 'birthdate' | 'phoneNumber' | 'gender' | 'nationality' | 'createdAt'>
  & { priorSportsCategory?: Maybe<(
    { __typename: 'SportsCategoryCollection' }
    & Pick<SportsCategoryCollection, 'id' | 'group'>
  )>, teamMaps: Array<(
    { __typename: 'SportsTeamUserMap' }
    & Pick<SportsTeamUserMap, 'id' | 'teamAuthority'>
    & { team: (
      { __typename: 'SportsTeam' }
      & AnalyticsTeamFragment
    ) }
  )> }
);

export type AnalyticsTeamFragment = (
  { __typename: 'SportsTeam' }
  & Pick<SportsTeam, 'id' | 'name' | 'pictureUrl' | 'code'>
  & { allUsers: (
    { __typename: 'SportsTeamUserMapByPage' }
    & Pick<SportsTeamUserMapByPage, 'total'>
  ), players: (
    { __typename: 'SportsTeamUserMapByPage' }
    & Pick<SportsTeamUserMapByPage, 'total'>
  ) }
);

export type InvoiceBillingQueryVariables = Exact<{
  identityToken: Scalars['ID'];
}>;


export type InvoiceBillingQuery = (
  { __typename: 'Query' }
  & { billing?: Maybe<(
    { __typename: 'Billing' }
    & Pick<Billing, 'id'>
    & InvoiceBillingItemFragment
  )> }
);

export type InvoiceBillingItemFragment = (
  { __typename: 'Billing' }
  & Pick<Billing, 'id' | 'identityToken' | 'customerUid' | 'cardName' | 'cardNumber' | 'buyerName' | 'buyerTel' | 'buyerEmail'>
);

export type MultilingualDataQueryVariables = Exact<{
  input: MultilingualTextInput;
}>;


export type MultilingualDataQuery = (
  { __typename: 'Query' }
  & { multilingualText: (
    { __typename: 'MultilingualTextQuery' }
    & { categoryGroupList: Array<(
      { __typename: 'MultilingualCategoryGroup' }
      & Pick<MultilingualCategoryGroup, 'id' | 'value'>
      & { categoryList: Array<(
        { __typename: 'MultilingualCategory' }
        & Pick<MultilingualCategory, 'id' | 'value'>
        & { coachPositionList: Array<(
          { __typename: 'MultilingualCoachPosition' }
          & Pick<MultilingualCoachPosition, 'id' | 'value'>
        )>, playerPositionList: Array<(
          { __typename: 'MultilingualPlayerPosition' }
          & Pick<MultilingualPlayerPosition, 'id' | 'value'>
        )> }
      )> }
    )>, countryList: Array<(
      { __typename: 'MultilingualCountry' }
      & Pick<MultilingualCountry, 'id' | 'value'>
    )> }
  ) }
);

export type TeamPlanListQueryVariables = Exact<{
  couponId?: Maybe<Scalars['String']>;
}>;


export type TeamPlanListQuery = (
  { __typename: 'Query' }
  & { teamPlanList: Array<(
    { __typename: 'Plan' }
    & Pick<Plan, 'id' | 'planName' | 'planType' | 'limitCount' | 'discountStartAt' | 'discountEndAt' | 'originalPriceStartAt'>
    & { planOptionInfoList?: Maybe<Array<Maybe<(
      { __typename: 'PlanOptionWithCoupon' }
      & PlanOptionInfoFragment
    )>>> }
  )> }
);

export type PlanOptionInfoFragment = (
  { __typename: 'PlanOptionWithCoupon' }
  & Pick<PlanOptionWithCoupon, 'id' | 'currency' | 'description' | 'originalPrice' | 'discountedPrice' | 'duration' | 'maxPlayerCount' | 'maxTeamCount' | 'nextPaymentDay' | 'period' | 'planOptionName'>
);

export type PlayerInjuryQueryVariables = Exact<{
  playerId: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
  input: MultilingualTextInput;
}>;


export type PlayerInjuryQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { user?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id'>
      & { data: Array<(
        { __typename: 'SportsTimeSeriesData' }
        & Pick<SportsTimeSeriesData, 'name'>
        & { ranges: Array<(
          { __typename: 'SportsDataRange' }
          & { entries: Array<(
            { __typename: 'SportsDataEntry' }
            & Pick<SportsDataEntry, 'time' | 'value'>
          )> }
        )> }
      )> }
      & PlayerSummaryIdentityFragment
    )> }
  ) }
);

export type PlayerSummaryIdentityFragment = (
  { __typename: 'SportsUser' }
  & Pick<SportsUser, 'pictureUrl' | 'name' | 'gender' | 'birthdate' | 'priorSportsPosition' | 'priorSportsRole'>
  & { priorSportsCategory?: Maybe<(
    { __typename: 'SportsCategoryCollection' }
    & Pick<SportsCategoryCollection, 'id' | 'group'>
  )> }
);

export type PlayerSelectAllUserMapsByGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PlayerSelectAllUserMapsByGroupQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { team?: Maybe<(
      { __typename: 'SportsTeam' }
      & Pick<SportsTeam, 'id'>
      & { memberUserList: (
        { __typename: 'SportsUserList' }
        & Pick<SportsUserList, 'count'>
        & { userList: Array<(
          { __typename: 'SportsUser' }
          & Pick<SportsUser, 'id' | 'name' | 'pictureUrl' | 'nationality'>
        )> }
      ) }
    )> }
  ) }
);

export type GroupsMemberMapByTeamQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupsMemberMapByTeamQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { team?: Maybe<(
      { __typename: 'SportsTeam' }
      & Pick<SportsTeam, 'id'>
      & { groupList: Array<(
        { __typename: 'TeamGroup' }
        & { groupMemberList: Array<(
          { __typename: 'TeamGroupUser' }
          & { user: (
            { __typename: 'SportsUser' }
            & FSportsUserFragment
          ) }
        )> }
        & FTeamGroupFragment
      )> }
    )> }
  ) }
);

export type TGroupMemberMapFragment = (
  { __typename: 'TeamGroup' }
  & Pick<TeamGroup, 'id' | 'name' | 'orderRanking'>
  & { groupMemberList: Array<(
    { __typename: 'TeamGroupUser' }
    & { user: (
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id' | 'name' | 'pictureUrl' | 'nationality'>
    ) }
  )> }
);

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { viewer?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id'>
      & { guideReopenStatus: (
        { __typename: 'GuideReopenStatus' }
        & { alarm: (
          { __typename: 'GuideReopenStatusUnit' }
          & Pick<GuideReopenStatusUnit, 'web'>
        ) }
      ), teamMaps: Array<(
        { __typename: 'SportsTeamUserMap' }
        & FSportsTeamUserMapFragment
      )> }
      & FSportsUserFragment
    )> }
  ) }
);

export type QuerySystemUserDataQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  groups?: Maybe<Array<SportsDataGroup> | SportsDataGroup>;
  names?: Maybe<Array<SportsDataName> | SportsDataName>;
  timezone: Scalars['String'];
  input: MultilingualTextInput;
}>;


export type QuerySystemUserDataQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { user?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id' | 'name' | 'pictureUrl'>
      & { data: Array<(
        { __typename: 'SportsTimeSeriesData' }
        & Pick<SportsTimeSeriesData, 'name'>
        & { ranges: Array<(
          { __typename: 'SportsDataRange' }
          & Pick<SportsDataRange, 'from'>
          & { entries: Array<(
            { __typename: 'SportsDataEntry' }
            & Pick<SportsDataEntry, 'value' | 'time'>
          )> }
        )> }
      )>, workload: Array<(
        { __typename: 'UserWorkloadData' }
        & Pick<UserWorkloadData, 'time' | 'count' | 'reasonForNoWorkout'>
        & { workload: (
          { __typename: 'Statistic' }
          & Pick<Statistic, 'sum'>
        ), duration: (
          { __typename: 'Statistic' }
          & Pick<Statistic, 'sum'>
        ), intensity: (
          { __typename: 'Statistic' }
          & Pick<Statistic, 'avg'>
        ), satisfaction: (
          { __typename: 'Statistic' }
          & Pick<Statistic, 'avg'>
        ), workloadList: Array<(
          { __typename: 'SportsRawWorkload' }
          & Pick<SportsRawWorkload, 'id' | 'name' | 'time' | 'load' | 'duration' | 'intensity' | 'satisfaction' | 'type'>
          & { event?: Maybe<(
            { __typename: 'BasicEventInvitee' }
            & { event: (
              { __typename: 'BasicEvent' }
              & Pick<BasicEvent, 'id' | 'title' | 'hideExpectedIntensityFromPlayers' | 'startAt' | 'endAt'>
            ) | (
              { __typename: 'Match' }
              & Pick<Match, 'id' | 'title' | 'hideExpectedIntensityFromPlayers' | 'startAt' | 'endAt'>
            ) | (
              { __typename: 'Training' }
              & Pick<Training, 'id' | 'title' | 'hideExpectedIntensityFromPlayers' | 'startAt' | 'endAt'>
            ) }
          ) | (
            { __typename: 'MatchInvitee' }
            & { event: (
              { __typename: 'BasicEvent' }
              & Pick<BasicEvent, 'id' | 'title' | 'hideExpectedIntensityFromPlayers' | 'startAt' | 'endAt'>
            ) | (
              { __typename: 'Match' }
              & Pick<Match, 'id' | 'title' | 'hideExpectedIntensityFromPlayers' | 'startAt' | 'endAt'>
            ) | (
              { __typename: 'Training' }
              & Pick<Training, 'id' | 'title' | 'hideExpectedIntensityFromPlayers' | 'startAt' | 'endAt'>
            ) }
          ) | (
            { __typename: 'TrainingInvitee' }
            & { event: (
              { __typename: 'BasicEvent' }
              & Pick<BasicEvent, 'id' | 'title' | 'hideExpectedIntensityFromPlayers' | 'startAt' | 'endAt'>
            ) | (
              { __typename: 'Match' }
              & Pick<Match, 'id' | 'title' | 'hideExpectedIntensityFromPlayers' | 'startAt' | 'endAt'>
            ) | (
              { __typename: 'Training' }
              & Pick<Training, 'id' | 'title' | 'hideExpectedIntensityFromPlayers' | 'startAt' | 'endAt'>
            ) }
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type QuerySystemUserWorkloadDataQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
  teamId?: Maybe<Scalars['ID']>;
}>;


export type QuerySystemUserWorkloadDataQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { user?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id' | 'name' | 'pictureUrl'>
      & { sportsDataList: Array<(
        { __typename: 'SportsData' }
        & Pick<SportsData, 'id' | 'date'>
        & { workload?: Maybe<(
          { __typename: 'WorkloadData' }
          & Pick<WorkloadData, 'count' | 'reasonForNoWorkout' | 'isChecked'>
          & { workload: (
            { __typename: 'Statistic' }
            & Pick<Statistic, 'sum'>
          ), duration: (
            { __typename: 'Statistic' }
            & Pick<Statistic, 'sum'>
          ), intensity: (
            { __typename: 'Statistic' }
            & Pick<Statistic, 'avg'>
          ), satisfaction: (
            { __typename: 'Statistic' }
            & Pick<Statistic, 'avg'>
          ), workloadList: Array<(
            { __typename: 'Workload' }
            & Pick<Workload, 'id' | 'time' | 'load' | 'duration' | 'intensity' | 'satisfaction' | 'type'>
            & { schedule?: Maybe<(
              { __typename: 'BasicScheduleInvitee' }
              & Pick<BasicScheduleInvitee, 'id'>
              & { schedule?: Maybe<(
                { __typename: 'BasicSchedule' }
                & Pick<BasicSchedule, 'id' | 'title' | 'startTime' | 'endTime'>
                & { team?: Maybe<(
                  { __typename: 'SportsTeam' }
                  & Pick<SportsTeam, 'id'>
                )> }
              ) | (
                { __typename: 'MatchSchedule' }
                & Pick<MatchSchedule, 'id' | 'title' | 'startTime' | 'endTime'>
                & { team?: Maybe<(
                  { __typename: 'SportsTeam' }
                  & Pick<SportsTeam, 'id'>
                )> }
              ) | (
                { __typename: 'TrainingSchedule' }
                & Pick<TrainingSchedule, 'id' | 'title' | 'startTime' | 'endTime'>
                & { team?: Maybe<(
                  { __typename: 'SportsTeam' }
                  & Pick<SportsTeam, 'id'>
                )> }
              )> }
            ) | (
              { __typename: 'MatchScheduleInvitee' }
              & Pick<MatchScheduleInvitee, 'id'>
              & { schedule?: Maybe<(
                { __typename: 'BasicSchedule' }
                & Pick<BasicSchedule, 'id' | 'title' | 'startTime' | 'endTime'>
                & { team?: Maybe<(
                  { __typename: 'SportsTeam' }
                  & Pick<SportsTeam, 'id'>
                )> }
              ) | (
                { __typename: 'MatchSchedule' }
                & Pick<MatchSchedule, 'id' | 'title' | 'startTime' | 'endTime'>
                & { team?: Maybe<(
                  { __typename: 'SportsTeam' }
                  & Pick<SportsTeam, 'id'>
                )> }
              ) | (
                { __typename: 'TrainingSchedule' }
                & Pick<TrainingSchedule, 'id' | 'title' | 'startTime' | 'endTime'>
                & { team?: Maybe<(
                  { __typename: 'SportsTeam' }
                  & Pick<SportsTeam, 'id'>
                )> }
              )> }
            ) | (
              { __typename: 'TrainingInviteeSchedule' }
              & Pick<TrainingInviteeSchedule, 'id'>
              & { schedule?: Maybe<(
                { __typename: 'BasicSchedule' }
                & Pick<BasicSchedule, 'id' | 'title' | 'startTime' | 'endTime'>
                & { team?: Maybe<(
                  { __typename: 'SportsTeam' }
                  & Pick<SportsTeam, 'id'>
                )> }
              ) | (
                { __typename: 'MatchSchedule' }
                & Pick<MatchSchedule, 'id' | 'title' | 'startTime' | 'endTime'>
                & { team?: Maybe<(
                  { __typename: 'SportsTeam' }
                  & Pick<SportsTeam, 'id'>
                )> }
              ) | (
                { __typename: 'TrainingSchedule' }
                & Pick<TrainingSchedule, 'id' | 'title' | 'startTime' | 'endTime'>
                & { team?: Maybe<(
                  { __typename: 'SportsTeam' }
                  & Pick<SportsTeam, 'id'>
                )> }
              )> }
            )> }
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type QuerySystemTeamUserMapsDataQueryVariables = Exact<{
  id: Scalars['ID'];
  cursor: Scalars['DateTime'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  timezone: Scalars['String'];
  groups?: Maybe<Array<SportsDataGroup> | SportsDataGroup>;
  names?: Maybe<Array<SportsDataName> | SportsDataName>;
  filter?: Maybe<TeamUserMapFilterInput>;
  order?: Maybe<UserDataOrderByInput>;
  input: MultilingualTextInput;
}>;


export type QuerySystemTeamUserMapsDataQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { team?: Maybe<(
      { __typename: 'SportsTeam' }
      & Pick<SportsTeam, 'id'>
      & { userMapsByPage: (
        { __typename: 'SportsTeamUserMapByPage' }
        & Pick<SportsTeamUserMapByPage, 'offset' | 'limit' | 'total' | 'hasPrev' | 'hasNext'>
        & { entries: Array<(
          { __typename: 'SportsTeamUserMap' }
          & Pick<SportsTeamUserMap, 'id' | 'teamAuthority'>
          & { user: (
            { __typename: 'SportsUser' }
            & Pick<SportsUser, 'id' | 'name' | 'pictureUrl'>
            & { data: Array<(
              { __typename: 'SportsTimeSeriesData' }
              & Pick<SportsTimeSeriesData, 'name' | 'stride'>
              & { ranges: Array<(
                { __typename: 'SportsDataRange' }
                & Pick<SportsDataRange, 'from'>
                & { entries: Array<(
                  { __typename: 'SportsDataEntry' }
                  & Pick<SportsDataEntry, 'time' | 'value'>
                )> }
              )> }
            )> }
          ) }
        )> }
      ) }
    )> }
  ) }
);

export type QuerySystemTeamAverageDataQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  timezone: Scalars['String'];
  names: Array<SportsTeamDataName> | SportsTeamDataName;
  filter?: Maybe<TeamUserMapForTeamDataFilterInput>;
}>;


export type QuerySystemTeamAverageDataQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { team?: Maybe<(
      { __typename: 'SportsTeam' }
      & Pick<SportsTeam, 'id'>
      & { data: Array<(
        { __typename: 'SportsTimeSeriesTeamData' }
        & Pick<SportsTimeSeriesTeamData, 'stride' | 'name'>
        & { ranges: Array<(
          { __typename: 'SportsTeamDataRange' }
          & Pick<SportsTeamDataRange, 'from' | 'to'>
          & { entries: Array<(
            { __typename: 'SportsTeamDataEntry' }
            & Pick<SportsTeamDataEntry, 'time' | 'value'>
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type PlanBillingTeamSubscriptionQueryVariables = Exact<{
  teamId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type PlanBillingTeamSubscriptionQuery = (
  { __typename: 'Query' }
  & { teamSubscriptionItem?: Maybe<(
    { __typename: 'SubscriptionItem' }
    & PlanBillingTeamSubscriptionFragment
  )> }
);

export type PlanBillingTeamSubscriptionFragment = (
  { __typename: 'SubscriptionItem' }
  & Pick<SubscriptionItem, 'id' | 'status' | 'cycleAnchor' | 'startAt' | 'endAt' | 'teamId' | 'isSubscripting' | 'isRefundable' | 'isFreeTrial'>
  & { invoicesByPage: (
    { __typename: 'InvoiceList' }
    & Pick<InvoiceList, 'offset' | 'limit' | 'total' | 'hasNext' | 'hasPrev'>
    & { invoiceList?: Maybe<Array<Maybe<(
      { __typename: 'PayInvoice' }
      & PlanBillingPayInvoiceInfoFragment
    ) | (
      { __typename: 'RefundInvoice' }
      & Pick<RefundInvoice, 'id' | 'refundAt' | 'paymentName' | 'paymentStatus' | 'refundAmount' | 'cardName' | 'cardNumber' | 'receiptUrl'>
    )>>> }
  ), coupon: (
    { __typename: 'UseCoupon' }
    & Pick<UseCoupon, 'id' | 'isUsed'>
  ), plan: (
    { __typename: 'PlanWithOption' }
    & Pick<PlanWithOption, 'id' | 'planName' | 'planType'>
    & { planOptionInfo: (
      { __typename: 'PlanOption' }
      & Pick<PlanOption, 'id' | 'planOptionName' | 'description' | 'amount' | 'currency' | 'period' | 'duration' | 'maxPlayerCount' | 'maxTeamCount'>
    ) }
  ) }
);

export type PlanBillingBillingQueryVariables = Exact<{
  identityToken: Scalars['ID'];
}>;


export type PlanBillingBillingQuery = (
  { __typename: 'Query' }
  & { billing?: Maybe<(
    { __typename: 'Billing' }
    & Pick<Billing, 'id' | 'identityToken' | 'customerUid' | 'cardName' | 'cardNumber' | 'buyerName' | 'buyerTel' | 'buyerEmail'>
  )> }
);

export type PlanBillingInvoicesByPageQueryVariables = Exact<{
  subscriptionId: Scalars['ID'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type PlanBillingInvoicesByPageQuery = (
  { __typename: 'Query' }
  & { invoicesByPage: (
    { __typename: 'InvoiceList' }
    & Pick<InvoiceList, 'offset' | 'limit' | 'total' | 'hasNext' | 'hasPrev'>
    & { invoiceList?: Maybe<Array<Maybe<(
      { __typename: 'PayInvoice' }
      & PlanBillingPayInvoiceInfoFragment
    ) | (
      { __typename: 'RefundInvoice' }
      & Pick<RefundInvoice, 'id' | 'refundAt' | 'paymentName' | 'paymentStatus' | 'refundAmount' | 'cardName' | 'cardNumber' | 'receiptUrl'>
    )>>> }
  ) }
);

export type PlanBillingPayInvoiceInfoFragment = (
  { __typename: 'PayInvoice' }
  & Pick<PayInvoice, 'id' | 'paidAt' | 'paymentName' | 'paymentStatus' | 'amount' | 'cardName' | 'cardNumber' | 'receiptUrl'>
);

export type PlanBillingLicenseQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type PlanBillingLicenseQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { team?: Maybe<(
      { __typename: 'SportsTeam' }
      & Pick<SportsTeam, 'id'>
      & { license?: Maybe<(
        { __typename: 'License' }
        & Pick<License, 'id' | 'startAt' | 'endAt' | 'licenseName' | 'teamVolume' | 'teamIdList'>
      )> }
    )> }
  ) }
);

export type PlanPayPricingBillingQueryVariables = Exact<{
  identityToken: Scalars['ID'];
}>;


export type PlanPayPricingBillingQuery = (
  { __typename: 'Query' }
  & { billing?: Maybe<(
    { __typename: 'Billing' }
    & PlanPayPricingBillingItemFragment
  )> }
);

export type PlanPayPricingTeamSubscriptionQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type PlanPayPricingTeamSubscriptionQuery = (
  { __typename: 'Query' }
  & { teamSubscriptionItem?: Maybe<(
    { __typename: 'SubscriptionItem' }
    & PlanPayPricingSubscriptionFragment
  )> }
);

export type PlanPayPricingTeamCouponsQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type PlanPayPricingTeamCouponsQuery = (
  { __typename: 'Query' }
  & { couponListByTeam: (
    { __typename: 'CouponListByTeam' }
    & { content?: Maybe<Array<(
      { __typename: 'CouponSimple' }
      & Pick<CouponSimple, 'couponId' | 'name'>
    )>> }
  ) }
);

export type PlanPayPricingAppliedPriceQueryVariables = Exact<{
  input: GetCouponAppliedPriceInput;
}>;


export type PlanPayPricingAppliedPriceQuery = (
  { __typename: 'Query' }
  & { couponAppliedPrice: (
    { __typename: 'CouponApplied' }
    & Pick<CouponApplied, 'deductedPrice' | 'discountedPrice' | 'originalPrice'>
    & { discountInfo: (
      { __typename: 'DiscountInfo' }
      & Pick<DiscountInfo, 'type' | 'value'>
    ) }
  ) }
);

export type HighestBenefitCouponByTeamQueryVariables = Exact<{
  originalPrice: Scalars['Float'];
  teamId: Scalars['ID'];
}>;


export type HighestBenefitCouponByTeamQuery = (
  { __typename: 'Query' }
  & { highestBenefitCouponByTeam?: Maybe<(
    { __typename: 'CouponSimple' }
    & Pick<CouponSimple, 'couponId' | 'endAt' | 'name' | 'remainDays' | 'startAt'>
  )> }
);

export type PlanPayPricingSubscriptionFragment = (
  { __typename: 'SubscriptionItem' }
  & Pick<SubscriptionItem, 'id' | 'status' | 'cycleAnchor' | 'startAt' | 'endAt' | 'teamId' | 'isSubscripting' | 'isRefundable' | 'isFreeTrial'>
  & { plan: (
    { __typename: 'PlanWithOption' }
    & Pick<PlanWithOption, 'id' | 'planName' | 'planType'>
    & { planOptionInfo: (
      { __typename: 'PlanOption' }
      & Pick<PlanOption, 'id' | 'planOptionName' | 'description' | 'currency' | 'period' | 'duration' | 'maxPlayerCount' | 'maxTeamCount' | 'amount'>
    ) }
  ) }
);

export type PlanPayPricingBillingItemFragment = (
  { __typename: 'Billing' }
  & Pick<Billing, 'id' | 'identityToken' | 'customerUid' | 'cardName' | 'cardNumber' | 'buyerName' | 'buyerTel' | 'buyerEmail'>
);

export type RegisterPostionPositionsQueryVariables = Exact<{
  categoryId: Scalars['String'];
}>;


export type RegisterPostionPositionsQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { category: (
      { __typename: 'SportsCategoryCollection' }
      & Pick<SportsCategoryCollection, 'id' | 'coachPositions'>
    ) }
  ) }
);

export type UploadUserProfileImageMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadUserProfileImageMutation = (
  { __typename: 'Mutation' }
  & { uploadProfile: (
    { __typename: 'UploadProfileResponse' }
    & { user?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id' | 'pictureFileId'>
    )> }
  ) }
);

export type NavigationViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type NavigationViewerQuery = (
  { __typename: 'Query' }
  & { sports: (
    { __typename: 'SportsQuery' }
    & { viewer?: Maybe<(
      { __typename: 'SportsUser' }
      & Pick<SportsUser, 'id'>
      & { teamMaps: Array<(
        { __typename: 'SportsTeamUserMap' }
        & FSportsTeamUserMapFragment
      )>, guideReopenStatus: (
        { __typename: 'GuideReopenStatus' }
        & { alarm: (
          { __typename: 'GuideReopenStatusUnit' }
          & Pick<GuideReopenStatusUnit, 'web'>
        ) }
      ) }
      & FSportsUserFragment
    )> }
  ) }
);

export type TRegisterViewerFragment = (
  { __typename: 'SportsUser' }
  & Pick<SportsUser, 'id' | 'priorSportsPosition' | 'pictureUrl' | 'name' | 'gender' | 'birthdate' | 'nationality' | 'phoneNumber'>
  & { priorSportsCategory?: Maybe<(
    { __typename: 'SportsCategoryCollection' }
    & Pick<SportsCategoryCollection, 'id' | 'group'>
  )> }
);

export type NavigationViewerFragment = (
  { __typename: 'SportsUser' }
  & Pick<SportsUser, 'id' | 'name' | 'slug' | 'pictureUrl' | 'priorSportsRole' | 'priorSportsPosition' | 'createdAt'>
  & { priorSportsCategory?: Maybe<(
    { __typename: 'SportsCategoryCollection' }
    & Pick<SportsCategoryCollection, 'id' | 'group'>
  )> }
);

export type NavigationByPlanQueryVariables = Exact<{
  teamId: Scalars['ID'];
  includeSubscription?: Maybe<Scalars['Boolean']>;
  includeLicense?: Maybe<Scalars['Boolean']>;
}>;


export type NavigationByPlanQuery = (
  { __typename: 'Query' }
  & { teamSubscriptionItem?: Maybe<(
    { __typename: 'SubscriptionItem' }
    & NavigationTeamSubscriptionFragment
  )>, licenseByTeam?: Maybe<(
    { __typename: 'License' }
    & NavigationTeamLicenseFragment
  )> }
);

export type NavigationTeamSubscriptionFragment = (
  { __typename: 'SubscriptionItem' }
  & Pick<SubscriptionItem, 'id' | 'status' | 'teamId' | 'isFreeTrial' | 'isSubscripting' | 'startAt' | 'endAt' | 'planId' | 'planOptionId'>
  & { plan: (
    { __typename: 'PlanWithOption' }
    & Pick<PlanWithOption, 'id' | 'planType'>
    & { planOptionInfo: (
      { __typename: 'PlanOption' }
      & Pick<PlanOption, 'id' | 'maxPlayerCount' | 'maxTeamCount' | 'amount' | 'currency' | 'period' | 'description' | 'planOptionName' | 'nextPaymentDay'>
    ) }
  ) }
);

export type NavigationTeamLicenseFragment = (
  { __typename: 'License' }
  & Pick<License, 'id' | 'isActivate'>
);

export type NavigationQualificationQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type NavigationQualificationQuery = (
  { __typename: 'Query' }
  & { qualification: (
    { __typename: 'Qualification' }
    & Pick<Qualification, 'id' | 'qualificationType' | 'isExpired'>
  ) }
);

export const namedOperations = {
  Query: {
    CardDiscountDetailsCouponContents: 'CardDiscountDetailsCouponContents',
    InvitationRequestBadgeRequests: 'InvitationRequestBadgeRequests',
    UserCurrentInjuryList: 'UserCurrentInjuryList',
    UserPastInjuryList: 'UserPastInjuryList',
    FeedbackDetail: 'FeedbackDetail',
    FeedbackSuggestionList: 'FeedbackSuggestionList',
    DialogTeamPlayerList: 'DialogTeamPlayerList',
    DrawerPlayersList: 'DrawerPlayersList',
    BodyParts: 'BodyParts',
    BodyPartMultilingualText: 'BodyPartMultilingualText',
    ModalTeamCreateViewer: 'ModalTeamCreateViewer',
    ModalTeamCreateTeamData: 'ModalTeamCreateTeamData',
    ModalTeamJoinViewer: 'ModalTeamJoinViewer',
    NavbarTeamsTeamData: 'NavbarTeamsTeamData',
    AnalyticsViewer: 'AnalyticsViewer',
    InvoiceBilling: 'InvoiceBilling',
    MultilingualData: 'MultilingualData',
    TeamPlanList: 'TeamPlanList',
    PlayerInjury: 'PlayerInjury',
    PlayerSelectAllUserMapsByGroup: 'PlayerSelectAllUserMapsByGroup',
    GroupsMemberMapByTeam: 'GroupsMemberMapByTeam',
    Viewer: 'Viewer',
    QuerySystemUserData: 'QuerySystemUserData',
    QuerySystemUserWorkloadData: 'QuerySystemUserWorkloadData',
    QuerySystemTeamUserMapsData: 'QuerySystemTeamUserMapsData',
    QuerySystemTeamAverageData: 'QuerySystemTeamAverageData',
    PlanBillingTeamSubscription: 'PlanBillingTeamSubscription',
    PlanBillingBilling: 'PlanBillingBilling',
    PlanBillingInvoicesByPage: 'PlanBillingInvoicesByPage',
    PlanBillingLicense: 'PlanBillingLicense',
    PlanPayPricingBilling: 'PlanPayPricingBilling',
    PlanPayPricingTeamSubscription: 'PlanPayPricingTeamSubscription',
    PlanPayPricingTeamCoupons: 'PlanPayPricingTeamCoupons',
    PlanPayPricingAppliedPrice: 'PlanPayPricingAppliedPrice',
    HighestBenefitCouponByTeam: 'HighestBenefitCouponByTeam',
    RegisterPostionPositions: 'RegisterPostionPositions',
    NavigationViewer: 'NavigationViewer',
    NavigationByPlan: 'NavigationByPlan',
    NavigationQualification: 'NavigationQualification'
  },
  Mutation: {
    CreateFeedback: 'CreateFeedback',
    DeleteFeedback: 'DeleteFeedback',
    UpdateFeedback: 'UpdateFeedback',
    CreateFeedbackComments: 'CreateFeedbackComments',
    UpdateFeedbackComments: 'UpdateFeedbackComments',
    DeleteFeedbackComments: 'DeleteFeedbackComments',
    CreateInjury: 'CreateInjury',
    UpdateInjury: 'UpdateInjury',
    DeleteInjury: 'DeleteInjury',
    SendCheckConditionReminderPush: 'SendCheckConditionReminderPush',
    SendCheckWorkloadReminderPush: 'SendCheckWorkloadReminderPush',
    RequestBillingToken: 'RequestBillingToken',
    UpdateBillingKey: 'UpdateBillingKey',
    UpdateBillingBuyerName: 'UpdateBillingBuyerName',
    UpdateBillingBuyerNumber: 'UpdateBillingBuyerNumber',
    UpdateBillingBuyerEmail: 'UpdateBillingBuyerEmail',
    StartSubscription: 'StartSubscription',
    RestartSubscription: 'RestartSubscription',
    RefundSubscription: 'RefundSubscription',
    ResumeSubscription: 'ResumeSubscription',
    CancelSubscription: 'CancelSubscription',
    Refund: 'Refund',
    RePaymentRequest: 'RePaymentRequest',
    LeaveTeam: 'LeaveTeam',
    DeleteTeam: 'DeleteTeam',
    TransferTeamOwnership: 'TransferTeamOwnership',
    KickoutTeamUserList: 'KickoutTeamUserList',
    CreateTeamGroup: 'CreateTeamGroup',
    UpdateTeamGroup: 'UpdateTeamGroup',
    DeleteTeamGroup: 'DeleteTeamGroup',
    RequestTeamInvitation: 'RequestTeamInvitation',
    AcceptInvitationList: 'AcceptInvitationList',
    RejectTeamInvitationList: 'RejectTeamInvitationList',
    ToggleTeamUserStarStatus: 'ToggleTeamUserStarStatus',
    UploadProfile: 'UploadProfile',
    UpdateUser: 'UpdateUser',
    UploadUserProfileImage: 'UploadUserProfileImage'
  },
  Fragment: {
    UserInjuryData: 'UserInjuryData',
    FeedbackData: 'FeedbackData',
    ModalTeamCreateTeam: 'ModalTeamCreateTeam',
    NavbarTeamsTeam: 'NavbarTeamsTeam',
    FSportsTeam: 'FSportsTeam',
    FSportsTeamInvitationRequest: 'FSportsTeamInvitationRequest',
    FSportsTeamUserMap: 'FSportsTeamUserMap',
    FSportsUser: 'FSportsUser',
    FTeamGroup: 'FTeamGroup',
    PaymentSubscrption: 'PaymentSubscrption',
    AnalyticsViewer: 'AnalyticsViewer',
    AnalyticsTeam: 'AnalyticsTeam',
    InvoiceBillingItem: 'InvoiceBillingItem',
    PlanOptionInfo: 'PlanOptionInfo',
    PlayerSummaryIdentity: 'PlayerSummaryIdentity',
    TGroupMemberMap: 'TGroupMemberMap',
    PlanBillingTeamSubscription: 'PlanBillingTeamSubscription',
    PlanBillingPayInvoiceInfo: 'PlanBillingPayInvoiceInfo',
    PlanPayPricingSubscription: 'PlanPayPricingSubscription',
    PlanPayPricingBillingItem: 'PlanPayPricingBillingItem',
    TRegisterViewer: 'TRegisterViewer',
    NavigationViewer: 'NavigationViewer',
    NavigationTeamSubscription: 'NavigationTeamSubscription',
    NavigationTeamLicense: 'NavigationTeamLicense'
  }
}